
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire1c76"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire1c76"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("j60L3", function(module, exports) {

$parcel$export(module.exports, "HeadProvider", function () { return $de6f2a5d5c34a644$export$b6e9256a1f1b97ae; });
$parcel$export(module.exports, "Title", function () { return $de6f2a5d5c34a644$export$f99233281efd08a0; });
$parcel$export(module.exports, "Link", function () { return $de6f2a5d5c34a644$export$a6c7ac8248d6e38a; });

var $GZIIz = parcelRequire("GZIIz");

var $7E7Dk = parcelRequire("7E7Dk");

var $cq2Uw = parcelRequire("cq2Uw");

var $lUyOW = parcelRequire("lUyOW");

var $hzbSh = parcelRequire("hzbSh");

var $jUqC3 = parcelRequire("jUqC3");
var $de6f2a5d5c34a644$var$_React$createContext = /*#__PURE__*/ (0, $7E7Dk.createContext)(null), $de6f2a5d5c34a644$var$Consumer = $de6f2a5d5c34a644$var$_React$createContext.Consumer, $de6f2a5d5c34a644$var$Provider = $de6f2a5d5c34a644$var$_React$createContext.Provider;
var $de6f2a5d5c34a644$var$HeadTag = /*#__PURE__*/ function(_React$Component) {
    (0, $lUyOW.default)(HeadTag, _React$Component);
    function HeadTag() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.state = {
            canUseDOM: false
        };
        _this.headTags = null;
        _this.index = -1;
        return _this;
    }
    var _proto = HeadTag.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var _this$props = this.props, tag = _this$props.tag, name = _this$props.name, property = _this$props.property;
        this.setState({
            canUseDOM: true
        });
        this.index = this.headTags.addClientTag(tag, name || property);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        var tag = this.props.tag;
        this.headTags.removeClientTag(tag, this.index);
    };
    _proto.render = function render() {
        var _this2 = this;
        var _this$props2 = this.props, Tag = _this$props2.tag, rest = (0, $cq2Uw.default)(_this$props2, [
            "tag"
        ]);
        var canUseDOM = this.state.canUseDOM;
        return /*#__PURE__*/ (0, $7E7Dk.createElement)($de6f2a5d5c34a644$var$Consumer, null, function(headTags) {
            if (headTags == null) throw Error("<HeadProvider /> should be in the tree");
            _this2.headTags = headTags;
            if (canUseDOM) {
                if (!headTags.shouldRenderTag(Tag, _this2.index)) return null;
                var ClientComp = /*#__PURE__*/ (0, $7E7Dk.createElement)(Tag, rest);
                return /*#__PURE__*/ (0, $hzbSh.createPortal)(ClientComp, document.head);
            }
            var ServerComp = /*#__PURE__*/ (0, $7E7Dk.createElement)(Tag, (0, $GZIIz.default)({
                "data-rh": ""
            }, rest));
            headTags.addServerTag(ServerComp);
            return null;
        });
    };
    return HeadTag;
}((0, $7E7Dk.Component));
var $de6f2a5d5c34a644$var$cascadingTags = [
    "title",
    "meta"
];
var $de6f2a5d5c34a644$export$b6e9256a1f1b97ae = /*#__PURE__*/ function(_React$Component) {
    (0, $lUyOW.default)(HeadProvider, _React$Component);
    function HeadProvider() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.indices = new Map();
        _this.state = {
            addClientTag: function addClientTag(tag, name) {
                // consider only cascading tags
                if ($de6f2a5d5c34a644$var$cascadingTags.indexOf(tag) !== -1) {
                    _this.setState(function(state) {
                        var _ref;
                        var names = state[tag] || [];
                        return _ref = {}, _ref[tag] = [].concat(names, [
                            name
                        ]), _ref;
                    }); // track indices synchronously
                    var _assertThisInitialize = (0, $jUqC3.default)(_this), indices = _assertThisInitialize.indices;
                    var index = indices.has(tag) ? indices.get(tag) + 1 : 0;
                    indices.set(tag, index);
                    return index;
                }
                return -1;
            },
            shouldRenderTag: function shouldRenderTag(tag, index) {
                if ($de6f2a5d5c34a644$var$cascadingTags.indexOf(tag) !== -1) {
                    var names = _this.state[tag]; // eslint-disable-line react/destructuring-assignment
                    // check if the tag is the last one of similar
                    return names && names.lastIndexOf(names[index]) === index;
                }
                return true;
            },
            removeClientTag: function removeClientTag(tag, index) {
                _this.setState(function(state) {
                    var names = state[tag];
                    if (names) {
                        var _ref2;
                        names[index] = null;
                        return _ref2 = {}, _ref2[tag] = names, _ref2;
                    }
                    return null;
                });
            },
            addServerTag: function addServerTag(tagNode) {
                var _this$props$headTags = _this.props.headTags, headTags = _this$props$headTags === void 0 ? [] : _this$props$headTags; // tweak only cascading tags
                if ($de6f2a5d5c34a644$var$cascadingTags.indexOf(tagNode.type) !== -1) {
                    var index = headTags.findIndex(function(prev) {
                        var prevName = prev.props.name || prev.props.property;
                        var nextName = tagNode.props.name || tagNode.props.property;
                        return prev.type === tagNode.type && prevName === nextName;
                    });
                    if (index !== -1) headTags.splice(index, 1);
                }
                headTags.push(tagNode);
            }
        };
        return _this;
    }
    var _proto = HeadProvider.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var ssrTags = document.head.querySelectorAll('[data-rh=""]'); // `forEach` on `NodeList` is not supported in Googlebot, so use a workaround
        Array.prototype.forEach.call(ssrTags, function(ssrTag) {
            return ssrTag.parentNode.removeChild(ssrTag);
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, headTags = _this$props.headTags, children = _this$props.children;
        if (typeof window === "undefined" && Array.isArray(headTags) === false) throw Error("headTags array should be passed to <HeadProvider /> in node");
        return /*#__PURE__*/ (0, $7E7Dk.createElement)($de6f2a5d5c34a644$var$Provider, {
            value: this.state
        }, children);
    };
    return HeadProvider;
}((0, $7E7Dk.Component));
var $de6f2a5d5c34a644$export$f99233281efd08a0 = function Title(props) {
    return /*#__PURE__*/ (0, $7E7Dk.createElement)($de6f2a5d5c34a644$var$HeadTag, (0, $GZIIz.default)({
        tag: "title"
    }, props));
};
var $de6f2a5d5c34a644$export$d9e45bc13d335801 = function Style(props) {
    return /*#__PURE__*/ (0, $7E7Dk.createElement)($de6f2a5d5c34a644$var$HeadTag, (0, $GZIIz.default)({
        tag: "style"
    }, props));
};
var $de6f2a5d5c34a644$export$b08a9033b36413fb = function Meta(props) {
    return /*#__PURE__*/ (0, $7E7Dk.createElement)($de6f2a5d5c34a644$var$HeadTag, (0, $GZIIz.default)({
        tag: "meta"
    }, props));
};
var $de6f2a5d5c34a644$export$a6c7ac8248d6e38a = function Link(props) {
    return /*#__PURE__*/ (0, $7E7Dk.createElement)($de6f2a5d5c34a644$var$HeadTag, (0, $GZIIz.default)({
        tag: "link"
    }, props));
};
var $de6f2a5d5c34a644$export$ef88aa0d34c34520 = function Base(props) {
    return /*#__PURE__*/ (0, $7E7Dk.createElement)($de6f2a5d5c34a644$var$HeadTag, (0, $GZIIz.default)({
        tag: "base"
    }, props));
};

});

parcelRegister("awukm", function(module, exports) {
$parcel$export(module.exports, "ChargePointDetailsPage", function () { return (parcelRequire("faOFo")).ChargePointDetailsPage; });
parcelRequire("faOFo");

});
parcelRegister("faOFo", function(module, exports) {

$parcel$export(module.exports, "ChargePointDetailsPage", function () { return $8b382639eed89d80$export$dfdb4e8d44bad2a8; });

var $7E7Dk = parcelRequire("7E7Dk");

var $gRonV = parcelRequire("gRonV");

var $4AX6R = parcelRequire("4AX6R");

var $e5J0l = parcelRequire("e5J0l");

var $igvrl = parcelRequire("igvrl");

var $gKMW8 = parcelRequire("gKMW8");

var $1O9Jh = parcelRequire("1O9Jh");

var $hHV5D = parcelRequire("hHV5D");

var $j5rWC = parcelRequire("j5rWC");
const $8b382639eed89d80$var$SExternalChargerMessageWrapper = (0, $gRonV.default).div`
    width: 100%;
    display: flex;
    justify-content: center;
    padding-bottom: 20px;
`;
const $8b382639eed89d80$var$SExternalChargerMessage = (0, $gRonV.default).div`
    color: #31708f;
    background-color: #d9edf7;
    border-color: #bce8f1;
    padding: 15px;
    border: 1px solid transparent;
    border-radius: 4px;
    text-align: center;
    width: 310px;
`;
const $8b382639eed89d80$var$SContainer = (0, $gRonV.default).div`
    padding-right: 15px;
    padding-left: 15px;
    margin-right: auto;
    margin-left: auto;
    background-color: #ffffff;
    border: none;

    @media (min-width: 990px) {
        width: 970px;
    }

    @media (min-width: 1200px) {
        width: 90vw;
        max-width: 1400px;
    }
`;
function $8b382639eed89d80$export$dfdb4e8d44bad2a8() {
    const chargePointId = (0, $4AX6R.useParams)().chargePointId;
    const { data: chargePoint, isLoading: isLoading } = (0, $1O9Jh.useChargePointGetQuery)({
        chargePointId: chargePointId,
        expand: "additionalInfo,scheduleInfo,wifisignal"
    }, {
        skip: !chargePointId,
        refetchOnFocus: true
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($8b382639eed89d80$var$SContainer, null, chargePoint ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $gKMW8.ChargePointContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $hHV5D.ChargePointPageControls), {
        chargePoint: chargePoint
    }), chargePoint?.ocppServerMode === "None" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $e5J0l.ChargePointCapiPage), {
        chargePoint: chargePoint,
        isLoading: isLoading
    }), chargePoint?.ocppServerMode === "Internal" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $j5rWC.ChargePointOcppPage), {
        chargePoint: chargePoint,
        isLoading: isLoading
    }), chargePoint?.ocppServerMode === "External" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($8b382639eed89d80$var$SExternalChargerMessageWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($8b382639eed89d80$var$SExternalChargerMessage, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
        code: "msgChargerIsDeployedToExternalPart",
        values: {
            chargePointId: chargePoint.id
        }
    })))))) : null);
}

});


parcelRegister("yF3FB", function(module, exports) {

$parcel$export(module.exports, "ReportsPage", function () { return (parcelRequire("eQXET")).ReportsPage; });

var $eQXET = parcelRequire("eQXET");

});
parcelRegister("eQXET", function(module, exports) {

$parcel$export(module.exports, "ReportsPage", function () { return $a81a57965aecd5e1$export$b8a443164510a1b4; });

var $7E7Dk = parcelRequire("7E7Dk");

var $26yAo = parcelRequire("26yAo");

var $eIymc = parcelRequire("eIymc");

var $5YsTM = parcelRequire("5YsTM");

var $b7038 = parcelRequire("b7038");

var $bVWHj = parcelRequire("bVWHj");
parcelRequire("aApW6");
var $5G9JV = parcelRequire("5G9JV");
parcelRequire("goDc7");
var $cRmaU = parcelRequire("cRmaU");

var $81LJ2 = parcelRequire("81LJ2");

var $5u6k9 = parcelRequire("5u6k9");
const $a81a57965aecd5e1$export$b8a443164510a1b4 = ()=>{
    const text = (0, $5u6k9.default)();
    const entitlements = (0, $81LJ2.useEntitlements)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $26yAo.PageLayoutContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $5YsTM.ReportsGeneratorWidget), null), (0, $eIymc.isAdminDomain) ? (0, $bVWHj.hasAccessToEntitlement)((0, $bVWHj.EntitlementsEnum).AUTOMATED_REPORTS, entitlements) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $b7038.AutomaticReportDeliveriesTable), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $cRmaU.Paywalled), {
        bodyRowOne: text("lblReportsPaywallBodyRowOne"),
        bodyRowTwo: text("lblReportsPaywallBodyRowTwo")
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $5G9JV.DummyAutomaticReportDeliveriesTable), null)) : null);
};

});
parcelRegister("5YsTM", function(module, exports) {

$parcel$export(module.exports, "ReportsGeneratorWidget", function () { return $3f3c4a9a452d4483$export$1278b746cbafc746; });

var $7E7Dk = parcelRequire("7E7Dk");

var $cCnqE = parcelRequire("cCnqE");

var $2rQNl = parcelRequire("2rQNl");

var $hmFZG = parcelRequire("hmFZG");
var $jW4vR = parcelRequire("jW4vR");
var $6eR9t = parcelRequire("6eR9t");
var $6Wotx = parcelRequire("6Wotx");

var $2kyoL = parcelRequire("2kyoL");

var $3um4r = parcelRequire("3um4r");

var $1ot1u = parcelRequire("1ot1u");

var $ecJXD = parcelRequire("ecJXD");

var $f7u8v = parcelRequire("f7u8v");

var $1O9Jh = parcelRequire("1O9Jh");

var $igvrl = parcelRequire("igvrl");

var $2nOeJ = parcelRequire("2nOeJ");

var $2RW25 = parcelRequire("2RW25");

var $r38ZI = parcelRequire("r38ZI");

var $eIymc = parcelRequire("eIymc");

var $bVWHj = parcelRequire("bVWHj");

var $81LJ2 = parcelRequire("81LJ2");

var $2Vabr = parcelRequire("2Vabr");

var $jzLwa = parcelRequire("jzLwa");

var $5EmX1 = parcelRequire("5EmX1");

var $5u6k9 = parcelRequire("5u6k9");

var $hPpPu = parcelRequire("hPpPu");

var $5OAxW = parcelRequire("5OAxW");
const $3f3c4a9a452d4483$var$dateFormat = "yyyy-MM-dd";
const $3f3c4a9a452d4483$var$normalizeReportInputs = (values, isRestrictedHistory, historyCutoffDate)=>{
    const today = (0, $6Wotx.default)(new Date());
    const normalizedFromDate = isRestrictedHistory && (0, $6eR9t.default)((0, $6Wotx.default)(values.fromDate), historyCutoffDate) ? historyCutoffDate : (0, $6eR9t.default)(today, (0, $6Wotx.default)(values.fromDate)) ? today : values.fromDate;
    const normalizedToDateCandidate = (0, $6eR9t.default)(today, (0, $6Wotx.default)(values.toDate)) ? today : values.toDate;
    const normalizedToDate = (0, $6eR9t.default)((0, $6Wotx.default)(normalizedToDateCandidate), (0, $6Wotx.default)(normalizedFromDate)) ? normalizedFromDate : normalizedToDateCandidate;
    return {
        reportId: values.reportId,
        fromDate: normalizedFromDate,
        toDate: normalizedToDate
    };
};
const $3f3c4a9a452d4483$export$1278b746cbafc746 = ()=>{
    const text = (0, $5u6k9.default)();
    const { selectedCompanyId: selectedCompanyId, partnerId: partnerId } = (0, $2rQNl.useSelector)((state)=>state.user);
    const entitlements = (0, $81LJ2.useEntitlements)();
    const screenSize = (0, $2Vabr.default)();
    const [intervalSelected, setIntervalSelected] = (0, $7E7Dk.useState)("CurrentWeek");
    const [isGeneratingReport, setIsGeneratingReport] = (0, $7E7Dk.useState)(false);
    const [isHelpInformationDialogVisible, setIsHelpInformationDialogVisible] = (0, $7E7Dk.useState)(false);
    const isRestrictedHistory = (0, $eIymc.isAdminDomain) && !(0, $bVWHj.hasAccessToEntitlement)((0, $bVWHj.EntitlementsEnum).REPORTS_EXTENDED_HISTORY, entitlements);
    const historyCutoffDate = (0, $7E7Dk.useMemo)(()=>(0, $5OAxW.getRestrictedReportHistoryCutoffDate)(), []);
    const periodOptions = (0, $7E7Dk.useMemo)(()=>{
        return [
            {
                label: text("btnCurrentWeek"),
                value: "CurrentWeek"
            },
            {
                label: text("btnPreviousWeek"),
                value: "PreviousWeek"
            },
            {
                label: text("btnCurrentMonth"),
                value: "CurrentMonth"
            },
            {
                label: text("btnPreviousMonth"),
                value: "PreviousMonth",
                disabled: isRestrictedHistory && !(0, $5OAxW.isIntervalWithinHistoryCutoff)("PreviousMonth", historyCutoffDate)
            },
            {
                label: text("btnCurrentYear"),
                value: "CurrentYear",
                disabled: isRestrictedHistory && !(0, $5OAxW.isIntervalWithinHistoryCutoff)("CurrentYear", historyCutoffDate)
            },
            {
                label: text("btnPreviousYear"),
                value: "PreviousYear",
                disabled: isRestrictedHistory && !(0, $5OAxW.isIntervalWithinHistoryCutoff)("PreviousYear", historyCutoffDate)
            }
        ];
    }, [
        historyCutoffDate,
        isRestrictedHistory,
        text
    ]);
    const { control: control, handleSubmit: handleSubmit, watch: watch, setValue: setValue, getValues: getValues, formState: { isValid: isValid } } = (0, $cCnqE.useForm)({
        mode: "onChange",
        defaultValues: {
            reportId: undefined,
            ...(0, $5OAxW.getDatesForInterval)("CurrentWeek")
        }
    });
    const { data: adminReports } = (0, $1O9Jh.useReportGetReportsForAdminQuery)({
        selectedCompanyId: selectedCompanyId
    }, {
        skip: !(0, $eIymc.isAdminDomain)
    });
    const { data: partnerReports } = (0, $1O9Jh.useReportGetReportsForPartnerQuery)({
        partnerId: partnerId
    }, {
        skip: !(0, $eIymc.isPartnerDomain)
    });
    const reportsOptions = (0, $7E7Dk.useMemo)(()=>{
        let reports;
        if ((0, $eIymc.isAdminDomain) && adminReports) reports = adminReports;
        else if ((0, $eIymc.isPartnerDomain) && partnerReports) reports = partnerReports;
        else return;
        return reports?.map((nextReport)=>({
                value: nextReport.id,
                label: nextReport.name
            }));
    }, [
        adminReports,
        partnerReports
    ]);
    const [getReports] = (0, $1O9Jh.useLazyReportGetReportDataQuery)();
    const generateReportCompany = async ({ reportId: reportId, fromDate: fromDate, toDate: toDate })=>{
        try {
            setIsGeneratingReport(true);
            const from = (0, $jW4vR.default)(fromDate, $3f3c4a9a452d4483$var$dateFormat);
            const to = (0, $jW4vR.default)((0, $hmFZG.default)(toDate, 1), $3f3c4a9a452d4483$var$dateFormat);
            (0, $r38ZI.notifySuccess)(text("lblGeneratingReport"));
            const tz = (0, (/*@__PURE__*/$parcel$interopDefault($2kyoL))).determine();
            const reportData = await getReports({
                reportId: reportId,
                companyId: selectedCompanyId,
                fromInLocalTime: from,
                toInLocalTime: to,
                timeZone: tz.name()
            }).unwrap();
            (0, $5OAxW.generateReports)(reportData, from, to);
            (0, $r38ZI.notifySuccess)(text("lblReportGenerateSuccess"));
        } catch (error) {
            (0, $r38ZI.notifyError)(text("lblReportGenerateFailed"));
        } finally{
            setIsGeneratingReport(false);
        }
    };
    const generateReportPartner = async ({ reportId: reportId, fromDate: fromDate, toDate: toDate })=>{
        try {
            setIsGeneratingReport(true);
            const from = (0, $jW4vR.default)(fromDate, $3f3c4a9a452d4483$var$dateFormat);
            const to = (0, $jW4vR.default)((0, $hmFZG.default)(toDate, 1), $3f3c4a9a452d4483$var$dateFormat);
            (0, $r38ZI.notifySuccess)(text("lblGeneratingReport"));
            const tz = (0, (/*@__PURE__*/$parcel$interopDefault($2kyoL))).determine();
            const reportData = await getReports({
                reportId: reportId,
                partnerId: partnerId,
                fromInLocalTime: from,
                toInLocalTime: to,
                timeZone: tz.name()
            }).unwrap();
            (0, $5OAxW.generateReports)(reportData, from, to);
            (0, $r38ZI.notifySuccess)(text("lblReportGenerateSuccess"));
        } catch (error) {
            (0, $r38ZI.notifyError)(text("lblReportGenerateFailed"));
        } finally{
            setIsGeneratingReport(false);
        }
    };
    const getReportDescription = ()=>{
        const reports = (0, $eIymc.isAdminDomain) ? adminReports : partnerReports;
        return reports?.find((report)=>report.id === reportId)?.description;
    };
    const reportId = watch("reportId");
    const fromDate = watch("fromDate");
    const toDate = watch("toDate");
    (0, $7E7Dk.useEffect)(()=>{
        const nextValues = $3f3c4a9a452d4483$var$normalizeReportInputs(getValues(), isRestrictedHistory, historyCutoffDate);
        if (nextValues.fromDate.getTime() !== fromDate.getTime()) setValue("fromDate", nextValues.fromDate, {
            shouldDirty: true,
            shouldValidate: true
        });
        if (nextValues.toDate.getTime() !== toDate.getTime()) setValue("toDate", nextValues.toDate, {
            shouldDirty: true,
            shouldValidate: true
        });
        if (intervalSelected && periodOptions.find((option)=>option.value === intervalSelected)?.disabled) setIntervalSelected(undefined);
    }, [
        fromDate,
        getValues,
        historyCutoffDate,
        intervalSelected,
        isRestrictedHistory,
        periodOptions,
        setValue,
        toDate
    ]);
    const setDateBasedOnInterval = (interval)=>{
        if (periodOptions.find((option)=>option.value === interval)?.disabled) return;
        const dateInterval = (0, $5OAxW.getDatesForInterval)(interval);
        if (!dateInterval) return;
        if (dateInterval.fromDate) setValue("fromDate", dateInterval.fromDate, {
            shouldDirty: true,
            shouldValidate: true
        });
        if (dateInterval.toDate) setValue("toDate", dateInterval.toDate, {
            shouldDirty: true,
            shouldValidate: true
        });
        setIntervalSelected(interval);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $2nOeJ.WidgetLayout), {
        title: text("lblReportGenerator"),
        headerButtons: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
            type: "button",
            icon: "pi pi-question-circle",
            "aria-label": text("btnHelp"),
            tooltip: text("btnHelp"),
            text: true,
            rounded: true,
            onClick: ()=>setIsHelpInformationDialogVisible(true)
        }),
        actionButtons: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
            type: "button",
            onClick: handleSubmit((values)=>(0, $eIymc.isAdminDomain) ? generateReportCompany($3f3c4a9a452d4483$var$normalizeReportInputs(values, isRestrictedHistory, historyCutoffDate)) : generateReportPartner($3f3c4a9a452d4483$var$normalizeReportInputs(values, isRestrictedHistory, historyCutoffDate))),
            label: text("btnGenerate"),
            icon: "pi pi-file-export",
            disabled: !isValid,
            loading: isGeneratingReport,
            "data-testid": "generate-btn"
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "flex flex-wrap md:flex-nowrap gap-3 field"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "w-full w-12 md:w-6"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $cCnqE.Controller), {
        name: "reportId",
        control: control,
        rules: {
            required: true
        },
        render: ({ field: { onChange: onChange, value: value } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $f7u8v.Combobox), {
                id: "selecter-report",
                "data-testid": "select-report-dropdown",
                options: reportsOptions,
                value: value,
                onChange: (option)=>onChange(option.value),
                labelText: text("lblReport")
            })
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "w-12 md:w-6 flex gap-2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $cCnqE.Controller), {
        name: "fromDate",
        control: control,
        rules: {
            required: true,
            validate: (value)=>!isRestrictedHistory || !(0, $6eR9t.default)((0, $6Wotx.default)(value), historyCutoffDate) || text("msgReportsHistoryRestrictionValidation", {
                    days: (0, $bVWHj.REPORT_HISTORY_RESTRICTION_DAYS)
                })
        },
        render: ({ field: { onChange: onChange, value: value } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $ecJXD.default), {
                id: "fromDate",
                "data-testid": "fromDate-input",
                wrapperClassName: "w-6",
                labelText: text("lblFromField"),
                min: isRestrictedHistory ? (0, $jW4vR.default)(historyCutoffDate, $3f3c4a9a452d4483$var$dateFormat) : undefined,
                max: (0, $jW4vR.default)((0, $6eR9t.default)((0, $6Wotx.default)(new Date()), (0, $6Wotx.default)(toDate)) ? new Date() : toDate, $3f3c4a9a452d4483$var$dateFormat),
                value: (0, $jW4vR.default)(value, $3f3c4a9a452d4483$var$dateFormat),
                onChange: (event)=>{
                    const nextFromDate = event.target.valueAsDate;
                    if (!nextFromDate) return;
                    const normalizedFromDate = isRestrictedHistory && (0, $6eR9t.default)((0, $6Wotx.default)(nextFromDate), (0, $6Wotx.default)(historyCutoffDate)) ? historyCutoffDate : nextFromDate;
                    onChange(normalizedFromDate);
                    if ((0, $6eR9t.default)((0, $6Wotx.default)(toDate), (0, $6Wotx.default)(normalizedFromDate))) setValue("toDate", normalizedFromDate, {
                        shouldDirty: true,
                        shouldValidate: true
                    });
                    setIntervalSelected(undefined);
                }
            })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $cCnqE.Controller), {
        name: "toDate",
        control: control,
        rules: {
            required: true
        },
        render: ({ field: { onChange: onChange, value: value } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $ecJXD.default), {
                id: "toDate",
                "data-testid": "toDate-input",
                wrapperClassName: "w-6",
                labelText: text("lblToField"),
                min: (0, $jW4vR.default)(fromDate, $3f3c4a9a452d4483$var$dateFormat),
                max: (0, $jW4vR.default)(new Date(), $3f3c4a9a452d4483$var$dateFormat),
                value: (0, $jW4vR.default)(value, $3f3c4a9a452d4483$var$dateFormat),
                onChange: (event)=>{
                    onChange(event.target.valueAsDate);
                    setIntervalSelected(undefined);
                }
            })
    }))), isRestrictedHistory && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "my-3 text-sm text-gray-600",
        "data-testid": "report-history-restriction"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("p", {
        className: "flex gap-1"
    }, `${text("msgReportsHistoryRestriction", {
        days: (0, $bVWHj.REPORT_HISTORY_RESTRICTION_DAYS)
    })}`, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $3um4r.Link), {
        to: "/billing",
        className: "p-0",
        "data-testid": "report-history-upgrade-link"
    }, text("lblUpgradePlan")))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "flex justify-content-between mb-2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $2RW25.SLabelText), {
        className: "label-indent",
        "data-testid": "earthingSystem-label"
    }, text("lblPreDefinedIntervals"))), screenSize === (0, $jzLwa.ScreenDeviceType).Tablet ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $f7u8v.Combobox), {
        enableDefaultOption: false,
        id: "interval",
        "data-testid": "interval-dropdown",
        options: periodOptions,
        value: intervalSelected,
        onChange: (option)=>setDateBasedOnInterval(option.value)
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $hPpPu.SelectButton), {
        id: "pre-defined-intervals",
        ariaLabel: text("lblPreDefinedIntervals"),
        options: periodOptions,
        onChange: (value)=>setDateBasedOnInterval(value),
        value: intervalSelected
    })), reportId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "mt-2 mb-4"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "flex justify-content-between mb-2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $2RW25.SLabelText), {
        className: "label-indent",
        "data-testid": "earthingSystem-label"
    }, text("lblSelectedReportDescription"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("i", null, getReportDescription())))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $5EmX1.InformationDialog), {
        visible: isHelpInformationDialogVisible,
        title: text("lblReportHelpDialogTitle"),
        message: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
            code: "msgImportingReports"
        }),
        onHide: ()=>setIsHelpInformationDialogVisible(false)
    }));
};

});
parcelRegister("bVWHj", function(module, exports) {

$parcel$export(module.exports, "EntitlementsEnum", function () { return $e91103dfaa94c1d2$export$318f9d4849f56423; });
$parcel$export(module.exports, "REPORT_HISTORY_RESTRICTION_DAYS", function () { return $e91103dfaa94c1d2$export$821621e09125263a; });
$parcel$export(module.exports, "hasAccessToEntitlement", function () { return $e91103dfaa94c1d2$export$609ddfa8b9085541; });
$parcel$export(module.exports, "canAccessBillingPage", function () { return $e91103dfaa94c1d2$export$3d88a25db58be4c5; });
const $e91103dfaa94c1d2$export$318f9d4849f56423 = {
    BYPASS_ENTITLEMENTS: 1,
    AUTOMATED_REPORTS: 2,
    REPORTS_EXTENDED_HISTORY: 4,
    STATISTICS_EXTENDED_HISTORY: 8,
    OCPP_RELAY: 16,
    CHARGER_GROUPS: 32,
    EAPI_EXTENDED_USE: 64,
    CALLBACKS_EXTENDED_USE: 128,
    LOAD_MANAGEMENT_SCHEDULE: 256,
    PRIORITIZED_CHARGING: 512,
    HIERARCHICAL_LOAD_MANAGEMENT: 1024
};
const $e91103dfaa94c1d2$export$821621e09125263a = 45;
const $e91103dfaa94c1d2$var$hasEntitlement = (mask, flag)=>(mask & flag) !== 0;
const $e91103dfaa94c1d2$var$getEntitlementsBitmask = (entitlements)=>Number(entitlements?.entitlementsMask ?? 0);
const $e91103dfaa94c1d2$var$bypassesEntitlementEnforcement = (entitlements)=>Boolean(entitlements?.bypassEntitlementEnforcement) || $e91103dfaa94c1d2$var$hasEntitlement($e91103dfaa94c1d2$var$getEntitlementsBitmask(entitlements), $e91103dfaa94c1d2$export$318f9d4849f56423.BYPASS_ENTITLEMENTS);
const $e91103dfaa94c1d2$export$609ddfa8b9085541 = (entitlement, entitlements)=>{
    if ($e91103dfaa94c1d2$var$bypassesEntitlementEnforcement(entitlements)) return true;
    return $e91103dfaa94c1d2$var$hasEntitlement($e91103dfaa94c1d2$var$getEntitlementsBitmask(entitlements), entitlement);
};
const $e91103dfaa94c1d2$export$3d88a25db58be4c5 = (entitlements)=>!$e91103dfaa94c1d2$export$609ddfa8b9085541($e91103dfaa94c1d2$export$318f9d4849f56423.BYPASS_ENTITLEMENTS, entitlements);

});

parcelRegister("81LJ2", function(module, exports) {

$parcel$export(module.exports, "useEntitlements", function () { return $ebb07559d156185c$export$60923aa21903cc38; });

var $2rQNl = parcelRequire("2rQNl");
const $ebb07559d156185c$export$60923aa21903cc38 = ()=>(0, $2rQNl.useSelector)((state)=>state.entitlements);

});

parcelRegister("5OAxW", function(module, exports) {

$parcel$export(module.exports, "getRestrictedReportHistoryCutoffDate", function () { return $dd850e0ee81f48c0$export$c49c82f7152770db; });
$parcel$export(module.exports, "isIntervalWithinHistoryCutoff", function () { return $dd850e0ee81f48c0$export$cf22c35a095226fd; });
$parcel$export(module.exports, "getDatesForInterval", function () { return $dd850e0ee81f48c0$export$6d61308487428d58; });
$parcel$export(module.exports, "generateReports", function () { return $dd850e0ee81f48c0$export$50c60a6cc98727b6; });

var $d7PJE = parcelRequire("d7PJE");
var $dWX9T = parcelRequire("dWX9T");
var $khqR8 = parcelRequire("khqR8");
var $6eR9t = parcelRequire("6eR9t");
var $6Wotx = parcelRequire("6Wotx");
var $ajiUn = parcelRequire("ajiUn");
var $4V6Kt = parcelRequire("4V6Kt");
var $lmK01 = parcelRequire("lmK01");
var $i2nlv = parcelRequire("i2nlv");
var $4MLzO = parcelRequire("4MLzO");
var $21Sub = parcelRequire("21Sub");
var $4179t = parcelRequire("4179t");

var $6eMNz = parcelRequire("6eMNz");

var $cTZfX = parcelRequire("cTZfX");

var $bVWHj = parcelRequire("bVWHj");
const $dd850e0ee81f48c0$export$c49c82f7152770db = (referenceDate = new Date())=>(0, $6Wotx.default)((0, $i2nlv.default)(referenceDate, (0, $bVWHj.REPORT_HISTORY_RESTRICTION_DAYS)));
const $dd850e0ee81f48c0$export$cf22c35a095226fd = (interval, cutoffDate)=>{
    const dateInterval = $dd850e0ee81f48c0$export$6d61308487428d58(interval);
    if (!dateInterval) return false;
    return !(0, $6eR9t.default)((0, $6Wotx.default)(dateInterval.fromDate), (0, $6Wotx.default)(cutoffDate));
};
const $dd850e0ee81f48c0$export$6d61308487428d58 = (interval)=>{
    let intervalStart;
    let fromDate;
    let toDate;
    switch(interval){
        case "CurrentWeek":
            fromDate = (0, $4V6Kt.default)(new Date(), {
                weekStartsOn: 1
            });
            toDate = (0, $dWX9T.default)(new Date(), {
                weekStartsOn: 1
            });
            break;
        case "PreviousWeek":
            intervalStart = (0, $21Sub.default)(new Date(), 1);
            fromDate = (0, $4V6Kt.default)(intervalStart, {
                weekStartsOn: 1
            });
            toDate = (0, $dWX9T.default)(intervalStart, {
                weekStartsOn: 1
            });
            break;
        case "CurrentMonth":
            fromDate = (0, $ajiUn.default)(new Date());
            toDate = (0, $d7PJE.default)(new Date());
            break;
        case "PreviousMonth":
            intervalStart = (0, $4MLzO.default)(new Date(), 1);
            fromDate = (0, $ajiUn.default)(intervalStart);
            toDate = (0, $d7PJE.default)(intervalStart);
            break;
        case "CurrentYear":
            fromDate = (0, $lmK01.default)(new Date());
            toDate = (0, $khqR8.default)(new Date());
            break;
        case "PreviousYear":
            intervalStart = (0, $4179t.default)(new Date(), 1);
            fromDate = (0, $lmK01.default)(intervalStart);
            toDate = (0, $khqR8.default)(intervalStart);
            break;
        default:
            return;
    }
    return {
        fromDate: fromDate,
        toDate: toDate
    };
};
const $dd850e0ee81f48c0$export$50c60a6cc98727b6 = (report, fromDate, toDate)=>{
    const reportName = (0, $6eMNz.default)(report, fromDate, toDate);
    let csvData = "\uFEFF" + report.formattedData;
    if (!report.formattedData || report.formattedData.length === 0) csvData += "N/A";
    (0, $cTZfX.downloadFile)(reportName, "csv", csvData);
};

});
parcelRegister("4MLzO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $37c08cdc7b0499d6$export$2e2bcd8739ae039; });

var $9xbCI = parcelRequire("9xbCI");

var $9ega8 = parcelRequire("9ega8");

var $7GcJU = parcelRequire("7GcJU");
function $37c08cdc7b0499d6$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $7GcJU.default)(2, arguments);
    var amount = (0, $9xbCI.default)(dirtyAmount);
    return (0, $9ega8.default)(dirtyDate, -amount);
}

});

parcelRegister("21Sub", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $17a5f0855c7c4ce3$export$2e2bcd8739ae039; });

var $9xbCI = parcelRequire("9xbCI");

var $xO2rg = parcelRequire("xO2rg");

var $7GcJU = parcelRequire("7GcJU");
function $17a5f0855c7c4ce3$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $7GcJU.default)(2, arguments);
    var amount = (0, $9xbCI.default)(dirtyAmount);
    return (0, $xO2rg.default)(dirtyDate, -amount);
}

});

parcelRegister("4179t", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2ecccda38d7adba3$export$2e2bcd8739ae039; });

var $9xbCI = parcelRequire("9xbCI");

var $c5mhl = parcelRequire("c5mhl");

var $7GcJU = parcelRequire("7GcJU");
function $2ecccda38d7adba3$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $7GcJU.default)(2, arguments);
    var amount = (0, $9xbCI.default)(dirtyAmount);
    return (0, $c5mhl.default)(dirtyDate, -amount);
}

});

parcelRegister("6eMNz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $52cb0150cc6d744e$export$2e2bcd8739ae039; });
const $52cb0150cc6d744e$var$getReportName = (report, dateFrom, dateTo)=>`${report.name}_${dateFrom}--${dateTo}.${report.fileExtension}`;
var $52cb0150cc6d744e$export$2e2bcd8739ae039 = $52cb0150cc6d744e$var$getReportName;

});

parcelRegister("cTZfX", function(module, exports) {

$parcel$export(module.exports, "downloadFile", function () { return $388283af707b029d$export$bb3b75778e3e272; });
const $388283af707b029d$var$blobType = {
    csv: "text/csv;charset=UTF-8",
    txt: "application/txt",
    pdf: "application/pdf",
    json: "application/json",
    xml: "application/xml"
};
const $388283af707b029d$export$bb3b75778e3e272 = (fileName, extension, data)=>{
    const file = new Blob([
        data
    ], {
        type: $388283af707b029d$var$blobType[extension]
    });
    const anchor = Object.assign(document.createElement("a"), {
        href: URL.createObjectURL(file),
        target: "_blank",
        download: `${fileName}`,
        style: "display: none"
    });
    document.body.appendChild(anchor);
    anchor.click();
    anchor.remove();
};

});



parcelRegister("b7038", function(module, exports) {

$parcel$export(module.exports, "AutomaticReportDeliveriesTable", function () { return $cea291a8b73129e1$export$7f0aebe95bb55606; });

var $7E7Dk = parcelRequire("7E7Dk");

var $2rQNl = parcelRequire("2rQNl");

var $1ot1u = parcelRequire("1ot1u");

var $ej4sl = parcelRequire("ej4sl");

var $bAq2r = parcelRequire("bAq2r");

var $lk7fg = parcelRequire("lk7fg");

var $r38ZI = parcelRequire("r38ZI");

var $1O9Jh = parcelRequire("1O9Jh");

var $2nOeJ = parcelRequire("2nOeJ");

var $5u6k9 = parcelRequire("5u6k9");

var $9p3YO = parcelRequire("9p3YO");

var $g915J = parcelRequire("g915J");

var $igvrl = parcelRequire("igvrl");
parcelRequire("lbsPE");
var $zgvc1 = parcelRequire("zgvc1");
const $cea291a8b73129e1$export$7f0aebe95bb55606 = ()=>{
    const text = (0, $5u6k9.default)();
    const { selectedCompanyId: selectedCompanyId } = (0, $2rQNl.useSelector)((state)=>state.user);
    const [automaticReportDeliveryDialogIsOpen, setAutomaticReportDeliveryDialogIsOpen] = (0, $7E7Dk.useState)(false);
    const [selectedReportDeliverySchedule, setSelectedReportDeliverySchedule] = (0, $7E7Dk.useState)();
    const { data: reports, isLoading: isLoading } = (0, $1O9Jh.useReportGetReportsForAdminQuery)({
        selectedCompanyId: selectedCompanyId
    });
    const reportNames = (0, $7E7Dk.useMemo)(()=>new Map(reports?.map((i)=>[
                i.id,
                i.name
            ])), [
        reports
    ]);
    const { data: reportDeliverySchedules } = (0, $1O9Jh.useCompanyGetReportDeliverySchedulesQuery)({
        companyId: selectedCompanyId
    });
    const [deleteDeliveryScheduleRequest] = (0, $1O9Jh.useCompanyDeleteReportDeliveryScheduleMutation)();
    const openNewReportDeliveryDialog = ()=>{
        setSelectedReportDeliverySchedule(undefined);
        setAutomaticReportDeliveryDialogIsOpen(true);
    };
    const openEditReportDeliveryDialog = (reportDeliverySchedule)=>{
        setSelectedReportDeliverySchedule(reportDeliverySchedule);
        setAutomaticReportDeliveryDialogIsOpen(true);
    };
    const hideReportDeliveryDialog = ()=>{
        setAutomaticReportDeliveryDialogIsOpen(false);
        setSelectedReportDeliverySchedule(undefined);
    };
    const handleDeleteDeliverySchedule = async (reportDeliverySchedule)=>{
        if (!reportDeliverySchedule || !reportDeliverySchedule.id) return;
        const confirmed = await (0, $9p3YO.confirm)({
            header: text("lblProceedConfirmation"),
            message: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
                code: "msgConfirmReportRemoving",
                values: {
                    reportName: reportNames.get(reportDeliverySchedule.reportId)
                }
            }),
            variant: "danger"
        });
        if (!confirmed) return;
        try {
            await deleteDeliveryScheduleRequest({
                companyId: selectedCompanyId,
                reportDeliveryScheduleId: reportDeliverySchedule.id
            }).unwrap();
            (0, $r38ZI.notifySuccess)("Report delivery schedule has been removed");
        } catch (_) {
            (0, $r38ZI.notifyError)("Failed to remove report delivery schedule");
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $2nOeJ.WidgetLayout), {
        title: text("lblAutomaticReportDeliveriesField"),
        headerButtons: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
            type: "button",
            icon: "pi pi-plus",
            label: text("lblAdd"),
            onClick: openNewReportDeliveryDialog
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $g915J.Table), {
        value: reportDeliverySchedules ?? [],
        loading: isLoading,
        dataKey: "id",
        pt: {
            table: {
                "aria-label": text("lblAutomaticReportDeliveriesField")
            }
        },
        "data-testid": "automatic-report-deliveries-table"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $ej4sl.Column), {
        field: "active",
        header: text("lblActive"),
        bodyClassName: "w-1rem",
        body: (reportDeliverySchedule)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
                className: "flex justify-content-center"
            }, reportDeliverySchedule.active ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $lk7fg.CheckMarkIcon), {
                size: 18
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("i", {
                className: "pi pi-times text-red-500",
                "aria-label": text("lblInactiveStatus"),
                title: text("lblInactiveStatus")
            }))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $ej4sl.Column), {
        field: "reportId",
        header: text("lblReport"),
        body: (reportDeliverySchedule)=>reportDeliverySchedule.reportId && reportNames.get(reportDeliverySchedule.reportId)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $ej4sl.Column), {
        field: "deliveryType",
        header: text("lblType")
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $ej4sl.Column), {
        field: "deliveryInterval",
        header: text("lblInterval")
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $ej4sl.Column), {
        field: "receiverEmail",
        header: text("lblReceiverEmail")
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $ej4sl.Column), {
        field: "lastSent",
        header: text("lblLastSent"),
        body: (reportDeliverySchedule)=>(0, $bAq2r.default)(reportDeliverySchedule.lastSent)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $ej4sl.Column), {
        bodyClassName: "w-8rem text-right",
        body: (reportDeliverySchedule)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
                className: "flex justify-content-end gap-2"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
                type: "button",
                icon: "pi pi-pencil",
                size: "small",
                severity: "info",
                outlined: true,
                rounded: true,
                "aria-label": text("btnEdit"),
                tooltip: text("btnEdit"),
                onClick: ()=>openEditReportDeliveryDialog(reportDeliverySchedule)
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
                type: "button",
                icon: "pi pi-trash",
                size: "small",
                severity: "danger",
                outlined: true,
                rounded: true,
                "aria-label": text("btnRemove"),
                tooltip: text("lblDelete"),
                onClick: ()=>handleDeleteDeliverySchedule(reportDeliverySchedule)
            }))
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $zgvc1.AutomaticReportDeliveryDialog), {
        key: selectedReportDeliverySchedule?.id ?? "new",
        companyId: selectedCompanyId,
        reports: reports,
        visible: automaticReportDeliveryDialogIsOpen,
        onHide: hideReportDeliveryDialog,
        selectedReportDeliverySchedule: selectedReportDeliverySchedule
    }));
};

});
parcelRegister("lbsPE", function(module, exports) {

$parcel$export(module.exports, "AutomaticReportDeliveryDialog", function () { return (parcelRequire("zgvc1")).AutomaticReportDeliveryDialog; });
parcelRequire("8XOgq");
var $zgvc1 = parcelRequire("zgvc1");

});
parcelRegister("8XOgq", function(module, exports) {

$parcel$export(module.exports, "AutomaticReportDeliveryDialog", function () { return (parcelRequire("zgvc1")).AutomaticReportDeliveryDialog; });

var $zgvc1 = parcelRequire("zgvc1");

});
parcelRegister("zgvc1", function(module, exports) {

$parcel$export(module.exports, "AutomaticReportDeliveryDialog", function () { return $9eaca4ab5d961f03$export$afb42245cb8b508f; });

var $7E7Dk = parcelRequire("7E7Dk");

var $2kyoL = parcelRequire("2kyoL");

var $cCnqE = parcelRequire("cCnqE");

var $l6tdd = parcelRequire("l6tdd");

var $7FGDK = parcelRequire("7FGDK");

var $1ot1u = parcelRequire("1ot1u");

var $hPpPu = parcelRequire("hPpPu");

var $1O9Jh = parcelRequire("1O9Jh");

var $5u6k9 = parcelRequire("5u6k9");

var $1o9MR = parcelRequire("1o9MR");

var $c6fcw = parcelRequire("c6fcw");

var $MMfqT = parcelRequire("MMfqT");

var $j8chc = parcelRequire("j8chc");

var $aCffN = parcelRequire("aCffN");
const $9eaca4ab5d961f03$var$formId = "report-delivery-form";
const $9eaca4ab5d961f03$export$afb42245cb8b508f = ({ companyId: companyId, reports: reports, visible: visible, onHide: onHide, selectedReportDeliverySchedule: selectedReportDeliverySchedule })=>{
    const text = (0, $5u6k9.default)();
    const toast = (0, $aCffN.useToast)();
    const reportDeliveryIntervalsList = [
        {
            value: "Day",
            label: text("lblDayInterval")
        },
        {
            value: "Month",
            label: text("lblMonthInterval")
        },
        {
            value: "Year",
            label: text("lblYearInterval")
        },
        {
            value: "Quarter",
            label: text("lblQuarterInterval")
        }
    ];
    const reportDeliverySchema = $7FGDK.object().shape({
        reportId: $7FGDK.number().nullable().required(text("errReportRequired")),
        deliveryInterval: $7FGDK.mixed().oneOf([
            "Day",
            "Month",
            "Year",
            "Quarter"
        ]).required(text("errDeliveryIntervalRequired")),
        deliveryType: $7FGDK.mixed().oneOf([
            "Email",
            "Ftp"
        ]).required(text("errDeliveryTypeRequired")),
        receiverName: $7FGDK.string().when("deliveryType", {
            is: "Email",
            then: $7FGDK.string().required(text("errReceiverNameRequired")),
            otherwise: $7FGDK.string().nullable().notRequired()
        }),
        receiverEmail: $7FGDK.string().nullable().when("deliveryType", {
            is: "Email",
            then: $7FGDK.string().email(text("lblInvalidEmail")).required(text("errReceiverEmailRequired")),
            otherwise: $7FGDK.string().nullable().notRequired()
        }),
        mailSubject: $7FGDK.string().when("deliveryType", {
            is: "Email",
            then: $7FGDK.string().required(text("errMailSubjectRequired")),
            otherwise: $7FGDK.string().nullable().notRequired()
        }),
        ftpUrl: $7FGDK.string().when("deliveryType", {
            is: "Ftp",
            then: $7FGDK.string().url(text("errFtpUrlInvalid")).required(text("errFtpUrlRequired")),
            otherwise: $7FGDK.string().nullable().notRequired()
        }),
        ftpUserName: $7FGDK.string().when("deliveryType", {
            is: "Ftp",
            then: $7FGDK.string().required(text("errFtpUserNameRequired")),
            otherwise: $7FGDK.string().nullable().notRequired()
        }),
        ftpPassword: $7FGDK.string().when("deliveryType", {
            is: "Ftp",
            then: $7FGDK.string().required(text("errFtpPasswordRequired")),
            otherwise: $7FGDK.string().nullable().notRequired()
        }),
        active: $7FGDK.boolean().notRequired()
    });
    const getFormValues = (schedule)=>({
            reportId: schedule?.reportId,
            deliveryInterval: schedule?.deliveryInterval,
            deliveryType: schedule?.deliveryType ?? "Email",
            receiverName: schedule?.receiverName ?? "",
            receiverEmail: schedule?.receiverEmail ?? "",
            mailSubject: schedule?.mailSubject ?? "",
            ftpUrl: schedule?.ftpUrl ?? "",
            ftpUserName: schedule?.ftpUserName ?? "",
            ftpPassword: schedule?.ftpPassword ?? "",
            active: schedule?.active ?? false
        });
    const { control: control, register: register, handleSubmit: handleSubmit, watch: watch, reset: reset, formState: { errors: errors, isSubmitted: isSubmitted, isValid: isValid, isSubmitting: isSubmitting } } = (0, $cCnqE.useForm)({
        defaultValues: getFormValues(selectedReportDeliverySchedule),
        mode: "onSubmit",
        reValidateMode: "onChange",
        resolver: (0, $l6tdd.yupResolver)(reportDeliverySchema)
    });
    const deliveryType = watch("deliveryType");
    const [updateReport, { isLoading: isUpdating }] = (0, $1O9Jh.useCompanyUpdateReportDeliveryScheduleMutation)();
    const [createReport, { isLoading: isCreating }] = (0, $1O9Jh.useCompanyCreateReportDeliveryScheduleMutation)();
    const handleOnHide = ()=>{
        reset(getFormValues(selectedReportDeliverySchedule));
        onHide();
    };
    const saveReportDelivery = async (formValues)=>{
        try {
            const payload = {
                ...selectedReportDeliverySchedule,
                ...formValues,
                ftpUrl: formValues.deliveryType === "Ftp" ? formValues.ftpUrl : undefined,
                ftpUserName: formValues.deliveryType === "Ftp" ? formValues.ftpUserName : undefined,
                ftpPassword: formValues.deliveryType === "Ftp" ? formValues.ftpPassword : undefined,
                receiverName: formValues.deliveryType === "Email" ? formValues.receiverName : undefined,
                receiverEmail: formValues.deliveryType === "Email" ? formValues.receiverEmail : undefined,
                mailSubject: formValues.deliveryType === "Email" ? formValues.mailSubject : undefined,
                timeZone: (0, (/*@__PURE__*/$parcel$interopDefault($2kyoL))).determine().name()
            };
            if (selectedReportDeliverySchedule) await updateReport({
                companyId: companyId,
                reportDeliverySchedule: payload
            }).unwrap();
            else await createReport({
                companyId: companyId,
                reportDeliverySchedule: payload
            }).unwrap();
            toast.notifySuccess(text("msgReportSaved"));
            handleOnHide();
        } catch (_) {
            toast.notifyError(text("msgReportNotSaved"));
        }
    };
    const reportsOptions = (0, $7E7Dk.useMemo)(()=>reports?.map((nextReport)=>({
                value: nextReport.id,
                label: nextReport.name
            })) || [], [
        reports
    ]);
    const deliveryTypeOptions = [
        {
            value: "Email",
            label: text("lblEmail")
        },
        {
            value: "Ftp",
            label: text("lblFtpDeliveryType")
        }
    ];
    const saving = isCreating || isUpdating || isSubmitting;
    const saveDisabled = saving || isSubmitted && !isValid;
    const footer = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "flex justify-content-end gap-2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
        label: text("btnCancel"),
        type: "button",
        text: true,
        onClick: handleOnHide
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
        label: text(selectedReportDeliverySchedule ? "btnSave" : "btnCreate"),
        type: "submit",
        form: $9eaca4ab5d961f03$var$formId,
        disabled: saveDisabled,
        loading: saving
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $MMfqT.Dialog), {
        header: text(selectedReportDeliverySchedule ? "lblEditAutomaticReportDeliveryDialogTitle" : "lblNewAutomaticReportDeliveryDialogTitle"),
        visible: visible,
        onHide: handleOnHide,
        footer: footer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("form", {
        id: $9eaca4ab5d961f03$var$formId,
        className: "flex flex-column gap-4",
        onSubmit: handleSubmit(saveReportDelivery),
        noValidate: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $cCnqE.Controller), {
        name: "reportId",
        control: control,
        render: ({ field: field })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $c6fcw.Dropdown), {
                options: reportsOptions,
                id: "report-id-select",
                "data-testid": "report-id-select",
                label: text("lblReport"),
                value: field.value,
                onChange: (option)=>field.onChange(option.value),
                error: errors.reportId?.message,
                required: true
            })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $cCnqE.Controller), {
        name: "deliveryInterval",
        control: control,
        render: ({ field: field })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $c6fcw.Dropdown), {
                options: reportDeliveryIntervalsList,
                label: text("lblReportDeliveryIntervalField"),
                id: "interval-select",
                "data-testid": "interval-select",
                value: field.value,
                onChange: (option)=>field.onChange(option.value),
                error: errors.deliveryInterval?.message,
                required: true
            })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $cCnqE.Controller), {
        name: "deliveryType",
        control: control,
        render: ({ field: field })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $hPpPu.SelectButton), {
                id: "report-delivery-type",
                label: text("lblReportDeliveryTypeField"),
                options: deliveryTypeOptions,
                onChange: field.onChange,
                value: field.value
            })
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("h3", {
        className: "m-0 text-xl text-color-secondary"
    }, text("lblReportDeliverySettings")), deliveryType === "Email" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "flex flex-column gap-3",
        key: "email"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1o9MR.Input), {
        id: "receiverName",
        label: text("lblReceiverNameField"),
        maxLength: 50,
        error: errors.receiverName?.message,
        required: true,
        ...register("receiverName")
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1o9MR.Input), {
        id: "receiverEmail",
        label: text("lblReceiverEmailField"),
        type: "email",
        autoComplete: "off",
        maxLength: 100,
        error: errors.receiverEmail?.message,
        required: true,
        ...register("receiverEmail")
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1o9MR.Input), {
        id: "receiverSubject",
        label: text("lblEmailSubjectField"),
        autoComplete: "off",
        maxLength: 50,
        error: errors.mailSubject?.message,
        required: true,
        ...register("mailSubject")
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "flex flex-column gap-3",
        key: "ftp"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1o9MR.Input), {
        id: "ftpURL",
        label: text("lblFtpUrlField"),
        type: "url",
        error: errors.ftpUrl?.message,
        required: true,
        ...register("ftpUrl")
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1o9MR.Input), {
        id: "ftpUserName",
        label: text("lblFtpUsernameField"),
        autoComplete: "new-password",
        error: errors.ftpUserName?.message,
        required: true,
        ...register("ftpUserName")
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1o9MR.Input), {
        id: "ftpPassword",
        label: text("lblFtpPasswordField"),
        type: "password",
        autoComplete: "new-password",
        error: errors.ftpPassword?.message,
        required: true,
        ...register("ftpPassword")
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $cCnqE.Controller), {
        name: "active",
        control: control,
        render: ({ field: field })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $j8chc.Switch), {
                inputId: "report-delivery-active",
                label: text("lblActive"),
                checked: field.value ?? false,
                onChange: (event)=>field.onChange(event.value)
            })
    })));
};

});




parcelRegister("aApW6", function(module, exports) {
$parcel$export(module.exports, "DummyAutomaticReportDeliveriesTable", function () { return (parcelRequire("5G9JV")).DummyAutomaticReportDeliveriesTable; });
parcelRequire("5G9JV");

});
parcelRegister("5G9JV", function(module, exports) {

$parcel$export(module.exports, "DummyAutomaticReportDeliveriesTable", function () { return $d947b9f1e5e7e2c7$export$6823689a93b5c65f; });

var $7E7Dk = parcelRequire("7E7Dk");

var $2rQNl = parcelRequire("2rQNl");

var $1ot1u = parcelRequire("1ot1u");

var $ej4sl = parcelRequire("ej4sl");

var $bAq2r = parcelRequire("bAq2r");

var $1O9Jh = parcelRequire("1O9Jh");

var $2nOeJ = parcelRequire("2nOeJ");

var $5u6k9 = parcelRequire("5u6k9");

var $g915J = parcelRequire("g915J");
const $d947b9f1e5e7e2c7$export$6823689a93b5c65f = ()=>{
    const text = (0, $5u6k9.default)();
    const { selectedCompanyId: selectedCompanyId } = (0, $2rQNl.useSelector)((state)=>state.user);
    const { data: reports, isLoading: isLoading } = (0, $1O9Jh.useReportGetReportsForAdminQuery)({
        selectedCompanyId: selectedCompanyId
    });
    const reportNames = (0, $7E7Dk.useMemo)(()=>new Map(reports?.map((i)=>[
                i.id,
                i.name
            ])), [
        reports
    ]);
    const { data: reportDeliverySchedules } = (0, $1O9Jh.useCompanyGetReportDeliverySchedulesQuery)({
        companyId: selectedCompanyId
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $2nOeJ.WidgetLayout), {
        title: `${text("lblAutomaticReportDeliveriesField")}`,
        headerButtons: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
            type: "button",
            icon: "pi pi-plus",
            label: text("lblAdd"),
            disabled: true
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $g915J.Table), {
        value: reportDeliverySchedules ?? [],
        loading: isLoading,
        dataKey: "id",
        pt: {
            table: {
                "aria-label": text("lblAutomaticReportDeliveriesField")
            }
        },
        rowClassName: ()=>"pointer",
        "data-testid": "blocked-automatic-report-deliveries-table"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $ej4sl.Column), {
        field: "active",
        header: text("lblActive"),
        bodyClassName: "w-1rem",
        body: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
                className: "flex justify-content-center"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("i", {
                className: "pi pi-ban",
                "aria-label": text("lblBlockedByTier"),
                title: text("lblBlockedByTier")
            }))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $ej4sl.Column), {
        field: "reportId",
        header: text("lblReport"),
        body: (reportDeliverySchedule)=>reportDeliverySchedule.reportId && reportNames.get(reportDeliverySchedule.reportId)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $ej4sl.Column), {
        field: "deliveryType",
        header: text("lblType")
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $ej4sl.Column), {
        field: "deliveryInterval",
        header: text("lblInterval")
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $ej4sl.Column), {
        field: "receiverEmail",
        header: text("lblReceiverEmail")
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $ej4sl.Column), {
        field: "lastSent",
        header: text("lblLastSent"),
        body: (reportDeliverySchedule)=>(0, $bAq2r.default)(reportDeliverySchedule.lastSent)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $ej4sl.Column), {
        body: ()=>null
    }))));
};

});


parcelRegister("goDc7", function(module, exports) {
$parcel$export(module.exports, "Paywalled", function () { return (parcelRequire("cRmaU")).Paywalled; });
parcelRequire("cRmaU");

});
parcelRegister("cRmaU", function(module, exports) {

$parcel$export(module.exports, "Paywalled", function () { return $69ccac2616fa3426$export$23a0a86a9877650f; });

var $1ot1u = parcelRequire("1ot1u");

var $7E7Dk = parcelRequire("7E7Dk");

var $3um4r = parcelRequire("3um4r");

var $5u6k9 = parcelRequire("5u6k9");
const $69ccac2616fa3426$export$23a0a86a9877650f = ({ children: children, bodyRowOne: bodyRowOne, bodyRowTwo: bodyRowTwo })=>{
    const navigate = (0, $3um4r.useNavigate)();
    const text = (0, $5u6k9.default)();
    const [isOverlayHovered, setIsOverlayHovered] = (0, $7E7Dk.useState)(false);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "relative"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "pointer-events-none select-none",
        style: {
            inset: 0,
            opacity: isOverlayHovered ? 0.3 : 1,
            transition: "opacity 150ms ease-in-out"
        }
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "absolute flex flex-column align-items-center justify-content-center gap-3 z-3",
        onMouseEnter: ()=>setIsOverlayHovered(true),
        onMouseLeave: ()=>setIsOverlayHovered(false),
        style: {
            inset: 0,
            opacity: isOverlayHovered ? 1 : 0.4,
            transition: "opacity 150ms ease-in-out"
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "flex align-items-center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("i", {
        className: "fa fa-lock text-8xl text-gray-800",
        style: {
            textShadow: "0 6px 18px rgba(0, 0, 0, 0.4)"
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "flex flex-column align-items-center text-lg text-center w-8",
        style: {
            textShadow: "0 2px 8px rgba(0, 0, 0, 0.35)"
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "mb-4"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("p", {
        className: "m-0"
    }, bodyRowOne), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("p", {
        className: "m-0"
    }, bodyRowTwo)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
        type: "button",
        onClick: ()=>navigate("/billing"),
        label: text("lblUpgradePlan"),
        icon: "pi pi-arrow-up-right",
        iconPos: "right",
        className: "align-self-center",
        style: {
            boxShadow: "0 6px 16px rgba(0, 0, 0, 0.35)"
        }
    }))));
};

});




parcelRegister("h8spA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $07dedea254b871ff$export$2e2bcd8739ae039; });

var $7E7Dk = parcelRequire("7E7Dk");

var $gRonV = parcelRequire("gRonV");

var $1ot1u = parcelRequire("1ot1u");

var $igvrl = parcelRequire("igvrl");

var $1sDHO = parcelRequire("1sDHO");

var $exX3k = parcelRequire("exX3k");
const $07dedea254b871ff$var$SDiv = (0, $gRonV.default).div`
    position: fixed;
    bottom: 0px;
    width: 100%;
    z-index: 1000;
    padding: ${({ theme: theme })=>theme.sizing.padding.l};
    background-color: ${({ theme: theme })=>theme.whiteBackground};
    box-shadow: rgba(0, 0, 0, 0.1) 0px -10px 15px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    a {
        text-decoration: underline;
    }

    @media (max-width: 767px) {
        flex-flow: column;
        gap: 20px;
    }
`;
const $07dedea254b871ff$var$SBtnGroup = (0, $gRonV.default).div`
    display: flex;
    gap: ${({ theme: theme })=>theme.sizing.margin.m};

    @media (max-width: 767px) {
        margin-left: auto;
        flex-flow: column;
        width: 100%;

        button {
            width: 100%;
        }
    }
`;
const $07dedea254b871ff$var$cookieConsentName = "acceptCookieConsent";
const $07dedea254b871ff$var$clarityCookieName = "_clck";
const $07dedea254b871ff$var$CookieConsentBar = ()=>{
    const hasClarityCookie = ()=>document.cookie.split(";").findIndex((nextCookie)=>nextCookie.trimStart().startsWith($07dedea254b871ff$var$clarityCookieName)) > -1;
    const [cookieSelection, setCookieSelection] = (0, $7E7Dk.useState)(()=>{
        if (hasClarityCookie()) return true;
        return (0, $1sDHO.default).getItem($07dedea254b871ff$var$cookieConsentName) === false;
    });
    const consentCookies = ()=>{
        if (!hasClarityCookie()) window.clarity("consent");
        (0, $exX3k.appInsights)?.getCookieMgr().setEnabled(true);
        (0, $1sDHO.default).setItem($07dedea254b871ff$var$cookieConsentName, true);
        setCookieSelection(true);
    };
    const closeCookies = ()=>{
        (0, $1sDHO.default).setItem($07dedea254b871ff$var$cookieConsentName, false);
        setCookieSelection(true);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).Fragment, null, !cookieSelection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($07dedea254b871ff$var$SDiv, {
        "data-testid": "cookie-consent-banner"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("span", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
        code: "msgCookiePolicyInformation",
        values: {
            link: {
                href: `https://www.chargeamps.com/cookie-policy/`,
                target: "_blank",
                rel: "noopener noreferrer",
                className: "blueLink"
            }
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($07dedea254b871ff$var$SBtnGroup, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
        type: "button",
        label: "Accept",
        onClick: ()=>consentCookies(),
        className: "consent-btn",
        "data-testid": "cookie-accept-btn",
        icon: "pi pi-check"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
        type: "button",
        label: "Decline",
        onClick: ()=>closeCookies(),
        outlined: true,
        icon: "pi pi-times",
        "data-testid": "cookie-decline-btn"
    }))));
};
var $07dedea254b871ff$export$2e2bcd8739ae039 = $07dedea254b871ff$var$CookieConsentBar;

});
parcelRegister("exX3k", function(module, exports) {

$parcel$export(module.exports, "appInsights", function () { return $03aabcf81e034cb7$export$3615512b8c4a30de; });

var $bnYtd = parcelRequire("bnYtd");

var $3UyYL = parcelRequire("3UyYL");

var $2Ptzq = parcelRequire("2Ptzq");
const { hostname: $03aabcf81e034cb7$var$hostname } = window.location;
const $03aabcf81e034cb7$var$shouldTrack = [
    ...(0, $bnYtd.PRODUCTION_HOSTS),
    ...(0, $bnYtd.STAGING_HOSTS),
    ...(0, $bnYtd.DEV_HOSTS)
].includes($03aabcf81e034cb7$var$hostname);
const $03aabcf81e034cb7$var$shouldDisplay = [
    ...(0, $bnYtd.DEV_HOSTS),
    (0, $bnYtd.LOCAL_HOSTS)
].includes($03aabcf81e034cb7$var$hostname);
const $03aabcf81e034cb7$export$3615512b8c4a30de = $03aabcf81e034cb7$var$shouldTrack ? (0, $3UyYL.default)("5b67ff0e-1cba-4c78-824d-c02d4a18c275") : null;
const $03aabcf81e034cb7$var$track = (eventName, props)=>{
    if ($03aabcf81e034cb7$var$shouldDisplay) (0, $2Ptzq.default)("gtag", [
        eventName,
        props
    ]);
};
$03aabcf81e034cb7$var$track.pageView = (props)=>{
    $03aabcf81e034cb7$export$3615512b8c4a30de?.trackPageView({
        name: props.title || document.title,
        uri: props.location || window.location.href
    });
};
var $03aabcf81e034cb7$export$2e2bcd8739ae039 = $03aabcf81e034cb7$var$track;

});
parcelRegister("bnYtd", function(module, exports) {

$parcel$export(module.exports, "PRODUCTION_HOSTS", function () { return $fb149cc83a8e4f0e$export$179d7ce44db1bb86; });
$parcel$export(module.exports, "STAGING_HOSTS", function () { return $fb149cc83a8e4f0e$export$6abbd97376ac33ee; });
$parcel$export(module.exports, "DEV_HOSTS", function () { return $fb149cc83a8e4f0e$export$441ffaf2f9e0a685; });
$parcel$export(module.exports, "LOCAL_HOSTS", function () { return $fb149cc83a8e4f0e$export$a7a99665d76eb3de; });
const $fb149cc83a8e4f0e$export$179d7ce44db1bb86 = [
    "ca-web-north-eu-webapp.azurewebsites.net",
    "chargeampsweb.azurewebsites.net",
    "my.charge.space"
];
const $fb149cc83a8e4f0e$export$6abbd97376ac33ee = [
    "ca-web-north-eu-webapp-staging.azurewebsites.net",
    "chargeampsweb-stage.azurewebsites.net",
    "mys.charge.space"
];
const $fb149cc83a8e4f0e$export$441ffaf2f9e0a685 = [
    "ca-web-webapp-dev.azurewebsites.net",
    "chargeampsweb-dev.azurewebsites.net",
    "myd.charge.space",
    "myz.charge.space"
];
const $fb149cc83a8e4f0e$export$97e33e37eeb5c5b7 = [
    "chargeampsweb-test.azurewebsites.net",
    "myt.charge.space"
];
const $fb149cc83a8e4f0e$export$a7a99665d76eb3de = [
    "localhost"
];

});

parcelRegister("3UyYL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d7bcf7c52cc12dda$export$2e2bcd8739ae039; });

var $eezZs = parcelRequire("eezZs");
const $d7bcf7c52cc12dda$var$setupAppInsights = (trackingId)=>{
    const appInsights = new (0, $eezZs.Initialization)({
        config: {
            instrumentationKey: trackingId,
            autoTrackPageVisitTime: true,
            enableAutoRouteTracking: true,
            disableCookiesUsage: true
        }
    });
    appInsights.loadAppInsights();
    return appInsights;
};
var $d7bcf7c52cc12dda$export$2e2bcd8739ae039 = $d7bcf7c52cc12dda$var$setupAppInsights;

});
parcelRegister("eezZs", function(module, exports) {

$parcel$export(module.exports, "Initialization", function () { return $a5ce4a62ad2de69d$export$d49a2f682d00cad8; });
/*
 * Application Insights JavaScript SDK - Web, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $kbmky = parcelRequire("kbmky");

var $ch4sE = parcelRequire("ch4sE");

var $dSEhk = parcelRequire("dSEhk");

var $1EHoQ = parcelRequire("1EHoQ");
var $jqqu3 = parcelRequire("jqqu3");
var $5cDez = parcelRequire("5cDez");
var $gygzP = parcelRequire("gygzP");
var $4sUzw = parcelRequire("4sUzw");
var $2gDxc = parcelRequire("2gDxc");
var $coTnQ = parcelRequire("coTnQ");
var $cGFCT = parcelRequire("cGFCT");
var $dCW8D = parcelRequire("dCW8D");
var $efuYp = parcelRequire("efuYp");
var $1V1Zd = parcelRequire("1V1Zd");
var $fK8rK = parcelRequire("fK8rK");
var $3AuL8 = parcelRequire("3AuL8");
var $ihDSn = parcelRequire("ihDSn");
var $80I4P = parcelRequire("80I4P");
var $bmYDZ = parcelRequire("bmYDZ");
var $7fph4 = parcelRequire("7fph4");
var $f5lFa = parcelRequire("f5lFa");
var $7504k = parcelRequire("7504k");
var $62ywT = parcelRequire("62ywT");
var $lL63Q = parcelRequire("lL63Q");

var $8z2Gd = parcelRequire("8z2Gd");
var $cIC5n = parcelRequire("cIC5n");
var $ghxFc = parcelRequire("ghxFc");
var $erRAP = parcelRequire("erRAP");
var $2w0XY = parcelRequire("2w0XY");
var $kBiyL = parcelRequire("kBiyL");
var $3I5zg = parcelRequire("3I5zg");

var $9ZYOv = parcelRequire("9ZYOv");

var $cPPgl = parcelRequire("cPPgl");

var $4GkI4 = parcelRequire("4GkI4");

var $iRSJj = parcelRequire("iRSJj");
"use strict";
var $a5ce4a62ad2de69d$var$_internalSdkSrc;
// This is an exclude list of properties that should not be updated during initialization
// They include a combination of private and internal property names
var $a5ce4a62ad2de69d$var$_ignoreUpdateSnippetProperties = [
    (0, $4GkI4.STR_SNIPPET),
    "dependencies",
    "properties",
    "_snippetVersion",
    "appInsightsNew",
    "getSKUDefaults"
];
// Re-exposing the Common classes as Telemetry, the list was taken by reviewing the generated code for the build while using
// the previous configuration :-
// import * as Common from "@microsoft/applicationinsights-common"
// export const Telemetry = Common;
var $a5ce4a62ad2de69d$var$fieldType = {
    Default: 0 /* FieldType.Default */ ,
    Required: 1 /* FieldType.Required */ ,
    Array: 2 /* FieldType.Array */ ,
    Hidden: 4 /* FieldType.Hidden */ 
};
var $a5ce4a62ad2de69d$export$dce6f134b7ab7df7 = {
    __proto__: null,
    PropertiesPluginIdentifier: (0, $1EHoQ.PropertiesPluginIdentifier),
    BreezeChannelIdentifier: (0, $1EHoQ.BreezeChannelIdentifier),
    AnalyticsPluginIdentifier: (0, $1EHoQ.AnalyticsPluginIdentifier),
    Util: (0, $4sUzw.Util),
    CorrelationIdHelper: (0, $4sUzw.CorrelationIdHelper),
    UrlHelper: (0, $4sUzw.UrlHelper),
    DateTimeUtils: (0, $4sUzw.DateTimeUtils),
    ConnectionStringParser: (0, $5cDez.ConnectionStringParser),
    FieldType: $a5ce4a62ad2de69d$var$fieldType,
    RequestHeaders: (0, $f5lFa.RequestHeaders),
    DisabledPropertyName: (0, $dCW8D.DisabledPropertyName),
    ProcessLegacy: (0, $dCW8D.ProcessLegacy),
    SampleRate: (0, $dCW8D.SampleRate),
    HttpMethod: (0, $dCW8D.HttpMethod),
    DEFAULT_BREEZE_ENDPOINT: (0, $dCW8D.DEFAULT_BREEZE_ENDPOINT),
    Envelope: (0, $1V1Zd.Envelope),
    Event: (0, $fK8rK.Event),
    Exception: (0, $3AuL8.Exception),
    Metric: (0, $ihDSn.Metric),
    PageView: (0, $80I4P.PageView),
    RemoteDependencyData: (0, $7fph4.RemoteDependencyData),
    Trace: (0, $lL63Q.Trace),
    PageViewPerformance: (0, $bmYDZ.PageViewPerformance),
    Data: (0, $coTnQ.Data),
    SeverityLevel: (0, $7504k.SeverityLevel),
    ConfigurationManager: (0, $jqqu3.ConfigurationManager),
    ContextTagKeys: (0, $gygzP.ContextTagKeys),
    DataSanitizer: (0, $cGFCT.DataSanitizer),
    TelemetryItemCreator: (0, $62ywT.TelemetryItemCreator),
    CtxTagKeys: (0, $2gDxc.CtxTagKeys),
    Extensions: (0, $2gDxc.Extensions),
    DistributedTracingModes: (0, $efuYp.DistributedTracingModes)
};
/**
 * Application Insights API
 * @class Initialization
 * @implements {IApplicationInsights}
 */ var $a5ce4a62ad2de69d$export$d49a2f682d00cad8 = /** @class */ function() {
    function Initialization(snippet) {
        var _this = this;
        // NOTE!: DON'T set default values here, instead set them in the _initDefaults() function as it is also called during teardown()
        var dependencies;
        var properties;
        var _sender;
        var _snippetVersion;
        var _evtNamespace;
        var _houseKeepingNamespace;
        var _core;
        (0, $kbmky.default)(Initialization, this, function(_self) {
            _initDefaults();
            // initialize the queue and config in case they are undefined
            _snippetVersion = "" + (snippet.sv || snippet[0, $iRSJj._DYN_VERSION /* @min:%2eversion */ ] || "");
            snippet[0, $iRSJj._DYN_QUEUE /* @min:%2equeue */ ] = snippet[0, $iRSJj._DYN_QUEUE /* @min:%2equeue */ ] || [];
            snippet[0, $iRSJj._DYN_VERSION /* @min:%2eversion */ ] = snippet[0, $iRSJj._DYN_VERSION /* @min:%2eversion */ ] || 2.0; // Default to new version
            var config = snippet[0, $iRSJj._DYN_CONFIG /* @min:%2econfig */ ] || {};
            if (config[0, $iRSJj._DYN_CONNECTION_STRING /* @min:%2econnectionString */ ]) {
                var cs = (0, $5cDez.parseConnectionString)(config[0, $iRSJj._DYN_CONNECTION_STRING /* @min:%2econnectionString */ ]);
                var ingest = cs.ingestionendpoint;
                config[0, $iRSJj._DYN_ENDPOINT_URL /* @min:%2eendpointUrl */ ] = ingest ? ingest + (0, $dCW8D.DEFAULT_BREEZE_PATH) : config[0, $iRSJj._DYN_ENDPOINT_URL /* @min:%2eendpointUrl */ ]; // only add /v2/track when from connectionstring
                config[0, $iRSJj._DYN_INSTRUMENTATION_KEY /* @min:%2einstrumentationKey */ ] = cs.instrumentationkey || config[0, $iRSJj._DYN_INSTRUMENTATION_KEY /* @min:%2einstrumentationKey */ ];
            }
            _self[0, $iRSJj._DYN_APP_INSIGHTS /* @min:%2eappInsights */ ] = new (0, $ch4sE.AnalyticsPlugin)();
            properties = new (0, $cPPgl.default)();
            dependencies = new (0, $9ZYOv.AjaxMonitor)();
            _sender = new (0, $dSEhk.Sender)();
            _core = new (0, $ghxFc.AppInsightsCore)();
            _self.core = _core;
            var isErrMessageDisabled = (0, $erRAP.isNullOrUndefined)(config[0, $iRSJj._DYN_DISABLE_IKEY_DEPRECA18 /* @min:%2edisableIkeyDeprecationMessage */ ]) ? true : config[0, $iRSJj._DYN_DISABLE_IKEY_DEPRECA18 /* @min:%2edisableIkeyDeprecationMessage */ ];
            if (!config[0, $iRSJj._DYN_CONNECTION_STRING /* @min:%2econnectionString */ ] && !isErrMessageDisabled) (0, $8z2Gd._throwInternal)(_core.logger, 1 /* eLoggingSeverity.CRITICAL */ , 106 /* _eInternalMessageId.InstrumentationKeyDeprecation */ , "Instrumentation key support will end soon, see aka.ms/IkeyMigrate");
            _self[0, $4GkI4.STR_SNIPPET /* @min:%2esnippet */ ] = snippet;
            _self[0, $iRSJj._DYN_CONFIG /* @min:%2econfig */ ] = config;
            _getSKUDefaults();
            _self[0, $4GkI4.STR_FLUSH /* @min:%2eflush */ ] = function(async) {
                if (async === void 0) async = true;
                (0, $kBiyL.doPerf)(_core, function() {
                    return "AISKU.flush";
                }, function() {
                    (0, $erRAP.arrForEach)(_core[0, $iRSJj._DYN_GET_TRANSMISSION_CON19 /* @min:%2egetTransmissionControls */ ](), function(channels) {
                        (0, $erRAP.arrForEach)(channels, function(channel) {
                            channel[0, $4GkI4.STR_FLUSH /* @min:%2eflush */ ](async);
                        });
                    });
                }, null, async);
            };
            _self[0, $iRSJj._DYN_ONUNLOAD_FLUSH /* @min:%2eonunloadFlush */ ] = function(async) {
                if (async === void 0) async = true;
                (0, $erRAP.arrForEach)(_core[0, $iRSJj._DYN_GET_TRANSMISSION_CON19 /* @min:%2egetTransmissionControls */ ](), function(channels) {
                    (0, $erRAP.arrForEach)(channels, function(channel) {
                        if (channel[0, $iRSJj._DYN_ONUNLOAD_FLUSH /* @min:%2eonunloadFlush */ ]) channel[0, $iRSJj._DYN_ONUNLOAD_FLUSH /* @min:%2eonunloadFlush */ ]();
                        else channel[0, $4GkI4.STR_FLUSH /* @min:%2eflush */ ](async);
                    });
                });
            };
            _self[0, $iRSJj._DYN_LOAD_APP_INSIGHTS /* @min:%2eloadAppInsights */ ] = function(legacyMode, logger, notificationManager) {
                if (legacyMode === void 0) legacyMode = false;
                function _updateSnippetProperties(snippet) {
                    if (snippet) {
                        var snippetVer = "";
                        if (!(0, $erRAP.isNullOrUndefined)(_snippetVersion)) snippetVer += _snippetVersion;
                        if (legacyMode) snippetVer += ".lg";
                        if (_self[0, $iRSJj._DYN_CONTEXT /* @min:%2econtext */ ] && _self[0, $iRSJj._DYN_CONTEXT /* @min:%2econtext */ ].internal) _self[0, $iRSJj._DYN_CONTEXT /* @min:%2econtext */ ].internal.snippetVer = snippetVer || "-";
                        // apply updated properties to the global instance (snippet)
                        (0, $erRAP.objForEachKey)(_self, function(field, value) {
                            if ((0, $erRAP.isString)(field) && !(0, $erRAP.isFunction)(value) && field && field[0] !== "_" && // Don't copy "internal" values
                            (0, $erRAP.arrIndexOf)($a5ce4a62ad2de69d$var$_ignoreUpdateSnippetProperties, field) === -1) snippet[field] = value;
                        });
                    }
                }
                // dont allow additional channels/other extensions for legacy mode; legacy mode is only to allow users to switch with no code changes!
                if (legacyMode && _self[0, $iRSJj._DYN_CONFIG /* @min:%2econfig */ ].extensions && _self[0, $iRSJj._DYN_CONFIG /* @min:%2econfig */ ].extensions.length > 0) (0, $erRAP.throwError)("Extensions not allowed in legacy mode");
                (0, $kBiyL.doPerf)(_self.core, function() {
                    return "AISKU.loadAppInsights";
                }, function() {
                    var extensions = [];
                    extensions[0, $iRSJj._DYN_PUSH /* @min:%2epush */ ](_sender);
                    extensions[0, $iRSJj._DYN_PUSH /* @min:%2epush */ ](properties);
                    extensions[0, $iRSJj._DYN_PUSH /* @min:%2epush */ ](dependencies);
                    extensions[0, $iRSJj._DYN_PUSH /* @min:%2epush */ ](_self[0, $iRSJj._DYN_APP_INSIGHTS /* @min:%2eappInsights */ ]);
                    // initialize core
                    _core.initialize(_self[0, $iRSJj._DYN_CONFIG /* @min:%2econfig */ ], extensions, logger, notificationManager);
                    _self[0, $iRSJj._DYN_CONTEXT /* @min:%2econtext */ ] = properties[0, $iRSJj._DYN_CONTEXT /* @min:%2econtext */ ];
                    if ($a5ce4a62ad2de69d$var$_internalSdkSrc && _self[0, $iRSJj._DYN_CONTEXT /* @min:%2econtext */ ]) _self[0, $iRSJj._DYN_CONTEXT /* @min:%2econtext */ ].internal.sdkSrc = $a5ce4a62ad2de69d$var$_internalSdkSrc;
                    _updateSnippetProperties(_self[0, $4GkI4.STR_SNIPPET /* @min:%2esnippet */ ]);
                    // Empty queue of all api calls logged prior to sdk download
                    _self.emptyQueue();
                    _self[0, $4GkI4.STR_POLL_INTERNAL_LOGS /* @min:%2epollInternalLogs */ ]();
                    _self[0, $iRSJj._DYN_ADD_HOUSEKEEPING_BEF20 /* @min:%2eaddHousekeepingBeforeUnload */ ](_self);
                });
                return _self;
            };
            _self[0, $iRSJj._DYN_UPDATE_SNIPPET_DEFIN0 /* @min:%2eupdateSnippetDefinitions */ ] = function(snippet) {
                // apply full appInsights to the global instance
                // Note: This must be called before loadAppInsights is called
                (0, $erRAP.proxyAssign)(snippet, _self, function(name) {
                    // Not excluding names prefixed with "_" as we need to proxy some functions like _onError
                    return name && (0, $erRAP.arrIndexOf)($a5ce4a62ad2de69d$var$_ignoreUpdateSnippetProperties, name) === -1;
                });
            };
            _self.emptyQueue = function() {
                // call functions that were queued before the main script was loaded
                try {
                    if ((0, $erRAP.isArray)(_self.snippet[0, $iRSJj._DYN_QUEUE /* @min:%2equeue */ ])) {
                        // note: do not check length in the for-loop conditional in case something goes wrong and the stub methods are not overridden.
                        var length_1 = _self.snippet[0, $iRSJj._DYN_QUEUE /* @min:%2equeue */ ].length;
                        for(var i = 0; i < length_1; i++){
                            var call = _self.snippet[0, $iRSJj._DYN_QUEUE /* @min:%2equeue */ ][i];
                            call();
                        }
                        _self.snippet[0, $iRSJj._DYN_QUEUE /* @min:%2equeue */ ] = undefined;
                        delete _self.snippet[0, $iRSJj._DYN_QUEUE /* @min:%2equeue */ ];
                    }
                } catch (exception) {
                    var properties_1 = {};
                    if (exception && (0, $erRAP.isFunction)(exception.toString)) properties_1.exception = exception.toString();
                // need from core
                // Microsoft.ApplicationInsights._InternalLogging.throwInternal(
                //     eLoggingSeverity.WARNING,
                //     _eInternalMessageId.FailedToSendQueuedTelemetry,
                //     "Failed to send queued telemetry",
                //     properties);
                }
            };
            _self[0, $iRSJj._DYN_ADD_HOUSEKEEPING_BEF20 /* @min:%2eaddHousekeepingBeforeUnload */ ] = function(appInsightsInstance) {
                // Add callback to push events when the user navigates away
                if ((0, $3I5zg.hasWindow)() || (0, $3I5zg.hasDocument)()) {
                    var performHousekeeping = function() {
                        // Adds the ability to flush all data before the page unloads.
                        // Note: This approach tries to push a sync request with all the pending events onbeforeunload.
                        // Firefox does not respect this.Other browsers DO push out the call with < 100% hit rate.
                        // Telemetry here will help us analyze how effective this approach is.
                        // Another approach would be to make this call sync with a acceptable timeout to reduce the
                        // impact on user experience.
                        // appInsightsInstance.context._sender.triggerSend();
                        appInsightsInstance[0, $iRSJj._DYN_ONUNLOAD_FLUSH /* @min:%2eonunloadFlush */ ](false);
                        // Back up the current session to local storage
                        // This lets us close expired sessions after the cookies themselves expire
                        if ((0, $erRAP.isFunction)(_this.core[0, $4GkI4.STR_GET_PLUGIN /* @min:%2egetPlugin */ ])) {
                            var loadedPlugin = _this.core[0, $4GkI4.STR_GET_PLUGIN /* @min:%2egetPlugin */ ]((0, $1EHoQ.PropertiesPluginIdentifier));
                            if (loadedPlugin) {
                                var propertiesPlugin = loadedPlugin.plugin;
                                if (propertiesPlugin && propertiesPlugin[0, $iRSJj._DYN_CONTEXT /* @min:%2econtext */ ] && propertiesPlugin[0, $iRSJj._DYN_CONTEXT /* @min:%2econtext */ ]._sessionManager) propertiesPlugin[0, $iRSJj._DYN_CONTEXT /* @min:%2econtext */ ]._sessionManager.backup();
                            }
                        }
                    };
                    var added = false;
                    var excludePageUnloadEvents = appInsightsInstance.appInsights[0, $iRSJj._DYN_CONFIG /* @min:%2econfig */ ].disablePageUnloadEvents;
                    if (!_houseKeepingNamespace) _houseKeepingNamespace = (0, $cIC5n.mergeEvtNamespace)(_evtNamespace, _core[0, $4GkI4.STR_EVT_NAMESPACE /* @min:%2eevtNamespace */ ] && _core[0, $4GkI4.STR_EVT_NAMESPACE /* @min:%2eevtNamespace */ ]());
                    if (!appInsightsInstance.appInsights.config[0, $iRSJj._DYN_DISABLE_FLUSH_ON_BEF11 /* @min:%2edisableFlushOnBeforeUnload */ ]) {
                        // Hook the unload event for the document, window and body to ensure that the client events are flushed to the server
                        // As just hooking the window does not always fire (on chrome) for page navigation's.
                        if ((0, $cIC5n.addPageUnloadEventListener)(performHousekeeping, excludePageUnloadEvents, _houseKeepingNamespace)) added = true;
                        // We also need to hook the pagehide and visibilitychange events as not all versions of Safari support load/unload events.
                        if ((0, $cIC5n.addPageHideEventListener)(performHousekeeping, excludePageUnloadEvents, _houseKeepingNamespace)) added = true;
                        // A reactNative app may not have a window and therefore the beforeunload/pagehide events -- so don't
                        // log the failure in this case
                        if (!added && !(0, $3I5zg.isReactNative)()) (0, $8z2Gd._throwInternal)(appInsightsInstance[0, $iRSJj._DYN_APP_INSIGHTS /* @min:%2eappInsights */ ].core.logger, 1 /* eLoggingSeverity.CRITICAL */ , 19 /* _eInternalMessageId.FailedToAddHandlerForOnBeforeUnload */ , "Could not add handler for beforeunload and pagehide");
                    }
                    if (!added && !appInsightsInstance.appInsights.config[0, $iRSJj._DYN_DISABLE_FLUSH_ON_UNL12 /* @min:%2edisableFlushOnUnload */ ]) // If we didn't add the normal set then attempt to add the pagehide and visibilitychange only
                    (0, $cIC5n.addPageHideEventListener)(performHousekeeping, excludePageUnloadEvents, _houseKeepingNamespace);
                }
            };
            _self.getSender = function() {
                return _sender;
            };
            _self.unload = function(isAsync, unloadComplete, cbTimeout) {
                _self[0, $iRSJj._DYN_ONUNLOAD_FLUSH /* @min:%2eonunloadFlush */ ](isAsync);
                // Remove any registered event handlers
                if (_houseKeepingNamespace) {
                    (0, $cIC5n.removePageUnloadEventListener)(null, _houseKeepingNamespace);
                    (0, $cIC5n.removePageHideEventListener)(null, _houseKeepingNamespace);
                }
                _core.unload && _core.unload(isAsync, unloadComplete, cbTimeout);
            };
            (0, $erRAP.proxyFunctions)(_self, _self[0, $iRSJj._DYN_APP_INSIGHTS /* @min:%2eappInsights */ ], [
                (0, $4GkI4.STR_GET_COOKIE_MGR),
                (0, $4GkI4.STR_TRACK_EVENT),
                (0, $4GkI4.STR_TRACK_PAGE_VIEW),
                "trackPageViewPerformance",
                (0, $4GkI4.STR_TRACK_EXCEPTION),
                "_onerror",
                (0, $4GkI4.STR_TRACK_TRACE),
                (0, $4GkI4.STR_TRACK_METRIC),
                (0, $4GkI4.STR_START_TRACK_PAGE),
                (0, $4GkI4.STR_STOP_TRACK_PAGE),
                (0, $4GkI4.STR_START_TRACK_EVENT),
                (0, $4GkI4.STR_STOP_TRACK_EVENT)
            ]);
            (0, $erRAP.proxyFunctions)(_self, _getCurrentDependencies, [
                (0, $4GkI4.STR_TRACK_DEPENDENCY_DATA),
                "addDependencyListener",
                "addDependencyInitializer"
            ]);
            (0, $erRAP.proxyFunctions)(_self, _core, [
                (0, $4GkI4.STR_ADD_TELEMETRY_INITIALIZER),
                (0, $4GkI4.STR_POLL_INTERNAL_LOGS),
                "stopPollingInternalLogs",
                (0, $4GkI4.STR_GET_PLUGIN),
                "addPlugin",
                (0, $4GkI4.STR_EVT_NAMESPACE),
                "addUnloadCb",
                "getTraceCtx"
            ]);
            (0, $erRAP.proxyFunctions)(_self, function() {
                var context = properties[0, $iRSJj._DYN_CONTEXT /* @min:%2econtext */ ];
                return context ? context.user : null;
            }, [
                (0, $4GkI4.STR_SET_AUTHENTICATED_USER_CONTEXT),
                (0, $4GkI4.STR_CLEAR_AUTHENTICATED_USER_CONTEXT)
            ]);
            function _getSKUDefaults() {
                _self.config[0, $iRSJj._DYN_DIAGNOSTIC_LOG_INTER4 /* @min:%2ediagnosticLogInterval */ ] = _self.config[0, $iRSJj._DYN_DIAGNOSTIC_LOG_INTER4 /* @min:%2ediagnosticLogInterval */ ] && _self[0, $iRSJj._DYN_CONFIG /* @min:%2econfig */ ][0, $iRSJj._DYN_DIAGNOSTIC_LOG_INTER4 /* @min:%2ediagnosticLogInterval */ ] > 0 ? _self[0, $iRSJj._DYN_CONFIG /* @min:%2econfig */ ][0, $iRSJj._DYN_DIAGNOSTIC_LOG_INTER4 /* @min:%2ediagnosticLogInterval */ ] : 10000;
            }
            // Using a function to support the dynamic adding / removal of plugins, so this will always return the current value
            function _getCurrentDependencies() {
                return dependencies;
            }
            function _initDefaults() {
                _evtNamespace = (0, $2w0XY.createUniqueNamespace)("AISKU");
                _houseKeepingNamespace = null;
                dependencies = null;
                properties = null;
                _sender = null;
                _snippetVersion = null;
            }
        });
    }
    // Analytics Plugin
    // Removed Stub for Initialization.prototype.getCookieMgr.
    // Removed Stub for Initialization.prototype.trackEvent.
    // Removed Stub for Initialization.prototype.trackPageView.
    // Removed Stub for Initialization.prototype.trackPageViewPerformance.
    // Removed Stub for Initialization.prototype.trackException.
    // Removed Stub for Initialization.prototype._onerror.
    // Removed Stub for Initialization.prototype.trackTrace.
    // Removed Stub for Initialization.prototype.trackMetric.
    // Removed Stub for Initialization.prototype.startTrackPage.
    // Removed Stub for Initialization.prototype.stopTrackPage.
    // Removed Stub for Initialization.prototype.startTrackEvent.
    // Removed Stub for Initialization.prototype.stopTrackEvent.
    // Removed Stub for Initialization.prototype.addTelemetryInitializer.
    // Properties Plugin
    // Removed Stub for Initialization.prototype.setAuthenticatedUserContext.
    // Removed Stub for Initialization.prototype.clearAuthenticatedUserContext.
    // Dependencies Plugin
    // Removed Stub for Initialization.prototype.trackDependencyData.
    // Misc
    // Removed Stub for Initialization.prototype.flush.
    // Removed Stub for Initialization.prototype.onunloadFlush.
    // Removed Stub for Initialization.prototype.loadAppInsights.
    // Removed Stub for Initialization.prototype.updateSnippetDefinitions.
    // Removed Stub for Initialization.prototype.emptyQueue.
    // Removed Stub for Initialization.prototype.pollInternalLogs.
    // Removed Stub for Initialization.prototype.stopPollingInternalLogs.
    // Removed Stub for Initialization.prototype.addHousekeepingBeforeUnload.
    // Removed Stub for Initialization.prototype.getSender.
    // Removed Stub for Initialization.prototype.unload.
    // Removed Stub for Initialization.prototype.getPlugin.
    // Removed Stub for Initialization.prototype.addPlugin.
    // Removed Stub for Initialization.prototype.evtNamespace.
    // Removed Stub for Initialization.prototype.addUnloadCb.
    // Removed Stub for Initialization.prototype.addDependencyListener.
    /**
     * Add an dependency telemetry initializer callback function to allow populating additional properties or drop the request.
     * It is called after the dependency call has completed and any available performance details are available. A dependency
     * initializer is similar to the TelemetryInitializer function but it allows you to block the reporting of the dependency
     * request so that it doesn't count against the `maxAjaxCallsPerView`.
     * @param dependencyInitializer - The Dependency Telemetry Initializer function
     * @returns - A IDependencyInitializerHandler to enable the initializer to be removed
     */ Initialization.prototype.addDependencyInitializer = function(dependencyInitializer) {
        return null;
    };
    // Removed Stub for Initialization.prototype.getTraceCtx.
    return Initialization;
}();
// tslint:disable-next-line
(function() {
    var sdkSrc = null;
    var isModule = false;
    var cdns = [
        "://js.monitor.azure.com/",
        "://az416426.vo.msecnd.net/"
    ];
    try {
        // Try and determine whether the sdk is being loaded from the CDN
        // currentScript is only valid during initial processing
        var scrpt = (document || {}).currentScript;
        if (scrpt) sdkSrc = scrpt.src;
    } catch (e) {
    // eslint-disable-next-line no-empty
    }
    if (sdkSrc) try {
        var url = sdkSrc.toLowerCase();
        if (url) {
            var src = "";
            for(var idx = 0; idx < cdns.length; idx++)if (url[0, $iRSJj._DYN_INDEX_OF /* @min:%2eindexOf */ ](cdns[idx]) !== -1) {
                src = "cdn" + (idx + 1);
                if (url[0, $iRSJj._DYN_INDEX_OF /* @min:%2eindexOf */ ]("/scripts/") === -1) {
                    if (url[0, $iRSJj._DYN_INDEX_OF /* @min:%2eindexOf */ ]("/next/") !== -1) src += "-next";
                    else if (url[0, $iRSJj._DYN_INDEX_OF /* @min:%2eindexOf */ ]("/beta/") !== -1) src += "-beta";
                }
                $a5ce4a62ad2de69d$var$_internalSdkSrc = src + (isModule ? ".mod" : "");
                break;
            }
        }
    } catch (e) {
    // eslint-disable-next-line no-empty
    }
})();

});
parcelRegister("kbmky", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eb162816e55a6098$export$2e2bcd8739ae039; });
/*!
 * Microsoft Dynamic Proto Utility, 1.1.11
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ var $eb162816e55a6098$var$_a;
var $eb162816e55a6098$var$UNDEFINED = "undefined";
/**
 * Constant string defined to support minimization
 * @ignore
 */ var $eb162816e55a6098$var$Constructor = "constructor";
/**
 * Constant string defined to support minimization
 * @ignore
 */ var $eb162816e55a6098$var$Prototype = "prototype";
/**
 * Constant string defined to support minimization
 * @ignore
 */ var $eb162816e55a6098$var$strFunction = "function";
/**
 * Used to define the name of the instance function lookup table
 * @ignore
 */ var $eb162816e55a6098$var$DynInstFuncTable = "_dynInstFuncs";
/**
 * Name used to tag the dynamic prototype function
 * @ignore
 */ var $eb162816e55a6098$var$DynProxyTag = "_isDynProxy";
/**
 * Name added to a prototype to define the dynamic prototype "class" name used to lookup the function table
 * @ignore
 */ var $eb162816e55a6098$var$DynClassName = "_dynClass";
/**
 * Prefix added to the classname to avoid any name clashes with other instance level properties
 * @ignore
 */ var $eb162816e55a6098$var$DynClassNamePrefix = "_dynCls$";
/**
 * A tag which is used to check if we have already to attempted to set the instance function if one is not present
 * @ignore
 */ var $eb162816e55a6098$var$DynInstChkTag = "_dynInstChk";
/**
 * A tag which is used to check if we are allows to try and set an instance function is one is not present. Using the same
 * tag name as the function level but a different const name for readability only.
 */ var $eb162816e55a6098$var$DynAllowInstChkTag = $eb162816e55a6098$var$DynInstChkTag;
/**
 * The global (imported) instances where the global performance options are stored
 */ var $eb162816e55a6098$var$DynProtoDefaultOptions = "_dfOpts";
/**
 * Value used as the name of a class when it cannot be determined
 * @ignore
 */ var $eb162816e55a6098$var$UnknownValue = "_unknown_";
/**
 * Constant string defined to support minimization
 * @ignore
 */ var $eb162816e55a6098$var$str__Proto = "__proto__";
/**
 * The polyfill version of __proto__ so that it doesn't cause issues for anyone not expecting it to exist
 */ var $eb162816e55a6098$var$DynProtoBaseProto = "_dyn" + $eb162816e55a6098$var$str__Proto;
/**
 * Runtime Global holder for dynamicProto settings
 */ var $eb162816e55a6098$var$DynProtoGlobalSettings = "__dynProto$Gbl";
/**
 * Track the current prototype for IE8 as you can't look back to get the prototype
 */ var $eb162816e55a6098$var$DynProtoCurrent = "_dynInstProto";
/**
 * Constant string defined to support minimization
 * @ignore
 */ var $eb162816e55a6098$var$strUseBaseInst = "useBaseInst";
/**
 * Constant string defined to support minimization
 * @ignore
 */ var $eb162816e55a6098$var$strSetInstFuncs = "setInstFuncs";
var $eb162816e55a6098$var$Obj = Object;
/**
 * Pre-lookup to check if we are running on a modern browser (i.e. not IE8)
 * @ignore
 */ var $eb162816e55a6098$var$_objGetPrototypeOf = $eb162816e55a6098$var$Obj["getPrototypeOf"];
/**
 * Pre-lookup to check for the existence of this function
 */ var $eb162816e55a6098$var$_objGetOwnProps = $eb162816e55a6098$var$Obj["getOwnPropertyNames"];
/**
 * Gets the runtime global reference
 * @returns
 */ function $eb162816e55a6098$var$_getGlobal() {
    var result;
    if (typeof globalThis !== $eb162816e55a6098$var$UNDEFINED) result = globalThis;
    if (!result && typeof self !== $eb162816e55a6098$var$UNDEFINED) result = self;
    if (!result && typeof window !== $eb162816e55a6098$var$UNDEFINED) result = window;
    if (!result && typeof $parcel$global !== $eb162816e55a6098$var$UNDEFINED) result = $parcel$global;
    return result || {};
}
// Since 1.1.7 moving these to the runtime global to work around mixed version and module issues
// See Issue https://github.com/microsoft/DynamicProto-JS/issues/57 for details
var $eb162816e55a6098$var$_gbl = $eb162816e55a6098$var$_getGlobal();
var $eb162816e55a6098$var$_gblInst = $eb162816e55a6098$var$_gbl[$eb162816e55a6098$var$DynProtoGlobalSettings] || ($eb162816e55a6098$var$_gbl[$eb162816e55a6098$var$DynProtoGlobalSettings] = {
    o: ($eb162816e55a6098$var$_a = {}, $eb162816e55a6098$var$_a[$eb162816e55a6098$var$strSetInstFuncs] = true, $eb162816e55a6098$var$_a[$eb162816e55a6098$var$strUseBaseInst] = true, $eb162816e55a6098$var$_a),
    n: 1000 // Start new global index @ 1000 so we "fix" some cases when mixed with 1.1.6 or earlier
});
/**
 * Helper to check if the object contains a property of the name
 * @ignore
 */ function $eb162816e55a6098$var$_hasOwnProperty(obj, prop) {
    return obj && $eb162816e55a6098$var$Obj[$eb162816e55a6098$var$Prototype].hasOwnProperty.call(obj, prop);
}
/**
 * Helper used to check whether the target is an Object prototype or Array prototype
 * @ignore
 */ function $eb162816e55a6098$var$_isObjectOrArrayPrototype(target) {
    return target && (target === $eb162816e55a6098$var$Obj[$eb162816e55a6098$var$Prototype] || target === Array[$eb162816e55a6098$var$Prototype]);
}
/**
 * Helper used to check whether the target is an Object prototype, Array prototype or Function prototype
 * @ignore
 */ function $eb162816e55a6098$var$_isObjectArrayOrFunctionPrototype(target) {
    return $eb162816e55a6098$var$_isObjectOrArrayPrototype(target) || target === Function[$eb162816e55a6098$var$Prototype];
}
/**
 * Helper used to get the prototype of the target object as getPrototypeOf is not available in an ES3 environment.
 * @ignore
 */ function $eb162816e55a6098$var$_getObjProto(target) {
    var newProto;
    if (target) {
        // This method doesn't exist in older browsers (e.g. IE8)
        if ($eb162816e55a6098$var$_objGetPrototypeOf) return $eb162816e55a6098$var$_objGetPrototypeOf(target);
        var curProto = target[$eb162816e55a6098$var$str__Proto] || target[$eb162816e55a6098$var$Prototype] || (target[$eb162816e55a6098$var$Constructor] ? target[$eb162816e55a6098$var$Constructor][$eb162816e55a6098$var$Prototype] : null);
        // Using the pre-calculated value as IE8 doesn't support looking up the prototype of a prototype and thus fails for more than 1 base class
        newProto = target[$eb162816e55a6098$var$DynProtoBaseProto] || curProto;
        if (!$eb162816e55a6098$var$_hasOwnProperty(target, $eb162816e55a6098$var$DynProtoBaseProto)) {
            // As this prototype doesn't have this property then this is from an inherited class so newProto is the base to return so save it
            // so we can look it up value (which for a multiple hierarchy dynamicProto will be the base class)
            delete target[$eb162816e55a6098$var$DynProtoCurrent]; // Delete any current value allocated to this instance so we pick up the value from prototype hierarchy
            newProto = target[$eb162816e55a6098$var$DynProtoBaseProto] = target[$eb162816e55a6098$var$DynProtoCurrent] || target[$eb162816e55a6098$var$DynProtoBaseProto];
            target[$eb162816e55a6098$var$DynProtoCurrent] = curProto;
        }
    }
    return newProto;
}
/**
 * Helper to get the properties of an object, including none enumerable ones as functions on a prototype in ES6
 * are not enumerable.
 * @param target
 */ function $eb162816e55a6098$var$_forEachProp(target, func) {
    var props = [];
    if ($eb162816e55a6098$var$_objGetOwnProps) props = $eb162816e55a6098$var$_objGetOwnProps(target);
    else {
        for(var name_1 in target)if (typeof name_1 === "string" && $eb162816e55a6098$var$_hasOwnProperty(target, name_1)) props.push(name_1);
    }
    if (props && props.length > 0) for(var lp = 0; lp < props.length; lp++)func(props[lp]);
}
/**
 * Helper function to check whether the provided function name is a potential candidate for dynamic
 * callback and prototype generation.
 * @param target The target object, may be a prototype or class object
 * @param funcName The function name
 * @param skipOwn Skips the check for own property
 * @ignore
 */ function $eb162816e55a6098$var$_isDynamicCandidate(target, funcName, skipOwn) {
    return funcName !== $eb162816e55a6098$var$Constructor && typeof target[funcName] === $eb162816e55a6098$var$strFunction && (skipOwn || $eb162816e55a6098$var$_hasOwnProperty(target, funcName)) && funcName !== $eb162816e55a6098$var$str__Proto && funcName !== $eb162816e55a6098$var$Prototype;
}
/**
 * Helper to throw a TypeError exception
 * @param message the message
 * @ignore
 */ function $eb162816e55a6098$var$_throwTypeError(message) {
    throw new TypeError("DynamicProto: " + message);
}
function $eb162816e55a6098$var$_newObject() {
    return Object.create ? function(obj) {
        var func = Object["create"];
        if (func) return func(obj);
        if (obj == null) return {};
        var type = typeof obj;
        if (type !== "object" && type !== "function") throw new TypeError("Object prototype may only be an Object:" + obj);
        function tmpFunc() {}
        tmpFunc.prototype = obj;
        return new tmpFunc();
    }(null) : {};
}
/**
 * Returns a collection of the instance functions that are defined directly on the thisTarget object, it does
 * not return any inherited functions
 * @param thisTarget The object to get the instance functions from
 * @ignore
 */ function $eb162816e55a6098$var$_getInstanceFuncs(thisTarget) {
    // Get the base proto
    var instFuncs = $eb162816e55a6098$var$_newObject();
    // Save any existing instance functions
    $eb162816e55a6098$var$_forEachProp(thisTarget, function(name) {
        // Don't include any dynamic prototype instances - as we only want the real functions
        if (!instFuncs[name] && $eb162816e55a6098$var$_isDynamicCandidate(thisTarget, name, false)) // Create an instance callback for passing the base function to the caller
        instFuncs[name] = thisTarget[name];
    });
    return instFuncs;
}
/**
 * Returns whether the value is included in the array
 * @param values The array of values
 * @param value  The value
 */ function $eb162816e55a6098$var$_hasVisited(values, value) {
    for(var lp = values.length - 1; lp >= 0; lp--){
        if (values[lp] === value) return true;
    }
    return false;
}
/**
 * Returns an object that contains callback functions for all "base/super" functions, this is used to "save"
 * enabling calling super.xxx() functions without requiring that the base "class" has defined a prototype references
 * @param target The current instance
 * @ignore
 */ function $eb162816e55a6098$var$_getBaseFuncs(classProto, thisTarget, instFuncs, useBaseInst) {
    function _instFuncProxy(target, funcHost, funcName) {
        var theFunc = funcHost[funcName];
        if (theFunc[$eb162816e55a6098$var$DynProxyTag] && useBaseInst) {
            // grab and reuse the hosted looking function (if available) otherwise the original passed function
            var instFuncTable = target[$eb162816e55a6098$var$DynInstFuncTable] || {};
            if (instFuncTable[$eb162816e55a6098$var$DynAllowInstChkTag] !== false) theFunc = (instFuncTable[funcHost[$eb162816e55a6098$var$DynClassName]] || {})[funcName] || theFunc;
        }
        return function() {
            // eslint-disable-next-line prefer-rest-params
            return theFunc.apply(target, arguments);
        };
    }
    // Start creating a new baseFuncs by creating proxies for the instance functions (as they may get replaced)
    var baseFuncs = $eb162816e55a6098$var$_newObject();
    $eb162816e55a6098$var$_forEachProp(instFuncs, function(name) {
        // Create an instance callback for passing the base function to the caller
        baseFuncs[name] = _instFuncProxy(thisTarget, instFuncs, name);
    });
    // Get the base prototype functions
    var baseProto = $eb162816e55a6098$var$_getObjProto(classProto);
    var visited = [];
    // Don't include base object functions for Object, Array or Function
    while(baseProto && !$eb162816e55a6098$var$_isObjectArrayOrFunctionPrototype(baseProto) && !$eb162816e55a6098$var$_hasVisited(visited, baseProto)){
        // look for prototype functions
        $eb162816e55a6098$var$_forEachProp(baseProto, function(name) {
            // Don't include any dynamic prototype instances - as we only want the real functions
            // For IE 7/8 the prototype lookup doesn't provide the full chain so we need to bypass the 
            // hasOwnProperty check we get all of the methods, main difference is that IE7/8 doesn't return
            // the Object prototype methods while bypassing the check
            if (!baseFuncs[name] && $eb162816e55a6098$var$_isDynamicCandidate(baseProto, name, !$eb162816e55a6098$var$_objGetPrototypeOf)) // Create an instance callback for passing the base function to the caller
            baseFuncs[name] = _instFuncProxy(thisTarget, baseProto, name);
        });
        // We need to find all possible functions that might be overloaded by walking the entire prototype chain
        // This avoids the caller from needing to check whether it's direct base class implements the function or not
        // by walking the entire chain it simplifies the usage and issues from upgrading any of the base classes.
        visited.push(baseProto);
        baseProto = $eb162816e55a6098$var$_getObjProto(baseProto);
    }
    return baseFuncs;
}
function $eb162816e55a6098$var$_getInstFunc(target, funcName, proto, currentDynProtoProxy) {
    var instFunc = null;
    // We need to check whether the class name is defined directly on this prototype otherwise
    // it will walk the proto chain and return any parent proto classname.
    if (target && $eb162816e55a6098$var$_hasOwnProperty(proto, $eb162816e55a6098$var$DynClassName)) {
        var instFuncTable = target[$eb162816e55a6098$var$DynInstFuncTable] || $eb162816e55a6098$var$_newObject();
        instFunc = (instFuncTable[proto[$eb162816e55a6098$var$DynClassName]] || $eb162816e55a6098$var$_newObject())[funcName];
        if (!instFunc) // Avoid stack overflow from recursive calling the same function
        $eb162816e55a6098$var$_throwTypeError("Missing [" + funcName + "] " + $eb162816e55a6098$var$strFunction);
        // We have the instance function, lets check it we can speed up further calls
        // by adding the instance function back directly on the instance (avoiding the dynamic func lookup)
        if (!instFunc[$eb162816e55a6098$var$DynInstChkTag] && instFuncTable[$eb162816e55a6098$var$DynAllowInstChkTag] !== false) {
            // If the instance already has an instance function we can't replace it
            var canAddInst = !$eb162816e55a6098$var$_hasOwnProperty(target, funcName);
            // Get current prototype
            var objProto = $eb162816e55a6098$var$_getObjProto(target);
            var visited = [];
            // Lookup the function starting at the top (instance level prototype) and traverse down, if the first matching function
            // if nothing is found or if the first hit is a dynamic proto instance then we can safely add an instance shortcut
            while(canAddInst && objProto && !$eb162816e55a6098$var$_isObjectArrayOrFunctionPrototype(objProto) && !$eb162816e55a6098$var$_hasVisited(visited, objProto)){
                var protoFunc = objProto[funcName];
                if (protoFunc) {
                    canAddInst = protoFunc === currentDynProtoProxy;
                    break;
                }
                // We need to find all possible initial functions to ensure that we don't bypass a valid override function
                visited.push(objProto);
                objProto = $eb162816e55a6098$var$_getObjProto(objProto);
            }
            try {
                if (canAddInst) // This instance doesn't have an instance func and the class hierarchy does have a higher level prototype version
                // so it's safe to directly assign for any subsequent calls (for better performance)
                target[funcName] = instFunc;
                // Block further attempts to set the instance function for any
                instFunc[$eb162816e55a6098$var$DynInstChkTag] = 1;
            } catch (e) {
                // Don't crash if the object is readonly or the runtime doesn't allow changing this
                // And set a flag so we don't try again for any function
                instFuncTable[$eb162816e55a6098$var$DynAllowInstChkTag] = false;
            }
        }
    }
    return instFunc;
}
function $eb162816e55a6098$var$_getProtoFunc(funcName, proto, currentDynProtoProxy) {
    var protoFunc = proto[funcName];
    // Check that the prototype function is not a self reference -- try to avoid stack overflow!
    if (protoFunc === currentDynProtoProxy) // It is so lookup the base prototype
    protoFunc = $eb162816e55a6098$var$_getObjProto(proto)[funcName];
    if (typeof protoFunc !== $eb162816e55a6098$var$strFunction) $eb162816e55a6098$var$_throwTypeError("[" + funcName + "] is not a " + $eb162816e55a6098$var$strFunction);
    return protoFunc;
}
/**
 * Add the required dynamic prototype methods to the the class prototype
 * @param proto - The class prototype
 * @param className - The instance classname
 * @param target - The target instance
 * @param baseInstFuncs - The base instance functions
 * @param setInstanceFunc - Flag to allow prototype function to reset the instance function if one does not exist
 * @ignore
 */ function $eb162816e55a6098$var$_populatePrototype(proto, className, target, baseInstFuncs, setInstanceFunc) {
    function _createDynamicPrototype(proto, funcName) {
        var dynProtoProxy = function() {
            // Use the instance or prototype function
            var instFunc = $eb162816e55a6098$var$_getInstFunc(this, funcName, proto, dynProtoProxy) || $eb162816e55a6098$var$_getProtoFunc(funcName, proto, dynProtoProxy);
            // eslint-disable-next-line prefer-rest-params
            return instFunc.apply(this, arguments);
        };
        // Tag this function as a proxy to support replacing dynamic proxy elements (primary use case is for unit testing
        // via which can dynamically replace the prototype function reference)
        dynProtoProxy[$eb162816e55a6098$var$DynProxyTag] = 1;
        return dynProtoProxy;
    }
    if (!$eb162816e55a6098$var$_isObjectOrArrayPrototype(proto)) {
        var instFuncTable = target[$eb162816e55a6098$var$DynInstFuncTable] = target[$eb162816e55a6098$var$DynInstFuncTable] || $eb162816e55a6098$var$_newObject();
        if (!$eb162816e55a6098$var$_isObjectOrArrayPrototype(instFuncTable)) {
            var instFuncs_1 = instFuncTable[className] = instFuncTable[className] || $eb162816e55a6098$var$_newObject(); // fetch and assign if as it may not exist yet
            // Set whether we are allow to lookup instances, if someone has set to false then do not re-enable
            if (instFuncTable[$eb162816e55a6098$var$DynAllowInstChkTag] !== false) instFuncTable[$eb162816e55a6098$var$DynAllowInstChkTag] = !!setInstanceFunc;
            if (!$eb162816e55a6098$var$_isObjectOrArrayPrototype(instFuncs_1)) $eb162816e55a6098$var$_forEachProp(target, function(name) {
                // Only add overridden functions
                if ($eb162816e55a6098$var$_isDynamicCandidate(target, name, false) && target[name] !== baseInstFuncs[name]) {
                    // Save the instance Function to the lookup table and remove it from the instance as it's not a dynamic proto function
                    instFuncs_1[name] = target[name];
                    delete target[name];
                    // Add a dynamic proto if one doesn't exist or if a prototype function exists and it's not a dynamic one
                    if (!$eb162816e55a6098$var$_hasOwnProperty(proto, name) || proto[name] && !proto[name][$eb162816e55a6098$var$DynProxyTag]) proto[name] = _createDynamicPrototype(proto, name);
                }
            });
        }
    }
}
/**
 * Checks whether the passed prototype object appears to be correct by walking the prototype hierarchy of the instance
 * @param classProto The class prototype instance
 * @param thisTarget The current instance that will be checked whether the passed prototype instance is in the hierarchy
 * @ignore
 */ function $eb162816e55a6098$var$_checkPrototype(classProto, thisTarget) {
    // This method doesn't existing in older browsers (e.g. IE8)
    if ($eb162816e55a6098$var$_objGetPrototypeOf) {
        // As this is primarily a coding time check, don't bother checking if running in IE8 or lower
        var visited = [];
        var thisProto = $eb162816e55a6098$var$_getObjProto(thisTarget);
        while(thisProto && !$eb162816e55a6098$var$_isObjectArrayOrFunctionPrototype(thisProto) && !$eb162816e55a6098$var$_hasVisited(visited, thisProto)){
            if (thisProto === classProto) return true;
            // This avoids the caller from needing to check whether it's direct base class implements the function or not
            // by walking the entire chain it simplifies the usage and issues from upgrading any of the base classes.
            visited.push(thisProto);
            thisProto = $eb162816e55a6098$var$_getObjProto(thisProto);
        }
        return false;
    }
    // If objGetPrototypeOf doesn't exist then just assume everything is ok.
    return true;
}
/**
 * Gets the current prototype name using the ES6 name if available otherwise falling back to a use unknown as the name.
 * It's not critical for this to return a name, it's used to decorate the generated unique name for easier debugging only.
 * @param target
 * @param unknownValue
 * @ignore
 */ function $eb162816e55a6098$var$_getObjName(target, unknownValue) {
    if ($eb162816e55a6098$var$_hasOwnProperty(target, $eb162816e55a6098$var$Prototype)) // Look like a prototype
    return target.name || unknownValue || $eb162816e55a6098$var$UnknownValue;
    return ((target || {})[$eb162816e55a6098$var$Constructor] || {}).name || unknownValue || $eb162816e55a6098$var$UnknownValue;
}
/**
 * Helper function when creating dynamic (inline) functions for classes, this helper performs the following tasks :-
 * - Saves references to all defined base class functions
 * - Calls the delegateFunc with the current target (this) and a base object reference that can be used to call all "super" functions.
 * - Will populate the class prototype for all overridden functions to support class extension that call the prototype instance.
 * Callers should use this helper when declaring all function within the constructor of a class, as mentioned above the delegateFunc is
 * passed both the target "this" and an object that can be used to call any base (super) functions, using this based object in place of
 * super.XXX() (which gets expanded to _super.prototype.XXX()) provides a better minification outcome and also ensures the correct "this"
 * context is maintained as TypeScript creates incorrect references using super.XXXX() for dynamically defined functions i.e. Functions
 * defined in the constructor or some other function (rather than declared as complete typescript functions).
 * ### Usage
 * ```typescript
 * import dynamicProto from "@microsoft/dynamicproto-js";
 * class ExampleClass extends BaseClass {
 *     constructor() {
 *         dynamicProto(ExampleClass, this, (_self, base) => {
 *             // This will define a function that will be converted to a prototype function
 *             _self.newFunc = () => {
 *                 // Access any "this" instance property
 *                 if (_self.someProperty) {
 *                     ...
 *                 }
 *             }
 *             // This will define a function that will be converted to a prototype function
 *             _self.myFunction = () => {
 *                 // Access any "this" instance property
 *                 if (_self.someProperty) {
 *                     // Call the base version of the function that we are overriding
 *                     base.myFunction();
 *                 }
 *                 ...
 *             }
 *             _self.initialize = () => {
 *                 ...
 *             }
 *             // Warnings: While the following will work as _self is simply a reference to
 *             // this, if anyone overrides myFunction() the overridden will be called first
 *             // as the normal JavaScript method resolution will occur and the defined
 *             // _self.initialize() function is actually gets removed from the instance and
 *             // a proxy prototype version is created to reference the created method.
 *             _self.initialize();
 *         });
 *     }
 * }
 * ```
 * @typeparam DPType This is the generic type of the class, used to keep intellisense valid
 * @typeparam DPCls The type that contains the prototype of the current class
 * @param theClass - This is the current class instance which contains the prototype for the current class
 * @param target - The current "this" (target) reference, when the class has been extended this.prototype will not be the 'theClass' value.
 * @param delegateFunc - The callback function (closure) that will create the dynamic function
 * @param options - Additional options to configure how the dynamic prototype operates
 */ function $eb162816e55a6098$export$2e2bcd8739ae039(theClass, target, delegateFunc, options) {
    // Make sure that the passed theClass argument looks correct
    if (!$eb162816e55a6098$var$_hasOwnProperty(theClass, $eb162816e55a6098$var$Prototype)) $eb162816e55a6098$var$_throwTypeError("theClass is an invalid class definition.");
    // Quick check to make sure that the passed theClass argument looks correct (this is a common copy/paste error)
    var classProto = theClass[$eb162816e55a6098$var$Prototype];
    if (!$eb162816e55a6098$var$_checkPrototype(classProto, target)) $eb162816e55a6098$var$_throwTypeError("[" + $eb162816e55a6098$var$_getObjName(theClass) + "] not in hierarchy of [" + $eb162816e55a6098$var$_getObjName(target) + "]");
    var className = null;
    if ($eb162816e55a6098$var$_hasOwnProperty(classProto, $eb162816e55a6098$var$DynClassName)) // Only grab the class name if it's defined on this prototype (i.e. don't walk the prototype chain)
    className = classProto[$eb162816e55a6098$var$DynClassName];
    else {
        // As not all browser support name on the prototype creating a unique dynamic one if we have not already
        // assigned one, so we can use a simple string as the lookup rather than an object for the dynamic instance
        // function table lookup.
        className = $eb162816e55a6098$var$DynClassNamePrefix + $eb162816e55a6098$var$_getObjName(theClass, "_") + "$" + $eb162816e55a6098$var$_gblInst.n;
        $eb162816e55a6098$var$_gblInst.n++;
        classProto[$eb162816e55a6098$var$DynClassName] = className;
    }
    var perfOptions = $eb162816e55a6098$export$2e2bcd8739ae039[$eb162816e55a6098$var$DynProtoDefaultOptions];
    var useBaseInst = !!perfOptions[$eb162816e55a6098$var$strUseBaseInst];
    if (useBaseInst && options && options[$eb162816e55a6098$var$strUseBaseInst] !== undefined) useBaseInst = !!options[$eb162816e55a6098$var$strUseBaseInst];
    // Get the current instance functions
    var instFuncs = $eb162816e55a6098$var$_getInstanceFuncs(target);
    // Get all of the functions for any base instance (before they are potentially overridden)
    var baseFuncs = $eb162816e55a6098$var$_getBaseFuncs(classProto, target, instFuncs, useBaseInst);
    // Execute the delegate passing in both the current target "this" and "base" function references
    // Note casting the same type as we don't actually have the base class here and this will provide some intellisense support
    delegateFunc(target, baseFuncs);
    // Don't allow setting instance functions for older IE instances
    var setInstanceFunc = !!$eb162816e55a6098$var$_objGetPrototypeOf && !!perfOptions[$eb162816e55a6098$var$strSetInstFuncs];
    if (setInstanceFunc && options) setInstanceFunc = !!options[$eb162816e55a6098$var$strSetInstFuncs];
    // Populate the Prototype for any overridden instance functions
    $eb162816e55a6098$var$_populatePrototype(classProto, className, target, instFuncs, setInstanceFunc !== false);
}
/**
 * Exposes the default global options to allow global configuration, if the global values are disabled these will override
 * any passed values. This is primarily exposed to support unit-testing without the need for individual classes to expose
 * their internal usage of dynamic proto.
 */ $eb162816e55a6098$export$2e2bcd8739ae039[$eb162816e55a6098$var$DynProtoDefaultOptions] = $eb162816e55a6098$var$_gblInst.o;

});

parcelRegister("ch4sE", function(module, exports) {

$parcel$export(module.exports, "AnalyticsPlugin", function () { return $8efa887a1f7ab362$export$ca681bfeb2cf0fca; });
/*
 * Application Insights JavaScript SDK - Web Analytics, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ /**
* ApplicationInsights.ts
* @copyright Microsoft 2018
*/ 
var $fcMe7 = parcelRequire("fcMe7");

var $kbmky = parcelRequire("kbmky");

var $1EHoQ = parcelRequire("1EHoQ");
var $4sUzw = parcelRequire("4sUzw");
var $4AhFx = parcelRequire("4AhFx");
var $62ywT = parcelRequire("62ywT");
var $cGFCT = parcelRequire("cGFCT");
var $fK8rK = parcelRequire("fK8rK");
var $3AuL8 = parcelRequire("3AuL8");
var $6Gvon = parcelRequire("6Gvon");
var $ihDSn = parcelRequire("ihDSn");
var $80I4P = parcelRequire("80I4P");
var $bmYDZ = parcelRequire("bmYDZ");
var $7fph4 = parcelRequire("7fph4");
var $dCW8D = parcelRequire("dCW8D");
var $lL63Q = parcelRequire("lL63Q");
var $fu0yT = parcelRequire("fu0yT");

var $erRAP = parcelRequire("erRAP");
var $3wvVb = parcelRequire("3wvVb");
var $kry7o = parcelRequire("kry7o");
var $2w0XY = parcelRequire("2w0XY");
var $3I5zg = parcelRequire("3I5zg");
var $cIC5n = parcelRequire("cIC5n");
var $iBAi6 = parcelRequire("iBAi6");
var $2CgMu = parcelRequire("2CgMu");
var $31Ks8 = parcelRequire("31Ks8");
var $VVkgt = parcelRequire("VVkgt");

var $cPiEJ = parcelRequire("cPiEJ");

var $4wyIY = parcelRequire("4wyIY");

var $fcx3d = parcelRequire("fcx3d");

var $idCyU = parcelRequire("idCyU");

var $d5JsA = parcelRequire("d5JsA");
var $8efa887a1f7ab362$var$strEvent = "event";
function $8efa887a1f7ab362$var$_dispatchEvent(target, evnt) {
    if (target && target.dispatchEvent && evnt) target.dispatchEvent(evnt);
}
function $8efa887a1f7ab362$var$_getReason(error) {
    if (error && error.reason) {
        var reason = error.reason;
        if (!(0, $erRAP.isString)(reason) && (0, $erRAP.isFunction)(reason[0, $cPiEJ._DYN_TO_STRING /* @min:%2etoString */ ])) return reason[0, $cPiEJ._DYN_TO_STRING /* @min:%2etoString */ ]();
        return (0, $3I5zg.dumpObj)(reason);
    }
    // Pass the original object down which will eventually get evaluated for any message or description
    return error || "";
}
var $8efa887a1f7ab362$var$MinMilliSeconds = 60000;
function $8efa887a1f7ab362$var$_configMilliseconds(value, defValue) {
    value = value || defValue;
    if (value < $8efa887a1f7ab362$var$MinMilliSeconds) value = $8efa887a1f7ab362$var$MinMilliSeconds;
    return value;
}
function $8efa887a1f7ab362$var$_getDefaultConfig(config) {
    if (!config) config = {};
    // set default values
    config.sessionRenewalMs = $8efa887a1f7ab362$var$_configMilliseconds(config.sessionRenewalMs, 1800000);
    config.sessionExpirationMs = $8efa887a1f7ab362$var$_configMilliseconds(config.sessionExpirationMs, 86400000);
    config[0, $cPiEJ._DYN_DISABLE_EXCEPTION_TR0 /* @min:%2edisableExceptionTracking */ ] = (0, $6Gvon.stringToBoolOrDefault)(config[0, $cPiEJ._DYN_DISABLE_EXCEPTION_TR0 /* @min:%2edisableExceptionTracking */ ]);
    config[0, $cPiEJ._DYN_AUTO_TRACK_PAGE_VISI1 /* @min:%2eautoTrackPageVisitTime */ ] = (0, $6Gvon.stringToBoolOrDefault)(config[0, $cPiEJ._DYN_AUTO_TRACK_PAGE_VISI1 /* @min:%2eautoTrackPageVisitTime */ ]);
    config[0, $cPiEJ._DYN_OVERRIDE_PAGE_VIEW_D2 /* @min:%2eoverridePageViewDuration */ ] = (0, $6Gvon.stringToBoolOrDefault)(config[0, $cPiEJ._DYN_OVERRIDE_PAGE_VIEW_D2 /* @min:%2eoverridePageViewDuration */ ]);
    config[0, $cPiEJ._DYN_ENABLE_UNHANDLED_PRO3 /* @min:%2eenableUnhandledPromiseRejectionTracking */ ] = (0, $6Gvon.stringToBoolOrDefault)(config[0, $cPiEJ._DYN_ENABLE_UNHANDLED_PRO3 /* @min:%2eenableUnhandledPromiseRejectionTracking */ ]);
    if (isNaN(config[0, $cPiEJ._DYN_SAMPLING_PERCENTAGE /* @min:%2esamplingPercentage */ ]) || config[0, $cPiEJ._DYN_SAMPLING_PERCENTAGE /* @min:%2esamplingPercentage */ ] <= 0 || config[0, $cPiEJ._DYN_SAMPLING_PERCENTAGE /* @min:%2esamplingPercentage */ ] >= 100) config[0, $cPiEJ._DYN_SAMPLING_PERCENTAGE /* @min:%2esamplingPercentage */ ] = 100;
    config[0, $cPiEJ._DYN_IS_STORAGE_USE_DISAB4 /* @min:%2eisStorageUseDisabled */ ] = (0, $6Gvon.stringToBoolOrDefault)(config[0, $cPiEJ._DYN_IS_STORAGE_USE_DISAB4 /* @min:%2eisStorageUseDisabled */ ]);
    config[0, $cPiEJ._DYN_IS_BROWSER_LINK_TRAC5 /* @min:%2eisBrowserLinkTrackingEnabled */ ] = (0, $6Gvon.stringToBoolOrDefault)(config[0, $cPiEJ._DYN_IS_BROWSER_LINK_TRAC5 /* @min:%2eisBrowserLinkTrackingEnabled */ ]);
    config[0, $cPiEJ._DYN_ENABLE_AUTO_ROUTE_TR6 /* @min:%2eenableAutoRouteTracking */ ] = (0, $6Gvon.stringToBoolOrDefault)(config[0, $cPiEJ._DYN_ENABLE_AUTO_ROUTE_TR6 /* @min:%2eenableAutoRouteTracking */ ]);
    config[0, $cPiEJ._DYN_NAME_PREFIX /* @min:%2enamePrefix */ ] = config[0, $cPiEJ._DYN_NAME_PREFIX /* @min:%2enamePrefix */ ] || "";
    config.enableDebug = (0, $6Gvon.stringToBoolOrDefault)(config.enableDebug);
    config[0, $cPiEJ._DYN_DISABLE_FLUSH_ON_BEF7 /* @min:%2edisableFlushOnBeforeUnload */ ] = (0, $6Gvon.stringToBoolOrDefault)(config[0, $cPiEJ._DYN_DISABLE_FLUSH_ON_BEF7 /* @min:%2edisableFlushOnBeforeUnload */ ]);
    config.disableFlushOnUnload = (0, $6Gvon.stringToBoolOrDefault)(config.disableFlushOnUnload, config[0, $cPiEJ._DYN_DISABLE_FLUSH_ON_BEF7 /* @min:%2edisableFlushOnBeforeUnload */ ]);
    return config;
}
function $8efa887a1f7ab362$var$_updateStorageUsage(extConfig) {
    // Not resetting the storage usage as someone may have manually called utlDisableStorage, so this will only
    // reset based if the configuration option is provided
    if (!(0, $erRAP.isUndefined)(extConfig[0, $cPiEJ._DYN_IS_STORAGE_USE_DISAB4 /* @min:%2eisStorageUseDisabled */ ])) {
        if (extConfig[0, $cPiEJ._DYN_IS_STORAGE_USE_DISAB4 /* @min:%2eisStorageUseDisabled */ ]) (0, $fu0yT.utlDisableStorage)();
        else (0, $fu0yT.utlEnableStorage)();
    }
}
var $8efa887a1f7ab362$export$ca681bfeb2cf0fca = /** @class */ function(_super) {
    (0, $fcMe7.__extendsFn)(AnalyticsPlugin, _super);
    function AnalyticsPlugin() {
        var _this = _super.call(this) || this;
        _this.identifier = (0, $1EHoQ.AnalyticsPluginIdentifier); // do not change name or priority
        _this.priority = 180; // take from reserved priority range 100- 200
        _this.autoRoutePVDelay = 500; // ms; Time to wait after a route change before triggering a pageview to allow DOM changes to take place
        var _eventTracking;
        var _pageTracking;
        var _pageViewManager;
        var _pageViewPerformanceManager;
        var _pageVisitTimeManager;
        var _preInitTelemetryInitializers;
        var _isBrowserLinkTrackingEnabled;
        var _browserLinkInitializerAdded;
        var _enableAutoRouteTracking;
        var _historyListenerAdded;
        var _disableExceptionTracking;
        var _autoExceptionInstrumented;
        var _enableUnhandledPromiseRejectionTracking;
        var _autoUnhandledPromiseInstrumented;
        // Counts number of trackAjax invocations.
        // By default we only monitor X ajax call per view to avoid too much load.
        // Default value is set in config.
        // This counter keeps increasing even after the limit is reached.
        var _trackAjaxAttempts = 0;
        // array with max length of 2 that store current url and previous url for SPA page route change trackPageview use.
        var _prevUri; // Assigned in the constructor
        var _currUri;
        var _evtNamespace;
        (0, $kbmky.default)(AnalyticsPlugin, _this, function(_self, _base) {
            var _addHook = _base._addHook;
            _initDefaults();
            _self.getCookieMgr = function() {
                return (0, $31Ks8.safeGetCookieMgr)(_self[0, $cPiEJ._DYN_CORE /* @min:%2ecore */ ]);
            };
            _self.processTelemetry = function(env, itemCtx) {
                _self.processNext(env, itemCtx);
            };
            _self.trackEvent = function(event, customProperties) {
                try {
                    var telemetryItem = (0, $62ywT.createTelemetryItem)(event, (0, $fK8rK.Event)[0, $cPiEJ._DYN_DATA_TYPE /* @min:%2edataType */ ], (0, $fK8rK.Event)[0, $cPiEJ._DYN_ENVELOPE_TYPE /* @min:%2eenvelopeType */ ], _self[0, $cPiEJ._DYN_DIAG_LOG /* @min:%2ediagLog */ ](), customProperties);
                    _self[0, $cPiEJ._DYN_CORE /* @min:%2ecore */ ][0, $cPiEJ._DYN_TRACK /* @min:%2etrack */ ](telemetryItem);
                } catch (e) {
                    _throwInternal(2 /* eLoggingSeverity.WARNING */ , 39 /* _eInternalMessageId.TrackTraceFailed */ , "trackTrace failed, trace will not be collected: " + (0, $erRAP.getExceptionName)(e), {
                        exception: (0, $3I5zg.dumpObj)(e)
                    });
                }
            };
            /**
             * Start timing an extended event. Call `stopTrackEvent` to log the event when it ends.
             * @param   name    A string that identifies this event uniquely within the document.
             */ _self.startTrackEvent = function(name) {
                try {
                    _eventTracking.start(name);
                } catch (e) {
                    _throwInternal(1 /* eLoggingSeverity.CRITICAL */ , 29 /* _eInternalMessageId.StartTrackEventFailed */ , "startTrackEvent failed, event will not be collected: " + (0, $erRAP.getExceptionName)(e), {
                        exception: (0, $3I5zg.dumpObj)(e)
                    });
                }
            };
            /**
             * Log an extended event that you started timing with `startTrackEvent`.
             * @param   name    The string you used to identify this event in `startTrackEvent`.
             * @param   properties  map[string, string] - additional data used to filter events and metrics in the portal. Defaults to empty.
             * @param   measurements    map[string, number] - metrics associated with this event, displayed in Metrics Explorer on the portal. Defaults to empty.
             */ _self.stopTrackEvent = function(name, properties, measurements) {
                try {
                    _eventTracking.stop(name, undefined, properties, measurements);
                } catch (e) {
                    _throwInternal(1 /* eLoggingSeverity.CRITICAL */ , 30 /* _eInternalMessageId.StopTrackEventFailed */ , "stopTrackEvent failed, event will not be collected: " + (0, $erRAP.getExceptionName)(e), {
                        exception: (0, $3I5zg.dumpObj)(e)
                    });
                }
            };
            /**
             * @description Log a diagnostic message
             * @param {ITraceTelemetry} trace
             * @param ICustomProperties.
             * @memberof ApplicationInsights
             */ _self.trackTrace = function(trace, customProperties) {
                try {
                    var telemetryItem = (0, $62ywT.createTelemetryItem)(trace, (0, $lL63Q.Trace)[0, $cPiEJ._DYN_DATA_TYPE /* @min:%2edataType */ ], (0, $lL63Q.Trace)[0, $cPiEJ._DYN_ENVELOPE_TYPE /* @min:%2eenvelopeType */ ], _self[0, $cPiEJ._DYN_DIAG_LOG /* @min:%2ediagLog */ ](), customProperties);
                    _self[0, $cPiEJ._DYN_CORE /* @min:%2ecore */ ][0, $cPiEJ._DYN_TRACK /* @min:%2etrack */ ](telemetryItem);
                } catch (e) {
                    _throwInternal(2 /* eLoggingSeverity.WARNING */ , 39 /* _eInternalMessageId.TrackTraceFailed */ , "trackTrace failed, trace will not be collected: " + (0, $erRAP.getExceptionName)(e), {
                        exception: (0, $3I5zg.dumpObj)(e)
                    });
                }
            };
            /**
             * @description Log a numeric value that is not associated with a specific event. Typically
             * used to send regular reports of performance indicators. To send single measurement, just
             * use the name and average fields of {@link IMetricTelemetry}. If you take measurements
             * frequently, you can reduce the telemetry bandwidth by aggregating multiple measurements
             * and sending the resulting average at intervals
             * @param {IMetricTelemetry} metric input object argument. Only name and average are mandatory.
             * @param {{[key: string]: any}} customProperties additional data used to filter metrics in the
             * portal. Defaults to empty.
             * @memberof ApplicationInsights
             */ _self.trackMetric = function(metric, customProperties) {
                try {
                    var telemetryItem = (0, $62ywT.createTelemetryItem)(metric, (0, $ihDSn.Metric)[0, $cPiEJ._DYN_DATA_TYPE /* @min:%2edataType */ ], (0, $ihDSn.Metric)[0, $cPiEJ._DYN_ENVELOPE_TYPE /* @min:%2eenvelopeType */ ], _self[0, $cPiEJ._DYN_DIAG_LOG /* @min:%2ediagLog */ ](), customProperties);
                    _self[0, $cPiEJ._DYN_CORE /* @min:%2ecore */ ][0, $cPiEJ._DYN_TRACK /* @min:%2etrack */ ](telemetryItem);
                } catch (e) {
                    _throwInternal(1 /* eLoggingSeverity.CRITICAL */ , 36 /* _eInternalMessageId.TrackMetricFailed */ , "trackMetric failed, metric will not be collected: " + (0, $erRAP.getExceptionName)(e), {
                        exception: (0, $3I5zg.dumpObj)(e)
                    });
                }
            };
            /**
             * Logs that a page or other item was viewed.
             * @param IPageViewTelemetry The string you used as the name in startTrackPage. Defaults to the document title.
             * @param customProperties Additional data used to filter events and metrics. Defaults to empty.
             * If a user wants to provide duration for pageLoad, it'll have to be in pageView.properties.duration
             */ _self[0, $cPiEJ._DYN_TRACK_PAGE_VIEW /* @min:%2etrackPageView */ ] = function(pageView, customProperties) {
                try {
                    var inPv = pageView || {};
                    _pageViewManager[0, $cPiEJ._DYN_TRACK_PAGE_VIEW /* @min:%2etrackPageView */ ](inPv, (0, $fcMe7.__assignFn)((0, $fcMe7.__assignFn)((0, $fcMe7.__assignFn)({}, inPv.properties), inPv.measurements), customProperties));
                    if (_self.config[0, $cPiEJ._DYN_AUTO_TRACK_PAGE_VISI1 /* @min:%2eautoTrackPageVisitTime */ ]) _pageVisitTimeManager[0, $cPiEJ._DYN_TRACK_PREVIOUS_PAGE_9 /* @min:%2etrackPreviousPageVisit */ ](inPv.name, inPv.uri);
                } catch (e) {
                    _throwInternal(1 /* eLoggingSeverity.CRITICAL */ , 37 /* _eInternalMessageId.TrackPVFailed */ , "trackPageView failed, page view will not be collected: " + (0, $erRAP.getExceptionName)(e), {
                        exception: (0, $3I5zg.dumpObj)(e)
                    });
                }
            };
            /**
             * Create a page view telemetry item and send it to the SDK pipeline through the core.track API
             * @param pageView Page view item to be sent
             * @param properties Custom properties (Part C) that a user can add to the telemetry item
             * @param systemProperties System level properties (Part A) that a user can add to the telemetry item
             */ _self[0, $cPiEJ._DYN_SEND_PAGE_VIEW_INTER10 /* @min:%2esendPageViewInternal */ ] = function(pageView, properties, systemProperties) {
                var doc = (0, $3I5zg.getDocument)();
                if (doc) pageView.refUri = pageView.refUri === undefined ? doc.referrer : pageView.refUri;
                var telemetryItem = (0, $62ywT.createTelemetryItem)(pageView, (0, $80I4P.PageView)[0, $cPiEJ._DYN_DATA_TYPE /* @min:%2edataType */ ], (0, $80I4P.PageView)[0, $cPiEJ._DYN_ENVELOPE_TYPE /* @min:%2eenvelopeType */ ], _self[0, $cPiEJ._DYN_DIAG_LOG /* @min:%2ediagLog */ ](), properties, systemProperties);
                _self[0, $cPiEJ._DYN_CORE /* @min:%2ecore */ ][0, $cPiEJ._DYN_TRACK /* @min:%2etrack */ ](telemetryItem);
                // reset ajaxes counter
                _trackAjaxAttempts = 0;
            };
            /**
             * @ignore INTERNAL ONLY
             * @param pageViewPerformance
             * @param properties
             */ _self[0, $cPiEJ._DYN_SEND_PAGE_VIEW_PERFO11 /* @min:%2esendPageViewPerformanceInternal */ ] = function(pageViewPerformance, properties, systemProperties) {
                var telemetryItem = (0, $62ywT.createTelemetryItem)(pageViewPerformance, (0, $bmYDZ.PageViewPerformance)[0, $cPiEJ._DYN_DATA_TYPE /* @min:%2edataType */ ], (0, $bmYDZ.PageViewPerformance)[0, $cPiEJ._DYN_ENVELOPE_TYPE /* @min:%2eenvelopeType */ ], _self[0, $cPiEJ._DYN_DIAG_LOG /* @min:%2ediagLog */ ](), properties, systemProperties);
                _self[0, $cPiEJ._DYN_CORE /* @min:%2ecore */ ][0, $cPiEJ._DYN_TRACK /* @min:%2etrack */ ](telemetryItem);
            };
            /**
             * Send browser performance metrics.
             * @param pageViewPerformance
             * @param customProperties
             */ _self.trackPageViewPerformance = function(pageViewPerformance, customProperties) {
                var inPvp = pageViewPerformance || {};
                try {
                    _pageViewPerformanceManager[0, $cPiEJ._DYN_POPULATE_PAGE_VIEW_P12 /* @min:%2epopulatePageViewPerformanceEvent */ ](inPvp);
                    _self[0, $cPiEJ._DYN_SEND_PAGE_VIEW_PERFO11 /* @min:%2esendPageViewPerformanceInternal */ ](inPvp, customProperties);
                } catch (e) {
                    _throwInternal(1 /* eLoggingSeverity.CRITICAL */ , 37 /* _eInternalMessageId.TrackPVFailed */ , "trackPageViewPerformance failed, page view will not be collected: " + (0, $erRAP.getExceptionName)(e), {
                        exception: (0, $3I5zg.dumpObj)(e)
                    });
                }
            };
            /**
             * Starts the timer for tracking a page load time. Use this instead of `trackPageView` if you want to control when the page view timer starts and stops,
             * but don't want to calculate the duration yourself. This method doesn't send any telemetry. Call `stopTrackPage` to log the end of the page view
             * and send the event.
             * @param name A string that idenfities this item, unique within this HTML document. Defaults to the document title.
             */ _self.startTrackPage = function(name) {
                try {
                    if (typeof name !== "string") {
                        var doc = (0, $3I5zg.getDocument)();
                        name = doc && doc.title || "";
                    }
                    _pageTracking.start(name);
                } catch (e) {
                    _throwInternal(1 /* eLoggingSeverity.CRITICAL */ , 31 /* _eInternalMessageId.StartTrackFailed */ , "startTrackPage failed, page view may not be collected: " + (0, $erRAP.getExceptionName)(e), {
                        exception: (0, $3I5zg.dumpObj)(e)
                    });
                }
            };
            /**
             * Stops the timer that was started by calling `startTrackPage` and sends the pageview load time telemetry with the specified properties and measurements.
             * The duration of the page view will be the time between calling `startTrackPage` and `stopTrackPage`.
             * @param   name  The string you used as the name in startTrackPage. Defaults to the document title.
             * @param   url   String - a relative or absolute URL that identifies the page or other item. Defaults to the window location.
             * @param   properties  map[string, string] - additional data used to filter pages and metrics in the portal. Defaults to empty.
             * @param   measurements    map[string, number] - metrics associated with this page, displayed in Metrics Explorer on the portal. Defaults to empty.
             */ _self.stopTrackPage = function(name, url, properties, measurement) {
                try {
                    if (typeof name !== "string") {
                        var doc = (0, $3I5zg.getDocument)();
                        name = doc && doc.title || "";
                    }
                    if (typeof url !== "string") {
                        var loc = (0, $3I5zg.getLocation)();
                        url = loc && loc[0, $cPiEJ._DYN_HREF /* @min:%2ehref */ ] || "";
                    }
                    _pageTracking.stop(name, url, properties, measurement);
                    if (_self.config[0, $cPiEJ._DYN_AUTO_TRACK_PAGE_VISI1 /* @min:%2eautoTrackPageVisitTime */ ]) _pageVisitTimeManager[0, $cPiEJ._DYN_TRACK_PREVIOUS_PAGE_9 /* @min:%2etrackPreviousPageVisit */ ](name, url);
                } catch (e) {
                    _throwInternal(1 /* eLoggingSeverity.CRITICAL */ , 32 /* _eInternalMessageId.StopTrackFailed */ , "stopTrackPage failed, page view will not be collected: " + (0, $erRAP.getExceptionName)(e), {
                        exception: (0, $3I5zg.dumpObj)(e)
                    });
                }
            };
            /**
            * @ignore INTERNAL ONLY
            * @param exception
            * @param properties
            * @param systemProperties
            */ _self[0, $cPiEJ._DYN_SEND_EXCEPTION_INTER13 /* @min:%2esendExceptionInternal */ ] = function(exception, customProperties, systemProperties) {
                // Adding additional edge cases to handle
                // - Not passing anything (null / undefined)
                var theError = exception && (exception[0, $cPiEJ._DYN_EXCEPTION /* @min:%2eexception */ ] || exception[0, $cPiEJ._DYN_ERROR /* @min:%2eerror */ ]) || // - Handle someone calling trackException based of v1 API where the exception was the Error
                (0, $erRAP.isError)(exception) && exception || // - Handles no error being defined and instead of creating a new Error() instance attempt to map so any stacktrace
                //   is preserved and does not list ApplicationInsights code as the source
                {
                    name: exception && typeof exception,
                    message: exception || (0, $dCW8D.strNotSpecified)
                };
                // If no exception object was passed assign to an empty object to avoid internal exceptions
                exception = exception || {};
                var exceptionPartB = new (0, $3AuL8.Exception)(_self[0, $cPiEJ._DYN_DIAG_LOG /* @min:%2ediagLog */ ](), theError, exception.properties || customProperties, exception.measurements, exception.severityLevel, exception.id).toInterface();
                var telemetryItem = (0, $62ywT.createTelemetryItem)(exceptionPartB, (0, $3AuL8.Exception)[0, $cPiEJ._DYN_DATA_TYPE /* @min:%2edataType */ ], (0, $3AuL8.Exception)[0, $cPiEJ._DYN_ENVELOPE_TYPE /* @min:%2eenvelopeType */ ], _self[0, $cPiEJ._DYN_DIAG_LOG /* @min:%2ediagLog */ ](), customProperties, systemProperties);
                _self[0, $cPiEJ._DYN_CORE /* @min:%2ecore */ ][0, $cPiEJ._DYN_TRACK /* @min:%2etrack */ ](telemetryItem);
            };
            /**
             * Log an exception you have caught.
             *
             * @param {IExceptionTelemetry} exception   Object which contains exception to be sent
             * @param {{[key: string]: any}} customProperties   Additional data used to filter pages and metrics in the portal. Defaults to empty.
             *
             * Any property of type double will be considered a measurement, and will be treated by Application Insights as a metric.
             * @memberof ApplicationInsights
             */ _self.trackException = function(exception, customProperties) {
                if (exception && !exception[0, $cPiEJ._DYN_EXCEPTION /* @min:%2eexception */ ] && exception[0, $cPiEJ._DYN_ERROR /* @min:%2eerror */ ]) exception[0, $cPiEJ._DYN_EXCEPTION /* @min:%2eexception */ ] = exception[0, $cPiEJ._DYN_ERROR /* @min:%2eerror */ ];
                try {
                    _self[0, $cPiEJ._DYN_SEND_EXCEPTION_INTER13 /* @min:%2esendExceptionInternal */ ](exception, customProperties);
                } catch (e) {
                    _throwInternal(1 /* eLoggingSeverity.CRITICAL */ , 35 /* _eInternalMessageId.TrackExceptionFailed */ , "trackException failed, exception will not be collected: " + (0, $erRAP.getExceptionName)(e), {
                        exception: (0, $3I5zg.dumpObj)(e)
                    });
                }
            };
            /**
             * @description Custom error handler for Application Insights Analytics
             * @param {IAutoExceptionTelemetry} exception
             * @memberof ApplicationInsights
             */ _self[0, $cPiEJ._DYN__ONERROR /* @min:%2e_onerror */ ] = function(exception) {
                var error = exception && exception[0, $cPiEJ._DYN_ERROR /* @min:%2eerror */ ];
                var evt = exception && exception.evt;
                try {
                    if (!evt) {
                        var _window = (0, $3I5zg.getWindow)();
                        if (_window) evt = _window[$8efa887a1f7ab362$var$strEvent];
                    }
                    var url = exception && exception.url || ((0, $3I5zg.getDocument)() || {}).URL;
                    // If no error source is provided assume the default window.onerror handler
                    var errorSrc = exception[0, $cPiEJ._DYN_ERROR_SRC /* @min:%2eerrorSrc */ ] || "window.onerror@" + url + ":" + (exception[0, $cPiEJ._DYN_LINE_NUMBER /* @min:%2elineNumber */ ] || 0) + ":" + (exception[0, $cPiEJ._DYN_COLUMN_NUMBER /* @min:%2ecolumnNumber */ ] || 0);
                    var properties = {
                        errorSrc: errorSrc,
                        url: url,
                        lineNumber: exception[0, $cPiEJ._DYN_LINE_NUMBER /* @min:%2elineNumber */ ] || 0,
                        columnNumber: exception[0, $cPiEJ._DYN_COLUMN_NUMBER /* @min:%2ecolumnNumber */ ] || 0,
                        message: exception[0, $cPiEJ._DYN_MESSAGE /* @min:%2emessage */ ]
                    };
                    if ((0, $6Gvon.isCrossOriginError)(exception.message, exception.url, exception.lineNumber, exception.columnNumber, exception[0, $cPiEJ._DYN_ERROR /* @min:%2eerror */ ])) _sendCORSException((0, $3AuL8.Exception)[0, $cPiEJ._DYN__CREATE_AUTO_EXCEPTI14 /* @min:%2eCreateAutoException */ ]("Script error: The browser's same-origin policy prevents us from getting the details of this exception. Consider using the 'crossorigin' attribute.", url, exception[0, $cPiEJ._DYN_LINE_NUMBER /* @min:%2elineNumber */ ] || 0, exception[0, $cPiEJ._DYN_COLUMN_NUMBER /* @min:%2ecolumnNumber */ ] || 0, error, evt, null, errorSrc), properties);
                    else {
                        if (!exception[0, $cPiEJ._DYN_ERROR_SRC /* @min:%2eerrorSrc */ ]) exception[0, $cPiEJ._DYN_ERROR_SRC /* @min:%2eerrorSrc */ ] = errorSrc;
                        _self.trackException({
                            exception: exception,
                            severityLevel: 3 /* eSeverityLevel.Error */ 
                        }, properties);
                    }
                } catch (e) {
                    var errorString = error ? error.name + ", " + error[0, $cPiEJ._DYN_MESSAGE /* @min:%2emessage */ ] : "null";
                    _throwInternal(1 /* eLoggingSeverity.CRITICAL */ , 11 /* _eInternalMessageId.ExceptionWhileLoggingError */ , "_onError threw exception while logging error, error will not be collected: " + (0, $erRAP.getExceptionName)(e), {
                        exception: (0, $3I5zg.dumpObj)(e),
                        errorString: errorString
                    });
                }
            };
            _self[0, $cPiEJ._DYN_ADD_TELEMETRY_INITIA15 /* @min:%2eaddTelemetryInitializer */ ] = function(telemetryInitializer) {
                if (_self[0, $cPiEJ._DYN_CORE /* @min:%2ecore */ ]) // Just add to the core
                return _self[0, $cPiEJ._DYN_CORE /* @min:%2ecore */ ][0, $cPiEJ._DYN_ADD_TELEMETRY_INITIA15 /* @min:%2eaddTelemetryInitializer */ ](telemetryInitializer);
                // Handle "pre-initialization" telemetry initializers (for backward compatibility)
                if (!_preInitTelemetryInitializers) _preInitTelemetryInitializers = [];
                _preInitTelemetryInitializers.push(telemetryInitializer);
            };
            _self.initialize = function(config, core, extensions, pluginChain) {
                if (_self.isInitialized()) return;
                if ((0, $erRAP.isNullOrUndefined)(core)) (0, $erRAP.throwError)("Error initializing");
                _base.initialize(config, core, extensions, pluginChain);
                if (config.storagePrefix) (0, $fu0yT.utlSetStoragePrefix)(config.storagePrefix);
                try {
                    _evtNamespace = (0, $cIC5n.mergeEvtNamespace)((0, $2w0XY.createUniqueNamespace)(_self.identifier), core.evtNamespace && core.evtNamespace());
                    if (_preInitTelemetryInitializers) {
                        (0, $erRAP.arrForEach)(_preInitTelemetryInitializers, function(initializer) {
                            core[0, $cPiEJ._DYN_ADD_TELEMETRY_INITIA15 /* @min:%2eaddTelemetryInitializer */ ](initializer);
                        });
                        _preInitTelemetryInitializers = null;
                    }
                    var extConfig = _populateDefaults(config);
                    $8efa887a1f7ab362$var$_updateStorageUsage(extConfig);
                    _pageViewPerformanceManager = new (0, $fcx3d.PageViewPerformanceManager)(_self[0, $cPiEJ._DYN_CORE /* @min:%2ecore */ ]);
                    _pageViewManager = new (0, $4wyIY.PageViewManager)(_self, extConfig[0, $cPiEJ._DYN_OVERRIDE_PAGE_VIEW_D2 /* @min:%2eoverridePageViewDuration */ ], _self[0, $cPiEJ._DYN_CORE /* @min:%2ecore */ ], _pageViewPerformanceManager);
                    _pageVisitTimeManager = new (0, $idCyU.PageVisitTimeManager)(_self[0, $cPiEJ._DYN_DIAG_LOG /* @min:%2ediagLog */ ](), function(pageName, pageUrl, pageVisitTime) {
                        return trackPageVisitTime(pageName, pageUrl, pageVisitTime);
                    });
                    _updateBrowserLinkTracking(extConfig, config);
                    _eventTracking = new (0, $d5JsA.Timing)(_self[0, $cPiEJ._DYN_DIAG_LOG /* @min:%2ediagLog */ ](), "trackEvent");
                    _eventTracking.action = function(name, url, duration, properties, measurements) {
                        if (!properties) properties = {};
                        if (!measurements) measurements = {};
                        properties.duration = duration[0, $cPiEJ._DYN_TO_STRING /* @min:%2etoString */ ]();
                        _self.trackEvent({
                            name: name,
                            properties: properties,
                            measurements: measurements
                        });
                    };
                    // initialize page view timing
                    _pageTracking = new (0, $d5JsA.Timing)(_self[0, $cPiEJ._DYN_DIAG_LOG /* @min:%2ediagLog */ ](), "trackPageView");
                    _pageTracking.action = function(name, url, duration, properties, measurements) {
                        // duration must be a custom property in order for the collector to extract it
                        if ((0, $erRAP.isNullOrUndefined)(properties)) properties = {};
                        properties.duration = duration[0, $cPiEJ._DYN_TO_STRING /* @min:%2etoString */ ]();
                        var pageViewItem = {
                            name: name,
                            uri: url,
                            properties: properties,
                            measurements: measurements
                        };
                        _self[0, $cPiEJ._DYN_SEND_PAGE_VIEW_INTER10 /* @min:%2esendPageViewInternal */ ](pageViewItem, properties);
                    };
                    if ((0, $3I5zg.hasWindow)()) {
                        _updateExceptionTracking(extConfig);
                        _updateLocationChange(extConfig);
                    }
                } catch (e) {
                    // resetting the initialized state because of failure
                    _self.setInitialized(false);
                    throw e;
                }
            };
            _self._doTeardown = function(unloadCtx, unloadState) {
                _pageViewManager && _pageViewManager.teardown(unloadCtx, unloadState);
                // Just register to remove all events associated with this namespace
                (0, $cIC5n.eventOff)(window, null, null, _evtNamespace);
                _initDefaults();
            };
            function _populateDefaults(config) {
                var ctx = (0, $kry7o.createProcessTelemetryContext)(null, config, _self[0, $cPiEJ._DYN_CORE /* @min:%2ecore */ ]);
                var identifier = _self.identifier;
                // load default values if specified
                var defaults = $8efa887a1f7ab362$var$_getDefaultConfig(config);
                var extConfig = _self.config = ctx.getExtCfg(identifier);
                if (defaults !== undefined) (0, $erRAP.objForEachKey)(defaults, function(field, value) {
                    // for each unspecified field, set the default value
                    extConfig[field] = ctx.getConfig(identifier, field, value);
                    if (extConfig[field] === undefined) extConfig = value;
                });
                return extConfig;
            }
            function _updateBrowserLinkTracking(extConfig, config) {
                _isBrowserLinkTrackingEnabled = extConfig[0, $cPiEJ._DYN_IS_BROWSER_LINK_TRAC5 /* @min:%2eisBrowserLinkTrackingEnabled */ ] || config[0, $cPiEJ._DYN_IS_BROWSER_LINK_TRAC5 /* @min:%2eisBrowserLinkTrackingEnabled */ ];
                _addDefaultTelemetryInitializers();
            }
            /**
             * Log a page visit time
             * @param    pageName    Name of page
             * @param    pageVisitDuration Duration of visit to the page in milleseconds
             */ function trackPageVisitTime(pageName, pageUrl, pageVisitTime) {
                var properties = {
                    PageName: pageName,
                    PageUrl: pageUrl
                };
                _self.trackMetric({
                    name: "PageVisitTime",
                    average: pageVisitTime,
                    max: pageVisitTime,
                    min: pageVisitTime,
                    sampleCount: 1
                }, properties);
            }
            function _addDefaultTelemetryInitializers() {
                if (!_browserLinkInitializerAdded && _isBrowserLinkTrackingEnabled) {
                    var browserLinkPaths_1 = [
                        "/browserLinkSignalR/",
                        "/__browserLink/"
                    ];
                    var dropBrowserLinkRequests = function(envelope) {
                        if (_isBrowserLinkTrackingEnabled && envelope.baseType === (0, $7fph4.RemoteDependencyData)[0, $cPiEJ._DYN_DATA_TYPE /* @min:%2edataType */ ]) {
                            var remoteData = envelope.baseData;
                            if (remoteData) for(var i = 0; i < browserLinkPaths_1[0, $cPiEJ._DYN_LENGTH /* @min:%2elength */ ]; i++){
                                if (remoteData.target && remoteData.target.indexOf(browserLinkPaths_1[i]) >= 0) return false;
                            }
                        }
                        return true;
                    };
                    _self[0, $cPiEJ._DYN_ADD_TELEMETRY_INITIA15 /* @min:%2eaddTelemetryInitializer */ ](dropBrowserLinkRequests);
                    _browserLinkInitializerAdded = true;
                }
            }
            function _sendCORSException(exception, properties) {
                var telemetryItem = (0, $62ywT.createTelemetryItem)(exception, (0, $3AuL8.Exception)[0, $cPiEJ._DYN_DATA_TYPE /* @min:%2edataType */ ], (0, $3AuL8.Exception)[0, $cPiEJ._DYN_ENVELOPE_TYPE /* @min:%2eenvelopeType */ ], _self[0, $cPiEJ._DYN_DIAG_LOG /* @min:%2ediagLog */ ](), properties);
                _self[0, $cPiEJ._DYN_CORE /* @min:%2ecore */ ][0, $cPiEJ._DYN_TRACK /* @min:%2etrack */ ](telemetryItem);
            }
            function _updateExceptionTracking(extConfig) {
                var _window = (0, $3I5zg.getWindow)();
                var locn = (0, $3I5zg.getLocation)(true);
                _disableExceptionTracking = extConfig[0, $cPiEJ._DYN_DISABLE_EXCEPTION_TR0 /* @min:%2edisableExceptionTracking */ ];
                if (!_disableExceptionTracking && !_autoExceptionInstrumented && !extConfig.autoExceptionInstrumented) {
                    // We want to enable exception auto collection and it has not been done so yet
                    _addHook((0, $2CgMu.InstrumentEvent)(_window, "onerror", {
                        ns: _evtNamespace,
                        rsp: function(callDetails, message, url, lineNumber, columnNumber, error) {
                            if (!_disableExceptionTracking && callDetails.rslt !== true) _self[0, $cPiEJ._DYN__ONERROR /* @min:%2e_onerror */ ]((0, $3AuL8.Exception)[0, $cPiEJ._DYN__CREATE_AUTO_EXCEPTI14 /* @min:%2eCreateAutoException */ ](message, url, lineNumber, columnNumber, error, callDetails.evt));
                        }
                    }, false));
                    _autoExceptionInstrumented = true;
                }
                _addUnhandledPromiseRejectionTracking(extConfig, _window, locn);
            }
            function _updateLocationChange(extConfig) {
                var win = (0, $3I5zg.getWindow)();
                var locn = (0, $3I5zg.getLocation)(true);
                _enableAutoRouteTracking = extConfig[0, $cPiEJ._DYN_ENABLE_AUTO_ROUTE_TR6 /* @min:%2eenableAutoRouteTracking */ ] === true;
                /**
                 * Create a custom "locationchange" event which is triggered each time the history object is changed
                 */ if (win && _enableAutoRouteTracking && (0, $3I5zg.hasHistory)()) {
                    var _history = (0, $3I5zg.getHistory)();
                    if ((0, $erRAP.isFunction)(_history.pushState) && (0, $erRAP.isFunction)(_history.replaceState) && typeof Event !== (0, $VVkgt.strShimUndefined)) _addHistoryListener(extConfig, win, _history, locn);
                }
            }
            function _getDistributedTraceCtx() {
                var distributedTraceCtx = null;
                if (_self[0, $cPiEJ._DYN_CORE /* @min:%2ecore */ ] && _self[0, $cPiEJ._DYN_CORE /* @min:%2ecore */ ].getTraceCtx) distributedTraceCtx = _self[0, $cPiEJ._DYN_CORE /* @min:%2ecore */ ].getTraceCtx(false);
                if (!distributedTraceCtx) {
                    // Fallback when using an older Core and PropertiesPlugin
                    var properties = _self[0, $cPiEJ._DYN_CORE /* @min:%2ecore */ ].getPlugin((0, $1EHoQ.PropertiesPluginIdentifier));
                    if (properties) {
                        var context = properties.plugin.context;
                        if (context) distributedTraceCtx = (0, $4sUzw.createDistributedTraceContextFromTrace)(context.telemetryTrace);
                    }
                }
                return distributedTraceCtx;
            }
            /**
             * Create a custom "locationchange" event which is triggered each time the history object is changed
             */ function _addHistoryListener(extConfig, win, history, locn) {
                var namePrefix = extConfig[0, $cPiEJ._DYN_NAME_PREFIX /* @min:%2enamePrefix */ ] || "";
                function _popstateHandler() {
                    if (_enableAutoRouteTracking) $8efa887a1f7ab362$var$_dispatchEvent(win, (0, $4AhFx.createDomEvent)(namePrefix + "locationchange"));
                }
                function _locationChangeHandler() {
                    // We always track the changes (if the handler is installed) to handle the feature being disabled between location changes
                    if (_currUri) {
                        _prevUri = _currUri;
                        _currUri = locn && locn[0, $cPiEJ._DYN_HREF /* @min:%2ehref */ ] || "";
                    } else _currUri = locn && locn[0, $cPiEJ._DYN_HREF /* @min:%2ehref */ ] || "";
                    if (_enableAutoRouteTracking) {
                        var distributedTraceCtx = _getDistributedTraceCtx();
                        if (distributedTraceCtx) {
                            distributedTraceCtx.setTraceId((0, $iBAi6.generateW3CId)());
                            var traceLocationName = "_unknown_";
                            if (locn && locn.pathname) traceLocationName = locn.pathname + (locn.hash || "");
                            // This populates the ai.operation.name which has a maximum size of 1024 so we need to sanitize it
                            distributedTraceCtx.setName((0, $cGFCT.dataSanitizeString)(_self[0, $cPiEJ._DYN_DIAG_LOG /* @min:%2ediagLog */ ](), traceLocationName));
                        }
                        setTimeout((function(uri) {
                            // todo: override start time so that it is not affected by autoRoutePVDelay
                            _self[0, $cPiEJ._DYN_TRACK_PAGE_VIEW /* @min:%2etrackPageView */ ]({
                                refUri: uri,
                                properties: {
                                    duration: 0
                                }
                            }); // SPA route change loading durations are undefined, so send 0
                        }).bind(_self, _prevUri), _self.autoRoutePVDelay);
                    }
                }
                if (!_historyListenerAdded) {
                    _addHook((0, $2CgMu.InstrumentEvent)(history, "pushState", {
                        ns: _evtNamespace,
                        rsp: function() {
                            if (_enableAutoRouteTracking) {
                                $8efa887a1f7ab362$var$_dispatchEvent(win, (0, $4AhFx.createDomEvent)(namePrefix + "pushState"));
                                $8efa887a1f7ab362$var$_dispatchEvent(win, (0, $4AhFx.createDomEvent)(namePrefix + "locationchange"));
                            }
                        }
                    }, true));
                    _addHook((0, $2CgMu.InstrumentEvent)(history, "replaceState", {
                        ns: _evtNamespace,
                        rsp: function() {
                            if (_enableAutoRouteTracking) {
                                $8efa887a1f7ab362$var$_dispatchEvent(win, (0, $4AhFx.createDomEvent)(namePrefix + "replaceState"));
                                $8efa887a1f7ab362$var$_dispatchEvent(win, (0, $4AhFx.createDomEvent)(namePrefix + "locationchange"));
                            }
                        }
                    }, true));
                    (0, $cIC5n.eventOn)(win, namePrefix + "popstate", _popstateHandler, _evtNamespace);
                    (0, $cIC5n.eventOn)(win, namePrefix + "locationchange", _locationChangeHandler, _evtNamespace);
                    _historyListenerAdded = true;
                }
            }
            function _addUnhandledPromiseRejectionTracking(extConfig, _window, _location) {
                _enableUnhandledPromiseRejectionTracking = extConfig[0, $cPiEJ._DYN_ENABLE_UNHANDLED_PRO3 /* @min:%2eenableUnhandledPromiseRejectionTracking */ ] === true;
                if (_enableUnhandledPromiseRejectionTracking && !_autoUnhandledPromiseInstrumented) {
                    // We want to enable exception auto collection and it has not been done so yet
                    _addHook((0, $2CgMu.InstrumentEvent)(_window, "onunhandledrejection", {
                        ns: _evtNamespace,
                        rsp: function(callDetails, error) {
                            if (_enableUnhandledPromiseRejectionTracking && callDetails.rslt !== true) _self[0, $cPiEJ._DYN__ONERROR /* @min:%2e_onerror */ ]((0, $3AuL8.Exception)[0, $cPiEJ._DYN__CREATE_AUTO_EXCEPTI14 /* @min:%2eCreateAutoException */ ]($8efa887a1f7ab362$var$_getReason(error), _location ? _location[0, $cPiEJ._DYN_HREF /* @min:%2ehref */ ] : "", 0, 0, error, callDetails.evt));
                        }
                    }, false));
                    _autoUnhandledPromiseInstrumented = true;
                    extConfig.autoUnhandledPromiseInstrumented = _autoUnhandledPromiseInstrumented;
                }
            }
            /**
             * This method will throw exceptions in debug mode or attempt to log the error as a console warning.
             * @param severity {eLoggingSeverity} - The severity of the log message
             * @param message {_InternalLogMessage} - The log message.
             */ function _throwInternal(severity, msgId, msg, properties, isUserAct) {
                _self[0, $cPiEJ._DYN_DIAG_LOG /* @min:%2ediagLog */ ]().throwInternal(severity, msgId, msg, properties, isUserAct);
            }
            function _initDefaults() {
                _eventTracking = null;
                _pageTracking = null;
                _pageViewManager = null;
                _pageViewPerformanceManager = null;
                _pageVisitTimeManager = null;
                _preInitTelemetryInitializers = null;
                _isBrowserLinkTrackingEnabled = false;
                _browserLinkInitializerAdded = false;
                _enableAutoRouteTracking = false;
                _historyListenerAdded = false;
                _disableExceptionTracking = false;
                _autoExceptionInstrumented = false;
                _enableUnhandledPromiseRejectionTracking = false;
                _autoUnhandledPromiseInstrumented = false;
                // Counts number of trackAjax invocations.
                // By default we only monitor X ajax call per view to avoid too much load.
                // Default value is set in config.
                // This counter keeps increasing even after the limit is reached.
                _trackAjaxAttempts = 0;
                // array with max length of 2 that store current url and previous url for SPA page route change trackPageview use.
                var location = (0, $3I5zg.getLocation)(true);
                _prevUri = location && location[0, $cPiEJ._DYN_HREF /* @min:%2ehref */ ] || "";
                _currUri = null;
                _evtNamespace = null;
            }
            // For backward compatibility
            (0, $erRAP.objDefineAccessors)(_self, "_pageViewManager", function() {
                return _pageViewManager;
            });
            (0, $erRAP.objDefineAccessors)(_self, "_pageViewPerformanceManager", function() {
                return _pageViewPerformanceManager;
            });
            (0, $erRAP.objDefineAccessors)(_self, "_pageVisitTimeManager", function() {
                return _pageVisitTimeManager;
            });
            (0, $erRAP.objDefineAccessors)(_self, "_evtNamespace", function() {
                return "." + _evtNamespace;
            });
        });
        return _this;
    }
    // Removed Stub for AnalyticsPlugin.prototype.getCookieMgr.
    // Removed Stub for AnalyticsPlugin.prototype.processTelemetry.
    // Removed Stub for AnalyticsPlugin.prototype.trackEvent.
    // Removed Stub for AnalyticsPlugin.prototype.startTrackEvent.
    // Removed Stub for AnalyticsPlugin.prototype.stopTrackEvent.
    // Removed Stub for AnalyticsPlugin.prototype.trackTrace.
    // Removed Stub for AnalyticsPlugin.prototype.trackMetric.
    // Removed Stub for AnalyticsPlugin.prototype.trackPageView.
    // Removed Stub for AnalyticsPlugin.prototype.sendPageViewInternal.
    // Removed Stub for AnalyticsPlugin.prototype.sendPageViewPerformanceInternal.
    // Removed Stub for AnalyticsPlugin.prototype.trackPageViewPerformance.
    // Removed Stub for AnalyticsPlugin.prototype.startTrackPage.
    // Removed Stub for AnalyticsPlugin.prototype.stopTrackPage.
    // Removed Stub for AnalyticsPlugin.prototype.sendExceptionInternal.
    // Removed Stub for AnalyticsPlugin.prototype.trackException.
    // Removed Stub for AnalyticsPlugin.prototype._onerror.
    // Removed Stub for AnalyticsPlugin.prototype.addTelemetryInitializer.
    // Removed Stub for AnalyticsPlugin.prototype.initialize.
    AnalyticsPlugin.Version = "2.8.18"; // Not currently used anywhere
    AnalyticsPlugin.getDefaultConfig = $8efa887a1f7ab362$var$_getDefaultConfig;
    return AnalyticsPlugin;
}((0, $3wvVb.BaseTelemetryPlugin));

});
parcelRegister("fcMe7", function(module, exports) {

$parcel$export(module.exports, "__assignFn", function () { return $b11d62d98f464613$export$b3cf7a802e578501; });
$parcel$export(module.exports, "__extendsFn", function () { return $b11d62d98f464613$export$1f9c32e3fbfb8e62; });
$parcel$export(module.exports, "__spreadArrayFn", function () { return $b11d62d98f464613$export$643fbb7023bc1942; });
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.

var $VVkgt = parcelRequire("VVkgt");

var $gSD6i = parcelRequire("gSD6i");
var $b11d62d98f464613$export$3a8d60327f425095 = ((0, $gSD6i.getGlobal)() || {})["Symbol"];
var $b11d62d98f464613$export$904e7a8ad467688a = ((0, $gSD6i.getGlobal)() || {})["Reflect"];
var $b11d62d98f464613$export$b26f3a0ab26820ca = !!$b11d62d98f464613$export$3a8d60327f425095;
var $b11d62d98f464613$export$9f6bdf37c7d86dfe = !!$b11d62d98f464613$export$904e7a8ad467688a;
var $b11d62d98f464613$var$strDecorate = "decorate";
var $b11d62d98f464613$var$strMetadata = "metadata";
var $b11d62d98f464613$var$strGetOwnPropertySymbols = "getOwnPropertySymbols";
var $b11d62d98f464613$var$strIterator = "iterator";
var $b11d62d98f464613$export$64ecba31e1fc6f1e = function(t) {
    // tslint:disable-next-line: ban-comma-operator
    for(var s, i = 1, n = arguments.length; i < n; i++){
        s = arguments[i];
        for(var p in s)if ((0, $VVkgt.ObjProto)[0, $VVkgt.strShimHasOwnProperty].call(s, p)) t[p] = s[p];
    }
    return t;
};
var $b11d62d98f464613$export$b3cf7a802e578501 = (0, $VVkgt.ObjAssign) || $b11d62d98f464613$export$64ecba31e1fc6f1e;
// tslint:disable-next-line: only-arrow-functions
var $b11d62d98f464613$var$extendStaticsFn = function(d, b) {
    $b11d62d98f464613$var$extendStaticsFn = (0, $VVkgt.ObjClass)["setPrototypeOf"] || // tslint:disable-next-line: only-arrow-functions
    ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || // tslint:disable-next-line: only-arrow-functions
    function(d, b) {
        for(var p in b)if (b[0, $VVkgt.strShimHasOwnProperty](p)) d[p] = b[p];
    };
    return $b11d62d98f464613$var$extendStaticsFn(d, b);
};
function $b11d62d98f464613$export$1f9c32e3fbfb8e62(d, b) {
    if (typeof b !== (0, $VVkgt.strShimFunction) && b !== null) (0, $gSD6i.throwTypeError)("Class extends value " + String(b) + " is not a constructor or null");
    $b11d62d98f464613$var$extendStaticsFn(d, b);
    function __() {
        this.constructor = d;
    }
    // tslint:disable-next-line: ban-comma-operator
    d[0, $VVkgt.strShimPrototype] = b === null ? (0, $gSD6i.objCreateFn)(b) : (__[0, $VVkgt.strShimPrototype] = b[0, $VVkgt.strShimPrototype], new __());
}
function $b11d62d98f464613$export$b0e1e04064f2edd0(s, e) {
    var t = {};
    for(var k in s)if ((0, $VVkgt.ObjHasOwnProperty).call(s, k) && e.indexOf(k) < 0) t[k] = s[k];
    if (s != null && typeof (0, $VVkgt.ObjClass)[$b11d62d98f464613$var$strGetOwnPropertySymbols] === (0, $VVkgt.strShimFunction)) {
        for(var i = 0, p = (0, $VVkgt.ObjClass)[$b11d62d98f464613$var$strGetOwnPropertySymbols](s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && (0, $VVkgt.ObjProto)["propertyIsEnumerable"].call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $b11d62d98f464613$export$1f334cb233663b35(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = (0, $VVkgt.ObjClass)["getOwnPropertyDescriptor"](target, key) : desc, d;
    if ($b11d62d98f464613$export$9f6bdf37c7d86dfe && typeof $b11d62d98f464613$export$904e7a8ad467688a[$b11d62d98f464613$var$strDecorate] === (0, $VVkgt.strShimFunction)) r = $b11d62d98f464613$export$904e7a8ad467688a[$b11d62d98f464613$var$strDecorate](decorators, target, key, desc);
    else {
        for(var i = decorators.length - 1; i >= 0; i--)// eslint-disable-next-line no-cond-assign
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }
    // tslint:disable-next-line:ban-comma-operator
    return c > 3 && r && (0, $VVkgt.ObjDefineProperty)(target, key, r), r;
}
function $b11d62d98f464613$export$a862c09c17c00454(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $b11d62d98f464613$export$652131891efe9c32(metadataKey, metadataValue) {
    if ($b11d62d98f464613$export$9f6bdf37c7d86dfe && $b11d62d98f464613$export$904e7a8ad467688a[$b11d62d98f464613$var$strMetadata] === (0, $VVkgt.strShimFunction)) return $b11d62d98f464613$export$904e7a8ad467688a[$b11d62d98f464613$var$strMetadata](metadataKey, metadataValue);
}
function $b11d62d98f464613$export$11150685fa6930db(m, o) {
    for(var p in m)if (p !== (0, $VVkgt.strDefault) && !(0, $VVkgt.ObjHasOwnProperty).call(o, p)) $b11d62d98f464613$export$1ea27411cf67499d(o, m, p);
}
function $b11d62d98f464613$export$1ea27411cf67499d(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    if (!!(0, $VVkgt.ObjCreate)) (0, $VVkgt.ObjDefineProperty)(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
    else o[k2] = m[k];
}
function $b11d62d98f464613$export$19cc45bf4f6ae179(o) {
    var s = typeof $b11d62d98f464613$export$3a8d60327f425095 === (0, $VVkgt.strShimFunction) && $b11d62d98f464613$export$3a8d60327f425095[$b11d62d98f464613$var$strIterator], m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    (0, $gSD6i.throwTypeError)(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $b11d62d98f464613$export$18637e2f1e451a15(o, n) {
    var m = typeof $b11d62d98f464613$export$3a8d60327f425095 === (0, $VVkgt.strShimFunction) && o[$b11d62d98f464613$export$3a8d60327f425095[$b11d62d98f464613$var$strIterator]];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            // tslint:disable-next-line:no-conditional-assignment
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) // eslint-disable-next-line no-unsafe-finally
            throw e.error;
        }
    }
    return ar;
}
function $b11d62d98f464613$export$e4572e1e87bd3458() {
    var theArgs = arguments;
    // Calculate new total size
    for(var s = 0, i = 0, il = theArgs.length; i < il; i++)s += theArgs[i].length;
    // Create new full array
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = theArgs[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $b11d62d98f464613$export$643fbb7023bc1942(to, from) {
    for(var i = 0, il = from.length, j = to.length; i < il; i++, j++)to[j] = from[i];
    return to;
}
function $b11d62d98f464613$export$b4774f2d9ed4def4(cooked, raw) {
    if (0, $VVkgt.ObjDefineProperty) (0, $VVkgt.ObjDefineProperty)(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $b11d62d98f464613$export$8f42f3b1d1cb5f6d(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== (0, $VVkgt.strDefault) && Object.prototype.hasOwnProperty.call(mod, k)) $b11d62d98f464613$export$1ea27411cf67499d(result, mod, k);
    }
    // Set default module
    if (!!(0, $VVkgt.ObjCreate)) (0, $VVkgt.ObjDefineProperty)(result, (0, $VVkgt.strDefault), {
        enumerable: true,
        value: mod
    });
    else result[0, $VVkgt.strDefault] = mod;
    return result;
}
function $b11d62d98f464613$export$b2781524d4888cea(mod) {
    return mod && mod.__esModule ? mod : {
        strDefault: mod
    };
}

});
parcelRegister("VVkgt", function(module, exports) {

$parcel$export(module.exports, "strShimFunction", function () { return $0ae1cab4ac01bf9c$export$327014e6dfd5ba11; });
$parcel$export(module.exports, "strShimObject", function () { return $0ae1cab4ac01bf9c$export$127e9c2439c2ee16; });
$parcel$export(module.exports, "strShimUndefined", function () { return $0ae1cab4ac01bf9c$export$9b7d2d86cf58b987; });
$parcel$export(module.exports, "strShimPrototype", function () { return $0ae1cab4ac01bf9c$export$ecddaaeb55ecf049; });
$parcel$export(module.exports, "strShimHasOwnProperty", function () { return $0ae1cab4ac01bf9c$export$fdeb660efff83bae; });
$parcel$export(module.exports, "strDefault", function () { return $0ae1cab4ac01bf9c$export$b39d4edf23d6f14c; });
$parcel$export(module.exports, "ObjClass", function () { return $0ae1cab4ac01bf9c$export$9ec954dd81c90a5d; });
$parcel$export(module.exports, "ObjProto", function () { return $0ae1cab4ac01bf9c$export$e77bb59b5e655b3d; });
$parcel$export(module.exports, "ObjAssign", function () { return $0ae1cab4ac01bf9c$export$c06e62a67f43408b; });
$parcel$export(module.exports, "ObjCreate", function () { return $0ae1cab4ac01bf9c$export$62f62a547092e54f; });
$parcel$export(module.exports, "ObjDefineProperty", function () { return $0ae1cab4ac01bf9c$export$5cec132417feb069; });
$parcel$export(module.exports, "ObjHasOwnProperty", function () { return $0ae1cab4ac01bf9c$export$e75288e2c24be908; });
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
var $0ae1cab4ac01bf9c$export$327014e6dfd5ba11 = "function";
var $0ae1cab4ac01bf9c$export$127e9c2439c2ee16 = "object";
var $0ae1cab4ac01bf9c$export$9b7d2d86cf58b987 = "undefined";
var $0ae1cab4ac01bf9c$export$ecddaaeb55ecf049 = "prototype";
var $0ae1cab4ac01bf9c$export$fdeb660efff83bae = "hasOwnProperty";
var $0ae1cab4ac01bf9c$export$b39d4edf23d6f14c = "default";
var $0ae1cab4ac01bf9c$export$9ec954dd81c90a5d = Object;
var $0ae1cab4ac01bf9c$export$e77bb59b5e655b3d = $0ae1cab4ac01bf9c$export$9ec954dd81c90a5d[$0ae1cab4ac01bf9c$export$ecddaaeb55ecf049];
var $0ae1cab4ac01bf9c$export$c06e62a67f43408b = $0ae1cab4ac01bf9c$export$9ec954dd81c90a5d["assign"];
var $0ae1cab4ac01bf9c$export$62f62a547092e54f = $0ae1cab4ac01bf9c$export$9ec954dd81c90a5d["create"];
var $0ae1cab4ac01bf9c$export$5cec132417feb069 = $0ae1cab4ac01bf9c$export$9ec954dd81c90a5d["defineProperty"];
var $0ae1cab4ac01bf9c$export$e75288e2c24be908 = $0ae1cab4ac01bf9c$export$e77bb59b5e655b3d[$0ae1cab4ac01bf9c$export$fdeb660efff83bae];

});

parcelRegister("gSD6i", function(module, exports) {

$parcel$export(module.exports, "getGlobal", function () { return $c4a0050d8b3a9d75$export$a4e55266d2135a7f; });
$parcel$export(module.exports, "throwTypeError", function () { return $c4a0050d8b3a9d75$export$3f7738bd7dcba681; });
$parcel$export(module.exports, "objCreateFn", function () { return $c4a0050d8b3a9d75$export$9b0ce7e59d72f357; });
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.

var $VVkgt = parcelRequire("VVkgt");
var $c4a0050d8b3a9d75$var$_cachedGlobal = null;
function $c4a0050d8b3a9d75$export$a4e55266d2135a7f(useCached) {
    if (useCached === void 0) useCached = true;
    var result = useCached === false ? null : $c4a0050d8b3a9d75$var$_cachedGlobal;
    if (!result) {
        if (typeof globalThis !== (0, $VVkgt.strShimUndefined)) result = globalThis;
        if (!result && typeof self !== (0, $VVkgt.strShimUndefined)) result = self;
        if (!result && typeof window !== (0, $VVkgt.strShimUndefined)) result = window;
        if (!result && typeof $parcel$global !== (0, $VVkgt.strShimUndefined)) result = $parcel$global;
        $c4a0050d8b3a9d75$var$_cachedGlobal = result;
    }
    return result;
}
function $c4a0050d8b3a9d75$export$3f7738bd7dcba681(message) {
    throw new TypeError(message);
}
function $c4a0050d8b3a9d75$export$9b0ce7e59d72f357(obj) {
    var func = (0, $VVkgt.ObjCreate);
    // Use build in Object.create
    if (func) // Use Object create method if it exists
    return func(obj);
    if (obj == null) return {};
    var type = typeof obj;
    if (type !== (0, $VVkgt.strShimObject) && type !== (0, $VVkgt.strShimFunction)) $c4a0050d8b3a9d75$export$3f7738bd7dcba681("Object prototype may only be an Object:" + obj);
    function tmpFunc() {}
    tmpFunc[0, $VVkgt.strShimPrototype] = obj;
    return new tmpFunc();
}

});


parcelRegister("1EHoQ", function(module, exports) {

$parcel$export(module.exports, "PropertiesPluginIdentifier", function () { return $134b312c4f08febd$export$2268e69a6d93b7cc; });
$parcel$export(module.exports, "BreezeChannelIdentifier", function () { return $134b312c4f08febd$export$a714a094d3058c99; });
$parcel$export(module.exports, "AnalyticsPluginIdentifier", function () { return $134b312c4f08febd$export$862d858b0002f352; });
/*
 * Application Insights JavaScript SDK - Common, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ // Licensed under the

var $4sUzw = parcelRequire("4sUzw");


var $5cDez = parcelRequire("5cDez");

var $f5lFa = parcelRequire("f5lFa");

var $dCW8D = parcelRequire("dCW8D");

var $1V1Zd = parcelRequire("1V1Zd");

var $fK8rK = parcelRequire("fK8rK");

var $3AuL8 = parcelRequire("3AuL8");

var $ihDSn = parcelRequire("ihDSn");

var $80I4P = parcelRequire("80I4P");

var $7fph4 = parcelRequire("7fph4");

var $lL63Q = parcelRequire("lL63Q");

var $bmYDZ = parcelRequire("bmYDZ");

var $coTnQ = parcelRequire("coTnQ");

var $7504k = parcelRequire("7504k");

var $jqqu3 = parcelRequire("jqqu3");

var $gygzP = parcelRequire("gygzP");

var $cGFCT = parcelRequire("cGFCT");

var $62ywT = parcelRequire("62ywT");

var $2gDxc = parcelRequire("2gDxc");

var $efuYp = parcelRequire("efuYp");

var $6Gvon = parcelRequire("6Gvon");

var $jqfZe = parcelRequire("jqfZe");

var $4AhFx = parcelRequire("4AhFx");

var $fu0yT = parcelRequire("fu0yT");

var $8EowS = parcelRequire("8EowS");
var $134b312c4f08febd$export$2268e69a6d93b7cc = "AppInsightsPropertiesPlugin";
var $134b312c4f08febd$export$a714a094d3058c99 = "AppInsightsChannelPlugin";
var $134b312c4f08febd$export$862d858b0002f352 = "ApplicationInsightsAnalytics";

});
parcelRegister("4sUzw", function(module, exports) {

$parcel$export(module.exports, "isInternalApplicationInsightsEndpoint", function () { return $3405a8f0d7bc635b$export$edade5317663baa4; });
$parcel$export(module.exports, "Util", function () { return $3405a8f0d7bc635b$export$f8f26dd395d7e1bd; });
$parcel$export(module.exports, "UrlHelper", function () { return $3405a8f0d7bc635b$export$bacbc496e850c0a4; });
$parcel$export(module.exports, "CorrelationIdHelper", function () { return $3405a8f0d7bc635b$export$2f59e8ce91f8e350; });
$parcel$export(module.exports, "AjaxHelperParseDependencyPath", function () { return $3405a8f0d7bc635b$export$92b0aba7cb1d0e30; });
$parcel$export(module.exports, "dateTimeUtilsNow", function () { return $3405a8f0d7bc635b$export$30a447e32c58a836; });
$parcel$export(module.exports, "dateTimeUtilsDuration", function () { return $3405a8f0d7bc635b$export$bfc7deb7f4f00987; });
$parcel$export(module.exports, "DateTimeUtils", function () { return $3405a8f0d7bc635b$export$db030d70d2d24a2b; });
$parcel$export(module.exports, "createDistributedTraceContextFromTrace", function () { return $3405a8f0d7bc635b$export$847d5dabba5fabb9; });
/*
 * Application Insights JavaScript SDK - Common, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $erRAP = parcelRequire("erRAP");
var $cIC5n = parcelRequire("cIC5n");
var $iBAi6 = parcelRequire("iBAi6");
var $3I5zg = parcelRequire("3I5zg");
var $jqfZe = parcelRequire("jqfZe");
var $990ap = parcelRequire("990ap");
var $31Ks8 = parcelRequire("31Ks8");

var $dCW8D = parcelRequire("dCW8D");

var $4AhFx = parcelRequire("4AhFx");

var $6Gvon = parcelRequire("6Gvon");

var $f5lFa = parcelRequire("f5lFa");

var $fu0yT = parcelRequire("fu0yT");

var $cGFCT = parcelRequire("cGFCT");

var $8EowS = parcelRequire("8EowS");

var $9udGf = parcelRequire("9udGf");
// listing only non-geo specific locations
var $3405a8f0d7bc635b$var$_internalEndpoints = [
    (0, $dCW8D.DEFAULT_BREEZE_ENDPOINT) + (0, $dCW8D.DEFAULT_BREEZE_PATH),
    "https://breeze.aimon.applicationinsights.io" + (0, $dCW8D.DEFAULT_BREEZE_PATH),
    "https://dc-int.services.visualstudio.com" + (0, $dCW8D.DEFAULT_BREEZE_PATH)
];
function $3405a8f0d7bc635b$export$edade5317663baa4(endpointUrl) {
    return (0, $erRAP.arrIndexOf)($3405a8f0d7bc635b$var$_internalEndpoints, endpointUrl[0, $9udGf._DYN_TO_LOWER_CASE /* @min:%2etoLowerCase */ ]()) !== -1;
}
var $3405a8f0d7bc635b$export$f8f26dd395d7e1bd = {
    NotSpecified: (0, $dCW8D.strNotSpecified),
    createDomEvent: (0, $4AhFx.createDomEvent),
    disableStorage: (0, $fu0yT.utlDisableStorage),
    isInternalApplicationInsightsEndpoint: $3405a8f0d7bc635b$export$edade5317663baa4,
    canUseLocalStorage: (0, $fu0yT.utlCanUseLocalStorage),
    getStorage: (0, $fu0yT.utlGetLocalStorage),
    setStorage: (0, $fu0yT.utlSetLocalStorage),
    removeStorage: (0, $fu0yT.utlRemoveStorage),
    canUseSessionStorage: (0, $fu0yT.utlCanUseSessionStorage),
    getSessionStorageKeys: (0, $fu0yT.utlGetSessionStorageKeys),
    getSessionStorage: (0, $fu0yT.utlGetSessionStorage),
    setSessionStorage: (0, $fu0yT.utlSetSessionStorage),
    removeSessionStorage: (0, $fu0yT.utlRemoveSessionStorage),
    disableCookies: (0, $iBAi6.disableCookies),
    canUseCookies: (0, $iBAi6.canUseCookies),
    disallowsSameSiteNone: (0, $31Ks8.uaDisallowsSameSiteNone),
    setCookie: (0, $iBAi6.setCookie),
    stringToBoolOrDefault: (0, $6Gvon.stringToBoolOrDefault),
    getCookie: (0, $iBAi6.getCookie),
    deleteCookie: (0, $iBAi6.deleteCookie),
    trim: (0, $erRAP.strTrim),
    newId: (0, $990ap.newId),
    random32: function() {
        return (0, $990ap.random32)(true);
    },
    generateW3CId: (0, $iBAi6.generateW3CId),
    isArray: (0, $erRAP.isArray),
    isError: (0, $erRAP.isError),
    isDate: (0, $erRAP.isDate),
    toISOStringForIE8: (0, $erRAP.toISOString),
    getIEVersion: (0, $3I5zg.getIEVersion),
    msToTimeSpan: (0, $6Gvon.msToTimeSpan),
    isCrossOriginError: (0, $6Gvon.isCrossOriginError),
    dump: (0, $3I5zg.dumpObj),
    getExceptionName: (0, $erRAP.getExceptionName),
    addEventHandler: (0, $cIC5n.attachEvent),
    IsBeaconApiSupported: (0, $3I5zg.isBeaconsSupported),
    getExtension: (0, $6Gvon.getExtensionByName)
};
var $3405a8f0d7bc635b$export$bacbc496e850c0a4 = {
    parseUrl: (0, $8EowS.urlParseUrl),
    getAbsoluteUrl: (0, $8EowS.urlGetAbsoluteUrl),
    getPathName: (0, $8EowS.urlGetPathName),
    getCompleteUrl: (0, $8EowS.urlGetCompleteUrl),
    parseHost: (0, $8EowS.urlParseHost),
    parseFullHost: (0, $8EowS.urlParseFullHost)
};
var $3405a8f0d7bc635b$export$2f59e8ce91f8e350 = {
    correlationIdPrefix: "cid-v1:",
    /**
     * Checks if a request url is not on a excluded domain list and if it is safe to add correlation headers.
     * Headers are always included if the current domain matches the request domain. If they do not match (CORS),
     * they are regex-ed across correlationHeaderDomains and correlationHeaderExcludedDomains to determine if headers are included.
     * Some environments don't give information on currentHost via window.location.host (e.g. Cordova). In these cases, the user must
     * manually supply domains to include correlation headers on. Else, no headers will be included at all.
     */ canIncludeCorrelationHeader: function(config, requestUrl, currentHost) {
        if (!requestUrl || config && config.disableCorrelationHeaders) return false;
        if (config && config[0, $9udGf._DYN_CORRELATION_HEADER_E0 /* @min:%2ecorrelationHeaderExcludePatterns */ ]) for(var i = 0; i < config.correlationHeaderExcludePatterns[0, $9udGf._DYN_LENGTH /* @min:%2elength */ ]; i++){
            if (config[0, $9udGf._DYN_CORRELATION_HEADER_E0 /* @min:%2ecorrelationHeaderExcludePatterns */ ][i].test(requestUrl)) return false;
        }
        var requestHost = (0, $8EowS.urlParseUrl)(requestUrl).host[0, $9udGf._DYN_TO_LOWER_CASE /* @min:%2etoLowerCase */ ]();
        if (requestHost && (requestHost[0, $9udGf._DYN_INDEX_OF /* @min:%2eindexOf */ ](":443") !== -1 || requestHost[0, $9udGf._DYN_INDEX_OF /* @min:%2eindexOf */ ](":80") !== -1)) // [Bug #1260] IE can include the port even for http and https URLs so if present
        // try and parse it to remove if it matches the default protocol port
        requestHost = ((0, $8EowS.urlParseFullHost)(requestUrl, true) || "")[0, $9udGf._DYN_TO_LOWER_CASE /* @min:%2etoLowerCase */ ]();
        if ((!config || !config.enableCorsCorrelation) && requestHost && requestHost !== currentHost) return false;
        var includedDomains = config && config.correlationHeaderDomains;
        if (includedDomains) {
            var matchExists_1;
            (0, $erRAP.arrForEach)(includedDomains, function(domain) {
                var regex = new RegExp(domain.toLowerCase().replace(/\\/g, "\\\\").replace(/\./g, "\\.").replace(/\*/g, ".*"));
                matchExists_1 = matchExists_1 || regex.test(requestHost);
            });
            if (!matchExists_1) return false;
        }
        var excludedDomains = config && config.correlationHeaderExcludedDomains;
        if (!excludedDomains || excludedDomains[0, $9udGf._DYN_LENGTH /* @min:%2elength */ ] === 0) return true;
        for(var i = 0; i < excludedDomains[0, $9udGf._DYN_LENGTH /* @min:%2elength */ ]; i++){
            var regex = new RegExp(excludedDomains[i].toLowerCase().replace(/\\/g, "\\\\").replace(/\./g, "\\.").replace(/\*/g, ".*"));
            if (regex.test(requestHost)) return false;
        }
        // if we don't know anything about the requestHost, require the user to use included/excludedDomains.
        // Previously we always returned false for a falsy requestHost
        return requestHost && requestHost[0, $9udGf._DYN_LENGTH /* @min:%2elength */ ] > 0;
    },
    /**
     * Combines target appId and target role name from response header.
     */ getCorrelationContext: function(responseHeader) {
        if (responseHeader) {
            var correlationId = $3405a8f0d7bc635b$export$2f59e8ce91f8e350.getCorrelationContextValue(responseHeader, (0, $f5lFa.RequestHeaders)[1 /* eRequestHeaders.requestContextTargetKey */ ]);
            if (correlationId && correlationId !== $3405a8f0d7bc635b$export$2f59e8ce91f8e350.correlationIdPrefix) return correlationId;
        }
    },
    /**
     * Gets key from correlation response header
     */ getCorrelationContextValue: function(responseHeader, key) {
        if (responseHeader) {
            var keyValues = responseHeader[0, $9udGf._DYN_SPLIT /* @min:%2esplit */ ](",");
            for(var i = 0; i < keyValues[0, $9udGf._DYN_LENGTH /* @min:%2elength */ ]; ++i){
                var keyValue = keyValues[i][0, $9udGf._DYN_SPLIT /* @min:%2esplit */ ]("=");
                if (keyValue[0, $9udGf._DYN_LENGTH /* @min:%2elength */ ] === 2 && keyValue[0] === key) return keyValue[1];
            }
        }
    }
};
function $3405a8f0d7bc635b$export$92b0aba7cb1d0e30(logger, absoluteUrl, method, commandName) {
    var target, name = commandName, data = commandName;
    if (absoluteUrl && absoluteUrl[0, $9udGf._DYN_LENGTH /* @min:%2elength */ ] > 0) {
        var parsedUrl = (0, $8EowS.urlParseUrl)(absoluteUrl);
        target = parsedUrl.host;
        if (!name) {
            if (parsedUrl[0, $9udGf._DYN_PATHNAME /* @min:%2epathname */ ] != null) {
                var pathName = parsedUrl.pathname[0, $9udGf._DYN_LENGTH /* @min:%2elength */ ] === 0 ? "/" : parsedUrl[0, $9udGf._DYN_PATHNAME /* @min:%2epathname */ ];
                if (pathName.charAt(0) !== "/") pathName = "/" + pathName;
                data = parsedUrl[0, $9udGf._DYN_PATHNAME /* @min:%2epathname */ ];
                name = (0, $cGFCT.dataSanitizeString)(logger, method ? method + " " + pathName : pathName);
            } else name = (0, $cGFCT.dataSanitizeString)(logger, absoluteUrl);
        }
    } else {
        target = commandName;
        name = commandName;
    }
    return {
        target: target,
        name: name,
        data: data
    };
}
function $3405a8f0d7bc635b$export$30a447e32c58a836() {
    // returns the window or webworker performance object
    var perf = (0, $3I5zg.getPerformance)();
    if (perf && perf.now && perf.timing) {
        var now = perf.now() + perf.timing.navigationStart;
        // Known issue with IE where this calculation can be negative, so if it is then ignore and fallback
        if (now > 0) return now;
    }
    return (0, $erRAP.dateNow)();
}
function $3405a8f0d7bc635b$export$bfc7deb7f4f00987(start, end) {
    var result = null;
    if (start !== 0 && end !== 0 && !(0, $erRAP.isNullOrUndefined)(start) && !(0, $erRAP.isNullOrUndefined)(end)) result = end - start;
    return result;
}
var $3405a8f0d7bc635b$export$db030d70d2d24a2b = {
    Now: $3405a8f0d7bc635b$export$30a447e32c58a836,
    GetDuration: $3405a8f0d7bc635b$export$bfc7deb7f4f00987
};
function $3405a8f0d7bc635b$export$847d5dabba5fabb9(telemetryTrace, parentCtx) {
    var trace = telemetryTrace || {};
    return {
        getName: function() {
            return trace[0, $9udGf._DYN_NAME /* @min:%2ename */ ];
        },
        setName: function(newValue) {
            parentCtx && parentCtx.setName(newValue);
            trace[0, $9udGf._DYN_NAME /* @min:%2ename */ ] = newValue;
        },
        getTraceId: function() {
            return trace.traceID;
        },
        setTraceId: function(newValue) {
            parentCtx && parentCtx.setTraceId(newValue);
            if ((0, $jqfZe.isValidTraceId)(newValue)) trace.traceID = newValue;
        },
        getSpanId: function() {
            return trace.parentID;
        },
        setSpanId: function(newValue) {
            parentCtx && parentCtx.setSpanId(newValue);
            if ((0, $jqfZe.isValidSpanId)(newValue)) trace.parentID = newValue;
        },
        getTraceFlags: function() {
            return trace.traceFlags;
        },
        setTraceFlags: function(newTraceFlags) {
            parentCtx && parentCtx.setTraceFlags(newTraceFlags);
            trace.traceFlags = newTraceFlags;
        }
    };
}

});
parcelRegister("erRAP", function(module, exports) {

$parcel$export(module.exports, "_getObjProto", function () { return $a84d28c1557c3f10$export$821e81707b1677f9; });
$parcel$export(module.exports, "isTypeof", function () { return $a84d28c1557c3f10$export$aa336f94d74d9e02; });
$parcel$export(module.exports, "isUndefined", function () { return $a84d28c1557c3f10$export$fce6876652108ab; });
$parcel$export(module.exports, "isNullOrUndefined", function () { return $a84d28c1557c3f10$export$bedb7023a7733221; });
$parcel$export(module.exports, "isNotNullOrUndefined", function () { return $a84d28c1557c3f10$export$71fc1ee3e76bc1fe; });
$parcel$export(module.exports, "hasOwnProperty", function () { return $a84d28c1557c3f10$export$5a15a386532a5ea4; });
$parcel$export(module.exports, "isObject", function () { return $a84d28c1557c3f10$export$a6cdc56e425d0d0a; });
$parcel$export(module.exports, "isFunction", function () { return $a84d28c1557c3f10$export$f6e2535fb5126e54; });
$parcel$export(module.exports, "normalizeJsName", function () { return $a84d28c1557c3f10$export$f60443f194e40bc2; });
$parcel$export(module.exports, "isString", function () { return $a84d28c1557c3f10$export$844ec244b1367d54; });
$parcel$export(module.exports, "objForEachKey", function () { return $a84d28c1557c3f10$export$aa0705d5774c95d1; });
$parcel$export(module.exports, "strEndsWith", function () { return $a84d28c1557c3f10$export$5222b9460f3ddbec; });
$parcel$export(module.exports, "strContains", function () { return $a84d28c1557c3f10$export$3185d777c612e61f; });
$parcel$export(module.exports, "isDate", function () { return $a84d28c1557c3f10$export$871608497c498473; });
$parcel$export(module.exports, "isArray", function () { return $a84d28c1557c3f10$export$43bee75e5e14138e; });
$parcel$export(module.exports, "isError", function () { return $a84d28c1557c3f10$export$e6127cc7fe7395c3; });
$parcel$export(module.exports, "isNumber", function () { return $a84d28c1557c3f10$export$7e4aa119212bc614; });
$parcel$export(module.exports, "isBoolean", function () { return $a84d28c1557c3f10$export$f9ce7b637dfbe238; });
$parcel$export(module.exports, "toISOString", function () { return $a84d28c1557c3f10$export$dfaaa8705752128f; });
$parcel$export(module.exports, "arrForEach", function () { return $a84d28c1557c3f10$export$e2e5bcdbdc49c586; });
$parcel$export(module.exports, "arrIndexOf", function () { return $a84d28c1557c3f10$export$9f3b3ffa84393d30; });
$parcel$export(module.exports, "arrMap", function () { return $a84d28c1557c3f10$export$76f1a28030e24fa6; });
$parcel$export(module.exports, "arrReduce", function () { return $a84d28c1557c3f10$export$a16e2b23dbd5466c; });
$parcel$export(module.exports, "strTrim", function () { return $a84d28c1557c3f10$export$ef0e11c5f5f351f7; });
$parcel$export(module.exports, "objKeys", function () { return $a84d28c1557c3f10$export$f7628dc18f4211e5; });
$parcel$export(module.exports, "objDefineAccessors", function () { return $a84d28c1557c3f10$export$5525b807dcec3e1b; });
$parcel$export(module.exports, "deepFreeze", function () { return $a84d28c1557c3f10$export$7e32b29e1cb162e1; });
$parcel$export(module.exports, "objFreeze", function () { return $a84d28c1557c3f10$export$5da24d7703175bc5; });
$parcel$export(module.exports, "dateNow", function () { return $a84d28c1557c3f10$export$ceae11818251d43c; });
$parcel$export(module.exports, "getExceptionName", function () { return $a84d28c1557c3f10$export$39c4487b36c98fec; });
$parcel$export(module.exports, "setValue", function () { return $a84d28c1557c3f10$export$80746c6bc6142fc8; });
$parcel$export(module.exports, "getSetValue", function () { return $a84d28c1557c3f10$export$51417ccc212471e; });
$parcel$export(module.exports, "getCfgValue", function () { return $a84d28c1557c3f10$export$2f28e79027e1dc43; });
$parcel$export(module.exports, "isTruthy", function () { return $a84d28c1557c3f10$export$8f9cae6546f97a9f; });
$parcel$export(module.exports, "throwError", function () { return $a84d28c1557c3f10$export$8bf7aba4a9e09055; });
$parcel$export(module.exports, "proxyAssign", function () { return $a84d28c1557c3f10$export$21c1f632458708da; });
$parcel$export(module.exports, "proxyFunctionAs", function () { return $a84d28c1557c3f10$export$5dd8d245f6f94a18; });
$parcel$export(module.exports, "proxyFunctions", function () { return $a84d28c1557c3f10$export$94f4c7fb7e7d8dc7; });
$parcel$export(module.exports, "createClassFromInterface", function () { return $a84d28c1557c3f10$export$f0facb5bce2741f0; });
$parcel$export(module.exports, "optimizeObject", function () { return $a84d28c1557c3f10$export$3e03fa3fc3e422d7; });
$parcel$export(module.exports, "objExtend", function () { return $a84d28c1557c3f10$export$a7f7e50f928053df; });
/*
 * Application Insights JavaScript SDK - Core, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $VVkgt = parcelRequire("VVkgt");
var $gSD6i = parcelRequire("gSD6i");

var $fX4fx = parcelRequire("fX4fx");

var $lxIpo = parcelRequire("lxIpo");
// RESTRICT and AVOID circular dependencies you should not import other contained modules or export the contents of this file directly
// Added to help with minfication
var $a84d28c1557c3f10$var$strToISOString = "toISOString";
var $a84d28c1557c3f10$var$cStrEndsWith = "endsWith";
var $a84d28c1557c3f10$var$cStrStartsWith = "startsWith";
var $a84d28c1557c3f10$var$strIndexOf = "indexOf";
var $a84d28c1557c3f10$var$strMap = "map";
var $a84d28c1557c3f10$var$strReduce = "reduce";
var $a84d28c1557c3f10$var$cStrTrim = "trim";
var $a84d28c1557c3f10$var$strToString = "toString";
/**
 * Constant string defined to support minimization
 * @ignore
 */ var $a84d28c1557c3f10$var$str__Proto = "__proto__";
/**
  * Constant string defined to support minimization
  * @ignore
  */ var $a84d28c1557c3f10$var$strConstructor = "constructor";
var $a84d28c1557c3f10$var$_objDefineProperty = (0, $VVkgt.ObjDefineProperty);
var $a84d28c1557c3f10$var$_objFreeze = (0, $VVkgt.ObjClass).freeze;
var $a84d28c1557c3f10$var$_objSeal = (0, $VVkgt.ObjClass).seal;
var $a84d28c1557c3f10$var$_objKeys = (0, $VVkgt.ObjClass).keys;
var $a84d28c1557c3f10$var$StringProto = String[0, $VVkgt.strShimPrototype];
var $a84d28c1557c3f10$var$_strTrim = $a84d28c1557c3f10$var$StringProto[$a84d28c1557c3f10$var$cStrTrim];
var $a84d28c1557c3f10$var$_strEndsWith = $a84d28c1557c3f10$var$StringProto[$a84d28c1557c3f10$var$cStrEndsWith];
var $a84d28c1557c3f10$var$_strStartsWith = $a84d28c1557c3f10$var$StringProto[$a84d28c1557c3f10$var$cStrStartsWith];
var $a84d28c1557c3f10$var$DateProto = Date[0, $VVkgt.strShimPrototype];
var $a84d28c1557c3f10$var$_dataToISOString = $a84d28c1557c3f10$var$DateProto[$a84d28c1557c3f10$var$strToISOString];
var $a84d28c1557c3f10$var$_isArray = Array.isArray;
var $a84d28c1557c3f10$var$_objToString = (0, $VVkgt.ObjProto)[$a84d28c1557c3f10$var$strToString];
var $a84d28c1557c3f10$var$_fnToString = (0, $VVkgt.ObjHasOwnProperty)[$a84d28c1557c3f10$var$strToString];
// Cache what this browser reports as the object function constructor (as a string)
var $a84d28c1557c3f10$var$_objFunctionString = $a84d28c1557c3f10$var$_fnToString[0, $fX4fx._DYN_CALL /* @min:%2ecall */ ]((0, $VVkgt.ObjClass));
var $a84d28c1557c3f10$var$rCamelCase = /-([a-z])/g;
var $a84d28c1557c3f10$var$rNormalizeInvalid = /([^\w\d_$])/g;
var $a84d28c1557c3f10$var$rLeadingNumeric = /^(\d+[\w\d_$])/;
/**
 * Pre-lookup to check if we are running on a modern browser (i.e. not IE8)
 * @ignore
 */ var $a84d28c1557c3f10$var$_objGetPrototypeOf = Object["getPrototypeOf"];
function $a84d28c1557c3f10$export$821e81707b1677f9(target) {
    if (target) {
        // This method doesn't existing in older browsers (e.g. IE8)
        if ($a84d28c1557c3f10$var$_objGetPrototypeOf) return $a84d28c1557c3f10$var$_objGetPrototypeOf(target);
        // target[Constructor] May break if the constructor has been changed or removed
        var newProto = target[$a84d28c1557c3f10$var$str__Proto] || target[0, $VVkgt.strShimPrototype] || target[$a84d28c1557c3f10$var$strConstructor];
        if (newProto) return newProto;
    }
    return null;
}
function $a84d28c1557c3f10$export$3cbb80dec8953997(obj) {
    return $a84d28c1557c3f10$var$_objToString[0, $fX4fx._DYN_CALL /* @min:%2ecall */ ](obj);
}
function $a84d28c1557c3f10$export$aa336f94d74d9e02(value, theType) {
    return typeof value === theType;
}
function $a84d28c1557c3f10$export$fce6876652108ab(value) {
    return value === undefined || typeof value === (0, $VVkgt.strShimUndefined);
}
function $a84d28c1557c3f10$export$e7321bf46d18757f(value) {
    return !$a84d28c1557c3f10$export$fce6876652108ab(value);
}
function $a84d28c1557c3f10$export$bedb7023a7733221(value) {
    return value === null || $a84d28c1557c3f10$export$fce6876652108ab(value);
}
function $a84d28c1557c3f10$export$71fc1ee3e76bc1fe(value) {
    return !$a84d28c1557c3f10$export$bedb7023a7733221(value);
}
function $a84d28c1557c3f10$export$5a15a386532a5ea4(obj, prop) {
    return !!(obj && (0, $VVkgt.ObjHasOwnProperty)[0, $fX4fx._DYN_CALL /* @min:%2ecall */ ](obj, prop));
}
function $a84d28c1557c3f10$export$a6cdc56e425d0d0a(value) {
    // Changing to inline for performance
    return !!(value && typeof value === (0, $VVkgt.strShimObject));
}
function $a84d28c1557c3f10$export$f6e2535fb5126e54(value) {
    // Changing to inline for performance
    return !!(value && typeof value === (0, $VVkgt.strShimFunction));
}
function $a84d28c1557c3f10$export$ae936b9d47e5870e(value) {
    return value && $a84d28c1557c3f10$export$f6e2535fb5126e54(value.then);
}
function $a84d28c1557c3f10$export$f60443f194e40bc2(name) {
    var value = name;
    if (value && $a84d28c1557c3f10$export$844ec244b1367d54(value)) {
        // CamelCase everything after the "-" and remove the dash
        value = value[0, $fX4fx._DYN_REPLACE /* @min:%2ereplace */ ]($a84d28c1557c3f10$var$rCamelCase, function(_all, letter) {
            return letter.toUpperCase();
        });
        value = value[0, $fX4fx._DYN_REPLACE /* @min:%2ereplace */ ]($a84d28c1557c3f10$var$rNormalizeInvalid, "_");
        value = value[0, $fX4fx._DYN_REPLACE /* @min:%2ereplace */ ]($a84d28c1557c3f10$var$rLeadingNumeric, function(_all, match) {
            return "_" + match;
        });
    }
    return value;
}
function $a84d28c1557c3f10$export$aa0705d5774c95d1(target, callbackfn) {
    if (target) {
        for(var prop in target)if ((0, $VVkgt.ObjHasOwnProperty)[0, $fX4fx._DYN_CALL /* @min:%2ecall */ ](target, prop)) callbackfn[0, $fX4fx._DYN_CALL /* @min:%2ecall */ ](target, prop, target[prop]);
    }
}
function $a84d28c1557c3f10$export$5222b9460f3ddbec(value, search) {
    var result = false;
    if (value && search && !(result = value === search)) // For Performance try and use the native instance, using string lookup of the function to easily pass the ES3 build checks and minification
    result = $a84d28c1557c3f10$var$_strEndsWith ? value[$a84d28c1557c3f10$var$cStrEndsWith](search) : $a84d28c1557c3f10$export$2df85a6147c3ff40(value, search);
    return result;
}
function $a84d28c1557c3f10$export$2df85a6147c3ff40(value, search) {
    var result = false;
    var searchLen = search ? search[0, $fX4fx._DYN_LENGTH /* @min:%2elength */ ] : 0;
    var valLen = value ? value[0, $fX4fx._DYN_LENGTH /* @min:%2elength */ ] : 0;
    if (searchLen && valLen && valLen >= searchLen && !(result = value === search)) {
        var pos = valLen - 1;
        for(var lp = searchLen - 1; lp >= 0; lp--){
            if (value[pos] != search[lp]) return false;
            pos--;
        }
        result = true;
    }
    return result;
}
function $a84d28c1557c3f10$export$da061769d961e150(value, checkValue) {
    var result = false;
    if (value && checkValue && !(result = value === checkValue)) // For Performance try and use the native instance, using string lookup of the function to easily pass the ES3 build checks and minification
    result = $a84d28c1557c3f10$var$_strStartsWith ? value[$a84d28c1557c3f10$var$cStrStartsWith](checkValue) : $a84d28c1557c3f10$export$cb4f052c3fee979b(value, checkValue);
    return result;
}
function $a84d28c1557c3f10$export$cb4f052c3fee979b(value, checkValue) {
    // Using helper for performance and because string startsWith() is not available on IE
    var result = false;
    var chkLen = checkValue ? checkValue[0, $fX4fx._DYN_LENGTH /* @min:%2elength */ ] : 0;
    if (value && chkLen && value[0, $fX4fx._DYN_LENGTH /* @min:%2elength */ ] >= chkLen && !(result = value === checkValue)) {
        for(var lp = 0; lp < chkLen; lp++){
            if (value[lp] !== checkValue[lp]) return false;
        }
        result = true;
    }
    return result;
}
function $a84d28c1557c3f10$export$3185d777c612e61f(value, search) {
    if (value && search) return value[0, $fX4fx._DYN_INDEX_OF /* @min:%2eindexOf */ ](search) !== -1;
    return false;
}
function $a84d28c1557c3f10$export$871608497c498473(obj) {
    return !!(obj && $a84d28c1557c3f10$var$_objToString[0, $fX4fx._DYN_CALL /* @min:%2ecall */ ](obj) === "[object Date]");
}
var $a84d28c1557c3f10$export$43bee75e5e14138e = $a84d28c1557c3f10$var$_isArray || $a84d28c1557c3f10$var$_isArrayPoly;
function $a84d28c1557c3f10$var$_isArrayPoly(obj) {
    return !!(obj && $a84d28c1557c3f10$var$_objToString[0, $fX4fx._DYN_CALL /* @min:%2ecall */ ](obj) === "[object Array]");
}
function $a84d28c1557c3f10$export$e6127cc7fe7395c3(obj) {
    return !!(obj && $a84d28c1557c3f10$var$_objToString[0, $fX4fx._DYN_CALL /* @min:%2ecall */ ](obj) === "[object Error]");
}
function $a84d28c1557c3f10$export$844ec244b1367d54(value) {
    // Changing to inline for performance
    return typeof value === "string";
}
function $a84d28c1557c3f10$export$7e4aa119212bc614(value) {
    // Changing to inline for performance
    return typeof value === "number";
}
function $a84d28c1557c3f10$export$f9ce7b637dfbe238(value) {
    // Changing to inline for performance
    return typeof value === "boolean";
}
function $a84d28c1557c3f10$export$a244864fd9645c7f(value) {
    return typeof value === "symbol";
}
function $a84d28c1557c3f10$export$53b83ca8eaab0383(value) {
    var result = false;
    if (value && typeof value === "object") {
        // Inlining _objGetPrototypeOf for performance to avoid an additional function call
        var proto = $a84d28c1557c3f10$var$_objGetPrototypeOf ? $a84d28c1557c3f10$var$_objGetPrototypeOf(value) : $a84d28c1557c3f10$export$821e81707b1677f9(value);
        if (!proto) // No prototype found so this is a plain Object eg. 'Object.create(null)'
        result = true;
        else {
            // Objects that have a prototype are plain only if they were created using the Object global (native) function
            if (proto[$a84d28c1557c3f10$var$strConstructor] && (0, $VVkgt.ObjHasOwnProperty)[0, $fX4fx._DYN_CALL /* @min:%2ecall */ ](proto, $a84d28c1557c3f10$var$strConstructor)) proto = proto[$a84d28c1557c3f10$var$strConstructor];
            result = typeof proto === (0, $VVkgt.strShimFunction) && $a84d28c1557c3f10$var$_fnToString[0, $fX4fx._DYN_CALL /* @min:%2ecall */ ](proto) === $a84d28c1557c3f10$var$_objFunctionString;
        }
    }
    return result;
}
function $a84d28c1557c3f10$export$dfaaa8705752128f(date) {
    if (date) // For Performance try and use the native instance, using string lookup of the function to easily pass the ES3 build checks and minification
    return $a84d28c1557c3f10$var$_dataToISOString ? date[$a84d28c1557c3f10$var$strToISOString]() : $a84d28c1557c3f10$export$1a9b608c6a599ac2(date);
}
function $a84d28c1557c3f10$export$1a9b608c6a599ac2(date) {
    if (date && date.getUTCFullYear) {
        var pad = function(num) {
            var r = String(num);
            if (r[0, $fX4fx._DYN_LENGTH /* @min:%2elength */ ] === 1) r = "0" + r;
            return r;
        };
        return date.getUTCFullYear() + "-" + pad(date.getUTCMonth() + 1) + "-" + pad(date.getUTCDate()) + "T" + pad(date.getUTCHours()) + ":" + pad(date.getUTCMinutes()) + ":" + pad(date.getUTCSeconds()) + "." + String((date.getUTCMilliseconds() / 1000).toFixed(3)).slice(2, 5) + "Z";
    }
}
function $a84d28c1557c3f10$export$e2e5bcdbdc49c586(arr, callbackfn, thisArg) {
    var len = arr[0, $fX4fx._DYN_LENGTH /* @min:%2elength */ ];
    try {
        for(var idx = 0; idx < len; idx++)if (idx in arr) {
            if (callbackfn[0, $fX4fx._DYN_CALL /* @min:%2ecall */ ](thisArg || arr, arr[idx], idx, arr) === -1) break;
        }
    } catch (e) {
    // This can happen with some native browser objects, but should not happen for the type we are checking for
    }
}
function $a84d28c1557c3f10$export$9f3b3ffa84393d30(arr, searchElement, fromIndex) {
    if (arr) {
        // For Performance try and use the native instance, using string lookup of the function to easily pass the ES3 build checks and minification
        if (arr[$a84d28c1557c3f10$var$strIndexOf]) return arr[$a84d28c1557c3f10$var$strIndexOf](searchElement, fromIndex);
        var len = arr[0, $fX4fx._DYN_LENGTH /* @min:%2elength */ ];
        var from = fromIndex || 0;
        try {
            for(var lp = Math.max(from >= 0 ? from : len - Math.abs(from), 0); lp < len; lp++){
                if (lp in arr && arr[lp] === searchElement) return lp;
            }
        } catch (e) {
        // This can happen with some native browser objects, but should not happen for the type we are checking for
        }
    }
    return -1;
}
function $a84d28c1557c3f10$export$76f1a28030e24fa6(arr, callbackfn, thisArg) {
    var results;
    if (arr) {
        // For Performance try and use the native instance, using string lookup of the function to easily pass the ES3 build checks and minification
        if (arr[$a84d28c1557c3f10$var$strMap]) return arr[$a84d28c1557c3f10$var$strMap](callbackfn, thisArg);
        var len = arr[0, $fX4fx._DYN_LENGTH /* @min:%2elength */ ];
        var _this = thisArg || arr;
        results = new Array(len);
        try {
            for(var lp = 0; lp < len; lp++)if (lp in arr) results[lp] = callbackfn[0, $fX4fx._DYN_CALL /* @min:%2ecall */ ](_this, arr[lp], arr);
        } catch (e) {
        // This can happen with some native browser objects, but should not happen for the type we are checking for
        }
    }
    return results;
}
function $a84d28c1557c3f10$export$a16e2b23dbd5466c(arr, callbackfn, initialValue) {
    var value;
    if (arr) {
        // For Performance try and use the native instance, using string lookup of the function to easily pass the ES3 build checks and minification
        if (arr[$a84d28c1557c3f10$var$strReduce]) return arr[$a84d28c1557c3f10$var$strReduce](callbackfn, initialValue);
        var len = arr[0, $fX4fx._DYN_LENGTH /* @min:%2elength */ ];
        var lp = 0;
        // Specifically checking the number of passed arguments as the value could be anything
        if (arguments[0, $fX4fx._DYN_LENGTH /* @min:%2elength */ ] >= 3) value = arguments[2];
        else {
            while(lp < len && !(lp in arr))lp++;
            value = arr[lp++];
        }
        while(lp < len){
            if (lp in arr) value = callbackfn(value, arr[lp], lp, arr);
            lp++;
        }
    }
    return value;
}
function $a84d28c1557c3f10$export$ef0e11c5f5f351f7(str) {
    if (str) // For Performance try and use the native instance, using string lookup of the function to easily pass the ES3 build checks and minification
    str = $a84d28c1557c3f10$var$_strTrim && str[$a84d28c1557c3f10$var$cStrTrim] ? str[$a84d28c1557c3f10$var$cStrTrim]() : str[0, $fX4fx._DYN_REPLACE /* @min:%2ereplace */ ] ? str[0, $fX4fx._DYN_REPLACE /* @min:%2ereplace */ ](/^\s+|(?=\s)\s+$/g, (0, $lxIpo.STR_EMPTY)) : str;
    return str;
}
var $a84d28c1557c3f10$var$_objKeysHasDontEnumBug = !({
    toString: null
}).propertyIsEnumerable("toString");
var $a84d28c1557c3f10$var$_objKeysDontEnums = [
    "toString",
    "toLocaleString",
    "valueOf",
    "hasOwnProperty",
    "isPrototypeOf",
    "propertyIsEnumerable",
    "constructor"
];
function $a84d28c1557c3f10$export$f7628dc18f4211e5(obj) {
    var objType = typeof obj;
    if (objType !== (0, $VVkgt.strShimFunction) && (objType !== (0, $VVkgt.strShimObject) || obj === null)) (0, $gSD6i.throwTypeError)("objKeys called on non-object");
    // For Performance try and use the native instance, using string lookup of the function to easily pass the ES3 build checks and minification
    if (!$a84d28c1557c3f10$var$_objKeysHasDontEnumBug && $a84d28c1557c3f10$var$_objKeys) return $a84d28c1557c3f10$var$_objKeys(obj);
    var result = [];
    for(var prop in obj)if (obj && (0, $VVkgt.ObjHasOwnProperty)[0, $fX4fx._DYN_CALL /* @min:%2ecall */ ](obj, prop)) result[0, $fX4fx._DYN_PUSH /* @min:%2epush */ ](prop);
    if ($a84d28c1557c3f10$var$_objKeysHasDontEnumBug) {
        var dontEnumsLength = $a84d28c1557c3f10$var$_objKeysDontEnums[0, $fX4fx._DYN_LENGTH /* @min:%2elength */ ];
        for(var lp = 0; lp < dontEnumsLength; lp++)if (obj && (0, $VVkgt.ObjHasOwnProperty)[0, $fX4fx._DYN_CALL /* @min:%2ecall */ ](obj, $a84d28c1557c3f10$var$_objKeysDontEnums[lp])) result[0, $fX4fx._DYN_PUSH /* @min:%2epush */ ]($a84d28c1557c3f10$var$_objKeysDontEnums[lp]);
    }
    return result;
}
function $a84d28c1557c3f10$export$5525b807dcec3e1b(target, prop, getProp, setProp) {
    if ($a84d28c1557c3f10$var$_objDefineProperty) try {
        var descriptor = {
            enumerable: true,
            configurable: true
        };
        if (getProp) descriptor.get = getProp;
        if (setProp) descriptor.set = setProp;
        $a84d28c1557c3f10$var$_objDefineProperty(target, prop, descriptor);
        return true;
    } catch (e) {
    // IE8 Defines a defineProperty on Object but it's only supported for DOM elements so it will throw
    // We will just ignore this here.
    }
    return false;
}
function $a84d28c1557c3f10$var$_doNothing(value) {
    return value;
}
function $a84d28c1557c3f10$export$7e32b29e1cb162e1(obj) {
    if ($a84d28c1557c3f10$var$_objFreeze) $a84d28c1557c3f10$export$aa0705d5774c95d1(obj, function(name, value) {
        if ($a84d28c1557c3f10$export$43bee75e5e14138e(value) || $a84d28c1557c3f10$export$a6cdc56e425d0d0a(value)) $a84d28c1557c3f10$var$_objFreeze(value);
    });
    return $a84d28c1557c3f10$export$5da24d7703175bc5(obj);
}
var $a84d28c1557c3f10$export$5da24d7703175bc5 = $a84d28c1557c3f10$var$_objFreeze || $a84d28c1557c3f10$var$_doNothing;
var $a84d28c1557c3f10$export$8bbd42c2bec875c8 = $a84d28c1557c3f10$var$_objSeal || $a84d28c1557c3f10$var$_doNothing;
function $a84d28c1557c3f10$export$ceae11818251d43c() {
    var dt = Date;
    return dt.now ? dt.now() : new dt().getTime();
}
function $a84d28c1557c3f10$export$39c4487b36c98fec(object) {
    if ($a84d28c1557c3f10$export$e6127cc7fe7395c3(object)) return object[0, $fX4fx._DYN_NAME /* @min:%2ename */ ];
    return 0, $lxIpo.STR_EMPTY;
}
function $a84d28c1557c3f10$export$80746c6bc6142fc8(target, field, value, valChk, srcChk) {
    var theValue = value;
    if (target) {
        theValue = target[field];
        if (theValue !== value && (!srcChk || srcChk(theValue)) && (!valChk || valChk(value))) {
            theValue = value;
            target[field] = theValue;
        }
    }
    return theValue;
}
function $a84d28c1557c3f10$export$51417ccc212471e(target, field, defValue) {
    var theValue;
    if (target) {
        theValue = target[field];
        if (!theValue && $a84d28c1557c3f10$export$bedb7023a7733221(theValue)) {
            // Supports having the default as null
            theValue = !$a84d28c1557c3f10$export$fce6876652108ab(defValue) ? defValue : {};
            target[field] = theValue;
        }
    } else // Expanded for performance so we only check defValue if required
    theValue = !$a84d28c1557c3f10$export$fce6876652108ab(defValue) ? defValue : {};
    return theValue;
}
function $a84d28c1557c3f10$export$2f28e79027e1dc43(theValue, defaultValue) {
    return !$a84d28c1557c3f10$export$bedb7023a7733221(theValue) ? theValue : defaultValue;
}
function $a84d28c1557c3f10$export$5f2b986706b25721(value) {
    return !value;
}
function $a84d28c1557c3f10$export$8f9cae6546f97a9f(value) {
    return !!value;
}
function $a84d28c1557c3f10$export$8bf7aba4a9e09055(message) {
    throw new Error(message);
}
function $a84d28c1557c3f10$var$_createProxyFunction(source, funcName) {
    var srcFunc = null;
    var src = null;
    if ($a84d28c1557c3f10$export$f6e2535fb5126e54(source)) srcFunc = source;
    else src = source;
    return function() {
        // Capture the original arguments passed to the method
        var originalArguments = arguments;
        if (srcFunc) src = srcFunc();
        if (src) return src[funcName][0, $fX4fx._DYN_APPLY /* @min:%2eapply */ ](src, originalArguments);
    };
}
function $a84d28c1557c3f10$export$21c1f632458708da(target, source, chkSet) {
    if (target && source && $a84d28c1557c3f10$export$a6cdc56e425d0d0a(target) && $a84d28c1557c3f10$export$a6cdc56e425d0d0a(source)) {
        var _loop_1 = function(field) {
            if ($a84d28c1557c3f10$export$844ec244b1367d54(field)) {
                var value = source[field];
                if ($a84d28c1557c3f10$export$f6e2535fb5126e54(value)) {
                    if (!chkSet || chkSet(field, true, source, target)) // Create a proxy function rather than just copying the (possible) prototype to the new object as an instance function
                    target[field] = $a84d28c1557c3f10$var$_createProxyFunction(source, field);
                } else if (!chkSet || chkSet(field, false, source, target)) {
                    if ($a84d28c1557c3f10$export$5a15a386532a5ea4(target, field)) // Remove any previous instance property
                    delete target[field];
                    if (!$a84d28c1557c3f10$export$5525b807dcec3e1b(target, field, function() {
                        return source[field];
                    }, function(theValue) {
                        source[field] = theValue;
                    })) // Unable to create an accessor, so just assign the values as a fallback
                    // -- this will (mostly) work for objects
                    // -- but will fail for accessing primitives (if the source changes it) and all types of "setters" as the source won't be modified
                    target[field] = value;
                }
            }
        };
        // effectively apply/proxy full source to the target instance
        for(var field in source)_loop_1(field);
    }
    return target;
}
function $a84d28c1557c3f10$export$5dd8d245f6f94a18(target, name, source, theFunc, overwriteTarget) {
    if (target && name && source) {
        if (overwriteTarget !== false || $a84d28c1557c3f10$export$fce6876652108ab(target[name])) target[name] = $a84d28c1557c3f10$var$_createProxyFunction(source, theFunc);
    }
}
function $a84d28c1557c3f10$export$94f4c7fb7e7d8dc7(target, source, functionsToProxy, overwriteTarget) {
    if (target && source && $a84d28c1557c3f10$export$a6cdc56e425d0d0a(target) && $a84d28c1557c3f10$export$43bee75e5e14138e(functionsToProxy)) $a84d28c1557c3f10$export$e2e5bcdbdc49c586(functionsToProxy, function(theFuncName) {
        if ($a84d28c1557c3f10$export$844ec244b1367d54(theFuncName)) $a84d28c1557c3f10$export$5dd8d245f6f94a18(target, theFuncName, source, theFuncName, overwriteTarget);
    });
    return target;
}
function $a84d28c1557c3f10$export$f0facb5bce2741f0(defaults) {
    return /** @class */ function() {
        function class_1() {
            var _this_1 = this;
            if (defaults) $a84d28c1557c3f10$export$aa0705d5774c95d1(defaults, function(field, value) {
                _this_1[field] = value;
            });
        }
        return class_1;
    }();
}
function $a84d28c1557c3f10$export$3e03fa3fc3e422d7(theObject) {
    // V8 Optimization to cause the JIT compiler to create a new optimized object for looking up the own properties
    // primarily for object with <= 19 properties for >= 20 the effect is reduced or non-existent
    if (theObject && (0, $VVkgt.ObjAssign)) theObject = (0, $VVkgt.ObjClass)((0, $VVkgt.ObjAssign)({}, theObject));
    return theObject;
}
function $a84d28c1557c3f10$export$a7f7e50f928053df(obj1, obj2, obj3, obj4, obj5, obj6) {
    // Variables
    var theArgs = arguments;
    var extended = theArgs[0] || {};
    var argLen = theArgs[0, $fX4fx._DYN_LENGTH /* @min:%2elength */ ];
    var deep = false;
    var idx = 1;
    // Check for "Deep" flag
    if (argLen > 0 && $a84d28c1557c3f10$export$f9ce7b637dfbe238(extended)) {
        deep = extended;
        extended = theArgs[idx] || {};
        idx++;
    }
    // Handle case when target is a string or something (possible in deep copy)
    if (!$a84d28c1557c3f10$export$a6cdc56e425d0d0a(extended)) extended = {};
    // Loop through each remaining object and conduct a merge
    for(; idx < argLen; idx++){
        var arg = theArgs[idx];
        var isArgArray = $a84d28c1557c3f10$export$43bee75e5e14138e(arg);
        var isArgObj = $a84d28c1557c3f10$export$a6cdc56e425d0d0a(arg);
        for(var prop in arg){
            var propOk = isArgArray && prop in arg || isArgObj && (0, $VVkgt.ObjHasOwnProperty)[0, $fX4fx._DYN_CALL /* @min:%2ecall */ ](arg, prop);
            if (!propOk) continue;
            var newValue = arg[prop];
            var isNewArray = void 0;
            // If deep merge and property is an object, merge properties
            if (deep && newValue && ((isNewArray = $a84d28c1557c3f10$export$43bee75e5e14138e(newValue)) || $a84d28c1557c3f10$export$53b83ca8eaab0383(newValue))) {
                // Grab the current value of the extended object
                var clone = extended[prop];
                if (isNewArray) {
                    if (!$a84d28c1557c3f10$export$43bee75e5e14138e(clone)) // We can't "merge" an array with a non-array so overwrite the original
                    clone = [];
                } else if (!$a84d28c1557c3f10$export$53b83ca8eaab0383(clone)) // We can't "merge" an object with a non-object
                clone = {};
                // Never move the original objects always clone them
                newValue = $a84d28c1557c3f10$export$a7f7e50f928053df(deep, clone, newValue);
            }
            // Assign the new (or previous) value (unless undefined)
            if (newValue !== undefined) extended[prop] = newValue;
        }
    }
    return extended;
}

});
parcelRegister("fX4fx", function(module, exports) {

$parcel$export(module.exports, "_DYN_INITIALIZE", function () { return $b9cfa994364bf12a$export$65cd33bb52d04675; });
$parcel$export(module.exports, "_DYN_NAME", function () { return $b9cfa994364bf12a$export$9734b0a24bf02e93; });
$parcel$export(module.exports, "_DYN_GET_NOTIFY_MGR", function () { return $b9cfa994364bf12a$export$3a09068de032bb32; });
$parcel$export(module.exports, "_DYN_IDENTIFIER", function () { return $b9cfa994364bf12a$export$f001befbf8417151; });
$parcel$export(module.exports, "_DYN_PUSH", function () { return $b9cfa994364bf12a$export$a0a330e7fa1e278c; });
$parcel$export(module.exports, "_DYN_IS_INITIALIZED", function () { return $b9cfa994364bf12a$export$2e2716e9c35a66a8; });
$parcel$export(module.exports, "_DYN_CONFIG", function () { return $b9cfa994364bf12a$export$25fc8bd3fb7f1e5a; });
$parcel$export(module.exports, "_DYN_INSTRUMENTATION_KEY", function () { return $b9cfa994364bf12a$export$81cfd43387c8dbcc; });
$parcel$export(module.exports, "_DYN_LOGGER", function () { return $b9cfa994364bf12a$export$e6a243fe757439f9; });
$parcel$export(module.exports, "_DYN_LENGTH", function () { return $b9cfa994364bf12a$export$6eae51590aaea43; });
$parcel$export(module.exports, "_DYN_TIME", function () { return $b9cfa994364bf12a$export$7b5ba5854159c1f0; });
$parcel$export(module.exports, "_DYN_PROCESS_NEXT", function () { return $b9cfa994364bf12a$export$5c220169317cd6de; });
$parcel$export(module.exports, "_DYN_GET_PROCESS_TEL_CONT0", function () { return $b9cfa994364bf12a$export$a08d24db8e8aa3f3; });
$parcel$export(module.exports, "_DYN_ADD_NOTIFICATION_LIS1", function () { return $b9cfa994364bf12a$export$5c8bcfab4f42ca62; });
$parcel$export(module.exports, "_DYN_REMOVE_NOTIFICATION_2", function () { return $b9cfa994364bf12a$export$861144ba9c13be60; });
$parcel$export(module.exports, "_DYN_STOP_POLLING_INTERNA3", function () { return $b9cfa994364bf12a$export$8d1c48dba7ad83a; });
$parcel$export(module.exports, "_DYN_ON_COMPLETE", function () { return $b9cfa994364bf12a$export$8693bdba21bfca93; });
$parcel$export(module.exports, "_DYN_GET_PLUGIN", function () { return $b9cfa994364bf12a$export$37717a508eca6e2d; });
$parcel$export(module.exports, "_DYN_FLUSH", function () { return $b9cfa994364bf12a$export$cb47434b4a1b13a1; });
$parcel$export(module.exports, "_DYN__EXTENSIONS", function () { return $b9cfa994364bf12a$export$f97d4195cc7ba3fc; });
$parcel$export(module.exports, "_DYN_SPLICE", function () { return $b9cfa994364bf12a$export$84020a2e4fe863b0; });
$parcel$export(module.exports, "_DYN_TEARDOWN", function () { return $b9cfa994364bf12a$export$7176fb2a7d11927e; });
$parcel$export(module.exports, "_DYN_MESSAGE_ID", function () { return $b9cfa994364bf12a$export$2cc5b49df2eed261; });
$parcel$export(module.exports, "_DYN_MESSAGE", function () { return $b9cfa994364bf12a$export$923606b70907833e; });
$parcel$export(module.exports, "_DYN_IS_ASYNC", function () { return $b9cfa994364bf12a$export$d8114c9e990204cb; });
$parcel$export(module.exports, "_DYN__DO_TEARDOWN", function () { return $b9cfa994364bf12a$export$458d234b616d0745; });
$parcel$export(module.exports, "_DYN_UPDATE", function () { return $b9cfa994364bf12a$export$c9f4bebf02f459de; });
$parcel$export(module.exports, "_DYN_GET_NEXT", function () { return $b9cfa994364bf12a$export$36754a48de7fd714; });
$parcel$export(module.exports, "_DYN_DIAG_LOG", function () { return $b9cfa994364bf12a$export$c7ff2c36e5c78421; });
$parcel$export(module.exports, "_DYN_SET_NEXT_PLUGIN", function () { return $b9cfa994364bf12a$export$55d672a1dc4d50c1; });
$parcel$export(module.exports, "_DYN_CREATE_NEW", function () { return $b9cfa994364bf12a$export$1e6514b499ba4d34; });
$parcel$export(module.exports, "_DYN_COOKIE_CFG", function () { return $b9cfa994364bf12a$export$e090c68eb6dfd391; });
$parcel$export(module.exports, "_DYN_INDEX_OF", function () { return $b9cfa994364bf12a$export$a3d3f936db372b4b; });
$parcel$export(module.exports, "_DYN_SUBSTRING", function () { return $b9cfa994364bf12a$export$20dce058fdd3c573; });
$parcel$export(module.exports, "_DYN_USER_AGENT", function () { return $b9cfa994364bf12a$export$2e850152cb3355e2; });
$parcel$export(module.exports, "_DYN_SPLIT", function () { return $b9cfa994364bf12a$export$b889f1d4cb07c706; });
$parcel$export(module.exports, "_DYN_SET_ENABLED", function () { return $b9cfa994364bf12a$export$7fd5fce894e4cf77; });
$parcel$export(module.exports, "_DYN_SUBSTR", function () { return $b9cfa994364bf12a$export$5d9064a330e4b089; });
$parcel$export(module.exports, "_DYN_NODE_TYPE", function () { return $b9cfa994364bf12a$export$aa192ee35fac3196; });
$parcel$export(module.exports, "_DYN_APPLY", function () { return $b9cfa994364bf12a$export$2f85ca6962b15ff8; });
$parcel$export(module.exports, "_DYN_REPLACE", function () { return $b9cfa994364bf12a$export$ef9ef3ed86c4485; });
$parcel$export(module.exports, "_DYN_ENABLE_DEBUG_EXCEPTI4", function () { return $b9cfa994364bf12a$export$89fbbfd80220a152; });
$parcel$export(module.exports, "_DYN_LOG_INTERNAL_MESSAGE", function () { return $b9cfa994364bf12a$export$6a3333b2109fff2a; });
$parcel$export(module.exports, "_DYN_TO_LOWER_CASE", function () { return $b9cfa994364bf12a$export$e4eaee9e01d9baaa; });
$parcel$export(module.exports, "_DYN_CALL", function () { return $b9cfa994364bf12a$export$c9d274370e1187e2; });
$parcel$export(module.exports, "_DYN_TYPE", function () { return $b9cfa994364bf12a$export$8fdcd26070ec159; });
$parcel$export(module.exports, "_DYN_HANDLER", function () { return $b9cfa994364bf12a$export$b353fcbe1ae31450; });
$parcel$export(module.exports, "_DYN_LISTENERS", function () { return $b9cfa994364bf12a$export$2f9a1089308fc768; });
$parcel$export(module.exports, "_DYN_IS_CHILD_EVT", function () { return $b9cfa994364bf12a$export$3a89026537e5dfec; });
$parcel$export(module.exports, "_DYN_GET_CTX", function () { return $b9cfa994364bf12a$export$c405fd80acb80a5b; });
$parcel$export(module.exports, "_DYN_SET_CTX", function () { return $b9cfa994364bf12a$export$2ec27a3df8fa4130; });
$parcel$export(module.exports, "_DYN_COMPLETE", function () { return $b9cfa994364bf12a$export$b6736e780b133181; });
$parcel$export(module.exports, "_DYN_TRACE_ID", function () { return $b9cfa994364bf12a$export$a5eb52c53bba8560; });
$parcel$export(module.exports, "_DYN_SPAN_ID", function () { return $b9cfa994364bf12a$export$c105b94efa183847; });
$parcel$export(module.exports, "_DYN_TRACE_FLAGS", function () { return $b9cfa994364bf12a$export$4e92e4b92b41ba2d; });
$parcel$export(module.exports, "_DYN_VERSION", function () { return $b9cfa994364bf12a$export$568c4302d11f2b22; });
/*
 * Application Insights JavaScript SDK - Core, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ // @skip-file-minify
// ##############################################################
// AUTO GENERATED FILE: This file is Auto Generated during build.
// ##############################################################
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// Note: DON'T Export these const from the package as we are still targeting ES3 this will export a mutable variables that someone could change!!!
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
var $b9cfa994364bf12a$export$65cd33bb52d04675 = "initialize"; // Count: 8
var $b9cfa994364bf12a$export$9734b0a24bf02e93 = "name"; // Count: 11
var $b9cfa994364bf12a$export$3a09068de032bb32 = "getNotifyMgr"; // Count: 3
var $b9cfa994364bf12a$export$f001befbf8417151 = "identifier"; // Count: 8
var $b9cfa994364bf12a$export$a0a330e7fa1e278c = "push"; // Count: 30
var $b9cfa994364bf12a$export$2e2716e9c35a66a8 = "isInitialized"; // Count: 10
var $b9cfa994364bf12a$export$25fc8bd3fb7f1e5a = "config"; // Count: 7
var $b9cfa994364bf12a$export$81cfd43387c8dbcc = "instrumentationKey"; // Count: 3
var $b9cfa994364bf12a$export$e6a243fe757439f9 = "logger"; // Count: 10
var $b9cfa994364bf12a$export$6eae51590aaea43 = "length"; // Count: 45
var $b9cfa994364bf12a$export$7b5ba5854159c1f0 = "time"; // Count: 5
var $b9cfa994364bf12a$export$5c220169317cd6de = "processNext"; // Count: 21
var $b9cfa994364bf12a$export$a08d24db8e8aa3f3 = "getProcessTelContext"; // Count: 2
var $b9cfa994364bf12a$export$5c8bcfab4f42ca62 = "addNotificationListener"; // Count: 5
var $b9cfa994364bf12a$export$861144ba9c13be60 = "removeNotificationListener"; // Count: 5
var $b9cfa994364bf12a$export$8d1c48dba7ad83a = "stopPollingInternalLogs"; // Count: 2
var $b9cfa994364bf12a$export$8693bdba21bfca93 = "onComplete"; // Count: 6
var $b9cfa994364bf12a$export$37717a508eca6e2d = "getPlugin"; // Count: 5
var $b9cfa994364bf12a$export$cb47434b4a1b13a1 = "flush"; // Count: 5
var $b9cfa994364bf12a$export$f97d4195cc7ba3fc = "_extensions"; // Count: 4
var $b9cfa994364bf12a$export$84020a2e4fe863b0 = "splice"; // Count: 6
var $b9cfa994364bf12a$export$7176fb2a7d11927e = "teardown"; // Count: 10
var $b9cfa994364bf12a$export$2cc5b49df2eed261 = "messageId"; // Count: 4
var $b9cfa994364bf12a$export$923606b70907833e = "message"; // Count: 7
var $b9cfa994364bf12a$export$d8114c9e990204cb = "isAsync"; // Count: 7
var $b9cfa994364bf12a$export$458d234b616d0745 = "_doTeardown"; // Count: 4
var $b9cfa994364bf12a$export$c9f4bebf02f459de = "update"; // Count: 7
var $b9cfa994364bf12a$export$36754a48de7fd714 = "getNext"; // Count: 12
var $b9cfa994364bf12a$export$c7ff2c36e5c78421 = "diagLog"; // Count: 8
var $b9cfa994364bf12a$export$55d672a1dc4d50c1 = "setNextPlugin"; // Count: 5
var $b9cfa994364bf12a$export$1e6514b499ba4d34 = "createNew"; // Count: 6
var $b9cfa994364bf12a$export$e090c68eb6dfd391 = "cookieCfg"; // Count: 3
var $b9cfa994364bf12a$export$a3d3f936db372b4b = "indexOf"; // Count: 7
var $b9cfa994364bf12a$export$20dce058fdd3c573 = "substring"; // Count: 10
var $b9cfa994364bf12a$export$2e850152cb3355e2 = "userAgent"; // Count: 5
var $b9cfa994364bf12a$export$b889f1d4cb07c706 = "split"; // Count: 6
var $b9cfa994364bf12a$export$7fd5fce894e4cf77 = "setEnabled"; // Count: 5
var $b9cfa994364bf12a$export$5d9064a330e4b089 = "substr"; // Count: 6
var $b9cfa994364bf12a$export$aa192ee35fac3196 = "nodeType"; // Count: 3
var $b9cfa994364bf12a$export$2f85ca6962b15ff8 = "apply"; // Count: 6
var $b9cfa994364bf12a$export$ef9ef3ed86c4485 = "replace"; // Count: 10
var $b9cfa994364bf12a$export$89fbbfd80220a152 = "enableDebugExceptions"; // Count: 2
var $b9cfa994364bf12a$export$6a3333b2109fff2a = "logInternalMessage"; // Count: 2
var $b9cfa994364bf12a$export$e4eaee9e01d9baaa = "toLowerCase"; // Count: 8
var $b9cfa994364bf12a$export$c9d274370e1187e2 = "call"; // Count: 18
var $b9cfa994364bf12a$export$8fdcd26070ec159 = "type"; // Count: 14
var $b9cfa994364bf12a$export$b353fcbe1ae31450 = "handler"; // Count: 5
var $b9cfa994364bf12a$export$2f9a1089308fc768 = "listeners"; // Count: 6
var $b9cfa994364bf12a$export$3a89026537e5dfec = "isChildEvt"; // Count: 3
var $b9cfa994364bf12a$export$c405fd80acb80a5b = "getCtx"; // Count: 6
var $b9cfa994364bf12a$export$2ec27a3df8fa4130 = "setCtx"; // Count: 10
var $b9cfa994364bf12a$export$b6736e780b133181 = "complete"; // Count: 3
var $b9cfa994364bf12a$export$a5eb52c53bba8560 = "traceId"; // Count: 5
var $b9cfa994364bf12a$export$c105b94efa183847 = "spanId"; // Count: 5
var $b9cfa994364bf12a$export$4e92e4b92b41ba2d = "traceFlags"; // Count: 6
var $b9cfa994364bf12a$export$568c4302d11f2b22 = "version"; // Count: 4

});

parcelRegister("lxIpo", function(module, exports) {

$parcel$export(module.exports, "STR_EMPTY", function () { return $faef20ab50efe22c$export$5e8607ab26634759; });
$parcel$export(module.exports, "STR_CHANNELS", function () { return $faef20ab50efe22c$export$829012af4b2055a2; });
$parcel$export(module.exports, "STR_CORE", function () { return $faef20ab50efe22c$export$3094ace9cd82ff99; });
$parcel$export(module.exports, "STR_CREATE_PERF_MGR", function () { return $faef20ab50efe22c$export$1cf3476332da55b3; });
$parcel$export(module.exports, "STR_DISABLED", function () { return $faef20ab50efe22c$export$49e9417944569ae8; });
$parcel$export(module.exports, "STR_EXTENSION_CONFIG", function () { return $faef20ab50efe22c$export$ffb2356587263734; });
$parcel$export(module.exports, "STR_EXTENSIONS", function () { return $faef20ab50efe22c$export$a077ce616a1ab4ee; });
$parcel$export(module.exports, "STR_PROCESS_TELEMETRY", function () { return $faef20ab50efe22c$export$820a3bce4a265606; });
$parcel$export(module.exports, "STR_PRIORITY", function () { return $faef20ab50efe22c$export$58efcc07763b37be; });
$parcel$export(module.exports, "STR_EVENTS_SENT", function () { return $faef20ab50efe22c$export$bb3c4bc1b1175d3d; });
$parcel$export(module.exports, "STR_EVENTS_DISCARDED", function () { return $faef20ab50efe22c$export$bacb5b2f4c1081b9; });
$parcel$export(module.exports, "STR_EVENTS_SEND_REQUEST", function () { return $faef20ab50efe22c$export$d75e063cb88a1c25; });
$parcel$export(module.exports, "STR_PERF_EVENT", function () { return $faef20ab50efe22c$export$5d265841733c97c3; });
$parcel$export(module.exports, "STR_ERROR_TO_CONSOLE", function () { return $faef20ab50efe22c$export$5b92b2b2ccf8eb40; });
$parcel$export(module.exports, "STR_WARN_TO_CONSOLE", function () { return $faef20ab50efe22c$export$9068ba2f859ec94f; });
$parcel$export(module.exports, "STR_GET_PERF_MGR", function () { return $faef20ab50efe22c$export$f8b08c7de64edfbf; });
/*
 * Application Insights JavaScript SDK - Core, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ // ###################################################################################################################################################
// Note: DON'T Export these const from the package as we are still targeting ES3 this will export a mutable variables that someone could change!!!
// ###################################################################################################################################################
var $faef20ab50efe22c$export$5e8607ab26634759 = "";
var $faef20ab50efe22c$export$829012af4b2055a2 = "channels";
var $faef20ab50efe22c$export$3094ace9cd82ff99 = "core";
var $faef20ab50efe22c$export$1cf3476332da55b3 = "createPerfMgr";
var $faef20ab50efe22c$export$49e9417944569ae8 = "disabled";
var $faef20ab50efe22c$export$ffb2356587263734 = "extensionConfig";
var $faef20ab50efe22c$export$a077ce616a1ab4ee = "extensions";
var $faef20ab50efe22c$export$820a3bce4a265606 = "processTelemetry";
var $faef20ab50efe22c$export$58efcc07763b37be = "priority";
var $faef20ab50efe22c$export$bb3c4bc1b1175d3d = "eventsSent";
var $faef20ab50efe22c$export$bacb5b2f4c1081b9 = "eventsDiscarded";
var $faef20ab50efe22c$export$d75e063cb88a1c25 = "eventsSendRequest";
var $faef20ab50efe22c$export$5d265841733c97c3 = "perfEvent";
var $faef20ab50efe22c$export$5b92b2b2ccf8eb40 = "errorToConsole";
var $faef20ab50efe22c$export$9068ba2f859ec94f = "warnToConsole";
var $faef20ab50efe22c$export$f8b08c7de64edfbf = "getPerfMgr";

});


parcelRegister("cIC5n", function(module, exports) {

$parcel$export(module.exports, "mergeEvtNamespace", function () { return $94272325e505695e$export$3f37a50e0edde3be; });
$parcel$export(module.exports, "eventOn", function () { return $94272325e505695e$export$324ab159353a60a9; });
$parcel$export(module.exports, "eventOff", function () { return $94272325e505695e$export$51dedceb7c784eff; });
$parcel$export(module.exports, "attachEvent", function () { return $94272325e505695e$export$c7861dcba2385fcd; });
$parcel$export(module.exports, "detachEvent", function () { return $94272325e505695e$export$647f6b935c1d6b6; });
$parcel$export(module.exports, "addEventHandler", function () { return $94272325e505695e$export$3b37be979ee3303a; });
$parcel$export(module.exports, "addPageUnloadEventListener", function () { return $94272325e505695e$export$f16ce149aca77fdd; });
$parcel$export(module.exports, "removePageUnloadEventListener", function () { return $94272325e505695e$export$272dc813b0b2654c; });
$parcel$export(module.exports, "addPageHideEventListener", function () { return $94272325e505695e$export$46744aee53e5e558; });
$parcel$export(module.exports, "removePageHideEventListener", function () { return $94272325e505695e$export$6aca6ee3a147169f; });
/*
 * Application Insights JavaScript SDK - Core, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $fX4fx = parcelRequire("fX4fx");

var $2w0XY = parcelRequire("2w0XY");

var $3I5zg = parcelRequire("3I5zg");

var $erRAP = parcelRequire("erRAP");

var $lxIpo = parcelRequire("lxIpo");
// Added to help with minfication
var $94272325e505695e$var$strOnPrefix = "on";
var $94272325e505695e$var$strAttachEvent = "attachEvent";
var $94272325e505695e$var$strAddEventHelper = "addEventListener";
var $94272325e505695e$var$strDetachEvent = "detachEvent";
var $94272325e505695e$var$strRemoveEventListener = "removeEventListener";
var $94272325e505695e$var$strEvents = "events";
var $94272325e505695e$var$strVisibilityChangeEvt = "visibilitychange";
var $94272325e505695e$var$strPageHide = "pagehide";
var $94272325e505695e$var$strPageShow = "pageshow";
var $94272325e505695e$var$strUnload = "unload";
var $94272325e505695e$var$strBeforeUnload = "beforeunload";
var $94272325e505695e$var$strPageHideNamespace = (0, $2w0XY.createUniqueNamespace)("aiEvtPageHide");
var $94272325e505695e$var$strPageShowNamespace = (0, $2w0XY.createUniqueNamespace)("aiEvtPageShow");
var $94272325e505695e$var$rRemoveEmptyNs = /\.[\.]+/g;
var $94272325e505695e$var$rRemoveTrailingEmptyNs = /[\.]+$/;
var $94272325e505695e$var$_guid = 1;
var $94272325e505695e$var$elmNodeData = (0, $2w0XY.createElmNodeData)("events");
var $94272325e505695e$var$eventNamespace = /^([^.]*)(?:\.(.+)|)/;
function $94272325e505695e$var$_normalizeNamespace(name) {
    if (name && name[0, $fX4fx._DYN_REPLACE /* @min:%2ereplace */ ]) return name[0, $fX4fx._DYN_REPLACE /* @min:%2ereplace */ ](/^[\s\.]+|(?=[\s\.])[\.\s]+$/g, (0, $lxIpo.STR_EMPTY));
    return name;
}
function $94272325e505695e$var$_getEvtNamespace(eventName, evtNamespace) {
    var _a;
    if (evtNamespace) {
        var theNamespace_1 = (0, $lxIpo.STR_EMPTY);
        if ((0, $erRAP.isArray)(evtNamespace)) {
            theNamespace_1 = (0, $lxIpo.STR_EMPTY);
            (0, $erRAP.arrForEach)(evtNamespace, function(name) {
                name = $94272325e505695e$var$_normalizeNamespace(name);
                if (name) {
                    if (name[0] !== ".") name = "." + name;
                    theNamespace_1 += name;
                }
            });
        } else theNamespace_1 = $94272325e505695e$var$_normalizeNamespace(evtNamespace);
        if (theNamespace_1) {
            if (theNamespace_1[0] !== ".") theNamespace_1 = "." + theNamespace_1;
            // We may only have the namespace and not an eventName
            eventName = (eventName || (0, $lxIpo.STR_EMPTY)) + theNamespace_1;
        }
    }
    var parsedEvent = $94272325e505695e$var$eventNamespace.exec(eventName || (0, $lxIpo.STR_EMPTY)) || [];
    return _a = {}, _a[0, $fX4fx._DYN_TYPE /* @min:type */ ] = parsedEvent[1], _a.ns = (parsedEvent[2] || (0, $lxIpo.STR_EMPTY)).replace($94272325e505695e$var$rRemoveEmptyNs, ".").replace($94272325e505695e$var$rRemoveTrailingEmptyNs, (0, $lxIpo.STR_EMPTY))[0, $fX4fx._DYN_SPLIT /* @min:%2esplit */ ](".").sort().join("."), _a;
}
function $94272325e505695e$export$e2bcc16f65e2a5d2(target, eventName, evtNamespace) {
    var theEvents = [];
    var eventCache = $94272325e505695e$var$elmNodeData.get(target, $94272325e505695e$var$strEvents, {}, false);
    var evtName = $94272325e505695e$var$_getEvtNamespace(eventName, evtNamespace);
    (0, $erRAP.objForEachKey)(eventCache, function(evtType, registeredEvents) {
        (0, $erRAP.arrForEach)(registeredEvents, function(value) {
            var _a;
            if (!evtName[0, $fX4fx._DYN_TYPE /* @min:%2etype */ ] || evtName[0, $fX4fx._DYN_TYPE /* @min:%2etype */ ] === value.evtName[0, $fX4fx._DYN_TYPE /* @min:%2etype */ ]) {
                if (!evtName.ns || evtName.ns === evtName.ns) theEvents[0, $fX4fx._DYN_PUSH /* @min:%2epush */ ]((_a = {}, _a[0, $fX4fx._DYN_NAME /* @min:name */ ] = value.evtName[0, $fX4fx._DYN_TYPE /* @min:%2etype */ ] + (value.evtName.ns ? "." + value.evtName.ns : (0, $lxIpo.STR_EMPTY)), _a.handler = value[0, $fX4fx._DYN_HANDLER /* @min:%2ehandler */ ], _a));
            }
        });
    });
    return theEvents;
}
// Exported for internal unit testing only
function $94272325e505695e$var$_getRegisteredEvents(target, evtName, addDefault) {
    if (addDefault === void 0) addDefault = true;
    var aiEvts = $94272325e505695e$var$elmNodeData.get(target, $94272325e505695e$var$strEvents, {}, addDefault);
    var registeredEvents = aiEvts[evtName];
    if (!registeredEvents) registeredEvents = aiEvts[evtName] = [];
    return registeredEvents;
}
function $94272325e505695e$var$_doDetach(obj, evtName, handlerRef, useCapture) {
    if (obj && evtName && evtName[0, $fX4fx._DYN_TYPE /* @min:%2etype */ ]) {
        if (obj[$94272325e505695e$var$strRemoveEventListener]) obj[$94272325e505695e$var$strRemoveEventListener](evtName[0, $fX4fx._DYN_TYPE /* @min:%2etype */ ], handlerRef, useCapture);
        else if (obj[$94272325e505695e$var$strDetachEvent]) obj[$94272325e505695e$var$strDetachEvent]($94272325e505695e$var$strOnPrefix + evtName[0, $fX4fx._DYN_TYPE /* @min:%2etype */ ], handlerRef);
    }
}
function $94272325e505695e$var$_doAttach(obj, evtName, handlerRef, useCapture) {
    var result = false;
    if (obj && evtName && evtName[0, $fX4fx._DYN_TYPE /* @min:%2etype */ ] && handlerRef) {
        if (obj[$94272325e505695e$var$strAddEventHelper]) {
            // all browsers except IE before version 9
            obj[$94272325e505695e$var$strAddEventHelper](evtName[0, $fX4fx._DYN_TYPE /* @min:%2etype */ ], handlerRef, useCapture);
            result = true;
        } else if (obj[$94272325e505695e$var$strAttachEvent]) {
            // IE before version 9
            obj[$94272325e505695e$var$strAttachEvent]($94272325e505695e$var$strOnPrefix + evtName[0, $fX4fx._DYN_TYPE /* @min:%2etype */ ], handlerRef);
            result = true;
        }
    }
    return result;
}
function $94272325e505695e$var$_doUnregister(target, events, evtName, unRegFn) {
    var idx = events[0, $fX4fx._DYN_LENGTH /* @min:%2elength */ ];
    while(idx--){
        var theEvent = events[idx];
        if (theEvent) {
            if (!evtName.ns || evtName.ns === theEvent.evtName.ns) {
                if (!unRegFn || unRegFn(theEvent)) {
                    $94272325e505695e$var$_doDetach(target, theEvent.evtName, theEvent[0, $fX4fx._DYN_HANDLER /* @min:%2ehandler */ ], theEvent.capture);
                    // Remove the registered event
                    events[0, $fX4fx._DYN_SPLICE /* @min:%2esplice */ ](idx, 1);
                }
            }
        }
    }
}
function $94272325e505695e$var$_unregisterEvents(target, evtName, unRegFn) {
    if (evtName[0, $fX4fx._DYN_TYPE /* @min:%2etype */ ]) $94272325e505695e$var$_doUnregister(target, $94272325e505695e$var$_getRegisteredEvents(target, evtName[0, $fX4fx._DYN_TYPE /* @min:%2etype */ ]), evtName, unRegFn);
    else {
        var eventCache = $94272325e505695e$var$elmNodeData.get(target, $94272325e505695e$var$strEvents, {});
        (0, $erRAP.objForEachKey)(eventCache, function(evtType, events) {
            $94272325e505695e$var$_doUnregister(target, events, evtName, unRegFn);
        });
        // Cleanup
        if ((0, $erRAP.objKeys)(eventCache)[0, $fX4fx._DYN_LENGTH /* @min:%2elength */ ] === 0) $94272325e505695e$var$elmNodeData.kill(target, $94272325e505695e$var$strEvents);
    }
}
function $94272325e505695e$export$3f37a50e0edde3be(theNamespace, namespaces) {
    var newNamespaces;
    if (namespaces) {
        if ((0, $erRAP.isArray)(namespaces)) newNamespaces = [
            theNamespace
        ].concat(namespaces);
        else newNamespaces = [
            theNamespace,
            namespaces
        ];
        // resort the namespaces so they are always in order
        newNamespaces = $94272325e505695e$var$_getEvtNamespace("xx", newNamespaces).ns[0, $fX4fx._DYN_SPLIT /* @min:%2esplit */ ](".");
    } else newNamespaces = theNamespace;
    return newNamespaces;
}
function $94272325e505695e$export$324ab159353a60a9(target, eventName, handlerRef, evtNamespace, useCapture) {
    var _a;
    if (useCapture === void 0) useCapture = false;
    var result = false;
    if (target) try {
        var evtName = $94272325e505695e$var$_getEvtNamespace(eventName, evtNamespace);
        result = $94272325e505695e$var$_doAttach(target, evtName, handlerRef, useCapture);
        if (result && $94272325e505695e$var$elmNodeData.accept(target)) {
            var registeredEvent = (_a = {
                guid: $94272325e505695e$var$_guid++,
                evtName: evtName
            }, _a[0, $fX4fx._DYN_HANDLER /* @min:handler */ ] = handlerRef, _a.capture = useCapture, _a);
            $94272325e505695e$var$_getRegisteredEvents(target, evtName.type)[0, $fX4fx._DYN_PUSH /* @min:%2epush */ ](registeredEvent);
        }
    } catch (e) {
    // Just Ignore any error so that we don't break any execution path
    }
    return result;
}
function $94272325e505695e$export$51dedceb7c784eff(target, eventName, handlerRef, evtNamespace, useCapture) {
    if (useCapture === void 0) useCapture = false;
    if (target) try {
        var evtName_1 = $94272325e505695e$var$_getEvtNamespace(eventName, evtNamespace);
        var found_1 = false;
        $94272325e505695e$var$_unregisterEvents(target, evtName_1, function(regEvent) {
            if (evtName_1.ns && !handlerRef || regEvent[0, $fX4fx._DYN_HANDLER /* @min:%2ehandler */ ] === handlerRef) {
                found_1 = true;
                return true;
            }
            return false;
        });
        if (!found_1) // fallback to try and remove as requested
        $94272325e505695e$var$_doDetach(target, evtName_1, handlerRef, useCapture);
    } catch (e) {
    // Just Ignore any error so that we don't break any execution path
    }
}
function $94272325e505695e$export$c7861dcba2385fcd(obj, eventNameWithoutOn, handlerRef, useCapture) {
    if (useCapture === void 0) useCapture = false;
    return $94272325e505695e$export$324ab159353a60a9(obj, eventNameWithoutOn, handlerRef, null, useCapture);
}
function $94272325e505695e$export$647f6b935c1d6b6(obj, eventNameWithoutOn, handlerRef, useCapture) {
    if (useCapture === void 0) useCapture = false;
    $94272325e505695e$export$51dedceb7c784eff(obj, eventNameWithoutOn, handlerRef, null, useCapture);
}
function $94272325e505695e$export$3b37be979ee3303a(eventName, callback, evtNamespace) {
    var result = false;
    var w = (0, $3I5zg.getWindow)();
    if (w) {
        result = $94272325e505695e$export$324ab159353a60a9(w, eventName, callback, evtNamespace);
        result = $94272325e505695e$export$324ab159353a60a9(w["body"], eventName, callback, evtNamespace) || result;
    }
    var doc = (0, $3I5zg.getDocument)();
    if (doc) result = $94272325e505695e$export$324ab159353a60a9(doc, eventName, callback, evtNamespace) || result;
    return result;
}
function $94272325e505695e$export$546f5991fce5bf06(eventName, callback, evtNamespace) {
    var w = (0, $3I5zg.getWindow)();
    if (w) {
        $94272325e505695e$export$51dedceb7c784eff(w, eventName, callback, evtNamespace);
        $94272325e505695e$export$51dedceb7c784eff(w["body"], eventName, callback, evtNamespace);
    }
    var doc = (0, $3I5zg.getDocument)();
    if (doc) $94272325e505695e$export$51dedceb7c784eff(doc, eventName, callback, evtNamespace);
}
/**
 * Bind the listener to the array of events
 * @param events An string array of event names to bind the listener to
 * @param listener The event callback to call when the event is triggered
 * @param excludeEvents - [Optional] An array of events that should not be hooked (if possible), unless no other events can be.
 * @param evtNamespace - [Optional] Namespace(s) to append to the event listeners so they can be uniquely identified and removed based on this namespace.
 * @returns true - when at least one of the events was registered otherwise false
 */ function $94272325e505695e$var$_addEventListeners(events, listener, excludeEvents, evtNamespace) {
    var added = false;
    if (listener && events && events[0, $fX4fx._DYN_LENGTH /* @min:%2elength */ ] > 0) (0, $erRAP.arrForEach)(events, function(name) {
        if (name) {
            if (!excludeEvents || (0, $erRAP.arrIndexOf)(excludeEvents, name) === -1) added = $94272325e505695e$export$3b37be979ee3303a(name, listener, evtNamespace) || added;
        }
    });
    return added;
}
function $94272325e505695e$export$40a4ed63e5cb7043(events, listener, excludeEvents, evtNamespace) {
    var added = false;
    if (listener && events && (0, $erRAP.isArray)(events)) {
        added = $94272325e505695e$var$_addEventListeners(events, listener, excludeEvents, evtNamespace);
        if (!added && excludeEvents && excludeEvents[0, $fX4fx._DYN_LENGTH /* @min:%2elength */ ] > 0) // Failed to add any listeners and we excluded some, so just attempt to add the excluded events
        added = $94272325e505695e$var$_addEventListeners(events, listener, null, evtNamespace);
    }
    return added;
}
function $94272325e505695e$export$8c7b13b21690651d(events, listener, evtNamespace) {
    if (events && (0, $erRAP.isArray)(events)) (0, $erRAP.arrForEach)(events, function(name) {
        if (name) $94272325e505695e$export$546f5991fce5bf06(name, listener, evtNamespace);
    });
}
function $94272325e505695e$export$f16ce149aca77fdd(listener, excludeEvents, evtNamespace) {
    // Hook the unload event for the document, window and body to ensure that the client events are flushed to the server
    // As just hooking the window does not always fire (on chrome) for page navigation's.
    return $94272325e505695e$export$40a4ed63e5cb7043([
        $94272325e505695e$var$strBeforeUnload,
        $94272325e505695e$var$strUnload,
        $94272325e505695e$var$strPageHide
    ], listener, excludeEvents, evtNamespace);
}
function $94272325e505695e$export$272dc813b0b2654c(listener, evtNamespace) {
    $94272325e505695e$export$8c7b13b21690651d([
        $94272325e505695e$var$strBeforeUnload,
        $94272325e505695e$var$strUnload,
        $94272325e505695e$var$strPageHide
    ], listener, evtNamespace);
}
function $94272325e505695e$export$46744aee53e5e558(listener, excludeEvents, evtNamespace) {
    function _handlePageVisibility(evt) {
        var doc = (0, $3I5zg.getDocument)();
        if (listener && doc && doc.visibilityState === "hidden") listener(evt);
    }
    // add the unique page show namespace to any provided namespace so we can only remove the ones added by "pagehide"
    var newNamespaces = $94272325e505695e$export$3f37a50e0edde3be($94272325e505695e$var$strPageHideNamespace, evtNamespace);
    var pageUnloadAdded = $94272325e505695e$var$_addEventListeners([
        $94272325e505695e$var$strPageHide
    ], listener, excludeEvents, newNamespaces);
    if (!excludeEvents || (0, $erRAP.arrIndexOf)(excludeEvents, $94272325e505695e$var$strVisibilityChangeEvt) === -1) pageUnloadAdded = $94272325e505695e$var$_addEventListeners([
        $94272325e505695e$var$strVisibilityChangeEvt
    ], _handlePageVisibility, excludeEvents, newNamespaces) || pageUnloadAdded;
    if (!pageUnloadAdded && excludeEvents) // Failed to add any listeners and we where requested to exclude some, so just call again without excluding anything
    pageUnloadAdded = $94272325e505695e$export$46744aee53e5e558(listener, null, evtNamespace);
    return pageUnloadAdded;
}
function $94272325e505695e$export$6aca6ee3a147169f(listener, evtNamespace) {
    // add the unique page show namespace to any provided namespace so we only remove the ones added by "pagehide"
    var newNamespaces = $94272325e505695e$export$3f37a50e0edde3be($94272325e505695e$var$strPageHideNamespace, evtNamespace);
    $94272325e505695e$export$8c7b13b21690651d([
        $94272325e505695e$var$strPageHide
    ], listener, newNamespaces);
    $94272325e505695e$export$8c7b13b21690651d([
        $94272325e505695e$var$strVisibilityChangeEvt
    ], null, newNamespaces);
}
function $94272325e505695e$export$cce4a6563c734c0(listener, excludeEvents, evtNamespace) {
    function _handlePageVisibility(evt) {
        var doc = (0, $3I5zg.getDocument)();
        if (listener && doc && doc.visibilityState === "visible") listener(evt);
    }
    // add the unique page show namespace to any provided namespace so we can only remove the ones added by "pageshow"
    var newNamespaces = $94272325e505695e$export$3f37a50e0edde3be($94272325e505695e$var$strPageShowNamespace, evtNamespace);
    var pageShowAdded = $94272325e505695e$var$_addEventListeners([
        $94272325e505695e$var$strPageShow
    ], listener, excludeEvents, newNamespaces);
    pageShowAdded = $94272325e505695e$var$_addEventListeners([
        $94272325e505695e$var$strVisibilityChangeEvt
    ], _handlePageVisibility, excludeEvents, newNamespaces) || pageShowAdded;
    if (!pageShowAdded && excludeEvents) // Failed to add any listeners and we where requested to exclude some, so just call again without excluding anything
    pageShowAdded = $94272325e505695e$export$cce4a6563c734c0(listener, null, evtNamespace);
    return pageShowAdded;
}
function $94272325e505695e$export$c49093a8bd06690f(listener, evtNamespace) {
    // add the unique page show namespace to any provided namespace so we only remove the ones added by "pageshow"
    var newNamespaces = $94272325e505695e$export$3f37a50e0edde3be($94272325e505695e$var$strPageShowNamespace, evtNamespace);
    $94272325e505695e$export$8c7b13b21690651d([
        $94272325e505695e$var$strPageShow
    ], listener, newNamespaces);
    $94272325e505695e$export$8c7b13b21690651d([
        $94272325e505695e$var$strVisibilityChangeEvt
    ], null, newNamespaces);
}

});
parcelRegister("2w0XY", function(module, exports) {

$parcel$export(module.exports, "createUniqueNamespace", function () { return $1d4f51cbf658268c$export$eb4a6badb18ead04; });
$parcel$export(module.exports, "createElmNodeData", function () { return $1d4f51cbf658268c$export$b95c3438408d78aa; });
/*
 * Application Insights JavaScript SDK - Core, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $VVkgt = parcelRequire("VVkgt");

var $fX4fx = parcelRequire("fX4fx");

var $erRAP = parcelRequire("erRAP");

var $lxIpo = parcelRequire("lxIpo");

var $990ap = parcelRequire("990ap");
var $1d4f51cbf658268c$var$_objDefineProperty = (0, $VVkgt.ObjDefineProperty);
var $1d4f51cbf658268c$var$version = "2.8.18";
var $1d4f51cbf658268c$var$instanceName = "." + (0, $990ap.newId)(6);
var $1d4f51cbf658268c$var$_dataUid = 0;
function $1d4f51cbf658268c$var$_createAccessor(target, prop, value) {
    if ($1d4f51cbf658268c$var$_objDefineProperty) try {
        $1d4f51cbf658268c$var$_objDefineProperty(target, prop, {
            value: value,
            enumerable: false,
            configurable: true
        });
        return true;
    } catch (e) {
    // IE8 Defines a defineProperty on Object but it's only supported for DOM elements so it will throw
    // We will just ignore this here.
    }
    return false;
}
// Accepts only:
//  - Node
//    - Node.ELEMENT_NODE
//    - Node.DOCUMENT_NODE
//  - Object
//    - Any
function $1d4f51cbf658268c$var$_canAcceptData(target) {
    return target[0, $fX4fx._DYN_NODE_TYPE /* @min:%2enodeType */ ] === 1 || target[0, $fX4fx._DYN_NODE_TYPE /* @min:%2enodeType */ ] === 9 || !+target[0, $fX4fx._DYN_NODE_TYPE /* @min:%2enodeType */ ];
}
function $1d4f51cbf658268c$var$_getCache(data, target) {
    var theCache = target[data.id];
    if (!theCache) {
        theCache = {};
        try {
            if ($1d4f51cbf658268c$var$_canAcceptData(target)) {
                if (!$1d4f51cbf658268c$var$_createAccessor(target, data.id, theCache)) // Environment doesn't support accessor, so just use direct assignment
                target[data.id] = theCache;
            }
        } catch (e) {
        // Not all environments allow extending all objects, so just ignore the cache in those cases
        }
    }
    return theCache;
}
function $1d4f51cbf658268c$export$eb4a6badb18ead04(name, includeVersion) {
    if (includeVersion === void 0) includeVersion = false;
    return (0, $erRAP.normalizeJsName)(name + $1d4f51cbf658268c$var$_dataUid++ + (includeVersion ? "." + $1d4f51cbf658268c$var$version : (0, $lxIpo.STR_EMPTY)) + $1d4f51cbf658268c$var$instanceName);
}
function $1d4f51cbf658268c$export$b95c3438408d78aa(name) {
    var data = {
        id: $1d4f51cbf658268c$export$eb4a6badb18ead04("_aiData-" + (name || (0, $lxIpo.STR_EMPTY)) + "." + $1d4f51cbf658268c$var$version),
        accept: function(target) {
            return $1d4f51cbf658268c$var$_canAcceptData(target);
        },
        get: function(target, name, defValue, addDefault) {
            var theCache = target[data.id];
            if (!theCache) {
                if (addDefault) {
                    // Side effect is adds the cache
                    theCache = $1d4f51cbf658268c$var$_getCache(data, target);
                    theCache[(0, $erRAP.normalizeJsName)(name)] = defValue;
                }
                return defValue;
            }
            return theCache[(0, $erRAP.normalizeJsName)(name)];
        },
        kill: function(target, name) {
            if (target && target[name]) try {
                delete target[name];
            } catch (e) {
            // Just cleaning up, so if this fails -- ignore
            }
        }
    };
    return data;
}

});
parcelRegister("990ap", function(module, exports) {

$parcel$export(module.exports, "randomValue", function () { return $6a851576618b8881$export$b2cfcb5c32671fa4; });
$parcel$export(module.exports, "random32", function () { return $6a851576618b8881$export$aec042b223b6f5f9; });
$parcel$export(module.exports, "mwcRandom32", function () { return $6a851576618b8881$export$3ffb74f7babdd68f; });
$parcel$export(module.exports, "mwcRandomSeed", function () { return $6a851576618b8881$export$195aff7adbfe974f; });
$parcel$export(module.exports, "newId", function () { return $6a851576618b8881$export$9ffd10a3fbdc175b; });
/*
 * Application Insights JavaScript SDK - Core, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $fX4fx = parcelRequire("fX4fx");

var $3I5zg = parcelRequire("3I5zg");

var $erRAP = parcelRequire("erRAP");

var $lxIpo = parcelRequire("lxIpo");
var $6a851576618b8881$var$UInt32Mask = 0x100000000;
var $6a851576618b8881$var$MaxUInt32 = 0xffffffff;
// MWC based Random generator (for IE)
var $6a851576618b8881$var$_mwcSeeded = false;
var $6a851576618b8881$var$_mwcW = 123456789;
var $6a851576618b8881$var$_mwcZ = 987654321;
// Takes any integer
function $6a851576618b8881$var$_mwcSeed(seedValue) {
    if (seedValue < 0) // Make sure we end up with a positive number and not -ve one.
    seedValue >>>= 0;
    $6a851576618b8881$var$_mwcW = 123456789 + seedValue & $6a851576618b8881$var$MaxUInt32;
    $6a851576618b8881$var$_mwcZ = 987654321 - seedValue & $6a851576618b8881$var$MaxUInt32;
    $6a851576618b8881$var$_mwcSeeded = true;
}
function $6a851576618b8881$var$_autoSeedMwc() {
    // Simple initialization using default Math.random() - So we inherit any entropy from the browser
    // and bitwise XOR with the current milliseconds
    try {
        var now = (0, $erRAP.dateNow)() & 0x7fffffff;
        $6a851576618b8881$var$_mwcSeed((Math.random() * $6a851576618b8881$var$UInt32Mask ^ now) + now);
    } catch (e) {
    // Don't crash if something goes wrong
    }
}
function $6a851576618b8881$export$b2cfcb5c32671fa4(maxValue) {
    if (maxValue > 0) return Math.floor($6a851576618b8881$export$aec042b223b6f5f9() / $6a851576618b8881$var$MaxUInt32 * (maxValue + 1)) >>> 0;
    return 0;
}
function $6a851576618b8881$export$aec042b223b6f5f9(signed) {
    var value = 0;
    var c = (0, $3I5zg.getCrypto)() || (0, $3I5zg.getMsCrypto)();
    if (c && c.getRandomValues) // Make sure the number is converted into the specified range (-0x80000000..0x7FFFFFFF)
    value = c.getRandomValues(new Uint32Array(1))[0] & $6a851576618b8881$var$MaxUInt32;
    if (value === 0 && (0, $3I5zg.isIE)()) {
        // For IE 6, 7, 8 (especially on XP) Math.random is not very random
        if (!$6a851576618b8881$var$_mwcSeeded) // Set the seed for the Mwc algorithm
        $6a851576618b8881$var$_autoSeedMwc();
        // Don't use Math.random for IE
        // Make sure the number is converted into the specified range (-0x80000000..0x7FFFFFFF)
        value = $6a851576618b8881$export$3ffb74f7babdd68f() & $6a851576618b8881$var$MaxUInt32;
    }
    if (value === 0) // Make sure the number is converted into the specified range (-0x80000000..0x7FFFFFFF)
    value = Math.floor($6a851576618b8881$var$UInt32Mask * Math.random() | 0);
    if (!signed) // Make sure we end up with a positive number and not -ve one.
    value >>>= 0;
    return value;
}
function $6a851576618b8881$export$195aff7adbfe974f(value) {
    if (!value) $6a851576618b8881$var$_autoSeedMwc();
    else $6a851576618b8881$var$_mwcSeed(value);
}
function $6a851576618b8881$export$3ffb74f7babdd68f(signed) {
    $6a851576618b8881$var$_mwcZ = 36969 * ($6a851576618b8881$var$_mwcZ & 0xFFFF) + ($6a851576618b8881$var$_mwcZ >> 16) & $6a851576618b8881$var$MaxUInt32;
    $6a851576618b8881$var$_mwcW = 18000 * ($6a851576618b8881$var$_mwcW & 0xFFFF) + ($6a851576618b8881$var$_mwcW >> 16) & $6a851576618b8881$var$MaxUInt32;
    var value = ($6a851576618b8881$var$_mwcZ << 16) + ($6a851576618b8881$var$_mwcW & 0xFFFF) >>> 0 & $6a851576618b8881$var$MaxUInt32 | 0;
    if (!signed) // Make sure we end up with a positive number and not -ve one.
    value >>>= 0;
    return value;
}
function $6a851576618b8881$export$9ffd10a3fbdc175b(maxLength) {
    if (maxLength === void 0) maxLength = 22;
    var base64chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
    // Start with an initial random number, consuming the value in reverse byte order
    var number = $6a851576618b8881$export$aec042b223b6f5f9() >>> 0; // Make sure it's a +ve number
    var chars = 0;
    var result = (0, $lxIpo.STR_EMPTY);
    while(result[0, $fX4fx._DYN_LENGTH /* @min:%2elength */ ] < maxLength){
        chars++;
        result += base64chars.charAt(number & 0x3F);
        number >>>= 6; // Zero fill with right shift
        if (chars === 5) {
            // 5 base64 characters === 30 bits so we don't have enough bits for another base64 char
            // So add on another 30 bits and make sure it's +ve
            number = ($6a851576618b8881$export$aec042b223b6f5f9() << 2 & 0xFFFFFFFF | number & 0x03) >>> 0;
            chars = 0; // We need to reset the number every 5 chars (30 bits)
        }
    }
    return result;
}

});
parcelRegister("3I5zg", function(module, exports) {

$parcel$export(module.exports, "getGlobalInst", function () { return $2b39ccc8637f1ec7$export$516e580f5eed5df7; });
$parcel$export(module.exports, "hasWindow", function () { return $2b39ccc8637f1ec7$export$fef62134eea24008; });
$parcel$export(module.exports, "getWindow", function () { return $2b39ccc8637f1ec7$export$38b2d434cce3ea22; });
$parcel$export(module.exports, "hasDocument", function () { return $2b39ccc8637f1ec7$export$c4372eca9c56fe99; });
$parcel$export(module.exports, "getDocument", function () { return $2b39ccc8637f1ec7$export$f65ca476c09acec0; });
$parcel$export(module.exports, "getNavigator", function () { return $2b39ccc8637f1ec7$export$a56241c767c1d89f; });
$parcel$export(module.exports, "hasHistory", function () { return $2b39ccc8637f1ec7$export$b79afd6d47f11781; });
$parcel$export(module.exports, "getHistory", function () { return $2b39ccc8637f1ec7$export$f9582a3c130d9538; });
$parcel$export(module.exports, "getLocation", function () { return $2b39ccc8637f1ec7$export$e7fd20fad3cf4b5f; });
$parcel$export(module.exports, "getConsole", function () { return $2b39ccc8637f1ec7$export$bbe488cec1edd401; });
$parcel$export(module.exports, "getPerformance", function () { return $2b39ccc8637f1ec7$export$28a0276e10aa78d7; });
$parcel$export(module.exports, "hasJSON", function () { return $2b39ccc8637f1ec7$export$a2856ab6913b9fff; });
$parcel$export(module.exports, "getJSON", function () { return $2b39ccc8637f1ec7$export$d047a7c56db64af4; });
$parcel$export(module.exports, "getCrypto", function () { return $2b39ccc8637f1ec7$export$e003cc239f955cb6; });
$parcel$export(module.exports, "getMsCrypto", function () { return $2b39ccc8637f1ec7$export$6bc5093edbd2ea6; });
$parcel$export(module.exports, "isReactNative", function () { return $2b39ccc8637f1ec7$export$f7a1e23e542d38e3; });
$parcel$export(module.exports, "isIE", function () { return $2b39ccc8637f1ec7$export$7e7b1a9668aaed8; });
$parcel$export(module.exports, "getIEVersion", function () { return $2b39ccc8637f1ec7$export$eb7ff627fa81c42e; });
$parcel$export(module.exports, "dumpObj", function () { return $2b39ccc8637f1ec7$export$21fce7cbd4dc679f; });
$parcel$export(module.exports, "isBeaconsSupported", function () { return $2b39ccc8637f1ec7$export$cf496c79c05967a0; });
$parcel$export(module.exports, "isFetchSupported", function () { return $2b39ccc8637f1ec7$export$f8c1c61350d9749; });
$parcel$export(module.exports, "useXDomainRequest", function () { return $2b39ccc8637f1ec7$export$b9f2bc09e5ac0fa5; });
$parcel$export(module.exports, "isXhrSupported", function () { return $2b39ccc8637f1ec7$export$cfeac9aa070f0108; });
$parcel$export(module.exports, "findMetaTag", function () { return $2b39ccc8637f1ec7$export$cdb9869d6805c74f; });
$parcel$export(module.exports, "findNamedServerTiming", function () { return $2b39ccc8637f1ec7$export$a25efeeb107534e6; });
/*
 * Application Insights JavaScript SDK - Core, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $gSD6i = parcelRequire("gSD6i");
var $VVkgt = parcelRequire("VVkgt");

var $fX4fx = parcelRequire("fX4fx");

var $erRAP = parcelRequire("erRAP");

var $lxIpo = parcelRequire("lxIpo");
"use strict";
/**
 * This file exists to hold environment utilities that are required to check and
 * validate the current operating environment. Unless otherwise required, please
 * only use defined methods (functions) in this class so that users of these
 * functions/properties only need to include those that are used within their own modules.
 */ var $2b39ccc8637f1ec7$var$strWindow = "window";
var $2b39ccc8637f1ec7$var$strDocument = "document";
var $2b39ccc8637f1ec7$var$strDocumentMode = "documentMode";
var $2b39ccc8637f1ec7$var$strNavigator = "navigator";
var $2b39ccc8637f1ec7$var$strHistory = "history";
var $2b39ccc8637f1ec7$var$strLocation = "location";
var $2b39ccc8637f1ec7$var$strConsole = "console";
var $2b39ccc8637f1ec7$var$strPerformance = "performance";
var $2b39ccc8637f1ec7$var$strJSON = "JSON";
var $2b39ccc8637f1ec7$var$strCrypto = "crypto";
var $2b39ccc8637f1ec7$var$strMsCrypto = "msCrypto";
var $2b39ccc8637f1ec7$var$strReactNative = "ReactNative";
var $2b39ccc8637f1ec7$var$strMsie = "msie";
var $2b39ccc8637f1ec7$var$strTrident = "trident/";
var $2b39ccc8637f1ec7$var$strXMLHttpRequest = "XMLHttpRequest";
var $2b39ccc8637f1ec7$var$_isTrident = null;
var $2b39ccc8637f1ec7$var$_navUserAgentCheck = null;
var $2b39ccc8637f1ec7$var$_enableMocks = false;
var $2b39ccc8637f1ec7$var$_useXDomainRequest = null;
var $2b39ccc8637f1ec7$var$_beaconsSupported = null;
function $2b39ccc8637f1ec7$var$_hasProperty(theClass, property) {
    var supported = false;
    if (theClass) {
        try {
            supported = property in theClass;
            if (!supported) {
                var proto = theClass[0, $VVkgt.strShimPrototype];
                if (proto) supported = property in proto;
            }
        } catch (e) {
        // Do Nothing
        }
        if (!supported) try {
            var tmp = new theClass();
            supported = !(0, $erRAP.isUndefined)(tmp[property]);
        } catch (e) {
        // Do Nothing
        }
    }
    return supported;
}
function $2b39ccc8637f1ec7$export$6b8934f3c937d22f(enabled) {
    $2b39ccc8637f1ec7$var$_enableMocks = enabled;
}
function $2b39ccc8637f1ec7$export$516e580f5eed5df7(name) {
    var gbl = (0, $gSD6i.getGlobal)();
    if (gbl && gbl[name]) return gbl[name];
    // Test workaround, for environments where <global>.window (when global == window) doesn't return the base window
    if (name === $2b39ccc8637f1ec7$var$strWindow && $2b39ccc8637f1ec7$export$fef62134eea24008()) // tslint:disable-next-line: no-angle-bracket-type-assertion
    return window;
    return null;
}
function $2b39ccc8637f1ec7$export$fef62134eea24008() {
    return Boolean(typeof window === (0, $VVkgt.strShimObject) && window);
}
function $2b39ccc8637f1ec7$export$38b2d434cce3ea22() {
    if ($2b39ccc8637f1ec7$export$fef62134eea24008()) return window;
    // Return the global instance or null
    return $2b39ccc8637f1ec7$export$516e580f5eed5df7($2b39ccc8637f1ec7$var$strWindow);
}
function $2b39ccc8637f1ec7$export$c4372eca9c56fe99() {
    return Boolean(typeof document === (0, $VVkgt.strShimObject) && document);
}
function $2b39ccc8637f1ec7$export$f65ca476c09acec0() {
    if ($2b39ccc8637f1ec7$export$c4372eca9c56fe99()) return document;
    return $2b39ccc8637f1ec7$export$516e580f5eed5df7($2b39ccc8637f1ec7$var$strDocument);
}
function $2b39ccc8637f1ec7$export$bd82d106260417bf() {
    return Boolean(typeof navigator === (0, $VVkgt.strShimObject) && navigator);
}
function $2b39ccc8637f1ec7$export$a56241c767c1d89f() {
    if ($2b39ccc8637f1ec7$export$bd82d106260417bf()) return navigator;
    return $2b39ccc8637f1ec7$export$516e580f5eed5df7($2b39ccc8637f1ec7$var$strNavigator);
}
function $2b39ccc8637f1ec7$export$b79afd6d47f11781() {
    return Boolean(typeof history === (0, $VVkgt.strShimObject) && history);
}
function $2b39ccc8637f1ec7$export$f9582a3c130d9538() {
    if ($2b39ccc8637f1ec7$export$b79afd6d47f11781()) return history;
    return $2b39ccc8637f1ec7$export$516e580f5eed5df7($2b39ccc8637f1ec7$var$strHistory);
}
function $2b39ccc8637f1ec7$export$e7fd20fad3cf4b5f(checkForMock) {
    if (checkForMock && $2b39ccc8637f1ec7$var$_enableMocks) {
        var mockLocation = $2b39ccc8637f1ec7$export$516e580f5eed5df7("__mockLocation");
        if (mockLocation) return mockLocation;
    }
    if (typeof location === (0, $VVkgt.strShimObject) && location) return location;
    return $2b39ccc8637f1ec7$export$516e580f5eed5df7($2b39ccc8637f1ec7$var$strLocation);
}
function $2b39ccc8637f1ec7$export$bbe488cec1edd401() {
    if (typeof console !== (0, $VVkgt.strShimUndefined)) return console;
    return $2b39ccc8637f1ec7$export$516e580f5eed5df7($2b39ccc8637f1ec7$var$strConsole);
}
function $2b39ccc8637f1ec7$export$28a0276e10aa78d7() {
    return $2b39ccc8637f1ec7$export$516e580f5eed5df7($2b39ccc8637f1ec7$var$strPerformance);
}
function $2b39ccc8637f1ec7$export$a2856ab6913b9fff() {
    return Boolean(typeof JSON === (0, $VVkgt.strShimObject) && JSON || $2b39ccc8637f1ec7$export$516e580f5eed5df7($2b39ccc8637f1ec7$var$strJSON) !== null);
}
function $2b39ccc8637f1ec7$export$d047a7c56db64af4() {
    if ($2b39ccc8637f1ec7$export$a2856ab6913b9fff()) return JSON || $2b39ccc8637f1ec7$export$516e580f5eed5df7($2b39ccc8637f1ec7$var$strJSON);
    return null;
}
function $2b39ccc8637f1ec7$export$e003cc239f955cb6() {
    return $2b39ccc8637f1ec7$export$516e580f5eed5df7($2b39ccc8637f1ec7$var$strCrypto);
}
function $2b39ccc8637f1ec7$export$6bc5093edbd2ea6() {
    return $2b39ccc8637f1ec7$export$516e580f5eed5df7($2b39ccc8637f1ec7$var$strMsCrypto);
}
function $2b39ccc8637f1ec7$export$f7a1e23e542d38e3() {
    // If running in React Native, navigator.product will be populated
    var nav = $2b39ccc8637f1ec7$export$a56241c767c1d89f();
    if (nav && nav.product) return nav.product === $2b39ccc8637f1ec7$var$strReactNative;
    return false;
}
function $2b39ccc8637f1ec7$export$7e7b1a9668aaed8() {
    var nav = $2b39ccc8637f1ec7$export$a56241c767c1d89f();
    if (nav && (nav[0, $fX4fx._DYN_USER_AGENT /* @min:%2euserAgent */ ] !== $2b39ccc8637f1ec7$var$_navUserAgentCheck || $2b39ccc8637f1ec7$var$_isTrident === null)) {
        // Added to support test mocking of the user agent
        $2b39ccc8637f1ec7$var$_navUserAgentCheck = nav[0, $fX4fx._DYN_USER_AGENT /* @min:%2euserAgent */ ];
        var userAgent = ($2b39ccc8637f1ec7$var$_navUserAgentCheck || (0, $lxIpo.STR_EMPTY))[0, $fX4fx._DYN_TO_LOWER_CASE /* @min:%2etoLowerCase */ ]();
        $2b39ccc8637f1ec7$var$_isTrident = (0, $erRAP.strContains)(userAgent, $2b39ccc8637f1ec7$var$strMsie) || (0, $erRAP.strContains)(userAgent, $2b39ccc8637f1ec7$var$strTrident);
    }
    return $2b39ccc8637f1ec7$var$_isTrident;
}
function $2b39ccc8637f1ec7$export$eb7ff627fa81c42e(userAgentStr) {
    if (userAgentStr === void 0) userAgentStr = null;
    if (!userAgentStr) {
        var navigator_1 = $2b39ccc8637f1ec7$export$a56241c767c1d89f() || {};
        userAgentStr = navigator_1 ? (navigator_1[0, $fX4fx._DYN_USER_AGENT /* @min:%2euserAgent */ ] || (0, $lxIpo.STR_EMPTY))[0, $fX4fx._DYN_TO_LOWER_CASE /* @min:%2etoLowerCase */ ]() : (0, $lxIpo.STR_EMPTY);
    }
    var ua = (userAgentStr || (0, $lxIpo.STR_EMPTY))[0, $fX4fx._DYN_TO_LOWER_CASE /* @min:%2etoLowerCase */ ]();
    // Also check for documentMode in case X-UA-Compatible meta tag was included in HTML.
    if ((0, $erRAP.strContains)(ua, $2b39ccc8637f1ec7$var$strMsie)) {
        var doc = $2b39ccc8637f1ec7$export$f65ca476c09acec0() || {};
        return Math.max(parseInt(ua[0, $fX4fx._DYN_SPLIT /* @min:%2esplit */ ]($2b39ccc8637f1ec7$var$strMsie)[1]), doc[$2b39ccc8637f1ec7$var$strDocumentMode] || 0);
    } else if ((0, $erRAP.strContains)(ua, $2b39ccc8637f1ec7$var$strTrident)) {
        var tridentVer = parseInt(ua[0, $fX4fx._DYN_SPLIT /* @min:%2esplit */ ]($2b39ccc8637f1ec7$var$strTrident)[1]);
        if (tridentVer) return tridentVer + 4;
    }
    return null;
}
function $2b39ccc8637f1ec7$export$21fce7cbd4dc679f(object) {
    var objectTypeDump = Object[0, $VVkgt.strShimPrototype].toString[0, $fX4fx._DYN_CALL /* @min:%2ecall */ ](object);
    var propertyValueDump = (0, $lxIpo.STR_EMPTY);
    if (objectTypeDump === "[object Error]") propertyValueDump = "{ stack: '" + object.stack + "', message: '" + object.message + "', name: '" + object[0, $fX4fx._DYN_NAME /* @min:%2ename */ ] + "'";
    else if ($2b39ccc8637f1ec7$export$a2856ab6913b9fff()) propertyValueDump = $2b39ccc8637f1ec7$export$d047a7c56db64af4().stringify(object);
    return objectTypeDump + propertyValueDump;
}
function $2b39ccc8637f1ec7$export$95df08bae54cb4df(userAgentStr) {
    if (!userAgentStr || !(0, $erRAP.isString)(userAgentStr)) {
        var navigator_2 = $2b39ccc8637f1ec7$export$a56241c767c1d89f() || {};
        userAgentStr = navigator_2 ? (navigator_2[0, $fX4fx._DYN_USER_AGENT /* @min:%2euserAgent */ ] || (0, $lxIpo.STR_EMPTY))[0, $fX4fx._DYN_TO_LOWER_CASE /* @min:%2etoLowerCase */ ]() : (0, $lxIpo.STR_EMPTY);
    }
    var ua = (userAgentStr || (0, $lxIpo.STR_EMPTY))[0, $fX4fx._DYN_TO_LOWER_CASE /* @min:%2etoLowerCase */ ]();
    return ua[0, $fX4fx._DYN_INDEX_OF /* @min:%2eindexOf */ ]("safari") >= 0;
}
function $2b39ccc8637f1ec7$export$cf496c79c05967a0() {
    if ($2b39ccc8637f1ec7$var$_beaconsSupported === null) $2b39ccc8637f1ec7$var$_beaconsSupported = $2b39ccc8637f1ec7$export$bd82d106260417bf() && Boolean($2b39ccc8637f1ec7$export$a56241c767c1d89f().sendBeacon);
    return $2b39ccc8637f1ec7$var$_beaconsSupported;
}
function $2b39ccc8637f1ec7$export$f8c1c61350d9749(withKeepAlive) {
    var isSupported = false;
    try {
        isSupported = !!$2b39ccc8637f1ec7$export$516e580f5eed5df7("fetch");
        var request = $2b39ccc8637f1ec7$export$516e580f5eed5df7("Request");
        if (isSupported && withKeepAlive && request) isSupported = $2b39ccc8637f1ec7$var$_hasProperty(request, "keepalive");
    } catch (e) {
    // Just Swallow any failure during availability checks
    }
    return isSupported;
}
function $2b39ccc8637f1ec7$export$b9f2bc09e5ac0fa5() {
    if ($2b39ccc8637f1ec7$var$_useXDomainRequest === null) {
        $2b39ccc8637f1ec7$var$_useXDomainRequest = typeof XDomainRequest !== (0, $VVkgt.strShimUndefined);
        if ($2b39ccc8637f1ec7$var$_useXDomainRequest && $2b39ccc8637f1ec7$export$cfeac9aa070f0108()) $2b39ccc8637f1ec7$var$_useXDomainRequest = $2b39ccc8637f1ec7$var$_useXDomainRequest && !$2b39ccc8637f1ec7$var$_hasProperty($2b39ccc8637f1ec7$export$516e580f5eed5df7($2b39ccc8637f1ec7$var$strXMLHttpRequest), "withCredentials");
    }
    return $2b39ccc8637f1ec7$var$_useXDomainRequest;
}
function $2b39ccc8637f1ec7$export$cfeac9aa070f0108() {
    var isSupported = false;
    try {
        var xmlHttpRequest = $2b39ccc8637f1ec7$export$516e580f5eed5df7($2b39ccc8637f1ec7$var$strXMLHttpRequest);
        isSupported = !!xmlHttpRequest;
    } catch (e) {
    // Just Swallow any failure during availability checks
    }
    return isSupported;
}
function $2b39ccc8637f1ec7$var$_getNamedValue(values, name) {
    if (values) for(var i = 0; i < values[0, $fX4fx._DYN_LENGTH /* @min:%2elength */ ]; i++){
        var value = values[i];
        if (value[0, $fX4fx._DYN_NAME /* @min:%2ename */ ]) {
            if (value[0, $fX4fx._DYN_NAME /* @min:%2ename */ ] === name) return value;
        }
    }
    return {};
}
function $2b39ccc8637f1ec7$export$cdb9869d6805c74f(name) {
    var doc = $2b39ccc8637f1ec7$export$f65ca476c09acec0();
    if (doc && name) // Look for a meta-tag
    return $2b39ccc8637f1ec7$var$_getNamedValue(doc.querySelectorAll("meta"), name).content;
    return null;
}
function $2b39ccc8637f1ec7$export$a25efeeb107534e6(name) {
    var value;
    var perf = $2b39ccc8637f1ec7$export$28a0276e10aa78d7();
    if (perf) {
        // Try looking for a server-timing header
        var navPerf = perf.getEntriesByType("navigation") || [];
        value = $2b39ccc8637f1ec7$var$_getNamedValue((navPerf[0, $fX4fx._DYN_LENGTH /* @min:%2elength */ ] > 0 ? navPerf[0] : {}).serverTiming, name).description;
    }
    return value;
}
function $2b39ccc8637f1ec7$export$716a11175c03fb4e(target, evnt) {
    if (target && target.dispatchEvent && evnt) {
        target.dispatchEvent(evnt);
        return true;
    }
    return false;
}
function $2b39ccc8637f1ec7$export$8e16c003644f99f2(eventName, details) {
    var event = null;
    var detail = {
        detail: details || null
    };
    if ((0, $erRAP.isFunction)(CustomEvent)) event = new CustomEvent(eventName, detail);
    else {
        var doc = $2b39ccc8637f1ec7$export$f65ca476c09acec0();
        if (doc && doc.createEvent) {
            event = doc.createEvent("CustomEvent");
            event.initCustomEvent(eventName, true, true, detail);
        }
    }
    return event;
}
function $2b39ccc8637f1ec7$export$af531f0ca2964c96(evtName, cfg, customDetails) {
    var global = (0, $gSD6i.getGlobal)();
    if (global && global.CustomEvent) try {
        var details = {
            cfg: cfg || null,
            customDetails: customDetails || null
        };
        return $2b39ccc8637f1ec7$export$716a11175c03fb4e(global, $2b39ccc8637f1ec7$export$8e16c003644f99f2(evtName, details));
    } catch (e) {
    // eslint-disable-next-line no-empty
    }
    return false;
}

});




parcelRegister("iBAi6", function(module, exports) {

$parcel$export(module.exports, "generateW3CId", function () { return $d8b7d5584386b4a2$export$58d1fad45f39d957; });
$parcel$export(module.exports, "disableCookies", function () { return $d8b7d5584386b4a2$export$62933da51d94d272; });
$parcel$export(module.exports, "canUseCookies", function () { return $d8b7d5584386b4a2$export$304a5ec8c5d7d95; });
$parcel$export(module.exports, "getCookie", function () { return $d8b7d5584386b4a2$export$4be65e66cfa2648a; });
$parcel$export(module.exports, "setCookie", function () { return $d8b7d5584386b4a2$export$110700823644f4a6; });
$parcel$export(module.exports, "deleteCookie", function () { return $d8b7d5584386b4a2$export$b43e45590305ffaa; });
/*
 * Application Insights JavaScript SDK - Core, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $gSD6i = parcelRequire("gSD6i");
var $VVkgt = parcelRequire("VVkgt");

var $fX4fx = parcelRequire("fX4fx");

var $31Ks8 = parcelRequire("31Ks8");

var $3I5zg = parcelRequire("3I5zg");

var $cIC5n = parcelRequire("cIC5n");

var $erRAP = parcelRequire("erRAP");

var $lxIpo = parcelRequire("lxIpo");

var $990ap = parcelRequire("990ap");
"use strict";
var $d8b7d5584386b4a2$var$_cookieMgrs = null;
var $d8b7d5584386b4a2$var$_canUseCookies; // legacy supported config
var $d8b7d5584386b4a2$export$3bac393b8225adab = (0, $VVkgt.strShimUndefined);
function $d8b7d5584386b4a2$export$665eeb3ced5fba0b() {
    var uuid = $d8b7d5584386b4a2$export$58d1fad45f39d957();
    return uuid[0, $fX4fx._DYN_SUBSTRING /* @min:%2esubstring */ ](0, 8) + "-" + uuid[0, $fX4fx._DYN_SUBSTRING /* @min:%2esubstring */ ](8, 12) + "-" + uuid[0, $fX4fx._DYN_SUBSTRING /* @min:%2esubstring */ ](12, 16) + "-" + uuid[0, $fX4fx._DYN_SUBSTRING /* @min:%2esubstring */ ](16, 20) + "-" + uuid[0, $fX4fx._DYN_SUBSTRING /* @min:%2esubstring */ ](20);
}
function $d8b7d5584386b4a2$export$ba2b1ec760f018ed() {
    var perf = (0, $3I5zg.getPerformance)();
    if (perf && perf.now) return perf.now();
    return (0, $erRAP.dateNow)();
}
function $d8b7d5584386b4a2$export$5222b9460f3ddbec(value, search) {
    if (value && search) {
        var len = value[0, $fX4fx._DYN_LENGTH /* @min:%2elength */ ];
        var start = len - search[0, $fX4fx._DYN_LENGTH /* @min:%2elength */ ];
        return value[0, $fX4fx._DYN_SUBSTRING /* @min:%2esubstring */ ](start >= 0 ? start : 0, len) === search;
    }
    return false;
}
function $d8b7d5584386b4a2$export$58d1fad45f39d957() {
    var hexValues = [
        "0",
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "a",
        "b",
        "c",
        "d",
        "e",
        "f"
    ];
    // rfc4122 version 4 UUID without dashes and with lowercase letters
    var oct = (0, $lxIpo.STR_EMPTY), tmp;
    for(var a = 0; a < 4; a++){
        tmp = (0, $990ap.random32)();
        oct += hexValues[tmp & 0xF] + hexValues[tmp >> 4 & 0xF] + hexValues[tmp >> 8 & 0xF] + hexValues[tmp >> 12 & 0xF] + hexValues[tmp >> 16 & 0xF] + hexValues[tmp >> 20 & 0xF] + hexValues[tmp >> 24 & 0xF] + hexValues[tmp >> 28 & 0xF];
    }
    // "Set the two most significant bits (bits 6 and 7) of the clock_seq_hi_and_reserved to zero and one, respectively"
    var clockSequenceHi = hexValues[8 + ((0, $990ap.random32)() & 0x03) | 0];
    return oct[0, $fX4fx._DYN_SUBSTR /* @min:%2esubstr */ ](0, 8) + oct[0, $fX4fx._DYN_SUBSTR /* @min:%2esubstr */ ](9, 4) + "4" + oct[0, $fX4fx._DYN_SUBSTR /* @min:%2esubstr */ ](13, 3) + clockSequenceHi + oct[0, $fX4fx._DYN_SUBSTR /* @min:%2esubstr */ ](16, 3) + oct[0, $fX4fx._DYN_SUBSTR /* @min:%2esubstr */ ](19, 12);
}
var $d8b7d5584386b4a2$export$8e4719d8761024a1 = {
    _canUseCookies: undefined,
    isTypeof: (0, $erRAP.isTypeof),
    isUndefined: (0, $erRAP.isUndefined),
    isNullOrUndefined: (0, $erRAP.isNullOrUndefined),
    hasOwnProperty: (0, $erRAP.hasOwnProperty),
    isFunction: (0, $erRAP.isFunction),
    isObject: (0, $erRAP.isObject),
    isDate: (0, $erRAP.isDate),
    isArray: (0, $erRAP.isArray),
    isError: (0, $erRAP.isError),
    isString: (0, $erRAP.isString),
    isNumber: (0, $erRAP.isNumber),
    isBoolean: (0, $erRAP.isBoolean),
    toISOString: (0, $erRAP.toISOString),
    arrForEach: (0, $erRAP.arrForEach),
    arrIndexOf: (0, $erRAP.arrIndexOf),
    arrMap: (0, $erRAP.arrMap),
    arrReduce: (0, $erRAP.arrReduce),
    strTrim: (0, $erRAP.strTrim),
    objCreate: (0, $gSD6i.objCreateFn),
    objKeys: (0, $erRAP.objKeys),
    objDefineAccessors: (0, $erRAP.objDefineAccessors),
    addEventHandler: (0, $cIC5n.addEventHandler),
    dateNow: (0, $erRAP.dateNow),
    isIE: (0, $3I5zg.isIE),
    disableCookies: $d8b7d5584386b4a2$export$62933da51d94d272,
    newGuid: $d8b7d5584386b4a2$export$665eeb3ced5fba0b,
    perfNow: $d8b7d5584386b4a2$export$ba2b1ec760f018ed,
    newId: (0, $990ap.newId),
    randomValue: (0, $990ap.randomValue),
    random32: (0, $990ap.random32),
    mwcRandomSeed: (0, $990ap.mwcRandomSeed),
    mwcRandom32: (0, $990ap.mwcRandom32),
    generateW3CId: $d8b7d5584386b4a2$export$58d1fad45f39d957
};
var $d8b7d5584386b4a2$var$GuidRegex = /[xy]/g;
var $d8b7d5584386b4a2$export$b75a658845002fd7 = {
    Attach: (0, $cIC5n.attachEvent),
    AttachEvent: (0, $cIC5n.attachEvent),
    Detach: (0, $cIC5n.detachEvent),
    DetachEvent: (0, $cIC5n.detachEvent)
};
function $d8b7d5584386b4a2$export$9e27a47477d3d546(config, logger) {
    var cookieMgr = (0, $31Ks8._gblCookieMgr)(config, logger);
    var legacyCanUseCookies = $d8b7d5584386b4a2$export$8e4719d8761024a1._canUseCookies;
    if ($d8b7d5584386b4a2$var$_cookieMgrs === null) {
        $d8b7d5584386b4a2$var$_cookieMgrs = [];
        $d8b7d5584386b4a2$var$_canUseCookies = legacyCanUseCookies;
        // Dynamically create get/set property accessors for backward compatibility for enabling / disabling cookies
        // this WILL NOT work for ES3 browsers (< IE8)
        (0, $erRAP.objDefineAccessors)($d8b7d5584386b4a2$export$8e4719d8761024a1, "_canUseCookies", function() {
            return $d8b7d5584386b4a2$var$_canUseCookies;
        }, function(value) {
            $d8b7d5584386b4a2$var$_canUseCookies = value;
            (0, $erRAP.arrForEach)($d8b7d5584386b4a2$var$_cookieMgrs, function(mgr) {
                mgr[0, $fX4fx._DYN_SET_ENABLED /* @min:%2esetEnabled */ ](value);
            });
        });
    }
    if ((0, $erRAP.arrIndexOf)($d8b7d5584386b4a2$var$_cookieMgrs, cookieMgr) === -1) $d8b7d5584386b4a2$var$_cookieMgrs[0, $fX4fx._DYN_PUSH /* @min:%2epush */ ](cookieMgr);
    if ((0, $erRAP.isBoolean)(legacyCanUseCookies)) cookieMgr[0, $fX4fx._DYN_SET_ENABLED /* @min:%2esetEnabled */ ](legacyCanUseCookies);
    if ((0, $erRAP.isBoolean)($d8b7d5584386b4a2$var$_canUseCookies)) cookieMgr[0, $fX4fx._DYN_SET_ENABLED /* @min:%2esetEnabled */ ]($d8b7d5584386b4a2$var$_canUseCookies);
    return cookieMgr;
}
function $d8b7d5584386b4a2$export$62933da51d94d272() {
    $d8b7d5584386b4a2$export$9e27a47477d3d546()[0, $fX4fx._DYN_SET_ENABLED /* @min:%2esetEnabled */ ](false);
}
function $d8b7d5584386b4a2$export$304a5ec8c5d7d95(logger) {
    return $d8b7d5584386b4a2$export$9e27a47477d3d546(null, logger).isEnabled();
}
function $d8b7d5584386b4a2$export$4be65e66cfa2648a(logger, name) {
    return $d8b7d5584386b4a2$export$9e27a47477d3d546(null, logger).get(name);
}
function $d8b7d5584386b4a2$export$110700823644f4a6(logger, name, value, domain) {
    $d8b7d5584386b4a2$export$9e27a47477d3d546(null, logger).set(name, value, null, domain);
}
function $d8b7d5584386b4a2$export$b43e45590305ffaa(logger, name) {
    return $d8b7d5584386b4a2$export$9e27a47477d3d546(null, logger).del(name);
}

});
parcelRegister("31Ks8", function(module, exports) {

$parcel$export(module.exports, "_gblCookieMgr", function () { return $23457faba65b6aa6$export$ad5eff295dee5ae1; });
$parcel$export(module.exports, "createCookieMgr", function () { return $23457faba65b6aa6$export$2ae082191ac44e5a; });
$parcel$export(module.exports, "safeGetCookieMgr", function () { return $23457faba65b6aa6$export$76c0b273586c25c7; });
$parcel$export(module.exports, "uaDisallowsSameSiteNone", function () { return $23457faba65b6aa6$export$e44499c7a8a6a268; });
/*
 * Application Insights JavaScript SDK - Core, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $fX4fx = parcelRequire("fX4fx");

var $8z2Gd = parcelRequire("8z2Gd");

var $3I5zg = parcelRequire("3I5zg");

var $erRAP = parcelRequire("erRAP");

var $lxIpo = parcelRequire("lxIpo");
var $23457faba65b6aa6$var$strToGMTString = "toGMTString";
var $23457faba65b6aa6$var$strToUTCString = "toUTCString";
var $23457faba65b6aa6$var$strCookie = "cookie";
var $23457faba65b6aa6$var$strExpires = "expires";
var $23457faba65b6aa6$var$strEnabled = "enabled";
var $23457faba65b6aa6$var$strIsCookieUseDisabled = "isCookieUseDisabled";
var $23457faba65b6aa6$var$strDisableCookiesUsage = "disableCookiesUsage";
var $23457faba65b6aa6$var$strConfigCookieMgr = "_ckMgr";
var $23457faba65b6aa6$var$_supportsCookies = null;
var $23457faba65b6aa6$var$_allowUaSameSite = null;
var $23457faba65b6aa6$var$_parsedCookieValue = null;
var $23457faba65b6aa6$var$_doc = (0, $3I5zg.getDocument)();
var $23457faba65b6aa6$var$_cookieCache = {};
var $23457faba65b6aa6$var$_globalCookieConfig = {};
function $23457faba65b6aa6$export$ad5eff295dee5ae1(config, logger) {
    // Stash the global instance against the BaseCookieMgr class
    var inst = $23457faba65b6aa6$export$2ae082191ac44e5a[$23457faba65b6aa6$var$strConfigCookieMgr] || $23457faba65b6aa6$var$_globalCookieConfig[$23457faba65b6aa6$var$strConfigCookieMgr];
    if (!inst) {
        // Note: not using the getSetValue() helper as that would require always creating a temporary cookieMgr
        // that ultimately is never used
        inst = $23457faba65b6aa6$export$2ae082191ac44e5a[$23457faba65b6aa6$var$strConfigCookieMgr] = $23457faba65b6aa6$export$2ae082191ac44e5a(config, logger);
        $23457faba65b6aa6$var$_globalCookieConfig[$23457faba65b6aa6$var$strConfigCookieMgr] = inst;
    }
    return inst;
}
function $23457faba65b6aa6$var$_isMgrEnabled(cookieMgr) {
    if (cookieMgr) return cookieMgr.isEnabled();
    return true;
}
function $23457faba65b6aa6$var$_createCookieMgrConfig(rootConfig) {
    var cookieMgrCfg = rootConfig[0, $fX4fx._DYN_COOKIE_CFG /* @min:%2ecookieCfg */ ] = rootConfig[0, $fX4fx._DYN_COOKIE_CFG /* @min:%2ecookieCfg */ ] || {};
    // Sets the values from the root config if not already present on the cookieMgrCfg
    (0, $erRAP.setValue)(cookieMgrCfg, "domain", rootConfig.cookieDomain, (0, $erRAP.isNotNullOrUndefined), (0, $erRAP.isNullOrUndefined));
    (0, $erRAP.setValue)(cookieMgrCfg, "path", rootConfig.cookiePath || "/", null, (0, $erRAP.isNullOrUndefined));
    if ((0, $erRAP.isNullOrUndefined)(cookieMgrCfg[$23457faba65b6aa6$var$strEnabled])) {
        // Set the enabled from the provided setting or the legacy root values
        var cookieEnabled = void 0;
        if (!(0, $erRAP.isUndefined)(rootConfig[$23457faba65b6aa6$var$strIsCookieUseDisabled])) cookieEnabled = !rootConfig[$23457faba65b6aa6$var$strIsCookieUseDisabled];
        if (!(0, $erRAP.isUndefined)(rootConfig[$23457faba65b6aa6$var$strDisableCookiesUsage])) cookieEnabled = !rootConfig[$23457faba65b6aa6$var$strDisableCookiesUsage];
        cookieMgrCfg[$23457faba65b6aa6$var$strEnabled] = cookieEnabled;
    }
    return cookieMgrCfg;
}
function $23457faba65b6aa6$var$_isIgnoredCookie(cookieMgrCfg, name) {
    if (name && cookieMgrCfg && (0, $erRAP.isArray)(cookieMgrCfg.ignoreCookies)) return cookieMgrCfg.ignoreCookies[0, $fX4fx._DYN_INDEX_OF /* @min:%2eindexOf */ ](name) !== -1;
    return false;
}
function $23457faba65b6aa6$var$_isBlockedCookie(cookieMgrCfg, name) {
    if (name && cookieMgrCfg && (0, $erRAP.isArray)(cookieMgrCfg.blockedCookies)) {
        if (cookieMgrCfg.blockedCookies[0, $fX4fx._DYN_INDEX_OF /* @min:%2eindexOf */ ](name) !== -1) return true;
    }
    return $23457faba65b6aa6$var$_isIgnoredCookie(cookieMgrCfg, name);
}
function $23457faba65b6aa6$export$76c0b273586c25c7(core, config) {
    var cookieMgr;
    if (core) // Always returns an instance
    cookieMgr = core.getCookieMgr();
    else if (config) {
        var cookieCfg = config[0, $fX4fx._DYN_COOKIE_CFG /* @min:%2ecookieCfg */ ];
        if (cookieCfg[$23457faba65b6aa6$var$strConfigCookieMgr]) cookieMgr = cookieCfg[$23457faba65b6aa6$var$strConfigCookieMgr];
        else cookieMgr = $23457faba65b6aa6$export$2ae082191ac44e5a(config);
    }
    if (!cookieMgr) // Get or initialize the default global (legacy) cookie manager if we couldn't find one
    cookieMgr = $23457faba65b6aa6$export$ad5eff295dee5ae1(config, (core || {})[0, $fX4fx._DYN_LOGGER /* @min:%2elogger */ ]);
    return cookieMgr;
}
function $23457faba65b6aa6$export$2ae082191ac44e5a(rootConfig, logger) {
    var _a;
    var cookieMgrConfig = $23457faba65b6aa6$var$_createCookieMgrConfig(rootConfig || $23457faba65b6aa6$var$_globalCookieConfig);
    var _path = cookieMgrConfig.path || "/";
    var _domain = cookieMgrConfig.domain;
    // Explicitly checking against false, so that setting to undefined will === true
    var _enabled = cookieMgrConfig[$23457faba65b6aa6$var$strEnabled] !== false;
    var cookieMgr = (_a = {
        isEnabled: function() {
            var enabled = _enabled && $23457faba65b6aa6$export$25d06da9c29ef62a(logger);
            // Using an indirect lookup for any global cookie manager to support tree shaking for SDK's
            // that don't use the "applicationinsights-core" version of the default cookie function
            var gblManager = $23457faba65b6aa6$var$_globalCookieConfig[$23457faba65b6aa6$var$strConfigCookieMgr];
            if (enabled && gblManager && cookieMgr !== gblManager) // Make sure the GlobalCookie Manager instance (if not this instance) is also enabled.
            // As the global (deprecated) functions may have been called (for backward compatibility)
            enabled = $23457faba65b6aa6$var$_isMgrEnabled(gblManager);
            return enabled;
        }
    }, _a[0, $fX4fx._DYN_SET_ENABLED /* @min:setEnabled */ ] = function(value) {
        // Explicitly checking against false, so that setting to undefined will === true
        _enabled = value !== false;
    }, _a.set = function(name, value, maxAgeSec, domain, path) {
        var result = false;
        if ($23457faba65b6aa6$var$_isMgrEnabled(cookieMgr) && !$23457faba65b6aa6$var$_isBlockedCookie(cookieMgrConfig, name)) {
            var values = {};
            var theValue = (0, $erRAP.strTrim)(value || (0, $lxIpo.STR_EMPTY));
            var idx = theValue[0, $fX4fx._DYN_INDEX_OF /* @min:%2eindexOf */ ](";");
            if (idx !== -1) {
                theValue = (0, $erRAP.strTrim)(value[0, $fX4fx._DYN_SUBSTRING /* @min:%2esubstring */ ](0, idx));
                values = $23457faba65b6aa6$var$_extractParts(value[0, $fX4fx._DYN_SUBSTRING /* @min:%2esubstring */ ](idx + 1));
            }
            // Only update domain if not already present (isUndefined) and the value is truthy (not null, undefined or empty string)
            (0, $erRAP.setValue)(values, "domain", domain || _domain, (0, $erRAP.isTruthy), (0, $erRAP.isUndefined));
            if (!(0, $erRAP.isNullOrUndefined)(maxAgeSec)) {
                var _isIE = (0, $3I5zg.isIE)();
                if ((0, $erRAP.isUndefined)(values[$23457faba65b6aa6$var$strExpires])) {
                    var nowMs = (0, $erRAP.dateNow)();
                    // Only add expires if not already present
                    var expireMs = nowMs + maxAgeSec * 1000;
                    // Sanity check, if zero or -ve then ignore
                    if (expireMs > 0) {
                        var expiry = new Date();
                        expiry.setTime(expireMs);
                        (0, $erRAP.setValue)(values, $23457faba65b6aa6$var$strExpires, $23457faba65b6aa6$var$_formatDate(expiry, !_isIE ? $23457faba65b6aa6$var$strToUTCString : $23457faba65b6aa6$var$strToGMTString) || $23457faba65b6aa6$var$_formatDate(expiry, _isIE ? $23457faba65b6aa6$var$strToGMTString : $23457faba65b6aa6$var$strToUTCString) || (0, $lxIpo.STR_EMPTY), (0, $erRAP.isTruthy));
                    }
                }
                if (!_isIE) // Only replace if not already present
                (0, $erRAP.setValue)(values, "max-age", (0, $lxIpo.STR_EMPTY) + maxAgeSec, null, (0, $erRAP.isUndefined));
            }
            var location_1 = (0, $3I5zg.getLocation)();
            if (location_1 && location_1.protocol === "https:") {
                (0, $erRAP.setValue)(values, "secure", null, null, (0, $erRAP.isUndefined));
                // Only set same site if not also secure
                if ($23457faba65b6aa6$var$_allowUaSameSite === null) $23457faba65b6aa6$var$_allowUaSameSite = !$23457faba65b6aa6$export$e44499c7a8a6a268(((0, $3I5zg.getNavigator)() || {})[0, $fX4fx._DYN_USER_AGENT /* @min:%2euserAgent */ ]);
                if ($23457faba65b6aa6$var$_allowUaSameSite) (0, $erRAP.setValue)(values, "SameSite", "None", null, (0, $erRAP.isUndefined));
            }
            (0, $erRAP.setValue)(values, "path", path || _path, null, (0, $erRAP.isUndefined));
            var setCookieFn = cookieMgrConfig.setCookie || $23457faba65b6aa6$var$_setCookieValue;
            setCookieFn(name, $23457faba65b6aa6$var$_formatCookieValue(theValue, values));
            result = true;
        }
        return result;
    }, _a.get = function(name) {
        var value = (0, $lxIpo.STR_EMPTY);
        if ($23457faba65b6aa6$var$_isMgrEnabled(cookieMgr) && !$23457faba65b6aa6$var$_isIgnoredCookie(cookieMgrConfig, name)) value = (cookieMgrConfig.getCookie || $23457faba65b6aa6$var$_getCookieValue)(name);
        return value;
    }, _a.del = function(name, path) {
        var result = false;
        if ($23457faba65b6aa6$var$_isMgrEnabled(cookieMgr)) // Only remove the cookie if the manager and cookie support has not been disabled
        result = cookieMgr.purge(name, path);
        return result;
    }, _a.purge = function(name, path) {
        var _a;
        var result = false;
        if ($23457faba65b6aa6$export$25d06da9c29ef62a(logger)) {
            // Setting the expiration date in the past immediately removes the cookie
            var values = (_a = {}, _a["path"] = path ? path : "/", _a[$23457faba65b6aa6$var$strExpires] = "Thu, 01 Jan 1970 00:00:01 GMT", _a);
            if (!(0, $3I5zg.isIE)()) // Set max age to expire now
            values["max-age"] = "0";
            var delCookie = cookieMgrConfig.delCookie || $23457faba65b6aa6$var$_setCookieValue;
            delCookie(name, $23457faba65b6aa6$var$_formatCookieValue((0, $lxIpo.STR_EMPTY), values));
            result = true;
        }
        return result;
    }, _a);
    // Associated this cookie manager with the config
    cookieMgr[$23457faba65b6aa6$var$strConfigCookieMgr] = cookieMgr;
    return cookieMgr;
}
function $23457faba65b6aa6$export$25d06da9c29ef62a(logger) {
    if ($23457faba65b6aa6$var$_supportsCookies === null) {
        $23457faba65b6aa6$var$_supportsCookies = false;
        try {
            var doc = $23457faba65b6aa6$var$_doc || {};
            $23457faba65b6aa6$var$_supportsCookies = doc[$23457faba65b6aa6$var$strCookie] !== undefined;
        } catch (e) {
            (0, $8z2Gd._throwInternal)(logger, 2 /* eLoggingSeverity.WARNING */ , 68 /* _eInternalMessageId.CannotAccessCookie */ , "Cannot access document.cookie - " + (0, $erRAP.getExceptionName)(e), {
                exception: (0, $3I5zg.dumpObj)(e)
            });
        }
    }
    return $23457faba65b6aa6$var$_supportsCookies;
}
function $23457faba65b6aa6$var$_extractParts(theValue) {
    var values = {};
    if (theValue && theValue[0, $fX4fx._DYN_LENGTH /* @min:%2elength */ ]) {
        var parts = (0, $erRAP.strTrim)(theValue)[0, $fX4fx._DYN_SPLIT /* @min:%2esplit */ ](";");
        (0, $erRAP.arrForEach)(parts, function(thePart) {
            thePart = (0, $erRAP.strTrim)(thePart || (0, $lxIpo.STR_EMPTY));
            if (thePart) {
                var idx = thePart[0, $fX4fx._DYN_INDEX_OF /* @min:%2eindexOf */ ]("=");
                if (idx === -1) values[thePart] = null;
                else values[(0, $erRAP.strTrim)(thePart[0, $fX4fx._DYN_SUBSTRING /* @min:%2esubstring */ ](0, idx))] = (0, $erRAP.strTrim)(thePart[0, $fX4fx._DYN_SUBSTRING /* @min:%2esubstring */ ](idx + 1));
            }
        });
    }
    return values;
}
function $23457faba65b6aa6$var$_formatDate(theDate, func) {
    if ((0, $erRAP.isFunction)(theDate[func])) return theDate[func]();
    return null;
}
function $23457faba65b6aa6$var$_formatCookieValue(value, values) {
    var cookieValue = value || (0, $lxIpo.STR_EMPTY);
    (0, $erRAP.objForEachKey)(values, function(name, theValue) {
        cookieValue += "; " + name + (!(0, $erRAP.isNullOrUndefined)(theValue) ? "=" + theValue : (0, $lxIpo.STR_EMPTY));
    });
    return cookieValue;
}
function $23457faba65b6aa6$var$_getCookieValue(name) {
    var cookieValue = (0, $lxIpo.STR_EMPTY);
    if ($23457faba65b6aa6$var$_doc) {
        var theCookie = $23457faba65b6aa6$var$_doc[$23457faba65b6aa6$var$strCookie] || (0, $lxIpo.STR_EMPTY);
        if ($23457faba65b6aa6$var$_parsedCookieValue !== theCookie) {
            $23457faba65b6aa6$var$_cookieCache = $23457faba65b6aa6$var$_extractParts(theCookie);
            $23457faba65b6aa6$var$_parsedCookieValue = theCookie;
        }
        cookieValue = (0, $erRAP.strTrim)($23457faba65b6aa6$var$_cookieCache[name] || (0, $lxIpo.STR_EMPTY));
    }
    return cookieValue;
}
function $23457faba65b6aa6$var$_setCookieValue(name, cookieValue) {
    if ($23457faba65b6aa6$var$_doc) $23457faba65b6aa6$var$_doc[$23457faba65b6aa6$var$strCookie] = name + "=" + cookieValue;
}
function $23457faba65b6aa6$export$e44499c7a8a6a268(userAgent) {
    if (!(0, $erRAP.isString)(userAgent)) return false;
    // Cover all iOS based browsers here. This includes:
    // - Safari on iOS 12 for iPhone, iPod Touch, iPad
    // - WkWebview on iOS 12 for iPhone, iPod Touch, iPad
    // - Chrome on iOS 12 for iPhone, iPod Touch, iPad
    // All of which are broken by SameSite=None, because they use the iOS networking stack
    if ((0, $erRAP.strContains)(userAgent, "CPU iPhone OS 12") || (0, $erRAP.strContains)(userAgent, "iPad; CPU OS 12")) return true;
    // Cover Mac OS X based browsers that use the Mac OS networking stack. This includes:
    // - Safari on Mac OS X
    // This does not include:
    // - Internal browser on Mac OS X
    // - Chrome on Mac OS X
    // - Chromium on Mac OS X
    // Because they do not use the Mac OS networking stack.
    if ((0, $erRAP.strContains)(userAgent, "Macintosh; Intel Mac OS X 10_14") && (0, $erRAP.strContains)(userAgent, "Version/") && (0, $erRAP.strContains)(userAgent, "Safari")) return true;
    // Cover Mac OS X internal browsers that use the Mac OS networking stack. This includes:
    // - Internal browser on Mac OS X
    // This does not include:
    // - Safari on Mac OS X
    // - Chrome on Mac OS X
    // - Chromium on Mac OS X
    // Because they do not use the Mac OS networking stack.
    if ((0, $erRAP.strContains)(userAgent, "Macintosh; Intel Mac OS X 10_14") && (0, $erRAP.strEndsWith)(userAgent, "AppleWebKit/605.1.15 (KHTML, like Gecko)")) return true;
    // Cover Chrome 50-69, because some versions are broken by SameSite=None, and none in this range require it.
    // Note: this covers some pre-Chromium Edge versions, but pre-Chromim Edge does not require SameSite=None, so this is fine.
    // Note: this regex applies to Windows, Mac OS X, and Linux, deliberately.
    if ((0, $erRAP.strContains)(userAgent, "Chrome/5") || (0, $erRAP.strContains)(userAgent, "Chrome/6")) return true;
    // Unreal Engine runs Chromium 59, but does not advertise as Chrome until 4.23. Treat versions of Unreal
    // that don't specify their Chrome version as lacking support for SameSite=None.
    if ((0, $erRAP.strContains)(userAgent, "UnrealEngine") && !(0, $erRAP.strContains)(userAgent, "Chrome")) return true;
    // UCBrowser < 12.13.2 ignores Set-Cookie headers with SameSite=None
    // NB: this rule isn't complete - you need regex to make a complete rule.
    // See: https://www.chromium.org/updates/same-site/incompatible-clients
    if ((0, $erRAP.strContains)(userAgent, "UCBrowser/12") || (0, $erRAP.strContains)(userAgent, "UCBrowser/11")) return true;
    return false;
}

});
parcelRegister("8z2Gd", function(module, exports) {

$parcel$export(module.exports, "_InternalLogMessage", function () { return $63c3abcead67fb28$export$70ef838ed08aad47; });
$parcel$export(module.exports, "safeGetLogger", function () { return $63c3abcead67fb28$export$5102d32ea1d740a; });
$parcel$export(module.exports, "DiagnosticLogger", function () { return $63c3abcead67fb28$export$4f80edb2e10dc14c; });
$parcel$export(module.exports, "_throwInternal", function () { return $63c3abcead67fb28$export$c7ca1fcbf1d310c4; });
$parcel$export(module.exports, "_warnToConsole", function () { return $63c3abcead67fb28$export$25fb4cb97863f0a8; });
$parcel$export(module.exports, "_logInternalMessage", function () { return $63c3abcead67fb28$export$e15fbe42d9bc9d3d; });
/*
 * Application Insights JavaScript SDK - Core, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $kbmky = parcelRequire("kbmky");

var $fX4fx = parcelRequire("fX4fx");

var $hY07A = parcelRequire("hY07A");

var $3I5zg = parcelRequire("3I5zg");

var $erRAP = parcelRequire("erRAP");

var $lxIpo = parcelRequire("lxIpo");
"use strict";
/**
 * For user non actionable traces use AI Internal prefix.
 */ var $63c3abcead67fb28$var$AiNonUserActionablePrefix = "AI (Internal): ";
/**
 * Prefix of the traces in portal.
 */ var $63c3abcead67fb28$var$AiUserActionablePrefix = "AI: ";
/**
 *  Session storage key for the prefix for the key indicating message type already logged
 */ var $63c3abcead67fb28$var$AIInternalMessagePrefix = "AITR_";
function $63c3abcead67fb28$var$_sanitizeDiagnosticText(text) {
    if (text) return '"' + text[0, $fX4fx._DYN_REPLACE /* @min:%2ereplace */ ](/\"/g, (0, $lxIpo.STR_EMPTY)) + '"';
    return 0, $lxIpo.STR_EMPTY;
}
function $63c3abcead67fb28$var$_logToConsole(func, message) {
    var theConsole = (0, $3I5zg.getConsole)();
    if (!!theConsole) {
        var logFunc = "log";
        if (theConsole[func]) logFunc = func;
        if ((0, $erRAP.isFunction)(theConsole[logFunc])) theConsole[logFunc](message);
    }
}
var $63c3abcead67fb28$export$70ef838ed08aad47 = /** @class */ function() {
    function _InternalLogMessage(msgId, msg, isUserAct, properties) {
        if (isUserAct === void 0) isUserAct = false;
        var _self = this;
        _self[0, $fX4fx._DYN_MESSAGE_ID /* @min:%2emessageId */ ] = msgId;
        _self[0, $fX4fx._DYN_MESSAGE /* @min:%2emessage */ ] = (isUserAct ? $63c3abcead67fb28$var$AiUserActionablePrefix : $63c3abcead67fb28$var$AiNonUserActionablePrefix) + msgId;
        var strProps = (0, $lxIpo.STR_EMPTY);
        if ((0, $3I5zg.hasJSON)()) strProps = (0, $3I5zg.getJSON)().stringify(properties);
        var diagnosticText = (msg ? " message:" + $63c3abcead67fb28$var$_sanitizeDiagnosticText(msg) : (0, $lxIpo.STR_EMPTY)) + (properties ? " props:" + $63c3abcead67fb28$var$_sanitizeDiagnosticText(strProps) : (0, $lxIpo.STR_EMPTY));
        _self[0, $fX4fx._DYN_MESSAGE /* @min:%2emessage */ ] += diagnosticText;
    }
    _InternalLogMessage.dataType = "MessageData";
    return _InternalLogMessage;
}();
function $63c3abcead67fb28$export$5102d32ea1d740a(core, config) {
    return (core || {})[0, $fX4fx._DYN_LOGGER /* @min:%2elogger */ ] || new $63c3abcead67fb28$export$4f80edb2e10dc14c(config);
}
var $63c3abcead67fb28$export$4f80edb2e10dc14c = /** @class */ function() {
    function DiagnosticLogger(config) {
        this.identifier = "DiagnosticLogger";
        /**
         * The internal logging queue
         */ this.queue = [];
        /**
         * Count of internal messages sent
         */ var _messageCount = 0;
        /**
         * Holds information about what message types were already logged to console or sent to server.
         */ var _messageLogged = {};
        var _loggingLevelConsole;
        var _loggingLevelTelemetry;
        var _maxInternalMessageLimit;
        var _enableDebug;
        (0, $kbmky.default)(DiagnosticLogger, this, function(_self) {
            _setDefaultsFromConfig(config || {});
            _self.consoleLoggingLevel = function() {
                return _loggingLevelConsole;
            };
            _self.telemetryLoggingLevel = function() {
                return _loggingLevelTelemetry;
            };
            _self.maxInternalMessageLimit = function() {
                return _maxInternalMessageLimit;
            };
            _self[0, $fX4fx._DYN_ENABLE_DEBUG_EXCEPTI4 /* @min:%2eenableDebugExceptions */ ] = function() {
                return _enableDebug;
            };
            /**
             * This method will throw exceptions in debug mode or attempt to log the error as a console warning.
             * @param severity {LoggingSeverity} - The severity of the log message
             * @param message {_InternalLogMessage} - The log message.
             */ _self.throwInternal = function(severity, msgId, msg, properties, isUserAct) {
                if (isUserAct === void 0) isUserAct = false;
                var message = new $63c3abcead67fb28$export$70ef838ed08aad47(msgId, msg, isUserAct, properties);
                if (_enableDebug) throw (0, $3I5zg.dumpObj)(message);
                else {
                    // Get the logging function and fallback to warnToConsole of for some reason errorToConsole doesn't exist
                    var logFunc = severity === 1 /* eLoggingSeverity.CRITICAL */  ? (0, $lxIpo.STR_ERROR_TO_CONSOLE) : (0, $lxIpo.STR_WARN_TO_CONSOLE);
                    if (!(0, $erRAP.isUndefined)(message[0, $fX4fx._DYN_MESSAGE /* @min:%2emessage */ ])) {
                        if (isUserAct) {
                            // check if this message type was already logged to console for this page view and if so, don't log it again
                            var messageKey = +message[0, $fX4fx._DYN_MESSAGE_ID /* @min:%2emessageId */ ];
                            if (!_messageLogged[messageKey] && _loggingLevelConsole >= severity) {
                                _self[logFunc](message[0, $fX4fx._DYN_MESSAGE /* @min:%2emessage */ ]);
                                _messageLogged[messageKey] = true;
                            }
                        } else // Only log traces if the console Logging Level is >= the throwInternal severity level
                        if (_loggingLevelConsole >= severity) _self[logFunc](message[0, $fX4fx._DYN_MESSAGE /* @min:%2emessage */ ]);
                        _logInternalMessage(severity, message);
                    } else _debugExtMsg("throw" + (severity === 1 /* eLoggingSeverity.CRITICAL */  ? "Critical" : "Warning"), message);
                }
            };
            /**
             * This will write a warning to the console if possible
             * @param message {string} - The warning message
             */ _self[0, $lxIpo.STR_WARN_TO_CONSOLE /* @min:%2ewarnToConsole */ ] = function(message) {
                $63c3abcead67fb28$var$_logToConsole("warn", message);
                _debugExtMsg("warning", message);
            };
            /**
             * This will write an error to the console if possible
             * @param message {string} - The error message
             */ _self[0, $lxIpo.STR_ERROR_TO_CONSOLE /* @min:%2eerrorToConsole */ ] = function(message) {
                $63c3abcead67fb28$var$_logToConsole("error", message);
                _debugExtMsg("error", message);
            };
            /**
             * Resets the internal message count
             */ _self.resetInternalMessageCount = function() {
                _messageCount = 0;
                _messageLogged = {};
            };
            /**
             * Logs a message to the internal queue.
             * @param severity {LoggingSeverity} - The severity of the log message
             * @param message {_InternalLogMessage} - The message to log.
             */ _self[0, $fX4fx._DYN_LOG_INTERNAL_MESSAGE /* @min:%2elogInternalMessage */ ] = _logInternalMessage;
            function _logInternalMessage(severity, message) {
                if (_areInternalMessagesThrottled()) return;
                // check if this message type was already logged for this session and if so, don't log it again
                var logMessage = true;
                var messageKey = $63c3abcead67fb28$var$AIInternalMessagePrefix + message[0, $fX4fx._DYN_MESSAGE_ID /* @min:%2emessageId */ ];
                // if the session storage is not available, limit to only one message type per page view
                if (_messageLogged[messageKey]) logMessage = false;
                else _messageLogged[messageKey] = true;
                if (logMessage) {
                    // Push the event in the internal queue
                    if (severity <= _loggingLevelTelemetry) {
                        _self.queue[0, $fX4fx._DYN_PUSH /* @min:%2epush */ ](message);
                        _messageCount++;
                        _debugExtMsg(severity === 1 /* eLoggingSeverity.CRITICAL */  ? "error" : "warn", message);
                    }
                    // When throttle limit reached, send a special event
                    if (_messageCount === _maxInternalMessageLimit) {
                        var throttleLimitMessage = "Internal events throttle limit per PageView reached for this app.";
                        var throttleMessage = new $63c3abcead67fb28$export$70ef838ed08aad47(23 /* _eInternalMessageId.MessageLimitPerPVExceeded */ , throttleLimitMessage, false);
                        _self.queue[0, $fX4fx._DYN_PUSH /* @min:%2epush */ ](throttleMessage);
                        if (severity === 1 /* eLoggingSeverity.CRITICAL */ ) _self[0, $lxIpo.STR_ERROR_TO_CONSOLE /* @min:%2eerrorToConsole */ ](throttleLimitMessage);
                        else _self[0, $lxIpo.STR_WARN_TO_CONSOLE /* @min:%2ewarnToConsole */ ](throttleLimitMessage);
                    }
                }
            }
            function _setDefaultsFromConfig(config) {
                _loggingLevelConsole = (0, $erRAP.getCfgValue)(config.loggingLevelConsole, 0);
                _loggingLevelTelemetry = (0, $erRAP.getCfgValue)(config.loggingLevelTelemetry, 1);
                _maxInternalMessageLimit = (0, $erRAP.getCfgValue)(config.maxMessageLimit, 25);
                _enableDebug = (0, $erRAP.getCfgValue)(config.enableDebug, (0, $erRAP.getCfgValue)(config[0, $fX4fx._DYN_ENABLE_DEBUG_EXCEPTI4 /* @min:%2eenableDebugExceptions */ ], false));
            }
            function _areInternalMessagesThrottled() {
                return _messageCount >= _maxInternalMessageLimit;
            }
            function _debugExtMsg(name, data) {
                var dbgExt = (0, $hY07A.getDebugExt)(config || {});
                if (dbgExt && dbgExt[0, $fX4fx._DYN_DIAG_LOG /* @min:%2ediagLog */ ]) dbgExt[0, $fX4fx._DYN_DIAG_LOG /* @min:%2ediagLog */ ](name, data);
            }
        });
    }
    // Removed Stub for DiagnosticLogger.prototype.enableDebugExceptions.
    // Removed Stub for DiagnosticLogger.prototype.consoleLoggingLevel.
    // Removed Stub for DiagnosticLogger.prototype.telemetryLoggingLevel.
    // Removed Stub for DiagnosticLogger.prototype.maxInternalMessageLimit.
    // Removed Stub for DiagnosticLogger.prototype.throwInternal.
    // Removed Stub for DiagnosticLogger.prototype.warnToConsole.
    // Removed Stub for DiagnosticLogger.prototype.errorToConsole.
    // Removed Stub for DiagnosticLogger.prototype.resetInternalMessageCount.
    // Removed Stub for DiagnosticLogger.prototype.logInternalMessage.
    // This is a workaround for an IE8 bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    // this will be removed when ES3 support is dropped.
    DiagnosticLogger.__ieDyn = 1;
    return DiagnosticLogger;
}();
function $63c3abcead67fb28$var$_getLogger(logger) {
    return logger || new $63c3abcead67fb28$export$4f80edb2e10dc14c();
}
function $63c3abcead67fb28$export$c7ca1fcbf1d310c4(logger, severity, msgId, msg, properties, isUserAct) {
    if (isUserAct === void 0) isUserAct = false;
    $63c3abcead67fb28$var$_getLogger(logger).throwInternal(severity, msgId, msg, properties, isUserAct);
}
function $63c3abcead67fb28$export$25fb4cb97863f0a8(logger, message) {
    $63c3abcead67fb28$var$_getLogger(logger)[0, $lxIpo.STR_WARN_TO_CONSOLE /* @min:%2ewarnToConsole */ ](message);
}
function $63c3abcead67fb28$export$e15fbe42d9bc9d3d(logger, severity, message) {
    $63c3abcead67fb28$var$_getLogger(logger)[0, $fX4fx._DYN_LOG_INTERNAL_MESSAGE /* @min:%2elogInternalMessage */ ](severity, message);
}

});
parcelRegister("hY07A", function(module, exports) {

$parcel$export(module.exports, "getDebugExt", function () { return $d1482259b3c6926d$export$a0b1f407ae6b45dc; });
$parcel$export(module.exports, "getDebugListener", function () { return $d1482259b3c6926d$export$dae5ac50a0df0f5f; });
/*
 * Application Insights JavaScript SDK - Core, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $fX4fx = parcelRequire("fX4fx");

var $3I5zg = parcelRequire("3I5zg");
var $d1482259b3c6926d$var$listenerFuncs = [
    "eventsSent",
    "eventsDiscarded",
    "eventsSendRequest",
    "perfEvent"
];
var $d1482259b3c6926d$var$_aiNamespace = null;
var $d1482259b3c6926d$var$_debugListener;
function $d1482259b3c6926d$var$_listenerProxyFunc(name, config) {
    return function() {
        var args = arguments;
        var dbgExt = $d1482259b3c6926d$export$a0b1f407ae6b45dc(config);
        if (dbgExt) {
            var listener = dbgExt.listener;
            if (listener && listener[name]) listener[name][0, $fX4fx._DYN_APPLY /* @min:%2eapply */ ](listener, args);
        }
    };
}
function $d1482259b3c6926d$var$_getExtensionNamespace() {
    // Cache the lookup of the global namespace object
    var target = (0, $3I5zg.getGlobalInst)("Microsoft");
    if (target) $d1482259b3c6926d$var$_aiNamespace = target["ApplicationInsights"];
    return $d1482259b3c6926d$var$_aiNamespace;
}
function $d1482259b3c6926d$export$a0b1f407ae6b45dc(config) {
    var ns = $d1482259b3c6926d$var$_aiNamespace;
    if (!ns && config.disableDbgExt !== true) ns = $d1482259b3c6926d$var$_aiNamespace || $d1482259b3c6926d$var$_getExtensionNamespace();
    return ns ? ns["ChromeDbgExt"] : null;
}
function $d1482259b3c6926d$export$dae5ac50a0df0f5f(config) {
    if (!$d1482259b3c6926d$var$_debugListener) {
        $d1482259b3c6926d$var$_debugListener = {};
        for(var lp = 0; lp < $d1482259b3c6926d$var$listenerFuncs[0, $fX4fx._DYN_LENGTH /* @min:%2elength */ ]; lp++)$d1482259b3c6926d$var$_debugListener[$d1482259b3c6926d$var$listenerFuncs[lp]] = $d1482259b3c6926d$var$_listenerProxyFunc($d1482259b3c6926d$var$listenerFuncs[lp], config);
    }
    return $d1482259b3c6926d$var$_debugListener;
}

});




parcelRegister("jqfZe", function(module, exports) {

$parcel$export(module.exports, "createTraceParent", function () { return $e23cd8a605640f65$export$2f21fe23413fe96b; });
$parcel$export(module.exports, "isValidTraceId", function () { return $e23cd8a605640f65$export$29dd34cf1269f6da; });
$parcel$export(module.exports, "isValidSpanId", function () { return $e23cd8a605640f65$export$8e51c6d8f0586aff; });
$parcel$export(module.exports, "formatTraceParent", function () { return $e23cd8a605640f65$export$55f8c39d2c902d0d; });
/*
 * Application Insights JavaScript SDK - Core, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $fX4fx = parcelRequire("fX4fx");

var $iBAi6 = parcelRequire("iBAi6");

var $3I5zg = parcelRequire("3I5zg");

var $erRAP = parcelRequire("erRAP");

var $lxIpo = parcelRequire("lxIpo");
// using {0,16} for leading and trailing whitespace just to constrain the possible runtime of a random string
var $e23cd8a605640f65$var$TRACE_PARENT_REGEX = /^([\da-f]{2})-([\da-f]{32})-([\da-f]{16})-([\da-f]{2})(-[^\s]{1,64})?$/i;
var $e23cd8a605640f65$var$DEFAULT_VERSION = "00";
var $e23cd8a605640f65$var$INVALID_VERSION = "ff";
var $e23cd8a605640f65$var$INVALID_TRACE_ID = "00000000000000000000000000000000";
var $e23cd8a605640f65$var$INVALID_SPAN_ID = "0000000000000000";
var $e23cd8a605640f65$var$SAMPLED_FLAG = 0x01;
function $e23cd8a605640f65$var$_isValid(value, len, invalidValue) {
    if (value && value[0, $fX4fx._DYN_LENGTH /* @min:%2elength */ ] === len && value !== invalidValue) return !!value.match(/^[\da-f]*$/i);
    return false;
}
function $e23cd8a605640f65$var$_formatValue(value, len, defValue) {
    if ($e23cd8a605640f65$var$_isValid(value, len)) return value;
    return defValue;
}
function $e23cd8a605640f65$var$_formatFlags(value) {
    if (isNaN(value) || value < 0 || value > 255) value = 0x01;
    var result = value.toString(16);
    while(result[0, $fX4fx._DYN_LENGTH /* @min:%2elength */ ] < 2)result = "0" + result;
    return result;
}
function $e23cd8a605640f65$export$2f21fe23413fe96b(traceId, spanId, flags, version) {
    var _a;
    return _a = {}, _a[0, $fX4fx._DYN_VERSION /* @min:version */ ] = $e23cd8a605640f65$var$_isValid(version, 2, $e23cd8a605640f65$var$INVALID_VERSION) ? version : $e23cd8a605640f65$var$DEFAULT_VERSION, _a[0, $fX4fx._DYN_TRACE_ID /* @min:traceId */ ] = $e23cd8a605640f65$export$29dd34cf1269f6da(traceId) ? traceId : (0, $iBAi6.generateW3CId)(), _a.spanId = $e23cd8a605640f65$export$8e51c6d8f0586aff(spanId) ? spanId : (0, $iBAi6.generateW3CId)()[0, $fX4fx._DYN_SUBSTR /* @min:%2esubstr */ ](0, 16), _a.traceFlags = flags >= 0 && flags <= 0xFF ? flags : 1, _a;
}
function $e23cd8a605640f65$export$f4d87f8901a93f5d(value, selectIdx) {
    var _a;
    if (!value) // Don't pass a null/undefined or empty string
    return null;
    if ((0, $erRAP.isArray)(value)) // The value may have been encoded on the page into an array so handle this automatically
    value = value[0] || "";
    if (!value || !(0, $erRAP.isString)(value) || value[0, $fX4fx._DYN_LENGTH /* @min:%2elength */ ] > 8192) // limit potential processing based on total length
    return null;
    if (value[0, $fX4fx._DYN_INDEX_OF /* @min:%2eindexOf */ ](",") !== -1) {
        var values = value[0, $fX4fx._DYN_SPLIT /* @min:%2esplit */ ](",");
        value = values[selectIdx > 0 && values[0, $fX4fx._DYN_LENGTH /* @min:%2elength */ ] > selectIdx ? selectIdx : 0];
    }
    // See https://www.w3.org/TR/trace-context/#versioning-of-traceparent
    var match = $e23cd8a605640f65$var$TRACE_PARENT_REGEX.exec((0, $erRAP.strTrim)(value));
    if (!match || // No match
    match[1] === $e23cd8a605640f65$var$INVALID_VERSION || // version ff is forbidden
    match[2] === $e23cd8a605640f65$var$INVALID_TRACE_ID || // All zeros is considered to be invalid
    match[3] === $e23cd8a605640f65$var$INVALID_SPAN_ID) return null;
    return _a = {
        version: (match[1] || (0, $lxIpo.STR_EMPTY))[0, $fX4fx._DYN_TO_LOWER_CASE /* @min:%2etoLowerCase */ ](),
        traceId: (match[2] || (0, $lxIpo.STR_EMPTY))[0, $fX4fx._DYN_TO_LOWER_CASE /* @min:%2etoLowerCase */ ](),
        spanId: (match[3] || (0, $lxIpo.STR_EMPTY))[0, $fX4fx._DYN_TO_LOWER_CASE /* @min:%2etoLowerCase */ ]()
    }, _a[0, $fX4fx._DYN_TRACE_FLAGS /* @min:traceFlags */ ] = parseInt(match[4], 16), _a;
}
function $e23cd8a605640f65$export$29dd34cf1269f6da(value) {
    return $e23cd8a605640f65$var$_isValid(value, 32, $e23cd8a605640f65$var$INVALID_TRACE_ID);
}
function $e23cd8a605640f65$export$8e51c6d8f0586aff(value) {
    return $e23cd8a605640f65$var$_isValid(value, 16, $e23cd8a605640f65$var$INVALID_SPAN_ID);
}
function $e23cd8a605640f65$export$a210ed246a03bbf(value) {
    if (!value || !$e23cd8a605640f65$var$_isValid(value[0, $fX4fx._DYN_VERSION /* @min:%2eversion */ ], 2, $e23cd8a605640f65$var$INVALID_VERSION) || !$e23cd8a605640f65$var$_isValid(value[0, $fX4fx._DYN_TRACE_ID /* @min:%2etraceId */ ], 32, $e23cd8a605640f65$var$INVALID_TRACE_ID) || !$e23cd8a605640f65$var$_isValid(value[0, $fX4fx._DYN_SPAN_ID /* @min:%2espanId */ ], 16, $e23cd8a605640f65$var$INVALID_SPAN_ID) || !$e23cd8a605640f65$var$_isValid($e23cd8a605640f65$var$_formatFlags(value[0, $fX4fx._DYN_TRACE_FLAGS /* @min:%2etraceFlags */ ]), 2)) // Each known field must contain a valid value
    return false;
    return true;
}
function $e23cd8a605640f65$export$8577d514cd55191e(value) {
    if ($e23cd8a605640f65$export$a210ed246a03bbf(value)) return (value[0, $fX4fx._DYN_TRACE_FLAGS /* @min:%2etraceFlags */ ] & $e23cd8a605640f65$var$SAMPLED_FLAG) === $e23cd8a605640f65$var$SAMPLED_FLAG;
    return false;
}
function $e23cd8a605640f65$export$55f8c39d2c902d0d(value) {
    if (value) {
        // Special Note: This only supports formatting as version 00, future versions should encode any known supported version
        // So parsing a future version will populate the correct version value but reformatting will reduce it to version 00.
        var flags = $e23cd8a605640f65$var$_formatFlags(value[0, $fX4fx._DYN_TRACE_FLAGS /* @min:%2etraceFlags */ ]);
        if (!$e23cd8a605640f65$var$_isValid(flags, 2)) flags = "01";
        var version = value[0, $fX4fx._DYN_VERSION /* @min:%2eversion */ ] || $e23cd8a605640f65$var$DEFAULT_VERSION;
        if (version !== "00" && version !== "ff") // Reduce version to "00"
        version = $e23cd8a605640f65$var$DEFAULT_VERSION;
        // Format as version 00
        return "".concat(version.toLowerCase(), "-").concat($e23cd8a605640f65$var$_formatValue(value.traceId, 32, $e23cd8a605640f65$var$INVALID_TRACE_ID).toLowerCase(), "-").concat($e23cd8a605640f65$var$_formatValue(value.spanId, 16, $e23cd8a605640f65$var$INVALID_SPAN_ID).toLowerCase(), "-").concat(flags.toLowerCase());
    }
    return "";
}
function $e23cd8a605640f65$export$2a00dfdbe257ef74(selectIdx) {
    var name = "traceparent";
    var traceParent = $e23cd8a605640f65$export$f4d87f8901a93f5d((0, $3I5zg.findMetaTag)(name), selectIdx);
    if (!traceParent) traceParent = $e23cd8a605640f65$export$f4d87f8901a93f5d((0, $3I5zg.findNamedServerTiming)(name), selectIdx);
    return traceParent;
}

});

parcelRegister("dCW8D", function(module, exports) {

$parcel$export(module.exports, "DisabledPropertyName", function () { return $9ebbec0529d4783e$export$7c6abff2f2bdd9c0; });
$parcel$export(module.exports, "SampleRate", function () { return $9ebbec0529d4783e$export$dc288b6444e20c04; });
$parcel$export(module.exports, "ProcessLegacy", function () { return $9ebbec0529d4783e$export$ea8a69bf327def66; });
$parcel$export(module.exports, "HttpMethod", function () { return $9ebbec0529d4783e$export$8343e6f32f5246de; });
$parcel$export(module.exports, "DEFAULT_BREEZE_ENDPOINT", function () { return $9ebbec0529d4783e$export$5c9ec0fce655ebcf; });
$parcel$export(module.exports, "DEFAULT_BREEZE_PATH", function () { return $9ebbec0529d4783e$export$e6c0f3431c6cd728; });
$parcel$export(module.exports, "strNotSpecified", function () { return $9ebbec0529d4783e$export$4003f5e1672d759; });
$parcel$export(module.exports, "strIkey", function () { return $9ebbec0529d4783e$export$7d566319b90dbb26; });
/*
 * Application Insights JavaScript SDK - Common, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ /**
 * This is an internal property used to cause internal (reporting) requests to be ignored from reporting
 * additional telemetry, to handle polyfil implementations ALL urls used with a disabled request will
 * also be ignored for future requests even when this property is not provided.
 * Tagging as Ignore as this is an internal value and is not expected to be used outside of the SDK
 * @ignore
 */ var $9ebbec0529d4783e$export$7c6abff2f2bdd9c0 = "Microsoft_ApplicationInsights_BypassAjaxInstrumentation";
var $9ebbec0529d4783e$export$dc288b6444e20c04 = "sampleRate";
var $9ebbec0529d4783e$export$ea8a69bf327def66 = "ProcessLegacy";
var $9ebbec0529d4783e$export$8343e6f32f5246de = "http.method";
var $9ebbec0529d4783e$export$5c9ec0fce655ebcf = "https://dc.services.visualstudio.com";
var $9ebbec0529d4783e$export$e6c0f3431c6cd728 = "/v2/track";
var $9ebbec0529d4783e$export$4003f5e1672d759 = "not_specified";
var $9ebbec0529d4783e$export$7d566319b90dbb26 = "iKey";

});

parcelRegister("4AhFx", function(module, exports) {

$parcel$export(module.exports, "createDomEvent", function () { return $35683ae73cbd14f1$export$58aa8b47bf337bc8; });
/*
 * Application Insights JavaScript SDK - Common, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $3I5zg = parcelRequire("3I5zg");
var $erRAP = parcelRequire("erRAP");
function $35683ae73cbd14f1$export$58aa8b47bf337bc8(eventName) {
    var event = null;
    if ((0, $erRAP.isFunction)(Event)) event = new Event(eventName);
    else {
        var doc = (0, $3I5zg.getDocument)();
        if (doc && doc.createEvent) {
            event = doc.createEvent("Event");
            event.initEvent(eventName, true, true);
        }
    }
    return event;
}

});

parcelRegister("6Gvon", function(module, exports) {

$parcel$export(module.exports, "stringToBoolOrDefault", function () { return $4ddf042cf229f601$export$4e47185aa280358c; });
$parcel$export(module.exports, "msToTimeSpan", function () { return $4ddf042cf229f601$export$4460ed97e7c4a927; });
$parcel$export(module.exports, "getExtensionByName", function () { return $4ddf042cf229f601$export$80a37ba429dff231; });
$parcel$export(module.exports, "isCrossOriginError", function () { return $4ddf042cf229f601$export$8c465f5f14327ccd; });
/*
 * Application Insights JavaScript SDK - Common, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $erRAP = parcelRequire("erRAP");

var $9udGf = parcelRequire("9udGf");
var $4ddf042cf229f601$var$strEmpty = "";
function $4ddf042cf229f601$export$4e47185aa280358c(str, defaultValue) {
    if (defaultValue === void 0) defaultValue = false;
    if (str === undefined || str === null) return defaultValue;
    return str.toString()[0, $9udGf._DYN_TO_LOWER_CASE /* @min:%2etoLowerCase */ ]() === "true";
}
function $4ddf042cf229f601$export$4460ed97e7c4a927(totalms) {
    if (isNaN(totalms) || totalms < 0) totalms = 0;
    totalms = Math.round(totalms);
    var ms = $4ddf042cf229f601$var$strEmpty + totalms % 1000;
    var sec = $4ddf042cf229f601$var$strEmpty + Math.floor(totalms / 1000) % 60;
    var min = $4ddf042cf229f601$var$strEmpty + Math.floor(totalms / 60000) % 60;
    var hour = $4ddf042cf229f601$var$strEmpty + Math.floor(totalms / 3600000) % 24;
    var days = Math.floor(totalms / 86400000);
    ms = ms[0, $9udGf._DYN_LENGTH /* @min:%2elength */ ] === 1 ? "00" + ms : ms[0, $9udGf._DYN_LENGTH /* @min:%2elength */ ] === 2 ? "0" + ms : ms;
    sec = sec[0, $9udGf._DYN_LENGTH /* @min:%2elength */ ] < 2 ? "0" + sec : sec;
    min = min[0, $9udGf._DYN_LENGTH /* @min:%2elength */ ] < 2 ? "0" + min : min;
    hour = hour[0, $9udGf._DYN_LENGTH /* @min:%2elength */ ] < 2 ? "0" + hour : hour;
    return (days > 0 ? days + "." : $4ddf042cf229f601$var$strEmpty) + hour + ":" + min + ":" + sec + "." + ms;
}
function $4ddf042cf229f601$export$80a37ba429dff231(extensions, identifier) {
    var extension = null;
    (0, $erRAP.arrForEach)(extensions, function(value) {
        if (value.identifier === identifier) {
            extension = value;
            return -1;
        }
    });
    return extension;
}
function $4ddf042cf229f601$export$8c465f5f14327ccd(message, url, lineNumber, columnNumber, error) {
    return !error && (0, $erRAP.isString)(message) && (message === "Script error." || message === "Script error");
}

});
parcelRegister("9udGf", function(module, exports) {

$parcel$export(module.exports, "_DYN_SPLIT", function () { return $6e818707c85bbc57$export$b889f1d4cb07c706; });
$parcel$export(module.exports, "_DYN_LENGTH", function () { return $6e818707c85bbc57$export$6eae51590aaea43; });
$parcel$export(module.exports, "_DYN_TO_LOWER_CASE", function () { return $6e818707c85bbc57$export$e4eaee9e01d9baaa; });
$parcel$export(module.exports, "_DYN_INGESTIONENDPOINT", function () { return $6e818707c85bbc57$export$3960f2eafedb8f1; });
$parcel$export(module.exports, "_DYN_TO_STRING", function () { return $6e818707c85bbc57$export$e2818d11505fa034; });
$parcel$export(module.exports, "_DYN_REMOVE_ITEM", function () { return $6e818707c85bbc57$export$596e0e0dc14a1e9b; });
$parcel$export(module.exports, "_DYN_NAME", function () { return $6e818707c85bbc57$export$9734b0a24bf02e93; });
$parcel$export(module.exports, "_DYN_MESSAGE", function () { return $6e818707c85bbc57$export$923606b70907833e; });
$parcel$export(module.exports, "_DYN_COUNT", function () { return $6e818707c85bbc57$export$e9679ef501b0d1; });
$parcel$export(module.exports, "_DYN_STRINGIFY", function () { return $6e818707c85bbc57$export$a318a8141fc98747; });
$parcel$export(module.exports, "_DYN_PATHNAME", function () { return $6e818707c85bbc57$export$34ec22d747521ad; });
$parcel$export(module.exports, "_DYN_CORRELATION_HEADER_E0", function () { return $6e818707c85bbc57$export$89ce3552c03e8ec9; });
$parcel$export(module.exports, "_DYN_INDEX_OF", function () { return $6e818707c85bbc57$export$a3d3f936db372b4b; });
$parcel$export(module.exports, "_DYN_EXTENSION_CONFIG", function () { return $6e818707c85bbc57$export$e298802ab42a3b7f; });
$parcel$export(module.exports, "_DYN_EXCEPTIONS", function () { return $6e818707c85bbc57$export$967696d490ed5a4a; });
$parcel$export(module.exports, "_DYN_PARSED_STACK", function () { return $6e818707c85bbc57$export$4b848bcab7cafe5d; });
$parcel$export(module.exports, "_DYN_PROPERTIES", function () { return $6e818707c85bbc57$export$14814e6f9bf337b4; });
$parcel$export(module.exports, "_DYN_MEASUREMENTS", function () { return $6e818707c85bbc57$export$32fc64677eb5b7a2; });
$parcel$export(module.exports, "_DYN_SIZE_IN_BYTES", function () { return $6e818707c85bbc57$export$59a1581bc81a9aae; });
$parcel$export(module.exports, "_DYN_TYPE_NAME", function () { return $6e818707c85bbc57$export$6008dba8ea08a587; });
$parcel$export(module.exports, "_DYN_SEVERITY_LEVEL", function () { return $6e818707c85bbc57$export$2675b0014c60aa10; });
$parcel$export(module.exports, "_DYN_PROBLEM_GROUP", function () { return $6e818707c85bbc57$export$5bc84cbcfe97e161; });
$parcel$export(module.exports, "_DYN_IS_MANUAL", function () { return $6e818707c85bbc57$export$880f71e9a894c474; });
$parcel$export(module.exports, "_DYN__CREATE_FROM_INTERFA1", function () { return $6e818707c85bbc57$export$aadef743ee7d1db8; });
$parcel$export(module.exports, "_DYN_ASSEMBLY", function () { return $6e818707c85bbc57$export$7e3ee7b01672f321; });
$parcel$export(module.exports, "_DYN_FILE_NAME", function () { return $6e818707c85bbc57$export$8ea03ef8a4bcfeeb; });
$parcel$export(module.exports, "_DYN_HAS_FULL_STACK", function () { return $6e818707c85bbc57$export$b1b7551538b2085; });
$parcel$export(module.exports, "_DYN_LEVEL", function () { return $6e818707c85bbc57$export$25f3022e0cda8855; });
$parcel$export(module.exports, "_DYN_METHOD", function () { return $6e818707c85bbc57$export$47d30bd816d62bdc; });
$parcel$export(module.exports, "_DYN_LINE", function () { return $6e818707c85bbc57$export$138215f6c1f0eedf; });
$parcel$export(module.exports, "_DYN_DURATION", function () { return $6e818707c85bbc57$export$aa395e58f404db90; });
$parcel$export(module.exports, "_DYN_RECEIVED_RESPONSE", function () { return $6e818707c85bbc57$export$e046465ee502552; });
$parcel$export(module.exports, "_DYN_SUBSTRING", function () { return $6e818707c85bbc57$export$20dce058fdd3c573; });
$parcel$export(module.exports, "_DYN_SANITIZE_KEY_AND_ADD2", function () { return $6e818707c85bbc57$export$3e2d26f886f27705; });
$parcel$export(module.exports, "_DYN_SANITIZE_EXCEPTION", function () { return $6e818707c85bbc57$export$d41b8d8cb03ef566; });
$parcel$export(module.exports, "_DYN_SANITIZE_PROPERTIES", function () { return $6e818707c85bbc57$export$f3c9f4fd45ed1e80; });
$parcel$export(module.exports, "_DYN_SANITIZE_MEASUREMENT3", function () { return $6e818707c85bbc57$export$914f75e18f2d539f; });
/*
 * Application Insights JavaScript SDK - Common, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ // @skip-file-minify
// ##############################################################
// AUTO GENERATED FILE: This file is Auto Generated during build.
// ##############################################################
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// Note: DON'T Export these const from the package as we are still targeting ES3 this will export a mutable variables that someone could change!!!
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
var $6e818707c85bbc57$export$b889f1d4cb07c706 = "split"; // Count: 6
var $6e818707c85bbc57$export$6eae51590aaea43 = "length"; // Count: 41
var $6e818707c85bbc57$export$e4eaee9e01d9baaa = "toLowerCase"; // Count: 6
var $6e818707c85bbc57$export$3960f2eafedb8f1 = "ingestionendpoint"; // Count: 6
var $6e818707c85bbc57$export$e2818d11505fa034 = "toString"; // Count: 12
var $6e818707c85bbc57$export$596e0e0dc14a1e9b = "removeItem"; // Count: 3
var $6e818707c85bbc57$export$9734b0a24bf02e93 = "name"; // Count: 11
var $6e818707c85bbc57$export$923606b70907833e = "message"; // Count: 10
var $6e818707c85bbc57$export$e9679ef501b0d1 = "count"; // Count: 8
var $6e818707c85bbc57$export$89a9ed6e0f1c703a = "preTriggerDate"; // Count: 4
var $6e818707c85bbc57$export$bf48f5cc9167f468 = "disabled"; // Count: 3
var $6e818707c85bbc57$export$67d4e5d95e63e1b3 = "interval"; // Count: 3
var $6e818707c85bbc57$export$ffc8d7f1d37c54ec = "daysOfMonth"; // Count: 3
var $6e818707c85bbc57$export$abbddaba4ad71f38 = "date"; // Count: 5
var $6e818707c85bbc57$export$44cd8e854cee592d = "getUTCDate"; // Count: 3
var $6e818707c85bbc57$export$a318a8141fc98747 = "stringify"; // Count: 4
var $6e818707c85bbc57$export$34ec22d747521ad = "pathname"; // Count: 4
var $6e818707c85bbc57$export$89ce3552c03e8ec9 = "correlationHeaderExcludePatterns"; // Count: 2
var $6e818707c85bbc57$export$a3d3f936db372b4b = "indexOf"; // Count: 4
var $6e818707c85bbc57$export$e298802ab42a3b7f = "extensionConfig"; // Count: 4
var $6e818707c85bbc57$export$967696d490ed5a4a = "exceptions"; // Count: 6
var $6e818707c85bbc57$export$4b848bcab7cafe5d = "parsedStack"; // Count: 13
var $6e818707c85bbc57$export$14814e6f9bf337b4 = "properties"; // Count: 9
var $6e818707c85bbc57$export$32fc64677eb5b7a2 = "measurements"; // Count: 9
var $6e818707c85bbc57$export$59a1581bc81a9aae = "sizeInBytes"; // Count: 11
var $6e818707c85bbc57$export$6008dba8ea08a587 = "typeName"; // Count: 11
var $6e818707c85bbc57$export$2675b0014c60aa10 = "severityLevel"; // Count: 5
var $6e818707c85bbc57$export$5bc84cbcfe97e161 = "problemGroup"; // Count: 3
var $6e818707c85bbc57$export$880f71e9a894c474 = "isManual"; // Count: 3
var $6e818707c85bbc57$export$aadef743ee7d1db8 = "CreateFromInterface"; // Count: 2
var $6e818707c85bbc57$export$7e3ee7b01672f321 = "assembly"; // Count: 7
var $6e818707c85bbc57$export$8ea03ef8a4bcfeeb = "fileName"; // Count: 8
var $6e818707c85bbc57$export$b1b7551538b2085 = "hasFullStack"; // Count: 6
var $6e818707c85bbc57$export$25f3022e0cda8855 = "level"; // Count: 5
var $6e818707c85bbc57$export$47d30bd816d62bdc = "method"; // Count: 7
var $6e818707c85bbc57$export$138215f6c1f0eedf = "line"; // Count: 6
var $6e818707c85bbc57$export$aa395e58f404db90 = "duration"; // Count: 4
var $6e818707c85bbc57$export$e046465ee502552 = "receivedResponse"; // Count: 2
var $6e818707c85bbc57$export$20dce058fdd3c573 = "substring"; // Count: 6
var $6e818707c85bbc57$export$3e2d26f886f27705 = "sanitizeKeyAndAddUniqueness"; // Count: 2
var $6e818707c85bbc57$export$d41b8d8cb03ef566 = "sanitizeException"; // Count: 2
var $6e818707c85bbc57$export$f3c9f4fd45ed1e80 = "sanitizeProperties"; // Count: 2
var $6e818707c85bbc57$export$914f75e18f2d539f = "sanitizeMeasurements"; // Count: 2

});


parcelRegister("f5lFa", function(module, exports) {

$parcel$export(module.exports, "RequestHeaders", function () { return $afb8207b9d36c786$export$e499e02a1fe05177; });
/*
 * Application Insights JavaScript SDK - Common, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $4z4ow = parcelRequire("4z4ow");
var $afb8207b9d36c786$export$e499e02a1fe05177 = (0, $4z4ow.createValueMap)({
    requestContextHeader: [
        0 /* eRequestHeaders.requestContextHeader */ ,
        "Request-Context"
    ],
    requestContextTargetKey: [
        1 /* eRequestHeaders.requestContextTargetKey */ ,
        "appId"
    ],
    requestContextAppIdFormat: [
        2 /* eRequestHeaders.requestContextAppIdFormat */ ,
        "appId=cid-v1:"
    ],
    requestIdHeader: [
        3 /* eRequestHeaders.requestIdHeader */ ,
        "Request-Id"
    ],
    traceParentHeader: [
        4 /* eRequestHeaders.traceParentHeader */ ,
        "traceparent"
    ],
    traceStateHeader: [
        5 /* eRequestHeaders.traceStateHeader */ ,
        "tracestate"
    ],
    sdkContextHeader: [
        6 /* eRequestHeaders.sdkContextHeader */ ,
        "Sdk-Context"
    ],
    sdkContextHeaderAppIdRequest: [
        7 /* eRequestHeaders.sdkContextHeaderAppIdRequest */ ,
        "appId"
    ],
    requestContextHeaderLowerCase: [
        8 /* eRequestHeaders.requestContextHeaderLowerCase */ ,
        "request-context"
    ]
});

});
parcelRegister("4z4ow", function(module, exports) {

$parcel$export(module.exports, "createEnumStyle", function () { return $352dd6f4be635662$export$fd52abd0b2703048; });
$parcel$export(module.exports, "createValueMap", function () { return $352dd6f4be635662$export$8980fe7abaa99712; });
/*
 * Application Insights JavaScript SDK - Core, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $erRAP = parcelRequire("erRAP");
function $352dd6f4be635662$export$fd52abd0b2703048(values) {
    var enumClass = {};
    (0, $erRAP.objForEachKey)(values, function(field, value) {
        enumClass[field] = value;
        enumClass[value] = field;
    });
    return (0, $erRAP.deepFreeze)(enumClass);
}
function $352dd6f4be635662$export$a317a23ffc37c9e6(values) {
    var mapClass = {};
    (0, $erRAP.objForEachKey)(values, function(field, value) {
        mapClass[field] = field;
        mapClass[value] = field;
    });
    return (0, $erRAP.deepFreeze)(mapClass);
}
function $352dd6f4be635662$export$8980fe7abaa99712(values) {
    var mapClass = {};
    (0, $erRAP.objForEachKey)(values, function(field, value) {
        mapClass[field] = value[1];
        mapClass[value[0]] = value[1];
    });
    return (0, $erRAP.deepFreeze)(mapClass);
}

});


parcelRegister("fu0yT", function(module, exports) {

$parcel$export(module.exports, "utlCanUseLocalStorage", function () { return $b45a17e45109d6da$export$f28746933126d63f; });
$parcel$export(module.exports, "utlCanUseSessionStorage", function () { return $b45a17e45109d6da$export$c81985c4209bac26; });
$parcel$export(module.exports, "utlDisableStorage", function () { return $b45a17e45109d6da$export$53ddd0ab7db9403; });
$parcel$export(module.exports, "utlSetStoragePrefix", function () { return $b45a17e45109d6da$export$a08dccf4adbf6df9; });
$parcel$export(module.exports, "utlEnableStorage", function () { return $b45a17e45109d6da$export$f08cf9bcd292b981; });
$parcel$export(module.exports, "utlGetLocalStorage", function () { return $b45a17e45109d6da$export$c3876355f131c85c; });
$parcel$export(module.exports, "utlSetLocalStorage", function () { return $b45a17e45109d6da$export$631bce20500dc098; });
$parcel$export(module.exports, "utlRemoveStorage", function () { return $b45a17e45109d6da$export$63137c65c2cc6743; });
$parcel$export(module.exports, "utlGetSessionStorageKeys", function () { return $b45a17e45109d6da$export$42f95336fa01d38e; });
$parcel$export(module.exports, "utlGetSessionStorage", function () { return $b45a17e45109d6da$export$a398bd2f40e2eb6e; });
$parcel$export(module.exports, "utlSetSessionStorage", function () { return $b45a17e45109d6da$export$21abea3a85fee3f5; });
$parcel$export(module.exports, "utlRemoveSessionStorage", function () { return $b45a17e45109d6da$export$9f411b4ea05fb92a; });
/*
 * Application Insights JavaScript SDK - Common, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $8z2Gd = parcelRequire("8z2Gd");
var $3I5zg = parcelRequire("3I5zg");
var $erRAP = parcelRequire("erRAP");
var $gSD6i = parcelRequire("gSD6i");

var $efuYp = parcelRequire("efuYp");

var $9udGf = parcelRequire("9udGf");
var $b45a17e45109d6da$var$_canUseLocalStorage = undefined;
var $b45a17e45109d6da$var$_canUseSessionStorage = undefined;
var $b45a17e45109d6da$var$_storagePrefix = "";
/**
 * Gets the localStorage object if available
 * @return {Storage} - Returns the storage object if available else returns null
 */ function $b45a17e45109d6da$var$_getLocalStorageObject() {
    if ($b45a17e45109d6da$export$f28746933126d63f()) return $b45a17e45109d6da$var$_getVerifiedStorageObject((0, $efuYp.StorageType).LocalStorage);
    return null;
}
/**
 * Tests storage object (localStorage or sessionStorage) to verify that it is usable
 * More details here: https://mathiasbynens.be/notes/localstorage-pattern
 * @param storageType Type of storage
 * @return {Storage} Returns storage object verified that it is usable
 */ function $b45a17e45109d6da$var$_getVerifiedStorageObject(storageType) {
    try {
        if ((0, $erRAP.isNullOrUndefined)((0, $gSD6i.getGlobal)())) return null;
        var uid = (new Date)[0, $9udGf._DYN_TO_STRING /* @min:%2etoString */ ]();
        var storage = (0, $3I5zg.getGlobalInst)(storageType === (0, $efuYp.StorageType).LocalStorage ? "localStorage" : "sessionStorage");
        var name_1 = $b45a17e45109d6da$var$_storagePrefix + uid;
        storage.setItem(name_1, uid);
        var fail = storage.getItem(name_1) !== uid;
        storage[0, $9udGf._DYN_REMOVE_ITEM /* @min:%2eremoveItem */ ](name_1);
        if (!fail) return storage;
    } catch (exception) {
    // eslint-disable-next-line no-empty
    }
    return null;
}
/**
 * Gets the sessionStorage object if available
 * @return {Storage} - Returns the storage object if available else returns null
 */ function $b45a17e45109d6da$var$_getSessionStorageObject() {
    if ($b45a17e45109d6da$export$c81985c4209bac26()) return $b45a17e45109d6da$var$_getVerifiedStorageObject((0, $efuYp.StorageType).SessionStorage);
    return null;
}
function $b45a17e45109d6da$export$53ddd0ab7db9403() {
    $b45a17e45109d6da$var$_canUseLocalStorage = false;
    $b45a17e45109d6da$var$_canUseSessionStorage = false;
}
function $b45a17e45109d6da$export$a08dccf4adbf6df9(storagePrefix) {
    $b45a17e45109d6da$var$_storagePrefix = storagePrefix || "";
}
function $b45a17e45109d6da$export$f08cf9bcd292b981() {
    $b45a17e45109d6da$var$_canUseLocalStorage = $b45a17e45109d6da$export$f28746933126d63f(true);
    $b45a17e45109d6da$var$_canUseSessionStorage = $b45a17e45109d6da$export$c81985c4209bac26(true);
}
function $b45a17e45109d6da$export$f28746933126d63f(reset) {
    if (reset || $b45a17e45109d6da$var$_canUseLocalStorage === undefined) $b45a17e45109d6da$var$_canUseLocalStorage = !!$b45a17e45109d6da$var$_getVerifiedStorageObject((0, $efuYp.StorageType).LocalStorage);
    return $b45a17e45109d6da$var$_canUseLocalStorage;
}
function $b45a17e45109d6da$export$c3876355f131c85c(logger, name) {
    var storage = $b45a17e45109d6da$var$_getLocalStorageObject();
    if (storage !== null) try {
        return storage.getItem(name);
    } catch (e) {
        $b45a17e45109d6da$var$_canUseLocalStorage = false;
        (0, $8z2Gd._throwInternal)(logger, 2 /* eLoggingSeverity.WARNING */ , 1 /* _eInternalMessageId.BrowserCannotReadLocalStorage */ , "Browser failed read of local storage. " + (0, $erRAP.getExceptionName)(e), {
            exception: (0, $3I5zg.dumpObj)(e)
        });
    }
    return null;
}
function $b45a17e45109d6da$export$631bce20500dc098(logger, name, data) {
    var storage = $b45a17e45109d6da$var$_getLocalStorageObject();
    if (storage !== null) try {
        storage.setItem(name, data);
        return true;
    } catch (e) {
        $b45a17e45109d6da$var$_canUseLocalStorage = false;
        (0, $8z2Gd._throwInternal)(logger, 2 /* eLoggingSeverity.WARNING */ , 3 /* _eInternalMessageId.BrowserCannotWriteLocalStorage */ , "Browser failed write to local storage. " + (0, $erRAP.getExceptionName)(e), {
            exception: (0, $3I5zg.dumpObj)(e)
        });
    }
    return false;
}
function $b45a17e45109d6da$export$63137c65c2cc6743(logger, name) {
    var storage = $b45a17e45109d6da$var$_getLocalStorageObject();
    if (storage !== null) try {
        storage[0, $9udGf._DYN_REMOVE_ITEM /* @min:%2eremoveItem */ ](name);
        return true;
    } catch (e) {
        $b45a17e45109d6da$var$_canUseLocalStorage = false;
        (0, $8z2Gd._throwInternal)(logger, 2 /* eLoggingSeverity.WARNING */ , 5 /* _eInternalMessageId.BrowserFailedRemovalFromLocalStorage */ , "Browser failed removal of local storage item. " + (0, $erRAP.getExceptionName)(e), {
            exception: (0, $3I5zg.dumpObj)(e)
        });
    }
    return false;
}
function $b45a17e45109d6da$export$c81985c4209bac26(reset) {
    if (reset || $b45a17e45109d6da$var$_canUseSessionStorage === undefined) $b45a17e45109d6da$var$_canUseSessionStorage = !!$b45a17e45109d6da$var$_getVerifiedStorageObject((0, $efuYp.StorageType).SessionStorage);
    return $b45a17e45109d6da$var$_canUseSessionStorage;
}
function $b45a17e45109d6da$export$42f95336fa01d38e() {
    var keys = [];
    if ($b45a17e45109d6da$export$c81985c4209bac26()) (0, $erRAP.objForEachKey)((0, $3I5zg.getGlobalInst)("sessionStorage"), function(key) {
        keys.push(key);
    });
    return keys;
}
function $b45a17e45109d6da$export$a398bd2f40e2eb6e(logger, name) {
    var storage = $b45a17e45109d6da$var$_getSessionStorageObject();
    if (storage !== null) try {
        return storage.getItem(name);
    } catch (e) {
        $b45a17e45109d6da$var$_canUseSessionStorage = false;
        (0, $8z2Gd._throwInternal)(logger, 2 /* eLoggingSeverity.WARNING */ , 2 /* _eInternalMessageId.BrowserCannotReadSessionStorage */ , "Browser failed read of session storage. " + (0, $erRAP.getExceptionName)(e), {
            exception: (0, $3I5zg.dumpObj)(e)
        });
    }
    return null;
}
function $b45a17e45109d6da$export$21abea3a85fee3f5(logger, name, data) {
    var storage = $b45a17e45109d6da$var$_getSessionStorageObject();
    if (storage !== null) try {
        storage.setItem(name, data);
        return true;
    } catch (e) {
        $b45a17e45109d6da$var$_canUseSessionStorage = false;
        (0, $8z2Gd._throwInternal)(logger, 2 /* eLoggingSeverity.WARNING */ , 4 /* _eInternalMessageId.BrowserCannotWriteSessionStorage */ , "Browser failed write to session storage. " + (0, $erRAP.getExceptionName)(e), {
            exception: (0, $3I5zg.dumpObj)(e)
        });
    }
    return false;
}
function $b45a17e45109d6da$export$9f411b4ea05fb92a(logger, name) {
    var storage = $b45a17e45109d6da$var$_getSessionStorageObject();
    if (storage !== null) try {
        storage[0, $9udGf._DYN_REMOVE_ITEM /* @min:%2eremoveItem */ ](name);
        return true;
    } catch (e) {
        $b45a17e45109d6da$var$_canUseSessionStorage = false;
        (0, $8z2Gd._throwInternal)(logger, 2 /* eLoggingSeverity.WARNING */ , 6 /* _eInternalMessageId.BrowserFailedRemovalFromSessionStorage */ , "Browser failed removal of session storage item. " + (0, $erRAP.getExceptionName)(e), {
            exception: (0, $3I5zg.dumpObj)(e)
        });
    }
    return false;
}

});
parcelRegister("efuYp", function(module, exports) {

$parcel$export(module.exports, "StorageType", function () { return $a5fa7e10fdbe1cde$export$d5f3ec63cad061d9; });
$parcel$export(module.exports, "DistributedTracingModes", function () { return $a5fa7e10fdbe1cde$export$29bb472f6d62625c; });
/*
 * Application Insights JavaScript SDK - Common, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $4z4ow = parcelRequire("4z4ow");
var $a5fa7e10fdbe1cde$export$d5f3ec63cad061d9 = (0, $4z4ow.createEnumStyle)({
    LocalStorage: 0 /* eStorageType.LocalStorage */ ,
    SessionStorage: 1 /* eStorageType.SessionStorage */ 
});
var $a5fa7e10fdbe1cde$export$29bb472f6d62625c = (0, $4z4ow.createEnumStyle)({
    AI: 0 /* eDistributedTracingModes.AI */ ,
    AI_AND_W3C: 1 /* eDistributedTracingModes.AI_AND_W3C */ ,
    W3C: 2 /* eDistributedTracingModes.W3C */ 
});

});


parcelRegister("cGFCT", function(module, exports) {

$parcel$export(module.exports, "dataSanitizeString", function () { return $93c9b26403b12aaa$export$4e25b1d4bcd67eb8; });
$parcel$export(module.exports, "dataSanitizeUrl", function () { return $93c9b26403b12aaa$export$356146502a9f860c; });
$parcel$export(module.exports, "dataSanitizeMessage", function () { return $93c9b26403b12aaa$export$dff84a9939b48dc0; });
$parcel$export(module.exports, "dataSanitizeException", function () { return $93c9b26403b12aaa$export$e47d8a961052f8bc; });
$parcel$export(module.exports, "dataSanitizeProperties", function () { return $93c9b26403b12aaa$export$efba9e468fe3b2cf; });
$parcel$export(module.exports, "dataSanitizeMeasurements", function () { return $93c9b26403b12aaa$export$3f0e10abe91e800b; });
$parcel$export(module.exports, "dataSanitizeId", function () { return $93c9b26403b12aaa$export$808d3905d3d31f01; });
$parcel$export(module.exports, "DataSanitizer", function () { return $93c9b26403b12aaa$export$e8f2853040e43d45; });
/*
 * Application Insights JavaScript SDK - Common, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $8z2Gd = parcelRequire("8z2Gd");
var $3I5zg = parcelRequire("3I5zg");
var $erRAP = parcelRequire("erRAP");

var $9udGf = parcelRequire("9udGf");
var $93c9b26403b12aaa$var$_a;
function $93c9b26403b12aaa$export$1e3742b0a5fad0e9(logger, key, map) {
    var origLength = key[0, $9udGf._DYN_LENGTH /* @min:%2elength */ ];
    var field = $93c9b26403b12aaa$export$100c3b44eeb2bd0b(logger, key);
    // validation truncated the length.  We need to add uniqueness
    if (field[0, $9udGf._DYN_LENGTH /* @min:%2elength */ ] !== origLength) {
        var i = 0;
        var uniqueField = field;
        while(map[uniqueField] !== undefined){
            i++;
            uniqueField = field[0, $9udGf._DYN_SUBSTRING /* @min:%2esubstring */ ](0, 147) + $93c9b26403b12aaa$export$d924cb9df01a6484(i);
        }
        field = uniqueField;
    }
    return field;
}
function $93c9b26403b12aaa$export$100c3b44eeb2bd0b(logger, name) {
    var nameTrunc;
    if (name) {
        // Remove any leading or trailing whitespace
        name = (0, $erRAP.strTrim)(name[0, $9udGf._DYN_TO_STRING /* @min:%2etoString */ ]());
        // truncate the string to 150 chars
        if (name[0, $9udGf._DYN_LENGTH /* @min:%2elength */ ] > 150 /* DataSanitizerValues.MAX_NAME_LENGTH */ ) {
            nameTrunc = name[0, $9udGf._DYN_SUBSTRING /* @min:%2esubstring */ ](0, 150 /* DataSanitizerValues.MAX_NAME_LENGTH */ );
            (0, $8z2Gd._throwInternal)(logger, 2 /* eLoggingSeverity.WARNING */ , 57 /* _eInternalMessageId.NameTooLong */ , "name is too long.  It has been truncated to 150 characters.", {
                name: name
            }, true);
        }
    }
    return nameTrunc || name;
}
function $93c9b26403b12aaa$export$4e25b1d4bcd67eb8(logger, value, maxLength) {
    if (maxLength === void 0) maxLength = 1024 /* DataSanitizerValues.MAX_STRING_LENGTH */ ;
    var valueTrunc;
    if (value) {
        maxLength = maxLength ? maxLength : 1024 /* DataSanitizerValues.MAX_STRING_LENGTH */ ; // in case default parameters dont work
        value = (0, $erRAP.strTrim)(value);
        if (value.toString()[0, $9udGf._DYN_LENGTH /* @min:%2elength */ ] > maxLength) {
            valueTrunc = value[0, $9udGf._DYN_TO_STRING /* @min:%2etoString */ ]()[0, $9udGf._DYN_SUBSTRING /* @min:%2esubstring */ ](0, maxLength);
            (0, $8z2Gd._throwInternal)(logger, 2 /* eLoggingSeverity.WARNING */ , 61 /* _eInternalMessageId.StringValueTooLong */ , "string value is too long. It has been truncated to " + maxLength + " characters.", {
                value: value
            }, true);
        }
    }
    return valueTrunc || value;
}
function $93c9b26403b12aaa$export$356146502a9f860c(logger, url) {
    return $93c9b26403b12aaa$export$8860beb3484248f1(logger, url, 2048 /* DataSanitizerValues.MAX_URL_LENGTH */ , 66 /* _eInternalMessageId.UrlTooLong */ );
}
function $93c9b26403b12aaa$export$dff84a9939b48dc0(logger, message) {
    var messageTrunc;
    if (message) {
        if (message[0, $9udGf._DYN_LENGTH /* @min:%2elength */ ] > 32768 /* DataSanitizerValues.MAX_MESSAGE_LENGTH */ ) {
            messageTrunc = message[0, $9udGf._DYN_SUBSTRING /* @min:%2esubstring */ ](0, 32768 /* DataSanitizerValues.MAX_MESSAGE_LENGTH */ );
            (0, $8z2Gd._throwInternal)(logger, 2 /* eLoggingSeverity.WARNING */ , 56 /* _eInternalMessageId.MessageTruncated */ , "message is too long, it has been truncated to 32768 characters.", {
                message: message
            }, true);
        }
    }
    return messageTrunc || message;
}
function $93c9b26403b12aaa$export$e47d8a961052f8bc(logger, exception) {
    var exceptionTrunc;
    if (exception) {
        // Make surte its a string
        var value = "" + exception;
        if (value[0, $9udGf._DYN_LENGTH /* @min:%2elength */ ] > 32768 /* DataSanitizerValues.MAX_EXCEPTION_LENGTH */ ) {
            exceptionTrunc = value[0, $9udGf._DYN_SUBSTRING /* @min:%2esubstring */ ](0, 32768 /* DataSanitizerValues.MAX_EXCEPTION_LENGTH */ );
            (0, $8z2Gd._throwInternal)(logger, 2 /* eLoggingSeverity.WARNING */ , 52 /* _eInternalMessageId.ExceptionTruncated */ , "exception is too long, it has been truncated to 32768 characters.", {
                exception: exception
            }, true);
        }
    }
    return exceptionTrunc || exception;
}
function $93c9b26403b12aaa$export$efba9e468fe3b2cf(logger, properties) {
    if (properties) {
        var tempProps_1 = {};
        (0, $erRAP.objForEachKey)(properties, function(prop, value) {
            if ((0, $erRAP.isObject)(value) && (0, $3I5zg.hasJSON)()) // Stringify any part C properties
            try {
                value = (0, $3I5zg.getJSON)()[0, $9udGf._DYN_STRINGIFY /* @min:%2estringify */ ](value);
            } catch (e) {
                (0, $8z2Gd._throwInternal)(logger, 2 /* eLoggingSeverity.WARNING */ , 49 /* _eInternalMessageId.CannotSerializeObjectNonSerializable */ , "custom property is not valid", {
                    exception: e
                }, true);
            }
            value = $93c9b26403b12aaa$export$4e25b1d4bcd67eb8(logger, value, 8192 /* DataSanitizerValues.MAX_PROPERTY_LENGTH */ );
            prop = $93c9b26403b12aaa$export$1e3742b0a5fad0e9(logger, prop, tempProps_1);
            tempProps_1[prop] = value;
        });
        properties = tempProps_1;
    }
    return properties;
}
function $93c9b26403b12aaa$export$3f0e10abe91e800b(logger, measurements) {
    if (measurements) {
        var tempMeasurements_1 = {};
        (0, $erRAP.objForEachKey)(measurements, function(measure, value) {
            measure = $93c9b26403b12aaa$export$1e3742b0a5fad0e9(logger, measure, tempMeasurements_1);
            tempMeasurements_1[measure] = value;
        });
        measurements = tempMeasurements_1;
    }
    return measurements;
}
function $93c9b26403b12aaa$export$808d3905d3d31f01(logger, id) {
    return id ? $93c9b26403b12aaa$export$8860beb3484248f1(logger, id, 128 /* DataSanitizerValues.MAX_ID_LENGTH */ , 69 /* _eInternalMessageId.IdTooLong */ )[0, $9udGf._DYN_TO_STRING /* @min:%2etoString */ ]() : id;
}
function $93c9b26403b12aaa$export$8860beb3484248f1(logger, input, maxLength, _msgId) {
    var inputTrunc;
    if (input) {
        input = (0, $erRAP.strTrim)(input);
        if (input[0, $9udGf._DYN_LENGTH /* @min:%2elength */ ] > maxLength) {
            inputTrunc = input[0, $9udGf._DYN_SUBSTRING /* @min:%2esubstring */ ](0, maxLength);
            (0, $8z2Gd._throwInternal)(logger, 2 /* eLoggingSeverity.WARNING */ , _msgId, "input is too long, it has been truncated to " + maxLength + " characters.", {
                data: input
            }, true);
        }
    }
    return inputTrunc || input;
}
function $93c9b26403b12aaa$export$d924cb9df01a6484(num) {
    var s = "00" + num;
    return s.substr(s[0, $9udGf._DYN_LENGTH /* @min:%2elength */ ] - 3);
}
var $93c9b26403b12aaa$export$e8f2853040e43d45 = ($93c9b26403b12aaa$var$_a = {
    MAX_NAME_LENGTH: 150 /* DataSanitizerValues.MAX_NAME_LENGTH */ ,
    MAX_ID_LENGTH: 128 /* DataSanitizerValues.MAX_ID_LENGTH */ ,
    MAX_PROPERTY_LENGTH: 8192 /* DataSanitizerValues.MAX_PROPERTY_LENGTH */ ,
    MAX_STRING_LENGTH: 1024 /* DataSanitizerValues.MAX_STRING_LENGTH */ ,
    MAX_URL_LENGTH: 2048 /* DataSanitizerValues.MAX_URL_LENGTH */ ,
    MAX_MESSAGE_LENGTH: 32768 /* DataSanitizerValues.MAX_MESSAGE_LENGTH */ ,
    MAX_EXCEPTION_LENGTH: 32768 /* DataSanitizerValues.MAX_EXCEPTION_LENGTH */ 
}, $93c9b26403b12aaa$var$_a[0, $9udGf._DYN_SANITIZE_KEY_AND_ADD2 /* @min:sanitizeKeyAndAddUniqueness */ ] = $93c9b26403b12aaa$export$1e3742b0a5fad0e9, $93c9b26403b12aaa$var$_a.sanitizeKey = $93c9b26403b12aaa$export$100c3b44eeb2bd0b, $93c9b26403b12aaa$var$_a.sanitizeString = $93c9b26403b12aaa$export$4e25b1d4bcd67eb8, $93c9b26403b12aaa$var$_a.sanitizeUrl = $93c9b26403b12aaa$export$356146502a9f860c, $93c9b26403b12aaa$var$_a.sanitizeMessage = $93c9b26403b12aaa$export$dff84a9939b48dc0, $93c9b26403b12aaa$var$_a[0, $9udGf._DYN_SANITIZE_EXCEPTION /* @min:sanitizeException */ ] = $93c9b26403b12aaa$export$e47d8a961052f8bc, $93c9b26403b12aaa$var$_a[0, $9udGf._DYN_SANITIZE_PROPERTIES /* @min:sanitizeProperties */ ] = $93c9b26403b12aaa$export$efba9e468fe3b2cf, $93c9b26403b12aaa$var$_a[0, $9udGf._DYN_SANITIZE_MEASUREMENT3 /* @min:sanitizeMeasurements */ ] = $93c9b26403b12aaa$export$3f0e10abe91e800b, $93c9b26403b12aaa$var$_a.sanitizeId = $93c9b26403b12aaa$export$808d3905d3d31f01, $93c9b26403b12aaa$var$_a.sanitizeInput = $93c9b26403b12aaa$export$8860beb3484248f1, $93c9b26403b12aaa$var$_a.padNumber = $93c9b26403b12aaa$export$d924cb9df01a6484, $93c9b26403b12aaa$var$_a.trim = (0, $erRAP.strTrim), $93c9b26403b12aaa$var$_a);

});

parcelRegister("8EowS", function(module, exports) {

$parcel$export(module.exports, "urlParseUrl", function () { return $64c51625382f6ff0$export$7121b8cb971a9df2; });
$parcel$export(module.exports, "urlParseHost", function () { return $64c51625382f6ff0$export$ff1d1b7a9bae98f; });
$parcel$export(module.exports, "urlGetAbsoluteUrl", function () { return $64c51625382f6ff0$export$a98678973ebe2123; });
$parcel$export(module.exports, "urlGetPathName", function () { return $64c51625382f6ff0$export$d19e0ccf7100cfb3; });
$parcel$export(module.exports, "urlGetCompleteUrl", function () { return $64c51625382f6ff0$export$b959f3bc0a239498; });
$parcel$export(module.exports, "urlParseFullHost", function () { return $64c51625382f6ff0$export$eac70d47569302de; });
/*
 * Application Insights JavaScript SDK - Common, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $3I5zg = parcelRequire("3I5zg");
var $erRAP = parcelRequire("erRAP");

var $9udGf = parcelRequire("9udGf");
var $64c51625382f6ff0$var$_document = (0, $3I5zg.getDocument)() || {};
var $64c51625382f6ff0$var$_htmlAnchorIdx = 0;
// Use an array of temporary values as it's possible for multiple calls to parseUrl() will be called with different URLs
// Using a cache size of 5 for now as it current depth usage is at least 2, so adding a minor buffer to handle future updates
var $64c51625382f6ff0$var$_htmlAnchorElement = [
    null,
    null,
    null,
    null,
    null
];
function $64c51625382f6ff0$export$7121b8cb971a9df2(url) {
    var anchorIdx = $64c51625382f6ff0$var$_htmlAnchorIdx;
    var anchorCache = $64c51625382f6ff0$var$_htmlAnchorElement;
    var tempAnchor = anchorCache[anchorIdx];
    if (!$64c51625382f6ff0$var$_document.createElement) // Always create the temp instance if createElement is not available
    tempAnchor = {
        host: $64c51625382f6ff0$export$ff1d1b7a9bae98f(url, true)
    };
    else if (!anchorCache[anchorIdx]) // Create and cache the unattached anchor instance
    tempAnchor = anchorCache[anchorIdx] = $64c51625382f6ff0$var$_document.createElement("a");
    tempAnchor.href = url;
    // Move the cache index forward
    anchorIdx++;
    if (anchorIdx >= anchorCache[0, $9udGf._DYN_LENGTH /* @min:%2elength */ ]) anchorIdx = 0;
    $64c51625382f6ff0$var$_htmlAnchorIdx = anchorIdx;
    return tempAnchor;
}
function $64c51625382f6ff0$export$a98678973ebe2123(url) {
    var result;
    var a = $64c51625382f6ff0$export$7121b8cb971a9df2(url);
    if (a) result = a.href;
    return result;
}
function $64c51625382f6ff0$export$d19e0ccf7100cfb3(url) {
    var result;
    var a = $64c51625382f6ff0$export$7121b8cb971a9df2(url);
    if (a) result = a[0, $9udGf._DYN_PATHNAME /* @min:%2epathname */ ];
    return result;
}
function $64c51625382f6ff0$export$b959f3bc0a239498(method, absoluteUrl) {
    if (method) return method.toUpperCase() + " " + absoluteUrl;
    return absoluteUrl;
}
function $64c51625382f6ff0$export$ff1d1b7a9bae98f(url, inclPort) {
    var fullHost = $64c51625382f6ff0$export$eac70d47569302de(url, inclPort) || "";
    if (fullHost) {
        var match = fullHost.match(/(www\d{0,5}\.)?([^\/:]{1,256})(:\d{1,20})?/i);
        if (match != null && match[0, $9udGf._DYN_LENGTH /* @min:%2elength */ ] > 3 && (0, $erRAP.isString)(match[2]) && match[2][0, $9udGf._DYN_LENGTH /* @min:%2elength */ ] > 0) return match[2] + (match[3] || "");
    }
    return fullHost;
}
function $64c51625382f6ff0$export$eac70d47569302de(url, inclPort) {
    var result = null;
    if (url) {
        var match = url.match(/(\w{1,150}):\/\/([^\/:]{1,256})(:\d{1,20})?/i);
        if (match != null && match[0, $9udGf._DYN_LENGTH /* @min:%2elength */ ] > 2 && (0, $erRAP.isString)(match[2]) && match[2][0, $9udGf._DYN_LENGTH /* @min:%2elength */ ] > 0) {
            result = match[2] || "";
            if (inclPort && match[0, $9udGf._DYN_LENGTH /* @min:%2elength */ ] > 2) {
                var protocol = (match[1] || "")[0, $9udGf._DYN_TO_LOWER_CASE /* @min:%2etoLowerCase */ ]();
                var port = match[3] || "";
                // IE includes the standard port so pass it off if it's the same as the protocol
                if (protocol === "http" && port === ":80") port = "";
                else if (protocol === "https" && port === ":443") port = "";
                result += port;
            }
        }
    }
    return result;
}

});


parcelRegister("5cDez", function(module, exports) {

$parcel$export(module.exports, "parseConnectionString", function () { return $3c9c81ce9ccf5c0d$export$6369f286b474466d; });
$parcel$export(module.exports, "ConnectionStringParser", function () { return $3c9c81ce9ccf5c0d$export$9fc8be9be2105769; });
/*
 * Application Insights JavaScript SDK - Common, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $erRAP = parcelRequire("erRAP");

var $dCW8D = parcelRequire("dCW8D");

var $9udGf = parcelRequire("9udGf");
var $3c9c81ce9ccf5c0d$var$_FIELDS_SEPARATOR = ";";
var $3c9c81ce9ccf5c0d$var$_FIELD_KEY_VALUE_SEPARATOR = "=";
function $3c9c81ce9ccf5c0d$export$6369f286b474466d(connectionString) {
    if (!connectionString) return {};
    var kvPairs = connectionString[0, $9udGf._DYN_SPLIT /* @min:%2esplit */ ]($3c9c81ce9ccf5c0d$var$_FIELDS_SEPARATOR);
    var result = (0, $erRAP.arrReduce)(kvPairs, function(fields, kv) {
        var kvParts = kv[0, $9udGf._DYN_SPLIT /* @min:%2esplit */ ]($3c9c81ce9ccf5c0d$var$_FIELD_KEY_VALUE_SEPARATOR);
        if (kvParts[0, $9udGf._DYN_LENGTH /* @min:%2elength */ ] === 2) {
            var key = kvParts[0][0, $9udGf._DYN_TO_LOWER_CASE /* @min:%2etoLowerCase */ ]();
            var value = kvParts[1];
            fields[key] = value;
        }
        return fields;
    }, {});
    if ((0, $erRAP.objKeys)(result)[0, $9udGf._DYN_LENGTH /* @min:%2elength */ ] > 0) {
        // this is a valid connection string, so parse the results
        if (result.endpointsuffix) {
            // use endpoint suffix where overrides are not provided
            var locationPrefix = result.location ? result.location + "." : "";
            result[0, $9udGf._DYN_INGESTIONENDPOINT /* @min:%2eingestionendpoint */ ] = result[0, $9udGf._DYN_INGESTIONENDPOINT /* @min:%2eingestionendpoint */ ] || "https://" + locationPrefix + "dc." + result.endpointsuffix;
            if ((0, $erRAP.strEndsWith)(result[0, $9udGf._DYN_INGESTIONENDPOINT /* @min:%2eingestionendpoint */ ], "/")) result[0, $9udGf._DYN_INGESTIONENDPOINT /* @min:%2eingestionendpoint */ ] = result[0, $9udGf._DYN_INGESTIONENDPOINT /* @min:%2eingestionendpoint */ ].slice(0, -1);
        }
        // apply the default endpoints
        result[0, $9udGf._DYN_INGESTIONENDPOINT /* @min:%2eingestionendpoint */ ] = result[0, $9udGf._DYN_INGESTIONENDPOINT /* @min:%2eingestionendpoint */ ] || (0, $dCW8D.DEFAULT_BREEZE_ENDPOINT);
    }
    return result;
}
var $3c9c81ce9ccf5c0d$export$9fc8be9be2105769 = {
    parse: $3c9c81ce9ccf5c0d$export$6369f286b474466d
};

});

parcelRegister("1V1Zd", function(module, exports) {

$parcel$export(module.exports, "Envelope", function () { return $165ca7bdc88904c8$export$4e2d65a9843399df; });
/*
 * Application Insights JavaScript SDK - Common, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $erRAP = parcelRequire("erRAP");

var $dCW8D = parcelRequire("dCW8D");

var $9udGf = parcelRequire("9udGf");

var $cGFCT = parcelRequire("cGFCT");
var $165ca7bdc88904c8$export$4e2d65a9843399df = /** @class */ function() {
    /**
     * Constructs a new instance of telemetry data.
     */ function Envelope(logger, data, name) {
        var _this = this;
        var _self = this;
        _self.ver = 1;
        _self.sampleRate = 100.0;
        _self.tags = {};
        _self[0, $9udGf._DYN_NAME /* @min:%2ename */ ] = (0, $cGFCT.dataSanitizeString)(logger, name) || (0, $dCW8D.strNotSpecified);
        _self.data = data;
        _self.time = (0, $erRAP.toISOString)(new Date());
        _self.aiDataContract = {
            time: 1 /* FieldType.Required */ ,
            iKey: 1 /* FieldType.Required */ ,
            name: 1 /* FieldType.Required */ ,
            sampleRate: function() {
                return _this.sampleRate === 100 ? 4 /* FieldType.Hidden */  : 1 /* FieldType.Required */ ;
            },
            tags: 1 /* FieldType.Required */ ,
            data: 1 /* FieldType.Required */ 
        };
    }
    return Envelope;
}();

});

parcelRegister("fK8rK", function(module, exports) {

$parcel$export(module.exports, "Event", function () { return $b761b4348b304ff8$export$d61e24a684f9e51; });
/*
 * Application Insights JavaScript SDK - Common, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $dCW8D = parcelRequire("dCW8D");

var $9udGf = parcelRequire("9udGf");

var $cGFCT = parcelRequire("cGFCT");
var $b761b4348b304ff8$export$d61e24a684f9e51 = /** @class */ function() {
    /**
     * Constructs a new instance of the EventTelemetry object
     */ function Event(logger, name, properties, measurements) {
        this.aiDataContract = {
            ver: 1 /* FieldType.Required */ ,
            name: 1 /* FieldType.Required */ ,
            properties: 0 /* FieldType.Default */ ,
            measurements: 0 /* FieldType.Default */ 
        };
        var _self = this;
        _self.ver = 2;
        _self[0, $9udGf._DYN_NAME /* @min:%2ename */ ] = (0, $cGFCT.dataSanitizeString)(logger, name) || (0, $dCW8D.strNotSpecified);
        _self[0, $9udGf._DYN_PROPERTIES /* @min:%2eproperties */ ] = (0, $cGFCT.dataSanitizeProperties)(logger, properties);
        _self[0, $9udGf._DYN_MEASUREMENTS /* @min:%2emeasurements */ ] = (0, $cGFCT.dataSanitizeMeasurements)(logger, measurements);
    }
    Event.envelopeType = "Microsoft.ApplicationInsights.{0}.Event";
    Event.dataType = "EventData";
    return Event;
}();

});

parcelRegister("3AuL8", function(module, exports) {

$parcel$export(module.exports, "Exception", function () { return $29cc9804e37f51b3$export$e2f174de097e0bcd; });
/*
 * Application Insights JavaScript SDK - Common, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $fcMe7 = parcelRequire("fcMe7");

var $erRAP = parcelRequire("erRAP");

var $dCW8D = parcelRequire("dCW8D");

var $9udGf = parcelRequire("9udGf");

var $cGFCT = parcelRequire("cGFCT");
var $29cc9804e37f51b3$var$NoMethod = "<no_method>";
var $29cc9804e37f51b3$var$strError = "error";
var $29cc9804e37f51b3$var$strStack = "stack";
var $29cc9804e37f51b3$var$strStackDetails = "stackDetails";
var $29cc9804e37f51b3$var$strErrorSrc = "errorSrc";
var $29cc9804e37f51b3$var$strMessage = "message";
var $29cc9804e37f51b3$var$strDescription = "description";
function $29cc9804e37f51b3$var$_stringify(value, convertToString) {
    var result = value;
    if (result && !(0, $erRAP.isString)(result)) {
        if (JSON && JSON[0, $9udGf._DYN_STRINGIFY /* @min:%2estringify */ ]) {
            result = JSON[0, $9udGf._DYN_STRINGIFY /* @min:%2estringify */ ](value);
            if (convertToString && (!result || result === "{}")) {
                if ((0, $erRAP.isFunction)(value[0, $9udGf._DYN_TO_STRING /* @min:%2etoString */ ])) result = value[0, $9udGf._DYN_TO_STRING /* @min:%2etoString */ ]();
                else result = "" + value;
            }
        } else result = "" + value + " - (Missing JSON.stringify)";
    }
    return result || "";
}
function $29cc9804e37f51b3$var$_formatMessage(theEvent, errorType) {
    var evtMessage = theEvent;
    if (theEvent) {
        if (evtMessage && !(0, $erRAP.isString)(evtMessage)) evtMessage = theEvent[$29cc9804e37f51b3$var$strMessage] || theEvent[$29cc9804e37f51b3$var$strDescription] || evtMessage;
        // Make sure the message is a string
        if (evtMessage && !(0, $erRAP.isString)(evtMessage)) // tslint:disable-next-line: prefer-conditional-expression
        evtMessage = $29cc9804e37f51b3$var$_stringify(evtMessage, true);
        if (theEvent["filename"]) // Looks like an event object with filename
        evtMessage = evtMessage + " @" + (theEvent["filename"] || "") + ":" + (theEvent["lineno"] || "?") + ":" + (theEvent["colno"] || "?");
    }
    // Automatically add the error type to the message if it does already appear to be present
    if (errorType && errorType !== "String" && errorType !== "Object" && errorType !== "Error" && (evtMessage || "")[0, $9udGf._DYN_INDEX_OF /* @min:%2eindexOf */ ](errorType) === -1) evtMessage = errorType + ": " + evtMessage;
    return evtMessage || "";
}
function $29cc9804e37f51b3$var$_isExceptionDetailsInternal(value) {
    try {
        if ((0, $erRAP.isObject)(value)) return "hasFullStack" in value && "typeName" in value;
    } catch (e) {
    // This can happen with some native browser objects, but should not happen for the type we are checking for
    }
    return false;
}
function $29cc9804e37f51b3$var$_isExceptionInternal(value) {
    try {
        if ((0, $erRAP.isObject)(value)) return "ver" in value && "exceptions" in value && "properties" in value;
    } catch (e) {
    // This can happen with some native browser objects, but should not happen for the type we are checking for
    }
    return false;
}
function $29cc9804e37f51b3$var$_isStackDetails(details) {
    return details && details.src && (0, $erRAP.isString)(details.src) && details.obj && (0, $erRAP.isArray)(details.obj);
}
function $29cc9804e37f51b3$var$_convertStackObj(errorStack) {
    var src = errorStack || "";
    if (!(0, $erRAP.isString)(src)) {
        if ((0, $erRAP.isString)(src[$29cc9804e37f51b3$var$strStack])) src = src[$29cc9804e37f51b3$var$strStack];
        else src = "" + src;
    }
    var items = src[0, $9udGf._DYN_SPLIT /* @min:%2esplit */ ]("\n");
    return {
        src: src,
        obj: items
    };
}
function $29cc9804e37f51b3$var$_getOperaStack(errorMessage) {
    var stack = [];
    var lines = errorMessage[0, $9udGf._DYN_SPLIT /* @min:%2esplit */ ]("\n");
    for(var lp = 0; lp < lines[0, $9udGf._DYN_LENGTH /* @min:%2elength */ ]; lp++){
        var entry = lines[lp];
        if (lines[lp + 1]) {
            entry += "@" + lines[lp + 1];
            lp++;
        }
        stack.push(entry);
    }
    return {
        src: errorMessage,
        obj: stack
    };
}
function $29cc9804e37f51b3$var$_getStackFromErrorObj(errorObj) {
    var details = null;
    if (errorObj) try {
        /* Using bracket notation is support older browsers (IE 7/8 -- dont remember the version) that throw when using dot
            notation for undefined objects and we don't want to loose the error from being reported */ if (errorObj[$29cc9804e37f51b3$var$strStack]) // Chrome/Firefox
        details = $29cc9804e37f51b3$var$_convertStackObj(errorObj[$29cc9804e37f51b3$var$strStack]);
        else if (errorObj[$29cc9804e37f51b3$var$strError] && errorObj[$29cc9804e37f51b3$var$strError][$29cc9804e37f51b3$var$strStack]) // Edge error event provides the stack and error object
        details = $29cc9804e37f51b3$var$_convertStackObj(errorObj[$29cc9804e37f51b3$var$strError][$29cc9804e37f51b3$var$strStack]);
        else if (errorObj["exception"] && errorObj.exception[$29cc9804e37f51b3$var$strStack]) details = $29cc9804e37f51b3$var$_convertStackObj(errorObj.exception[$29cc9804e37f51b3$var$strStack]);
        else if ($29cc9804e37f51b3$var$_isStackDetails(errorObj)) details = errorObj;
        else if ($29cc9804e37f51b3$var$_isStackDetails(errorObj[$29cc9804e37f51b3$var$strStackDetails])) details = errorObj[$29cc9804e37f51b3$var$strStackDetails];
        else if (window && window["opera"] && errorObj[$29cc9804e37f51b3$var$strMessage]) // Opera
        details = $29cc9804e37f51b3$var$_getOperaStack(errorObj[0, $9udGf._DYN_MESSAGE /* @min:%2emessage */ ]);
        else if (errorObj["reason"] && errorObj.reason[$29cc9804e37f51b3$var$strStack]) // UnhandledPromiseRejection
        details = $29cc9804e37f51b3$var$_convertStackObj(errorObj.reason[$29cc9804e37f51b3$var$strStack]);
        else if ((0, $erRAP.isString)(errorObj)) details = $29cc9804e37f51b3$var$_convertStackObj(errorObj);
        else {
            var evtMessage = errorObj[$29cc9804e37f51b3$var$strMessage] || errorObj[$29cc9804e37f51b3$var$strDescription] || "";
            if ((0, $erRAP.isString)(errorObj[$29cc9804e37f51b3$var$strErrorSrc])) {
                if (evtMessage) evtMessage += "\n";
                evtMessage += " from " + errorObj[$29cc9804e37f51b3$var$strErrorSrc];
            }
            if (evtMessage) details = $29cc9804e37f51b3$var$_convertStackObj(evtMessage);
        }
    } catch (e) {
        // something unexpected happened so to avoid failing to report any error lets swallow the exception
        // and fallback to the callee/caller method
        details = $29cc9804e37f51b3$var$_convertStackObj(e);
    }
    return details || {
        src: "",
        obj: null
    };
}
function $29cc9804e37f51b3$var$_formatStackTrace(stackDetails) {
    var stack = "";
    if (stackDetails) {
        if (stackDetails.obj) (0, $erRAP.arrForEach)(stackDetails.obj, function(entry) {
            stack += entry + "\n";
        });
        else stack = stackDetails.src || "";
    }
    return stack;
}
function $29cc9804e37f51b3$var$_parseStack(stack) {
    var parsedStack;
    var frames = stack.obj;
    if (frames && frames[0, $9udGf._DYN_LENGTH /* @min:%2elength */ ] > 0) {
        parsedStack = [];
        var level_1 = 0;
        var totalSizeInBytes_1 = 0;
        (0, $erRAP.arrForEach)(frames, function(frame) {
            var theFrame = frame[0, $9udGf._DYN_TO_STRING /* @min:%2etoString */ ]();
            if ($29cc9804e37f51b3$export$b9d0519a34c90616.regex.test(theFrame)) {
                var parsedFrame = new $29cc9804e37f51b3$export$b9d0519a34c90616(theFrame, level_1++);
                totalSizeInBytes_1 += parsedFrame[0, $9udGf._DYN_SIZE_IN_BYTES /* @min:%2esizeInBytes */ ];
                parsedStack.push(parsedFrame);
            }
        });
        // DP Constraint - exception parsed stack must be < 32KB
        // remove frames from the middle to meet the threshold
        var exceptionParsedStackThreshold = 32768;
        if (totalSizeInBytes_1 > exceptionParsedStackThreshold) {
            var left = 0;
            var right = parsedStack[0, $9udGf._DYN_LENGTH /* @min:%2elength */ ] - 1;
            var size = 0;
            var acceptedLeft = left;
            var acceptedRight = right;
            while(left < right){
                // check size
                var lSize = parsedStack[left][0, $9udGf._DYN_SIZE_IN_BYTES /* @min:%2esizeInBytes */ ];
                var rSize = parsedStack[right][0, $9udGf._DYN_SIZE_IN_BYTES /* @min:%2esizeInBytes */ ];
                size += lSize + rSize;
                if (size > exceptionParsedStackThreshold) {
                    // remove extra frames from the middle
                    var howMany = acceptedRight - acceptedLeft + 1;
                    parsedStack.splice(acceptedLeft, howMany);
                    break;
                }
                // update pointers
                acceptedLeft = left;
                acceptedRight = right;
                left++;
                right--;
            }
        }
    }
    return parsedStack;
}
function $29cc9804e37f51b3$var$_getErrorType(errorType) {
    // Gets the Error Type by passing the constructor (used to get the true type of native error object).
    var typeName = "";
    if (errorType) {
        typeName = errorType.typeName || errorType[0, $9udGf._DYN_NAME /* @min:%2ename */ ] || "";
        if (!typeName) try {
            var funcNameRegex = /function (.{1,200})\(/;
            var results = funcNameRegex.exec(errorType.constructor[0, $9udGf._DYN_TO_STRING /* @min:%2etoString */ ]());
            typeName = results && results[0, $9udGf._DYN_LENGTH /* @min:%2elength */ ] > 1 ? results[1] : "";
        } catch (e) {
        // eslint-disable-next-line no-empty -- Ignoring any failures as nothing we can do
        }
    }
    return typeName;
}
function $29cc9804e37f51b3$export$7eb96e918bb60d21(errorObj) {
    if (errorObj) try {
        if (!(0, $erRAP.isString)(errorObj)) {
            var errorType = $29cc9804e37f51b3$var$_getErrorType(errorObj);
            var result = $29cc9804e37f51b3$var$_stringify(errorObj, false);
            if (!result || result === "{}") {
                if (errorObj[$29cc9804e37f51b3$var$strError]) {
                    // Looks like an MS Error Event
                    errorObj = errorObj[$29cc9804e37f51b3$var$strError];
                    errorType = $29cc9804e37f51b3$var$_getErrorType(errorObj);
                }
                result = $29cc9804e37f51b3$var$_stringify(errorObj, true);
            }
            if (result[0, $9udGf._DYN_INDEX_OF /* @min:%2eindexOf */ ](errorType) !== 0 && errorType !== "String") return errorType + ":" + result;
            return result;
        }
    } catch (e) {
    // eslint-disable-next-line no-empty -- Ignoring any failures as nothing we can do
    }
    // Fallback to just letting the object format itself into a string
    return "" + (errorObj || "");
}
var $29cc9804e37f51b3$export$e2f174de097e0bcd = /** @class */ function() {
    /**
     * Constructs a new instance of the ExceptionTelemetry object
     */ function Exception(logger, exception, properties, measurements, severityLevel, id) {
        this.aiDataContract = {
            ver: 1 /* FieldType.Required */ ,
            exceptions: 1 /* FieldType.Required */ ,
            severityLevel: 0 /* FieldType.Default */ ,
            properties: 0 /* FieldType.Default */ ,
            measurements: 0 /* FieldType.Default */ 
        };
        var _self = this;
        _self.ver = 2; // TODO: handle the CS"4.0" ==> breeze 2 conversion in a better way
        if (!$29cc9804e37f51b3$var$_isExceptionInternal(exception)) {
            if (!properties) properties = {};
            _self[0, $9udGf._DYN_EXCEPTIONS /* @min:%2eexceptions */ ] = [
                new $29cc9804e37f51b3$export$39152eac9dc76c5e(logger, exception, properties)
            ];
            _self[0, $9udGf._DYN_PROPERTIES /* @min:%2eproperties */ ] = (0, $cGFCT.dataSanitizeProperties)(logger, properties);
            _self[0, $9udGf._DYN_MEASUREMENTS /* @min:%2emeasurements */ ] = (0, $cGFCT.dataSanitizeMeasurements)(logger, measurements);
            if (severityLevel) _self[0, $9udGf._DYN_SEVERITY_LEVEL /* @min:%2eseverityLevel */ ] = severityLevel;
            if (id) _self.id = id;
        } else {
            _self[0, $9udGf._DYN_EXCEPTIONS /* @min:%2eexceptions */ ] = exception[0, $9udGf._DYN_EXCEPTIONS /* @min:%2eexceptions */ ] || [];
            _self[0, $9udGf._DYN_PROPERTIES /* @min:%2eproperties */ ] = exception[0, $9udGf._DYN_PROPERTIES /* @min:%2eproperties */ ];
            _self[0, $9udGf._DYN_MEASUREMENTS /* @min:%2emeasurements */ ] = exception[0, $9udGf._DYN_MEASUREMENTS /* @min:%2emeasurements */ ];
            if (exception[0, $9udGf._DYN_SEVERITY_LEVEL /* @min:%2eseverityLevel */ ]) _self[0, $9udGf._DYN_SEVERITY_LEVEL /* @min:%2eseverityLevel */ ] = exception[0, $9udGf._DYN_SEVERITY_LEVEL /* @min:%2eseverityLevel */ ];
            if (exception.id) _self.id = exception.id;
            if (exception[0, $9udGf._DYN_PROBLEM_GROUP /* @min:%2eproblemGroup */ ]) _self[0, $9udGf._DYN_PROBLEM_GROUP /* @min:%2eproblemGroup */ ] = exception[0, $9udGf._DYN_PROBLEM_GROUP /* @min:%2eproblemGroup */ ];
            // bool/int types, use isNullOrUndefined
            if (!(0, $erRAP.isNullOrUndefined)(exception[0, $9udGf._DYN_IS_MANUAL /* @min:%2eisManual */ ])) _self[0, $9udGf._DYN_IS_MANUAL /* @min:%2eisManual */ ] = exception[0, $9udGf._DYN_IS_MANUAL /* @min:%2eisManual */ ];
        }
    }
    Exception.CreateAutoException = function(message, url, lineNumber, columnNumber, error, evt, stack, errorSrc) {
        var _a;
        var errorType = $29cc9804e37f51b3$var$_getErrorType(error || evt || message);
        return _a = {}, _a[0, $9udGf._DYN_MESSAGE /* @min:message */ ] = $29cc9804e37f51b3$var$_formatMessage(message, errorType), _a.url = url, _a.lineNumber = lineNumber, _a.columnNumber = columnNumber, _a.error = $29cc9804e37f51b3$export$7eb96e918bb60d21(error || evt || message), _a.evt = $29cc9804e37f51b3$export$7eb96e918bb60d21(evt || message), _a[0, $9udGf._DYN_TYPE_NAME /* @min:typeName */ ] = errorType, _a.stackDetails = $29cc9804e37f51b3$var$_getStackFromErrorObj(stack || error || evt), _a.errorSrc = errorSrc, _a;
    };
    Exception.CreateFromInterface = function(logger, exception, properties, measurements) {
        var exceptions = exception[0, $9udGf._DYN_EXCEPTIONS /* @min:%2eexceptions */ ] && (0, $erRAP.arrMap)(exception[0, $9udGf._DYN_EXCEPTIONS /* @min:%2eexceptions */ ], function(ex) {
            return $29cc9804e37f51b3$export$39152eac9dc76c5e[0, $9udGf._DYN__CREATE_FROM_INTERFA1 /* @min:%2eCreateFromInterface */ ](logger, ex);
        });
        var exceptionData = new Exception(logger, (0, $fcMe7.__assignFn)((0, $fcMe7.__assignFn)({}, exception), {
            exceptions: exceptions
        }), properties, measurements);
        return exceptionData;
    };
    Exception.prototype.toInterface = function() {
        var _a;
        var _b = this, exceptions = _b.exceptions, properties = _b.properties, measurements = _b.measurements, severityLevel = _b.severityLevel, problemGroup = _b.problemGroup, id = _b.id, isManual = _b.isManual;
        var exceptionDetailsInterface = exceptions instanceof Array && (0, $erRAP.arrMap)(exceptions, function(exception) {
            return exception.toInterface();
        }) || undefined;
        return _a = {
            ver: "4.0"
        }, _a[0, $9udGf._DYN_EXCEPTIONS /* @min:exceptions */ ] = exceptionDetailsInterface, _a.severityLevel = severityLevel, _a.properties = properties, _a.measurements = measurements, _a.problemGroup = problemGroup, _a.id = id, _a.isManual = isManual, _a;
    };
    /**
     * Creates a simple exception with 1 stack frame. Useful for manual constracting of exception.
     */ Exception.CreateSimpleException = function(message, typeName, assembly, fileName, details, line) {
        var _a;
        return {
            exceptions: [
                (_a = {}, _a[0, $9udGf._DYN_HAS_FULL_STACK /* @min:hasFullStack */ ] = true, _a.message = message, _a.stack = details, _a.typeName = typeName, _a)
            ]
        };
    };
    Exception.envelopeType = "Microsoft.ApplicationInsights.{0}.Exception";
    Exception.dataType = "ExceptionData";
    Exception.formatError = $29cc9804e37f51b3$export$7eb96e918bb60d21;
    return Exception;
}();
var $29cc9804e37f51b3$export$39152eac9dc76c5e = /** @class */ function() {
    function _ExceptionDetails(logger, exception, properties) {
        this.aiDataContract = {
            id: 0 /* FieldType.Default */ ,
            outerId: 0 /* FieldType.Default */ ,
            typeName: 1 /* FieldType.Required */ ,
            message: 1 /* FieldType.Required */ ,
            hasFullStack: 0 /* FieldType.Default */ ,
            stack: 0 /* FieldType.Default */ ,
            parsedStack: 2 /* FieldType.Array */ 
        };
        var _self = this;
        if (!$29cc9804e37f51b3$var$_isExceptionDetailsInternal(exception)) {
            var error = exception;
            var evt = error && error.evt;
            if (!(0, $erRAP.isError)(error)) error = error[$29cc9804e37f51b3$var$strError] || evt || error;
            _self[0, $9udGf._DYN_TYPE_NAME /* @min:%2etypeName */ ] = (0, $cGFCT.dataSanitizeString)(logger, $29cc9804e37f51b3$var$_getErrorType(error)) || (0, $dCW8D.strNotSpecified);
            _self[0, $9udGf._DYN_MESSAGE /* @min:%2emessage */ ] = (0, $cGFCT.dataSanitizeMessage)(logger, $29cc9804e37f51b3$var$_formatMessage(exception || error, _self[0, $9udGf._DYN_TYPE_NAME /* @min:%2etypeName */ ])) || (0, $dCW8D.strNotSpecified);
            var stack = exception[$29cc9804e37f51b3$var$strStackDetails] || $29cc9804e37f51b3$var$_getStackFromErrorObj(exception);
            _self[0, $9udGf._DYN_PARSED_STACK /* @min:%2eparsedStack */ ] = $29cc9804e37f51b3$var$_parseStack(stack);
            // after parsedStack is inited, iterate over each frame object, sanitize its assembly field
            if ((0, $erRAP.isArray)(_self[0, $9udGf._DYN_PARSED_STACK /* @min:%2eparsedStack */ ])) (0, $erRAP.arrMap)(_self[0, $9udGf._DYN_PARSED_STACK /* @min:%2eparsedStack */ ], function(frame) {
                frame[0, $9udGf._DYN_ASSEMBLY /* @min:%2eassembly */ ] = (0, $cGFCT.dataSanitizeString)(logger, frame[0, $9udGf._DYN_ASSEMBLY /* @min:%2eassembly */ ]);
                frame[0, $9udGf._DYN_FILE_NAME /* @min:%2efileName */ ] = (0, $cGFCT.dataSanitizeString)(logger, frame[0, $9udGf._DYN_FILE_NAME /* @min:%2efileName */ ]);
            });
            _self[$29cc9804e37f51b3$var$strStack] = (0, $cGFCT.dataSanitizeException)(logger, $29cc9804e37f51b3$var$_formatStackTrace(stack));
            _self.hasFullStack = (0, $erRAP.isArray)(_self.parsedStack) && _self.parsedStack[0, $9udGf._DYN_LENGTH /* @min:%2elength */ ] > 0;
            if (properties) properties[0, $9udGf._DYN_TYPE_NAME /* @min:%2etypeName */ ] = properties[0, $9udGf._DYN_TYPE_NAME /* @min:%2etypeName */ ] || _self[0, $9udGf._DYN_TYPE_NAME /* @min:%2etypeName */ ];
        } else {
            _self[0, $9udGf._DYN_TYPE_NAME /* @min:%2etypeName */ ] = exception[0, $9udGf._DYN_TYPE_NAME /* @min:%2etypeName */ ];
            _self[0, $9udGf._DYN_MESSAGE /* @min:%2emessage */ ] = exception[0, $9udGf._DYN_MESSAGE /* @min:%2emessage */ ];
            _self[$29cc9804e37f51b3$var$strStack] = exception[$29cc9804e37f51b3$var$strStack];
            _self[0, $9udGf._DYN_PARSED_STACK /* @min:%2eparsedStack */ ] = exception[0, $9udGf._DYN_PARSED_STACK /* @min:%2eparsedStack */ ] || [];
            _self[0, $9udGf._DYN_HAS_FULL_STACK /* @min:%2ehasFullStack */ ] = exception[0, $9udGf._DYN_HAS_FULL_STACK /* @min:%2ehasFullStack */ ];
        }
    }
    _ExceptionDetails.prototype.toInterface = function() {
        var _a;
        var _self = this;
        var parsedStack = _self[0, $9udGf._DYN_PARSED_STACK /* @min:%2eparsedStack */ ] instanceof Array && (0, $erRAP.arrMap)(_self[0, $9udGf._DYN_PARSED_STACK /* @min:%2eparsedStack */ ], function(frame) {
            return frame.toInterface();
        });
        var exceptionDetailsInterface = (_a = {
            id: _self.id,
            outerId: _self.outerId,
            typeName: _self[0, $9udGf._DYN_TYPE_NAME /* @min:%2etypeName */ ],
            message: _self[0, $9udGf._DYN_MESSAGE /* @min:%2emessage */ ],
            hasFullStack: _self[0, $9udGf._DYN_HAS_FULL_STACK /* @min:%2ehasFullStack */ ],
            stack: _self[$29cc9804e37f51b3$var$strStack]
        }, _a[0, $9udGf._DYN_PARSED_STACK /* @min:parsedStack */ ] = parsedStack || undefined, _a);
        return exceptionDetailsInterface;
    };
    _ExceptionDetails.CreateFromInterface = function(logger, exception) {
        var parsedStack = exception[0, $9udGf._DYN_PARSED_STACK /* @min:%2eparsedStack */ ] instanceof Array && (0, $erRAP.arrMap)(exception[0, $9udGf._DYN_PARSED_STACK /* @min:%2eparsedStack */ ], function(frame) {
            return $29cc9804e37f51b3$export$b9d0519a34c90616[0, $9udGf._DYN__CREATE_FROM_INTERFA1 /* @min:%2eCreateFromInterface */ ](frame);
        }) || exception[0, $9udGf._DYN_PARSED_STACK /* @min:%2eparsedStack */ ];
        var exceptionDetails = new _ExceptionDetails(logger, (0, $fcMe7.__assignFn)((0, $fcMe7.__assignFn)({}, exception), {
            parsedStack: parsedStack
        }));
        return exceptionDetails;
    };
    return _ExceptionDetails;
}();
var $29cc9804e37f51b3$export$b9d0519a34c90616 = /** @class */ function() {
    function _StackFrame(sourceFrame, level) {
        this.aiDataContract = {
            level: 1 /* FieldType.Required */ ,
            method: 1 /* FieldType.Required */ ,
            assembly: 0 /* FieldType.Default */ ,
            fileName: 0 /* FieldType.Default */ ,
            line: 0 /* FieldType.Default */ 
        };
        var _self = this;
        _self[0, $9udGf._DYN_SIZE_IN_BYTES /* @min:%2esizeInBytes */ ] = 0;
        // Not converting this to isString() as typescript uses this logic to "understand" the different
        // types for the 2 different code paths
        if (typeof sourceFrame === "string") {
            var frame = sourceFrame;
            _self[0, $9udGf._DYN_LEVEL /* @min:%2elevel */ ] = level;
            _self[0, $9udGf._DYN_METHOD /* @min:%2emethod */ ] = $29cc9804e37f51b3$var$NoMethod;
            _self[0, $9udGf._DYN_ASSEMBLY /* @min:%2eassembly */ ] = (0, $erRAP.strTrim)(frame);
            _self[0, $9udGf._DYN_FILE_NAME /* @min:%2efileName */ ] = "";
            _self[0, $9udGf._DYN_LINE /* @min:%2eline */ ] = 0;
            var matches = frame.match(_StackFrame.regex);
            if (matches && matches[0, $9udGf._DYN_LENGTH /* @min:%2elength */ ] >= 5) {
                _self[0, $9udGf._DYN_METHOD /* @min:%2emethod */ ] = (0, $erRAP.strTrim)(matches[2]) || _self[0, $9udGf._DYN_METHOD /* @min:%2emethod */ ];
                _self[0, $9udGf._DYN_FILE_NAME /* @min:%2efileName */ ] = (0, $erRAP.strTrim)(matches[4]);
                _self[0, $9udGf._DYN_LINE /* @min:%2eline */ ] = parseInt(matches[5]) || 0;
            }
        } else {
            _self[0, $9udGf._DYN_LEVEL /* @min:%2elevel */ ] = sourceFrame[0, $9udGf._DYN_LEVEL /* @min:%2elevel */ ];
            _self[0, $9udGf._DYN_METHOD /* @min:%2emethod */ ] = sourceFrame[0, $9udGf._DYN_METHOD /* @min:%2emethod */ ];
            _self[0, $9udGf._DYN_ASSEMBLY /* @min:%2eassembly */ ] = sourceFrame[0, $9udGf._DYN_ASSEMBLY /* @min:%2eassembly */ ];
            _self[0, $9udGf._DYN_FILE_NAME /* @min:%2efileName */ ] = sourceFrame[0, $9udGf._DYN_FILE_NAME /* @min:%2efileName */ ];
            _self[0, $9udGf._DYN_LINE /* @min:%2eline */ ] = sourceFrame[0, $9udGf._DYN_LINE /* @min:%2eline */ ];
            _self[0, $9udGf._DYN_SIZE_IN_BYTES /* @min:%2esizeInBytes */ ] = 0;
        }
        _self.sizeInBytes += _self.method[0, $9udGf._DYN_LENGTH /* @min:%2elength */ ];
        _self.sizeInBytes += _self.fileName[0, $9udGf._DYN_LENGTH /* @min:%2elength */ ];
        _self.sizeInBytes += _self.assembly[0, $9udGf._DYN_LENGTH /* @min:%2elength */ ];
        // todo: these might need to be removed depending on how the back-end settles on their size calculation
        _self[0, $9udGf._DYN_SIZE_IN_BYTES /* @min:%2esizeInBytes */ ] += _StackFrame.baseSize;
        _self.sizeInBytes += _self.level.toString()[0, $9udGf._DYN_LENGTH /* @min:%2elength */ ];
        _self.sizeInBytes += _self.line.toString()[0, $9udGf._DYN_LENGTH /* @min:%2elength */ ];
    }
    _StackFrame.CreateFromInterface = function(frame) {
        return new _StackFrame(frame, null);
    };
    _StackFrame.prototype.toInterface = function() {
        var _self = this;
        return {
            level: _self[0, $9udGf._DYN_LEVEL /* @min:%2elevel */ ],
            method: _self[0, $9udGf._DYN_METHOD /* @min:%2emethod */ ],
            assembly: _self[0, $9udGf._DYN_ASSEMBLY /* @min:%2eassembly */ ],
            fileName: _self[0, $9udGf._DYN_FILE_NAME /* @min:%2efileName */ ],
            line: _self[0, $9udGf._DYN_LINE /* @min:%2eline */ ]
        };
    };
    // regex to match stack frames from ie/chrome/ff
    // methodName=$2, fileName=$4, lineNo=$5, column=$6
    _StackFrame.regex = /^([\s]+at)?[\s]{0,50}([^\@\()]+?)[\s]{0,50}(\@|\()([^\(\n]+):([0-9]+):([0-9]+)(\)?)$/;
    _StackFrame.baseSize = 58; // '{"method":"","level":,"assembly":"","fileName":"","line":}'.length
    return _StackFrame;
}();

});

parcelRegister("ihDSn", function(module, exports) {

$parcel$export(module.exports, "Metric", function () { return $d4f8bf18872141e7$export$efdd3e096bc27746; });
/*
 * Application Insights JavaScript SDK - Common, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $dCW8D = parcelRequire("dCW8D");

var $9udGf = parcelRequire("9udGf");

var $8t4wV = parcelRequire("8t4wV");

var $cGFCT = parcelRequire("cGFCT");
var $d4f8bf18872141e7$export$efdd3e096bc27746 = /** @class */ function() {
    /**
     * Constructs a new instance of the MetricTelemetry object
     */ function Metric(logger, name, value, count, min, max, stdDev, properties, measurements) {
        this.aiDataContract = {
            ver: 1 /* FieldType.Required */ ,
            metrics: 1 /* FieldType.Required */ ,
            properties: 0 /* FieldType.Default */ 
        };
        var _self = this;
        _self.ver = 2;
        var dataPoint = new (0, $8t4wV.DataPoint)();
        dataPoint[0, $9udGf._DYN_COUNT /* @min:%2ecount */ ] = count > 0 ? count : undefined;
        dataPoint.max = isNaN(max) || max === null ? undefined : max;
        dataPoint.min = isNaN(min) || min === null ? undefined : min;
        dataPoint[0, $9udGf._DYN_NAME /* @min:%2ename */ ] = (0, $cGFCT.dataSanitizeString)(logger, name) || (0, $dCW8D.strNotSpecified);
        dataPoint.value = value;
        dataPoint.stdDev = isNaN(stdDev) || stdDev === null ? undefined : stdDev;
        _self.metrics = [
            dataPoint
        ];
        _self[0, $9udGf._DYN_PROPERTIES /* @min:%2eproperties */ ] = (0, $cGFCT.dataSanitizeProperties)(logger, properties);
        _self[0, $9udGf._DYN_MEASUREMENTS /* @min:%2emeasurements */ ] = (0, $cGFCT.dataSanitizeMeasurements)(logger, measurements);
    }
    Metric.envelopeType = "Microsoft.ApplicationInsights.{0}.Metric";
    Metric.dataType = "MetricData";
    return Metric;
}();

});
parcelRegister("8t4wV", function(module, exports) {

$parcel$export(module.exports, "DataPoint", function () { return $62a48bb91ffca27d$export$7e0232b0f089a6b8; });
/*
 * Application Insights JavaScript SDK - Common, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ var $62a48bb91ffca27d$export$7e0232b0f089a6b8 = /** @class */ function() {
    function DataPoint() {
        /**
         * The data contract for serializing this object.
         */ this.aiDataContract = {
            name: 1 /* FieldType.Required */ ,
            kind: 0 /* FieldType.Default */ ,
            value: 1 /* FieldType.Required */ ,
            count: 0 /* FieldType.Default */ ,
            min: 0 /* FieldType.Default */ ,
            max: 0 /* FieldType.Default */ ,
            stdDev: 0 /* FieldType.Default */ 
        };
        /**
         * Metric type. Single measurement or the aggregated value.
         */ this.kind = 0 /* DataPointType.Measurement */ ;
    }
    return DataPoint;
}();

});


parcelRegister("80I4P", function(module, exports) {

$parcel$export(module.exports, "PageView", function () { return $5d50838a9e0d1959$export$12c0fdede1c6bc6c; });
/*
 * Application Insights JavaScript SDK - Common, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $dCW8D = parcelRequire("dCW8D");

var $6Gvon = parcelRequire("6Gvon");

var $9udGf = parcelRequire("9udGf");

var $cGFCT = parcelRequire("cGFCT");
var $5d50838a9e0d1959$export$12c0fdede1c6bc6c = /** @class */ function() {
    /**
     * Constructs a new instance of the PageEventTelemetry object
     */ function PageView(logger, name, url, durationMs, properties, measurements, id) {
        this.aiDataContract = {
            ver: 1 /* FieldType.Required */ ,
            name: 0 /* FieldType.Default */ ,
            url: 0 /* FieldType.Default */ ,
            duration: 0 /* FieldType.Default */ ,
            properties: 0 /* FieldType.Default */ ,
            measurements: 0 /* FieldType.Default */ ,
            id: 0 /* FieldType.Default */ 
        };
        var _self = this;
        _self.ver = 2;
        _self.id = (0, $cGFCT.dataSanitizeId)(logger, id);
        _self.url = (0, $cGFCT.dataSanitizeUrl)(logger, url);
        _self[0, $9udGf._DYN_NAME /* @min:%2ename */ ] = (0, $cGFCT.dataSanitizeString)(logger, name) || (0, $dCW8D.strNotSpecified);
        if (!isNaN(durationMs)) _self[0, $9udGf._DYN_DURATION /* @min:%2eduration */ ] = (0, $6Gvon.msToTimeSpan)(durationMs);
        _self[0, $9udGf._DYN_PROPERTIES /* @min:%2eproperties */ ] = (0, $cGFCT.dataSanitizeProperties)(logger, properties);
        _self[0, $9udGf._DYN_MEASUREMENTS /* @min:%2emeasurements */ ] = (0, $cGFCT.dataSanitizeMeasurements)(logger, measurements);
    }
    PageView.envelopeType = "Microsoft.ApplicationInsights.{0}.Pageview";
    PageView.dataType = "PageviewData";
    return PageView;
}();

});

parcelRegister("7fph4", function(module, exports) {

$parcel$export(module.exports, "RemoteDependencyData", function () { return $546d8a134146d222$export$a7b48490930dbffa; });
/*
 * Application Insights JavaScript SDK - Common, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $6Gvon = parcelRequire("6Gvon");

var $4sUzw = parcelRequire("4sUzw");

var $9udGf = parcelRequire("9udGf");

var $cGFCT = parcelRequire("cGFCT");
var $546d8a134146d222$export$a7b48490930dbffa = /** @class */ function() {
    /**
     * Constructs a new instance of the RemoteDependencyData object
     */ function RemoteDependencyData(logger, id, absoluteUrl, commandName, value, success, resultCode, method, requestAPI, correlationContext, properties, measurements) {
        if (requestAPI === void 0) requestAPI = "Ajax";
        this.aiDataContract = {
            id: 1 /* FieldType.Required */ ,
            ver: 1 /* FieldType.Required */ ,
            name: 0 /* FieldType.Default */ ,
            resultCode: 0 /* FieldType.Default */ ,
            duration: 0 /* FieldType.Default */ ,
            success: 0 /* FieldType.Default */ ,
            data: 0 /* FieldType.Default */ ,
            target: 0 /* FieldType.Default */ ,
            type: 0 /* FieldType.Default */ ,
            properties: 0 /* FieldType.Default */ ,
            measurements: 0 /* FieldType.Default */ ,
            kind: 0 /* FieldType.Default */ ,
            value: 0 /* FieldType.Default */ ,
            count: 0 /* FieldType.Default */ ,
            min: 0 /* FieldType.Default */ ,
            max: 0 /* FieldType.Default */ ,
            stdDev: 0 /* FieldType.Default */ ,
            dependencyKind: 0 /* FieldType.Default */ ,
            dependencySource: 0 /* FieldType.Default */ ,
            commandName: 0 /* FieldType.Default */ ,
            dependencyTypeName: 0 /* FieldType.Default */ 
        };
        var _self = this;
        _self.ver = 2;
        _self.id = id;
        _self[0, $9udGf._DYN_DURATION /* @min:%2eduration */ ] = (0, $6Gvon.msToTimeSpan)(value);
        _self.success = success;
        _self.resultCode = resultCode + "";
        _self.type = (0, $cGFCT.dataSanitizeString)(logger, requestAPI);
        var dependencyFields = (0, $4sUzw.AjaxHelperParseDependencyPath)(logger, absoluteUrl, method, commandName);
        _self.data = (0, $cGFCT.dataSanitizeUrl)(logger, commandName) || dependencyFields.data; // get a value from hosturl if commandName not available
        _self.target = (0, $cGFCT.dataSanitizeString)(logger, dependencyFields.target);
        if (correlationContext) _self.target = "".concat(_self.target, " | ").concat(correlationContext);
        _self[0, $9udGf._DYN_NAME /* @min:%2ename */ ] = (0, $cGFCT.dataSanitizeString)(logger, dependencyFields[0, $9udGf._DYN_NAME /* @min:%2ename */ ]);
        _self[0, $9udGf._DYN_PROPERTIES /* @min:%2eproperties */ ] = (0, $cGFCT.dataSanitizeProperties)(logger, properties);
        _self[0, $9udGf._DYN_MEASUREMENTS /* @min:%2emeasurements */ ] = (0, $cGFCT.dataSanitizeMeasurements)(logger, measurements);
    }
    RemoteDependencyData.envelopeType = "Microsoft.ApplicationInsights.{0}.RemoteDependency";
    RemoteDependencyData.dataType = "RemoteDependencyData";
    return RemoteDependencyData;
}();

});

parcelRegister("lL63Q", function(module, exports) {

$parcel$export(module.exports, "Trace", function () { return $fd72b054fc6ab597$export$78e1bea9036f120f; });
/*
 * Application Insights JavaScript SDK - Common, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $dCW8D = parcelRequire("dCW8D");

var $9udGf = parcelRequire("9udGf");

var $cGFCT = parcelRequire("cGFCT");
var $fd72b054fc6ab597$export$78e1bea9036f120f = /** @class */ function() {
    /**
     * Constructs a new instance of the TraceTelemetry object
     */ function Trace(logger, message, severityLevel, properties, measurements) {
        this.aiDataContract = {
            ver: 1 /* FieldType.Required */ ,
            message: 1 /* FieldType.Required */ ,
            severityLevel: 0 /* FieldType.Default */ ,
            properties: 0 /* FieldType.Default */ 
        };
        var _self = this;
        _self.ver = 2;
        message = message || (0, $dCW8D.strNotSpecified);
        _self[0, $9udGf._DYN_MESSAGE /* @min:%2emessage */ ] = (0, $cGFCT.dataSanitizeMessage)(logger, message);
        _self[0, $9udGf._DYN_PROPERTIES /* @min:%2eproperties */ ] = (0, $cGFCT.dataSanitizeProperties)(logger, properties);
        _self[0, $9udGf._DYN_MEASUREMENTS /* @min:%2emeasurements */ ] = (0, $cGFCT.dataSanitizeMeasurements)(logger, measurements);
        if (severityLevel) _self[0, $9udGf._DYN_SEVERITY_LEVEL /* @min:%2eseverityLevel */ ] = severityLevel;
    }
    Trace.envelopeType = "Microsoft.ApplicationInsights.{0}.Message";
    Trace.dataType = "MessageData";
    return Trace;
}();

});

parcelRegister("bmYDZ", function(module, exports) {

$parcel$export(module.exports, "PageViewPerformance", function () { return $8470ca6903d47bd7$export$709aae57ec681346; });
/*
 * Application Insights JavaScript SDK - Common, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $dCW8D = parcelRequire("dCW8D");

var $9udGf = parcelRequire("9udGf");

var $cGFCT = parcelRequire("cGFCT");
var $8470ca6903d47bd7$export$709aae57ec681346 = /** @class */ function() {
    /**
     * Constructs a new instance of the PageEventTelemetry object
     */ function PageViewPerformance(logger, name, url, unused, properties, measurements, cs4BaseData) {
        this.aiDataContract = {
            ver: 1 /* FieldType.Required */ ,
            name: 0 /* FieldType.Default */ ,
            url: 0 /* FieldType.Default */ ,
            duration: 0 /* FieldType.Default */ ,
            perfTotal: 0 /* FieldType.Default */ ,
            networkConnect: 0 /* FieldType.Default */ ,
            sentRequest: 0 /* FieldType.Default */ ,
            receivedResponse: 0 /* FieldType.Default */ ,
            domProcessing: 0 /* FieldType.Default */ ,
            properties: 0 /* FieldType.Default */ ,
            measurements: 0 /* FieldType.Default */ 
        };
        var _self = this;
        _self.ver = 2;
        _self.url = (0, $cGFCT.dataSanitizeUrl)(logger, url);
        _self[0, $9udGf._DYN_NAME /* @min:%2ename */ ] = (0, $cGFCT.dataSanitizeString)(logger, name) || (0, $dCW8D.strNotSpecified);
        _self[0, $9udGf._DYN_PROPERTIES /* @min:%2eproperties */ ] = (0, $cGFCT.dataSanitizeProperties)(logger, properties);
        _self[0, $9udGf._DYN_MEASUREMENTS /* @min:%2emeasurements */ ] = (0, $cGFCT.dataSanitizeMeasurements)(logger, measurements);
        if (cs4BaseData) {
            _self.domProcessing = cs4BaseData.domProcessing;
            _self[0, $9udGf._DYN_DURATION /* @min:%2eduration */ ] = cs4BaseData[0, $9udGf._DYN_DURATION /* @min:%2eduration */ ];
            _self.networkConnect = cs4BaseData.networkConnect;
            _self.perfTotal = cs4BaseData.perfTotal;
            _self[0, $9udGf._DYN_RECEIVED_RESPONSE /* @min:%2ereceivedResponse */ ] = cs4BaseData[0, $9udGf._DYN_RECEIVED_RESPONSE /* @min:%2ereceivedResponse */ ];
            _self.sentRequest = cs4BaseData.sentRequest;
        }
    }
    PageViewPerformance.envelopeType = "Microsoft.ApplicationInsights.{0}.PageviewPerformance";
    PageViewPerformance.dataType = "PageviewPerformanceData";
    return PageViewPerformance;
}();

});

parcelRegister("coTnQ", function(module, exports) {

$parcel$export(module.exports, "Data", function () { return $9072aff45712c30f$export$2d0294657ab35f1b; });
/*
 * Application Insights JavaScript SDK - Common, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ var $9072aff45712c30f$export$2d0294657ab35f1b = /** @class */ function() {
    /**
     * Constructs a new instance of telemetry data.
     */ function Data(baseType, data) {
        /**
         * The data contract for serializing this object.
         */ this.aiDataContract = {
            baseType: 1 /* FieldType.Required */ ,
            baseData: 1 /* FieldType.Required */ 
        };
        this.baseType = baseType;
        this.baseData = data;
    }
    return Data;
}();

});

parcelRegister("7504k", function(module, exports) {

$parcel$export(module.exports, "SeverityLevel", function () { return $52790db704edce4d$export$ee93949637004a58; });
/*
 * Application Insights JavaScript SDK - Common, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $4z4ow = parcelRequire("4z4ow");
var $52790db704edce4d$export$ee93949637004a58 = (0, $4z4ow.createEnumStyle)({
    Verbose: 0 /* eSeverityLevel.Verbose */ ,
    Information: 1 /* eSeverityLevel.Information */ ,
    Warning: 2 /* eSeverityLevel.Warning */ ,
    Error: 3 /* eSeverityLevel.Error */ ,
    Critical: 4 /* eSeverityLevel.Critical */ 
});

});

parcelRegister("jqqu3", function(module, exports) {

$parcel$export(module.exports, "ConfigurationManager", function () { return $e244fd2372c39c78$export$20f75fb4cfd446c4; });
/*
 * Application Insights JavaScript SDK - Common, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $erRAP = parcelRequire("erRAP");

var $9udGf = parcelRequire("9udGf");
var $e244fd2372c39c78$export$20f75fb4cfd446c4 = /** @class */ function() {
    function ConfigurationManager() {}
    ConfigurationManager.getConfig = function(config, field, identifier, defaultValue) {
        if (defaultValue === void 0) defaultValue = false;
        var configValue;
        if (identifier && config[0, $9udGf._DYN_EXTENSION_CONFIG /* @min:%2eextensionConfig */ ] && config[0, $9udGf._DYN_EXTENSION_CONFIG /* @min:%2eextensionConfig */ ][identifier] && !(0, $erRAP.isNullOrUndefined)(config[0, $9udGf._DYN_EXTENSION_CONFIG /* @min:%2eextensionConfig */ ][identifier][field])) configValue = config[0, $9udGf._DYN_EXTENSION_CONFIG /* @min:%2eextensionConfig */ ][identifier][field];
        else configValue = config[field];
        return !(0, $erRAP.isNullOrUndefined)(configValue) ? configValue : defaultValue;
    };
    return ConfigurationManager;
}();

});

parcelRegister("gygzP", function(module, exports) {

$parcel$export(module.exports, "ContextTagKeys", function () { return $c0ccae2188c21655$export$8e2bcdf18620784a; });
/*
 * Application Insights JavaScript SDK - Common, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $fcMe7 = parcelRequire("fcMe7");

var $erRAP = parcelRequire("erRAP");
function $c0ccae2188c21655$var$_aiNameFunc(baseName) {
    var aiName = "ai." + baseName + ".";
    return function(name) {
        return aiName + name;
    };
}
var $c0ccae2188c21655$var$_aiApplication = $c0ccae2188c21655$var$_aiNameFunc("application");
var $c0ccae2188c21655$var$_aiDevice = $c0ccae2188c21655$var$_aiNameFunc("device");
var $c0ccae2188c21655$var$_aiLocation = $c0ccae2188c21655$var$_aiNameFunc("location");
var $c0ccae2188c21655$var$_aiOperation = $c0ccae2188c21655$var$_aiNameFunc("operation");
var $c0ccae2188c21655$var$_aiSession = $c0ccae2188c21655$var$_aiNameFunc("session");
var $c0ccae2188c21655$var$_aiUser = $c0ccae2188c21655$var$_aiNameFunc("user");
var $c0ccae2188c21655$var$_aiCloud = $c0ccae2188c21655$var$_aiNameFunc("cloud");
var $c0ccae2188c21655$var$_aiInternal = $c0ccae2188c21655$var$_aiNameFunc("internal");
var $c0ccae2188c21655$export$8e2bcdf18620784a = /** @class */ function(_super) {
    (0, $fcMe7.__extendsFn)(ContextTagKeys, _super);
    function ContextTagKeys() {
        return _super.call(this) || this;
    }
    return ContextTagKeys;
}((0, $erRAP.createClassFromInterface)({
    applicationVersion: $c0ccae2188c21655$var$_aiApplication("ver"),
    applicationBuild: $c0ccae2188c21655$var$_aiApplication("build"),
    applicationTypeId: $c0ccae2188c21655$var$_aiApplication("typeId"),
    applicationId: $c0ccae2188c21655$var$_aiApplication("applicationId"),
    applicationLayer: $c0ccae2188c21655$var$_aiApplication("layer"),
    deviceId: $c0ccae2188c21655$var$_aiDevice("id"),
    deviceIp: $c0ccae2188c21655$var$_aiDevice("ip"),
    deviceLanguage: $c0ccae2188c21655$var$_aiDevice("language"),
    deviceLocale: $c0ccae2188c21655$var$_aiDevice("locale"),
    deviceModel: $c0ccae2188c21655$var$_aiDevice("model"),
    deviceFriendlyName: $c0ccae2188c21655$var$_aiDevice("friendlyName"),
    deviceNetwork: $c0ccae2188c21655$var$_aiDevice("network"),
    deviceNetworkName: $c0ccae2188c21655$var$_aiDevice("networkName"),
    deviceOEMName: $c0ccae2188c21655$var$_aiDevice("oemName"),
    deviceOS: $c0ccae2188c21655$var$_aiDevice("os"),
    deviceOSVersion: $c0ccae2188c21655$var$_aiDevice("osVersion"),
    deviceRoleInstance: $c0ccae2188c21655$var$_aiDevice("roleInstance"),
    deviceRoleName: $c0ccae2188c21655$var$_aiDevice("roleName"),
    deviceScreenResolution: $c0ccae2188c21655$var$_aiDevice("screenResolution"),
    deviceType: $c0ccae2188c21655$var$_aiDevice("type"),
    deviceMachineName: $c0ccae2188c21655$var$_aiDevice("machineName"),
    deviceVMName: $c0ccae2188c21655$var$_aiDevice("vmName"),
    deviceBrowser: $c0ccae2188c21655$var$_aiDevice("browser"),
    deviceBrowserVersion: $c0ccae2188c21655$var$_aiDevice("browserVersion"),
    locationIp: $c0ccae2188c21655$var$_aiLocation("ip"),
    locationCountry: $c0ccae2188c21655$var$_aiLocation("country"),
    locationProvince: $c0ccae2188c21655$var$_aiLocation("province"),
    locationCity: $c0ccae2188c21655$var$_aiLocation("city"),
    operationId: $c0ccae2188c21655$var$_aiOperation("id"),
    operationName: $c0ccae2188c21655$var$_aiOperation("name"),
    operationParentId: $c0ccae2188c21655$var$_aiOperation("parentId"),
    operationRootId: $c0ccae2188c21655$var$_aiOperation("rootId"),
    operationSyntheticSource: $c0ccae2188c21655$var$_aiOperation("syntheticSource"),
    operationCorrelationVector: $c0ccae2188c21655$var$_aiOperation("correlationVector"),
    sessionId: $c0ccae2188c21655$var$_aiSession("id"),
    sessionIsFirst: $c0ccae2188c21655$var$_aiSession("isFirst"),
    sessionIsNew: $c0ccae2188c21655$var$_aiSession("isNew"),
    userAccountAcquisitionDate: $c0ccae2188c21655$var$_aiUser("accountAcquisitionDate"),
    userAccountId: $c0ccae2188c21655$var$_aiUser("accountId"),
    userAgent: $c0ccae2188c21655$var$_aiUser("userAgent"),
    userId: $c0ccae2188c21655$var$_aiUser("id"),
    userStoreRegion: $c0ccae2188c21655$var$_aiUser("storeRegion"),
    userAuthUserId: $c0ccae2188c21655$var$_aiUser("authUserId"),
    userAnonymousUserAcquisitionDate: $c0ccae2188c21655$var$_aiUser("anonUserAcquisitionDate"),
    userAuthenticatedUserAcquisitionDate: $c0ccae2188c21655$var$_aiUser("authUserAcquisitionDate"),
    cloudName: $c0ccae2188c21655$var$_aiCloud("name"),
    cloudRole: $c0ccae2188c21655$var$_aiCloud("role"),
    cloudRoleVer: $c0ccae2188c21655$var$_aiCloud("roleVer"),
    cloudRoleInstance: $c0ccae2188c21655$var$_aiCloud("roleInstance"),
    cloudEnvironment: $c0ccae2188c21655$var$_aiCloud("environment"),
    cloudLocation: $c0ccae2188c21655$var$_aiCloud("location"),
    cloudDeploymentUnit: $c0ccae2188c21655$var$_aiCloud("deploymentUnit"),
    internalNodeName: $c0ccae2188c21655$var$_aiInternal("nodeName"),
    internalSdkVersion: $c0ccae2188c21655$var$_aiInternal("sdkVersion"),
    internalAgentVersion: $c0ccae2188c21655$var$_aiInternal("agentVersion"),
    internalSnippet: $c0ccae2188c21655$var$_aiInternal("snippet"),
    internalSdkSrc: $c0ccae2188c21655$var$_aiInternal("sdkSrc")
}));

});

parcelRegister("62ywT", function(module, exports) {

$parcel$export(module.exports, "createTelemetryItem", function () { return $465db6cee476e8cf$export$2dc41327de8d98f1; });
$parcel$export(module.exports, "TelemetryItemCreator", function () { return $465db6cee476e8cf$export$7af32501561f3b4a; });
/*
 * Application Insights JavaScript SDK - Common, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $erRAP = parcelRequire("erRAP");

var $dCW8D = parcelRequire("dCW8D");

var $cGFCT = parcelRequire("cGFCT");

var $9udGf = parcelRequire("9udGf");
function $465db6cee476e8cf$export$2dc41327de8d98f1(item, baseType, envelopeName, logger, customProperties, systemProperties) {
    var _a;
    envelopeName = (0, $cGFCT.dataSanitizeString)(logger, envelopeName) || (0, $dCW8D.strNotSpecified);
    if ((0, $erRAP.isNullOrUndefined)(item) || (0, $erRAP.isNullOrUndefined)(baseType) || (0, $erRAP.isNullOrUndefined)(envelopeName)) (0, $erRAP.throwError)("Input doesn't contain all required fields");
    var iKey = "";
    if (item[0, $dCW8D.strIkey]) {
        iKey = item[0, $dCW8D.strIkey];
        delete item[0, $dCW8D.strIkey];
    }
    var telemetryItem = (_a = {}, _a[0, $9udGf._DYN_NAME /* @min:name */ ] = envelopeName, _a.time = (0, $erRAP.toISOString)(new Date()), _a.iKey = iKey, _a.ext = systemProperties ? systemProperties : {}, _a.tags = [], _a.data = {}, _a.baseType = baseType, _a.baseData = item // Part B
    , _a);
    // Part C
    if (!(0, $erRAP.isNullOrUndefined)(customProperties)) (0, $erRAP.objForEachKey)(customProperties, function(prop, value) {
        telemetryItem.data[prop] = value;
    });
    return telemetryItem;
}
var $465db6cee476e8cf$export$7af32501561f3b4a = /** @class */ function() {
    function TelemetryItemCreator() {}
    /**
     * Create a telemetry item that the 1DS channel understands
     * @param item domain specific properties; part B
     * @param baseType telemetry item type. ie PageViewData
     * @param envelopeName name of the envelope. ie Microsoft.ApplicationInsights.<instrumentation key>.PageView
     * @param customProperties user defined custom properties; part C
     * @param systemProperties system properties that are added to the context; part A
     * @returns ITelemetryItem that is sent to channel
     */ TelemetryItemCreator.create = $465db6cee476e8cf$export$2dc41327de8d98f1;
    return TelemetryItemCreator;
}();

});

parcelRegister("2gDxc", function(module, exports) {

$parcel$export(module.exports, "Extensions", function () { return $1a6bbe20328a8f03$export$152f4bb29f8263d0; });
$parcel$export(module.exports, "CtxTagKeys", function () { return $1a6bbe20328a8f03$export$ebc7727f2a4272f6; });
/*
 * Application Insights JavaScript SDK - Common, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $gygzP = parcelRequire("gygzP");
var $1a6bbe20328a8f03$export$152f4bb29f8263d0 = {
    UserExt: "user",
    DeviceExt: "device",
    TraceExt: "trace",
    WebExt: "web",
    AppExt: "app",
    OSExt: "os",
    SessionExt: "ses",
    SDKExt: "sdk"
};
var $1a6bbe20328a8f03$export$ebc7727f2a4272f6 = new (0, $gygzP.ContextTagKeys)();

});


parcelRegister("3wvVb", function(module, exports) {

$parcel$export(module.exports, "BaseTelemetryPlugin", function () { return $290d1f2a78caf004$export$64a11c2f90e6766c; });
/*
 * Application Insights JavaScript SDK - Core, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $kbmky = parcelRequire("kbmky");

var $fX4fx = parcelRequire("fX4fx");

var $erRAP = parcelRequire("erRAP");

var $lxIpo = parcelRequire("lxIpo");

var $kry7o = parcelRequire("kry7o");

var $f3Boy = parcelRequire("f3Boy");
"use strict";
var $290d1f2a78caf004$var$strGetPlugin = "getPlugin";
/**
 * BaseTelemetryPlugin provides a basic implementation of the ITelemetryPlugin interface so that plugins
 * can avoid implementation the same set of boiler plate code as well as provide a base
 * implementation so that new default implementations can be added without breaking all plugins.
 */ var $290d1f2a78caf004$export$64a11c2f90e6766c = /** @class */ function() {
    function BaseTelemetryPlugin() {
        var _self = this; // Setting _self here as it's used outside of the dynamicProto as well
        // NOTE!: DON'T set default values here, instead set them in the _initDefaults() function as it is also called during teardown()
        var _isinitialized;
        var _rootCtx; // Used as the root context, holding the current config and initialized core
        var _nextPlugin; // Used for backward compatibility where plugins don't call the main pipeline
        var _unloadHandlerContainer;
        var _hooks;
        _initDefaults();
        (0, $kbmky.default)(BaseTelemetryPlugin, _self, function(_self) {
            _self[0, $fX4fx._DYN_INITIALIZE /* @min:%2einitialize */ ] = function(config, core, extensions, pluginChain) {
                _setDefaults(config, core, pluginChain);
                _isinitialized = true;
            };
            _self[0, $fX4fx._DYN_TEARDOWN /* @min:%2eteardown */ ] = function(unloadCtx, unloadState) {
                var _a;
                // If this plugin has already been torn down (not operational) or is not initialized (core is not set)
                // or the core being used for unload was not the same core used for initialization.
                var core = _self[0, $lxIpo.STR_CORE /* @min:%2ecore */ ];
                if (!core || unloadCtx && core !== unloadCtx[0, $lxIpo.STR_CORE /* @min:%2ecore */ ]()) // Do Nothing as either the plugin is not initialized or was not initialized by the current core
                return;
                var result;
                var unloadDone = false;
                var theUnloadCtx = unloadCtx || (0, $kry7o.createProcessTelemetryUnloadContext)(null, core, _nextPlugin && _nextPlugin[$290d1f2a78caf004$var$strGetPlugin] ? _nextPlugin[$290d1f2a78caf004$var$strGetPlugin]() : _nextPlugin);
                var theUnloadState = unloadState || (_a = {
                    reason: 0 /* TelemetryUnloadReason.ManualTeardown */ 
                }, _a[0, $fX4fx._DYN_IS_ASYNC /* @min:isAsync */ ] = false, _a);
                function _unloadCallback() {
                    if (!unloadDone) {
                        unloadDone = true;
                        _unloadHandlerContainer.run(theUnloadCtx, unloadState);
                        var oldHooks = _hooks;
                        _hooks = [];
                        // Remove all instrumentation hooks
                        (0, $erRAP.arrForEach)(oldHooks, function(fn) {
                            fn.rm();
                        });
                        if (result === true) theUnloadCtx[0, $fX4fx._DYN_PROCESS_NEXT /* @min:%2eprocessNext */ ](theUnloadState);
                        _initDefaults();
                    }
                }
                if (!_self[0, $fX4fx._DYN__DO_TEARDOWN /* @min:%2e_doTeardown */ ] || _self[0, $fX4fx._DYN__DO_TEARDOWN /* @min:%2e_doTeardown */ ](theUnloadCtx, theUnloadState, _unloadCallback) !== true) _unloadCallback();
                else // Tell the caller that we will be calling processNext()
                result = true;
                return result;
            };
            _self[0, $fX4fx._DYN_UPDATE /* @min:%2eupdate */ ] = function(updateCtx, updateState) {
                // If this plugin has already been torn down (not operational) or is not initialized (core is not set)
                // or the core being used for unload was not the same core used for initialization.
                var core = _self[0, $lxIpo.STR_CORE /* @min:%2ecore */ ];
                if (!core || updateCtx && core !== updateCtx[0, $lxIpo.STR_CORE /* @min:%2ecore */ ]()) // Do Nothing
                return;
                var result;
                var updateDone = false;
                var theUpdateCtx = updateCtx || (0, $kry7o.createProcessTelemetryUpdateContext)(null, core, _nextPlugin && _nextPlugin[$290d1f2a78caf004$var$strGetPlugin] ? _nextPlugin[$290d1f2a78caf004$var$strGetPlugin]() : _nextPlugin);
                var theUpdateState = updateState || {
                    reason: 0 /* TelemetryUpdateReason.Unknown */ 
                };
                function _updateCallback() {
                    if (!updateDone) {
                        updateDone = true;
                        _setDefaults(theUpdateCtx.getCfg(), theUpdateCtx.core(), theUpdateCtx[0, $fX4fx._DYN_GET_NEXT /* @min:%2egetNext */ ]());
                    }
                }
                if (!_self._doUpdate || _self._doUpdate(theUpdateCtx, theUpdateState, _updateCallback) !== true) _updateCallback();
                else result = true;
                return result;
            };
            _self._addHook = function(hooks) {
                if (hooks) {
                    if ((0, $erRAP.isArray)(hooks)) _hooks = _hooks.concat(hooks);
                    else _hooks[0, $fX4fx._DYN_PUSH /* @min:%2epush */ ](hooks);
                }
            };
            (0, $erRAP.proxyFunctionAs)(_self, "_addUnloadCb", function() {
                return _unloadHandlerContainer;
            }, "add");
        });
        // These are added after the dynamicProto so that are not moved to the prototype
        _self[0, $fX4fx._DYN_DIAG_LOG /* @min:%2ediagLog */ ] = function(itemCtx) {
            return _getTelCtx(itemCtx)[0, $fX4fx._DYN_DIAG_LOG /* @min:%2ediagLog */ ]();
        };
        _self[0, $fX4fx._DYN_IS_INITIALIZED /* @min:%2eisInitialized */ ] = function() {
            return _isinitialized;
        };
        _self.setInitialized = function(isInitialized) {
            _isinitialized = isInitialized;
        };
        // _self.getNextPlugin = () => DO NOT IMPLEMENT
        // Sub-classes of this base class *should* not be relying on this value and instead
        // should use processNext() function. If you require access to the plugin use the
        // IProcessTelemetryContext.getNext().getPlugin() while in the pipeline, Note getNext() may return null.
        _self[0, $fX4fx._DYN_SET_NEXT_PLUGIN /* @min:%2esetNextPlugin */ ] = function(next) {
            _nextPlugin = next;
        };
        _self[0, $fX4fx._DYN_PROCESS_NEXT /* @min:%2eprocessNext */ ] = function(env, itemCtx) {
            if (itemCtx) // Normal core execution sequence
            itemCtx[0, $fX4fx._DYN_PROCESS_NEXT /* @min:%2eprocessNext */ ](env);
            else if (_nextPlugin && (0, $erRAP.isFunction)(_nextPlugin[0, $lxIpo.STR_PROCESS_TELEMETRY /* @min:%2eprocessTelemetry */ ])) // Looks like backward compatibility or out of band processing. And as it looks
            // like a ITelemetryPlugin or ITelemetryPluginChain, just call processTelemetry
            _nextPlugin[0, $lxIpo.STR_PROCESS_TELEMETRY /* @min:%2eprocessTelemetry */ ](env, null);
        };
        _self._getTelCtx = _getTelCtx;
        function _getTelCtx(currentCtx) {
            if (currentCtx === void 0) currentCtx = null;
            var itemCtx = currentCtx;
            if (!itemCtx) {
                var rootCtx = _rootCtx || (0, $kry7o.createProcessTelemetryContext)(null, {}, _self[0, $lxIpo.STR_CORE /* @min:%2ecore */ ]);
                // tslint:disable-next-line: prefer-conditional-expression
                if (_nextPlugin && _nextPlugin[$290d1f2a78caf004$var$strGetPlugin]) // Looks like a chain object
                itemCtx = rootCtx[0, $fX4fx._DYN_CREATE_NEW /* @min:%2ecreateNew */ ](null, _nextPlugin[$290d1f2a78caf004$var$strGetPlugin]);
                else itemCtx = rootCtx[0, $fX4fx._DYN_CREATE_NEW /* @min:%2ecreateNew */ ](null, _nextPlugin);
            }
            return itemCtx;
        }
        function _setDefaults(config, core, pluginChain) {
            if (config) // Make sure the extensionConfig exists
            (0, $erRAP.setValue)(config, (0, $lxIpo.STR_EXTENSION_CONFIG), [], null, (0, $erRAP.isNullOrUndefined));
            if (!pluginChain && core) // Get the first plugin from the core
            pluginChain = core[0, $fX4fx._DYN_GET_PROCESS_TEL_CONT0 /* @min:%2egetProcessTelContext */ ]()[0, $fX4fx._DYN_GET_NEXT /* @min:%2egetNext */ ]();
            var nextPlugin = _nextPlugin;
            if (_nextPlugin && _nextPlugin[$290d1f2a78caf004$var$strGetPlugin]) // If it looks like a proxy/chain then get the plugin
            nextPlugin = _nextPlugin[$290d1f2a78caf004$var$strGetPlugin]();
            // Support legacy plugins where core was defined as a property
            _self[0, $lxIpo.STR_CORE /* @min:%2ecore */ ] = core;
            _rootCtx = (0, $kry7o.createProcessTelemetryContext)(pluginChain, config, core, nextPlugin);
        }
        function _initDefaults() {
            _isinitialized = false;
            _self[0, $lxIpo.STR_CORE /* @min:%2ecore */ ] = null;
            _rootCtx = null;
            _nextPlugin = null;
            _hooks = [];
            _unloadHandlerContainer = (0, $f3Boy.createUnloadHandlerContainer)();
        }
    }
    // Removed Stub for BaseTelemetryPlugin.prototype.initialize.
    // Removed Stub for BaseTelemetryPlugin.prototype.teardown.
    // Removed Stub for BaseTelemetryPlugin.prototype.update.
    // Removed Stub for BaseTelemetryPlugin.prototype._addUnloadCb.
    // Removed Stub for BaseTelemetryPlugin.prototype._addHook.
    // This is a workaround for an IE8 bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    // this will be removed when ES3 support is dropped.
    BaseTelemetryPlugin.__ieDyn = 1;
    return BaseTelemetryPlugin;
}();

});
parcelRegister("kry7o", function(module, exports) {

$parcel$export(module.exports, "createTelemetryProxyChain", function () { return $ee20cb6ead4d933d$export$107e639207cdf742; });
$parcel$export(module.exports, "createProcessTelemetryContext", function () { return $ee20cb6ead4d933d$export$ca98f11e981bcfd6; });
$parcel$export(module.exports, "createProcessTelemetryUnloadContext", function () { return $ee20cb6ead4d933d$export$91bbbd4999751948; });
$parcel$export(module.exports, "createProcessTelemetryUpdateContext", function () { return $ee20cb6ead4d933d$export$e4c32b40c4fbf98a; });
/*
 * Application Insights JavaScript SDK - Core, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $fX4fx = parcelRequire("fX4fx");

var $8z2Gd = parcelRequire("8z2Gd");

var $3I5zg = parcelRequire("3I5zg");

var $erRAP = parcelRequire("erRAP");

var $lxIpo = parcelRequire("lxIpo");

var $kBiyL = parcelRequire("kBiyL");

var $Vt75T = parcelRequire("Vt75T");
"use strict";
var $ee20cb6ead4d933d$var$strTelemetryPluginChain = "TelemetryPluginChain";
var $ee20cb6ead4d933d$var$strHasRunFlags = "_hasRun";
var $ee20cb6ead4d933d$var$strGetTelCtx = "_getTelCtx";
var $ee20cb6ead4d933d$var$_chainId = 0;
function $ee20cb6ead4d933d$var$_getNextProxyStart(proxy, core, startAt) {
    while(proxy){
        if (proxy[0, $fX4fx._DYN_GET_PLUGIN /* @min:%2egetPlugin */ ]() === startAt) return proxy;
        proxy = proxy[0, $fX4fx._DYN_GET_NEXT /* @min:%2egetNext */ ]();
    }
    // This wasn't found in the existing chain so create an isolated one with just this plugin
    return $ee20cb6ead4d933d$export$107e639207cdf742([
        startAt
    ], core[0, $fX4fx._DYN_CONFIG /* @min:%2econfig */ ] || {}, core);
}
/**
 * @ignore
 * @param telemetryChain
 * @param config
 * @param core
 * @param startAt - Identifies the next plugin to execute, if null there is no "next" plugin and if undefined it should assume the start of the chain
 * @returns
 */ function $ee20cb6ead4d933d$var$_createInternalContext(telemetryChain, config, core, startAt) {
    // We have a special case where we want to start execution from this specific plugin
    // or we simply reuse the existing telemetry plugin chain (normal execution case)
    var _nextProxy = null; // By Default set as no next plugin
    var _onComplete = [];
    if (startAt !== null) // There is no next element (null) vs not defined (undefined) so use the full chain
    _nextProxy = startAt ? $ee20cb6ead4d933d$var$_getNextProxyStart(telemetryChain, core, startAt) : telemetryChain;
    var context = {
        _next: _moveNext,
        ctx: {
            core: function() {
                return core;
            },
            diagLog: function() {
                return (0, $8z2Gd.safeGetLogger)(core, config);
            },
            getCfg: function() {
                return config;
            },
            getExtCfg: _getExtCfg,
            getConfig: _getConfig,
            hasNext: function() {
                return !!_nextProxy;
            },
            getNext: function() {
                return _nextProxy;
            },
            setNext: function(nextPlugin) {
                _nextProxy = nextPlugin;
            },
            iterate: _iterateChain,
            onComplete: _addOnComplete
        }
    };
    function _addOnComplete(onComplete, that) {
        var args = [];
        for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
        if (onComplete) _onComplete[0, $fX4fx._DYN_PUSH /* @min:%2epush */ ]({
            func: onComplete,
            self: !(0, $erRAP.isUndefined)(that) ? that : context.ctx,
            args: args
        });
    }
    function _moveNext() {
        var nextProxy = _nextProxy;
        // Automatically move to the next plugin
        _nextProxy = nextProxy ? nextProxy[0, $fX4fx._DYN_GET_NEXT /* @min:%2egetNext */ ]() : null;
        if (!nextProxy) {
            var onComplete = _onComplete;
            if (onComplete && onComplete[0, $fX4fx._DYN_LENGTH /* @min:%2elength */ ] > 0) {
                (0, $erRAP.arrForEach)(onComplete, function(completeDetails) {
                    try {
                        completeDetails.func[0, $fX4fx._DYN_CALL /* @min:%2ecall */ ](completeDetails.self, completeDetails.args);
                    } catch (e) {
                        (0, $8z2Gd._throwInternal)(core[0, $fX4fx._DYN_LOGGER /* @min:%2elogger */ ], 2 /* eLoggingSeverity.WARNING */ , 73 /* _eInternalMessageId.PluginException */ , "Unexpected Exception during onComplete - " + (0, $3I5zg.dumpObj)(e));
                    }
                });
                _onComplete = [];
            }
        }
        return nextProxy;
    }
    function _getExtCfg(identifier, defaultValue, mergeDefault) {
        if (defaultValue === void 0) defaultValue = {};
        if (mergeDefault === void 0) mergeDefault = 0 /* GetExtCfgMergeType.None */ ;
        var theConfig;
        if (config) {
            var extConfig = config[0, $lxIpo.STR_EXTENSION_CONFIG /* @min:%2eextensionConfig */ ];
            if (extConfig && identifier) theConfig = extConfig[identifier];
        }
        if (!theConfig) // Just use the defaults
        theConfig = defaultValue;
        else if ((0, $erRAP.isObject)(defaultValue)) {
            if (mergeDefault !== 0 /* GetExtCfgMergeType.None */ ) {
                // Merge the defaults and configured values
                var newConfig_1 = (0, $erRAP.objExtend)(true, defaultValue, theConfig);
                if (config && mergeDefault === 2 /* GetExtCfgMergeType.MergeDefaultFromRootOrDefault */ ) // Enumerate over the defaultValues and if not already populated attempt to
                // find a value from the root config
                (0, $erRAP.objForEachKey)(defaultValue, function(field) {
                    // for each unspecified field, set the default value
                    if ((0, $erRAP.isNullOrUndefined)(newConfig_1[field])) {
                        var cfgValue = config[field];
                        if (!(0, $erRAP.isNullOrUndefined)(cfgValue)) newConfig_1[field] = cfgValue;
                    }
                });
                theConfig = newConfig_1;
            }
        }
        return theConfig;
    }
    function _getConfig(identifier, field, defaultValue) {
        if (defaultValue === void 0) defaultValue = false;
        var theValue;
        var extConfig = _getExtCfg(identifier, null);
        if (extConfig && !(0, $erRAP.isNullOrUndefined)(extConfig[field])) theValue = extConfig[field];
        else if (config && !(0, $erRAP.isNullOrUndefined)(config[field])) theValue = config[field];
        return !(0, $erRAP.isNullOrUndefined)(theValue) ? theValue : defaultValue;
    }
    function _iterateChain(cb) {
        // Keep processing until we reach the end of the chain
        var nextPlugin;
        while(!!(nextPlugin = context._next())){
            var plugin = nextPlugin[0, $fX4fx._DYN_GET_PLUGIN /* @min:%2egetPlugin */ ]();
            if (plugin) // callback with the current on
            cb(plugin);
        }
    }
    return context;
}
function $ee20cb6ead4d933d$export$ca98f11e981bcfd6(telemetryChain, config, core, startAt) {
    var internalContext = $ee20cb6ead4d933d$var$_createInternalContext(telemetryChain, config, core, startAt);
    var context = internalContext.ctx;
    function _processNext(env) {
        var nextPlugin = internalContext._next();
        // Run the next plugin which will call "processNext()"
        nextPlugin && nextPlugin[0, $lxIpo.STR_PROCESS_TELEMETRY /* @min:%2eprocessTelemetry */ ](env, context);
        return !nextPlugin;
    }
    function _createNew(plugins, startAt) {
        if (plugins === void 0) plugins = null;
        if ((0, $erRAP.isArray)(plugins)) plugins = $ee20cb6ead4d933d$export$107e639207cdf742(plugins, config, core, startAt);
        return $ee20cb6ead4d933d$export$ca98f11e981bcfd6(plugins || context[0, $fX4fx._DYN_GET_NEXT /* @min:%2egetNext */ ](), config, core, startAt);
    }
    context[0, $fX4fx._DYN_PROCESS_NEXT /* @min:%2eprocessNext */ ] = _processNext;
    context[0, $fX4fx._DYN_CREATE_NEW /* @min:%2ecreateNew */ ] = _createNew;
    return context;
}
function $ee20cb6ead4d933d$export$91bbbd4999751948(telemetryChain, core, startAt) {
    var config = core[0, $fX4fx._DYN_CONFIG /* @min:%2econfig */ ] || {};
    var internalContext = $ee20cb6ead4d933d$var$_createInternalContext(telemetryChain, config, core, startAt);
    var context = internalContext.ctx;
    function _processNext(unloadState) {
        var nextPlugin = internalContext._next();
        nextPlugin && nextPlugin.unload(context, unloadState);
        return !nextPlugin;
    }
    function _createNew(plugins, startAt) {
        if (plugins === void 0) plugins = null;
        if ((0, $erRAP.isArray)(plugins)) plugins = $ee20cb6ead4d933d$export$107e639207cdf742(plugins, config, core, startAt);
        return $ee20cb6ead4d933d$export$91bbbd4999751948(plugins || context[0, $fX4fx._DYN_GET_NEXT /* @min:%2egetNext */ ](), core, startAt);
    }
    context[0, $fX4fx._DYN_PROCESS_NEXT /* @min:%2eprocessNext */ ] = _processNext;
    context[0, $fX4fx._DYN_CREATE_NEW /* @min:%2ecreateNew */ ] = _createNew;
    return context;
}
function $ee20cb6ead4d933d$export$e4c32b40c4fbf98a(telemetryChain, core, startAt) {
    var config = core[0, $fX4fx._DYN_CONFIG /* @min:%2econfig */ ] || {};
    var internalContext = $ee20cb6ead4d933d$var$_createInternalContext(telemetryChain, config, core, startAt);
    var context = internalContext.ctx;
    function _processNext(updateState) {
        return context.iterate(function(plugin) {
            if ((0, $erRAP.isFunction)(plugin[0, $fX4fx._DYN_UPDATE /* @min:%2eupdate */ ])) plugin[0, $fX4fx._DYN_UPDATE /* @min:%2eupdate */ ](context, updateState);
        });
    }
    function _createNew(plugins, startAt) {
        if (plugins === void 0) plugins = null;
        if ((0, $erRAP.isArray)(plugins)) plugins = $ee20cb6ead4d933d$export$107e639207cdf742(plugins, config, core, startAt);
        return $ee20cb6ead4d933d$export$e4c32b40c4fbf98a(plugins || context[0, $fX4fx._DYN_GET_NEXT /* @min:%2egetNext */ ](), core, startAt);
    }
    context[0, $fX4fx._DYN_PROCESS_NEXT /* @min:%2eprocessNext */ ] = _processNext;
    context[0, $fX4fx._DYN_CREATE_NEW /* @min:%2ecreateNew */ ] = _createNew;
    return context;
}
function $ee20cb6ead4d933d$export$107e639207cdf742(plugins, config, core, startAt) {
    var firstProxy = null;
    var add = startAt ? false : true;
    if ((0, $erRAP.isArray)(plugins) && plugins[0, $fX4fx._DYN_LENGTH /* @min:%2elength */ ] > 0) {
        // Create the proxies and wire up the next plugin chain
        var lastProxy_1 = null;
        (0, $erRAP.arrForEach)(plugins, function(thePlugin) {
            if (!add && startAt === thePlugin) add = true;
            if (add && thePlugin && (0, $erRAP.isFunction)(thePlugin[0, $lxIpo.STR_PROCESS_TELEMETRY /* @min:%2eprocessTelemetry */ ])) {
                // Only add plugins that are processors
                var newProxy = $ee20cb6ead4d933d$export$7f7b955927f4ae5e(thePlugin, config, core);
                if (!firstProxy) firstProxy = newProxy;
                if (lastProxy_1) // Set this new proxy as the next for the previous one
                lastProxy_1._setNext(newProxy);
                lastProxy_1 = newProxy;
            }
        });
    }
    if (startAt && !firstProxy) // Special case where the "startAt" was not in the original list of plugins
    return $ee20cb6ead4d933d$export$107e639207cdf742([
        startAt
    ], config, core);
    return firstProxy;
}
function $ee20cb6ead4d933d$export$7f7b955927f4ae5e(plugin, config, core) {
    var nextProxy = null;
    var hasProcessTelemetry = (0, $erRAP.isFunction)(plugin[0, $lxIpo.STR_PROCESS_TELEMETRY /* @min:%2eprocessTelemetry */ ]);
    var hasSetNext = (0, $erRAP.isFunction)(plugin[0, $fX4fx._DYN_SET_NEXT_PLUGIN /* @min:%2esetNextPlugin */ ]);
    var chainId;
    if (plugin) chainId = plugin[0, $fX4fx._DYN_IDENTIFIER /* @min:%2eidentifier */ ] + "-" + plugin[0, $lxIpo.STR_PRIORITY /* @min:%2epriority */ ] + "-" + $ee20cb6ead4d933d$var$_chainId++;
    else chainId = "Unknown-0-" + $ee20cb6ead4d933d$var$_chainId++;
    var proxyChain = {
        getPlugin: function() {
            return plugin;
        },
        getNext: function() {
            return nextProxy;
        },
        processTelemetry: _processTelemetry,
        unload: _unloadPlugin,
        update: _updatePlugin,
        _id: chainId,
        _setNext: function(nextPlugin) {
            nextProxy = nextPlugin;
        }
    };
    function _getTelCtx() {
        var itemCtx;
        // Looks like a plugin didn't pass the (optional) context, so create a new one
        if (plugin && (0, $erRAP.isFunction)(plugin[$ee20cb6ead4d933d$var$strGetTelCtx])) // This plugin extends from the BaseTelemetryPlugin so lets use it
        itemCtx = plugin[$ee20cb6ead4d933d$var$strGetTelCtx]();
        if (!itemCtx) // Create a temporary one
        itemCtx = $ee20cb6ead4d933d$export$ca98f11e981bcfd6(proxyChain, config, core);
        return itemCtx;
    }
    function _processChain(itemCtx, processPluginFn, name, details, isAsync) {
        var hasRun = false;
        var identifier = plugin ? plugin[0, $fX4fx._DYN_IDENTIFIER /* @min:%2eidentifier */ ] : $ee20cb6ead4d933d$var$strTelemetryPluginChain;
        var hasRunContext = itemCtx[$ee20cb6ead4d933d$var$strHasRunFlags];
        if (!hasRunContext) // Assign and populate
        hasRunContext = itemCtx[$ee20cb6ead4d933d$var$strHasRunFlags] = {};
        // Ensure that we keep the context in sync
        itemCtx.setNext(nextProxy);
        if (plugin) (0, $kBiyL.doPerf)(itemCtx[0, $lxIpo.STR_CORE /* @min:%2ecore */ ](), function() {
            return identifier + ":" + name;
        }, function() {
            // Mark this component as having run
            hasRunContext[chainId] = true;
            try {
                // Set a flag on the next plugin so we know if it was attempted to be executed
                var nextId = nextProxy ? nextProxy._id : (0, $lxIpo.STR_EMPTY);
                if (nextId) hasRunContext[nextId] = false;
                hasRun = processPluginFn(itemCtx);
            } catch (error) {
                var hasNextRun = nextProxy ? hasRunContext[nextProxy._id] : true;
                if (hasNextRun) // The next plugin after us has already run so set this one as complete
                hasRun = true;
                if (!nextProxy || !hasNextRun) // Either we have no next plugin or the current one did not attempt to call the next plugin
                // Which means the current one is the root of the failure so log/report this failure
                (0, $8z2Gd._throwInternal)(itemCtx[0, $fX4fx._DYN_DIAG_LOG /* @min:%2ediagLog */ ](), 1 /* eLoggingSeverity.CRITICAL */ , 73 /* _eInternalMessageId.PluginException */ , "Plugin [" + identifier + "] failed during " + name + " - " + (0, $3I5zg.dumpObj)(error) + ", run flags: " + (0, $3I5zg.dumpObj)(hasRunContext));
            }
        }, details, isAsync);
        return hasRun;
    }
    function _processTelemetry(env, itemCtx) {
        itemCtx = itemCtx || _getTelCtx();
        function _callProcessTelemetry(itemCtx) {
            if (!plugin || !hasProcessTelemetry) return false;
            var pluginState = (0, $Vt75T._getPluginState)(plugin);
            if (pluginState[0, $fX4fx._DYN_TEARDOWN /* @min:%2eteardown */ ] || pluginState[0, $lxIpo.STR_DISABLED]) return false;
            // Ensure that we keep the context in sync (for processNext()), just in case a plugin
            // doesn't calls processTelemetry() instead of itemContext.processNext() or some
            // other form of error occurred
            if (hasSetNext) // Backward compatibility setting the next plugin on the instance
            plugin[0, $fX4fx._DYN_SET_NEXT_PLUGIN /* @min:%2esetNextPlugin */ ](nextProxy);
            plugin[0, $lxIpo.STR_PROCESS_TELEMETRY /* @min:%2eprocessTelemetry */ ](env, itemCtx);
            // Process Telemetry is expected to call itemCtx.processNext() or nextPlugin.processTelemetry()
            return true;
        }
        if (!_processChain(itemCtx, _callProcessTelemetry, "processTelemetry", function() {
            return {
                item: env
            };
        }, !env.sync)) // The underlying plugin is either not defined, not enabled or does not have a processTelemetry implementation
        // so we still want the next plugin to be executed.
        itemCtx[0, $fX4fx._DYN_PROCESS_NEXT /* @min:%2eprocessNext */ ](env);
    }
    function _unloadPlugin(unloadCtx, unloadState) {
        function _callTeardown() {
            // Setting default of hasRun as false so the proxyProcessFn() is called as teardown() doesn't have to exist or call unloadNext().
            var hasRun = false;
            if (plugin) {
                var pluginState = (0, $Vt75T._getPluginState)(plugin);
                var pluginCore = plugin[0, $lxIpo.STR_CORE] || pluginState[0, $lxIpo.STR_CORE /* @min:%2ecore */ ];
                // Only teardown the plugin if it was initialized by the current core (i.e. It's not a shared plugin)
                if (plugin && (!pluginCore || pluginCore === unloadCtx.core()) && !pluginState[0, $fX4fx._DYN_TEARDOWN /* @min:%2eteardown */ ]) {
                    // Handle plugins that don't extend from the BaseTelemetryPlugin
                    pluginState[0, $lxIpo.STR_CORE /* @min:%2ecore */ ] = null;
                    pluginState[0, $fX4fx._DYN_TEARDOWN /* @min:%2eteardown */ ] = true;
                    pluginState[0, $fX4fx._DYN_IS_INITIALIZED /* @min:%2eisInitialized */ ] = false;
                    if (plugin[0, $fX4fx._DYN_TEARDOWN /* @min:%2eteardown */ ] && plugin[0, $fX4fx._DYN_TEARDOWN /* @min:%2eteardown */ ](unloadCtx, unloadState) === true) // plugin told us that it was going to (or has) call unloadCtx.processNext()
                    hasRun = true;
                }
            }
            return hasRun;
        }
        if (!_processChain(unloadCtx, _callTeardown, "unload", function() {}, unloadState[0, $fX4fx._DYN_IS_ASYNC /* @min:%2eisAsync */ ])) // Only called if we hasRun was not true
        unloadCtx[0, $fX4fx._DYN_PROCESS_NEXT /* @min:%2eprocessNext */ ](unloadState);
    }
    function _updatePlugin(updateCtx, updateState) {
        function _callUpdate() {
            // Setting default of hasRun as false so the proxyProcessFn() is called as teardown() doesn't have to exist or call unloadNext().
            var hasRun = false;
            if (plugin) {
                var pluginState = (0, $Vt75T._getPluginState)(plugin);
                var pluginCore = plugin[0, $lxIpo.STR_CORE] || pluginState[0, $lxIpo.STR_CORE /* @min:%2ecore */ ];
                // Only update the plugin if it was initialized by the current core (i.e. It's not a shared plugin)
                if (plugin && (!pluginCore || pluginCore === updateCtx.core()) && !pluginState[0, $fX4fx._DYN_TEARDOWN /* @min:%2eteardown */ ]) {
                    if (plugin[0, $fX4fx._DYN_UPDATE /* @min:%2eupdate */ ] && plugin[0, $fX4fx._DYN_UPDATE /* @min:%2eupdate */ ](updateCtx, updateState) === true) // plugin told us that it was going to (or has) call unloadCtx.processNext()
                    hasRun = true;
                }
            }
            return hasRun;
        }
        if (!_processChain(updateCtx, _callUpdate, "update", function() {}, false)) // Only called if we hasRun was not true
        updateCtx[0, $fX4fx._DYN_PROCESS_NEXT /* @min:%2eprocessNext */ ](updateState);
    }
    return (0, $erRAP.objFreeze)(proxyChain);
}
/**
 * This class will be removed!
 * @deprecated use createProcessTelemetryContext() instead
 */ var $ee20cb6ead4d933d$export$7c2ac74a00234af1 = /** @class */ function() {
    /**
     * Creates a new Telemetry Item context with the current config, core and plugin execution chain
     * @param plugins - The plugin instances that will be executed
     * @param config - The current config
     * @param core - The current core instance
     */ function ProcessTelemetryContext(pluginChain, config, core, startAt) {
        var _self = this;
        var context = $ee20cb6ead4d933d$export$ca98f11e981bcfd6(pluginChain, config, core, startAt);
        // Proxy all functions of the context to this object
        (0, $erRAP.proxyFunctions)(_self, context, (0, $erRAP.objKeys)(context));
    }
    return ProcessTelemetryContext;
}();

});
parcelRegister("kBiyL", function(module, exports) {

$parcel$export(module.exports, "PerfManager", function () { return $eff5a8ed5c352eb6$export$cbeb6df2e8e9b5ae; });
$parcel$export(module.exports, "doPerf", function () { return $eff5a8ed5c352eb6$export$c6fbeb260600c482; });
$parcel$export(module.exports, "getGblPerfMgr", function () { return $eff5a8ed5c352eb6$export$6cdbf3f34ace6568; });
/*
 * Application Insights JavaScript SDK - Core, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $kbmky = parcelRequire("kbmky");

var $fX4fx = parcelRequire("fX4fx");

var $erRAP = parcelRequire("erRAP");

var $lxIpo = parcelRequire("lxIpo");
var $eff5a8ed5c352eb6$var$strExecutionContextKey = "ctx";
var $eff5a8ed5c352eb6$var$strParentContextKey = "ParentContextKey";
var $eff5a8ed5c352eb6$var$strChildrenContextKey = "ChildrenContextKey";
var $eff5a8ed5c352eb6$var$_defaultPerfManager = null;
var $eff5a8ed5c352eb6$export$e3556d2ce46cdae0 = /** @class */ function() {
    function PerfEvent(name, payloadDetails, isAsync) {
        var _self = this;
        var accessorDefined = false;
        _self.start = (0, $erRAP.dateNow)();
        _self[0, $fX4fx._DYN_NAME /* @min:%2ename */ ] = name;
        _self[0, $fX4fx._DYN_IS_ASYNC /* @min:%2eisAsync */ ] = isAsync;
        _self[0, $fX4fx._DYN_IS_CHILD_EVT /* @min:%2eisChildEvt */ ] = function() {
            return false;
        };
        if ((0, $erRAP.isFunction)(payloadDetails)) {
            // Create an accessor to minimize the potential performance impact of executing the payloadDetails callback
            var theDetails_1;
            accessorDefined = (0, $erRAP.objDefineAccessors)(_self, "payload", function() {
                // Delay the execution of the payloadDetails until needed
                if (!theDetails_1 && (0, $erRAP.isFunction)(payloadDetails)) {
                    theDetails_1 = payloadDetails();
                    // clear it out now so the referenced objects can be garbage collected
                    payloadDetails = null;
                }
                return theDetails_1;
            });
        }
        _self[0, $fX4fx._DYN_GET_CTX /* @min:%2egetCtx */ ] = function(key) {
            if (key) {
                // The parent and child links are located directly on the object (for better viewing in the DebugPlugin)
                if (key === PerfEvent[$eff5a8ed5c352eb6$var$strParentContextKey] || key === PerfEvent[$eff5a8ed5c352eb6$var$strChildrenContextKey]) return _self[key];
                return (_self[$eff5a8ed5c352eb6$var$strExecutionContextKey] || {})[key];
            }
            return null;
        };
        _self[0, $fX4fx._DYN_SET_CTX /* @min:%2esetCtx */ ] = function(key, value) {
            if (key) {
                // Put the parent and child links directly on the object (for better viewing in the DebugPlugin)
                if (key === PerfEvent[$eff5a8ed5c352eb6$var$strParentContextKey]) {
                    // Simple assumption, if we are setting a parent then we must be a child
                    if (!_self[key]) _self[0, $fX4fx._DYN_IS_CHILD_EVT /* @min:%2eisChildEvt */ ] = function() {
                        return true;
                    };
                    _self[key] = value;
                } else if (key === PerfEvent[$eff5a8ed5c352eb6$var$strChildrenContextKey]) _self[key] = value;
                else {
                    var ctx = _self[$eff5a8ed5c352eb6$var$strExecutionContextKey] = _self[$eff5a8ed5c352eb6$var$strExecutionContextKey] || {};
                    ctx[key] = value;
                }
            }
        };
        _self[0, $fX4fx._DYN_COMPLETE /* @min:%2ecomplete */ ] = function() {
            var childTime = 0;
            var childEvts = _self[0, $fX4fx._DYN_GET_CTX /* @min:%2egetCtx */ ](PerfEvent[$eff5a8ed5c352eb6$var$strChildrenContextKey]);
            if ((0, $erRAP.isArray)(childEvts)) for(var lp = 0; lp < childEvts[0, $fX4fx._DYN_LENGTH /* @min:%2elength */ ]; lp++){
                var childEvt = childEvts[lp];
                if (childEvt) childTime += childEvt[0, $fX4fx._DYN_TIME /* @min:%2etime */ ];
            }
            _self[0, $fX4fx._DYN_TIME /* @min:%2etime */ ] = (0, $erRAP.dateNow)() - _self.start;
            _self.exTime = _self[0, $fX4fx._DYN_TIME /* @min:%2etime */ ] - childTime;
            _self[0, $fX4fx._DYN_COMPLETE /* @min:%2ecomplete */ ] = function() {};
            if (!accessorDefined && (0, $erRAP.isFunction)(payloadDetails)) // If we couldn't define the property set during complete -- to minimize the perf impact until after the time
            _self.payload = payloadDetails();
        };
    }
    PerfEvent.ParentContextKey = "parent";
    PerfEvent.ChildrenContextKey = "childEvts";
    return PerfEvent;
}();
var $eff5a8ed5c352eb6$export$cbeb6df2e8e9b5ae = /** @class */ function() {
    function PerfManager(manager) {
        /**
         * General bucket used for execution context set and retrieved via setCtx() and getCtx.
         * Defined as private so it can be visualized via the DebugPlugin
         */ this.ctx = {};
        (0, $kbmky.default)(PerfManager, this, function(_self) {
            _self.create = function(src, payloadDetails, isAsync) {
                // TODO (@MSNev): at some point we will want to add additional configuration to "select" which events to instrument
                // for now this is just a simple do everything.
                return new $eff5a8ed5c352eb6$export$e3556d2ce46cdae0(src, payloadDetails, isAsync);
            };
            _self.fire = function(perfEvent) {
                if (perfEvent) {
                    perfEvent[0, $fX4fx._DYN_COMPLETE /* @min:%2ecomplete */ ]();
                    if (manager && (0, $erRAP.isFunction)(manager[0, $lxIpo.STR_PERF_EVENT /* @min:%2eperfEvent */ ])) manager[0, $lxIpo.STR_PERF_EVENT /* @min:%2eperfEvent */ ](perfEvent);
                }
            };
            _self[0, $fX4fx._DYN_SET_CTX /* @min:%2esetCtx */ ] = function(key, value) {
                if (key) {
                    var ctx = _self[$eff5a8ed5c352eb6$var$strExecutionContextKey] = _self[$eff5a8ed5c352eb6$var$strExecutionContextKey] || {};
                    ctx[key] = value;
                }
            };
            _self[0, $fX4fx._DYN_GET_CTX /* @min:%2egetCtx */ ] = function(key) {
                return (_self[$eff5a8ed5c352eb6$var$strExecutionContextKey] || {})[key];
            };
        });
    }
    // Removed Stub for PerfManager.prototype.create.
    // Removed Stub for PerfManager.prototype.fire.
    // Removed Stub for PerfManager.prototype.setCtx.
    // Removed Stub for PerfManager.prototype.getCtx.
    // This is a workaround for an IE8 bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    // this will be removed when ES3 support is dropped.
    PerfManager.__ieDyn = 1;
    return PerfManager;
}();
var $eff5a8ed5c352eb6$var$doPerfActiveKey = "CoreUtils.doPerf";
function $eff5a8ed5c352eb6$export$c6fbeb260600c482(mgrSource, getSource, func, details, isAsync) {
    if (mgrSource) {
        var perfMgr = mgrSource;
        if (perfMgr[0, $lxIpo.STR_GET_PERF_MGR]) // Looks like a perf manager provider object
        perfMgr = perfMgr[0, $lxIpo.STR_GET_PERF_MGR]();
        if (perfMgr) {
            var perfEvt = void 0;
            var currentActive = perfMgr[0, $fX4fx._DYN_GET_CTX /* @min:%2egetCtx */ ]($eff5a8ed5c352eb6$var$doPerfActiveKey);
            try {
                perfEvt = perfMgr.create(getSource(), details, isAsync);
                if (perfEvt) {
                    if (currentActive && perfEvt[0, $fX4fx._DYN_SET_CTX /* @min:%2esetCtx */ ]) {
                        perfEvt[0, $fX4fx._DYN_SET_CTX /* @min:%2esetCtx */ ]($eff5a8ed5c352eb6$export$e3556d2ce46cdae0[$eff5a8ed5c352eb6$var$strParentContextKey], currentActive);
                        if (currentActive[0, $fX4fx._DYN_GET_CTX /* @min:%2egetCtx */ ] && currentActive[0, $fX4fx._DYN_SET_CTX /* @min:%2esetCtx */ ]) {
                            var children = currentActive[0, $fX4fx._DYN_GET_CTX /* @min:%2egetCtx */ ]($eff5a8ed5c352eb6$export$e3556d2ce46cdae0[$eff5a8ed5c352eb6$var$strChildrenContextKey]);
                            if (!children) {
                                children = [];
                                currentActive[0, $fX4fx._DYN_SET_CTX /* @min:%2esetCtx */ ]($eff5a8ed5c352eb6$export$e3556d2ce46cdae0[$eff5a8ed5c352eb6$var$strChildrenContextKey], children);
                            }
                            children[0, $fX4fx._DYN_PUSH /* @min:%2epush */ ](perfEvt);
                        }
                    }
                    // Set this event as the active event now
                    perfMgr[0, $fX4fx._DYN_SET_CTX /* @min:%2esetCtx */ ]($eff5a8ed5c352eb6$var$doPerfActiveKey, perfEvt);
                    return func(perfEvt);
                }
            } catch (ex) {
                if (perfEvt && perfEvt[0, $fX4fx._DYN_SET_CTX /* @min:%2esetCtx */ ]) perfEvt[0, $fX4fx._DYN_SET_CTX /* @min:%2esetCtx */ ]("exception", ex);
            } finally{
                // fire the perf event
                if (perfEvt) perfMgr.fire(perfEvt);
                // Reset the active event to the previous value
                perfMgr[0, $fX4fx._DYN_SET_CTX /* @min:%2esetCtx */ ]($eff5a8ed5c352eb6$var$doPerfActiveKey, currentActive);
            }
        }
    }
    return func();
}
function $eff5a8ed5c352eb6$export$1e94af82fd6977f1(perfManager) {
    $eff5a8ed5c352eb6$var$_defaultPerfManager = perfManager;
}
function $eff5a8ed5c352eb6$export$6cdbf3f34ace6568() {
    return $eff5a8ed5c352eb6$var$_defaultPerfManager;
}

});

parcelRegister("Vt75T", function(module, exports) {

$parcel$export(module.exports, "_getPluginState", function () { return $0acbe84df126bdb3$export$37cfaecb9b4b1b3b; });
$parcel$export(module.exports, "initializePlugins", function () { return $0acbe84df126bdb3$export$be211df7b1eeb33e; });
$parcel$export(module.exports, "sortPlugins", function () { return $0acbe84df126bdb3$export$478771939b7b39a2; });
$parcel$export(module.exports, "createDistributedTraceContext", function () { return $0acbe84df126bdb3$export$10fa4480433f402c; });
/*
 * Application Insights JavaScript SDK - Core, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $fX4fx = parcelRequire("fX4fx");

var $2w0XY = parcelRequire("2w0XY");

var $erRAP = parcelRequire("erRAP");

var $lxIpo = parcelRequire("lxIpo");

var $jqfZe = parcelRequire("jqfZe");
"use strict";
var $0acbe84df126bdb3$var$pluginStateData = (0, $2w0XY.createElmNodeData)("plugin");
function $0acbe84df126bdb3$export$37cfaecb9b4b1b3b(plugin) {
    return $0acbe84df126bdb3$var$pluginStateData.get(plugin, "state", {}, true);
}
function $0acbe84df126bdb3$export$be211df7b1eeb33e(processContext, extensions) {
    // Set the next plugin and identified the uninitialized plugins
    var initPlugins = [];
    var lastPlugin = null;
    var proxy = processContext[0, $fX4fx._DYN_GET_NEXT /* @min:%2egetNext */ ]();
    var pluginState;
    while(proxy){
        var thePlugin = proxy[0, $fX4fx._DYN_GET_PLUGIN /* @min:%2egetPlugin */ ]();
        if (thePlugin) {
            if (lastPlugin && (0, $erRAP.isFunction)(lastPlugin[0, $fX4fx._DYN_SET_NEXT_PLUGIN /* @min:%2esetNextPlugin */ ]) && (0, $erRAP.isFunction)(thePlugin[0, $lxIpo.STR_PROCESS_TELEMETRY /* @min:%2eprocessTelemetry */ ])) // Set this plugin as the next for the previous one
            lastPlugin[0, $fX4fx._DYN_SET_NEXT_PLUGIN /* @min:%2esetNextPlugin */ ](thePlugin);
            var isInitialized = false;
            if ((0, $erRAP.isFunction)(thePlugin[0, $fX4fx._DYN_IS_INITIALIZED /* @min:%2eisInitialized */ ])) isInitialized = thePlugin[0, $fX4fx._DYN_IS_INITIALIZED /* @min:%2eisInitialized */ ]();
            else {
                pluginState = $0acbe84df126bdb3$export$37cfaecb9b4b1b3b(thePlugin);
                isInitialized = pluginState[0, $fX4fx._DYN_IS_INITIALIZED /* @min:%2eisInitialized */ ];
            }
            if (!isInitialized) initPlugins[0, $fX4fx._DYN_PUSH /* @min:%2epush */ ](thePlugin);
            lastPlugin = thePlugin;
            proxy = proxy[0, $fX4fx._DYN_GET_NEXT /* @min:%2egetNext */ ]();
        }
    }
    // Now initialize the plugins
    (0, $erRAP.arrForEach)(initPlugins, function(thePlugin) {
        var core = processContext[0, $lxIpo.STR_CORE]();
        thePlugin[0, $fX4fx._DYN_INITIALIZE /* @min:%2einitialize */ ](processContext.getCfg(), core, extensions, processContext[0, $fX4fx._DYN_GET_NEXT /* @min:%2egetNext */ ]());
        pluginState = $0acbe84df126bdb3$export$37cfaecb9b4b1b3b(thePlugin);
        // Only add the core to the state if the plugin didn't set it (doesn't extent from BaseTelemetryPlugin)
        if (!thePlugin[0, $lxIpo.STR_CORE] && !pluginState[0, $lxIpo.STR_CORE]) pluginState[0, $lxIpo.STR_CORE] = core;
        pluginState[0, $fX4fx._DYN_IS_INITIALIZED /* @min:%2eisInitialized */ ] = true;
        delete pluginState[0, $fX4fx._DYN_TEARDOWN /* @min:%2eteardown */ ];
    });
}
function $0acbe84df126bdb3$export$478771939b7b39a2(plugins) {
    // Sort by priority
    return plugins.sort(function(extA, extB) {
        var result = 0;
        if (extB) {
            var bHasProcess = (0, $erRAP.isFunction)(extB[0, $lxIpo.STR_PROCESS_TELEMETRY]);
            if ((0, $erRAP.isFunction)(extA[0, $lxIpo.STR_PROCESS_TELEMETRY])) result = bHasProcess ? extA[0, $lxIpo.STR_PRIORITY] - extB[0, $lxIpo.STR_PRIORITY] : 1;
            else if (bHasProcess) result = -1;
        } else result = extA ? 1 : -1;
        return result;
    });
// sort complete
}
function $0acbe84df126bdb3$export$24978f1b175640d9(components, unloadCtx, unloadState, asyncCallback) {
    var idx = 0;
    function _doUnload() {
        while(idx < components[0, $fX4fx._DYN_LENGTH /* @min:%2elength */ ]){
            var component = components[idx++];
            if (component) {
                var func = component._doUnload || component[0, $fX4fx._DYN__DO_TEARDOWN /* @min:%2e_doTeardown */ ];
                if ((0, $erRAP.isFunction)(func)) {
                    if (func[0, $fX4fx._DYN_CALL /* @min:%2ecall */ ](component, unloadCtx, unloadState, _doUnload) === true) return true;
                }
            }
        }
    }
    return _doUnload();
}
function $0acbe84df126bdb3$export$10fa4480433f402c(parentCtx) {
    var trace = {};
    return {
        getName: function() {
            return trace[0, $fX4fx._DYN_NAME /* @min:%2ename */ ];
        },
        setName: function(newValue) {
            parentCtx && parentCtx.setName(newValue);
            trace[0, $fX4fx._DYN_NAME /* @min:%2ename */ ] = newValue;
        },
        getTraceId: function() {
            return trace[0, $fX4fx._DYN_TRACE_ID /* @min:%2etraceId */ ];
        },
        setTraceId: function(newValue) {
            parentCtx && parentCtx.setTraceId(newValue);
            if ((0, $jqfZe.isValidTraceId)(newValue)) trace[0, $fX4fx._DYN_TRACE_ID /* @min:%2etraceId */ ] = newValue;
        },
        getSpanId: function() {
            return trace[0, $fX4fx._DYN_SPAN_ID /* @min:%2espanId */ ];
        },
        setSpanId: function(newValue) {
            parentCtx && parentCtx.setSpanId(newValue);
            if ((0, $jqfZe.isValidSpanId)(newValue)) trace[0, $fX4fx._DYN_SPAN_ID /* @min:%2espanId */ ] = newValue;
        },
        getTraceFlags: function() {
            return trace[0, $fX4fx._DYN_TRACE_FLAGS /* @min:%2etraceFlags */ ];
        },
        setTraceFlags: function(newTraceFlags) {
            parentCtx && parentCtx.setTraceFlags(newTraceFlags);
            trace[0, $fX4fx._DYN_TRACE_FLAGS /* @min:%2etraceFlags */ ] = newTraceFlags;
        }
    };
}

});


parcelRegister("f3Boy", function(module, exports) {

$parcel$export(module.exports, "createUnloadHandlerContainer", function () { return $af6424b14b41c78e$export$1dd1604aeaf8cfed; });
/*
 * Application Insights JavaScript SDK - Core, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $fX4fx = parcelRequire("fX4fx");

var $8z2Gd = parcelRequire("8z2Gd");

var $3I5zg = parcelRequire("3I5zg");

var $erRAP = parcelRequire("erRAP");
function $af6424b14b41c78e$export$1dd1604aeaf8cfed() {
    var handlers = [];
    function _addHandler(handler) {
        if (handler) handlers[0, $fX4fx._DYN_PUSH /* @min:%2epush */ ](handler);
    }
    function _runHandlers(unloadCtx, unloadState) {
        (0, $erRAP.arrForEach)(handlers, function(handler) {
            try {
                handler(unloadCtx, unloadState);
            } catch (e) {
                (0, $8z2Gd._throwInternal)(unloadCtx[0, $fX4fx._DYN_DIAG_LOG /* @min:%2ediagLog */ ](), 2 /* eLoggingSeverity.WARNING */ , 73 /* _eInternalMessageId.PluginException */ , "Unexpected error calling unload handler - " + (0, $3I5zg.dumpObj)(e));
            }
        });
        handlers = [];
    }
    return {
        add: _addHandler,
        run: _runHandlers
    };
}

});


parcelRegister("2CgMu", function(module, exports) {

$parcel$export(module.exports, "InstrumentProto", function () { return $1e7c25c7f3fe3128$export$6b32104a5f4313f6; });
$parcel$export(module.exports, "InstrumentFunc", function () { return $1e7c25c7f3fe3128$export$152e6c4c396a57a; });
$parcel$export(module.exports, "InstrumentEvent", function () { return $1e7c25c7f3fe3128$export$b96f6cbe9b035430; });
/*
 * Application Insights JavaScript SDK - Core, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $VVkgt = parcelRequire("VVkgt");

var $fX4fx = parcelRequire("fX4fx");

var $3I5zg = parcelRequire("3I5zg");

var $erRAP = parcelRequire("erRAP");
var $1e7c25c7f3fe3128$var$aiInstrumentHooks = "_aiHooks";
var $1e7c25c7f3fe3128$var$cbNames = [
    "req",
    "rsp",
    "hkErr",
    "fnErr"
];
/** @ignore */ function $1e7c25c7f3fe3128$var$_arrLoop(arr, fn) {
    if (arr) for(var lp = 0; lp < arr[0, $fX4fx._DYN_LENGTH /* @min:%2elength */ ]; lp++){
        if (fn(arr[lp], lp)) break;
    }
}
/** @ignore */ function $1e7c25c7f3fe3128$var$_doCallbacks(hooks, callDetails, cbArgs, hookCtx, type) {
    if (type >= 0 /* CallbackType.Request */  && type <= 2 /* CallbackType.HookError */ ) $1e7c25c7f3fe3128$var$_arrLoop(hooks, function(hook, idx) {
        var cbks = hook.cbks;
        var cb = cbks[$1e7c25c7f3fe3128$var$cbNames[type]];
        if (cb) {
            // Set the specific hook context implementation using a lazy creation pattern
            callDetails.ctx = function() {
                var ctx = hookCtx[idx] = hookCtx[idx] || {};
                return ctx;
            };
            try {
                cb[0, $fX4fx._DYN_APPLY /* @min:%2eapply */ ](callDetails.inst, cbArgs);
            } catch (err) {
                var orgEx = callDetails.err;
                try {
                    // Report Hook error via the callback
                    var hookErrorCb = cbks[$1e7c25c7f3fe3128$var$cbNames[2 /* CallbackType.HookError */ ]];
                    if (hookErrorCb) {
                        callDetails.err = err;
                        hookErrorCb[0, $fX4fx._DYN_APPLY /* @min:%2eapply */ ](callDetails.inst, cbArgs);
                    }
                } catch (e) {
                // Not much we can do here -- swallowing the exception to avoid crashing the hosting app
                } finally{
                    // restore the original exception (if any)
                    callDetails.err = orgEx;
                }
            }
        }
    });
}
/** @ignore */ function $1e7c25c7f3fe3128$var$_createFunctionHook(aiHook) {
    // Define a temporary method that queues-up a the real method call
    return function() {
        var _a;
        var funcThis = this;
        // Capture the original arguments passed to the method
        var orgArgs = arguments;
        var hooks = aiHook.h;
        var funcArgs = (_a = {}, _a[0, $fX4fx._DYN_NAME /* @min:name */ ] = aiHook.n, _a.inst = funcThis, _a.ctx = null, _a.set = _replaceArg, _a);
        var hookCtx = [];
        var cbArgs = _createArgs([
            funcArgs
        ], orgArgs);
        funcArgs.evt = (0, $3I5zg.getGlobalInst)("event");
        function _createArgs(target, theArgs) {
            $1e7c25c7f3fe3128$var$_arrLoop(theArgs, function(arg) {
                target[0, $fX4fx._DYN_PUSH /* @min:%2epush */ ](arg);
            });
            return target;
        }
        function _replaceArg(idx, value) {
            orgArgs = _createArgs([], orgArgs);
            orgArgs[idx] = value;
            cbArgs = _createArgs([
                funcArgs
            ], orgArgs);
        }
        // Call the pre-request hooks
        $1e7c25c7f3fe3128$var$_doCallbacks(hooks, funcArgs, cbArgs, hookCtx, 0 /* CallbackType.Request */ );
        // Call the original function was called
        var theFunc = aiHook.f;
        if (theFunc) try {
            funcArgs.rslt = theFunc[0, $fX4fx._DYN_APPLY /* @min:%2eapply */ ](funcThis, orgArgs);
        } catch (err) {
            // Report the request callback
            funcArgs.err = err;
            $1e7c25c7f3fe3128$var$_doCallbacks(hooks, funcArgs, cbArgs, hookCtx, 3 /* CallbackType.FunctionError */ );
            // rethrow the original exception so anyone listening for it can catch the exception
            throw err;
        }
        // Call the post-request hooks
        $1e7c25c7f3fe3128$var$_doCallbacks(hooks, funcArgs, cbArgs, hookCtx, 1 /* CallbackType.Response */ );
        return funcArgs.rslt;
    };
}
/** @ignore */ function $1e7c25c7f3fe3128$var$_getOwner(target, name, checkPrototype, checkParentProto) {
    var owner = null;
    if (target) {
        if ((0, $erRAP.hasOwnProperty)(target, name)) owner = target;
        else if (checkPrototype) owner = $1e7c25c7f3fe3128$var$_getOwner((0, $erRAP._getObjProto)(target), name, checkParentProto, false);
    }
    return owner;
}
function $1e7c25c7f3fe3128$export$6b32104a5f4313f6(target, funcName, callbacks) {
    if (target) return $1e7c25c7f3fe3128$export$152e6c4c396a57a(target[0, $VVkgt.strShimPrototype], funcName, callbacks, false);
    return null;
}
function $1e7c25c7f3fe3128$export$aaa214566a8b50d(target, funcNames, callbacks) {
    if (target) return $1e7c25c7f3fe3128$export$3bccad25f6aafea4(target[0, $VVkgt.strShimPrototype], funcNames, callbacks, false);
    return null;
}
function $1e7c25c7f3fe3128$var$_createInstrumentHook(owner, funcName, fn, callbacks) {
    var aiHook = fn && fn[$1e7c25c7f3fe3128$var$aiInstrumentHooks];
    if (!aiHook) {
        // Only hook the function once
        aiHook = {
            i: 0,
            n: funcName,
            f: fn,
            h: []
        };
        // Override (hook) the original function
        var newFunc = $1e7c25c7f3fe3128$var$_createFunctionHook(aiHook);
        newFunc[$1e7c25c7f3fe3128$var$aiInstrumentHooks] = aiHook; // Tag and store the function hooks
        owner[funcName] = newFunc;
    }
    var theHook = {
        // tslint:disable:object-literal-shorthand
        id: aiHook.i,
        cbks: callbacks,
        rm: function() {
            // DO NOT Use () => { shorthand for the function as the this gets replaced
            // with the outer this and not the this for theHook instance.
            var id = this.id;
            $1e7c25c7f3fe3128$var$_arrLoop(aiHook.h, function(hook, idx) {
                if (hook.id === id) {
                    aiHook.h[0, $fX4fx._DYN_SPLICE /* @min:%2esplice */ ](idx, 1);
                    return 1;
                }
            });
        }
    };
    aiHook.i++;
    aiHook.h[0, $fX4fx._DYN_PUSH /* @min:%2epush */ ](theHook);
    return theHook;
}
function $1e7c25c7f3fe3128$export$152e6c4c396a57a(target, funcName, callbacks, checkPrototype, checkParentProto) {
    if (checkPrototype === void 0) checkPrototype = true;
    if (target && funcName && callbacks) {
        var owner = $1e7c25c7f3fe3128$var$_getOwner(target, funcName, checkPrototype, checkParentProto);
        if (owner) {
            var fn = owner[funcName];
            if (typeof fn === (0, $VVkgt.strShimFunction)) return $1e7c25c7f3fe3128$var$_createInstrumentHook(owner, funcName, fn, callbacks);
        }
    }
    return null;
}
function $1e7c25c7f3fe3128$export$3bccad25f6aafea4(target, funcNames, callbacks, checkPrototype, checkParentProto) {
    if (checkPrototype === void 0) checkPrototype = true;
    var hooks = null;
    $1e7c25c7f3fe3128$var$_arrLoop(funcNames, function(funcName) {
        var hook = $1e7c25c7f3fe3128$export$152e6c4c396a57a(target, funcName, callbacks, checkPrototype, checkParentProto);
        if (hook) {
            if (!hooks) hooks = [];
            hooks[0, $fX4fx._DYN_PUSH /* @min:%2epush */ ](hook);
        }
    });
    return hooks;
}
function $1e7c25c7f3fe3128$export$b96f6cbe9b035430(target, evtName, callbacks, checkPrototype, checkParentProto) {
    if (target && evtName && callbacks) {
        var owner = $1e7c25c7f3fe3128$var$_getOwner(target, evtName, checkPrototype, checkParentProto) || target;
        if (owner) return $1e7c25c7f3fe3128$var$_createInstrumentHook(owner, evtName, owner[evtName], callbacks);
    }
    return null;
}

});

parcelRegister("cPiEJ", function(module, exports) {

$parcel$export(module.exports, "_DYN_TO_STRING", function () { return $9568b8210600cb8f$export$e2818d11505fa034; });
$parcel$export(module.exports, "_DYN_DISABLE_EXCEPTION_TR0", function () { return $9568b8210600cb8f$export$f8c520424f754c1c; });
$parcel$export(module.exports, "_DYN_AUTO_TRACK_PAGE_VISI1", function () { return $9568b8210600cb8f$export$65bc351810f367dc; });
$parcel$export(module.exports, "_DYN_OVERRIDE_PAGE_VIEW_D2", function () { return $9568b8210600cb8f$export$d0a26b7eaadd0d4e; });
$parcel$export(module.exports, "_DYN_ENABLE_UNHANDLED_PRO3", function () { return $9568b8210600cb8f$export$4f55a24a56b3d5ca; });
$parcel$export(module.exports, "_DYN_SAMPLING_PERCENTAGE", function () { return $9568b8210600cb8f$export$51ccd61d31b31ade; });
$parcel$export(module.exports, "_DYN_IS_STORAGE_USE_DISAB4", function () { return $9568b8210600cb8f$export$c8f0ddf05bfb48a8; });
$parcel$export(module.exports, "_DYN_IS_BROWSER_LINK_TRAC5", function () { return $9568b8210600cb8f$export$8f81e2d5093195fc; });
$parcel$export(module.exports, "_DYN_ENABLE_AUTO_ROUTE_TR6", function () { return $9568b8210600cb8f$export$2c102e3a86379a7; });
$parcel$export(module.exports, "_DYN_NAME_PREFIX", function () { return $9568b8210600cb8f$export$6d013a7bc2da53c1; });
$parcel$export(module.exports, "_DYN_DISABLE_FLUSH_ON_BEF7", function () { return $9568b8210600cb8f$export$9173a290c0626b54; });
$parcel$export(module.exports, "_DYN_CORE", function () { return $9568b8210600cb8f$export$f9ae8d0acf86503e; });
$parcel$export(module.exports, "_DYN_DATA_TYPE", function () { return $9568b8210600cb8f$export$9e16762ab4f2648; });
$parcel$export(module.exports, "_DYN_ENVELOPE_TYPE", function () { return $9568b8210600cb8f$export$2672d4f7ccc80348; });
$parcel$export(module.exports, "_DYN_DIAG_LOG", function () { return $9568b8210600cb8f$export$c7ff2c36e5c78421; });
$parcel$export(module.exports, "_DYN_TRACK", function () { return $9568b8210600cb8f$export$548634e98b3af9c4; });
$parcel$export(module.exports, "_DYN_TRACK_PAGE_VIEW", function () { return $9568b8210600cb8f$export$ab1a8669316b7a02; });
$parcel$export(module.exports, "_DYN_TRACK_PREVIOUS_PAGE_9", function () { return $9568b8210600cb8f$export$e468e9c9816152cf; });
$parcel$export(module.exports, "_DYN_SEND_PAGE_VIEW_INTER10", function () { return $9568b8210600cb8f$export$a6c6e891ce0a5106; });
$parcel$export(module.exports, "_DYN_SEND_PAGE_VIEW_PERFO11", function () { return $9568b8210600cb8f$export$982b1825c068e342; });
$parcel$export(module.exports, "_DYN_POPULATE_PAGE_VIEW_P12", function () { return $9568b8210600cb8f$export$81995f88bf49a98b; });
$parcel$export(module.exports, "_DYN_HREF", function () { return $9568b8210600cb8f$export$8d0bd9d006f3ecea; });
$parcel$export(module.exports, "_DYN_SEND_EXCEPTION_INTER13", function () { return $9568b8210600cb8f$export$f59078bb778c9553; });
$parcel$export(module.exports, "_DYN_EXCEPTION", function () { return $9568b8210600cb8f$export$4852fd87b68a6e1f; });
$parcel$export(module.exports, "_DYN_ERROR", function () { return $9568b8210600cb8f$export$ff0a0f80c43edd37; });
$parcel$export(module.exports, "_DYN__ONERROR", function () { return $9568b8210600cb8f$export$31fe7bcf0f7c83e8; });
$parcel$export(module.exports, "_DYN_ERROR_SRC", function () { return $9568b8210600cb8f$export$d190ee0b6bfe36d8; });
$parcel$export(module.exports, "_DYN_LINE_NUMBER", function () { return $9568b8210600cb8f$export$4d19a8ea486d5967; });
$parcel$export(module.exports, "_DYN_COLUMN_NUMBER", function () { return $9568b8210600cb8f$export$91a182df12726bcd; });
$parcel$export(module.exports, "_DYN_MESSAGE", function () { return $9568b8210600cb8f$export$923606b70907833e; });
$parcel$export(module.exports, "_DYN__CREATE_AUTO_EXCEPTI14", function () { return $9568b8210600cb8f$export$5ad7f2cdb26509a7; });
$parcel$export(module.exports, "_DYN_ADD_TELEMETRY_INITIA15", function () { return $9568b8210600cb8f$export$d4bb20b04e217271; });
$parcel$export(module.exports, "_DYN_DURATION", function () { return $9568b8210600cb8f$export$aa395e58f404db90; });
$parcel$export(module.exports, "_DYN_LENGTH", function () { return $9568b8210600cb8f$export$6eae51590aaea43; });
$parcel$export(module.exports, "_DYN_IS_PERFORMANCE_TIMIN16", function () { return $9568b8210600cb8f$export$22b3a1855dbf3858; });
$parcel$export(module.exports, "_DYN_GET_PERFORMANCE_TIMI17", function () { return $9568b8210600cb8f$export$ab75e037bf1b3e24; });
$parcel$export(module.exports, "_DYN_NAVIGATION_START", function () { return $9568b8210600cb8f$export$f8670e269dbf7411; });
$parcel$export(module.exports, "_DYN_SHOULD_COLLECT_DURAT18", function () { return $9568b8210600cb8f$export$29c6d1b9c4ab3707; });
$parcel$export(module.exports, "_DYN_IS_PERFORMANCE_TIMIN19", function () { return $9568b8210600cb8f$export$ad0658e0d367af69; });
$parcel$export(module.exports, "_DYN_GET_ENTRIES_BY_TYPE", function () { return $9568b8210600cb8f$export$96ba0dffa6c93bb1; });
$parcel$export(module.exports, "_DYN_RESPONSE_START", function () { return $9568b8210600cb8f$export$efd7bea2390142dc; });
$parcel$export(module.exports, "_DYN_REQUEST_START", function () { return $9568b8210600cb8f$export$2a979904ebe4c805; });
$parcel$export(module.exports, "_DYN_LOAD_EVENT_END", function () { return $9568b8210600cb8f$export$3e2743adb5050880; });
$parcel$export(module.exports, "_DYN_RESPONSE_END", function () { return $9568b8210600cb8f$export$cb472b94f03785cf; });
$parcel$export(module.exports, "_DYN_CONNECT_END", function () { return $9568b8210600cb8f$export$ade5c25ec120f74e; });
$parcel$export(module.exports, "_DYN_PAGE_VISIT_START_TIM20", function () { return $9568b8210600cb8f$export$9c1a08f4929dd5e8; });
/*
 * Application Insights JavaScript SDK - Web Analytics, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ // @skip-file-minify
// ##############################################################
// AUTO GENERATED FILE: This file is Auto Generated during build.
// ##############################################################
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// Note: DON'T Export these const from the package as we are still targeting ES3 this will export a mutable variables that someone could change!!!
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
var $9568b8210600cb8f$export$e2818d11505fa034 = "toString"; // Count: 4
var $9568b8210600cb8f$export$f8c520424f754c1c = "disableExceptionTracking"; // Count: 3
var $9568b8210600cb8f$export$65bc351810f367dc = "autoTrackPageVisitTime"; // Count: 4
var $9568b8210600cb8f$export$d0a26b7eaadd0d4e = "overridePageViewDuration"; // Count: 3
var $9568b8210600cb8f$export$4f55a24a56b3d5ca = "enableUnhandledPromiseRejectionTracking"; // Count: 3
var $9568b8210600cb8f$export$51ccd61d31b31ade = "samplingPercentage"; // Count: 4
var $9568b8210600cb8f$export$c8f0ddf05bfb48a8 = "isStorageUseDisabled"; // Count: 4
var $9568b8210600cb8f$export$8f81e2d5093195fc = "isBrowserLinkTrackingEnabled"; // Count: 4
var $9568b8210600cb8f$export$2c102e3a86379a7 = "enableAutoRouteTracking"; // Count: 3
var $9568b8210600cb8f$export$6d013a7bc2da53c1 = "namePrefix"; // Count: 3
var $9568b8210600cb8f$export$9173a290c0626b54 = "disableFlushOnBeforeUnload"; // Count: 3
var $9568b8210600cb8f$export$89658174a707d672 = "disableFlushOnUnload"; // Count: 2
var $9568b8210600cb8f$export$f9ae8d0acf86503e = "core"; // Count: 7
var $9568b8210600cb8f$export$9e16762ab4f2648 = "dataType"; // Count: 8
var $9568b8210600cb8f$export$2672d4f7ccc80348 = "envelopeType"; // Count: 7
var $9568b8210600cb8f$export$c7ff2c36e5c78421 = "diagLog"; // Count: 13
var $9568b8210600cb8f$export$548634e98b3af9c4 = "track"; // Count: 7
var $9568b8210600cb8f$export$ab1a8669316b7a02 = "trackPageView"; // Count: 4
var $9568b8210600cb8f$export$e468e9c9816152cf = "trackPreviousPageVisit"; // Count: 3
var $9568b8210600cb8f$export$a6c6e891ce0a5106 = "sendPageViewInternal"; // Count: 7
var $9568b8210600cb8f$export$982b1825c068e342 = "sendPageViewPerformanceInternal"; // Count: 3
var $9568b8210600cb8f$export$81995f88bf49a98b = "populatePageViewPerformanceEvent"; // Count: 3
var $9568b8210600cb8f$export$8d0bd9d006f3ecea = "href"; // Count: 6
var $9568b8210600cb8f$export$f59078bb778c9553 = "sendExceptionInternal"; // Count: 2
var $9568b8210600cb8f$export$4852fd87b68a6e1f = "exception"; // Count: 3
var $9568b8210600cb8f$export$ff0a0f80c43edd37 = "error"; // Count: 5
var $9568b8210600cb8f$export$31fe7bcf0f7c83e8 = "_onerror"; // Count: 3
var $9568b8210600cb8f$export$d190ee0b6bfe36d8 = "errorSrc"; // Count: 3
var $9568b8210600cb8f$export$4d19a8ea486d5967 = "lineNumber"; // Count: 5
var $9568b8210600cb8f$export$91a182df12726bcd = "columnNumber"; // Count: 5
var $9568b8210600cb8f$export$923606b70907833e = "message"; // Count: 4
var $9568b8210600cb8f$export$5ad7f2cdb26509a7 = "CreateAutoException"; // Count: 3
var $9568b8210600cb8f$export$d4bb20b04e217271 = "addTelemetryInitializer"; // Count: 4
var $9568b8210600cb8f$export$aa395e58f404db90 = "duration"; // Count: 10
var $9568b8210600cb8f$export$6eae51590aaea43 = "length"; // Count: 5
var $9568b8210600cb8f$export$22b3a1855dbf3858 = "isPerformanceTimingSupported"; // Count: 2
var $9568b8210600cb8f$export$ab75e037bf1b3e24 = "getPerformanceTiming"; // Count: 2
var $9568b8210600cb8f$export$f8670e269dbf7411 = "navigationStart"; // Count: 4
var $9568b8210600cb8f$export$29c6d1b9c4ab3707 = "shouldCollectDuration"; // Count: 3
var $9568b8210600cb8f$export$ad0658e0d367af69 = "isPerformanceTimingDataReady"; // Count: 2
var $9568b8210600cb8f$export$96ba0dffa6c93bb1 = "getEntriesByType"; // Count: 3
var $9568b8210600cb8f$export$efd7bea2390142dc = "responseStart"; // Count: 5
var $9568b8210600cb8f$export$2a979904ebe4c805 = "requestStart"; // Count: 3
var $9568b8210600cb8f$export$3e2743adb5050880 = "loadEventEnd"; // Count: 4
var $9568b8210600cb8f$export$cb472b94f03785cf = "responseEnd"; // Count: 5
var $9568b8210600cb8f$export$ade5c25ec120f74e = "connectEnd"; // Count: 4
var $9568b8210600cb8f$export$9c1a08f4929dd5e8 = "pageVisitStartTime"; // Count: 2

});

parcelRegister("4wyIY", function(module, exports) {

$parcel$export(module.exports, "PageViewManager", function () { return $34b51623935f36a2$export$5bb8d6768724bf86; });
/*
 * Application Insights JavaScript SDK - Web Analytics, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $kbmky = parcelRequire("kbmky");

var $4sUzw = parcelRequire("4sUzw");

var $8z2Gd = parcelRequire("8z2Gd");
var $erRAP = parcelRequire("erRAP");
var $3I5zg = parcelRequire("3I5zg");

var $cPiEJ = parcelRequire("cPiEJ");
var $34b51623935f36a2$var$_isWebWorker = null;
function $34b51623935f36a2$var$isWebWorker() {
    if ($34b51623935f36a2$var$_isWebWorker == null) try {
        $34b51623935f36a2$var$_isWebWorker = !!(self && self instanceof WorkerGlobalScope);
    } catch (e) {
        $34b51623935f36a2$var$_isWebWorker = false;
    }
    return $34b51623935f36a2$var$_isWebWorker;
}
/**
 * Class encapsulates sending page views and page view performance telemetry.
 */ var $34b51623935f36a2$export$5bb8d6768724bf86 = /** @class */ function() {
    function PageViewManager(appInsights, overridePageViewDuration, core, pageViewPerformanceManager) {
        (0, $kbmky.default)(PageViewManager, this, function(_self) {
            var queueTimer = null;
            var itemQueue = [];
            var pageViewPerformanceSent = false;
            var _logger;
            if (core) _logger = core.logger;
            function _flushChannels(isAsync) {
                if (core) core.flush(isAsync);
            }
            function _startTimer() {
                if (!queueTimer) queueTimer = setTimeout(function() {
                    queueTimer = null;
                    var allItems = itemQueue.slice(0);
                    var doFlush = false;
                    itemQueue = [];
                    (0, $erRAP.arrForEach)(allItems, function(item) {
                        if (!item()) // Not processed so rescheduled
                        itemQueue.push(item);
                        else doFlush = true;
                    });
                    if (itemQueue[0, $cPiEJ._DYN_LENGTH /* @min:%2elength */ ] > 0) _startTimer();
                    if (doFlush) // We process at least one item so flush the queue
                    _flushChannels(true);
                }, 100);
            }
            function _addQueue(cb) {
                itemQueue.push(cb);
                _startTimer();
            }
            _self[0, $cPiEJ._DYN_TRACK_PAGE_VIEW /* @min:%2etrackPageView */ ] = function(pageView, customProperties) {
                var name = pageView.name;
                if ((0, $erRAP.isNullOrUndefined)(name) || typeof name !== "string") {
                    var doc = (0, $3I5zg.getDocument)();
                    name = pageView.name = doc && doc.title || "";
                }
                var uri = pageView.uri;
                if ((0, $erRAP.isNullOrUndefined)(uri) || typeof uri !== "string") {
                    var location_1 = (0, $3I5zg.getLocation)();
                    uri = pageView.uri = location_1 && location_1[0, $cPiEJ._DYN_HREF /* @min:%2ehref */ ] || "";
                }
                // case 1a. if performance timing is not supported by the browser, send the page view telemetry with the duration provided by the user. If the user
                // do not provide the duration, set duration to undefined
                // Also this is case 4
                if (!pageViewPerformanceManager[0, $cPiEJ._DYN_IS_PERFORMANCE_TIMIN16 /* @min:%2eisPerformanceTimingSupported */ ]()) {
                    appInsights[0, $cPiEJ._DYN_SEND_PAGE_VIEW_INTER10 /* @min:%2esendPageViewInternal */ ](pageView, customProperties);
                    _flushChannels(true);
                    if (!$34b51623935f36a2$var$isWebWorker()) // no navigation timing (IE 8, iOS Safari 8.4, Opera Mini 8 - see http://caniuse.com/#feat=nav-timing)
                    (0, $8z2Gd._throwInternal)(_logger, 2 /* eLoggingSeverity.WARNING */ , 25 /* _eInternalMessageId.NavigationTimingNotSupported */ , "trackPageView: navigation timing API used for calculation of page duration is not supported in this browser. This page view will be collected without duration and timing info.");
                    return;
                }
                var pageViewSent = false;
                var customDuration;
                // if the performance timing is supported by the browser, calculate the custom duration
                var start = pageViewPerformanceManager[0, $cPiEJ._DYN_GET_PERFORMANCE_TIMI17 /* @min:%2egetPerformanceTiming */ ]()[0, $cPiEJ._DYN_NAVIGATION_START /* @min:%2enavigationStart */ ];
                if (start > 0) {
                    customDuration = (0, $4sUzw.dateTimeUtilsDuration)(start, +new Date);
                    if (!pageViewPerformanceManager[0, $cPiEJ._DYN_SHOULD_COLLECT_DURAT18 /* @min:%2eshouldCollectDuration */ ](customDuration)) customDuration = undefined;
                }
                // if the user has provided duration, send a page view telemetry with the provided duration. Otherwise, if
                // overridePageViewDuration is set to true, send a page view telemetry with the custom duration calculated earlier
                var duration;
                if (!(0, $erRAP.isNullOrUndefined)(customProperties) && !(0, $erRAP.isNullOrUndefined)(customProperties[0, $cPiEJ._DYN_DURATION /* @min:%2eduration */ ])) duration = customProperties[0, $cPiEJ._DYN_DURATION /* @min:%2eduration */ ];
                if (overridePageViewDuration || !isNaN(duration)) {
                    if (isNaN(duration)) {
                        // case 3
                        if (!customProperties) customProperties = {};
                        customProperties[0, $cPiEJ._DYN_DURATION /* @min:%2eduration */ ] = customDuration;
                    }
                    // case 2
                    appInsights[0, $cPiEJ._DYN_SEND_PAGE_VIEW_INTER10 /* @min:%2esendPageViewInternal */ ](pageView, customProperties);
                    _flushChannels(true);
                    pageViewSent = true;
                }
                // now try to send the page view performance telemetry
                var maxDurationLimit = 60000;
                if (!customProperties) customProperties = {};
                // Queue the event for processing
                _addQueue(function() {
                    var processed = false;
                    try {
                        if (pageViewPerformanceManager[0, $cPiEJ._DYN_IS_PERFORMANCE_TIMIN19 /* @min:%2eisPerformanceTimingDataReady */ ]()) {
                            processed = true;
                            var pageViewPerformance = {
                                name: name,
                                uri: uri
                            };
                            pageViewPerformanceManager[0, $cPiEJ._DYN_POPULATE_PAGE_VIEW_P12 /* @min:%2epopulatePageViewPerformanceEvent */ ](pageViewPerformance);
                            if (!pageViewPerformance.isValid && !pageViewSent) {
                                // If navigation timing gives invalid numbers, then go back to "override page view duration" mode.
                                // That's the best value we can get that makes sense.
                                customProperties[0, $cPiEJ._DYN_DURATION /* @min:%2eduration */ ] = customDuration;
                                appInsights[0, $cPiEJ._DYN_SEND_PAGE_VIEW_INTER10 /* @min:%2esendPageViewInternal */ ](pageView, customProperties);
                            } else {
                                if (!pageViewSent) {
                                    customProperties[0, $cPiEJ._DYN_DURATION /* @min:%2eduration */ ] = pageViewPerformance.durationMs;
                                    appInsights[0, $cPiEJ._DYN_SEND_PAGE_VIEW_INTER10 /* @min:%2esendPageViewInternal */ ](pageView, customProperties);
                                }
                                if (!pageViewPerformanceSent) {
                                    appInsights[0, $cPiEJ._DYN_SEND_PAGE_VIEW_PERFO11 /* @min:%2esendPageViewPerformanceInternal */ ](pageViewPerformance, customProperties);
                                    pageViewPerformanceSent = true;
                                }
                            }
                        } else if (start > 0 && (0, $4sUzw.dateTimeUtilsDuration)(start, +new Date) > maxDurationLimit) {
                            // if performance timings are not ready but we exceeded the maximum duration limit, just log a page view telemetry
                            // with the maximum duration limit. Otherwise, keep waiting until performance timings are ready
                            processed = true;
                            if (!pageViewSent) {
                                customProperties[0, $cPiEJ._DYN_DURATION /* @min:%2eduration */ ] = maxDurationLimit;
                                appInsights[0, $cPiEJ._DYN_SEND_PAGE_VIEW_INTER10 /* @min:%2esendPageViewInternal */ ](pageView, customProperties);
                            }
                        }
                    } catch (e) {
                        (0, $8z2Gd._throwInternal)(_logger, 1 /* eLoggingSeverity.CRITICAL */ , 38 /* _eInternalMessageId.TrackPVFailedCalc */ , "trackPageView failed on page load calculation: " + (0, $erRAP.getExceptionName)(e), {
                            exception: (0, $3I5zg.dumpObj)(e)
                        });
                    }
                    return processed;
                });
            };
            _self.teardown = function(unloadCtx, unloadState) {
                if (queueTimer) {
                    clearTimeout(queueTimer);
                    queueTimer = null;
                    var allItems = itemQueue.slice(0);
                    var doFlush_1 = false;
                    itemQueue = [];
                    (0, $erRAP.arrForEach)(allItems, function(item) {
                        if (item()) doFlush_1 = true;
                    });
                }
            };
        });
    }
    // Removed Stub for PageViewManager.prototype.trackPageView.
    // Removed Stub for PageViewManager.prototype.teardown.
    // This is a workaround for an IE8 bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    // this will be removed when ES3 support is dropped.
    PageViewManager.__ieDyn = 1;
    return PageViewManager;
}();

});

parcelRegister("fcx3d", function(module, exports) {

$parcel$export(module.exports, "PageViewPerformanceManager", function () { return $b1119d3b90c13de4$export$da80ef98bc1bafa6; });
/*
 * Application Insights JavaScript SDK - Web Analytics, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $kbmky = parcelRequire("kbmky");

var $4sUzw = parcelRequire("4sUzw");
var $6Gvon = parcelRequire("6Gvon");

var $8z2Gd = parcelRequire("8z2Gd");
var $3I5zg = parcelRequire("3I5zg");

var $cPiEJ = parcelRequire("cPiEJ");
var $b1119d3b90c13de4$var$MAX_DURATION_ALLOWED = 3600000; // 1h
var $b1119d3b90c13de4$var$botAgentNames = [
    "googlebot",
    "adsbot-google",
    "apis-google",
    "mediapartners-google"
];
function $b1119d3b90c13de4$var$_isPerformanceTimingSupported() {
    var perf = (0, $3I5zg.getPerformance)();
    return perf && !!perf.timing;
}
function $b1119d3b90c13de4$var$_isPerformanceNavigationTimingSupported() {
    var perf = (0, $3I5zg.getPerformance)();
    return perf && perf.getEntriesByType && perf.getEntriesByType("navigation")[0, $cPiEJ._DYN_LENGTH /* @min:%2elength */ ] > 0;
}
function $b1119d3b90c13de4$var$_isPerformanceTimingDataReady() {
    var perf = (0, $3I5zg.getPerformance)();
    var timing = perf ? perf.timing : 0;
    return timing && timing.domainLookupStart > 0 && timing[0, $cPiEJ._DYN_NAVIGATION_START /* @min:%2enavigationStart */ ] > 0 && timing[0, $cPiEJ._DYN_RESPONSE_START /* @min:%2eresponseStart */ ] > 0 && timing[0, $cPiEJ._DYN_REQUEST_START /* @min:%2erequestStart */ ] > 0 && timing[0, $cPiEJ._DYN_LOAD_EVENT_END /* @min:%2eloadEventEnd */ ] > 0 && timing[0, $cPiEJ._DYN_RESPONSE_END /* @min:%2eresponseEnd */ ] > 0 && timing[0, $cPiEJ._DYN_CONNECT_END /* @min:%2econnectEnd */ ] > 0 && timing.domLoading > 0;
}
function $b1119d3b90c13de4$var$_getPerformanceTiming() {
    if ($b1119d3b90c13de4$var$_isPerformanceTimingSupported()) return (0, $3I5zg.getPerformance)().timing;
    return null;
}
function $b1119d3b90c13de4$var$_getPerformanceNavigationTiming() {
    if ($b1119d3b90c13de4$var$_isPerformanceNavigationTimingSupported()) return (0, $3I5zg.getPerformance)()[0, $cPiEJ._DYN_GET_ENTRIES_BY_TYPE /* @min:%2egetEntriesByType */ ]("navigation")[0];
    return null;
}
/**
* This method tells if given durations should be excluded from collection.
*/ function $b1119d3b90c13de4$var$_shouldCollectDuration() {
    var durations = [];
    for(var _i = 0; _i < arguments.length; _i++)durations[_i] = arguments[_i];
    var _navigator = (0, $3I5zg.getNavigator)() || {};
    // a full list of Google crawlers user agent strings - https://support.google.com/webmasters/answer/1061943?hl=en
    var userAgent = _navigator.userAgent;
    var isGoogleBot = false;
    if (userAgent) for(var i = 0; i < $b1119d3b90c13de4$var$botAgentNames[0, $cPiEJ._DYN_LENGTH /* @min:%2elength */ ]; i++)isGoogleBot = isGoogleBot || userAgent.toLowerCase().indexOf($b1119d3b90c13de4$var$botAgentNames[i]) !== -1;
    if (isGoogleBot) // Don't report durations for GoogleBot, it is returning invalid values in performance.timing API.
    return false;
    else // for other page views, don't report if it's outside of a reasonable range
    for(var i = 0; i < durations[0, $cPiEJ._DYN_LENGTH /* @min:%2elength */ ]; i++){
        if (durations[i] < 0 || durations[i] >= $b1119d3b90c13de4$var$MAX_DURATION_ALLOWED) return false;
    }
    return true;
}
/**
 * Class encapsulates sending page view performance telemetry.
 */ var $b1119d3b90c13de4$export$da80ef98bc1bafa6 = /** @class */ function() {
    function PageViewPerformanceManager(core) {
        var _logger = (0, $8z2Gd.safeGetLogger)(core);
        (0, $kbmky.default)(PageViewPerformanceManager, this, function(_self) {
            _self[0, $cPiEJ._DYN_POPULATE_PAGE_VIEW_P12 /* @min:%2epopulatePageViewPerformanceEvent */ ] = function(pageViewPerformance) {
                pageViewPerformance.isValid = false;
                /*
                 * http://www.w3.org/TR/navigation-timing/#processing-model
                 *  |-navigationStart
                 *  |             |-connectEnd
                 *  |             ||-requestStart
                 *  |             ||             |-responseStart
                 *  |             ||             |              |-responseEnd
                 *  |             ||             |              |
                 *  |             ||             |              |         |-loadEventEnd
                 *  |---network---||---request---|---response---|---dom---|
                 *  |--------------------------total----------------------|
                 *
                 *  total = The difference between the load event of the current document is completed and the first recorded timestamp of the performance entry : https://developer.mozilla.org/en-US/docs/Web/Performance/Navigation_and_resource_timings#duration
                 *  network = Redirect time + App Cache + DNS lookup time + TCP connection time
                 *  request = Request time : https://developer.mozilla.org/en-US/docs/Web/Performance/Navigation_and_resource_timings#request_time
                 *  response = Response time
                 *  dom = Document load time : https://html.spec.whatwg.org/multipage/dom.html#document-load-timing-info
                 *      = Document processing time : https://developers.google.com/web/fundamentals/performance/navigation-and-resource-timing/#document_processing
                 *      + Loading time : https://developers.google.com/web/fundamentals/performance/navigation-and-resource-timing/#loading
                 */ var navigationTiming = $b1119d3b90c13de4$var$_getPerformanceNavigationTiming();
                var timing = $b1119d3b90c13de4$var$_getPerformanceTiming();
                var total = 0;
                var network = 0;
                var request = 0;
                var response = 0;
                var dom = 0;
                if (navigationTiming || timing) {
                    if (navigationTiming) {
                        total = navigationTiming[0, $cPiEJ._DYN_DURATION /* @min:%2eduration */ ];
                        /**
                         * support both cases:
                         * - startTime is always zero: https://developer.mozilla.org/en-US/docs/Web/API/PerformanceNavigationTiming
                         * - for older browsers where the startTime is not zero
                         */ network = navigationTiming.startTime === 0 ? navigationTiming[0, $cPiEJ._DYN_CONNECT_END /* @min:%2econnectEnd */ ] : (0, $4sUzw.dateTimeUtilsDuration)(navigationTiming.startTime, navigationTiming[0, $cPiEJ._DYN_CONNECT_END /* @min:%2econnectEnd */ ]);
                        request = (0, $4sUzw.dateTimeUtilsDuration)(navigationTiming.requestStart, navigationTiming[0, $cPiEJ._DYN_RESPONSE_START /* @min:%2eresponseStart */ ]);
                        response = (0, $4sUzw.dateTimeUtilsDuration)(navigationTiming[0, $cPiEJ._DYN_RESPONSE_START /* @min:%2eresponseStart */ ], navigationTiming[0, $cPiEJ._DYN_RESPONSE_END /* @min:%2eresponseEnd */ ]);
                        dom = (0, $4sUzw.dateTimeUtilsDuration)(navigationTiming.responseEnd, navigationTiming[0, $cPiEJ._DYN_LOAD_EVENT_END /* @min:%2eloadEventEnd */ ]);
                    } else {
                        total = (0, $4sUzw.dateTimeUtilsDuration)(timing[0, $cPiEJ._DYN_NAVIGATION_START /* @min:%2enavigationStart */ ], timing[0, $cPiEJ._DYN_LOAD_EVENT_END /* @min:%2eloadEventEnd */ ]);
                        network = (0, $4sUzw.dateTimeUtilsDuration)(timing[0, $cPiEJ._DYN_NAVIGATION_START /* @min:%2enavigationStart */ ], timing[0, $cPiEJ._DYN_CONNECT_END /* @min:%2econnectEnd */ ]);
                        request = (0, $4sUzw.dateTimeUtilsDuration)(timing.requestStart, timing[0, $cPiEJ._DYN_RESPONSE_START /* @min:%2eresponseStart */ ]);
                        response = (0, $4sUzw.dateTimeUtilsDuration)(timing[0, $cPiEJ._DYN_RESPONSE_START /* @min:%2eresponseStart */ ], timing[0, $cPiEJ._DYN_RESPONSE_END /* @min:%2eresponseEnd */ ]);
                        dom = (0, $4sUzw.dateTimeUtilsDuration)(timing.responseEnd, timing[0, $cPiEJ._DYN_LOAD_EVENT_END /* @min:%2eloadEventEnd */ ]);
                    }
                    if (total === 0) (0, $8z2Gd._throwInternal)(_logger, 2 /* eLoggingSeverity.WARNING */ , 10 /* _eInternalMessageId.ErrorPVCalc */ , "error calculating page view performance.", {
                        total: total,
                        network: network,
                        request: request,
                        response: response,
                        dom: dom
                    });
                    else if (!_self[0, $cPiEJ._DYN_SHOULD_COLLECT_DURAT18 /* @min:%2eshouldCollectDuration */ ](total, network, request, response, dom)) (0, $8z2Gd._throwInternal)(_logger, 2 /* eLoggingSeverity.WARNING */ , 45 /* _eInternalMessageId.InvalidDurationValue */ , "Invalid page load duration value. Browser perf data won't be sent.", {
                        total: total,
                        network: network,
                        request: request,
                        response: response,
                        dom: dom
                    });
                    else if (total < Math.floor(network) + Math.floor(request) + Math.floor(response) + Math.floor(dom)) // some browsers may report individual components incorrectly so that the sum of the parts will be bigger than total PLT
                    // in this case, don't report client performance from this page
                    (0, $8z2Gd._throwInternal)(_logger, 2 /* eLoggingSeverity.WARNING */ , 8 /* _eInternalMessageId.ClientPerformanceMathError */ , "client performance math error.", {
                        total: total,
                        network: network,
                        request: request,
                        response: response,
                        dom: dom
                    });
                    else {
                        pageViewPerformance.durationMs = total;
                        // // convert to timespans
                        pageViewPerformance.perfTotal = pageViewPerformance[0, $cPiEJ._DYN_DURATION /* @min:%2eduration */ ] = (0, $6Gvon.msToTimeSpan)(total);
                        pageViewPerformance.networkConnect = (0, $6Gvon.msToTimeSpan)(network);
                        pageViewPerformance.sentRequest = (0, $6Gvon.msToTimeSpan)(request);
                        pageViewPerformance.receivedResponse = (0, $6Gvon.msToTimeSpan)(response);
                        pageViewPerformance.domProcessing = (0, $6Gvon.msToTimeSpan)(dom);
                        pageViewPerformance.isValid = true;
                    }
                }
            };
            _self[0, $cPiEJ._DYN_GET_PERFORMANCE_TIMI17 /* @min:%2egetPerformanceTiming */ ] = $b1119d3b90c13de4$var$_getPerformanceTiming;
            _self[0, $cPiEJ._DYN_IS_PERFORMANCE_TIMIN16 /* @min:%2eisPerformanceTimingSupported */ ] = $b1119d3b90c13de4$var$_isPerformanceTimingSupported;
            _self[0, $cPiEJ._DYN_IS_PERFORMANCE_TIMIN19 /* @min:%2eisPerformanceTimingDataReady */ ] = $b1119d3b90c13de4$var$_isPerformanceTimingDataReady;
            _self[0, $cPiEJ._DYN_SHOULD_COLLECT_DURAT18 /* @min:%2eshouldCollectDuration */ ] = $b1119d3b90c13de4$var$_shouldCollectDuration;
        });
    }
    // Removed Stub for PageViewPerformanceManager.prototype.populatePageViewPerformanceEvent.
    // Removed Stub for PageViewPerformanceManager.prototype.getPerformanceTiming.
    // Removed Stub for PageViewPerformanceManager.prototype.isPerformanceTimingSupported.
    // Removed Stub for PageViewPerformanceManager.prototype.isPerformanceTimingDataReady.
    // Removed Stub for PageViewPerformanceManager.prototype.shouldCollectDuration.
    // This is a workaround for an IE8 bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    // this will be removed when ES3 support is dropped.
    PageViewPerformanceManager.__ieDyn = 1;
    return PageViewPerformanceManager;
}();

});

parcelRegister("idCyU", function(module, exports) {

$parcel$export(module.exports, "PageVisitTimeManager", function () { return $d4375a883bb6ec03$export$f6fdd81afb2fe76; });
/*
 * Application Insights JavaScript SDK - Web Analytics, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $kbmky = parcelRequire("kbmky");

var $fu0yT = parcelRequire("fu0yT");

var $8z2Gd = parcelRequire("8z2Gd");
var $erRAP = parcelRequire("erRAP");
var $3I5zg = parcelRequire("3I5zg");

var $cPiEJ = parcelRequire("cPiEJ");
/**
 * Used to track page visit durations
 */ var $d4375a883bb6ec03$export$f6fdd81afb2fe76 = /** @class */ function() {
    /**
     * Creates a new instance of PageVisitTimeManager
     * @param pageVisitTimeTrackingHandler Delegate that will be called to send telemetry data to AI (when trackPreviousPageVisit is called)
     * @returns {}
     */ function PageVisitTimeManager(logger, pageVisitTimeTrackingHandler) {
        var prevPageVisitDataKeyName = "prevPageVisitData";
        (0, $kbmky.default)(PageVisitTimeManager, this, function(_self) {
            _self[0, $cPiEJ._DYN_TRACK_PREVIOUS_PAGE_9 /* @min:%2etrackPreviousPageVisit */ ] = function(currentPageName, currentPageUrl) {
                try {
                    // Restart timer for new page view
                    var prevPageVisitTimeData = restartPageVisitTimer(currentPageName, currentPageUrl);
                    // If there was a page already being timed, track the visit time for it now.
                    if (prevPageVisitTimeData) pageVisitTimeTrackingHandler(prevPageVisitTimeData.pageName, prevPageVisitTimeData.pageUrl, prevPageVisitTimeData.pageVisitTime);
                } catch (e) {
                    (0, $8z2Gd._warnToConsole)(logger, "Auto track page visit time failed, metric will not be collected: " + (0, $3I5zg.dumpObj)(e));
                }
            };
            /**
             * Stops timing of current page (if exists) and starts timing for duration of visit to pageName
             * @param pageName Name of page to begin timing visit duration
             * @returns {PageVisitData} Page visit data (including duration) of pageName from last call to start or restart, if exists. Null if not.
             */ function restartPageVisitTimer(pageName, pageUrl) {
                var prevPageVisitData = null;
                try {
                    prevPageVisitData = stopPageVisitTimer();
                    startPageVisitTimer(pageName, pageUrl);
                } catch (e) {
                    (0, $8z2Gd._warnToConsole)(logger, "Call to restart failed: " + (0, $3I5zg.dumpObj)(e));
                    prevPageVisitData = null;
                }
                return prevPageVisitData;
            }
            /**
             * Starts timing visit duration of pageName
             * @param pageName
             * @returns {}
             */ function startPageVisitTimer(pageName, pageUrl) {
                try {
                    if ((0, $fu0yT.utlCanUseSessionStorage)()) {
                        if ((0, $fu0yT.utlGetSessionStorage)(logger, prevPageVisitDataKeyName) != null) (0, $erRAP.throwError)("Cannot call startPageVisit consecutively without first calling stopPageVisit");
                        var currPageVisitData = new $d4375a883bb6ec03$export$513202441432a369(pageName, pageUrl);
                        var currPageVisitDataStr = (0, $3I5zg.getJSON)().stringify(currPageVisitData);
                        (0, $fu0yT.utlSetSessionStorage)(logger, prevPageVisitDataKeyName, currPageVisitDataStr);
                    }
                } catch (e) {
                    // TODO: Remove this catch in next phase, since if start is called twice in a row the exception needs to be propagated out
                    (0, $8z2Gd._warnToConsole)(logger, "Call to start failed: " + (0, $3I5zg.dumpObj)(e));
                }
            }
            /**
             * Stops timing of current page, if exists.
             * @returns {PageVisitData} Page visit data (including duration) of pageName from call to start, if exists. Null if not.
             */ function stopPageVisitTimer() {
                var prevPageVisitData = null;
                try {
                    if ((0, $fu0yT.utlCanUseSessionStorage)()) {
                        // Define end time of page's visit
                        var pageVisitEndTime = (0, $erRAP.dateNow)();
                        // Try to retrieve  page name and start time from session storage
                        var pageVisitDataJsonStr = (0, $fu0yT.utlGetSessionStorage)(logger, prevPageVisitDataKeyName);
                        if (pageVisitDataJsonStr && (0, $3I5zg.hasJSON)()) {
                            // if previous page data exists, set end time of visit
                            prevPageVisitData = (0, $3I5zg.getJSON)().parse(pageVisitDataJsonStr);
                            prevPageVisitData.pageVisitTime = pageVisitEndTime - prevPageVisitData[0, $cPiEJ._DYN_PAGE_VISIT_START_TIM20 /* @min:%2epageVisitStartTime */ ];
                            // Remove data from storage since we already used it
                            (0, $fu0yT.utlRemoveSessionStorage)(logger, prevPageVisitDataKeyName);
                        }
                    }
                } catch (e) {
                    (0, $8z2Gd._warnToConsole)(logger, "Stop page visit timer failed: " + (0, $3I5zg.dumpObj)(e));
                    prevPageVisitData = null;
                }
                return prevPageVisitData;
            }
            // For backward compatibility
            (0, $erRAP.objDefineAccessors)(_self, "_logger", function() {
                return logger;
            });
            (0, $erRAP.objDefineAccessors)(_self, "pageVisitTimeTrackingHandler", function() {
                return pageVisitTimeTrackingHandler;
            });
        });
    }
    // Removed Stub for PageVisitTimeManager.prototype.trackPreviousPageVisit.
    // This is a workaround for an IE8 bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    // this will be removed when ES3 support is dropped.
    PageVisitTimeManager.__ieDyn = 1;
    return PageVisitTimeManager;
}();
var $d4375a883bb6ec03$export$513202441432a369 = /** @class */ function() {
    function PageVisitData(pageName, pageUrl) {
        this[0, $cPiEJ._DYN_PAGE_VISIT_START_TIM20 /* @min:%2epageVisitStartTime */ ] = (0, $erRAP.dateNow)();
        this.pageName = pageName;
        this.pageUrl = pageUrl;
    }
    return PageVisitData;
}();

});

parcelRegister("d5JsA", function(module, exports) {

$parcel$export(module.exports, "Timing", function () { return $987f016a137ae002$export$ef1e5872612852d1; });
/*
 * Application Insights JavaScript SDK - Web Analytics, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $4sUzw = parcelRequire("4sUzw");

var $8z2Gd = parcelRequire("8z2Gd");
/**
 * Used to record timed events and page views.
 */ var $987f016a137ae002$export$ef1e5872612852d1 = /** @class */ function() {
    function Timing(logger, name) {
        var _self = this;
        var _events = {};
        _self.start = function(name) {
            if (typeof _events[name] !== "undefined") (0, $8z2Gd._throwInternal)(logger, 2 /* eLoggingSeverity.WARNING */ , 62 /* _eInternalMessageId.StartCalledMoreThanOnce */ , "start was called more than once for this event without calling stop.", {
                name: name,
                key: name
            }, true);
            _events[name] = +new Date;
        };
        _self.stop = function(name, url, properties, measurements) {
            var start = _events[name];
            if (isNaN(start)) (0, $8z2Gd._throwInternal)(logger, 2 /* eLoggingSeverity.WARNING */ , 63 /* _eInternalMessageId.StopCalledWithoutStart */ , "stop was called without a corresponding start.", {
                name: name,
                key: name
            }, true);
            else {
                var end = +new Date;
                var duration = (0, $4sUzw.dateTimeUtilsDuration)(start, end);
                _self.action(name, url, duration, properties, measurements);
            }
            delete _events[name];
            _events[name] = undefined;
        };
    }
    return Timing;
}();

});


parcelRegister("dSEhk", function(module, exports) {

$parcel$export(module.exports, "Sender", function () { return $a1af8ff87da6e1d5$export$c5a96f3e01fb6582; });
/*
 * Application Insights JavaScript SDK - Channel, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $fcMe7 = parcelRequire("fcMe7");

var $kbmky = parcelRequire("kbmky");

var $1EHoQ = parcelRequire("1EHoQ");
var $dCW8D = parcelRequire("dCW8D");
var $fK8rK = parcelRequire("fK8rK");
var $3AuL8 = parcelRequire("3AuL8");
var $4sUzw = parcelRequire("4sUzw");
var $ihDSn = parcelRequire("ihDSn");
var $80I4P = parcelRequire("80I4P");
var $bmYDZ = parcelRequire("bmYDZ");
var $7fph4 = parcelRequire("7fph4");
var $f5lFa = parcelRequire("f5lFa");
var $lL63Q = parcelRequire("lL63Q");
var $fu0yT = parcelRequire("fu0yT");

var $8z2Gd = parcelRequire("8z2Gd");
var $erRAP = parcelRequire("erRAP");
var $3wvVb = parcelRequire("3wvVb");
var $2w0XY = parcelRequire("2w0XY");
var $3I5zg = parcelRequire("3I5zg");
var $cIC5n = parcelRequire("cIC5n");

var $eD5eQ = parcelRequire("eD5eQ");

var $7lPJP = parcelRequire("7lPJP");

var $aWy8a = parcelRequire("aWy8a");

var $5l8m1 = parcelRequire("5l8m1");

var $k9aAC = parcelRequire("k9aAC");

var $d7IsH = parcelRequire("d7IsH");
var $a1af8ff87da6e1d5$var$_a;
var $a1af8ff87da6e1d5$var$FetchSyncRequestSizeLimitBytes = 65000; // approx 64kb (the current Edge, Firefox and Chrome max limit)
function $a1af8ff87da6e1d5$var$_getResponseText(xhr) {
    try {
        return xhr.responseText;
    } catch (e) {
    // Best effort, as XHR may throw while XDR wont so just ignore
    }
    return null;
}
function $a1af8ff87da6e1d5$var$_getDefaultAppInsightsChannelConfig() {
    var _a;
    var defaultValue;
    var defaultCustomHeaders;
    // set default values
    return _a = {
        endpointUrl: function() {
            return (0, $dCW8D.DEFAULT_BREEZE_ENDPOINT) + (0, $dCW8D.DEFAULT_BREEZE_PATH);
        }
    }, _a[0, $d7IsH._DYN_EMIT_LINE_DELIMITED_0 /* @min:emitLineDelimitedJson */ ] = function() {
        return false;
    }, _a[0, $d7IsH._DYN_MAX_BATCH_INTERVAL /* @min:maxBatchInterval */ ] = function() {
        return 15000;
    }, _a[0, $d7IsH._DYN_MAX_BATCH_SIZE_IN_BY1 /* @min:maxBatchSizeInBytes */ ] = function() {
        return 102400;
    }, _a[0, $d7IsH._DYN_DISABLE_TELEMETRY /* @min:disableTelemetry */ ] = function() {
        return false;
    }, _a[0, $d7IsH._DYN_ENABLE_SESSION_STORA4 /* @min:enableSessionStorageBuffer */ ] = function() {
        return true;
    }, _a[0, $d7IsH._DYN_BUFFER_OVERRIDE /* @min:bufferOverride */ ] = function() {
        return false;
    }, _a[0, $d7IsH._DYN_IS_RETRY_DISABLED /* @min:isRetryDisabled */ ] = function() {
        return false;
    }, _a[0, $d7IsH._DYN_IS_BEACON_API_DISABL3 /* @min:isBeaconApiDisabled */ ] = function() {
        return true;
    }, _a[0, $d7IsH._DYN_DISABLE_XHR /* @min:disableXhr */ ] = function() {
        return false;
    }, _a[0, $d7IsH._DYN_ONUNLOAD_DISABLE_FET5 /* @min:onunloadDisableFetch */ ] = function() {
        return false;
    }, _a[0, $d7IsH._DYN_ONUNLOAD_DISABLE_BEA2 /* @min:onunloadDisableBeacon */ ] = function() {
        return false;
    }, _a[0, $d7IsH._DYN_INSTRUMENTATION_KEY /* @min:instrumentationKey */ ] = function() {
        return defaultValue;
    }, _a[0, $d7IsH._DYN_NAME_PREFIX /* @min:namePrefix */ ] = function() {
        return defaultValue;
    }, _a[0, $d7IsH._DYN_SAMPLING_PERCENTAGE /* @min:samplingPercentage */ ] = function() {
        return 100;
    }, _a[0, $d7IsH._DYN_CUSTOM_HEADERS /* @min:customHeaders */ ] = function() {
        return defaultCustomHeaders;
    }, _a[0, $d7IsH._DYN_CONVERT_UNDEFINED /* @min:convertUndefined */ ] = function() {
        return defaultValue;
    }, _a[0, $d7IsH._DYN_EVENTS_LIMIT_IN_MEM /* @min:eventsLimitInMem */ ] = function() {
        return 10000;
    }, _a.retryCodes = function() {
        return null;
    }, _a;
}
var $a1af8ff87da6e1d5$var$EnvelopeTypeCreator = ($a1af8ff87da6e1d5$var$_a = {}, $a1af8ff87da6e1d5$var$_a[(0, $fK8rK.Event).dataType] = (0, $eD5eQ.EventEnvelopeCreator), $a1af8ff87da6e1d5$var$_a[(0, $lL63Q.Trace).dataType] = (0, $eD5eQ.TraceEnvelopeCreator), $a1af8ff87da6e1d5$var$_a[(0, $80I4P.PageView).dataType] = (0, $eD5eQ.PageViewEnvelopeCreator), $a1af8ff87da6e1d5$var$_a[(0, $bmYDZ.PageViewPerformance).dataType] = (0, $eD5eQ.PageViewPerformanceEnvelopeCreator), $a1af8ff87da6e1d5$var$_a[(0, $3AuL8.Exception).dataType] = (0, $eD5eQ.ExceptionEnvelopeCreator), $a1af8ff87da6e1d5$var$_a[(0, $ihDSn.Metric).dataType] = (0, $eD5eQ.MetricEnvelopeCreator), $a1af8ff87da6e1d5$var$_a[(0, $7fph4.RemoteDependencyData).dataType] = (0, $eD5eQ.DependencyEnvelopeCreator), $a1af8ff87da6e1d5$var$_a);
var $a1af8ff87da6e1d5$export$c5a96f3e01fb6582 = /** @class */ function(_super) {
    (0, $fcMe7.__extendsFn)(Sender, _super);
    function Sender() {
        var _this = _super.call(this) || this;
        _this.priority = 1001;
        _this.identifier = (0, $1EHoQ.BreezeChannelIdentifier);
        /**
         * The configuration for this sender instance
         */ _this._senderConfig = $a1af8ff87da6e1d5$var$_getDefaultAppInsightsChannelConfig();
        // Don't set the defaults here, set them in the _initDefaults() as this is also called during unload
        var _consecutiveErrors; // How many times in a row a retryable error condition has occurred.
        var _retryAt; // The time to retry at in milliseconds from 1970/01/01 (this makes the timer calculation easy).
        var _lastSend; // The time of the last send operation.
        var _paused; // Flag indicating that the sending should be paused
        var _timeoutHandle; // Handle to the timer for delayed sending of batches of data.
        var _serializer;
        var _stamp_specific_redirects;
        var _headers;
        var _syncFetchPayload = 0; // Keep track of the outstanding sync fetch payload total (as sync fetch has limits)
        var _fallbackSender; // The sender to use if the payload size is too large
        var _syncUnloadSender; // The identified sender to use for the synchronous unload stage
        var _offlineListener;
        var _evtNamespace;
        var _retryCodes;
        (0, $kbmky.default)(Sender, _this, function(_self, _base) {
            _initDefaults();
            _self.pause = function() {
                _clearScheduledTimer();
                _paused = true;
            };
            _self.resume = function() {
                if (_paused) {
                    _paused = false;
                    _retryAt = null;
                    // flush if we have exceeded the max-size already
                    if (_self._buffer.size() > _self._senderConfig[0, $d7IsH._DYN_MAX_BATCH_SIZE_IN_BY1 /* @min:%2emaxBatchSizeInBytes */ ]()) _self[0, $d7IsH._DYN_TRIGGER_SEND /* @min:%2etriggerSend */ ](true, null, 10 /* SendRequestReason.MaxBatchSize */ );
                    _setupTimer();
                }
            };
            _self.flush = function(isAsync, callBack, sendReason) {
                if (isAsync === void 0) isAsync = true;
                if (!_paused) {
                    // Clear the normal schedule timer as we are going to try and flush ASAP
                    _clearScheduledTimer();
                    try {
                        _self[0, $d7IsH._DYN_TRIGGER_SEND /* @min:%2etriggerSend */ ](isAsync, null, sendReason || 1 /* SendRequestReason.ManualFlush */ );
                    } catch (e) {
                        (0, $8z2Gd._throwInternal)(_self[0, $d7IsH._DYN_DIAG_LOG /* @min:%2ediagLog */ ](), 1 /* eLoggingSeverity.CRITICAL */ , 22 /* _eInternalMessageId.FlushFailed */ , "flush failed, telemetry will not be collected: " + (0, $erRAP.getExceptionName)(e), {
                            exception: (0, $3I5zg.dumpObj)(e)
                        });
                    }
                }
            };
            _self.onunloadFlush = function() {
                if (!_paused) {
                    if ((_self._senderConfig[0, $d7IsH._DYN_ONUNLOAD_DISABLE_BEA2 /* @min:%2eonunloadDisableBeacon */ ]() === false || _self[0, $d7IsH._DYN__SENDER_CONFIG /* @min:%2e_senderConfig */ ][0, $d7IsH._DYN_IS_BEACON_API_DISABL3 /* @min:%2eisBeaconApiDisabled */ ]() === false) && (0, $3I5zg.isBeaconsSupported)()) try {
                        _self[0, $d7IsH._DYN_TRIGGER_SEND /* @min:%2etriggerSend */ ](true, _doUnloadSend, 2 /* SendRequestReason.Unload */ );
                    } catch (e) {
                        (0, $8z2Gd._throwInternal)(_self[0, $d7IsH._DYN_DIAG_LOG /* @min:%2ediagLog */ ](), 1 /* eLoggingSeverity.CRITICAL */ , 20 /* _eInternalMessageId.FailedToSendQueuedTelemetry */ , "failed to flush with beacon sender on page unload, telemetry will not be collected: " + (0, $erRAP.getExceptionName)(e), {
                            exception: (0, $3I5zg.dumpObj)(e)
                        });
                    }
                    else _self.flush();
                }
            };
            _self.addHeader = function(name, value) {
                _headers[name] = value;
            };
            _self.initialize = function(config, core, extensions, pluginChain) {
                if (_self.isInitialized()) (0, $8z2Gd._throwInternal)(_self[0, $d7IsH._DYN_DIAG_LOG /* @min:%2ediagLog */ ](), 1 /* eLoggingSeverity.CRITICAL */ , 28 /* _eInternalMessageId.SenderNotInitialized */ , "Sender is already initialized");
                _base.initialize(config, core, extensions, pluginChain);
                var ctx = _self._getTelCtx();
                var identifier = _self.identifier;
                _serializer = new (0, $5l8m1.Serializer)(core.logger);
                _consecutiveErrors = 0;
                _retryAt = null;
                _lastSend = 0;
                _self[0, $d7IsH._DYN__SENDER /* @min:%2e_sender */ ] = null;
                _stamp_specific_redirects = 0;
                var diagLog = _self[0, $d7IsH._DYN_DIAG_LOG /* @min:%2ediagLog */ ]();
                _evtNamespace = (0, $cIC5n.mergeEvtNamespace)((0, $2w0XY.createUniqueNamespace)("Sender"), core.evtNamespace && core.evtNamespace());
                _offlineListener = (0, $7lPJP.createOfflineListener)(_evtNamespace);
                // TODO v3.x: Change the ISenderConfig to not be function calls
                var defaultConfig = $a1af8ff87da6e1d5$var$_getDefaultAppInsightsChannelConfig();
                (0, $erRAP.objForEachKey)(defaultConfig, function(field, value) {
                    _self[0, $d7IsH._DYN__SENDER_CONFIG /* @min:%2e_senderConfig */ ][field] = function() {
                        var theValue = ctx.getConfig(identifier, field, value());
                        if (!theValue && field === "endpointUrl") // Use the default value (handles empty string in the configuration)
                        theValue = value();
                        return theValue;
                    };
                });
                _retryCodes = _self[0, $d7IsH._DYN__SENDER_CONFIG /* @min:%2e_senderConfig */ ].retryCodes();
                if (config.storagePrefix) (0, $fu0yT.utlSetStoragePrefix)(config.storagePrefix);
                var useSessionStorage = _self[0, $d7IsH._DYN__SENDER_CONFIG /* @min:%2e_senderConfig */ ][0, $d7IsH._DYN_ENABLE_SESSION_STORA4 /* @min:%2eenableSessionStorageBuffer */ ]() && !!(_self._senderConfig[0, $d7IsH._DYN_BUFFER_OVERRIDE /* @min:%2ebufferOverride */ ]() || (0, $fu0yT.utlCanUseSessionStorage)());
                _self[0, $d7IsH._DYN__BUFFER /* @min:%2e_buffer */ ] = useSessionStorage ? new (0, $aWy8a.SessionStorageSendBuffer)(diagLog, _self[0, $d7IsH._DYN__SENDER_CONFIG /* @min:%2e_senderConfig */ ]) : new (0, $aWy8a.ArraySendBuffer)(diagLog, _self[0, $d7IsH._DYN__SENDER_CONFIG /* @min:%2e_senderConfig */ ]);
                _self._sample = new (0, $k9aAC.Sample)(_self[0, $d7IsH._DYN__SENDER_CONFIG /* @min:%2e_senderConfig */ ][0, $d7IsH._DYN_SAMPLING_PERCENTAGE /* @min:%2esamplingPercentage */ ](), diagLog);
                if (!_validateInstrumentationKey(config)) (0, $8z2Gd._throwInternal)(diagLog, 1 /* eLoggingSeverity.CRITICAL */ , 100 /* _eInternalMessageId.InvalidInstrumentationKey */ , "Invalid Instrumentation key " + config[0, $d7IsH._DYN_INSTRUMENTATION_KEY /* @min:%2einstrumentationKey */ ]);
                if (!(0, $4sUzw.isInternalApplicationInsightsEndpoint)(_self._senderConfig.endpointUrl()) && _self._senderConfig.customHeaders() && _self._senderConfig.customHeaders()[0, $d7IsH._DYN_LENGTH /* @min:%2elength */ ] > 0) (0, $erRAP.arrForEach)(_self[0, $d7IsH._DYN__SENDER_CONFIG /* @min:%2e_senderConfig */ ][0, $d7IsH._DYN_CUSTOM_HEADERS /* @min:%2ecustomHeaders */ ](), function(customHeader) {
                    _this.addHeader(customHeader.header, customHeader.value);
                });
                var senderConfig = _self[0, $d7IsH._DYN__SENDER_CONFIG /* @min:%2e_senderConfig */ ];
                var sendPostFunc = null;
                if (!senderConfig[0, $d7IsH._DYN_DISABLE_XHR /* @min:%2edisableXhr */ ]() && (0, $3I5zg.useXDomainRequest)()) sendPostFunc = _xdrSender; // IE 8 and 9
                else if (!senderConfig[0, $d7IsH._DYN_DISABLE_XHR /* @min:%2edisableXhr */ ]() && (0, $3I5zg.isXhrSupported)()) sendPostFunc = _xhrSender;
                if (!sendPostFunc && (0, $3I5zg.isFetchSupported)()) sendPostFunc = _fetchSender;
                // always fallback to XHR
                _fallbackSender = sendPostFunc || _xhrSender;
                if (!senderConfig[0, $d7IsH._DYN_IS_BEACON_API_DISABL3 /* @min:%2eisBeaconApiDisabled */ ]() && (0, $3I5zg.isBeaconsSupported)()) // Config is set to always used beacon sending
                sendPostFunc = _beaconSender;
                _self[0, $d7IsH._DYN__SENDER /* @min:%2e_sender */ ] = sendPostFunc || _xhrSender;
                if (!senderConfig[0, $d7IsH._DYN_ONUNLOAD_DISABLE_FET5 /* @min:%2eonunloadDisableFetch */ ]() && (0, $3I5zg.isFetchSupported)(true)) // Try and use the fetch with keepalive
                _syncUnloadSender = _fetchKeepAliveSender;
                else if ((0, $3I5zg.isBeaconsSupported)()) // Try and use sendBeacon
                _syncUnloadSender = _beaconSender;
                else if (!senderConfig[0, $d7IsH._DYN_DISABLE_XHR /* @min:%2edisableXhr */ ]() && (0, $3I5zg.useXDomainRequest)()) _syncUnloadSender = _xdrSender; // IE 8 and 9
                else if (!senderConfig[0, $d7IsH._DYN_DISABLE_XHR /* @min:%2edisableXhr */ ]() && (0, $3I5zg.isXhrSupported)()) _syncUnloadSender = _xhrSender;
                else _syncUnloadSender = _fallbackSender;
            };
            _self.processTelemetry = function(telemetryItem, itemCtx) {
                itemCtx = _self._getTelCtx(itemCtx);
                var diagLogger = itemCtx[0, $d7IsH._DYN_DIAG_LOG /* @min:%2ediagLog */ ]();
                try {
                    // if master off switch is set, don't send any data
                    if (_self[0, $d7IsH._DYN__SENDER_CONFIG /* @min:%2e_senderConfig */ ][0, $d7IsH._DYN_DISABLE_TELEMETRY /* @min:%2edisableTelemetry */ ]()) // Do not send/save data
                    return;
                    // validate input
                    if (!telemetryItem) {
                        (0, $8z2Gd._throwInternal)(diagLogger, 1 /* eLoggingSeverity.CRITICAL */ , 7 /* _eInternalMessageId.CannotSendEmptyTelemetry */ , "Cannot send empty telemetry");
                        return;
                    }
                    // validate event
                    if (telemetryItem.baseData && !telemetryItem[0, $d7IsH._DYN_BASE_TYPE /* @min:%2ebaseType */ ]) {
                        (0, $8z2Gd._throwInternal)(diagLogger, 1 /* eLoggingSeverity.CRITICAL */ , 70 /* _eInternalMessageId.InvalidEvent */ , "Cannot send telemetry without baseData and baseType");
                        return;
                    }
                    if (!telemetryItem[0, $d7IsH._DYN_BASE_TYPE /* @min:%2ebaseType */ ]) // Default
                    telemetryItem[0, $d7IsH._DYN_BASE_TYPE /* @min:%2ebaseType */ ] = "EventData";
                    // ensure a sender was constructed
                    if (!_self[0, $d7IsH._DYN__SENDER /* @min:%2e_sender */ ]) {
                        (0, $8z2Gd._throwInternal)(diagLogger, 1 /* eLoggingSeverity.CRITICAL */ , 28 /* _eInternalMessageId.SenderNotInitialized */ , "Sender was not initialized");
                        return;
                    }
                    // check if this item should be sampled in, else add sampleRate tag
                    if (!_isSampledIn(telemetryItem)) {
                        // Item is sampled out, do not send it
                        (0, $8z2Gd._throwInternal)(diagLogger, 2 /* eLoggingSeverity.WARNING */ , 33 /* _eInternalMessageId.TelemetrySampledAndNotSent */ , "Telemetry item was sampled out and not sent", {
                            SampleRate: _self._sample[0, $d7IsH._DYN_SAMPLE_RATE /* @min:%2esampleRate */ ]
                        });
                        return;
                    } else telemetryItem[0, $dCW8D.SampleRate] = _self._sample[0, $d7IsH._DYN_SAMPLE_RATE /* @min:%2esampleRate */ ];
                    var convertUndefined = _self[0, $d7IsH._DYN__SENDER_CONFIG /* @min:%2e_senderConfig */ ][0, $d7IsH._DYN_CONVERT_UNDEFINED /* @min:%2econvertUndefined */ ]() || undefined;
                    // construct an envelope that Application Insights endpoint can understand
                    // if ikey of telemetry is provided and not empty, envelope will use this iKey instead of senderConfig iKey
                    var defaultEnvelopeIkey = telemetryItem.iKey || _self[0, $d7IsH._DYN__SENDER_CONFIG /* @min:%2e_senderConfig */ ][0, $d7IsH._DYN_INSTRUMENTATION_KEY /* @min:%2einstrumentationKey */ ]();
                    var aiEnvelope_1 = Sender.constructEnvelope(telemetryItem, defaultEnvelopeIkey, diagLogger, convertUndefined);
                    if (!aiEnvelope_1) {
                        (0, $8z2Gd._throwInternal)(diagLogger, 1 /* eLoggingSeverity.CRITICAL */ , 47 /* _eInternalMessageId.CreateEnvelopeError */ , "Unable to create an AppInsights envelope");
                        return;
                    }
                    var doNotSendItem_1 = false;
                    // this is for running in legacy mode, where customer may already have a custom initializer present
                    if (telemetryItem[0, $d7IsH._DYN_TAGS /* @min:%2etags */ ] && telemetryItem[0, $d7IsH._DYN_TAGS /* @min:%2etags */ ][0, $dCW8D.ProcessLegacy]) {
                        (0, $erRAP.arrForEach)(telemetryItem[0, $d7IsH._DYN_TAGS /* @min:%2etags */ ][0, $dCW8D.ProcessLegacy], function(callBack) {
                            try {
                                if (callBack && callBack(aiEnvelope_1) === false) {
                                    doNotSendItem_1 = true;
                                    (0, $8z2Gd._warnToConsole)(diagLogger, "Telemetry processor check returns false");
                                }
                            } catch (e) {
                                // log error but dont stop executing rest of the telemetry initializers
                                // doNotSendItem = true;
                                (0, $8z2Gd._throwInternal)(diagLogger, 1 /* eLoggingSeverity.CRITICAL */ , 64 /* _eInternalMessageId.TelemetryInitializerFailed */ , "One of telemetry initializers failed, telemetry item will not be sent: " + (0, $erRAP.getExceptionName)(e), {
                                    exception: (0, $3I5zg.dumpObj)(e)
                                }, true);
                            }
                        });
                        delete telemetryItem[0, $d7IsH._DYN_TAGS /* @min:%2etags */ ][0, $dCW8D.ProcessLegacy];
                    }
                    if (doNotSendItem_1) return; // do not send, no need to execute next plugin
                    // check if the incoming payload is too large, truncate if necessary
                    var payload = _serializer.serialize(aiEnvelope_1);
                    // flush if we would exceed the max-size limit by adding this item
                    var buffer = _self[0, $d7IsH._DYN__BUFFER /* @min:%2e_buffer */ ];
                    var bufferSize = buffer.size();
                    if (bufferSize + payload[0, $d7IsH._DYN_LENGTH /* @min:%2elength */ ] > _self[0, $d7IsH._DYN__SENDER_CONFIG /* @min:%2e_senderConfig */ ][0, $d7IsH._DYN_MAX_BATCH_SIZE_IN_BY1 /* @min:%2emaxBatchSizeInBytes */ ]()) {
                        if (!_offlineListener || _offlineListener[0, $d7IsH._DYN_IS_ONLINE /* @min:%2eisOnline */ ]()) _self[0, $d7IsH._DYN_TRIGGER_SEND /* @min:%2etriggerSend */ ](true, null, 10 /* SendRequestReason.MaxBatchSize */ );
                    }
                    // enqueue the payload
                    buffer[0, $d7IsH._DYN_ENQUEUE /* @min:%2eenqueue */ ](payload);
                    // ensure an invocation timeout is set
                    _setupTimer();
                } catch (e) {
                    (0, $8z2Gd._throwInternal)(diagLogger, 2 /* eLoggingSeverity.WARNING */ , 12 /* _eInternalMessageId.FailedAddingTelemetryToBuffer */ , "Failed adding telemetry to the sender's buffer, some telemetry will be lost: " + (0, $erRAP.getExceptionName)(e), {
                        exception: (0, $3I5zg.dumpObj)(e)
                    });
                }
                // hand off the telemetry item to the next plugin
                _self.processNext(telemetryItem, itemCtx);
            };
            /**
             * xhr state changes
             */ _self[0, $d7IsH._DYN__XHR_READY_STATE_CHA6 /* @min:%2e_xhrReadyStateChange */ ] = function(xhr, payload, countOfItemsInPayload) {
                if (xhr.readyState === 4) _checkResponsStatus(xhr.status, payload, xhr.responseURL, countOfItemsInPayload, _formatErrorMessageXhr(xhr), $a1af8ff87da6e1d5$var$_getResponseText(xhr) || xhr.response);
            };
            /**
             * Immediately send buffered data
             * @param async {boolean} - Indicates if the events should be sent asynchronously
             * @param forcedSender {SenderFunction} - Indicates the forcedSender, undefined if not passed
             */ _self[0, $d7IsH._DYN_TRIGGER_SEND /* @min:%2etriggerSend */ ] = function(async, forcedSender, sendReason) {
                if (async === void 0) async = true;
                if (!_paused) try {
                    var buffer = _self[0, $d7IsH._DYN__BUFFER /* @min:%2e_buffer */ ];
                    // Send data only if disableTelemetry is false
                    if (!_self[0, $d7IsH._DYN__SENDER_CONFIG /* @min:%2e_senderConfig */ ][0, $d7IsH._DYN_DISABLE_TELEMETRY /* @min:%2edisableTelemetry */ ]()) {
                        if (buffer[0, $d7IsH._DYN_COUNT /* @min:%2ecount */ ]() > 0) {
                            var payload = buffer.getItems();
                            _notifySendRequest(sendReason || 0 /* SendRequestReason.Undefined */ , async);
                            // invoke send
                            if (forcedSender) forcedSender.call(_self, payload, async);
                            else _self[0, $d7IsH._DYN__SENDER /* @min:%2e_sender */ ](payload, async);
                        }
                        // update lastSend time to enable throttling
                        _lastSend = +new Date;
                    } else buffer[0, $d7IsH._DYN_CLEAR /* @min:%2eclear */ ]();
                    _clearScheduledTimer();
                } catch (e) {
                    /* Ignore this error for IE under v10 */ var ieVer = (0, $3I5zg.getIEVersion)();
                    if (!ieVer || ieVer > 9) (0, $8z2Gd._throwInternal)(_self[0, $d7IsH._DYN_DIAG_LOG /* @min:%2ediagLog */ ](), 1 /* eLoggingSeverity.CRITICAL */ , 40 /* _eInternalMessageId.TransmissionFailed */ , "Telemetry transmission failed, some telemetry will be lost: " + (0, $erRAP.getExceptionName)(e), {
                        exception: (0, $3I5zg.dumpObj)(e)
                    });
                }
            };
            _self._doTeardown = function(unloadCtx, unloadState) {
                _self.onunloadFlush();
                _offlineListener.unload();
                _initDefaults();
            };
            /**
             * error handler
             */ _self[0, $d7IsH._DYN__ON_ERROR /* @min:%2e_onError */ ] = function(payload, message, event) {
                (0, $8z2Gd._throwInternal)(_self[0, $d7IsH._DYN_DIAG_LOG /* @min:%2ediagLog */ ](), 2 /* eLoggingSeverity.WARNING */ , 26 /* _eInternalMessageId.OnError */ , "Failed to send telemetry.", {
                    message: message
                });
                _self._buffer && _self._buffer[0, $d7IsH._DYN_CLEAR_SENT /* @min:%2eclearSent */ ](payload);
            };
            /**
             * partial success handler
             */ _self[0, $d7IsH._DYN__ON_PARTIAL_SUCCESS /* @min:%2e_onPartialSuccess */ ] = function(payload, results) {
                var failed = [];
                var retry = [];
                // Iterate through the reversed array of errors so that splicing doesn't have invalid indexes after the first item.
                var errors = results.errors.reverse();
                for(var _i = 0, errors_1 = errors; _i < errors_1.length; _i++){
                    var error = errors_1[_i];
                    var extracted = payload.splice(error.index, 1)[0];
                    if (_isRetriable(error.statusCode)) retry[0, $d7IsH._DYN_PUSH /* @min:%2epush */ ](extracted);
                    else // All other errors, including: 402 (Monthly quota exceeded) and 439 (Too many requests and refresh cache).
                    failed[0, $d7IsH._DYN_PUSH /* @min:%2epush */ ](extracted);
                }
                if (payload[0, $d7IsH._DYN_LENGTH /* @min:%2elength */ ] > 0) _self[0, $d7IsH._DYN__ON_SUCCESS /* @min:%2e_onSuccess */ ](payload, results[0, $d7IsH._DYN_ITEMS_ACCEPTED /* @min:%2eitemsAccepted */ ]);
                if (failed[0, $d7IsH._DYN_LENGTH /* @min:%2elength */ ] > 0) _self[0, $d7IsH._DYN__ON_ERROR /* @min:%2e_onError */ ](failed, _formatErrorMessageXhr(null, [
                    "partial success",
                    results[0, $d7IsH._DYN_ITEMS_ACCEPTED /* @min:%2eitemsAccepted */ ],
                    "of",
                    results.itemsReceived
                ].join(" ")));
                if (retry[0, $d7IsH._DYN_LENGTH /* @min:%2elength */ ] > 0) {
                    _resendPayload(retry);
                    (0, $8z2Gd._throwInternal)(_self[0, $d7IsH._DYN_DIAG_LOG /* @min:%2ediagLog */ ](), 2 /* eLoggingSeverity.WARNING */ , 40 /* _eInternalMessageId.TransmissionFailed */ , "Partial success. Delivered: " + payload[0, $d7IsH._DYN_LENGTH /* @min:%2elength */ ] + ", Failed: " + failed[0, $d7IsH._DYN_LENGTH /* @min:%2elength */ ] + ". Will retry to send " + retry[0, $d7IsH._DYN_LENGTH /* @min:%2elength */ ] + " our of " + results[0, $d7IsH._DYN_ITEMS_RECEIVED /* @min:%2eitemsReceived */ ] + " items");
                }
            };
            /**
             * success handler
             */ _self[0, $d7IsH._DYN__ON_SUCCESS /* @min:%2e_onSuccess */ ] = function(payload, countOfItemsInPayload) {
                _self._buffer && _self._buffer[0, $d7IsH._DYN_CLEAR_SENT /* @min:%2eclearSent */ ](payload);
            };
            /**
             * xdr state changes
             */ _self._xdrOnLoad = function(xdr, payload) {
                var responseText = $a1af8ff87da6e1d5$var$_getResponseText(xdr);
                if (xdr && (responseText + "" === "200" || responseText === "")) {
                    _consecutiveErrors = 0;
                    _self[0, $d7IsH._DYN__ON_SUCCESS /* @min:%2e_onSuccess */ ](payload, 0);
                } else {
                    var results = _parseResponse(responseText);
                    if (results && results.itemsReceived && results.itemsReceived > results[0, $d7IsH._DYN_ITEMS_ACCEPTED /* @min:%2eitemsAccepted */ ] && !_self[0, $d7IsH._DYN__SENDER_CONFIG /* @min:%2e_senderConfig */ ][0, $d7IsH._DYN_IS_RETRY_DISABLED /* @min:%2eisRetryDisabled */ ]()) _self[0, $d7IsH._DYN__ON_PARTIAL_SUCCESS /* @min:%2e_onPartialSuccess */ ](payload, results);
                    else _self[0, $d7IsH._DYN__ON_ERROR /* @min:%2e_onError */ ](payload, _formatErrorMessageXdr(xdr));
                }
            };
            function _isSampledIn(envelope) {
                return _self._sample.isSampledIn(envelope);
            }
            function _checkResponsStatus(status, payload, responseUrl, countOfItemsInPayload, errorMessage, res) {
                var response = null;
                if (!_self._appId) {
                    response = _parseResponse(res);
                    if (response && response.appId) _self._appId = response.appId;
                }
                if ((status < 200 || status >= 300) && status !== 0) {
                    // Update End Point url if permanent redirect or moved permanently
                    // Updates the end point url before retry
                    if (status === 301 || status === 307 || status === 308) {
                        if (!_checkAndUpdateEndPointUrl(responseUrl)) {
                            _self[0, $d7IsH._DYN__ON_ERROR /* @min:%2e_onError */ ](payload, errorMessage);
                            return;
                        }
                    }
                    if (!_self[0, $d7IsH._DYN__SENDER_CONFIG /* @min:%2e_senderConfig */ ][0, $d7IsH._DYN_IS_RETRY_DISABLED /* @min:%2eisRetryDisabled */ ]() && _isRetriable(status)) {
                        _resendPayload(payload);
                        (0, $8z2Gd._throwInternal)(_self[0, $d7IsH._DYN_DIAG_LOG /* @min:%2ediagLog */ ](), 2 /* eLoggingSeverity.WARNING */ , 40 /* _eInternalMessageId.TransmissionFailed */ , ". Response code " + status + ". Will retry to send " + payload[0, $d7IsH._DYN_LENGTH /* @min:%2elength */ ] + " items.");
                    } else _self[0, $d7IsH._DYN__ON_ERROR /* @min:%2e_onError */ ](payload, errorMessage);
                } else if (_offlineListener && !_offlineListener[0, $d7IsH._DYN_IS_ONLINE /* @min:%2eisOnline */ ]()) // Note: Don't check for status == 0, since adblock gives this code
                {
                    if (!_self[0, $d7IsH._DYN__SENDER_CONFIG /* @min:%2e_senderConfig */ ][0, $d7IsH._DYN_IS_RETRY_DISABLED /* @min:%2eisRetryDisabled */ ]()) {
                        var offlineBackOffMultiplier = 10; // arbritrary number
                        _resendPayload(payload, offlineBackOffMultiplier);
                        (0, $8z2Gd._throwInternal)(_self[0, $d7IsH._DYN_DIAG_LOG /* @min:%2ediagLog */ ](), 2 /* eLoggingSeverity.WARNING */ , 40 /* _eInternalMessageId.TransmissionFailed */ , ". Offline - Response Code: ".concat(status, ". Offline status: ").concat(!_offlineListener.isOnline(), ". Will retry to send ").concat(payload.length, " items."));
                    }
                } else {
                    // check if the xhr's responseURL or fetch's response.url is same as endpoint url
                    // TODO after 10 redirects force send telemetry with 'redirect=false' as query parameter.
                    _checkAndUpdateEndPointUrl(responseUrl);
                    if (status === 206) {
                        if (!response) response = _parseResponse(res);
                        if (response && !_self[0, $d7IsH._DYN__SENDER_CONFIG /* @min:%2e_senderConfig */ ][0, $d7IsH._DYN_IS_RETRY_DISABLED /* @min:%2eisRetryDisabled */ ]()) _self[0, $d7IsH._DYN__ON_PARTIAL_SUCCESS /* @min:%2e_onPartialSuccess */ ](payload, response);
                        else _self[0, $d7IsH._DYN__ON_ERROR /* @min:%2e_onError */ ](payload, errorMessage);
                    } else {
                        _consecutiveErrors = 0;
                        _self[0, $d7IsH._DYN__ON_SUCCESS /* @min:%2e_onSuccess */ ](payload, countOfItemsInPayload);
                    }
                }
            }
            function _checkAndUpdateEndPointUrl(responseUrl) {
                // Maximum stamp specific redirects allowed(uncomment this when breeze is ready with not allowing redirects feature)
                if (_stamp_specific_redirects >= 10) //  _self._senderConfig.endpointUrl = () => Sender._getDefaultAppInsightsChannelConfig().endpointUrl()+"/?redirect=false";
                //  _stamp_specific_redirects = 0;
                return false;
                if (!(0, $erRAP.isNullOrUndefined)(responseUrl) && responseUrl !== "") {
                    if (responseUrl !== _self[0, $d7IsH._DYN__SENDER_CONFIG /* @min:%2e_senderConfig */ ][0, $d7IsH._DYN_ENDPOINT_URL /* @min:%2eendpointUrl */ ]()) {
                        _self[0, $d7IsH._DYN__SENDER_CONFIG /* @min:%2e_senderConfig */ ][0, $d7IsH._DYN_ENDPOINT_URL /* @min:%2eendpointUrl */ ] = function() {
                            return responseUrl;
                        };
                        ++_stamp_specific_redirects;
                        return true;
                    }
                }
                return false;
            }
            function _doUnloadSend(payload, isAsync) {
                if (_syncUnloadSender) // We are unloading so always call the sender with sync set to false
                _syncUnloadSender(payload, false);
                else // Fallback to the previous beacon Sender (which causes a CORB warning on chrome now)
                _beaconSender(payload, isAsync);
            }
            function _doBeaconSend(payload) {
                var nav = (0, $3I5zg.getNavigator)();
                var buffer = _self[0, $d7IsH._DYN__BUFFER /* @min:%2e_buffer */ ];
                var url = _self[0, $d7IsH._DYN__SENDER_CONFIG /* @min:%2e_senderConfig */ ][0, $d7IsH._DYN_ENDPOINT_URL /* @min:%2eendpointUrl */ ]();
                var batch = _self._buffer[0, $d7IsH._DYN_BATCH_PAYLOADS /* @min:%2ebatchPayloads */ ](payload);
                // Chrome only allows CORS-safelisted values for the sendBeacon data argument
                // see: https://bugs.chromium.org/p/chromium/issues/detail?id=720283
                var plainTextBatch = new Blob([
                    batch
                ], {
                    type: "text/plain;charset=UTF-8"
                });
                // The sendBeacon method returns true if the user agent is able to successfully queue the data for transfer. Otherwise it returns false.
                var queued = nav.sendBeacon(url, plainTextBatch);
                if (queued) {
                    buffer[0, $d7IsH._DYN_MARK_AS_SENT /* @min:%2emarkAsSent */ ](payload);
                    // no response from beaconSender, clear buffer
                    _self._onSuccess(payload, payload[0, $d7IsH._DYN_LENGTH /* @min:%2elength */ ]);
                }
                return queued;
            }
            /**
             * Send Beacon API request
             * @param payload {string} - The data payload to be sent.
             * @param isAsync {boolean} - not used
             * Note: Beacon API does not support custom headers and we are not able to get
             * appId from the backend for the correct correlation.
             */ function _beaconSender(payload, isAsync) {
                if ((0, $erRAP.isArray)(payload) && payload[0, $d7IsH._DYN_LENGTH /* @min:%2elength */ ] > 0) // The sendBeacon method returns true if the user agent is able to successfully queue the data for transfer. Otherwise it returns false.
                {
                    if (!_doBeaconSend(payload)) {
                        // Failed to send entire payload so try and split data and try to send as much events as possible
                        var droppedPayload = [];
                        for(var lp = 0; lp < payload[0, $d7IsH._DYN_LENGTH /* @min:%2elength */ ]; lp++){
                            var thePayload = payload[lp];
                            if (!_doBeaconSend([
                                thePayload
                            ])) // Can't send anymore, so split the batch and drop the rest
                            droppedPayload[0, $d7IsH._DYN_PUSH /* @min:%2epush */ ](thePayload);
                        }
                        if (droppedPayload[0, $d7IsH._DYN_LENGTH /* @min:%2elength */ ] > 0) {
                            _fallbackSender && _fallbackSender(droppedPayload, true);
                            (0, $8z2Gd._throwInternal)(_self[0, $d7IsH._DYN_DIAG_LOG /* @min:%2ediagLog */ ](), 2 /* eLoggingSeverity.WARNING */ , 40 /* _eInternalMessageId.TransmissionFailed */ , ". Failed to send telemetry with Beacon API, retried with normal sender.");
                        }
                    }
                }
            }
            /**
             * Send XMLHttpRequest
             * @param payload {string} - The data payload to be sent.
             * @param isAsync {boolean} - Indicates if the request should be sent asynchronously
             */ function _xhrSender(payload, isAsync) {
                var xhr = new XMLHttpRequest();
                var endPointUrl = _self[0, $d7IsH._DYN__SENDER_CONFIG /* @min:%2e_senderConfig */ ][0, $d7IsH._DYN_ENDPOINT_URL /* @min:%2eendpointUrl */ ]();
                try {
                    xhr[0, $dCW8D.DisabledPropertyName] = true;
                } catch (e) {
                // If the environment has locked down the XMLHttpRequest (preventExtensions and/or freeze), this would
                // cause the request to fail and we no telemetry would be sent
                }
                xhr.open("POST", endPointUrl, isAsync);
                xhr[0, $d7IsH._DYN_SET_REQUEST_HEADER /* @min:%2esetRequestHeader */ ]("Content-type", "application/json");
                // append Sdk-Context request header only in case of breeze endpoint
                if ((0, $4sUzw.isInternalApplicationInsightsEndpoint)(endPointUrl)) xhr[0, $d7IsH._DYN_SET_REQUEST_HEADER /* @min:%2esetRequestHeader */ ]((0, $f5lFa.RequestHeaders)[6 /* eRequestHeaders.sdkContextHeader */ ], (0, $f5lFa.RequestHeaders)[7 /* eRequestHeaders.sdkContextHeaderAppIdRequest */ ]);
                (0, $erRAP.arrForEach)((0, $erRAP.objKeys)(_headers), function(headerName) {
                    xhr[0, $d7IsH._DYN_SET_REQUEST_HEADER /* @min:%2esetRequestHeader */ ](headerName, _headers[headerName]);
                });
                xhr.onreadystatechange = function() {
                    return _self._xhrReadyStateChange(xhr, payload, payload[0, $d7IsH._DYN_LENGTH /* @min:%2elength */ ]);
                };
                xhr.onerror = function(event) {
                    return _self[0, $d7IsH._DYN__ON_ERROR /* @min:%2e_onError */ ](payload, _formatErrorMessageXhr(xhr), event);
                };
                // compose an array of payloads
                var batch = _self._buffer[0, $d7IsH._DYN_BATCH_PAYLOADS /* @min:%2ebatchPayloads */ ](payload);
                xhr.send(batch);
                _self._buffer[0, $d7IsH._DYN_MARK_AS_SENT /* @min:%2emarkAsSent */ ](payload);
            }
            function _fetchKeepAliveSender(payload, isAsync) {
                if ((0, $erRAP.isArray)(payload)) {
                    var payloadSize = payload[0, $d7IsH._DYN_LENGTH /* @min:%2elength */ ];
                    for(var lp = 0; lp < payload[0, $d7IsH._DYN_LENGTH /* @min:%2elength */ ]; lp++)payloadSize += payload[lp][0, $d7IsH._DYN_LENGTH /* @min:%2elength */ ];
                    if (_syncFetchPayload + payloadSize <= $a1af8ff87da6e1d5$var$FetchSyncRequestSizeLimitBytes) _doFetchSender(payload, false);
                    else if ((0, $3I5zg.isBeaconsSupported)()) // Fallback to beacon sender as we at least get told which events can't be scheduled
                    _beaconSender(payload, isAsync);
                    else {
                        // Payload is going to be too big so just try and send via XHR
                        _fallbackSender && _fallbackSender(payload, true);
                        (0, $8z2Gd._throwInternal)(_self[0, $d7IsH._DYN_DIAG_LOG /* @min:%2ediagLog */ ](), 2 /* eLoggingSeverity.WARNING */ , 40 /* _eInternalMessageId.TransmissionFailed */ , ". Failed to send telemetry with Beacon API, retried with xhrSender.");
                    }
                }
            }
            /**
             * Send fetch API request
             * @param payload {string} - The data payload to be sent.
             * @param isAsync {boolean} - not used
             */ function _fetchSender(payload, isAsync) {
                _doFetchSender(payload, true);
            }
            /**
             * Send fetch API request
             * @param payload {string} - The data payload to be sent.
             * @param isAsync {boolean} - For fetch this identifies whether we are "unloading" (false) or a normal request
             */ function _doFetchSender(payload, isAsync) {
                var _a;
                var endPointUrl = _self[0, $d7IsH._DYN__SENDER_CONFIG /* @min:%2e_senderConfig */ ][0, $d7IsH._DYN_ENDPOINT_URL /* @min:%2eendpointUrl */ ]();
                var batch = _self._buffer[0, $d7IsH._DYN_BATCH_PAYLOADS /* @min:%2ebatchPayloads */ ](payload);
                var plainTextBatch = new Blob([
                    batch
                ], {
                    type: "application/json"
                });
                var requestHeaders = new Headers();
                var batchLength = batch[0, $d7IsH._DYN_LENGTH /* @min:%2elength */ ];
                var ignoreResponse = false;
                var responseHandled = false;
                // append Sdk-Context request header only in case of breeze endpoint
                if ((0, $4sUzw.isInternalApplicationInsightsEndpoint)(endPointUrl)) requestHeaders.append((0, $f5lFa.RequestHeaders)[6 /* eRequestHeaders.sdkContextHeader */ ], (0, $f5lFa.RequestHeaders)[7 /* eRequestHeaders.sdkContextHeaderAppIdRequest */ ]);
                (0, $erRAP.arrForEach)((0, $erRAP.objKeys)(_headers), function(headerName) {
                    requestHeaders.append(headerName, _headers[headerName]);
                });
                var init = (_a = {
                    method: "POST",
                    headers: requestHeaders,
                    body: plainTextBatch
                }, _a[0, $dCW8D.DisabledPropertyName] = true // Mark so we don't attempt to track this request
                , _a);
                if (!isAsync) {
                    init.keepalive = true;
                    // As a sync request (during unload), it is unlikely that we will get a chance to process the response so
                    // just like beacon send assume that the events have been accepted and processed
                    ignoreResponse = true;
                    _syncFetchPayload += batchLength;
                }
                var request = new Request(endPointUrl, init);
                try {
                    // Also try and tag the request (just in case the value in init is not copied over)
                    request[0, $dCW8D.DisabledPropertyName] = true;
                } catch (e) {
                // If the environment has locked down the XMLHttpRequest (preventExtensions and/or freeze), this would
                // cause the request to fail and we no telemetry would be sent
                }
                _self._buffer[0, $d7IsH._DYN_MARK_AS_SENT /* @min:%2emarkAsSent */ ](payload);
                try {
                    fetch(request).then(function(response) {
                        if (!isAsync) {
                            _syncFetchPayload -= batchLength;
                            batchLength = 0;
                        }
                        if (!responseHandled) {
                            responseHandled = true;
                            /**
                             * The Promise returned from fetch() won’t reject on HTTP error status even if the response is an HTTP 404 or 500.
                             * Instead, it will resolve normally (with ok status set to false), and it will only reject on network failure
                             * or if anything prevented the request from completing.
                             */ if (!response.ok) _self[0, $d7IsH._DYN__ON_ERROR /* @min:%2e_onError */ ](payload, response.statusText);
                            else response.text().then(function(text) {
                                _checkResponsStatus(response.status, payload, response.url, payload[0, $d7IsH._DYN_LENGTH /* @min:%2elength */ ], response.statusText, text);
                            });
                        }
                    })["catch"](function(error) {
                        if (!isAsync) {
                            _syncFetchPayload -= batchLength;
                            batchLength = 0;
                        }
                        if (!responseHandled) {
                            responseHandled = true;
                            _self[0, $d7IsH._DYN__ON_ERROR /* @min:%2e_onError */ ](payload, error.message);
                        }
                    });
                } catch (e) {
                    if (!responseHandled) _self[0, $d7IsH._DYN__ON_ERROR /* @min:%2e_onError */ ](payload, (0, $3I5zg.dumpObj)(e));
                }
                if (ignoreResponse && !responseHandled) {
                    // Assume success during unload processing as we most likely won't get the response
                    responseHandled = true;
                    _self._onSuccess(payload, payload[0, $d7IsH._DYN_LENGTH /* @min:%2elength */ ]);
                }
            }
            /**
             * Parses the response from the backend.
             * @param response - XMLHttpRequest or XDomainRequest response
             */ function _parseResponse(response) {
                try {
                    if (response && response !== "") {
                        var result = (0, $3I5zg.getJSON)().parse(response);
                        if (result && result.itemsReceived && result.itemsReceived >= result[0, $d7IsH._DYN_ITEMS_ACCEPTED /* @min:%2eitemsAccepted */ ] && result.itemsReceived - result.itemsAccepted === result.errors[0, $d7IsH._DYN_LENGTH /* @min:%2elength */ ]) return result;
                    }
                } catch (e) {
                    (0, $8z2Gd._throwInternal)(_self[0, $d7IsH._DYN_DIAG_LOG /* @min:%2ediagLog */ ](), 1 /* eLoggingSeverity.CRITICAL */ , 43 /* _eInternalMessageId.InvalidBackendResponse */ , "Cannot parse the response. " + (0, $erRAP.getExceptionName)(e), {
                        response: response
                    });
                }
                return null;
            }
            /**
             * Resend payload. Adds payload back to the send buffer and setup a send timer (with exponential backoff).
             * @param payload
             */ function _resendPayload(payload, linearFactor) {
                if (linearFactor === void 0) linearFactor = 1;
                if (!payload || payload[0, $d7IsH._DYN_LENGTH /* @min:%2elength */ ] === 0) return;
                var buffer = _self[0, $d7IsH._DYN__BUFFER /* @min:%2e_buffer */ ];
                buffer[0, $d7IsH._DYN_CLEAR_SENT /* @min:%2eclearSent */ ](payload);
                _consecutiveErrors++;
                for(var _i = 0, payload_1 = payload; _i < payload_1.length; _i++){
                    var item = payload_1[_i];
                    buffer[0, $d7IsH._DYN_ENQUEUE /* @min:%2eenqueue */ ](item);
                }
                // setup timer
                _setRetryTime(linearFactor);
                _setupTimer();
            }
            /**
             * Calculates the time to wait before retrying in case of an error based on
             * http://en.wikipedia.org/wiki/Exponential_backoff
             */ function _setRetryTime(linearFactor) {
                var SlotDelayInSeconds = 10;
                var delayInSeconds;
                if (_consecutiveErrors <= 1) delayInSeconds = SlotDelayInSeconds;
                else {
                    var backOffSlot = (Math.pow(2, _consecutiveErrors) - 1) / 2;
                    // tslint:disable-next-line:insecure-random
                    var backOffDelay = Math.floor(Math.random() * backOffSlot * SlotDelayInSeconds) + 1;
                    backOffDelay = linearFactor * backOffDelay;
                    delayInSeconds = Math.max(Math.min(backOffDelay, 3600), SlotDelayInSeconds);
                }
                // TODO: Log the backoff time like the C# version does.
                var retryAfterTimeSpan = (0, $erRAP.dateNow)() + delayInSeconds * 1000;
                // TODO: Log the retry at time like the C# version does.
                _retryAt = retryAfterTimeSpan;
            }
            /**
             * Sets up the timer which triggers actually sending the data.
             */ function _setupTimer() {
                if (!_timeoutHandle && !_paused) {
                    var retryInterval = _retryAt ? Math.max(0, _retryAt - (0, $erRAP.dateNow)()) : 0;
                    var timerValue = Math.max(_self[0, $d7IsH._DYN__SENDER_CONFIG /* @min:%2e_senderConfig */ ][0, $d7IsH._DYN_MAX_BATCH_INTERVAL /* @min:%2emaxBatchInterval */ ](), retryInterval);
                    _timeoutHandle = setTimeout(function() {
                        _timeoutHandle = null;
                        _self[0, $d7IsH._DYN_TRIGGER_SEND /* @min:%2etriggerSend */ ](true, null, 1 /* SendRequestReason.NormalSchedule */ );
                    }, timerValue);
                }
            }
            function _clearScheduledTimer() {
                clearTimeout(_timeoutHandle);
                _timeoutHandle = null;
                _retryAt = null;
            }
            /**
             * Checks if the SDK should resend the payload after receiving this status code from the backend.
             * @param statusCode
             */ function _isRetriable(statusCode) {
                // retryCodes = [] means should not retry
                if (!(0, $erRAP.isNullOrUndefined)(_retryCodes)) return _retryCodes[0, $d7IsH._DYN_LENGTH /* @min:%2elength */ ] && (0, $erRAP.arrIndexOf)(_retryCodes, statusCode) > -1;
                return statusCode === 401 // Unauthorized
                 || statusCode === 408 // Timeout
                 || statusCode === 429 // Too many requests.
                 || statusCode === 500 // Internal server error.
                 || statusCode === 502 // Bad Gateway.
                 || statusCode === 503 // Service unavailable.
                 || statusCode === 504; // Gateway timeout.
            }
            function _formatErrorMessageXhr(xhr, message) {
                if (xhr) return "XMLHttpRequest,Status:" + xhr.status + ",Response:" + $a1af8ff87da6e1d5$var$_getResponseText(xhr) || xhr.response || "";
                return message;
            }
            /**
             * Send XDomainRequest
             * @param payload {string} - The data payload to be sent.
             * @param isAsync {boolean} - Indicates if the request should be sent asynchronously
             *
             * Note: XDomainRequest does not support sync requests. This 'isAsync' parameter is added
             * to maintain consistency with the xhrSender's contract
             * Note: XDomainRequest does not support custom headers and we are not able to get
             * appId from the backend for the correct correlation.
             */ function _xdrSender(payload, isAsync) {
                var buffer = _self[0, $d7IsH._DYN__BUFFER /* @min:%2e_buffer */ ];
                var _window = (0, $3I5zg.getWindow)();
                var xdr = new XDomainRequest();
                xdr.onload = function() {
                    return _self._xdrOnLoad(xdr, payload);
                };
                xdr.onerror = function(event) {
                    return _self[0, $d7IsH._DYN__ON_ERROR /* @min:%2e_onError */ ](payload, _formatErrorMessageXdr(xdr), event);
                };
                // XDomainRequest requires the same protocol as the hosting page.
                // If the protocol doesn't match, we can't send the telemetry :(.
                var hostingProtocol = _window && _window.location && _window.location.protocol || "";
                if (_self[0, $d7IsH._DYN__SENDER_CONFIG /* @min:%2e_senderConfig */ ][0, $d7IsH._DYN_ENDPOINT_URL /* @min:%2eendpointUrl */ ]().lastIndexOf(hostingProtocol, 0) !== 0) {
                    (0, $8z2Gd._throwInternal)(_self[0, $d7IsH._DYN_DIAG_LOG /* @min:%2ediagLog */ ](), 2 /* eLoggingSeverity.WARNING */ , 40 /* _eInternalMessageId.TransmissionFailed */ , ". Cannot send XDomain request. The endpoint URL protocol doesn't match the hosting page protocol.");
                    buffer[0, $d7IsH._DYN_CLEAR /* @min:%2eclear */ ]();
                    return;
                }
                var endpointUrl = _self[0, $d7IsH._DYN__SENDER_CONFIG /* @min:%2e_senderConfig */ ][0, $d7IsH._DYN_ENDPOINT_URL /* @min:%2eendpointUrl */ ]().replace(/^(https?:)/, "");
                xdr.open("POST", endpointUrl);
                // compose an array of payloads
                var batch = buffer[0, $d7IsH._DYN_BATCH_PAYLOADS /* @min:%2ebatchPayloads */ ](payload);
                xdr.send(batch);
                buffer[0, $d7IsH._DYN_MARK_AS_SENT /* @min:%2emarkAsSent */ ](payload);
            }
            function _formatErrorMessageXdr(xdr, message) {
                if (xdr) return "XDomainRequest,Response:" + $a1af8ff87da6e1d5$var$_getResponseText(xdr);
                return message;
            }
            // Using function lookups for backward compatibility as the getNotifyMgr() did not exist until after v2.5.6
            function _getNotifyMgr() {
                var func = "getNotifyMgr";
                if (_self.core[func]) return _self.core[func]();
                // using _self.core['_notificationManager'] for backward compatibility
                return _self.core["_notificationManager"];
            }
            function _notifySendRequest(sendRequest, isAsync) {
                var manager = _getNotifyMgr();
                if (manager && manager[0, $d7IsH._DYN_EVENTS_SEND_REQUEST /* @min:%2eeventsSendRequest */ ]) try {
                    manager[0, $d7IsH._DYN_EVENTS_SEND_REQUEST /* @min:%2eeventsSendRequest */ ](sendRequest, isAsync);
                } catch (e) {
                    (0, $8z2Gd._throwInternal)(_self[0, $d7IsH._DYN_DIAG_LOG /* @min:%2ediagLog */ ](), 1 /* eLoggingSeverity.CRITICAL */ , 74 /* _eInternalMessageId.NotificationException */ , "send request notification failed: " + (0, $erRAP.getExceptionName)(e), {
                        exception: (0, $3I5zg.dumpObj)(e)
                    });
                }
            }
            /**
             * Validate UUID Format
             * Specs taken from https://tools.ietf.org/html/rfc4122 and breeze repo
             */ function _validateInstrumentationKey(config) {
                var disableIKeyValidationFlag = (0, $erRAP.isNullOrUndefined)(config[0, $d7IsH._DYN_DISABLE_INSTRUMENTAT7 /* @min:%2edisableInstrumentationKeyValidation */ ]) ? false : config[0, $d7IsH._DYN_DISABLE_INSTRUMENTAT7 /* @min:%2edisableInstrumentationKeyValidation */ ];
                if (disableIKeyValidationFlag) return true;
                var UUID_Regex = "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$";
                var regexp = new RegExp(UUID_Regex);
                return regexp.test(config[0, $d7IsH._DYN_INSTRUMENTATION_KEY /* @min:%2einstrumentationKey */ ]);
            }
            function _initDefaults() {
                _self[0, $d7IsH._DYN__SENDER /* @min:%2e_sender */ ] = null;
                _self[0, $d7IsH._DYN__BUFFER /* @min:%2e_buffer */ ] = null;
                _self._appId = null;
                _self._sample = null;
                _headers = {};
                _offlineListener = null;
                _consecutiveErrors = 0;
                _retryAt = null;
                _lastSend = null;
                _paused = false;
                _timeoutHandle = null;
                _serializer = null;
                _stamp_specific_redirects = 0;
                _syncFetchPayload = 0;
                _fallbackSender = null;
                _syncUnloadSender = null;
                _evtNamespace = null;
            }
        });
        return _this;
    }
    Sender.constructEnvelope = function(orig, iKey, logger, convertUndefined) {
        var envelope;
        if (iKey !== orig.iKey && !(0, $erRAP.isNullOrUndefined)(iKey)) envelope = (0, $fcMe7.__assignFn)((0, $fcMe7.__assignFn)({}, orig), {
            iKey: iKey
        });
        else envelope = orig;
        var creator = $a1af8ff87da6e1d5$var$EnvelopeTypeCreator[envelope.baseType] || (0, $eD5eQ.EventEnvelopeCreator);
        return creator(logger, envelope, convertUndefined);
    };
    // Removed Stub for Sender.prototype.pause.
    // Removed Stub for Sender.prototype.resume.
    // Removed Stub for Sender.prototype.flush.
    // Removed Stub for Sender.prototype.onunloadFlush.
    // Removed Stub for Sender.prototype.initialize.
    // Removed Stub for Sender.prototype.processTelemetry.
    // Removed Stub for Sender.prototype._xhrReadyStateChange.
    // Removed Stub for Sender.prototype.triggerSend.
    // Removed Stub for Sender.prototype._onError.
    // Removed Stub for Sender.prototype._onPartialSuccess.
    // Removed Stub for Sender.prototype._onSuccess.
    // Removed Stub for Sender.prototype._xdrOnLoad.
    // Removed Stub for Sender.prototype.addHeader.
    return Sender;
}((0, $3wvVb.BaseTelemetryPlugin));

});
parcelRegister("eD5eQ", function(module, exports) {

$parcel$export(module.exports, "DependencyEnvelopeCreator", function () { return $aa68c56f5088d49c$export$74e603a08a7deabe; });
$parcel$export(module.exports, "EventEnvelopeCreator", function () { return $aa68c56f5088d49c$export$b74153364c2066d1; });
$parcel$export(module.exports, "ExceptionEnvelopeCreator", function () { return $aa68c56f5088d49c$export$eca78b65eeb356ed; });
$parcel$export(module.exports, "MetricEnvelopeCreator", function () { return $aa68c56f5088d49c$export$bb5bee4039a2e495; });
$parcel$export(module.exports, "PageViewEnvelopeCreator", function () { return $aa68c56f5088d49c$export$edbb8a2c6529947a; });
$parcel$export(module.exports, "PageViewPerformanceEnvelopeCreator", function () { return $aa68c56f5088d49c$export$bb801863268e7049; });
$parcel$export(module.exports, "TraceEnvelopeCreator", function () { return $aa68c56f5088d49c$export$bc9e843f2eb8a61c; });
/*
 * Application Insights JavaScript SDK - Channel, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $fcMe7 = parcelRequire("fcMe7");

var $2gDxc = parcelRequire("2gDxc");
var $coTnQ = parcelRequire("coTnQ");
var $cGFCT = parcelRequire("cGFCT");
var $1V1Zd = parcelRequire("1V1Zd");
var $fK8rK = parcelRequire("fK8rK");
var $3AuL8 = parcelRequire("3AuL8");
var $dCW8D = parcelRequire("dCW8D");
var $ihDSn = parcelRequire("ihDSn");
var $80I4P = parcelRequire("80I4P");
var $bmYDZ = parcelRequire("bmYDZ");
var $7fph4 = parcelRequire("7fph4");
var $lL63Q = parcelRequire("lL63Q");

var $8z2Gd = parcelRequire("8z2Gd");
var $3I5zg = parcelRequire("3I5zg");
var $erRAP = parcelRequire("erRAP");

var $ay3qT = parcelRequire("ay3qT");

var $d7IsH = parcelRequire("d7IsH");
// these two constants are used to filter out properties not needed when trying to extract custom properties and measurements from the incoming payload
var $aa68c56f5088d49c$var$strBaseType = "baseType";
var $aa68c56f5088d49c$var$strBaseData = "baseData";
var $aa68c56f5088d49c$var$strProperties = "properties";
var $aa68c56f5088d49c$var$strTrue = "true";
function $aa68c56f5088d49c$var$_setValueIf(target, field, value) {
    return (0, $erRAP.setValue)(target, field, value, (0, $erRAP.isTruthy));
}
/*
 * Maps Part A data from CS 4.0
 */ function $aa68c56f5088d49c$var$_extractPartAExtensions(logger, item, env) {
    // todo: switch to keys from common in this method
    var envTags = env[0, $d7IsH._DYN_TAGS /* @min:%2etags */ ] = env[0, $d7IsH._DYN_TAGS /* @min:%2etags */ ] || {};
    var itmExt = item.ext = item.ext || {};
    var itmTags = item[0, $d7IsH._DYN_TAGS /* @min:%2etags */ ] = item[0, $d7IsH._DYN_TAGS /* @min:%2etags */ ] || [];
    var extUser = itmExt.user;
    if (extUser) {
        $aa68c56f5088d49c$var$_setValueIf(envTags, (0, $2gDxc.CtxTagKeys).userAuthUserId, extUser.authId);
        $aa68c56f5088d49c$var$_setValueIf(envTags, (0, $2gDxc.CtxTagKeys).userId, extUser.id || extUser.localId);
    }
    var extApp = itmExt.app;
    if (extApp) $aa68c56f5088d49c$var$_setValueIf(envTags, (0, $2gDxc.CtxTagKeys).sessionId, extApp.sesId);
    var extDevice = itmExt.device;
    if (extDevice) {
        $aa68c56f5088d49c$var$_setValueIf(envTags, (0, $2gDxc.CtxTagKeys).deviceId, extDevice.id || extDevice.localId);
        $aa68c56f5088d49c$var$_setValueIf(envTags, (0, $2gDxc.CtxTagKeys)[0, $d7IsH._DYN_DEVICE_TYPE /* @min:%2edeviceType */ ], extDevice.deviceClass);
        $aa68c56f5088d49c$var$_setValueIf(envTags, (0, $2gDxc.CtxTagKeys).deviceIp, extDevice.ip);
        $aa68c56f5088d49c$var$_setValueIf(envTags, (0, $2gDxc.CtxTagKeys).deviceModel, extDevice.model);
        $aa68c56f5088d49c$var$_setValueIf(envTags, (0, $2gDxc.CtxTagKeys)[0, $d7IsH._DYN_DEVICE_TYPE /* @min:%2edeviceType */ ], extDevice[0, $d7IsH._DYN_DEVICE_TYPE /* @min:%2edeviceType */ ]);
    }
    var web = item.ext.web;
    if (web) {
        $aa68c56f5088d49c$var$_setValueIf(envTags, (0, $2gDxc.CtxTagKeys).deviceLanguage, web.browserLang);
        $aa68c56f5088d49c$var$_setValueIf(envTags, (0, $2gDxc.CtxTagKeys).deviceBrowserVersion, web.browserVer);
        $aa68c56f5088d49c$var$_setValueIf(envTags, (0, $2gDxc.CtxTagKeys).deviceBrowser, web.browser);
        var envData = env[0, $d7IsH._DYN_DATA /* @min:%2edata */ ] = env[0, $d7IsH._DYN_DATA /* @min:%2edata */ ] || {};
        var envBaseData = envData[$aa68c56f5088d49c$var$strBaseData] = envData[$aa68c56f5088d49c$var$strBaseData] || {};
        var envProps = envBaseData[$aa68c56f5088d49c$var$strProperties] = envBaseData[$aa68c56f5088d49c$var$strProperties] || {};
        $aa68c56f5088d49c$var$_setValueIf(envProps, "domain", web.domain);
        $aa68c56f5088d49c$var$_setValueIf(envProps, "isManual", web.isManual ? $aa68c56f5088d49c$var$strTrue : null);
        $aa68c56f5088d49c$var$_setValueIf(envProps, "screenRes", web.screenRes);
        $aa68c56f5088d49c$var$_setValueIf(envProps, "userConsent", web.userConsent ? $aa68c56f5088d49c$var$strTrue : null);
    }
    var extOs = itmExt.os;
    if (extOs) $aa68c56f5088d49c$var$_setValueIf(envTags, (0, $2gDxc.CtxTagKeys).deviceOS, extOs[0, $d7IsH._DYN_NAME /* @min:%2ename */ ]);
    // No support for mapping Trace.traceState to 2.0 as it is currently empty
    var extTrace = itmExt.trace;
    if (extTrace) {
        $aa68c56f5088d49c$var$_setValueIf(envTags, (0, $2gDxc.CtxTagKeys).operationParentId, extTrace.parentID);
        $aa68c56f5088d49c$var$_setValueIf(envTags, (0, $2gDxc.CtxTagKeys).operationName, (0, $cGFCT.dataSanitizeString)(logger, extTrace[0, $d7IsH._DYN_NAME /* @min:%2ename */ ]));
        $aa68c56f5088d49c$var$_setValueIf(envTags, (0, $2gDxc.CtxTagKeys).operationId, extTrace[0, $d7IsH._DYN_TRACE_ID /* @min:%2etraceID */ ]);
    }
    // Sample 4.0 schema
    //  {
    //     "time" : "2018-09-05T22:51:22.4936Z",
    //     "name" : "MetricWithNamespace",
    //     "iKey" : "ABC-5a4cbd20-e601-4ef5-a3c6-5d6577e4398e",
    //     "ext": {  "cloud": {
    //          "role": "WATSON3",
    //          "roleInstance": "CO4AEAP00000260"
    //      },
    //      "device": {}, "correlation": {} },
    //      "tags": [
    //        { "amazon.region" : "east2" },
    //        { "os.expid" : "wp:02df239" }
    //     ]
    //   }
    var tgs = {};
    // deals with tags.push({object})
    for(var i = itmTags[0, $d7IsH._DYN_LENGTH /* @min:%2elength */ ] - 1; i >= 0; i--){
        var tg = itmTags[i];
        (0, $erRAP.objForEachKey)(tg, function(key, value) {
            tgs[key] = value;
        });
        itmTags.splice(i, 1);
    }
    // deals with tags[key]=value (and handles hasOwnProperty)
    (0, $erRAP.objForEachKey)(itmTags, function(tg, value) {
        tgs[tg] = value;
    });
    var theTags = (0, $fcMe7.__assignFn)((0, $fcMe7.__assignFn)({}, envTags), tgs);
    if (!theTags[(0, $2gDxc.CtxTagKeys).internalSdkVersion]) // Append a version in case it is not already set
    theTags[(0, $2gDxc.CtxTagKeys).internalSdkVersion] = (0, $cGFCT.dataSanitizeString)(logger, "javascript:".concat($aa68c56f5088d49c$export$3f11c9a3e644970c.Version), 64);
    env[0, $d7IsH._DYN_TAGS /* @min:%2etags */ ] = (0, $erRAP.optimizeObject)(theTags);
}
function $aa68c56f5088d49c$var$_extractPropsAndMeasurements(data, properties, measurements) {
    if (!(0, $erRAP.isNullOrUndefined)(data)) (0, $erRAP.objForEachKey)(data, function(key, value) {
        if ((0, $erRAP.isNumber)(value)) measurements[key] = value;
        else if ((0, $erRAP.isString)(value)) properties[key] = value;
        else if ((0, $3I5zg.hasJSON)()) properties[key] = (0, $3I5zg.getJSON)()[0, $d7IsH._DYN_STRINGIFY /* @min:%2estringify */ ](value);
    });
}
function $aa68c56f5088d49c$var$_convertPropsUndefinedToCustomDefinedValue(properties, customUndefinedValue) {
    if (!(0, $erRAP.isNullOrUndefined)(properties)) (0, $erRAP.objForEachKey)(properties, function(key, value) {
        properties[key] = value || customUndefinedValue;
    });
}
// TODO: Do we want this to take logger as arg or use this._logger as nonstatic?
function $aa68c56f5088d49c$var$_createEnvelope(logger, envelopeType, telemetryItem, data) {
    var envelope = new (0, $1V1Zd.Envelope)(logger, data, envelopeType);
    $aa68c56f5088d49c$var$_setValueIf(envelope, "sampleRate", telemetryItem[0, $dCW8D.SampleRate]);
    if ((telemetryItem[$aa68c56f5088d49c$var$strBaseData] || {}).startTime) envelope.time = (0, $erRAP.toISOString)(telemetryItem[$aa68c56f5088d49c$var$strBaseData].startTime);
    envelope.iKey = telemetryItem.iKey;
    var iKeyNoDashes = telemetryItem.iKey.replace(/-/g, "");
    envelope[0, $d7IsH._DYN_NAME /* @min:%2ename */ ] = envelope[0, $d7IsH._DYN_NAME /* @min:%2ename */ ].replace("{0}", iKeyNoDashes);
    // extract all extensions from ctx
    $aa68c56f5088d49c$var$_extractPartAExtensions(logger, telemetryItem, envelope);
    // loop through the envelope tags (extension of Part A) and pick out the ones that should go in outgoing envelope tags
    telemetryItem[0, $d7IsH._DYN_TAGS /* @min:%2etags */ ] = telemetryItem[0, $d7IsH._DYN_TAGS /* @min:%2etags */ ] || [];
    return (0, $erRAP.optimizeObject)(envelope);
}
function $aa68c56f5088d49c$var$EnvelopeCreatorInit(logger, telemetryItem) {
    if ((0, $erRAP.isNullOrUndefined)(telemetryItem[$aa68c56f5088d49c$var$strBaseData])) (0, $8z2Gd._throwInternal)(logger, 1 /* eLoggingSeverity.CRITICAL */ , 46 /* _eInternalMessageId.TelemetryEnvelopeInvalid */ , "telemetryItem.baseData cannot be null.");
}
var $aa68c56f5088d49c$export$3f11c9a3e644970c = {
    Version: "2.8.18"
};
function $aa68c56f5088d49c$export$74e603a08a7deabe(logger, telemetryItem, customUndefinedValue) {
    $aa68c56f5088d49c$var$EnvelopeCreatorInit(logger, telemetryItem);
    var customMeasurements = telemetryItem[$aa68c56f5088d49c$var$strBaseData][0, $d7IsH._DYN_MEASUREMENTS /* @min:%2emeasurements */ ] || {};
    var customProperties = telemetryItem[$aa68c56f5088d49c$var$strBaseData][$aa68c56f5088d49c$var$strProperties] || {};
    $aa68c56f5088d49c$var$_extractPropsAndMeasurements(telemetryItem[0, $d7IsH._DYN_DATA /* @min:%2edata */ ], customProperties, customMeasurements);
    if (!(0, $erRAP.isNullOrUndefined)(customUndefinedValue)) $aa68c56f5088d49c$var$_convertPropsUndefinedToCustomDefinedValue(customProperties, customUndefinedValue);
    var bd = telemetryItem[$aa68c56f5088d49c$var$strBaseData];
    if ((0, $erRAP.isNullOrUndefined)(bd)) {
        (0, $8z2Gd._warnToConsole)(logger, "Invalid input for dependency data");
        return null;
    }
    var method = bd[$aa68c56f5088d49c$var$strProperties] && bd[$aa68c56f5088d49c$var$strProperties][0, $dCW8D.HttpMethod] ? bd[$aa68c56f5088d49c$var$strProperties][0, $dCW8D.HttpMethod] : "GET";
    var remoteDepData = new (0, $7fph4.RemoteDependencyData)(logger, bd.id, bd.target, bd[0, $d7IsH._DYN_NAME /* @min:%2ename */ ], bd[0, $ay3qT.STR_DURATION /* @min:%2eduration */ ], bd.success, bd.responseCode, method, bd.type, bd.correlationContext, customProperties, customMeasurements);
    var data = new (0, $coTnQ.Data)((0, $7fph4.RemoteDependencyData)[0, $d7IsH._DYN_DATA_TYPE /* @min:%2edataType */ ], remoteDepData);
    return $aa68c56f5088d49c$var$_createEnvelope(logger, (0, $7fph4.RemoteDependencyData)[0, $d7IsH._DYN_ENVELOPE_TYPE /* @min:%2eenvelopeType */ ], telemetryItem, data);
}
function $aa68c56f5088d49c$export$b74153364c2066d1(logger, telemetryItem, customUndefinedValue) {
    $aa68c56f5088d49c$var$EnvelopeCreatorInit(logger, telemetryItem);
    var customProperties = {};
    var customMeasurements = {};
    if (telemetryItem[$aa68c56f5088d49c$var$strBaseType] !== (0, $fK8rK.Event)[0, $d7IsH._DYN_DATA_TYPE /* @min:%2edataType */ ]) customProperties["baseTypeSource"] = telemetryItem[$aa68c56f5088d49c$var$strBaseType]; // save the passed in base type as a property
    if (telemetryItem[$aa68c56f5088d49c$var$strBaseType] === (0, $fK8rK.Event)[0, $d7IsH._DYN_DATA_TYPE /* @min:%2edataType */ ]) {
        customProperties = telemetryItem[$aa68c56f5088d49c$var$strBaseData][$aa68c56f5088d49c$var$strProperties] || {};
        customMeasurements = telemetryItem[$aa68c56f5088d49c$var$strBaseData][0, $d7IsH._DYN_MEASUREMENTS /* @min:%2emeasurements */ ] || {};
    } else if (telemetryItem[$aa68c56f5088d49c$var$strBaseData]) $aa68c56f5088d49c$var$_extractPropsAndMeasurements(telemetryItem[$aa68c56f5088d49c$var$strBaseData], customProperties, customMeasurements);
    // Extract root level properties from part C telemetryItem.data
    $aa68c56f5088d49c$var$_extractPropsAndMeasurements(telemetryItem[0, $d7IsH._DYN_DATA /* @min:%2edata */ ], customProperties, customMeasurements);
    if (!(0, $erRAP.isNullOrUndefined)(customUndefinedValue)) $aa68c56f5088d49c$var$_convertPropsUndefinedToCustomDefinedValue(customProperties, customUndefinedValue);
    var eventName = telemetryItem[$aa68c56f5088d49c$var$strBaseData][0, $d7IsH._DYN_NAME /* @min:%2ename */ ];
    var eventData = new (0, $fK8rK.Event)(logger, eventName, customProperties, customMeasurements);
    var data = new (0, $coTnQ.Data)((0, $fK8rK.Event)[0, $d7IsH._DYN_DATA_TYPE /* @min:%2edataType */ ], eventData);
    return $aa68c56f5088d49c$var$_createEnvelope(logger, (0, $fK8rK.Event)[0, $d7IsH._DYN_ENVELOPE_TYPE /* @min:%2eenvelopeType */ ], telemetryItem, data);
}
function $aa68c56f5088d49c$export$eca78b65eeb356ed(logger, telemetryItem, customUndefinedValue) {
    $aa68c56f5088d49c$var$EnvelopeCreatorInit(logger, telemetryItem);
    // Extract root level properties from part C telemetryItem.data
    var customMeasurements = telemetryItem[$aa68c56f5088d49c$var$strBaseData][0, $d7IsH._DYN_MEASUREMENTS /* @min:%2emeasurements */ ] || {};
    var customProperties = telemetryItem[$aa68c56f5088d49c$var$strBaseData][$aa68c56f5088d49c$var$strProperties] || {};
    $aa68c56f5088d49c$var$_extractPropsAndMeasurements(telemetryItem[0, $d7IsH._DYN_DATA /* @min:%2edata */ ], customProperties, customMeasurements);
    if (!(0, $erRAP.isNullOrUndefined)(customUndefinedValue)) $aa68c56f5088d49c$var$_convertPropsUndefinedToCustomDefinedValue(customProperties, customUndefinedValue);
    var bd = telemetryItem[$aa68c56f5088d49c$var$strBaseData];
    var exData = (0, $3AuL8.Exception).CreateFromInterface(logger, bd, customProperties, customMeasurements);
    var data = new (0, $coTnQ.Data)((0, $3AuL8.Exception)[0, $d7IsH._DYN_DATA_TYPE /* @min:%2edataType */ ], exData);
    return $aa68c56f5088d49c$var$_createEnvelope(logger, (0, $3AuL8.Exception)[0, $d7IsH._DYN_ENVELOPE_TYPE /* @min:%2eenvelopeType */ ], telemetryItem, data);
}
function $aa68c56f5088d49c$export$bb5bee4039a2e495(logger, telemetryItem, customUndefinedValue) {
    $aa68c56f5088d49c$var$EnvelopeCreatorInit(logger, telemetryItem);
    var baseData = telemetryItem[$aa68c56f5088d49c$var$strBaseData];
    var props = baseData[$aa68c56f5088d49c$var$strProperties] || {};
    var measurements = baseData[0, $d7IsH._DYN_MEASUREMENTS /* @min:%2emeasurements */ ] || {};
    $aa68c56f5088d49c$var$_extractPropsAndMeasurements(telemetryItem[0, $d7IsH._DYN_DATA /* @min:%2edata */ ], props, measurements);
    if (!(0, $erRAP.isNullOrUndefined)(customUndefinedValue)) $aa68c56f5088d49c$var$_convertPropsUndefinedToCustomDefinedValue(props, customUndefinedValue);
    var baseMetricData = new (0, $ihDSn.Metric)(logger, baseData[0, $d7IsH._DYN_NAME /* @min:%2ename */ ], baseData.average, baseData.sampleCount, baseData.min, baseData.max, baseData.stdDev, props, measurements);
    var data = new (0, $coTnQ.Data)((0, $ihDSn.Metric)[0, $d7IsH._DYN_DATA_TYPE /* @min:%2edataType */ ], baseMetricData);
    return $aa68c56f5088d49c$var$_createEnvelope(logger, (0, $ihDSn.Metric)[0, $d7IsH._DYN_ENVELOPE_TYPE /* @min:%2eenvelopeType */ ], telemetryItem, data);
}
function $aa68c56f5088d49c$export$edbb8a2c6529947a(logger, telemetryItem, customUndefinedValue) {
    $aa68c56f5088d49c$var$EnvelopeCreatorInit(logger, telemetryItem);
    // Since duration is not part of the domain properties in Common Schema, extract it from part C
    var duration;
    var baseData = telemetryItem[$aa68c56f5088d49c$var$strBaseData];
    if (!(0, $erRAP.isNullOrUndefined)(baseData) && !(0, $erRAP.isNullOrUndefined)(baseData[$aa68c56f5088d49c$var$strProperties]) && !(0, $erRAP.isNullOrUndefined)(baseData[$aa68c56f5088d49c$var$strProperties][0, $ay3qT.STR_DURATION])) {
        duration = baseData[$aa68c56f5088d49c$var$strProperties][0, $ay3qT.STR_DURATION];
        delete baseData[$aa68c56f5088d49c$var$strProperties][0, $ay3qT.STR_DURATION];
    } else if (!(0, $erRAP.isNullOrUndefined)(telemetryItem[0, $d7IsH._DYN_DATA /* @min:%2edata */ ]) && !(0, $erRAP.isNullOrUndefined)(telemetryItem[0, $d7IsH._DYN_DATA /* @min:%2edata */ ][0, $ay3qT.STR_DURATION])) {
        duration = telemetryItem[0, $d7IsH._DYN_DATA /* @min:%2edata */ ][0, $ay3qT.STR_DURATION];
        delete telemetryItem[0, $d7IsH._DYN_DATA /* @min:%2edata */ ][0, $ay3qT.STR_DURATION];
    }
    var bd = telemetryItem[$aa68c56f5088d49c$var$strBaseData];
    // special case: pageview.id is grabbed from current operation id. Analytics plugin is decoupled from properties plugin, so this is done here instead. This can be made a default telemetry intializer instead if needed to be decoupled from channel
    var currentContextId;
    if (((telemetryItem.ext || {}).trace || {})[0, $d7IsH._DYN_TRACE_ID /* @min:%2etraceID */ ]) currentContextId = telemetryItem.ext.trace[0, $d7IsH._DYN_TRACE_ID /* @min:%2etraceID */ ];
    var id = bd.id || currentContextId;
    var name = bd[0, $d7IsH._DYN_NAME /* @min:%2ename */ ];
    var url = bd.uri;
    var properties = bd[$aa68c56f5088d49c$var$strProperties] || {};
    var measurements = bd[0, $d7IsH._DYN_MEASUREMENTS /* @min:%2emeasurements */ ] || {};
    // refUri is a field that Breeze still does not recognize as part of Part B. For now, put it in Part C until it supports it as a domain property
    if (!(0, $erRAP.isNullOrUndefined)(bd.refUri)) properties["refUri"] = bd.refUri;
    // pageType is a field that Breeze still does not recognize as part of Part B. For now, put it in Part C until it supports it as a domain property
    if (!(0, $erRAP.isNullOrUndefined)(bd.pageType)) properties["pageType"] = bd.pageType;
    // isLoggedIn is a field that Breeze still does not recognize as part of Part B. For now, put it in Part C until it supports it as a domain property
    if (!(0, $erRAP.isNullOrUndefined)(bd.isLoggedIn)) properties["isLoggedIn"] = bd.isLoggedIn[0, $d7IsH._DYN_TO_STRING /* @min:%2etoString */ ]();
    // pageTags is a field that Breeze still does not recognize as part of Part B. For now, put it in Part C until it supports it as a domain property
    if (!(0, $erRAP.isNullOrUndefined)(bd[$aa68c56f5088d49c$var$strProperties])) {
        var pageTags = bd[$aa68c56f5088d49c$var$strProperties];
        (0, $erRAP.objForEachKey)(pageTags, function(key, value) {
            properties[key] = value;
        });
    }
    $aa68c56f5088d49c$var$_extractPropsAndMeasurements(telemetryItem[0, $d7IsH._DYN_DATA /* @min:%2edata */ ], properties, measurements);
    if (!(0, $erRAP.isNullOrUndefined)(customUndefinedValue)) $aa68c56f5088d49c$var$_convertPropsUndefinedToCustomDefinedValue(properties, customUndefinedValue);
    var pageViewData = new (0, $80I4P.PageView)(logger, name, url, duration, properties, measurements, id);
    var data = new (0, $coTnQ.Data)((0, $80I4P.PageView)[0, $d7IsH._DYN_DATA_TYPE /* @min:%2edataType */ ], pageViewData);
    return $aa68c56f5088d49c$var$_createEnvelope(logger, (0, $80I4P.PageView)[0, $d7IsH._DYN_ENVELOPE_TYPE /* @min:%2eenvelopeType */ ], telemetryItem, data);
}
function $aa68c56f5088d49c$export$bb801863268e7049(logger, telemetryItem, customUndefinedValue) {
    $aa68c56f5088d49c$var$EnvelopeCreatorInit(logger, telemetryItem);
    var bd = telemetryItem[$aa68c56f5088d49c$var$strBaseData];
    var name = bd[0, $d7IsH._DYN_NAME /* @min:%2ename */ ];
    var url = bd.uri || bd.url;
    var properties = bd[$aa68c56f5088d49c$var$strProperties] || {};
    var measurements = bd[0, $d7IsH._DYN_MEASUREMENTS /* @min:%2emeasurements */ ] || {};
    $aa68c56f5088d49c$var$_extractPropsAndMeasurements(telemetryItem[0, $d7IsH._DYN_DATA /* @min:%2edata */ ], properties, measurements);
    if (!(0, $erRAP.isNullOrUndefined)(customUndefinedValue)) $aa68c56f5088d49c$var$_convertPropsUndefinedToCustomDefinedValue(properties, customUndefinedValue);
    var baseData = new (0, $bmYDZ.PageViewPerformance)(logger, name, url, undefined, properties, measurements, bd);
    var data = new (0, $coTnQ.Data)((0, $bmYDZ.PageViewPerformance)[0, $d7IsH._DYN_DATA_TYPE /* @min:%2edataType */ ], baseData);
    return $aa68c56f5088d49c$var$_createEnvelope(logger, (0, $bmYDZ.PageViewPerformance)[0, $d7IsH._DYN_ENVELOPE_TYPE /* @min:%2eenvelopeType */ ], telemetryItem, data);
}
function $aa68c56f5088d49c$export$bc9e843f2eb8a61c(logger, telemetryItem, customUndefinedValue) {
    $aa68c56f5088d49c$var$EnvelopeCreatorInit(logger, telemetryItem);
    var message = telemetryItem[$aa68c56f5088d49c$var$strBaseData].message;
    var severityLevel = telemetryItem[$aa68c56f5088d49c$var$strBaseData].severityLevel;
    var props = telemetryItem[$aa68c56f5088d49c$var$strBaseData][$aa68c56f5088d49c$var$strProperties] || {};
    var measurements = telemetryItem[$aa68c56f5088d49c$var$strBaseData][0, $d7IsH._DYN_MEASUREMENTS /* @min:%2emeasurements */ ] || {};
    $aa68c56f5088d49c$var$_extractPropsAndMeasurements(telemetryItem[0, $d7IsH._DYN_DATA /* @min:%2edata */ ], props, measurements);
    if (!(0, $erRAP.isNullOrUndefined)(customUndefinedValue)) $aa68c56f5088d49c$var$_convertPropsUndefinedToCustomDefinedValue(props, customUndefinedValue);
    var baseData = new (0, $lL63Q.Trace)(logger, message, severityLevel, props, measurements);
    var data = new (0, $coTnQ.Data)((0, $lL63Q.Trace)[0, $d7IsH._DYN_DATA_TYPE /* @min:%2edataType */ ], baseData);
    return $aa68c56f5088d49c$var$_createEnvelope(logger, (0, $lL63Q.Trace)[0, $d7IsH._DYN_ENVELOPE_TYPE /* @min:%2eenvelopeType */ ], telemetryItem, data);
}

});
parcelRegister("ay3qT", function(module, exports) {

$parcel$export(module.exports, "STR_DURATION", function () { return $7adfbe0745487c71$export$be41298b7716c698; });
/*
 * Application Insights JavaScript SDK - Channel, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ // !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// Note: DON'T Export these const from the package as we are still targeting ES3 this will export a mutable variables that someone could change!!!
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// Generally you should only put values that are used more than 2 times and then only if not already exposed as a constant (such as SdkCoreNames)
// as when using "short" named values from here they will be will be minified smaller than the SdkCoreNames[eSdkCoreNames.xxxx] value.
var $7adfbe0745487c71$export$be41298b7716c698 = "duration";

});

parcelRegister("d7IsH", function(module, exports) {

$parcel$export(module.exports, "_DYN_TAGS", function () { return $98de6afe6e02440c$export$d0f526aa8043f6d7; });
$parcel$export(module.exports, "_DYN_DEVICE_TYPE", function () { return $98de6afe6e02440c$export$f393dda3e1c87f59; });
$parcel$export(module.exports, "_DYN_DATA", function () { return $98de6afe6e02440c$export$2f5ff0b46814907e; });
$parcel$export(module.exports, "_DYN_NAME", function () { return $98de6afe6e02440c$export$9734b0a24bf02e93; });
$parcel$export(module.exports, "_DYN_TRACE_ID", function () { return $98de6afe6e02440c$export$a5eb52c53bba8560; });
$parcel$export(module.exports, "_DYN_LENGTH", function () { return $98de6afe6e02440c$export$6eae51590aaea43; });
$parcel$export(module.exports, "_DYN_STRINGIFY", function () { return $98de6afe6e02440c$export$a318a8141fc98747; });
$parcel$export(module.exports, "_DYN_MEASUREMENTS", function () { return $98de6afe6e02440c$export$32fc64677eb5b7a2; });
$parcel$export(module.exports, "_DYN_DATA_TYPE", function () { return $98de6afe6e02440c$export$9e16762ab4f2648; });
$parcel$export(module.exports, "_DYN_ENVELOPE_TYPE", function () { return $98de6afe6e02440c$export$2672d4f7ccc80348; });
$parcel$export(module.exports, "_DYN_TO_STRING", function () { return $98de6afe6e02440c$export$e2818d11505fa034; });
$parcel$export(module.exports, "_DYN_ON_LINE", function () { return $98de6afe6e02440c$export$a9130fdcd11ec7ef; });
$parcel$export(module.exports, "_DYN_IS_ONLINE", function () { return $98de6afe6e02440c$export$704cf8098f85ad0f; });
$parcel$export(module.exports, "_DYN_ENQUEUE", function () { return $98de6afe6e02440c$export$4aae77f3ba3c48b4; });
$parcel$export(module.exports, "_DYN_COUNT", function () { return $98de6afe6e02440c$export$e9679ef501b0d1; });
$parcel$export(module.exports, "_DYN_EVENTS_LIMIT_IN_MEM", function () { return $98de6afe6e02440c$export$c8dd872dc774fa7c; });
$parcel$export(module.exports, "_DYN_PUSH", function () { return $98de6afe6e02440c$export$a0a330e7fa1e278c; });
$parcel$export(module.exports, "_DYN_EMIT_LINE_DELIMITED_0", function () { return $98de6afe6e02440c$export$b18aabdfc0aaf6b; });
$parcel$export(module.exports, "_DYN_CLEAR", function () { return $98de6afe6e02440c$export$5eeb73fac03da74a; });
$parcel$export(module.exports, "_DYN_BATCH_PAYLOADS", function () { return $98de6afe6e02440c$export$a5da323a4da829fc; });
$parcel$export(module.exports, "_DYN_MARK_AS_SENT", function () { return $98de6afe6e02440c$export$52e50651d87300e3; });
$parcel$export(module.exports, "_DYN_CLEAR_SENT", function () { return $98de6afe6e02440c$export$13da1b5a005ef035; });
$parcel$export(module.exports, "_DYN_BUFFER_OVERRIDE", function () { return $98de6afe6e02440c$export$4637bcb72c509e60; });
$parcel$export(module.exports, "_DYN__BUFFER__KEY", function () { return $98de6afe6e02440c$export$63ab2dad6d8a60ed; });
$parcel$export(module.exports, "_DYN__SENT__BUFFER__KEY", function () { return $98de6afe6e02440c$export$d03f333763905c89; });
$parcel$export(module.exports, "_DYN__MAX__BUFFER__SIZE", function () { return $98de6afe6e02440c$export$20d3a25105cda3b1; });
$parcel$export(module.exports, "_DYN_NAME_PREFIX", function () { return $98de6afe6e02440c$export$6d013a7bc2da53c1; });
$parcel$export(module.exports, "_DYN_MAX_BATCH_SIZE_IN_BY1", function () { return $98de6afe6e02440c$export$803d432e48ba5ceb; });
$parcel$export(module.exports, "_DYN_TRIGGER_SEND", function () { return $98de6afe6e02440c$export$df21ab0de9057cc4; });
$parcel$export(module.exports, "_DYN_DIAG_LOG", function () { return $98de6afe6e02440c$export$c7ff2c36e5c78421; });
$parcel$export(module.exports, "_DYN_ONUNLOAD_DISABLE_BEA2", function () { return $98de6afe6e02440c$export$6b8e1dc9b77f253c; });
$parcel$export(module.exports, "_DYN_IS_BEACON_API_DISABL3", function () { return $98de6afe6e02440c$export$f5629284a6f7ec3d; });
$parcel$export(module.exports, "_DYN__SENDER", function () { return $98de6afe6e02440c$export$e5390b88ba6f1b04; });
$parcel$export(module.exports, "_DYN__SENDER_CONFIG", function () { return $98de6afe6e02440c$export$82b4fc64eafa0acf; });
$parcel$export(module.exports, "_DYN_ENABLE_SESSION_STORA4", function () { return $98de6afe6e02440c$export$782dd40ba58c3597; });
$parcel$export(module.exports, "_DYN__BUFFER", function () { return $98de6afe6e02440c$export$3f8a6394c5f7e7be; });
$parcel$export(module.exports, "_DYN_SAMPLING_PERCENTAGE", function () { return $98de6afe6e02440c$export$51ccd61d31b31ade; });
$parcel$export(module.exports, "_DYN_INSTRUMENTATION_KEY", function () { return $98de6afe6e02440c$export$81cfd43387c8dbcc; });
$parcel$export(module.exports, "_DYN_ENDPOINT_URL", function () { return $98de6afe6e02440c$export$bfa1c9e5dcf1e78; });
$parcel$export(module.exports, "_DYN_CUSTOM_HEADERS", function () { return $98de6afe6e02440c$export$dbe59923e879fdc5; });
$parcel$export(module.exports, "_DYN_DISABLE_XHR", function () { return $98de6afe6e02440c$export$85f018eb7798fb52; });
$parcel$export(module.exports, "_DYN_ONUNLOAD_DISABLE_FET5", function () { return $98de6afe6e02440c$export$d1f891e9714d3108; });
$parcel$export(module.exports, "_DYN_DISABLE_TELEMETRY", function () { return $98de6afe6e02440c$export$99a824310ffb055; });
$parcel$export(module.exports, "_DYN_BASE_TYPE", function () { return $98de6afe6e02440c$export$aa558e99f83347cf; });
$parcel$export(module.exports, "_DYN_SAMPLE_RATE", function () { return $98de6afe6e02440c$export$c2afe23fa18f9dff; });
$parcel$export(module.exports, "_DYN_CONVERT_UNDEFINED", function () { return $98de6afe6e02440c$export$12df46deb7379c67; });
$parcel$export(module.exports, "_DYN__XHR_READY_STATE_CHA6", function () { return $98de6afe6e02440c$export$9b55da9813cf231b; });
$parcel$export(module.exports, "_DYN__ON_ERROR", function () { return $98de6afe6e02440c$export$fd0c91d4da43d71b; });
$parcel$export(module.exports, "_DYN__ON_PARTIAL_SUCCESS", function () { return $98de6afe6e02440c$export$689c49d56ac33585; });
$parcel$export(module.exports, "_DYN__ON_SUCCESS", function () { return $98de6afe6e02440c$export$82a109ffee49e423; });
$parcel$export(module.exports, "_DYN_ITEMS_ACCEPTED", function () { return $98de6afe6e02440c$export$fb8523c8667e286a; });
$parcel$export(module.exports, "_DYN_ITEMS_RECEIVED", function () { return $98de6afe6e02440c$export$746df81af2cb9d94; });
$parcel$export(module.exports, "_DYN_IS_RETRY_DISABLED", function () { return $98de6afe6e02440c$export$daf21ca1b4199d89; });
$parcel$export(module.exports, "_DYN_SET_REQUEST_HEADER", function () { return $98de6afe6e02440c$export$84ecd29f369f5b1d; });
$parcel$export(module.exports, "_DYN_MAX_BATCH_INTERVAL", function () { return $98de6afe6e02440c$export$983774f06380e463; });
$parcel$export(module.exports, "_DYN_EVENTS_SEND_REQUEST", function () { return $98de6afe6e02440c$export$298b8388870fcfe9; });
$parcel$export(module.exports, "_DYN_DISABLE_INSTRUMENTAT7", function () { return $98de6afe6e02440c$export$87cff5e4f8bac22c; });
$parcel$export(module.exports, "_DYN_GET_SAMPLING_SCORE", function () { return $98de6afe6e02440c$export$2c3af30a5c45aa6e; });
$parcel$export(module.exports, "_DYN_GET_HASH_CODE_SCORE", function () { return $98de6afe6e02440c$export$d676f8c50f371355; });
/*
 * Application Insights JavaScript SDK - Channel, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ // @skip-file-minify
// ##############################################################
// AUTO GENERATED FILE: This file is Auto Generated during build.
// ##############################################################
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// Note: DON'T Export these const from the package as we are still targeting ES3 this will export a mutable variables that someone could change!!!
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
var $98de6afe6e02440c$export$d0f526aa8043f6d7 = "tags"; // Count: 17
var $98de6afe6e02440c$export$f393dda3e1c87f59 = "deviceType"; // Count: 3
var $98de6afe6e02440c$export$2f5ff0b46814907e = "data"; // Count: 13
var $98de6afe6e02440c$export$9734b0a24bf02e93 = "name"; // Count: 8
var $98de6afe6e02440c$export$a5eb52c53bba8560 = "traceID"; // Count: 5
var $98de6afe6e02440c$export$6eae51590aaea43 = "length"; // Count: 37
var $98de6afe6e02440c$export$a318a8141fc98747 = "stringify"; // Count: 5
var $98de6afe6e02440c$export$32fc64677eb5b7a2 = "measurements"; // Count: 7
var $98de6afe6e02440c$export$9e16762ab4f2648 = "dataType"; // Count: 10
var $98de6afe6e02440c$export$2672d4f7ccc80348 = "envelopeType"; // Count: 7
var $98de6afe6e02440c$export$e2818d11505fa034 = "toString"; // Count: 7
var $98de6afe6e02440c$export$a9130fdcd11ec7ef = "onLine"; // Count: 4
var $98de6afe6e02440c$export$704cf8098f85ad0f = "isOnline"; // Count: 3
var $98de6afe6e02440c$export$4aae77f3ba3c48b4 = "enqueue"; // Count: 5
var $98de6afe6e02440c$export$e9679ef501b0d1 = "count"; // Count: 6
var $98de6afe6e02440c$export$c8dd872dc774fa7c = "eventsLimitInMem"; // Count: 2
var $98de6afe6e02440c$export$a0a330e7fa1e278c = "push"; // Count: 6
var $98de6afe6e02440c$export$b18aabdfc0aaf6b = "emitLineDelimitedJson"; // Count: 3
var $98de6afe6e02440c$export$5eeb73fac03da74a = "clear"; // Count: 6
var $98de6afe6e02440c$export$a5da323a4da829fc = "batchPayloads"; // Count: 5
var $98de6afe6e02440c$export$52e50651d87300e3 = "markAsSent"; // Count: 6
var $98de6afe6e02440c$export$13da1b5a005ef035 = "clearSent"; // Count: 5
var $98de6afe6e02440c$export$4637bcb72c509e60 = "bufferOverride"; // Count: 3
var $98de6afe6e02440c$export$63ab2dad6d8a60ed = "BUFFER_KEY"; // Count: 5
var $98de6afe6e02440c$export$d03f333763905c89 = "SENT_BUFFER_KEY"; // Count: 7
var $98de6afe6e02440c$export$20d3a25105cda3b1 = "MAX_BUFFER_SIZE"; // Count: 5
var $98de6afe6e02440c$export$6d013a7bc2da53c1 = "namePrefix"; // Count: 6
var $98de6afe6e02440c$export$803d432e48ba5ceb = "maxBatchSizeInBytes"; // Count: 3
var $98de6afe6e02440c$export$df21ab0de9057cc4 = "triggerSend"; // Count: 6
var $98de6afe6e02440c$export$c7ff2c36e5c78421 = "diagLog"; // Count: 15
var $98de6afe6e02440c$export$6b8e1dc9b77f253c = "onunloadDisableBeacon"; // Count: 2
var $98de6afe6e02440c$export$f5629284a6f7ec3d = "isBeaconApiDisabled"; // Count: 3
var $98de6afe6e02440c$export$e5390b88ba6f1b04 = "_sender"; // Count: 5
var $98de6afe6e02440c$export$82b4fc64eafa0acf = "_senderConfig"; // Count: 4
var $98de6afe6e02440c$export$782dd40ba58c3597 = "enableSessionStorageBuffer"; // Count: 2
var $98de6afe6e02440c$export$3f8a6394c5f7e7be = "_buffer"; // Count: 9
var $98de6afe6e02440c$export$51ccd61d31b31ade = "samplingPercentage"; // Count: 2
var $98de6afe6e02440c$export$81cfd43387c8dbcc = "instrumentationKey"; // Count: 4
var $98de6afe6e02440c$export$bfa1c9e5dcf1e78 = "endpointUrl"; // Count: 8
var $98de6afe6e02440c$export$dbe59923e879fdc5 = "customHeaders"; // Count: 4
var $98de6afe6e02440c$export$85f018eb7798fb52 = "disableXhr"; // Count: 5
var $98de6afe6e02440c$export$d1f891e9714d3108 = "onunloadDisableFetch"; // Count: 2
var $98de6afe6e02440c$export$99a824310ffb055 = "disableTelemetry"; // Count: 2
var $98de6afe6e02440c$export$aa558e99f83347cf = "baseType"; // Count: 4
var $98de6afe6e02440c$export$c2afe23fa18f9dff = "sampleRate"; // Count: 4
var $98de6afe6e02440c$export$12df46deb7379c67 = "convertUndefined"; // Count: 2
var $98de6afe6e02440c$export$9b55da9813cf231b = "_xhrReadyStateChange"; // Count: 2
var $98de6afe6e02440c$export$fd0c91d4da43d71b = "_onError"; // Count: 11
var $98de6afe6e02440c$export$689c49d56ac33585 = "_onPartialSuccess"; // Count: 3
var $98de6afe6e02440c$export$82a109ffee49e423 = "_onSuccess"; // Count: 6
var $98de6afe6e02440c$export$fb8523c8667e286a = "itemsAccepted"; // Count: 5
var $98de6afe6e02440c$export$746df81af2cb9d94 = "itemsReceived"; // Count: 6
var $98de6afe6e02440c$export$daf21ca1b4199d89 = "isRetryDisabled"; // Count: 5
var $98de6afe6e02440c$export$84ecd29f369f5b1d = "setRequestHeader"; // Count: 3
var $98de6afe6e02440c$export$983774f06380e463 = "maxBatchInterval"; // Count: 2
var $98de6afe6e02440c$export$298b8388870fcfe9 = "eventsSendRequest"; // Count: 2
var $98de6afe6e02440c$export$87cff5e4f8bac22c = "disableInstrumentationKeyValidation"; // Count: 2
var $98de6afe6e02440c$export$2c3af30a5c45aa6e = "getSamplingScore"; // Count: 2
var $98de6afe6e02440c$export$d676f8c50f371355 = "getHashCodeScore"; // Count: 4

});


parcelRegister("7lPJP", function(module, exports) {

$parcel$export(module.exports, "createOfflineListener", function () { return $55a2a0ac3bc7d27a$export$798b7fe42d5e3d06; });
/*
 * Application Insights JavaScript SDK - Channel, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $2w0XY = parcelRequire("2w0XY");
var $cIC5n = parcelRequire("cIC5n");
var $3I5zg = parcelRequire("3I5zg");
var $erRAP = parcelRequire("erRAP");

var $d7IsH = parcelRequire("d7IsH");
function $55a2a0ac3bc7d27a$var$_disableEvents(target, evtNamespace) {
    (0, $cIC5n.eventOff)(target, null, null, evtNamespace);
}
function $55a2a0ac3bc7d27a$export$798b7fe42d5e3d06(parentEvtNamespace) {
    var _a;
    var _document = (0, $3I5zg.getDocument)();
    var _navigator = (0, $3I5zg.getNavigator)(); // Gets the window.navigator or workerNavigator depending on the global
    var _isListening = false;
    var _onlineStatus = true;
    var _evtNamespace = (0, $cIC5n.mergeEvtNamespace)((0, $2w0XY.createUniqueNamespace)("OfflineListener"), parentEvtNamespace);
    try {
        if (_enableEvents((0, $3I5zg.getWindow)())) _isListening = true;
        if (_document) {
            // Also attach to the document.body or document
            var target = _document.body || _document;
            if (target.ononline) {
                if (_enableEvents(target)) _isListening = true;
            }
        }
        if (_isListening) // We are listening to events so lets set the current status rather than assuming we are online #1538
        {
            if (_navigator && !(0, $erRAP.isNullOrUndefined)(_navigator[0, $d7IsH._DYN_ON_LINE /* @min:%2eonLine */ ])) _onlineStatus = _navigator[0, $d7IsH._DYN_ON_LINE /* @min:%2eonLine */ ];
        }
    } catch (e) {
        // this makes react-native less angry
        _isListening = false;
    }
    function _enableEvents(target) {
        var enabled = false;
        if (target) {
            enabled = (0, $cIC5n.eventOn)(target, "online", _setOnline, _evtNamespace);
            if (enabled) (0, $cIC5n.eventOn)(target, "offline", _setOffline, _evtNamespace);
        }
        return enabled;
    }
    function _setOnline() {
        _onlineStatus = true;
    }
    function _setOffline() {
        _onlineStatus = false;
    }
    function _isOnline() {
        var result = true;
        if (_isListening) result = _onlineStatus;
        else if (_navigator && !(0, $erRAP.isNullOrUndefined)(_navigator[0, $d7IsH._DYN_ON_LINE /* @min:%2eonLine */ ])) result = _navigator[0, $d7IsH._DYN_ON_LINE /* @min:%2eonLine */ ];
        return result;
    }
    function _unload() {
        var win = (0, $3I5zg.getWindow)();
        if (win && _isListening) {
            $55a2a0ac3bc7d27a$var$_disableEvents(win, _evtNamespace);
            if (_document) {
                // Also attach to the document.body or document
                var target = _document.body || _document;
                if (!(0, $erRAP.isUndefined)(target.ononline)) $55a2a0ac3bc7d27a$var$_disableEvents(target, _evtNamespace);
            }
            _isListening = false;
        }
    }
    return _a = {}, _a[0, $d7IsH._DYN_IS_ONLINE /* @min:isOnline */ ] = _isOnline, _a.isListening = function() {
        return _isListening;
    }, _a.unload = _unload, _a;
}

});

parcelRegister("aWy8a", function(module, exports) {

$parcel$export(module.exports, "ArraySendBuffer", function () { return $7f79cbd5c8ae5832$export$d706e5fd60d36d56; });
$parcel$export(module.exports, "SessionStorageSendBuffer", function () { return $7f79cbd5c8ae5832$export$dcb776947c16915f; });
/*
 * Application Insights JavaScript SDK - Channel, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $fcMe7 = parcelRequire("fcMe7");

var $kbmky = parcelRequire("kbmky");

var $fu0yT = parcelRequire("fu0yT");

var $8z2Gd = parcelRequire("8z2Gd");
var $erRAP = parcelRequire("erRAP");
var $3I5zg = parcelRequire("3I5zg");

var $d7IsH = parcelRequire("d7IsH");
var $7f79cbd5c8ae5832$var$BaseSendBuffer = /** @class */ function() {
    function BaseSendBuffer(logger, config) {
        var _buffer = [];
        var _bufferFullMessageSent = false;
        this._get = function() {
            return _buffer;
        };
        this._set = function(buffer) {
            _buffer = buffer;
            return _buffer;
        };
        (0, $kbmky.default)(BaseSendBuffer, this, function(_self) {
            _self[0, $d7IsH._DYN_ENQUEUE /* @min:%2eenqueue */ ] = function(payload) {
                if (_self[0, $d7IsH._DYN_COUNT /* @min:%2ecount */ ]() >= config[0, $d7IsH._DYN_EVENTS_LIMIT_IN_MEM /* @min:%2eeventsLimitInMem */ ]()) {
                    // sent internal log only once per page view
                    if (!_bufferFullMessageSent) {
                        (0, $8z2Gd._throwInternal)(logger, 2 /* eLoggingSeverity.WARNING */ , 105 /* _eInternalMessageId.InMemoryStorageBufferFull */ , "Maximum in-memory buffer size reached: " + _self[0, $d7IsH._DYN_COUNT /* @min:%2ecount */ ](), true);
                        _bufferFullMessageSent = true;
                    }
                    return;
                }
                _buffer[0, $d7IsH._DYN_PUSH /* @min:%2epush */ ](payload);
            };
            _self[0, $d7IsH._DYN_COUNT /* @min:%2ecount */ ] = function() {
                return _buffer[0, $d7IsH._DYN_LENGTH /* @min:%2elength */ ];
            };
            _self.size = function() {
                var size = _buffer[0, $d7IsH._DYN_LENGTH /* @min:%2elength */ ];
                for(var lp = 0; lp < _buffer[0, $d7IsH._DYN_LENGTH /* @min:%2elength */ ]; lp++)size += _buffer[lp][0, $d7IsH._DYN_LENGTH /* @min:%2elength */ ];
                if (!config[0, $d7IsH._DYN_EMIT_LINE_DELIMITED_0 /* @min:%2eemitLineDelimitedJson */ ]()) size += 2;
                return size;
            };
            _self[0, $d7IsH._DYN_CLEAR /* @min:%2eclear */ ] = function() {
                _buffer = [];
                _bufferFullMessageSent = false;
            };
            _self.getItems = function() {
                return _buffer.slice(0);
            };
            _self[0, $d7IsH._DYN_BATCH_PAYLOADS /* @min:%2ebatchPayloads */ ] = function(payload) {
                if (payload && payload[0, $d7IsH._DYN_LENGTH /* @min:%2elength */ ] > 0) {
                    var batch = config[0, $d7IsH._DYN_EMIT_LINE_DELIMITED_0 /* @min:%2eemitLineDelimitedJson */ ]() ? payload.join("\n") : "[" + payload.join(",") + "]";
                    return batch;
                }
                return null;
            };
        });
    }
    // Removed Stub for BaseSendBuffer.prototype.enqueue.
    // Removed Stub for BaseSendBuffer.prototype.count.
    // Removed Stub for BaseSendBuffer.prototype.size.
    // Removed Stub for BaseSendBuffer.prototype.clear.
    // Removed Stub for BaseSendBuffer.prototype.getItems.
    // Removed Stub for BaseSendBuffer.prototype.batchPayloads.
    // This is a workaround for an IE8 bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    // this will be removed when ES3 support is dropped.
    BaseSendBuffer.__ieDyn = 1;
    return BaseSendBuffer;
}();
/*
 * An array based send buffer.
 */ var $7f79cbd5c8ae5832$export$d706e5fd60d36d56 = /** @class */ function(_super) {
    (0, $fcMe7.__extendsFn)(ArraySendBuffer, _super);
    function ArraySendBuffer(logger, config) {
        var _this = _super.call(this, logger, config) || this;
        (0, $kbmky.default)(ArraySendBuffer, _this, function(_self, _base) {
            _self[0, $d7IsH._DYN_MARK_AS_SENT /* @min:%2emarkAsSent */ ] = function(payload) {
                _base[0, $d7IsH._DYN_CLEAR /* @min:%2eclear */ ]();
            };
            _self[0, $d7IsH._DYN_CLEAR_SENT /* @min:%2eclearSent */ ] = function(payload) {
            // not supported
            };
        });
        return _this;
    }
    // Removed Stub for ArraySendBuffer.prototype.markAsSent.
    // Removed Stub for ArraySendBuffer.prototype.clearSent.
    // This is a workaround for an IE8 bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    // this will be removed when ES3 support is dropped.
    ArraySendBuffer.__ieDyn = 1;
    return ArraySendBuffer;
}($7f79cbd5c8ae5832$var$BaseSendBuffer);
/*
 * Session storage buffer holds a copy of all unsent items in the browser session storage.
 */ var $7f79cbd5c8ae5832$export$dcb776947c16915f = /** @class */ function(_super) {
    (0, $fcMe7.__extendsFn)(SessionStorageSendBuffer, _super);
    function SessionStorageSendBuffer(logger, config) {
        var _this = _super.call(this, logger, config) || this;
        var _bufferFullMessageSent = false;
        var _a = config[0, $d7IsH._DYN_BUFFER_OVERRIDE /* @min:%2ebufferOverride */ ]() || {
            getItem: (0, $fu0yT.utlGetSessionStorage),
            setItem: (0, $fu0yT.utlSetSessionStorage)
        }, getItem = _a.getItem, setItem = _a.setItem;
        (0, $kbmky.default)(SessionStorageSendBuffer, _this, function(_self, _base) {
            var bufferItems = _getBuffer(SessionStorageSendBuffer[0, $d7IsH._DYN__BUFFER__KEY /* @min:%2eBUFFER_KEY */ ]);
            var notDeliveredItems = _getBuffer(SessionStorageSendBuffer[0, $d7IsH._DYN__SENT__BUFFER__KEY /* @min:%2eSENT_BUFFER_KEY */ ]);
            var buffer = _self._set(bufferItems.concat(notDeliveredItems));
            // If the buffer has too many items, drop items from the end.
            if (buffer[0, $d7IsH._DYN_LENGTH /* @min:%2elength */ ] > SessionStorageSendBuffer[0, $d7IsH._DYN__MAX__BUFFER__SIZE /* @min:%2eMAX_BUFFER_SIZE */ ]) buffer[0, $d7IsH._DYN_LENGTH /* @min:%2elength */ ] = SessionStorageSendBuffer[0, $d7IsH._DYN__MAX__BUFFER__SIZE /* @min:%2eMAX_BUFFER_SIZE */ ];
            _setBuffer(SessionStorageSendBuffer[0, $d7IsH._DYN__SENT__BUFFER__KEY /* @min:%2eSENT_BUFFER_KEY */ ], []);
            _setBuffer(SessionStorageSendBuffer[0, $d7IsH._DYN__BUFFER__KEY /* @min:%2eBUFFER_KEY */ ], buffer);
            _self[0, $d7IsH._DYN_ENQUEUE /* @min:%2eenqueue */ ] = function(payload) {
                if (_self[0, $d7IsH._DYN_COUNT /* @min:%2ecount */ ]() >= SessionStorageSendBuffer[0, $d7IsH._DYN__MAX__BUFFER__SIZE /* @min:%2eMAX_BUFFER_SIZE */ ]) {
                    // sent internal log only once per page view
                    if (!_bufferFullMessageSent) {
                        (0, $8z2Gd._throwInternal)(logger, 2 /* eLoggingSeverity.WARNING */ , 67 /* _eInternalMessageId.SessionStorageBufferFull */ , "Maximum buffer size reached: " + _self[0, $d7IsH._DYN_COUNT /* @min:%2ecount */ ](), true);
                        _bufferFullMessageSent = true;
                    }
                    return;
                }
                _base[0, $d7IsH._DYN_ENQUEUE /* @min:%2eenqueue */ ](payload);
                _setBuffer(SessionStorageSendBuffer[0, $d7IsH._DYN__BUFFER__KEY /* @min:%2eBUFFER_KEY */ ], _self._get());
            };
            _self[0, $d7IsH._DYN_CLEAR /* @min:%2eclear */ ] = function() {
                _base[0, $d7IsH._DYN_CLEAR /* @min:%2eclear */ ]();
                _setBuffer(SessionStorageSendBuffer[0, $d7IsH._DYN__BUFFER__KEY /* @min:%2eBUFFER_KEY */ ], _self._get());
                _setBuffer(SessionStorageSendBuffer[0, $d7IsH._DYN__SENT__BUFFER__KEY /* @min:%2eSENT_BUFFER_KEY */ ], []);
                _bufferFullMessageSent = false;
            };
            _self[0, $d7IsH._DYN_MARK_AS_SENT /* @min:%2emarkAsSent */ ] = function(payload) {
                _setBuffer(SessionStorageSendBuffer[0, $d7IsH._DYN__BUFFER__KEY /* @min:%2eBUFFER_KEY */ ], _self._set(_removePayloadsFromBuffer(payload, _self._get())));
                var sentElements = _getBuffer(SessionStorageSendBuffer[0, $d7IsH._DYN__SENT__BUFFER__KEY /* @min:%2eSENT_BUFFER_KEY */ ]);
                if (sentElements instanceof Array && payload instanceof Array) {
                    sentElements = sentElements.concat(payload);
                    if (sentElements[0, $d7IsH._DYN_LENGTH /* @min:%2elength */ ] > SessionStorageSendBuffer[0, $d7IsH._DYN__MAX__BUFFER__SIZE /* @min:%2eMAX_BUFFER_SIZE */ ]) {
                        // We send telemetry normally. If the SENT_BUFFER is too big we don't add new elements
                        // until we receive a response from the backend and the buffer has free space again (see clearSent method)
                        (0, $8z2Gd._throwInternal)(logger, 1 /* eLoggingSeverity.CRITICAL */ , 67 /* _eInternalMessageId.SessionStorageBufferFull */ , "Sent buffer reached its maximum size: " + sentElements[0, $d7IsH._DYN_LENGTH /* @min:%2elength */ ], true);
                        sentElements[0, $d7IsH._DYN_LENGTH /* @min:%2elength */ ] = SessionStorageSendBuffer[0, $d7IsH._DYN__MAX__BUFFER__SIZE /* @min:%2eMAX_BUFFER_SIZE */ ];
                    }
                    _setBuffer(SessionStorageSendBuffer[0, $d7IsH._DYN__SENT__BUFFER__KEY /* @min:%2eSENT_BUFFER_KEY */ ], sentElements);
                }
            };
            _self[0, $d7IsH._DYN_CLEAR_SENT /* @min:%2eclearSent */ ] = function(payload) {
                var sentElements = _getBuffer(SessionStorageSendBuffer[0, $d7IsH._DYN__SENT__BUFFER__KEY /* @min:%2eSENT_BUFFER_KEY */ ]);
                sentElements = _removePayloadsFromBuffer(payload, sentElements);
                _setBuffer(SessionStorageSendBuffer[0, $d7IsH._DYN__SENT__BUFFER__KEY /* @min:%2eSENT_BUFFER_KEY */ ], sentElements);
            };
            function _removePayloadsFromBuffer(payloads, buffer) {
                var remaining = [];
                (0, $erRAP.arrForEach)(buffer, function(value) {
                    if (!(0, $erRAP.isFunction)(value) && (0, $erRAP.arrIndexOf)(payloads, value) === -1) remaining[0, $d7IsH._DYN_PUSH /* @min:%2epush */ ](value);
                });
                return remaining;
            }
            function _getBuffer(key) {
                var prefixedKey = key;
                try {
                    prefixedKey = config[0, $d7IsH._DYN_NAME_PREFIX /* @min:%2enamePrefix */ ] && config[0, $d7IsH._DYN_NAME_PREFIX /* @min:%2enamePrefix */ ]() ? config[0, $d7IsH._DYN_NAME_PREFIX /* @min:%2enamePrefix */ ]() + "_" + prefixedKey : prefixedKey;
                    var bufferJson = getItem(logger, prefixedKey);
                    if (bufferJson) {
                        var buffer_1 = (0, $3I5zg.getJSON)().parse(bufferJson);
                        if ((0, $erRAP.isString)(buffer_1)) // When using some version prototype.js the stringify / parse cycle does not decode array's correctly
                        buffer_1 = (0, $3I5zg.getJSON)().parse(buffer_1);
                        if (buffer_1 && (0, $erRAP.isArray)(buffer_1)) return buffer_1;
                    }
                } catch (e) {
                    (0, $8z2Gd._throwInternal)(logger, 1 /* eLoggingSeverity.CRITICAL */ , 42 /* _eInternalMessageId.FailedToRestoreStorageBuffer */ , " storage key: " + prefixedKey + ", " + (0, $erRAP.getExceptionName)(e), {
                        exception: (0, $3I5zg.dumpObj)(e)
                    });
                }
                return [];
            }
            function _setBuffer(key, buffer) {
                var prefixedKey = key;
                try {
                    prefixedKey = config[0, $d7IsH._DYN_NAME_PREFIX /* @min:%2enamePrefix */ ] && config[0, $d7IsH._DYN_NAME_PREFIX /* @min:%2enamePrefix */ ]() ? config[0, $d7IsH._DYN_NAME_PREFIX /* @min:%2enamePrefix */ ]() + "_" + prefixedKey : prefixedKey;
                    var bufferJson = JSON[0, $d7IsH._DYN_STRINGIFY /* @min:%2estringify */ ](buffer);
                    setItem(logger, prefixedKey, bufferJson);
                } catch (e) {
                    // if there was an error, clear the buffer
                    // telemetry is stored in the _buffer array so we won't loose any items
                    setItem(logger, prefixedKey, JSON[0, $d7IsH._DYN_STRINGIFY /* @min:%2estringify */ ]([]));
                    (0, $8z2Gd._throwInternal)(logger, 2 /* eLoggingSeverity.WARNING */ , 41 /* _eInternalMessageId.FailedToSetStorageBuffer */ , " storage key: " + prefixedKey + ", " + (0, $erRAP.getExceptionName)(e) + ". Buffer cleared", {
                        exception: (0, $3I5zg.dumpObj)(e)
                    });
                }
            }
        });
        return _this;
    }
    // Removed Stub for SessionStorageSendBuffer.prototype.enqueue.
    // Removed Stub for SessionStorageSendBuffer.prototype.clear.
    // Removed Stub for SessionStorageSendBuffer.prototype.markAsSent.
    // Removed Stub for SessionStorageSendBuffer.prototype.clearSent.
    SessionStorageSendBuffer.BUFFER_KEY = "AI_buffer";
    SessionStorageSendBuffer.SENT_BUFFER_KEY = "AI_sentBuffer";
    // Maximum number of payloads stored in the buffer. If the buffer is full, new elements will be dropped.
    SessionStorageSendBuffer.MAX_BUFFER_SIZE = 2000;
    return SessionStorageSendBuffer;
}($7f79cbd5c8ae5832$var$BaseSendBuffer);

});

parcelRegister("5l8m1", function(module, exports) {

$parcel$export(module.exports, "Serializer", function () { return $3e3564e6f3554f6a$export$ef852775387a0be7; });
/*
 * Application Insights JavaScript SDK - Channel, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $kbmky = parcelRequire("kbmky");

var $8z2Gd = parcelRequire("8z2Gd");
var $3I5zg = parcelRequire("3I5zg");
var $erRAP = parcelRequire("erRAP");

var $d7IsH = parcelRequire("d7IsH");
var $3e3564e6f3554f6a$export$ef852775387a0be7 = /** @class */ function() {
    function Serializer(logger) {
        (0, $kbmky.default)(Serializer, this, function(_self) {
            /**
             * Serializes the current object to a JSON string.
             */ _self.serialize = function(input) {
                var output = _serializeObject(input, "root");
                try {
                    return (0, $3I5zg.getJSON)()[0, $d7IsH._DYN_STRINGIFY /* @min:%2estringify */ ](output);
                } catch (e) {
                    // if serialization fails return an empty string
                    (0, $8z2Gd._throwInternal)(logger, 1 /* eLoggingSeverity.CRITICAL */ , 48 /* _eInternalMessageId.CannotSerializeObject */ , e && (0, $erRAP.isFunction)(e[0, $d7IsH._DYN_TO_STRING /* @min:%2etoString */ ]) ? e[0, $d7IsH._DYN_TO_STRING /* @min:%2etoString */ ]() : "Error serializing object", null, true);
                }
            };
            function _serializeObject(source, name) {
                var circularReferenceCheck = "__aiCircularRefCheck";
                var output = {};
                if (!source) {
                    (0, $8z2Gd._throwInternal)(logger, 1 /* eLoggingSeverity.CRITICAL */ , 48 /* _eInternalMessageId.CannotSerializeObject */ , "cannot serialize object because it is null or undefined", {
                        name: name
                    }, true);
                    return output;
                }
                if (source[circularReferenceCheck]) {
                    (0, $8z2Gd._throwInternal)(logger, 2 /* eLoggingSeverity.WARNING */ , 50 /* _eInternalMessageId.CircularReferenceDetected */ , "Circular reference detected while serializing object", {
                        name: name
                    }, true);
                    return output;
                }
                if (!source.aiDataContract) {
                    // special case for measurements/properties/tags
                    if (name === "measurements") output = _serializeStringMap(source, "number", name);
                    else if (name === "properties") output = _serializeStringMap(source, "string", name);
                    else if (name === "tags") output = _serializeStringMap(source, "string", name);
                    else if ((0, $erRAP.isArray)(source)) output = _serializeArray(source, name);
                    else {
                        (0, $8z2Gd._throwInternal)(logger, 2 /* eLoggingSeverity.WARNING */ , 49 /* _eInternalMessageId.CannotSerializeObjectNonSerializable */ , "Attempting to serialize an object which does not implement ISerializable", {
                            name: name
                        }, true);
                        try {
                            // verify that the object can be stringified
                            (0, $3I5zg.getJSON)()[0, $d7IsH._DYN_STRINGIFY /* @min:%2estringify */ ](source);
                            output = source;
                        } catch (e) {
                            // if serialization fails return an empty string
                            (0, $8z2Gd._throwInternal)(logger, 1 /* eLoggingSeverity.CRITICAL */ , 48 /* _eInternalMessageId.CannotSerializeObject */ , e && (0, $erRAP.isFunction)(e[0, $d7IsH._DYN_TO_STRING /* @min:%2etoString */ ]) ? e[0, $d7IsH._DYN_TO_STRING /* @min:%2etoString */ ]() : "Error serializing object", null, true);
                        }
                    }
                    return output;
                }
                source[circularReferenceCheck] = true;
                (0, $erRAP.objForEachKey)(source.aiDataContract, function(field, contract) {
                    var isRequired = (0, $erRAP.isFunction)(contract) ? contract() & 1 /* FieldType.Required */  : contract & 1 /* FieldType.Required */ ;
                    var isHidden = (0, $erRAP.isFunction)(contract) ? contract() & 4 /* FieldType.Hidden */  : contract & 4 /* FieldType.Hidden */ ;
                    var isArray = contract & 2 /* FieldType.Array */ ;
                    var isPresent = source[field] !== undefined;
                    var isObj = (0, $erRAP.isObject)(source[field]) && source[field] !== null;
                    if (isRequired && !isPresent && !isArray) (0, $8z2Gd._throwInternal)(logger, 1 /* eLoggingSeverity.CRITICAL */ , 24 /* _eInternalMessageId.MissingRequiredFieldSpecification */ , "Missing required field specification. The field is required but not present on source", {
                        field: field,
                        name: name
                    });
                    else if (!isHidden) {
                        var value = void 0;
                        if (isObj) {
                            if (isArray) // special case; recurse on each object in the source array
                            value = _serializeArray(source[field], field);
                            else // recurse on the source object in this field
                            value = _serializeObject(source[field], field);
                        } else // assign the source field to the output even if undefined or required
                        value = source[field];
                        // only emit this field if the value is defined
                        if (value !== undefined) output[field] = value;
                    }
                });
                delete source[circularReferenceCheck];
                return output;
            }
            function _serializeArray(sources, name) {
                var output;
                if (!!sources) {
                    if (!(0, $erRAP.isArray)(sources)) (0, $8z2Gd._throwInternal)(logger, 1 /* eLoggingSeverity.CRITICAL */ , 54 /* _eInternalMessageId.ItemNotInArray */ , "This field was specified as an array in the contract but the item is not an array.\r\n", {
                        name: name
                    }, true);
                    else {
                        output = [];
                        for(var i = 0; i < sources[0, $d7IsH._DYN_LENGTH /* @min:%2elength */ ]; i++){
                            var source = sources[i];
                            var item = _serializeObject(source, name + "[" + i + "]");
                            output[0, $d7IsH._DYN_PUSH /* @min:%2epush */ ](item);
                        }
                    }
                }
                return output;
            }
            function _serializeStringMap(map, expectedType, name) {
                var output;
                if (map) {
                    output = {};
                    (0, $erRAP.objForEachKey)(map, function(field, value) {
                        if (expectedType === "string") {
                            if (value === undefined) output[field] = "undefined";
                            else if (value === null) output[field] = "null";
                            else if (!value[0, $d7IsH._DYN_TO_STRING /* @min:%2etoString */ ]) output[field] = "invalid field: toString() is not defined.";
                            else output[field] = value[0, $d7IsH._DYN_TO_STRING /* @min:%2etoString */ ]();
                        } else if (expectedType === "number") {
                            if (value === undefined) output[field] = "undefined";
                            else if (value === null) output[field] = "null";
                            else {
                                var num = parseFloat(value);
                                if (isNaN(num)) output[field] = "NaN";
                                else output[field] = num;
                            }
                        } else {
                            output[field] = "invalid field: " + name + " is of unknown type.";
                            (0, $8z2Gd._throwInternal)(logger, 1 /* eLoggingSeverity.CRITICAL */ , output[field], null, true);
                        }
                    });
                }
                return output;
            }
        });
    }
    // Removed Stub for Serializer.prototype.serialize.
    // This is a workaround for an IE8 bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    // this will be removed when ES3 support is dropped.
    Serializer.__ieDyn = 1;
    return Serializer;
}();

});

parcelRegister("k9aAC", function(module, exports) {

$parcel$export(module.exports, "Sample", function () { return $eaacdcc943719023$export$21a3eccb8a1780eb; });
/*
 * Application Insights JavaScript SDK - Channel, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $ihDSn = parcelRequire("ihDSn");

var $8z2Gd = parcelRequire("8z2Gd");

var $d7IsH = parcelRequire("d7IsH");

var $lhh1g = parcelRequire("lhh1g");
var $eaacdcc943719023$export$21a3eccb8a1780eb = /** @class */ function() {
    function Sample(sampleRate, logger) {
        // We're using 32 bit math, hence max value is (2^31 - 1)
        this.INT_MAX_VALUE = 2147483647;
        var _logger = logger || (0, $8z2Gd.safeGetLogger)(null);
        if (sampleRate > 100 || sampleRate < 0) {
            _logger.throwInternal(2 /* eLoggingSeverity.WARNING */ , 58 /* _eInternalMessageId.SampleRateOutOfRange */ , "Sampling rate is out of range (0..100). Sampling will be disabled, you may be sending too much data which may affect your AI service level.", {
                samplingRate: sampleRate
            }, true);
            sampleRate = 100;
        }
        this[0, $d7IsH._DYN_SAMPLE_RATE /* @min:%2esampleRate */ ] = sampleRate;
        this.samplingScoreGenerator = new (0, $lhh1g.SamplingScoreGenerator)();
    }
    /**
    * Determines if an envelope is sampled in (i.e. will be sent) or not (i.e. will be dropped).
    */ Sample.prototype.isSampledIn = function(envelope) {
        var samplingPercentage = this[0, $d7IsH._DYN_SAMPLE_RATE /* @min:%2esampleRate */ ]; // 0 - 100
        var isSampledIn = false;
        if (samplingPercentage === null || samplingPercentage === undefined || samplingPercentage >= 100) return true;
        else if (envelope.baseType === (0, $ihDSn.Metric)[0, $d7IsH._DYN_DATA_TYPE /* @min:%2edataType */ ]) // exclude MetricData telemetry from sampling
        return true;
        isSampledIn = this.samplingScoreGenerator[0, $d7IsH._DYN_GET_SAMPLING_SCORE /* @min:%2egetSamplingScore */ ](envelope) < samplingPercentage;
        return isSampledIn;
    };
    return Sample;
}();

});
parcelRegister("lhh1g", function(module, exports) {

$parcel$export(module.exports, "SamplingScoreGenerator", function () { return $f7d86335f3d99384$export$4526db980ad5b8a1; });
/*
 * Application Insights JavaScript SDK - Channel, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $gygzP = parcelRequire("gygzP");

var $d7IsH = parcelRequire("d7IsH");

var $kA8VC = parcelRequire("kA8VC");
var $f7d86335f3d99384$export$4526db980ad5b8a1 = /** @class */ function() {
    function SamplingScoreGenerator() {
        var _self = this;
        var hashCodeGenerator = new (0, $kA8VC.HashCodeScoreGenerator)();
        var keys = new (0, $gygzP.ContextTagKeys)();
        _self[0, $d7IsH._DYN_GET_SAMPLING_SCORE /* @min:%2egetSamplingScore */ ] = function(item) {
            var score = 0;
            if (item[0, $d7IsH._DYN_TAGS /* @min:%2etags */ ] && item[0, $d7IsH._DYN_TAGS /* @min:%2etags */ ][keys.userId]) score = hashCodeGenerator.getHashCodeScore(item[0, $d7IsH._DYN_TAGS /* @min:%2etags */ ][keys.userId]);
            else if (item.ext && item.ext.user && item.ext.user.id) score = hashCodeGenerator[0, $d7IsH._DYN_GET_HASH_CODE_SCORE /* @min:%2egetHashCodeScore */ ](item.ext.user.id);
            else if (item[0, $d7IsH._DYN_TAGS /* @min:%2etags */ ] && item[0, $d7IsH._DYN_TAGS /* @min:%2etags */ ][keys.operationId]) score = hashCodeGenerator.getHashCodeScore(item[0, $d7IsH._DYN_TAGS /* @min:%2etags */ ][keys.operationId]);
            else if (item.ext && item.ext.telemetryTrace && item.ext.telemetryTrace[0, $d7IsH._DYN_TRACE_ID /* @min:%2etraceID */ ]) score = hashCodeGenerator.getHashCodeScore(item.ext.telemetryTrace[0, $d7IsH._DYN_TRACE_ID /* @min:%2etraceID */ ]);
            else // tslint:disable-next-line:insecure-random
            score = Math.random() * 100;
            return score;
        };
    }
    return SamplingScoreGenerator;
}();

});
parcelRegister("kA8VC", function(module, exports) {

$parcel$export(module.exports, "HashCodeScoreGenerator", function () { return $efbe186e30fab5e9$export$e2bdf7ff70742e42; });
/*
 * Application Insights JavaScript SDK - Channel, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $d7IsH = parcelRequire("d7IsH");
// (Magic number) DJB algorithm can't work on shorter strings (results in poor distribution
var $efbe186e30fab5e9$var$MIN_INPUT_LENGTH = 8;
var $efbe186e30fab5e9$export$e2bdf7ff70742e42 = /** @class */ function() {
    function HashCodeScoreGenerator() {}
    HashCodeScoreGenerator.prototype.getHashCodeScore = function(key) {
        var score = this.getHashCode(key) / HashCodeScoreGenerator.INT_MAX_VALUE;
        return score * 100;
    };
    HashCodeScoreGenerator.prototype.getHashCode = function(input) {
        if (input === "") return 0;
        while(input[0, $d7IsH._DYN_LENGTH /* @min:%2elength */ ] < $efbe186e30fab5e9$var$MIN_INPUT_LENGTH)input = input.concat(input);
        // 5381 is a magic number: http://stackoverflow.com/questions/10696223/reason-for-5381-number-in-djb-hash-function
        var hash = 5381;
        for(var i = 0; i < input[0, $d7IsH._DYN_LENGTH /* @min:%2elength */ ]; ++i){
            hash = (hash << 5) + hash + input.charCodeAt(i);
            // 'hash' is of number type which means 53 bit integer (http://www.ecma-international.org/ecma-262/6.0/#sec-ecmascript-language-types-number-type)
            // 'hash & hash' will keep it 32 bit integer - just to make it clearer what the result is.
            hash = hash & hash;
        }
        return Math.abs(hash);
    };
    // We're using 32 bit math, hence max value is (2^31 - 1)
    HashCodeScoreGenerator.INT_MAX_VALUE = 2147483647;
    return HashCodeScoreGenerator;
}();

});




parcelRegister("ghxFc", function(module, exports) {

$parcel$export(module.exports, "AppInsightsCore", function () { return $bda858be1d187a3d$export$e7ac25a6828d23bf; });
/*
 * Application Insights JavaScript SDK - Core, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $fcMe7 = parcelRequire("fcMe7");

var $kbmky = parcelRequire("kbmky");

var $fX4fx = parcelRequire("fX4fx");

var $iWFkf = parcelRequire("iWFkf");

var $8z2Gd = parcelRequire("8z2Gd");

var $erRAP = parcelRequire("erRAP");

var $lxIpo = parcelRequire("lxIpo");

var $01RZI = parcelRequire("01RZI");

var $kBiyL = parcelRequire("kBiyL");
var $bda858be1d187a3d$export$e7ac25a6828d23bf = /** @class */ function(_super) {
    (0, $fcMe7.__extendsFn)(AppInsightsCore, _super);
    function AppInsightsCore() {
        var _this = _super.call(this) || this;
        (0, $kbmky.default)(AppInsightsCore, _this, function(_self, _base) {
            _self[0, $fX4fx._DYN_INITIALIZE /* @min:%2einitialize */ ] = function(config, extensions, logger, notificationManager) {
                _base[0, $fX4fx._DYN_INITIALIZE /* @min:%2einitialize */ ](config, extensions, logger || new (0, $8z2Gd.DiagnosticLogger)(config), notificationManager || new (0, $01RZI.NotificationManager)(config));
            };
            _self.track = function(telemetryItem) {
                (0, $kBiyL.doPerf)(_self[0, $lxIpo.STR_GET_PERF_MGR /* @min:%2egetPerfMgr */ ](), function() {
                    return "AppInsightsCore:track";
                }, function() {
                    if (telemetryItem === null) {
                        _notifyInvalidEvent(telemetryItem);
                        // throw error
                        (0, $erRAP.throwError)("Invalid telemetry item");
                    }
                    // do basic validation before sending it through the pipeline
                    _validateTelemetryItem(telemetryItem);
                    _base.track(telemetryItem);
                }, function() {
                    return {
                        item: telemetryItem
                    };
                }, !telemetryItem.sync);
            };
            function _validateTelemetryItem(telemetryItem) {
                if ((0, $erRAP.isNullOrUndefined)(telemetryItem[0, $fX4fx._DYN_NAME /* @min:%2ename */ ])) {
                    _notifyInvalidEvent(telemetryItem);
                    (0, $erRAP.throwError)("telemetry name required");
                }
            }
            function _notifyInvalidEvent(telemetryItem) {
                var manager = _self[0, $fX4fx._DYN_GET_NOTIFY_MGR /* @min:%2egetNotifyMgr */ ]();
                if (manager) manager[0, $lxIpo.STR_EVENTS_DISCARDED /* @min:%2eeventsDiscarded */ ]([
                    telemetryItem
                ], 2 /* eEventsDiscardedReason.InvalidEvent */ );
            }
        });
        return _this;
    }
    // Removed Stub for AppInsightsCore.prototype.initialize.
    // Removed Stub for AppInsightsCore.prototype.track.
    // This is a workaround for an IE8 bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    // this will be removed when ES3 support is dropped.
    AppInsightsCore.__ieDyn = 1;
    return AppInsightsCore;
}((0, $iWFkf.BaseCore));

});
parcelRegister("iWFkf", function(module, exports) {

$parcel$export(module.exports, "BaseCore", function () { return $dcadb327c884eb85$export$21d040fe824fa2f5; });
/*
 * Application Insights JavaScript SDK - Core, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $fcMe7 = parcelRequire("fcMe7");
var $gSD6i = parcelRequire("gSD6i");

var $kbmky = parcelRequire("kbmky");

var $fX4fx = parcelRequire("fX4fx");

var $lTu84 = parcelRequire("lTu84");

var $31Ks8 = parcelRequire("31Ks8");

var $2w0XY = parcelRequire("2w0XY");

var $hY07A = parcelRequire("hY07A");

var $8z2Gd = parcelRequire("8z2Gd");

var $erRAP = parcelRequire("erRAP");

var $lxIpo = parcelRequire("lxIpo");

var $kBiyL = parcelRequire("kBiyL");

var $kry7o = parcelRequire("kry7o");

var $Vt75T = parcelRequire("Vt75T");

var $77O10 = parcelRequire("77O10");

var $f3Boy = parcelRequire("f3Boy");
"use strict";
var $dcadb327c884eb85$var$strValidationError = "Plugins must provide initialize method";
var $dcadb327c884eb85$var$strNotificationManager = "_notificationManager";
var $dcadb327c884eb85$var$strSdkUnloadingError = "SDK is still unloading...";
var $dcadb327c884eb85$var$strSdkNotInitialized = "SDK is not initialized";
// const strPluginUnloadFailed = "Failed to unload plugin";
var $dcadb327c884eb85$var$defaultInitConfig = {
    // Have the Diagnostic Logger default to log critical errors to the console
    loggingLevelConsole: 1 /* eLoggingSeverity.CRITICAL */ 
};
/**
 * Helper to create the default performance manager
 * @param core
 * @param notificationMgr
 */ function $dcadb327c884eb85$var$_createPerfManager(core, notificationMgr) {
    return new (0, $kBiyL.PerfManager)(notificationMgr);
}
function $dcadb327c884eb85$var$_validateExtensions(logger, channelPriority, allExtensions) {
    var _a;
    // Concat all available extensions
    var coreExtensions = [];
    // Check if any two extensions have the same priority, then warn to console
    // And extract the local extensions from the
    var extPriorities = {};
    // Extension validation
    (0, $erRAP.arrForEach)(allExtensions, function(ext) {
        // Check for ext.initialize
        if ((0, $erRAP.isNullOrUndefined)(ext) || (0, $erRAP.isNullOrUndefined)(ext[0, $fX4fx._DYN_INITIALIZE /* @min:%2einitialize */ ])) (0, $erRAP.throwError)($dcadb327c884eb85$var$strValidationError);
        var extPriority = ext[0, $lxIpo.STR_PRIORITY /* @min:%2epriority */ ];
        var identifier = ext[0, $fX4fx._DYN_IDENTIFIER /* @min:%2eidentifier */ ];
        if (ext && extPriority) {
            if (!(0, $erRAP.isNullOrUndefined)(extPriorities[extPriority])) (0, $8z2Gd._warnToConsole)(logger, "Two extensions have same priority #" + extPriority + " - " + extPriorities[extPriority] + ", " + identifier);
            else // set a value
            extPriorities[extPriority] = identifier;
        }
        // Split extensions to core and channelController
        if (!extPriority || extPriority < channelPriority) // Add to core extension that will be managed by BaseCore
        coreExtensions[0, $fX4fx._DYN_PUSH /* @min:%2epush */ ](ext);
    });
    return _a = {
        all: allExtensions
    }, _a[0, $lxIpo.STR_CORE /* @min:core */ ] = coreExtensions, _a;
}
function $dcadb327c884eb85$var$_isPluginPresent(thePlugin, plugins) {
    var exists = false;
    (0, $erRAP.arrForEach)(plugins, function(plugin) {
        if (plugin === thePlugin) {
            exists = true;
            return -1;
        }
    });
    return exists;
}
function $dcadb327c884eb85$var$_createDummyNotificationManager() {
    var _a;
    return (0, $gSD6i.objCreateFn)((_a = {}, _a[0, $fX4fx._DYN_ADD_NOTIFICATION_LIS1 /* @min:addNotificationListener */ ] = function(listener) {}, _a[0, $fX4fx._DYN_REMOVE_NOTIFICATION_2 /* @min:removeNotificationListener */ ] = function(listener) {}, _a[0, $lxIpo.STR_EVENTS_SENT /* @min:eventsSent */ ] = function(events) {}, _a[0, $lxIpo.STR_EVENTS_DISCARDED /* @min:eventsDiscarded */ ] = function(events, reason) {}, _a[0, $lxIpo.STR_EVENTS_SEND_REQUEST /* @min:eventsSendRequest */ ] = function(sendReason, isAsync) {}, _a));
}
var $dcadb327c884eb85$export$21d040fe824fa2f5 = /** @class */ function() {
    function BaseCore() {
        // NOTE!: DON'T set default values here, instead set them in the _initDefaults() function as it is also called during teardown()
        var _config;
        var _isInitialized;
        var _eventQueue;
        var _notificationManager;
        var _perfManager;
        var _cfgPerfManager;
        var _cookieManager;
        var _pluginChain;
        var _configExtensions;
        var _coreExtensions;
        var _channelControl;
        var _channelConfig;
        var _channelQueue;
        var _isUnloading;
        var _telemetryInitializerPlugin;
        var _internalLogsEventName;
        var _evtNamespace;
        var _unloadHandlers;
        var _debugListener;
        var _traceCtx;
        /**
         * Internal log poller
         */ var _internalLogPoller = 0;
        var _forceStopInternalLogPoller = false;
        (0, $kbmky.default)(BaseCore, this, function(_self) {
            // Set the default values (also called during teardown)
            _initDefaults();
            _self[0, $fX4fx._DYN_IS_INITIALIZED /* @min:%2eisInitialized */ ] = function() {
                return _isInitialized;
            };
            // Creating the self.initialize = ()
            _self[0, $fX4fx._DYN_INITIALIZE /* @min:%2einitialize */ ] = function(config, extensions, logger, notificationManager) {
                if (_isUnloading) (0, $erRAP.throwError)($dcadb327c884eb85$var$strSdkUnloadingError);
                // Make sure core is only initialized once
                if (_self[0, $fX4fx._DYN_IS_INITIALIZED /* @min:%2eisInitialized */ ]()) (0, $erRAP.throwError)("Core should not be initialized more than once");
                _config = config || {};
                _self[0, $fX4fx._DYN_CONFIG /* @min:%2econfig */ ] = _config;
                if ((0, $erRAP.isNullOrUndefined)(config[0, $fX4fx._DYN_INSTRUMENTATION_KEY /* @min:%2einstrumentationKey */ ])) (0, $erRAP.throwError)("Please provide instrumentation key");
                _notificationManager = notificationManager;
                // For backward compatibility only
                _self[$dcadb327c884eb85$var$strNotificationManager] = notificationManager;
                _initDebugListener();
                _initPerfManager();
                // add notification to the extensions in the config so other plugins can access it
                _initExtConfig();
                if (logger) _self[0, $fX4fx._DYN_LOGGER /* @min:%2elogger */ ] = logger;
                var cfgExtensions = (0, $erRAP.getSetValue)(_config, (0, $lxIpo.STR_EXTENSIONS), []);
                // Extension validation
                _configExtensions = [];
                _configExtensions[0, $fX4fx._DYN_PUSH /* @min:%2epush */ ].apply(_configExtensions, (0, $fcMe7.__spreadArrayFn)((0, $fcMe7.__spreadArrayFn)([], extensions, false), cfgExtensions, false));
                _channelConfig = (0, $erRAP.getSetValue)(_config, (0, $lxIpo.STR_CHANNELS), []);
                _initPluginChain(null);
                if (!_channelQueue || _channelQueue[0, $fX4fx._DYN_LENGTH /* @min:%2elength */ ] === 0) (0, $erRAP.throwError)("No " + (0, $lxIpo.STR_CHANNELS) + " available");
                _isInitialized = true;
                _self.releaseQueue();
            };
            _self.getTransmissionControls = function() {
                var controls = [];
                if (_channelQueue) (0, $erRAP.arrForEach)(_channelQueue, function(channels) {
                    controls[0, $fX4fx._DYN_PUSH /* @min:%2epush */ ](channels.queue);
                });
                return (0, $erRAP.objFreeze)(controls);
            };
            _self.track = function(telemetryItem) {
                // setup default iKey if not passed in
                telemetryItem.iKey = telemetryItem.iKey || _config[0, $fX4fx._DYN_INSTRUMENTATION_KEY /* @min:%2einstrumentationKey */ ];
                // add default timestamp if not passed in
                telemetryItem[0, $fX4fx._DYN_TIME /* @min:%2etime */ ] = telemetryItem[0, $fX4fx._DYN_TIME /* @min:%2etime */ ] || (0, $erRAP.toISOString)(new Date());
                // Common Schema 4.0
                telemetryItem.ver = telemetryItem.ver || "4.0";
                if (!_isUnloading && _self[0, $fX4fx._DYN_IS_INITIALIZED /* @min:%2eisInitialized */ ]()) // Process the telemetry plugin chain
                _createTelCtx()[0, $fX4fx._DYN_PROCESS_NEXT /* @min:%2eprocessNext */ ](telemetryItem);
                else // Queue events until all extensions are initialized
                _eventQueue[0, $fX4fx._DYN_PUSH /* @min:%2epush */ ](telemetryItem);
            };
            _self[0, $fX4fx._DYN_GET_PROCESS_TEL_CONT0 /* @min:%2egetProcessTelContext */ ] = _createTelCtx;
            _self[0, $fX4fx._DYN_GET_NOTIFY_MGR /* @min:%2egetNotifyMgr */ ] = function() {
                if (!_notificationManager) {
                    // Create Dummy notification manager
                    _notificationManager = $dcadb327c884eb85$var$_createDummyNotificationManager();
                    // For backward compatibility only
                    _self[$dcadb327c884eb85$var$strNotificationManager] = _notificationManager;
                }
                return _notificationManager;
            };
            /**
             * Adds a notification listener. The SDK calls methods on the listener when an appropriate notification is raised.
             * The added plugins must raise notifications. If the plugins do not implement the notifications, then no methods will be
             * called.
             * @param {INotificationListener} listener - An INotificationListener object.
             */ _self[0, $fX4fx._DYN_ADD_NOTIFICATION_LIS1 /* @min:%2eaddNotificationListener */ ] = function(listener) {
                if (_notificationManager) _notificationManager[0, $fX4fx._DYN_ADD_NOTIFICATION_LIS1 /* @min:%2eaddNotificationListener */ ](listener);
            };
            /**
             * Removes all instances of the listener.
             * @param {INotificationListener} listener - INotificationListener to remove.
             */ _self[0, $fX4fx._DYN_REMOVE_NOTIFICATION_2 /* @min:%2eremoveNotificationListener */ ] = function(listener) {
                if (_notificationManager) _notificationManager[0, $fX4fx._DYN_REMOVE_NOTIFICATION_2 /* @min:%2eremoveNotificationListener */ ](listener);
            };
            _self.getCookieMgr = function() {
                if (!_cookieManager) _cookieManager = (0, $31Ks8.createCookieMgr)(_config, _self[0, $fX4fx._DYN_LOGGER /* @min:%2elogger */ ]);
                return _cookieManager;
            };
            _self.setCookieMgr = function(cookieMgr) {
                _cookieManager = cookieMgr;
            };
            _self[0, $lxIpo.STR_GET_PERF_MGR /* @min:%2egetPerfMgr */ ] = function() {
                if (!_perfManager && !_cfgPerfManager) {
                    if ((0, $erRAP.getCfgValue)(_config.enablePerfMgr)) {
                        var createPerfMgr = (0, $erRAP.getCfgValue)(_config[0, $lxIpo.STR_CREATE_PERF_MGR /* @min:%2ecreatePerfMgr */ ]);
                        if ((0, $erRAP.isFunction)(createPerfMgr)) _cfgPerfManager = createPerfMgr(_self, _self[0, $fX4fx._DYN_GET_NOTIFY_MGR /* @min:%2egetNotifyMgr */ ]());
                    }
                }
                return _perfManager || _cfgPerfManager || (0, $kBiyL.getGblPerfMgr)();
            };
            _self.setPerfMgr = function(perfMgr) {
                _perfManager = perfMgr;
            };
            _self.eventCnt = function() {
                return _eventQueue[0, $fX4fx._DYN_LENGTH /* @min:%2elength */ ];
            };
            _self.releaseQueue = function() {
                if (_isInitialized && _eventQueue[0, $fX4fx._DYN_LENGTH /* @min:%2elength */ ] > 0) {
                    var eventQueue = _eventQueue;
                    _eventQueue = [];
                    (0, $erRAP.arrForEach)(eventQueue, function(event) {
                        _createTelCtx()[0, $fX4fx._DYN_PROCESS_NEXT /* @min:%2eprocessNext */ ](event);
                    });
                }
            };
            _self.pollInternalLogs = function(eventName) {
                _internalLogsEventName = eventName || null;
                _forceStopInternalLogPoller = false;
                if (_internalLogPoller) {
                    clearInterval(_internalLogPoller);
                    _internalLogPoller = null;
                }
                return _startInternalLogTimer(true);
            };
            function _startInternalLogTimer(alwaysStart) {
                if (!_internalLogPoller && !_forceStopInternalLogPoller) {
                    var shouldStart = alwaysStart || _self[0, $fX4fx._DYN_LOGGER /* @min:%2elogger */ ] && _self[0, $fX4fx._DYN_LOGGER /* @min:%2elogger */ ].queue[0, $fX4fx._DYN_LENGTH /* @min:%2elength */ ] > 0;
                    if (shouldStart) {
                        var interval = (0, $erRAP.getCfgValue)(_config.diagnosticLogInterval);
                        if (!interval || !(interval > 0)) interval = 10000;
                        // Keeping as an interval timer for backward compatibility as it returns the result
                        _internalLogPoller = setInterval(function() {
                            clearInterval(_internalLogPoller);
                            _internalLogPoller = 0;
                            _flushInternalLogs();
                        }, interval);
                    }
                }
                return _internalLogPoller;
            }
            _self[0, $fX4fx._DYN_STOP_POLLING_INTERNA3 /* @min:%2estopPollingInternalLogs */ ] = function() {
                _forceStopInternalLogPoller = true;
                if (_internalLogPoller) {
                    clearInterval(_internalLogPoller);
                    _internalLogPoller = 0;
                    _flushInternalLogs();
                }
            };
            // Add addTelemetryInitializer
            (0, $erRAP.proxyFunctions)(_self, function() {
                return _telemetryInitializerPlugin;
            }, [
                "addTelemetryInitializer"
            ]);
            _self.unload = function(isAsync, unloadComplete, cbTimeout) {
                var _a;
                if (isAsync === void 0) isAsync = true;
                if (!_isInitialized) // The SDK is not initialized
                (0, $erRAP.throwError)($dcadb327c884eb85$var$strSdkNotInitialized);
                // Check if the SDK still unloading so throw
                if (_isUnloading) // The SDK is already unloading
                (0, $erRAP.throwError)($dcadb327c884eb85$var$strSdkUnloadingError);
                var unloadState = (_a = {
                    reason: 50 /* TelemetryUnloadReason.SdkUnload */ 
                }, _a[0, $fX4fx._DYN_IS_ASYNC /* @min:isAsync */ ] = isAsync, _a.flushComplete = false, _a);
                var processUnloadCtx = (0, $kry7o.createProcessTelemetryUnloadContext)(_getPluginChain(), _self);
                processUnloadCtx[0, $fX4fx._DYN_ON_COMPLETE /* @min:%2eonComplete */ ](function() {
                    _initDefaults();
                    unloadComplete && unloadComplete(unloadState);
                }, _self);
                function _doUnload(flushComplete) {
                    unloadState.flushComplete = flushComplete;
                    _isUnloading = true;
                    // Run all of the unload handlers first (before unloading the plugins)
                    _unloadHandlers.run(processUnloadCtx, unloadState);
                    // Stop polling the internal logs
                    _self[0, $fX4fx._DYN_STOP_POLLING_INTERNA3 /* @min:%2estopPollingInternalLogs */ ]();
                    // Start unloading the components, from this point onwards the SDK should be considered to be in an unstable state
                    processUnloadCtx[0, $fX4fx._DYN_PROCESS_NEXT /* @min:%2eprocessNext */ ](unloadState);
                }
                _flushInternalLogs();
                if (!_flushChannels(isAsync, _doUnload, 6 /* SendRequestReason.SdkUnload */ , cbTimeout)) _doUnload(false);
            };
            _self[0, $fX4fx._DYN_GET_PLUGIN /* @min:%2egetPlugin */ ] = _getPlugin;
            _self.addPlugin = function(plugin, replaceExisting, isAsync, addCb) {
                if (!plugin) {
                    addCb && addCb(false);
                    _logOrThrowError($dcadb327c884eb85$var$strValidationError);
                    return;
                }
                var existingPlugin = _getPlugin(plugin[0, $fX4fx._DYN_IDENTIFIER /* @min:%2eidentifier */ ]);
                if (existingPlugin && !replaceExisting) {
                    addCb && addCb(false);
                    _logOrThrowError("Plugin [" + plugin[0, $fX4fx._DYN_IDENTIFIER /* @min:%2eidentifier */ ] + "] is already loaded!");
                    return;
                }
                var updateState = {
                    reason: 16 /* TelemetryUpdateReason.PluginAdded */ 
                };
                function _addPlugin(removed) {
                    _configExtensions[0, $fX4fx._DYN_PUSH /* @min:%2epush */ ](plugin);
                    updateState.added = [
                        plugin
                    ];
                    // Re-Initialize the plugin chain
                    _initPluginChain(updateState);
                    addCb && addCb(true);
                }
                if (existingPlugin) {
                    var removedPlugins_1 = [
                        existingPlugin.plugin
                    ];
                    var unloadState = {
                        reason: 2 /* TelemetryUnloadReason.PluginReplace */ ,
                        isAsync: !!isAsync
                    };
                    _removePlugins(removedPlugins_1, unloadState, function(removed) {
                        if (!removed) // Previous plugin was successfully removed or was not installed
                        addCb && addCb(false);
                        else {
                            updateState.removed = removedPlugins_1;
                            updateState.reason |= 32 /* TelemetryUpdateReason.PluginRemoved */ ;
                            _addPlugin(true);
                        }
                    });
                } else _addPlugin(false);
            };
            _self.evtNamespace = function() {
                return _evtNamespace;
            };
            _self[0, $fX4fx._DYN_FLUSH /* @min:%2eflush */ ] = _flushChannels;
            _self.getTraceCtx = function(createNew) {
                if (!_traceCtx) _traceCtx = (0, $Vt75T.createDistributedTraceContext)();
                return _traceCtx;
            };
            _self.setTraceCtx = function(traceCtx) {
                _traceCtx = traceCtx || null;
            };
            // Create the addUnloadCb
            (0, $erRAP.proxyFunctionAs)(_self, "addUnloadCb", function() {
                return _unloadHandlers;
            }, "add");
            function _initDefaults() {
                _isInitialized = false;
                // Use a default logger so initialization errors are not dropped on the floor with full logging
                _config = (0, $erRAP.objExtend)(true, {}, $dcadb327c884eb85$var$defaultInitConfig);
                _self[0, $fX4fx._DYN_CONFIG /* @min:%2econfig */ ] = _config;
                _self[0, $fX4fx._DYN_LOGGER /* @min:%2elogger */ ] = new (0, $8z2Gd.DiagnosticLogger)(_config);
                _self[0, $fX4fx._DYN__EXTENSIONS /* @min:%2e_extensions */ ] = [];
                _telemetryInitializerPlugin = new (0, $77O10.TelemetryInitializerPlugin)();
                _eventQueue = [];
                _notificationManager = null;
                _perfManager = null;
                _cfgPerfManager = null;
                _cookieManager = null;
                _pluginChain = null;
                _coreExtensions = null;
                _configExtensions = [];
                _channelControl = null;
                _channelConfig = null;
                _channelQueue = null;
                _isUnloading = false;
                _internalLogsEventName = null;
                _evtNamespace = (0, $2w0XY.createUniqueNamespace)("AIBaseCore", true);
                _unloadHandlers = (0, $f3Boy.createUnloadHandlerContainer)();
                _traceCtx = null;
            }
            function _createTelCtx() {
                var theCtx = (0, $kry7o.createProcessTelemetryContext)(_getPluginChain(), _config, _self);
                theCtx[0, $fX4fx._DYN_ON_COMPLETE /* @min:%2eonComplete */ ](_startInternalLogTimer);
                return theCtx;
            }
            // Initialize or Re-initialize the plugins
            function _initPluginChain(updateState) {
                // Extension validation
                var theExtensions = $dcadb327c884eb85$var$_validateExtensions(_self[0, $fX4fx._DYN_LOGGER /* @min:%2elogger */ ], (0, $lTu84.ChannelControllerPriority), _configExtensions);
                _coreExtensions = theExtensions[0, $lxIpo.STR_CORE /* @min:%2ecore */ ];
                _pluginChain = null;
                // Sort the complete set of extensions by priority
                var allExtensions = theExtensions.all;
                // Initialize the Channel Queues and the channel plugins first
                _channelQueue = (0, $erRAP.objFreeze)((0, $lTu84.createChannelQueues)(_channelConfig, allExtensions, _self));
                if (_channelControl) {
                    // During add / remove of a plugin this may get called again, so don't re-add if already present
                    // But we also want the controller as the last, so remove if already present
                    // And reusing the existing instance, just in case an installed plugin has a reference and
                    // is using it.
                    var idx = (0, $erRAP.arrIndexOf)(allExtensions, _channelControl);
                    if (idx !== -1) allExtensions[0, $fX4fx._DYN_SPLICE /* @min:%2esplice */ ](idx, 1);
                    idx = (0, $erRAP.arrIndexOf)(_coreExtensions, _channelControl);
                    if (idx !== -1) _coreExtensions[0, $fX4fx._DYN_SPLICE /* @min:%2esplice */ ](idx, 1);
                    _channelControl._setQueue(_channelQueue);
                } else _channelControl = (0, $lTu84.createChannelControllerPlugin)(_channelQueue, _self);
                // Add on "channelController" as the last "plugin"
                allExtensions[0, $fX4fx._DYN_PUSH /* @min:%2epush */ ](_channelControl);
                _coreExtensions[0, $fX4fx._DYN_PUSH /* @min:%2epush */ ](_channelControl);
                // Required to allow plugins to call core.getPlugin() during their own initialization
                _self[0, $fX4fx._DYN__EXTENSIONS /* @min:%2e_extensions */ ] = (0, $Vt75T.sortPlugins)(allExtensions);
                // Initialize the controls
                _channelControl[0, $fX4fx._DYN_INITIALIZE /* @min:%2einitialize */ ](_config, _self, allExtensions);
                var initCtx = _createTelCtx();
                (0, $Vt75T.initializePlugins)(initCtx, allExtensions);
                // Now reset the extensions to just those being managed by Basecore
                _self[0, $fX4fx._DYN__EXTENSIONS /* @min:%2e_extensions */ ] = (0, $erRAP.objFreeze)((0, $Vt75T.sortPlugins)(_coreExtensions || [])).slice();
                if (updateState) _doUpdate(updateState);
            }
            function _getPlugin(pluginIdentifier) {
                var _a;
                var theExt = null;
                var thePlugin = null;
                (0, $erRAP.arrForEach)(_self[0, $fX4fx._DYN__EXTENSIONS /* @min:%2e_extensions */ ], function(ext) {
                    if (ext[0, $fX4fx._DYN_IDENTIFIER /* @min:%2eidentifier */ ] === pluginIdentifier && ext !== _channelControl && ext !== _telemetryInitializerPlugin) {
                        thePlugin = ext;
                        return -1;
                    }
                });
                if (!thePlugin && _channelControl) // Check the channel Controller
                thePlugin = _channelControl.getChannel(pluginIdentifier);
                if (thePlugin) theExt = (_a = {
                    plugin: thePlugin
                }, _a[0, $fX4fx._DYN_SET_ENABLED /* @min:setEnabled */ ] = function(enabled) {
                    (0, $Vt75T._getPluginState)(thePlugin)[0, $lxIpo.STR_DISABLED] = !enabled;
                }, _a.isEnabled = function() {
                    var pluginState = (0, $Vt75T._getPluginState)(thePlugin);
                    return !pluginState[0, $fX4fx._DYN_TEARDOWN /* @min:%2eteardown */ ] && !pluginState[0, $lxIpo.STR_DISABLED];
                }, _a.remove = function(isAsync, removeCb) {
                    var _a;
                    if (isAsync === void 0) isAsync = true;
                    var pluginsToRemove = [
                        thePlugin
                    ];
                    var unloadState = (_a = {
                        reason: 1 /* TelemetryUnloadReason.PluginUnload */ 
                    }, _a[0, $fX4fx._DYN_IS_ASYNC /* @min:isAsync */ ] = isAsync, _a);
                    _removePlugins(pluginsToRemove, unloadState, function(removed) {
                        if (removed) // Re-Initialize the plugin chain
                        _initPluginChain({
                            reason: 32 /* TelemetryUpdateReason.PluginRemoved */ ,
                            removed: pluginsToRemove
                        });
                        removeCb && removeCb(removed);
                    });
                }, _a);
                return theExt;
            }
            function _getPluginChain() {
                if (!_pluginChain) {
                    // copy the collection of extensions
                    var extensions = (_coreExtensions || []).slice();
                    // During add / remove this may get called again, so don't readd if already present
                    if ((0, $erRAP.arrIndexOf)(extensions, _telemetryInitializerPlugin) === -1) extensions[0, $fX4fx._DYN_PUSH /* @min:%2epush */ ](_telemetryInitializerPlugin);
                    _pluginChain = (0, $kry7o.createTelemetryProxyChain)((0, $Vt75T.sortPlugins)(extensions), _config, _self);
                }
                return _pluginChain;
            }
            function _removePlugins(thePlugins, unloadState, removeComplete) {
                if (thePlugins && thePlugins[0, $fX4fx._DYN_LENGTH /* @min:%2elength */ ] > 0) {
                    var unloadChain = (0, $kry7o.createTelemetryProxyChain)(thePlugins, _config, _self);
                    var unloadCtx = (0, $kry7o.createProcessTelemetryUnloadContext)(unloadChain, _self);
                    unloadCtx[0, $fX4fx._DYN_ON_COMPLETE /* @min:%2eonComplete */ ](function() {
                        var removed = false;
                        // Remove the listed config extensions
                        var newConfigExtensions = [];
                        (0, $erRAP.arrForEach)(_configExtensions, function(plugin, idx) {
                            if (!$dcadb327c884eb85$var$_isPluginPresent(plugin, thePlugins)) newConfigExtensions[0, $fX4fx._DYN_PUSH /* @min:%2epush */ ](plugin);
                            else removed = true;
                        });
                        _configExtensions = newConfigExtensions;
                        // Re-Create the channel config
                        var newChannelConfig = [];
                        if (_channelConfig) {
                            (0, $erRAP.arrForEach)(_channelConfig, function(queue, idx) {
                                var newQueue = [];
                                (0, $erRAP.arrForEach)(queue, function(channel) {
                                    if (!$dcadb327c884eb85$var$_isPluginPresent(channel, thePlugins)) newQueue[0, $fX4fx._DYN_PUSH /* @min:%2epush */ ](channel);
                                    else removed = true;
                                });
                                newChannelConfig[0, $fX4fx._DYN_PUSH /* @min:%2epush */ ](newQueue);
                            });
                            _channelConfig = newChannelConfig;
                        }
                        removeComplete && removeComplete(removed);
                        _startInternalLogTimer();
                    });
                    unloadCtx[0, $fX4fx._DYN_PROCESS_NEXT /* @min:%2eprocessNext */ ](unloadState);
                } else removeComplete(false);
            }
            function _flushInternalLogs() {
                if (_self[0, $fX4fx._DYN_LOGGER /* @min:%2elogger */ ] && _self[0, $fX4fx._DYN_LOGGER /* @min:%2elogger */ ].queue) {
                    var queue = _self[0, $fX4fx._DYN_LOGGER /* @min:%2elogger */ ].queue.slice(0);
                    _self[0, $fX4fx._DYN_LOGGER /* @min:%2elogger */ ].queue[0, $fX4fx._DYN_LENGTH /* @min:%2elength */ ] = 0;
                    (0, $erRAP.arrForEach)(queue, function(logMessage) {
                        var _a;
                        var item = (_a = {}, _a[0, $fX4fx._DYN_NAME /* @min:name */ ] = _internalLogsEventName ? _internalLogsEventName : "InternalMessageId: " + logMessage[0, $fX4fx._DYN_MESSAGE_ID /* @min:%2emessageId */ ], _a.iKey = (0, $erRAP.getCfgValue)(_config[0, $fX4fx._DYN_INSTRUMENTATION_KEY /* @min:%2einstrumentationKey */ ]), _a.time = (0, $erRAP.toISOString)(new Date()), _a.baseType = (0, $8z2Gd._InternalLogMessage).dataType, _a.baseData = {
                            message: logMessage[0, $fX4fx._DYN_MESSAGE /* @min:%2emessage */ ]
                        }, _a);
                        _self.track(item);
                    });
                }
            }
            function _flushChannels(isAsync, callBack, sendReason, cbTimeout) {
                if (_channelControl) return _channelControl[0, $fX4fx._DYN_FLUSH /* @min:%2eflush */ ](isAsync, callBack, sendReason || 6 /* SendRequestReason.SdkUnload */ , cbTimeout);
                callBack && callBack(false);
                return true;
            }
            function _initDebugListener() {
                var disableDbgExt = (0, $erRAP.getCfgValue)(_config.disableDbgExt);
                if (disableDbgExt === true && _debugListener) {
                    // Remove any previously loaded debug listener
                    _notificationManager[0, $fX4fx._DYN_REMOVE_NOTIFICATION_2 /* @min:%2eremoveNotificationListener */ ](_debugListener);
                    _debugListener = null;
                }
                if (_notificationManager && !_debugListener && disableDbgExt !== true) {
                    _debugListener = (0, $hY07A.getDebugListener)(_config);
                    _notificationManager[0, $fX4fx._DYN_ADD_NOTIFICATION_LIS1 /* @min:%2eaddNotificationListener */ ](_debugListener);
                }
            }
            function _initPerfManager() {
                var enablePerfMgr = (0, $erRAP.getCfgValue)(_config.enablePerfMgr);
                if (!enablePerfMgr && _cfgPerfManager) // Remove any existing config based performance manager
                _cfgPerfManager = null;
                if (enablePerfMgr) // Set the performance manager creation function if not defined
                (0, $erRAP.getSetValue)(_config, (0, $lxIpo.STR_CREATE_PERF_MGR), $dcadb327c884eb85$var$_createPerfManager);
            }
            function _initExtConfig() {
                var extConfig = (0, $erRAP.getSetValue)(_config, (0, $lxIpo.STR_EXTENSION_CONFIG), {});
                extConfig.NotificationManager = _notificationManager;
            }
            function _doUpdate(updateState) {
                var updateCtx = (0, $kry7o.createProcessTelemetryUpdateContext)(_getPluginChain(), _self);
                updateCtx[0, $fX4fx._DYN_ON_COMPLETE /* @min:%2eonComplete */ ](_startInternalLogTimer);
                if (!_self._updateHook || _self._updateHook(updateCtx, updateState) !== true) updateCtx[0, $fX4fx._DYN_PROCESS_NEXT /* @min:%2eprocessNext */ ](updateState);
            }
            function _logOrThrowError(message) {
                var logger = _self[0, $fX4fx._DYN_LOGGER /* @min:%2elogger */ ];
                if (logger) {
                    // there should always be a logger
                    (0, $8z2Gd._throwInternal)(logger, 2 /* eLoggingSeverity.WARNING */ , 73 /* _eInternalMessageId.PluginException */ , message);
                    _startInternalLogTimer();
                } else (0, $erRAP.throwError)(message);
            }
        });
    }
    // Removed Stub for BaseCore.prototype.initialize.
    // Removed Stub for BaseCore.prototype.getTransmissionControls.
    // Removed Stub for BaseCore.prototype.track.
    // Removed Stub for BaseCore.prototype.getProcessTelContext.
    // Removed Stub for BaseCore.prototype.getNotifyMgr.
    // Removed Stub for BaseCore.prototype.addNotificationListener.
    // Removed Stub for BaseCore.prototype.removeNotificationListener.
    // Removed Stub for BaseCore.prototype.getCookieMgr.
    // Removed Stub for BaseCore.prototype.setCookieMgr.
    // Removed Stub for BaseCore.prototype.getPerfMgr.
    // Removed Stub for BaseCore.prototype.setPerfMgr.
    // Removed Stub for BaseCore.prototype.eventCnt.
    // Removed Stub for BaseCore.prototype.pollInternalLogs.
    // Removed Stub for BaseCore.prototype.stopPollingInternalLogs.
    // Removed Stub for BaseCore.prototype.addTelemetryInitializer.
    // Removed Stub for BaseCore.prototype.unload.
    // Removed Stub for BaseCore.prototype.getPlugin.
    // Removed Stub for BaseCore.prototype.addPlugin.
    // Removed Stub for BaseCore.prototype.evtNamespace.
    // Removed Stub for BaseCore.prototype.addUnloadCb.
    // Removed Stub for BaseCore.prototype.flush.
    // Removed Stub for BaseCore.prototype.getTraceCtx.
    // Removed Stub for BaseCore.prototype.setTraceCtx.
    // Removed Stub for BaseCore.prototype.releaseQueue.
    // Removed Stub for BaseCore.prototype._updateHook.
    // This is a workaround for an IE8 bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    // this will be removed when ES3 support is dropped.
    BaseCore.__ieDyn = 1;
    return BaseCore;
}();

});
parcelRegister("lTu84", function(module, exports) {

$parcel$export(module.exports, "ChannelControllerPriority", function () { return $ff061b0ad2aa9992$export$a1373ad9f192f374; });
$parcel$export(module.exports, "createChannelControllerPlugin", function () { return $ff061b0ad2aa9992$export$7d61c45afab4719d; });
$parcel$export(module.exports, "createChannelQueues", function () { return $ff061b0ad2aa9992$export$9baa95a4af0f2d3; });
/*
 * Application Insights JavaScript SDK - Core, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ // 

var $fX4fx = parcelRequire("fX4fx");

var $erRAP = parcelRequire("erRAP");

var $lxIpo = parcelRequire("lxIpo");

var $kry7o = parcelRequire("kry7o");

var $Vt75T = parcelRequire("Vt75T");
var $ff061b0ad2aa9992$export$a1373ad9f192f374 = 500;
var $ff061b0ad2aa9992$var$ChannelValidationMessage = "Channel has invalid priority - ";
function $ff061b0ad2aa9992$var$_addChannelQueue(channelQueue, queue, core) {
    if (queue && (0, $erRAP.isArray)(queue) && queue[0, $fX4fx._DYN_LENGTH /* @min:%2elength */ ] > 0) {
        queue = queue.sort(function(a, b) {
            return a[0, $lxIpo.STR_PRIORITY /* @min:%2epriority */ ] - b[0, $lxIpo.STR_PRIORITY /* @min:%2epriority */ ];
        });
        (0, $erRAP.arrForEach)(queue, function(queueItem) {
            if (queueItem[0, $lxIpo.STR_PRIORITY /* @min:%2epriority */ ] < $ff061b0ad2aa9992$export$a1373ad9f192f374) (0, $erRAP.throwError)($ff061b0ad2aa9992$var$ChannelValidationMessage + queueItem[0, $fX4fx._DYN_IDENTIFIER /* @min:%2eidentifier */ ]);
        });
        channelQueue[0, $fX4fx._DYN_PUSH /* @min:%2epush */ ]({
            queue: (0, $erRAP.objFreeze)(queue),
            chain: (0, $kry7o.createTelemetryProxyChain)(queue, core[0, $fX4fx._DYN_CONFIG /* @min:%2econfig */ ], core)
        });
    }
}
function $ff061b0ad2aa9992$export$7d61c45afab4719d(channelQueue, core) {
    function _getTelCtx() {
        return (0, $kry7o.createProcessTelemetryContext)(null, core[0, $fX4fx._DYN_CONFIG /* @min:%2econfig */ ], core, null);
    }
    function _processChannelQueue(theChannels, itemCtx, processFn, onComplete) {
        var waiting = theChannels ? theChannels[0, $fX4fx._DYN_LENGTH /* @min:%2elength */ ] + 1 : 1;
        function _runChainOnComplete() {
            waiting--;
            if (waiting === 0) {
                onComplete && onComplete();
                onComplete = null;
            }
        }
        if (waiting > 0) (0, $erRAP.arrForEach)(theChannels, function(channels) {
            // pass on to first item in queue
            if (channels && channels.queue[0, $fX4fx._DYN_LENGTH /* @min:%2elength */ ] > 0) {
                var channelChain = channels.chain;
                var chainCtx = itemCtx[0, $fX4fx._DYN_CREATE_NEW /* @min:%2ecreateNew */ ](channelChain);
                chainCtx[0, $fX4fx._DYN_ON_COMPLETE /* @min:%2eonComplete */ ](_runChainOnComplete);
                // Cause this chain to start processing
                processFn(chainCtx);
            } else waiting--;
        });
        _runChainOnComplete();
    }
    function _doUpdate(updateCtx, updateState) {
        var theUpdateState = updateState || {
            reason: 0 /* TelemetryUpdateReason.Unknown */ 
        };
        _processChannelQueue(channelQueue, updateCtx, function(chainCtx) {
            chainCtx[0, $fX4fx._DYN_PROCESS_NEXT /* @min:%2eprocessNext */ ](theUpdateState);
        }, function() {
            updateCtx[0, $fX4fx._DYN_PROCESS_NEXT /* @min:%2eprocessNext */ ](theUpdateState);
        });
        return true;
    }
    function _doTeardown(unloadCtx, unloadState) {
        var theUnloadState = unloadState || {
            reason: 0 /* TelemetryUnloadReason.ManualTeardown */ ,
            isAsync: false
        };
        _processChannelQueue(channelQueue, unloadCtx, function(chainCtx) {
            chainCtx[0, $fX4fx._DYN_PROCESS_NEXT /* @min:%2eprocessNext */ ](theUnloadState);
        }, function() {
            unloadCtx[0, $fX4fx._DYN_PROCESS_NEXT /* @min:%2eprocessNext */ ](theUnloadState);
            isInitialized = false;
        });
        return true;
    }
    function _getChannel(pluginIdentifier) {
        var thePlugin = null;
        if (channelQueue && channelQueue[0, $fX4fx._DYN_LENGTH /* @min:%2elength */ ] > 0) (0, $erRAP.arrForEach)(channelQueue, function(channels) {
            // pass on to first item in queue
            if (channels && channels.queue[0, $fX4fx._DYN_LENGTH /* @min:%2elength */ ] > 0) {
                (0, $erRAP.arrForEach)(channels.queue, function(ext) {
                    if (ext[0, $fX4fx._DYN_IDENTIFIER /* @min:%2eidentifier */ ] === pluginIdentifier) {
                        thePlugin = ext;
                        // Cause arrForEach to stop iterating
                        return -1;
                    }
                });
                if (thePlugin) // Cause arrForEach to stop iterating
                return -1;
            }
        });
        return thePlugin;
    }
    var isInitialized = false;
    var channelController = {
        identifier: "ChannelControllerPlugin",
        priority: $ff061b0ad2aa9992$export$a1373ad9f192f374,
        initialize: function(config, core, extensions, pluginChain) {
            isInitialized = true;
            (0, $erRAP.arrForEach)(channelQueue, function(channels) {
                if (channels && channels.queue[0, $fX4fx._DYN_LENGTH /* @min:%2elength */ ] > 0) (0, $Vt75T.initializePlugins)((0, $kry7o.createProcessTelemetryContext)(channels.chain, config, core), extensions);
            });
        },
        isInitialized: function() {
            return isInitialized;
        },
        processTelemetry: function(item, itemCtx) {
            _processChannelQueue(channelQueue, itemCtx || _getTelCtx(), function(chainCtx) {
                chainCtx[0, $fX4fx._DYN_PROCESS_NEXT /* @min:%2eprocessNext */ ](item);
            }, function() {
                itemCtx[0, $fX4fx._DYN_PROCESS_NEXT /* @min:%2eprocessNext */ ](item);
            });
        },
        update: _doUpdate,
        pause: function() {
            _processChannelQueue(channelQueue, _getTelCtx(), function(chainCtx) {
                chainCtx.iterate(function(plugin) {
                    plugin.pause && plugin.pause();
                });
            }, null);
        },
        resume: function() {
            _processChannelQueue(channelQueue, _getTelCtx(), function(chainCtx) {
                chainCtx.iterate(function(plugin) {
                    plugin.resume && plugin.resume();
                });
            }, null);
        },
        teardown: _doTeardown,
        getChannel: _getChannel,
        flush: function(isAsync, callBack, sendReason, cbTimeout) {
            // Setting waiting to one so that we don't call the callBack until we finish iterating
            var waiting = 1;
            var doneIterating = false;
            var cbTimer = null;
            cbTimeout = cbTimeout || 5000;
            function doCallback() {
                waiting--;
                if (doneIterating && waiting === 0) {
                    if (cbTimer) {
                        clearTimeout(cbTimer);
                        cbTimer = null;
                    }
                    callBack && callBack(doneIterating);
                    callBack = null;
                }
            }
            _processChannelQueue(channelQueue, _getTelCtx(), function(chainCtx) {
                chainCtx.iterate(function(plugin) {
                    if (plugin[0, $fX4fx._DYN_FLUSH /* @min:%2eflush */ ]) {
                        waiting++;
                        var handled_1 = false;
                        // Not all channels will call this callback for every scenario
                        if (!plugin[0, $fX4fx._DYN_FLUSH /* @min:%2eflush */ ](isAsync, function() {
                            handled_1 = true;
                            doCallback();
                        }, sendReason)) {
                            if (!handled_1) {
                                // If any channel doesn't return true and it didn't call the callback, then we should assume that the callback
                                // will never be called, so use a timeout to allow the channel(s) some time to "finish" before triggering any
                                // followup function (such as unloading)
                                if (isAsync && cbTimer == null) cbTimer = setTimeout(function() {
                                    cbTimer = null;
                                    doCallback();
                                }, cbTimeout);
                                else doCallback();
                            }
                        }
                    }
                });
            }, function() {
                doneIterating = true;
                doCallback();
            });
            return true;
        },
        _setQueue: function(queue) {
            channelQueue = queue;
        }
    };
    return channelController;
}
function $ff061b0ad2aa9992$export$9baa95a4af0f2d3(channels, extensions, core) {
    var channelQueue = [];
    if (channels) // Add and sort the configuration channel queues
    (0, $erRAP.arrForEach)(channels, function(queue) {
        return $ff061b0ad2aa9992$var$_addChannelQueue(channelQueue, queue, core);
    });
    if (extensions) {
        // Create a new channel queue for any extensions with a priority > the ChannelControllerPriority
        var extensionQueue_1 = [];
        (0, $erRAP.arrForEach)(extensions, function(plugin) {
            if (plugin[0, $lxIpo.STR_PRIORITY /* @min:%2epriority */ ] > $ff061b0ad2aa9992$export$a1373ad9f192f374) extensionQueue_1[0, $fX4fx._DYN_PUSH /* @min:%2epush */ ](plugin);
        });
        $ff061b0ad2aa9992$var$_addChannelQueue(channelQueue, extensionQueue_1, core);
    }
    return channelQueue;
}

});

parcelRegister("77O10", function(module, exports) {

$parcel$export(module.exports, "TelemetryInitializerPlugin", function () { return $52fffbd8a2d9470e$export$5da7f32cc3b89dc1; });
/*
 * Application Insights JavaScript SDK - Core, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ // 
// 

var $fcMe7 = parcelRequire("fcMe7");

var $kbmky = parcelRequire("kbmky");

var $fX4fx = parcelRequire("fX4fx");

var $3wvVb = parcelRequire("3wvVb");

var $8z2Gd = parcelRequire("8z2Gd");

var $3I5zg = parcelRequire("3I5zg");

var $erRAP = parcelRequire("erRAP");

var $lxIpo = parcelRequire("lxIpo");
var $52fffbd8a2d9470e$export$5da7f32cc3b89dc1 = /** @class */ function(_super) {
    (0, $fcMe7.__extendsFn)(TelemetryInitializerPlugin, _super);
    function TelemetryInitializerPlugin() {
        var _this = _super.call(this) || this;
        _this.identifier = "TelemetryInitializerPlugin";
        _this.priority = 199;
        // NOTE!: DON'T set default values here, instead set them in the _initDefaults() function as it is also called during teardown()
        var _id;
        var _initializers;
        _initDefaults();
        (0, $kbmky.default)(TelemetryInitializerPlugin, _this, function(_self, _base) {
            _self.addTelemetryInitializer = function(telemetryInitializer) {
                var theInitializer = {
                    id: _id++,
                    fn: telemetryInitializer
                };
                _initializers[0, $fX4fx._DYN_PUSH /* @min:%2epush */ ](theInitializer);
                var handler = {
                    remove: function() {
                        (0, $erRAP.arrForEach)(_initializers, function(initializer, idx) {
                            if (initializer.id === theInitializer.id) {
                                _initializers[0, $fX4fx._DYN_SPLICE /* @min:%2esplice */ ](idx, 1);
                                return -1;
                            }
                        });
                    }
                };
                return handler;
            };
            _self[0, $lxIpo.STR_PROCESS_TELEMETRY /* @min:%2eprocessTelemetry */ ] = function(item, itemCtx) {
                var doNotSendItem = false;
                var telemetryInitializersCount = _initializers[0, $fX4fx._DYN_LENGTH /* @min:%2elength */ ];
                for(var i = 0; i < telemetryInitializersCount; ++i){
                    var telemetryInitializer = _initializers[i];
                    if (telemetryInitializer) try {
                        if (telemetryInitializer.fn[0, $fX4fx._DYN_APPLY /* @min:%2eapply */ ](null, [
                            item
                        ]) === false) {
                            doNotSendItem = true;
                            break;
                        }
                    } catch (e) {
                        // log error but dont stop executing rest of the telemetry initializers
                        // doNotSendItem = true;
                        (0, $8z2Gd._throwInternal)(itemCtx[0, $fX4fx._DYN_DIAG_LOG /* @min:%2ediagLog */ ](), 1 /* eLoggingSeverity.CRITICAL */ , 64 /* _eInternalMessageId.TelemetryInitializerFailed */ , "One of telemetry initializers failed, telemetry item will not be sent: " + (0, $erRAP.getExceptionName)(e), {
                            exception: (0, $3I5zg.dumpObj)(e)
                        }, true);
                    }
                }
                if (!doNotSendItem) _self[0, $fX4fx._DYN_PROCESS_NEXT /* @min:%2eprocessNext */ ](item, itemCtx);
            };
            _self[0, $fX4fx._DYN__DO_TEARDOWN /* @min:%2e_doTeardown */ ] = function() {
                _initDefaults();
            };
        });
        function _initDefaults() {
            _id = 0;
            _initializers = [];
        }
        return _this;
    }
    // Removed Stub for TelemetryInitializerPlugin.prototype.addTelemetryInitializer.
    // Removed Stub for TelemetryInitializerPlugin.prototype.processTelemetry.
    // This is a workaround for an IE8 bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    // this will be removed when ES3 support is dropped.
    TelemetryInitializerPlugin.__ieDyn = 1;
    return TelemetryInitializerPlugin;
}((0, $3wvVb.BaseTelemetryPlugin));

});


parcelRegister("01RZI", function(module, exports) {

$parcel$export(module.exports, "NotificationManager", function () { return $0059fa4820f4fe13$export$dfa1f14b6290f8c5; });
/*
 * Application Insights JavaScript SDK - Core, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $kbmky = parcelRequire("kbmky");

var $fX4fx = parcelRequire("fX4fx");

var $erRAP = parcelRequire("erRAP");

var $lxIpo = parcelRequire("lxIpo");
function $0059fa4820f4fe13$var$_runListeners(listeners, name, isAsync, callback) {
    (0, $erRAP.arrForEach)(listeners, function(listener) {
        if (listener && listener[name]) {
            if (isAsync) setTimeout(function() {
                return callback(listener);
            }, 0);
            else try {
                callback(listener);
            } catch (e) {
            // Catch errors to ensure we don't block sending the requests
            }
        }
    });
}
/**
 * Class to manage sending notifications to all the listeners.
 */ var $0059fa4820f4fe13$export$dfa1f14b6290f8c5 = /** @class */ function() {
    function NotificationManager(config) {
        this.listeners = [];
        var perfEvtsSendAll = !!(config || {}).perfEvtsSendAll;
        (0, $kbmky.default)(NotificationManager, this, function(_self) {
            _self[0, $fX4fx._DYN_ADD_NOTIFICATION_LIS1 /* @min:%2eaddNotificationListener */ ] = function(listener) {
                _self.listeners[0, $fX4fx._DYN_PUSH /* @min:%2epush */ ](listener);
            };
            /**
             * Removes all instances of the listener.
             * @param {INotificationListener} listener - AWTNotificationListener to remove.
             */ _self[0, $fX4fx._DYN_REMOVE_NOTIFICATION_2 /* @min:%2eremoveNotificationListener */ ] = function(listener) {
                var index = (0, $erRAP.arrIndexOf)(_self[0, $fX4fx._DYN_LISTENERS /* @min:%2elisteners */ ], listener);
                while(index > -1){
                    _self.listeners[0, $fX4fx._DYN_SPLICE /* @min:%2esplice */ ](index, 1);
                    index = (0, $erRAP.arrIndexOf)(_self[0, $fX4fx._DYN_LISTENERS /* @min:%2elisteners */ ], listener);
                }
            };
            /**
             * Notification for events sent.
             * @param {ITelemetryItem[]} events - The array of events that have been sent.
             */ _self[0, $lxIpo.STR_EVENTS_SENT /* @min:%2eeventsSent */ ] = function(events) {
                $0059fa4820f4fe13$var$_runListeners(_self[0, $fX4fx._DYN_LISTENERS /* @min:%2elisteners */ ], (0, $lxIpo.STR_EVENTS_SENT), true, function(listener) {
                    listener[0, $lxIpo.STR_EVENTS_SENT /* @min:%2eeventsSent */ ](events);
                });
            };
            /**
             * Notification for events being discarded.
             * @param {ITelemetryItem[]} events - The array of events that have been discarded by the SDK.
             * @param {number} reason           - The reason for which the SDK discarded the events. The EventsDiscardedReason
             * constant should be used to check the different values.
             */ _self[0, $lxIpo.STR_EVENTS_DISCARDED /* @min:%2eeventsDiscarded */ ] = function(events, reason) {
                $0059fa4820f4fe13$var$_runListeners(_self[0, $fX4fx._DYN_LISTENERS /* @min:%2elisteners */ ], (0, $lxIpo.STR_EVENTS_DISCARDED), true, function(listener) {
                    listener[0, $lxIpo.STR_EVENTS_DISCARDED /* @min:%2eeventsDiscarded */ ](events, reason);
                });
            };
            /**
             * [Optional] A function called when the events have been requested to be sent to the sever.
             * @param {number} sendReason - The reason why the event batch is being sent.
             * @param {boolean} isAsync   - A flag which identifies whether the requests are being sent in an async or sync manner.
             */ _self[0, $lxIpo.STR_EVENTS_SEND_REQUEST /* @min:%2eeventsSendRequest */ ] = function(sendReason, isAsync) {
                $0059fa4820f4fe13$var$_runListeners(_self[0, $fX4fx._DYN_LISTENERS /* @min:%2elisteners */ ], (0, $lxIpo.STR_EVENTS_SEND_REQUEST), isAsync, function(listener) {
                    listener[0, $lxIpo.STR_EVENTS_SEND_REQUEST /* @min:%2eeventsSendRequest */ ](sendReason, isAsync);
                });
            };
            _self[0, $lxIpo.STR_PERF_EVENT /* @min:%2eperfEvent */ ] = function(perfEvent) {
                if (perfEvent) // Send all events or only parent events
                {
                    if (perfEvtsSendAll || !perfEvent[0, $fX4fx._DYN_IS_CHILD_EVT /* @min:%2eisChildEvt */ ]()) $0059fa4820f4fe13$var$_runListeners(_self[0, $fX4fx._DYN_LISTENERS /* @min:%2elisteners */ ], (0, $lxIpo.STR_PERF_EVENT), false, function(listener) {
                        if (perfEvent[0, $fX4fx._DYN_IS_ASYNC /* @min:%2eisAsync */ ]) setTimeout(function() {
                            return listener[0, $lxIpo.STR_PERF_EVENT /* @min:%2eperfEvent */ ](perfEvent);
                        }, 0);
                        else listener[0, $lxIpo.STR_PERF_EVENT /* @min:%2eperfEvent */ ](perfEvent);
                    });
                }
            };
        });
    }
    // Removed Stub for NotificationManager.prototype.addNotificationListener.
    // Removed Stub for NotificationManager.prototype.removeNotificationListener.
    // Removed Stub for NotificationManager.prototype.eventsSent.
    // Removed Stub for NotificationManager.prototype.eventsDiscarded.
    // Removed Stub for NotificationManager.prototype.eventsSendRequest.
    // This is a workaround for an IE8 bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    // this will be removed when ES3 support is dropped.
    NotificationManager.__ieDyn = 1;
    return NotificationManager;
}();

});


parcelRegister("9ZYOv", function(module, exports) {

$parcel$export(module.exports, "AjaxMonitor", function () { return $7478fbe354599201$export$d9a50c4d1eb2475f; });
/*
 * Application Insights JavaScript SDK - Dependencies Plugin, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $fcMe7 = parcelRequire("fcMe7");

var $kbmky = parcelRequire("kbmky");

var $4sUzw = parcelRequire("4sUzw");
var $62ywT = parcelRequire("62ywT");
var $jqfZe = parcelRequire("jqfZe");
var $dCW8D = parcelRequire("dCW8D");
var $1EHoQ = parcelRequire("1EHoQ");
var $7fph4 = parcelRequire("7fph4");
var $f5lFa = parcelRequire("f5lFa");

var $8z2Gd = parcelRequire("8z2Gd");
var $erRAP = parcelRequire("erRAP");
var $3wvVb = parcelRequire("3wvVb");
var $kry7o = parcelRequire("kry7o");
var $2w0XY = parcelRequire("2w0XY");
var $3I5zg = parcelRequire("3I5zg");
var $cIC5n = parcelRequire("cIC5n");
var $iBAi6 = parcelRequire("iBAi6");
var $gSD6i = parcelRequire("gSD6i");
var $2CgMu = parcelRequire("2CgMu");
var $VVkgt = parcelRequire("VVkgt");

var $ag2Pd = parcelRequire("ag2Pd");

var $j1HbR = parcelRequire("j1HbR");

var $aZeII = parcelRequire("aZeII");
var $7478fbe354599201$var$AJAX_MONITOR_PREFIX = "ai.ajxmn.";
var $7478fbe354599201$var$strDiagLog = "diagLog";
var $7478fbe354599201$var$AJAX_DATA_CONTAINER = "_ajaxData";
var $7478fbe354599201$var$STR_FETCH = "fetch";
var $7478fbe354599201$var$ERROR_HEADER = "Failed to monitor XMLHttpRequest";
var $7478fbe354599201$var$ERROR_PREFIX = ", monitoring data for this ajax call ";
var $7478fbe354599201$var$ERROR_POSTFIX = $7478fbe354599201$var$ERROR_PREFIX + "may be incorrect.";
var $7478fbe354599201$var$ERROR_NOT_SENT = $7478fbe354599201$var$ERROR_PREFIX + "won't be sent.";
var $7478fbe354599201$var$CORRELATION_HEADER_ERROR = "Failed to get Request-Context correlation header as it may be not included in the response or not accessible.";
var $7478fbe354599201$var$CUSTOM_REQUEST_CONTEXT_ERROR = "Failed to add custom defined request context as configured call back may missing a null check.";
var $7478fbe354599201$var$FAILED_TO_CALCULATE_DURATION_ERROR = "Failed to calculate the duration of the ";
// Using a global value so that to handle same iKey with multiple app insights instances (mostly for testing)
var $7478fbe354599201$var$_markCount = 0;
/** @Ignore */ function $7478fbe354599201$var$_supportsFetch() {
    var _global = (0, $gSD6i.getGlobal)();
    if (!_global || (0, $erRAP.isNullOrUndefined)(_global.Request) || (0, $erRAP.isNullOrUndefined)(_global.Request[0, $VVkgt.strShimPrototype]) || (0, $erRAP.isNullOrUndefined)(_global[$7478fbe354599201$var$STR_FETCH])) return null;
    return _global[$7478fbe354599201$var$STR_FETCH];
}
var $7478fbe354599201$var$_isWebWorker = null;
function $7478fbe354599201$var$isWebWorker() {
    if ($7478fbe354599201$var$_isWebWorker == null) try {
        $7478fbe354599201$var$_isWebWorker = !!(self && self instanceof WorkerGlobalScope);
    } catch (e) {
        $7478fbe354599201$var$_isWebWorker = false;
    }
    return $7478fbe354599201$var$_isWebWorker;
}
/**
 * Determines whether ajax monitoring can be enabled on this document
 * @returns True if Ajax monitoring is supported on this page, otherwise false
 * @ignore
 */ function $7478fbe354599201$var$_supportsAjaxMonitoring(ajaxMonitorInstance, ajaxDataId) {
    var _a;
    var result = false;
    if ((0, $3I5zg.isXhrSupported)()) {
        var proto = XMLHttpRequest[0, $VVkgt.strShimPrototype];
        result = !(0, $erRAP.isNullOrUndefined)(proto) && !(0, $erRAP.isNullOrUndefined)(proto.open) && // eslint-disable-line security/detect-non-literal-fs-filename -- false positive
        !(0, $erRAP.isNullOrUndefined)(proto.send) && !(0, $erRAP.isNullOrUndefined)(proto.abort);
    }
    var ieVer = (0, $3I5zg.getIEVersion)();
    if (ieVer && ieVer < 9) result = false;
    if (result) // Disable if the XmlHttpRequest can't be extended or hooked
    try {
        var xhr = new XMLHttpRequest();
        var xhrData = {
            xh: [],
            i: (_a = {}, _a[ajaxDataId] = {}, _a)
        };
        xhr[$7478fbe354599201$var$AJAX_DATA_CONTAINER] = xhrData;
        // Check that we can update the prototype
        var theOpen = XMLHttpRequest[0, $VVkgt.strShimPrototype].open;
        XMLHttpRequest[0, $VVkgt.strShimPrototype].open = theOpen;
    } catch (e) {
        // We can't decorate the xhr object so disable monitoring
        result = false;
        $7478fbe354599201$var$_throwInternalCritical(ajaxMonitorInstance, 15 /* _eInternalMessageId.FailedMonitorAjaxOpen */ , "Failed to enable XMLHttpRequest monitoring, extension is not supported", {
            exception: (0, $3I5zg.dumpObj)(e)
        });
    }
    return result;
}
/**
 * Internal helper to fetch the SDK instance tracking data for this XHR request
 * @param xhr
 * @param ajaxDataId
 * @returns
 */ var $7478fbe354599201$var$_getAjaxData = function(xhr, ajaxDataId) {
    if (xhr && ajaxDataId && xhr[$7478fbe354599201$var$AJAX_DATA_CONTAINER]) return (xhr[$7478fbe354599201$var$AJAX_DATA_CONTAINER].i || {})[ajaxDataId];
    return null;
};
/**
 * @ignore
 * Internal helper to track the singleton shared tracking headers, so we can attempt to not create headers
 * that might cause an issue if multiple values are populated.
 * @param xhr - The instrumented XHR instance
 */ var $7478fbe354599201$var$_addSharedXhrHeaders = function(xhr, name, value) {
    if (xhr) {
        var headers = (xhr[$7478fbe354599201$var$AJAX_DATA_CONTAINER] || {}).xh;
        if (headers) headers.push({
            n: name,
            v: value
        });
    }
};
var $7478fbe354599201$var$_isHeaderSet = function(xhr, name) {
    var isPresent = false;
    if (xhr) {
        var headers = (xhr[$7478fbe354599201$var$AJAX_DATA_CONTAINER] || {}).xh;
        if (headers) (0, $erRAP.arrForEach)(headers, function(header) {
            if (header.n === name) {
                isPresent = true;
                return -1;
            }
        });
    }
    return isPresent;
};
/** @Ignore */ function $7478fbe354599201$var$_getFailedAjaxDiagnosticsMessage(xhr, ajaxDataId) {
    var result = "";
    try {
        var ajaxData = $7478fbe354599201$var$_getAjaxData(xhr, ajaxDataId);
        if (ajaxData && ajaxData[0, $j1HbR._DYN_REQUEST_URL /* @min:%2erequestUrl */ ]) result += "(url: '" + ajaxData[0, $j1HbR._DYN_REQUEST_URL /* @min:%2erequestUrl */ ] + "')";
    } catch (e) {
    // eslint-disable-next-line no-empty
    }
    return result;
}
/** @ignore */ function $7478fbe354599201$var$_throwInternalCritical(ajaxMonitorInstance, msgId, message, properties, isUserAct) {
    (0, $8z2Gd._throwInternal)(ajaxMonitorInstance[$7478fbe354599201$var$strDiagLog](), 1 /* eLoggingSeverity.CRITICAL */ , msgId, message, properties, isUserAct);
}
/** @ignore */ function $7478fbe354599201$var$_throwInternalWarning(ajaxMonitorInstance, msgId, message, properties, isUserAct) {
    (0, $8z2Gd._throwInternal)(ajaxMonitorInstance[$7478fbe354599201$var$strDiagLog](), 2 /* eLoggingSeverity.WARNING */ , msgId, message, properties, isUserAct);
}
/** @Ignore */ function $7478fbe354599201$var$_createErrorCallbackFunc(ajaxMonitorInstance, internalMessage, message) {
    // tslint:disable-next-line
    return function(callDetails) {
        $7478fbe354599201$var$_throwInternalCritical(ajaxMonitorInstance, internalMessage, message, {
            ajaxDiagnosticsMessage: $7478fbe354599201$var$_getFailedAjaxDiagnosticsMessage(callDetails[0, $j1HbR._DYN_INST /* @min:%2einst */ ], ajaxMonitorInstance._ajaxDataId),
            exception: (0, $3I5zg.dumpObj)(callDetails.err)
        });
    };
}
function $7478fbe354599201$var$_indexOf(value, match) {
    if (value && match) return value.indexOf(match);
    return -1;
}
function $7478fbe354599201$var$_addHandler(container, id, theFunc) {
    var theHandler = {
        id: id,
        fn: theFunc
    };
    container.push(theHandler);
    return {
        remove: function() {
            (0, $erRAP.arrForEach)(container, function(initializer, idx) {
                if (initializer.id === theHandler.id) {
                    container.splice(idx, 1);
                    return -1;
                }
            });
        }
    };
}
function $7478fbe354599201$var$_processDependencyContainer(core, container, details, message) {
    var result = true;
    (0, $erRAP.arrForEach)(container, function(theFunc, idx) {
        try {
            if (theFunc.fn.call(null, details) === false) result = false;
        } catch (e) {
            (0, $8z2Gd._throwInternal)(core && core.logger, 1 /* eLoggingSeverity.CRITICAL */ , 64 /* _eInternalMessageId.TelemetryInitializerFailed */ , "Dependency " + message + " [#" + idx + "] failed: " + (0, $erRAP.getExceptionName)(e), {
                exception: (0, $3I5zg.dumpObj)(e)
            }, true);
        }
    });
    return result;
}
function $7478fbe354599201$var$_processDependencyListeners(listeners, core, ajaxData, xhr, input, init) {
    var initializersCount = listeners[0, $j1HbR._DYN_LENGTH /* @min:%2elength */ ];
    if (initializersCount > 0) {
        var details = {
            core: core,
            xhr: xhr,
            input: input,
            init: init,
            traceId: ajaxData[0, $j1HbR._DYN_TRACE_ID /* @min:%2etraceID */ ],
            spanId: ajaxData[0, $j1HbR._DYN_SPAN_ID /* @min:%2espanID */ ],
            traceFlags: ajaxData[0, $j1HbR._DYN_TRACE_FLAGS /* @min:%2etraceFlags */ ],
            context: ajaxData[0, $j1HbR._DYN_CONTEXT /* @min:%2econtext */ ] || {},
            aborted: !!ajaxData[0, $j1HbR._DYN_ABORTED /* @min:%2eaborted */ ]
        };
        $7478fbe354599201$var$_processDependencyContainer(core, listeners, details, "listener");
        ajaxData[0, $j1HbR._DYN_TRACE_ID /* @min:%2etraceID */ ] = details[0, $j1HbR._DYN_TRACE_ID0 /* @min:%2etraceId */ ];
        ajaxData[0, $j1HbR._DYN_SPAN_ID /* @min:%2espanID */ ] = details[0, $j1HbR._DYN_SPAN_ID1 /* @min:%2espanId */ ];
        ajaxData[0, $j1HbR._DYN_TRACE_FLAGS /* @min:%2etraceFlags */ ] = details[0, $j1HbR._DYN_TRACE_FLAGS /* @min:%2etraceFlags */ ];
        ajaxData[0, $j1HbR._DYN_CONTEXT /* @min:%2econtext */ ] = details[0, $j1HbR._DYN_CONTEXT /* @min:%2econtext */ ];
    }
}
var $7478fbe354599201$var$BLOB_CORE = "*.blob.core.";
var $7478fbe354599201$export$ae1f7dcb3278b8bb = (0, $erRAP.deepFreeze)([
    $7478fbe354599201$var$BLOB_CORE + "windows.net",
    $7478fbe354599201$var$BLOB_CORE + "chinacloudapi.cn",
    $7478fbe354599201$var$BLOB_CORE + "cloudapi.de",
    $7478fbe354599201$var$BLOB_CORE + "usgovcloudapi.net"
]);
var $7478fbe354599201$var$_internalExcludeEndpoints = [
    /https:\/\/[^\/]*(\.pipe\.aria|aria\.pipe|events\.data|collector\.azure)\.[^\/]+\/(OneCollector\/1|Collector\/3)\.0/i
];
function $7478fbe354599201$var$_getDefaultConfig() {
    var config = {
        maxAjaxCallsPerView: 500,
        disableAjaxTracking: false,
        disableFetchTracking: false,
        excludeRequestFromAutoTrackingPatterns: undefined,
        disableCorrelationHeaders: false,
        distributedTracingMode: 1 /* eDistributedTracingModes.AI_AND_W3C */ ,
        correlationHeaderExcludedDomains: $7478fbe354599201$export$ae1f7dcb3278b8bb,
        correlationHeaderDomains: undefined,
        correlationHeaderExcludePatterns: undefined,
        appId: undefined,
        enableCorsCorrelation: false,
        enableRequestHeaderTracking: false,
        enableResponseHeaderTracking: false,
        enableAjaxErrorStatusText: false,
        enableAjaxPerfTracking: false,
        maxAjaxPerfLookupAttempts: 3,
        ajaxPerfLookupDelay: 25,
        ignoreHeaders: [
            "Authorization",
            "X-API-Key",
            "WWW-Authenticate"
        ],
        addRequestContext: undefined,
        addIntEndpoints: true
    };
    return config;
}
function $7478fbe354599201$var$_getEmptyConfig() {
    var emptyConfig = $7478fbe354599201$var$_getDefaultConfig();
    (0, $erRAP.objForEachKey)(emptyConfig, function(value) {
        emptyConfig[value] = undefined;
    });
    return emptyConfig;
}
var $7478fbe354599201$export$d9a50c4d1eb2475f = /** @class */ function(_super) {
    (0, $fcMe7.__extendsFn)(AjaxMonitor, _super);
    function AjaxMonitor() {
        var _this = _super.call(this) || this;
        _this.identifier = AjaxMonitor.identifier;
        _this.priority = 120;
        var _fetchInitialized; // fetch monitoring initialized
        var _xhrInitialized; // XHR monitoring initialized
        var _currentWindowHost;
        var _config;
        var _enableRequestHeaderTracking;
        var _enableAjaxErrorStatusText;
        var _trackAjaxAttempts;
        var _context;
        var _isUsingW3CHeaders;
        var _isUsingAIHeaders;
        var _markPrefix;
        var _enableAjaxPerfTracking;
        var _maxAjaxCallsPerView;
        var _enableResponseHeaderTracking;
        var _disabledUrls;
        var _disableAjaxTracking;
        var _disableFetchTracking;
        var _excludeRequestFromAutoTrackingPatterns;
        var _addRequestContext;
        var _evtNamespace;
        var _ajaxDataId;
        var _dependencyHandlerId;
        var _dependencyListeners;
        var _dependencyInitializers;
        (0, $kbmky.default)(AjaxMonitor, _this, function(_self, _base) {
            var _addHook = _base._addHook;
            _initDefaults();
            _self.initialize = function(config, core, extensions, pluginChain) {
                if (!_self.isInitialized()) {
                    _base.initialize(config, core, extensions, pluginChain);
                    _evtNamespace = (0, $cIC5n.mergeEvtNamespace)((0, $2w0XY.createUniqueNamespace)("ajax"), core && core.evtNamespace && core.evtNamespace());
                    _populateDefaults(config);
                    _instrumentXhr();
                    _instrumentFetch();
                    _populateContext();
                }
            };
            _self._doTeardown = function() {
                _initDefaults();
            };
            _self.trackDependencyData = function(dependency, properties) {
                _reportDependencyInternal(_dependencyInitializers, _self[0, $j1HbR._DYN_CORE /* @min:%2ecore */ ], null, dependency, properties);
            };
            _self[0, $j1HbR._DYN_INCLUDE_CORRELATION_2 /* @min:%2eincludeCorrelationHeaders */ ] = function(ajaxData, input, init, xhr) {
                // Test Hook to allow the overriding of the location host
                var currentWindowHost = _self["_currentWindowHost"] || _currentWindowHost;
                $7478fbe354599201$var$_processDependencyListeners(_dependencyListeners, _self[0, $j1HbR._DYN_CORE /* @min:%2ecore */ ], ajaxData, xhr, input, init);
                if (input || input === "") {
                    if ((0, $4sUzw.CorrelationIdHelper)[0, $j1HbR._DYN_CAN_INCLUDE_CORRELAT3 /* @min:%2ecanIncludeCorrelationHeader */ ](_config, ajaxData[0, $j1HbR._DYN_GET_ABSOLUTE_URL /* @min:%2egetAbsoluteUrl */ ](), currentWindowHost)) {
                        if (!init) init = {};
                        // init headers override original request headers
                        // so, if they exist use only them, otherwise use request's because they should have been applied in the first place
                        // not using original request headers will result in them being lost
                        var headers = new Headers(init[0, $j1HbR._DYN_HEADERS /* @min:%2eheaders */ ] || (input instanceof Request ? input[0, $j1HbR._DYN_HEADERS /* @min:%2eheaders */ ] || {} : {}));
                        if (_isUsingAIHeaders) {
                            var id = "|" + ajaxData[0, $j1HbR._DYN_TRACE_ID /* @min:%2etraceID */ ] + "." + ajaxData[0, $j1HbR._DYN_SPAN_ID /* @min:%2espanID */ ];
                            headers.set((0, $f5lFa.RequestHeaders)[3 /* eRequestHeaders.requestIdHeader */ ], id);
                            if (_enableRequestHeaderTracking) ajaxData[0, $j1HbR._DYN_REQUEST_HEADERS /* @min:%2erequestHeaders */ ][(0, $f5lFa.RequestHeaders)[3 /* eRequestHeaders.requestIdHeader */ ]] = id;
                        }
                        var appId = _config[0, $j1HbR._DYN_APP_ID /* @min:%2eappId */ ] || _context && _context[0, $j1HbR._DYN_APP_ID /* @min:%2eappId */ ]();
                        if (appId) {
                            headers.set((0, $f5lFa.RequestHeaders)[0 /* eRequestHeaders.requestContextHeader */ ], (0, $f5lFa.RequestHeaders)[2 /* eRequestHeaders.requestContextAppIdFormat */ ] + appId);
                            if (_enableRequestHeaderTracking) ajaxData[0, $j1HbR._DYN_REQUEST_HEADERS /* @min:%2erequestHeaders */ ][(0, $f5lFa.RequestHeaders)[0 /* eRequestHeaders.requestContextHeader */ ]] = (0, $f5lFa.RequestHeaders)[2 /* eRequestHeaders.requestContextAppIdFormat */ ] + appId;
                        }
                        if (_isUsingW3CHeaders) {
                            var traceFlags = ajaxData[0, $j1HbR._DYN_TRACE_FLAGS /* @min:%2etraceFlags */ ];
                            if ((0, $erRAP.isNullOrUndefined)(traceFlags)) traceFlags = 0x01;
                            var traceParent = (0, $jqfZe.formatTraceParent)((0, $jqfZe.createTraceParent)(ajaxData[0, $j1HbR._DYN_TRACE_ID /* @min:%2etraceID */ ], ajaxData[0, $j1HbR._DYN_SPAN_ID /* @min:%2espanID */ ], traceFlags));
                            headers.set((0, $f5lFa.RequestHeaders)[4 /* eRequestHeaders.traceParentHeader */ ], traceParent);
                            if (_enableRequestHeaderTracking) ajaxData[0, $j1HbR._DYN_REQUEST_HEADERS /* @min:%2erequestHeaders */ ][(0, $f5lFa.RequestHeaders)[4 /* eRequestHeaders.traceParentHeader */ ]] = traceParent;
                        }
                        init[0, $j1HbR._DYN_HEADERS /* @min:%2eheaders */ ] = headers;
                    }
                    return init;
                } else if (xhr) {
                    if ((0, $4sUzw.CorrelationIdHelper)[0, $j1HbR._DYN_CAN_INCLUDE_CORRELAT3 /* @min:%2ecanIncludeCorrelationHeader */ ](_config, ajaxData[0, $j1HbR._DYN_GET_ABSOLUTE_URL /* @min:%2egetAbsoluteUrl */ ](), currentWindowHost)) {
                        if (_isUsingAIHeaders) {
                            if (!$7478fbe354599201$var$_isHeaderSet(xhr, (0, $f5lFa.RequestHeaders)[3 /* eRequestHeaders.requestIdHeader */ ])) {
                                var id = "|" + ajaxData[0, $j1HbR._DYN_TRACE_ID /* @min:%2etraceID */ ] + "." + ajaxData[0, $j1HbR._DYN_SPAN_ID /* @min:%2espanID */ ];
                                xhr[0, $j1HbR._DYN_SET_REQUEST_HEADER /* @min:%2esetRequestHeader */ ]((0, $f5lFa.RequestHeaders)[3 /* eRequestHeaders.requestIdHeader */ ], id);
                                if (_enableRequestHeaderTracking) ajaxData[0, $j1HbR._DYN_REQUEST_HEADERS /* @min:%2erequestHeaders */ ][(0, $f5lFa.RequestHeaders)[3 /* eRequestHeaders.requestIdHeader */ ]] = id;
                            } else $7478fbe354599201$var$_throwInternalWarning(_self, 71 /* _eInternalMessageId.FailedMonitorAjaxSetRequestHeader */ , "Unable to set [" + (0, $f5lFa.RequestHeaders)[3 /* eRequestHeaders.requestIdHeader */ ] + "] as it has already been set by another instance");
                        }
                        var appId = _config[0, $j1HbR._DYN_APP_ID /* @min:%2eappId */ ] || _context && _context[0, $j1HbR._DYN_APP_ID /* @min:%2eappId */ ]();
                        if (appId) {
                            if (!$7478fbe354599201$var$_isHeaderSet(xhr, (0, $f5lFa.RequestHeaders)[0 /* eRequestHeaders.requestContextHeader */ ])) {
                                xhr[0, $j1HbR._DYN_SET_REQUEST_HEADER /* @min:%2esetRequestHeader */ ]((0, $f5lFa.RequestHeaders)[0 /* eRequestHeaders.requestContextHeader */ ], (0, $f5lFa.RequestHeaders)[2 /* eRequestHeaders.requestContextAppIdFormat */ ] + appId);
                                if (_enableRequestHeaderTracking) ajaxData[0, $j1HbR._DYN_REQUEST_HEADERS /* @min:%2erequestHeaders */ ][(0, $f5lFa.RequestHeaders)[0 /* eRequestHeaders.requestContextHeader */ ]] = (0, $f5lFa.RequestHeaders)[2 /* eRequestHeaders.requestContextAppIdFormat */ ] + appId;
                            } else $7478fbe354599201$var$_throwInternalWarning(_self, 71 /* _eInternalMessageId.FailedMonitorAjaxSetRequestHeader */ , "Unable to set [" + (0, $f5lFa.RequestHeaders)[0 /* eRequestHeaders.requestContextHeader */ ] + "] as it has already been set by another instance");
                        }
                        if (_isUsingW3CHeaders) {
                            var traceFlags = ajaxData[0, $j1HbR._DYN_TRACE_FLAGS /* @min:%2etraceFlags */ ];
                            if ((0, $erRAP.isNullOrUndefined)(traceFlags)) traceFlags = 0x01;
                            if (!$7478fbe354599201$var$_isHeaderSet(xhr, (0, $f5lFa.RequestHeaders)[4 /* eRequestHeaders.traceParentHeader */ ])) {
                                var traceParent = (0, $jqfZe.formatTraceParent)((0, $jqfZe.createTraceParent)(ajaxData[0, $j1HbR._DYN_TRACE_ID /* @min:%2etraceID */ ], ajaxData[0, $j1HbR._DYN_SPAN_ID /* @min:%2espanID */ ], traceFlags));
                                xhr[0, $j1HbR._DYN_SET_REQUEST_HEADER /* @min:%2esetRequestHeader */ ]((0, $f5lFa.RequestHeaders)[4 /* eRequestHeaders.traceParentHeader */ ], traceParent);
                                if (_enableRequestHeaderTracking) ajaxData[0, $j1HbR._DYN_REQUEST_HEADERS /* @min:%2erequestHeaders */ ][(0, $f5lFa.RequestHeaders)[4 /* eRequestHeaders.traceParentHeader */ ]] = traceParent;
                            } else $7478fbe354599201$var$_throwInternalWarning(_self, 71 /* _eInternalMessageId.FailedMonitorAjaxSetRequestHeader */ , "Unable to set [" + (0, $f5lFa.RequestHeaders)[4 /* eRequestHeaders.traceParentHeader */ ] + "] as it has already been set by another instance");
                        }
                    }
                    return xhr;
                }
                return undefined;
            };
            _self[0, $j1HbR._DYN_TRACK_DEPENDENCY_DAT4 /* @min:%2etrackDependencyDataInternal */ ] = function(dependency, properties, systemProperties) {
                if (_maxAjaxCallsPerView === -1 || _trackAjaxAttempts < _maxAjaxCallsPerView) {
                    // Hack since expected format in w3c mode is |abc.def.
                    // Non-w3c format is |abc.def
                    // @todo Remove if better solution is available, e.g. handle in portal
                    if ((_config[0, $j1HbR._DYN_DISTRIBUTED_TRACING_5 /* @min:%2edistributedTracingMode */ ] === 2 /* eDistributedTracingModes.W3C */  || _config[0, $j1HbR._DYN_DISTRIBUTED_TRACING_5 /* @min:%2edistributedTracingMode */ ] === 1 /* eDistributedTracingModes.AI_AND_W3C */ ) && typeof dependency.id === "string" && dependency.id[dependency.id[0, $j1HbR._DYN_LENGTH /* @min:%2elength */ ] - 1] !== ".") dependency.id += ".";
                    if ((0, $erRAP.isNullOrUndefined)(dependency[0, $j1HbR._DYN_START_TIME /* @min:%2estartTime */ ])) dependency[0, $j1HbR._DYN_START_TIME /* @min:%2estartTime */ ] = new Date();
                    var item = (0, $62ywT.createTelemetryItem)(dependency, (0, $7fph4.RemoteDependencyData).dataType, (0, $7fph4.RemoteDependencyData).envelopeType, _self[$7478fbe354599201$var$strDiagLog](), properties, systemProperties);
                    _self[0, $j1HbR._DYN_CORE /* @min:%2ecore */ ].track(item);
                } else if (_trackAjaxAttempts === _maxAjaxCallsPerView) $7478fbe354599201$var$_throwInternalCritical(_self, 55 /* _eInternalMessageId.MaxAjaxPerPVExceeded */ , "Maximum ajax per page view limit reached, ajax monitoring is paused until the next trackPageView(). In order to increase the limit set the maxAjaxCallsPerView configuration parameter.", true);
                ++_trackAjaxAttempts;
            };
            _self.addDependencyListener = function(dependencyListener) {
                return $7478fbe354599201$var$_addHandler(_dependencyListeners, _dependencyHandlerId++, dependencyListener);
            };
            _self.addDependencyInitializer = function(dependencyInitializer) {
                return $7478fbe354599201$var$_addHandler(_dependencyInitializers, _dependencyHandlerId++, dependencyInitializer);
            };
            function _initDefaults() {
                var location = (0, $3I5zg.getLocation)();
                _fetchInitialized = false; // fetch monitoring initialized
                _xhrInitialized = false; // XHR monitoring initialized
                _currentWindowHost = location && location.host && location.host[0, $j1HbR._DYN_TO_LOWER_CASE /* @min:%2etoLowerCase */ ]();
                _config = AjaxMonitor.getEmptyConfig();
                _enableRequestHeaderTracking = false;
                _enableAjaxErrorStatusText = false;
                _trackAjaxAttempts = 0;
                _context = null;
                _isUsingW3CHeaders = false;
                _isUsingAIHeaders = false;
                _markPrefix = null;
                _enableAjaxPerfTracking = false;
                _maxAjaxCallsPerView = 0;
                _enableResponseHeaderTracking = false;
                _disabledUrls = {};
                _disableAjaxTracking = false;
                _disableFetchTracking = false;
                _excludeRequestFromAutoTrackingPatterns = null;
                _addRequestContext = null;
                _evtNamespace = null;
                _dependencyHandlerId = 0;
                _dependencyListeners = [];
                _dependencyInitializers = [];
                _ajaxDataId = (0, $2w0XY.createUniqueNamespace)("ajaxData");
                _self._ajaxDataId = _ajaxDataId;
            }
            function _populateDefaults(config) {
                var ctx = (0, $kry7o.createProcessTelemetryContext)(null, config, _self[0, $j1HbR._DYN_CORE /* @min:%2ecore */ ]);
                // Reset to the empty config
                _config = $7478fbe354599201$var$_getEmptyConfig();
                var defaultConfig = $7478fbe354599201$var$_getDefaultConfig();
                (0, $erRAP.objForEachKey)(defaultConfig, function(field, value) {
                    _config[field] = ctx.getConfig(AjaxMonitor.identifier, field, value);
                });
                var distributedTracingMode = _config[0, $j1HbR._DYN_DISTRIBUTED_TRACING_5 /* @min:%2edistributedTracingMode */ ];
                _enableRequestHeaderTracking = _config[0, $j1HbR._DYN_ENABLE_REQUEST_HEADE6 /* @min:%2eenableRequestHeaderTracking */ ];
                _enableAjaxErrorStatusText = _config[0, $j1HbR._DYN_ENABLE_AJAX_ERROR_ST7 /* @min:%2eenableAjaxErrorStatusText */ ];
                _enableAjaxPerfTracking = _config[0, $j1HbR._DYN_ENABLE_AJAX_PERF_TRA8 /* @min:%2eenableAjaxPerfTracking */ ];
                _maxAjaxCallsPerView = _config[0, $j1HbR._DYN_MAX_AJAX_CALLS_PER_V9 /* @min:%2emaxAjaxCallsPerView */ ];
                _enableResponseHeaderTracking = _config[0, $j1HbR._DYN_ENABLE_RESPONSE_HEAD10 /* @min:%2eenableResponseHeaderTracking */ ];
                _excludeRequestFromAutoTrackingPatterns = [].concat(_config[0, $j1HbR._DYN_EXCLUDE_REQUEST_FROM11 /* @min:%2eexcludeRequestFromAutoTrackingPatterns */ ] || [], _config.addIntEndpoints !== false ? $7478fbe354599201$var$_internalExcludeEndpoints : []);
                _addRequestContext = _config[0, $j1HbR._DYN_ADD_REQUEST_CONTEXT /* @min:%2eaddRequestContext */ ];
                _isUsingAIHeaders = distributedTracingMode === 0 /* eDistributedTracingModes.AI */  || distributedTracingMode === 1 /* eDistributedTracingModes.AI_AND_W3C */ ;
                _isUsingW3CHeaders = distributedTracingMode === 1 /* eDistributedTracingModes.AI_AND_W3C */  || distributedTracingMode === 2 /* eDistributedTracingModes.W3C */ ;
                if (_enableAjaxPerfTracking) {
                    var iKey = config.instrumentationKey || "unkwn";
                    if (iKey[0, $j1HbR._DYN_LENGTH /* @min:%2elength */ ] > 5) _markPrefix = $7478fbe354599201$var$AJAX_MONITOR_PREFIX + iKey.substring(iKey[0, $j1HbR._DYN_LENGTH /* @min:%2elength */ ] - 5) + ".";
                    else _markPrefix = $7478fbe354599201$var$AJAX_MONITOR_PREFIX + iKey + ".";
                }
                _disableAjaxTracking = !!_config[0, $j1HbR._DYN_DISABLE_AJAX_TRACKIN12 /* @min:%2edisableAjaxTracking */ ];
                _disableFetchTracking = !!_config[0, $j1HbR._DYN_DISABLE_FETCH_TRACKI13 /* @min:%2edisableFetchTracking */ ];
            }
            function _populateContext() {
                var propExt = _self[0, $j1HbR._DYN_CORE /* @min:%2ecore */ ].getPlugin((0, $1EHoQ.PropertiesPluginIdentifier));
                if (propExt) _context = propExt.plugin[0, $j1HbR._DYN_CONTEXT /* @min:%2econtext */ ]; // we could move IPropertiesPlugin to common as well
            }
            // discard the header if it's defined as ignoreHeaders in ICorrelationConfig
            function _canIncludeHeaders(header) {
                var rlt = true;
                if (header || _config.ignoreHeaders) (0, $erRAP.arrForEach)(_config.ignoreHeaders, function(key) {
                    if (key[0, $j1HbR._DYN_TO_LOWER_CASE /* @min:%2etoLowerCase */ ]() === header[0, $j1HbR._DYN_TO_LOWER_CASE /* @min:%2etoLowerCase */ ]()) {
                        rlt = false;
                        return -1;
                    }
                });
                return rlt;
            }
            // Fetch Stuff
            function _instrumentFetch() {
                var fetch = $7478fbe354599201$var$_supportsFetch();
                if (!fetch) return;
                var global = (0, $gSD6i.getGlobal)();
                var isPolyfill = fetch.polyfill;
                if (!_disableFetchTracking && !_fetchInitialized) {
                    _addHook((0, $2CgMu.InstrumentFunc)(global, $7478fbe354599201$var$STR_FETCH, {
                        ns: _evtNamespace,
                        // Add request hook
                        req: function(callDetails, input, init) {
                            var fetchData;
                            if (!_disableFetchTracking && _fetchInitialized && !_isDisabledRequest(null, input, init) && // If we have a polyfil and XHR instrumented then let XHR report otherwise we get duplicates
                            !(isPolyfill && _xhrInitialized)) {
                                var ctx = callDetails.ctx();
                                fetchData = _createFetchRecord(input, init);
                                var newInit = _self[0, $j1HbR._DYN_INCLUDE_CORRELATION_2 /* @min:%2eincludeCorrelationHeaders */ ](fetchData, input, init);
                                if (newInit !== init) callDetails.set(1, newInit);
                                ctx.data = fetchData;
                            }
                        },
                        rsp: function(callDetails, input) {
                            if (!_disableFetchTracking) {
                                var fetchData_1 = callDetails.ctx().data;
                                if (fetchData_1) // Replace the result with the new promise from this code
                                callDetails.rslt = callDetails.rslt.then(function(response) {
                                    _reportFetchMetrics(callDetails, (response || {})[0, $j1HbR._DYN_STATUS /* @min:%2estatus */ ], input, response, fetchData_1, function() {
                                        var ajaxResponse = {
                                            statusText: (response || {})[0, $j1HbR._DYN_STATUS_TEXT /* @min:%2estatusText */ ],
                                            headerMap: null,
                                            correlationContext: _getFetchCorrelationContext(response)
                                        };
                                        if (_enableResponseHeaderTracking && response) {
                                            var responseHeaderMap_1 = {};
                                            response.headers.forEach(function(value, name) {
                                                if (_canIncludeHeaders(name)) responseHeaderMap_1[name] = value;
                                            });
                                            ajaxResponse[0, $j1HbR._DYN_HEADER_MAP /* @min:%2eheaderMap */ ] = responseHeaderMap_1;
                                        }
                                        return ajaxResponse;
                                    });
                                    return response;
                                })["catch"](function(reason) {
                                    _reportFetchMetrics(callDetails, 0, input, null, fetchData_1, null, {
                                        error: reason.message || (0, $3I5zg.dumpObj)(reason)
                                    });
                                    throw reason;
                                });
                            }
                        },
                        // Create an error callback to report any hook errors
                        hkErr: $7478fbe354599201$var$_createErrorCallbackFunc(_self, 15 /* _eInternalMessageId.FailedMonitorAjaxOpen */ , "Failed to monitor Window.fetch" + $7478fbe354599201$var$ERROR_POSTFIX)
                    }, true, $7478fbe354599201$var$isWebWorker()));
                    _fetchInitialized = true;
                } else if (isPolyfill) // If fetch is a polyfill we need to capture the request to ensure that we correctly track
                // disabled request URLS (i.e. internal urls) to ensure we don't end up in a constant loop
                // of reporting ourselves, for example React Native uses a polyfill for fetch
                // Note: Polyfill implementations that don't support the "poyyfill" tag are not supported
                // the workaround is to add a polyfill property to your fetch implementation before initializing
                // App Insights
                _addHook((0, $2CgMu.InstrumentFunc)(global, $7478fbe354599201$var$STR_FETCH, {
                    ns: _evtNamespace,
                    req: function(callDetails, input, init) {
                        // Just call so that we record any disabled URL
                        _isDisabledRequest(null, input, init);
                    }
                }));
                if (isPolyfill) // retag the instrumented fetch with the same polyfill settings this is mostly for testing
                // But also supports multiple App Insights usages
                global[$7478fbe354599201$var$STR_FETCH].polyfill = isPolyfill;
            }
            function _hookProto(target, funcName, callbacks) {
                _addHook((0, $2CgMu.InstrumentProto)(target, funcName, callbacks));
            }
            function _instrumentXhr() {
                if ($7478fbe354599201$var$_supportsAjaxMonitoring(_self, _ajaxDataId) && !_disableAjaxTracking && !_xhrInitialized) {
                    // Instrument open
                    _hookProto(XMLHttpRequest, "open", {
                        ns: _evtNamespace,
                        req: function(callDetails, method, url, async) {
                            if (!_disableAjaxTracking) {
                                var xhr = callDetails[0, $j1HbR._DYN_INST /* @min:%2einst */ ];
                                var ajaxData = $7478fbe354599201$var$_getAjaxData(xhr, _ajaxDataId);
                                if (!_isDisabledRequest(xhr, url) && _isMonitoredXhrInstance(xhr, ajaxData, true)) {
                                    if (!ajaxData || !ajaxData.xhrMonitoringState[0, $j1HbR._DYN_OPEN_DONE /* @min:%2eopenDone */ ]) // Only create a single ajaxData (even when multiple AI instances are running)
                                    ajaxData = _openHandler(xhr, method, url, async);
                                    // always attach to the on ready state change (required for handling multiple instances)
                                    _attachToOnReadyStateChange(xhr, ajaxData);
                                }
                            }
                        },
                        hkErr: $7478fbe354599201$var$_createErrorCallbackFunc(_self, 15 /* _eInternalMessageId.FailedMonitorAjaxOpen */ , $7478fbe354599201$var$ERROR_HEADER + ".open" + $7478fbe354599201$var$ERROR_POSTFIX)
                    });
                    // Instrument send
                    _hookProto(XMLHttpRequest, "send", {
                        ns: _evtNamespace,
                        req: function(callDetails, context) {
                            if (!_disableAjaxTracking) {
                                var xhr = callDetails[0, $j1HbR._DYN_INST /* @min:%2einst */ ];
                                var ajaxData = $7478fbe354599201$var$_getAjaxData(xhr, _ajaxDataId);
                                if (_isMonitoredXhrInstance(xhr, ajaxData) && !ajaxData.xhrMonitoringState[0, $j1HbR._DYN_SEND_DONE /* @min:%2esendDone */ ]) {
                                    _createMarkId("xhr", ajaxData);
                                    ajaxData[0, $j1HbR._DYN_REQUEST_SENT_TIME /* @min:%2erequestSentTime */ ] = (0, $4sUzw.dateTimeUtilsNow)();
                                    _self[0, $j1HbR._DYN_INCLUDE_CORRELATION_2 /* @min:%2eincludeCorrelationHeaders */ ](ajaxData, undefined, undefined, xhr);
                                    ajaxData.xhrMonitoringState[0, $j1HbR._DYN_SEND_DONE /* @min:%2esendDone */ ] = true;
                                }
                            }
                        },
                        hkErr: $7478fbe354599201$var$_createErrorCallbackFunc(_self, 17 /* _eInternalMessageId.FailedMonitorAjaxSend */ , $7478fbe354599201$var$ERROR_HEADER + $7478fbe354599201$var$ERROR_POSTFIX)
                    });
                    // Instrument abort
                    _hookProto(XMLHttpRequest, "abort", {
                        ns: _evtNamespace,
                        req: function(callDetails) {
                            if (!_disableAjaxTracking) {
                                var xhr = callDetails[0, $j1HbR._DYN_INST /* @min:%2einst */ ];
                                var ajaxData = $7478fbe354599201$var$_getAjaxData(xhr, _ajaxDataId);
                                if (_isMonitoredXhrInstance(xhr, ajaxData) && !ajaxData.xhrMonitoringState[0, $j1HbR._DYN_ABORT_DONE /* @min:%2eabortDone */ ]) {
                                    ajaxData[0, $j1HbR._DYN_ABORTED /* @min:%2eaborted */ ] = 1;
                                    ajaxData.xhrMonitoringState[0, $j1HbR._DYN_ABORT_DONE /* @min:%2eabortDone */ ] = true;
                                }
                            }
                        },
                        hkErr: $7478fbe354599201$var$_createErrorCallbackFunc(_self, 13 /* _eInternalMessageId.FailedMonitorAjaxAbort */ , $7478fbe354599201$var$ERROR_HEADER + ".abort" + $7478fbe354599201$var$ERROR_POSTFIX)
                    });
                    // Instrument setRequestHeader
                    _hookProto(XMLHttpRequest, "setRequestHeader", {
                        ns: _evtNamespace,
                        req: function(callDetails, header, value) {
                            if (!_disableAjaxTracking) {
                                var xhr = callDetails[0, $j1HbR._DYN_INST /* @min:%2einst */ ];
                                var ajaxData = $7478fbe354599201$var$_getAjaxData(xhr, _ajaxDataId);
                                if (ajaxData && _isMonitoredXhrInstance(xhr, ajaxData)) {
                                    $7478fbe354599201$var$_addSharedXhrHeaders(xhr, header, value);
                                    if (_enableRequestHeaderTracking && _canIncludeHeaders(header)) {
                                        if (ajaxData) ajaxData[0, $j1HbR._DYN_REQUEST_HEADERS /* @min:%2erequestHeaders */ ][header] = value;
                                    }
                                }
                            }
                        },
                        hkErr: $7478fbe354599201$var$_createErrorCallbackFunc(_self, 71 /* _eInternalMessageId.FailedMonitorAjaxSetRequestHeader */ , $7478fbe354599201$var$ERROR_HEADER + ".setRequestHeader" + $7478fbe354599201$var$ERROR_POSTFIX)
                    });
                    _xhrInitialized = true;
                }
            }
            function _isDisabledRequest(xhr, request, init) {
                var isDisabled = false;
                var theUrl = ((!(0, $erRAP.isString)(request) ? (request || {}).url || "" : request) || "")[0, $j1HbR._DYN_TO_LOWER_CASE /* @min:%2etoLowerCase */ ]();
                // check excludeRequestFromAutoTrackingPatterns before stripping off any query string
                (0, $erRAP.arrForEach)(_excludeRequestFromAutoTrackingPatterns, function(regex) {
                    var theRegex = regex;
                    if ((0, $erRAP.isString)(regex)) theRegex = new RegExp(regex);
                    if (!isDisabled) isDisabled = theRegex.test(theUrl);
                });
                // if request url matches with exclude regex pattern, return true and no need to check for headers
                if (isDisabled) return isDisabled;
                var idx = $7478fbe354599201$var$_indexOf(theUrl, "?");
                var idx2 = $7478fbe354599201$var$_indexOf(theUrl, "#");
                if (idx === -1 || idx2 !== -1 && idx2 < idx) idx = idx2;
                if (idx !== -1) // Strip off any Query string
                theUrl = theUrl.substring(0, idx);
                // check that this instance is not not used by ajax call performed inside client side monitoring to send data to collector
                if (!(0, $erRAP.isNullOrUndefined)(xhr)) // Look on the XMLHttpRequest of the URL string value
                isDisabled = xhr[0, $dCW8D.DisabledPropertyName] === true || theUrl[0, $dCW8D.DisabledPropertyName] === true;
                else if (!(0, $erRAP.isNullOrUndefined)(request)) // Look for DisabledPropertyName in either Request or RequestInit
                isDisabled = (typeof request === "object" ? request[0, $dCW8D.DisabledPropertyName] === true : false) || (init ? init[0, $dCW8D.DisabledPropertyName] === true : false);
                // Also add extra check just in case the XHR or fetch objects where not decorated with the DisableProperty due to sealing or freezing
                if (!isDisabled && theUrl && (0, $4sUzw.isInternalApplicationInsightsEndpoint)(theUrl)) isDisabled = true;
                if (isDisabled) // Add the disabled url if not present
                {
                    if (!_disabledUrls[theUrl]) _disabledUrls[theUrl] = 1;
                } else // Check to see if the url is listed as disabled
                if (_disabledUrls[theUrl]) isDisabled = true;
                return isDisabled;
            }
            /// <summary>Verifies that particular instance of XMLHttpRequest needs to be monitored</summary>
            /// <param name="excludeAjaxDataValidation">Optional parameter. True if ajaxData must be excluded from verification</param>
            /// <returns type="bool">True if instance needs to be monitored, otherwise false</returns>
            function _isMonitoredXhrInstance(xhr, ajaxData, excludeAjaxDataValidation) {
                var ajaxValidation = true;
                var initialized = _xhrInitialized;
                if (!(0, $erRAP.isNullOrUndefined)(xhr)) ajaxValidation = excludeAjaxDataValidation === true || !(0, $erRAP.isNullOrUndefined)(ajaxData);
                // checking to see that all interested functions on xhr were instrumented
                return initialized && ajaxValidation;
            }
            function _getDistributedTraceCtx() {
                var distributedTraceCtx = null;
                if (_self[0, $j1HbR._DYN_CORE /* @min:%2ecore */ ] && _self[0, $j1HbR._DYN_CORE /* @min:%2ecore */ ].getTraceCtx) distributedTraceCtx = _self[0, $j1HbR._DYN_CORE /* @min:%2ecore */ ].getTraceCtx(false);
                // Fall back
                if (!distributedTraceCtx && _context && _context.telemetryTrace) distributedTraceCtx = (0, $4sUzw.createDistributedTraceContextFromTrace)(_context.telemetryTrace);
                return distributedTraceCtx;
            }
            function _openHandler(xhr, method, url, async) {
                var _a;
                var distributedTraceCtx = _getDistributedTraceCtx();
                var traceID = distributedTraceCtx && distributedTraceCtx[0, $j1HbR._DYN_GET_TRACE_ID /* @min:%2egetTraceId */ ]() || (0, $iBAi6.generateW3CId)();
                var spanID = (0, $iBAi6.generateW3CId)().substr(0, 16);
                var xhrRequestData = xhr[$7478fbe354599201$var$AJAX_DATA_CONTAINER] = xhr[$7478fbe354599201$var$AJAX_DATA_CONTAINER] || {
                    xh: [],
                    i: {}
                };
                var ajaxDataCntr = xhrRequestData.i = xhrRequestData.i || {};
                var ajaxData = ajaxDataCntr[_ajaxDataId] = ajaxDataCntr[_ajaxDataId] || new (0, $aZeII.ajaxRecord)(traceID, spanID, _self[$7478fbe354599201$var$strDiagLog](), (_a = _self.core) === null || _a === void 0 ? void 0 : _a.getTraceCtx());
                ajaxData[0, $j1HbR._DYN_TRACE_FLAGS /* @min:%2etraceFlags */ ] = distributedTraceCtx && distributedTraceCtx[0, $j1HbR._DYN_GET_TRACE_FLAGS /* @min:%2egetTraceFlags */ ]();
                ajaxData[0, $j1HbR._DYN_METHOD /* @min:%2emethod */ ] = method;
                ajaxData[0, $j1HbR._DYN_REQUEST_URL /* @min:%2erequestUrl */ ] = url;
                ajaxData.xhrMonitoringState[0, $j1HbR._DYN_OPEN_DONE /* @min:%2eopenDone */ ] = true;
                ajaxData[0, $j1HbR._DYN_REQUEST_HEADERS /* @min:%2erequestHeaders */ ] = {};
                ajaxData.async = async;
                ajaxData[0, $j1HbR._DYN_ERROR_STATUS_TEXT /* @min:%2eerrorStatusText */ ] = _enableAjaxErrorStatusText;
                return ajaxData;
            }
            function _attachToOnReadyStateChange(xhr, ajaxData) {
                ajaxData.xhrMonitoringState[0, $j1HbR._DYN_STATE_CHANGE_ATTACHE14 /* @min:%2estateChangeAttached */ ] = (0, $cIC5n.eventOn)(xhr, "readystatechange", function() {
                    try {
                        if (xhr && xhr.readyState === 4 && _isMonitoredXhrInstance(xhr, ajaxData)) _onAjaxComplete(xhr);
                    } catch (e) {
                        var exceptionText = (0, $3I5zg.dumpObj)(e);
                        // ignore messages with c00c023f, as this a known IE9 XHR abort issue
                        if (!exceptionText || $7478fbe354599201$var$_indexOf(exceptionText[0, $j1HbR._DYN_TO_LOWER_CASE /* @min:%2etoLowerCase */ ](), "c00c023f") === -1) $7478fbe354599201$var$_throwInternalCritical(_self, 16 /* _eInternalMessageId.FailedMonitorAjaxRSC */ , $7478fbe354599201$var$ERROR_HEADER + " 'readystatechange' event handler" + $7478fbe354599201$var$ERROR_POSTFIX, {
                            ajaxDiagnosticsMessage: $7478fbe354599201$var$_getFailedAjaxDiagnosticsMessage(xhr, _ajaxDataId),
                            exception: exceptionText
                        });
                    }
                }, _evtNamespace);
            }
            function _getResponseText(xhr) {
                try {
                    var responseType = xhr.responseType;
                    if (responseType === "" || responseType === "text") // As per the specification responseText is only valid if the type is an empty string or "text"
                    return xhr[0, $j1HbR._DYN_RESPONSE_TEXT /* @min:%2eresponseText */ ];
                } catch (e) {
                // This shouldn't happen because of the above check -- but just in case, so just ignore
                }
                return null;
            }
            function _onAjaxComplete(xhr) {
                var ajaxData = $7478fbe354599201$var$_getAjaxData(xhr, _ajaxDataId);
                ajaxData[0, $j1HbR._DYN_RESPONSE_FINISHED_TI15 /* @min:%2eresponseFinishedTime */ ] = (0, $4sUzw.dateTimeUtilsNow)();
                ajaxData[0, $j1HbR._DYN_STATUS /* @min:%2estatus */ ] = xhr[0, $j1HbR._DYN_STATUS /* @min:%2estatus */ ];
                function _reportXhrError(e, failedProps) {
                    var errorProps = failedProps || {};
                    errorProps["ajaxDiagnosticsMessage"] = $7478fbe354599201$var$_getFailedAjaxDiagnosticsMessage(xhr, _ajaxDataId);
                    if (e) errorProps["exception"] = (0, $3I5zg.dumpObj)(e);
                    $7478fbe354599201$var$_throwInternalWarning(_self, 14 /* _eInternalMessageId.FailedMonitorAjaxDur */ , $7478fbe354599201$var$FAILED_TO_CALCULATE_DURATION_ERROR + "ajax call" + $7478fbe354599201$var$ERROR_NOT_SENT, errorProps);
                }
                _findPerfResourceEntry("xmlhttprequest", ajaxData, function() {
                    try {
                        var dependency = ajaxData[0, $j1HbR._DYN__CREATE_TRACK_ITEM /* @min:%2eCreateTrackItem */ ]("Ajax", _enableRequestHeaderTracking, function() {
                            var ajaxResponse = {
                                statusText: xhr[0, $j1HbR._DYN_STATUS_TEXT /* @min:%2estatusText */ ],
                                headerMap: null,
                                correlationContext: _getAjaxCorrelationContext(xhr),
                                type: xhr.responseType,
                                responseText: _getResponseText(xhr),
                                response: xhr[0, $j1HbR._DYN_RESPONSE /* @min:%2eresponse */ ]
                            };
                            if (_enableResponseHeaderTracking) {
                                var headers = xhr[0, $j1HbR._DYN_GET_ALL_RESPONSE_HEA16 /* @min:%2egetAllResponseHeaders */ ]();
                                if (headers) {
                                    // xhr.getAllResponseHeaders() method returns all the response headers, separated by CRLF, as a string or null
                                    // the regex converts the header string into an array of individual headers
                                    var arr = (0, $erRAP.strTrim)(headers).split(/[\r\n]+/);
                                    var responseHeaderMap_2 = {};
                                    (0, $erRAP.arrForEach)(arr, function(line) {
                                        var parts = line.split(": ");
                                        var header = parts.shift();
                                        var value = parts.join(": ");
                                        if (_canIncludeHeaders(header)) responseHeaderMap_2[header] = value;
                                    });
                                    ajaxResponse[0, $j1HbR._DYN_HEADER_MAP /* @min:%2eheaderMap */ ] = responseHeaderMap_2;
                                }
                            }
                            return ajaxResponse;
                        });
                        var properties = void 0;
                        try {
                            if (!!_addRequestContext) properties = _addRequestContext({
                                status: xhr[0, $j1HbR._DYN_STATUS /* @min:%2estatus */ ],
                                xhr: xhr
                            });
                        } catch (e) {
                            $7478fbe354599201$var$_throwInternalWarning(_self, 104 /* _eInternalMessageId.FailedAddingCustomDefinedRequestContext */ , $7478fbe354599201$var$CUSTOM_REQUEST_CONTEXT_ERROR);
                        }
                        if (dependency) {
                            if (properties !== undefined) dependency[0, $ag2Pd.STR_PROPERTIES /* @min:%2eproperties */ ] = (0, $fcMe7.__assignFn)((0, $fcMe7.__assignFn)({}, dependency.properties), properties);
                            var sysProperties = ajaxData[0, $j1HbR._DYN_GET_PART_APROPS /* @min:%2egetPartAProps */ ]();
                            _reportDependencyInternal(_dependencyInitializers, _self[0, $j1HbR._DYN_CORE /* @min:%2ecore */ ], ajaxData, dependency, null, sysProperties);
                        } else _reportXhrError(null, {
                            requestSentTime: ajaxData[0, $j1HbR._DYN_REQUEST_SENT_TIME /* @min:%2erequestSentTime */ ],
                            responseFinishedTime: ajaxData[0, $j1HbR._DYN_RESPONSE_FINISHED_TI15 /* @min:%2eresponseFinishedTime */ ]
                        });
                    } finally{
                        // cleanup telemetry data
                        try {
                            var xhrRequestData = xhr[$7478fbe354599201$var$AJAX_DATA_CONTAINER] || {
                                i: {}
                            };
                            var ajaxDataCntr = xhrRequestData.i || {};
                            if (ajaxDataCntr[_ajaxDataId]) ajaxDataCntr[_ajaxDataId] = null;
                        } catch (e) {
                        // May throw in environments that prevent extension or freeze xhr
                        }
                    }
                }, function(e) {
                    _reportXhrError(e, null);
                });
            }
            function _getAjaxCorrelationContext(xhr) {
                try {
                    var responseHeadersString = xhr[0, $j1HbR._DYN_GET_ALL_RESPONSE_HEA16 /* @min:%2egetAllResponseHeaders */ ]();
                    if (responseHeadersString !== null) {
                        var index = $7478fbe354599201$var$_indexOf(responseHeadersString[0, $j1HbR._DYN_TO_LOWER_CASE /* @min:%2etoLowerCase */ ](), (0, $f5lFa.RequestHeaders)[8 /* eRequestHeaders.requestContextHeaderLowerCase */ ]);
                        if (index !== -1) {
                            var responseHeader = xhr.getResponseHeader((0, $f5lFa.RequestHeaders)[0 /* eRequestHeaders.requestContextHeader */ ]);
                            return (0, $4sUzw.CorrelationIdHelper)[0, $j1HbR._DYN_GET_CORRELATION_CONT17 /* @min:%2egetCorrelationContext */ ](responseHeader);
                        }
                    }
                } catch (e) {
                    $7478fbe354599201$var$_throwInternalWarning(_self, 18 /* _eInternalMessageId.FailedMonitorAjaxGetCorrelationHeader */ , $7478fbe354599201$var$CORRELATION_HEADER_ERROR, {
                        ajaxDiagnosticsMessage: $7478fbe354599201$var$_getFailedAjaxDiagnosticsMessage(xhr, _ajaxDataId),
                        exception: (0, $3I5zg.dumpObj)(e)
                    });
                }
            }
            function _createMarkId(type, ajaxData) {
                if (ajaxData[0, $j1HbR._DYN_REQUEST_URL /* @min:%2erequestUrl */ ] && _markPrefix && _enableAjaxPerfTracking) {
                    var performance_1 = (0, $3I5zg.getPerformance)();
                    if (performance_1 && (0, $erRAP.isFunction)(performance_1.mark)) {
                        $7478fbe354599201$var$_markCount++;
                        var markId = _markPrefix + type + "#" + $7478fbe354599201$var$_markCount;
                        performance_1.mark(markId);
                        var entries = performance_1.getEntriesByName(markId);
                        if (entries && entries[0, $j1HbR._DYN_LENGTH /* @min:%2elength */ ] === 1) ajaxData[0, $j1HbR._DYN_PERF_MARK /* @min:%2eperfMark */ ] = entries[0];
                    }
                }
            }
            function _findPerfResourceEntry(initiatorType, ajaxData, trackCallback, reportError) {
                var perfMark = ajaxData[0, $j1HbR._DYN_PERF_MARK /* @min:%2eperfMark */ ];
                var performance = (0, $3I5zg.getPerformance)();
                var maxAttempts = _config.maxAjaxPerfLookupAttempts;
                var retryDelay = _config[0, $j1HbR._DYN_AJAX_PERF_LOOKUP_DEL18 /* @min:%2eajaxPerfLookupDelay */ ];
                var requestUrl = ajaxData[0, $j1HbR._DYN_REQUEST_URL /* @min:%2erequestUrl */ ];
                var attempt = 0;
                (function locateResourceTiming() {
                    try {
                        if (performance && perfMark) {
                            attempt++;
                            var perfTiming = null;
                            var entries = performance.getEntries();
                            for(var lp = entries[0, $j1HbR._DYN_LENGTH /* @min:%2elength */ ] - 1; lp >= 0; lp--){
                                var entry = entries[lp];
                                if (entry) {
                                    if (entry.entryType === "resource") {
                                        if (entry.initiatorType === initiatorType && ($7478fbe354599201$var$_indexOf(entry[0, $j1HbR._DYN_NAME /* @min:%2ename */ ], requestUrl) !== -1 || $7478fbe354599201$var$_indexOf(requestUrl, entry[0, $j1HbR._DYN_NAME /* @min:%2ename */ ]) !== -1)) perfTiming = entry;
                                    } else if (entry.entryType === "mark" && entry[0, $j1HbR._DYN_NAME /* @min:%2ename */ ] === perfMark[0, $j1HbR._DYN_NAME /* @min:%2ename */ ]) {
                                        // We hit the start event
                                        ajaxData[0, $j1HbR._DYN_PERF_TIMING /* @min:%2eperfTiming */ ] = perfTiming;
                                        break;
                                    }
                                    if (entry[0, $j1HbR._DYN_START_TIME /* @min:%2estartTime */ ] < perfMark[0, $j1HbR._DYN_START_TIME /* @min:%2estartTime */ ] - 1000) break;
                                }
                            }
                        }
                        if (!perfMark || // - we don't have a perfMark or
                        ajaxData[0, $j1HbR._DYN_PERF_TIMING /* @min:%2eperfTiming */ ] || // - we have not found the perf entry or
                        attempt >= maxAttempts || // - we have tried too many attempts or
                        ajaxData.async === false) {
                            if (perfMark && (0, $erRAP.isFunction)(performance.clearMarks)) // Remove the mark so we don't fill up the performance resources too much
                            performance.clearMarks(perfMark[0, $j1HbR._DYN_NAME /* @min:%2ename */ ]);
                            ajaxData.perfAttempts = attempt;
                            // just continue and report the track event
                            trackCallback();
                        } else // We need to wait for the browser to populate the window.performance entry
                        // This needs to be at least 1ms as waiting <= 1 (on firefox) is not enough time for fetch or xhr,
                        // this is a scheduling issue for the browser implementation
                        setTimeout(locateResourceTiming, retryDelay);
                    } catch (e) {
                        reportError(e);
                    }
                })();
            }
            function _createFetchRecord(input, init) {
                var _a;
                var distributedTraceCtx = _getDistributedTraceCtx();
                var traceID = distributedTraceCtx && distributedTraceCtx[0, $j1HbR._DYN_GET_TRACE_ID /* @min:%2egetTraceId */ ]() || (0, $iBAi6.generateW3CId)();
                var spanID = (0, $iBAi6.generateW3CId)().substr(0, 16);
                var ajaxData = new (0, $aZeII.ajaxRecord)(traceID, spanID, _self[$7478fbe354599201$var$strDiagLog](), (_a = _self.core) === null || _a === void 0 ? void 0 : _a.getTraceCtx());
                ajaxData[0, $j1HbR._DYN_TRACE_FLAGS /* @min:%2etraceFlags */ ] = distributedTraceCtx && distributedTraceCtx[0, $j1HbR._DYN_GET_TRACE_FLAGS /* @min:%2egetTraceFlags */ ]();
                ajaxData[0, $j1HbR._DYN_REQUEST_SENT_TIME /* @min:%2erequestSentTime */ ] = (0, $4sUzw.dateTimeUtilsNow)();
                ajaxData[0, $j1HbR._DYN_ERROR_STATUS_TEXT /* @min:%2eerrorStatusText */ ] = _enableAjaxErrorStatusText;
                if (input instanceof Request) ajaxData[0, $j1HbR._DYN_REQUEST_URL /* @min:%2erequestUrl */ ] = input ? input.url : "";
                else ajaxData[0, $j1HbR._DYN_REQUEST_URL /* @min:%2erequestUrl */ ] = input;
                var method = "GET";
                if (init && init[0, $j1HbR._DYN_METHOD /* @min:%2emethod */ ]) method = init[0, $j1HbR._DYN_METHOD /* @min:%2emethod */ ];
                else if (input && input instanceof Request) method = input[0, $j1HbR._DYN_METHOD /* @min:%2emethod */ ];
                ajaxData[0, $j1HbR._DYN_METHOD /* @min:%2emethod */ ] = method;
                var requestHeaders = {};
                if (_enableRequestHeaderTracking) {
                    var headers = new Headers((init ? init[0, $j1HbR._DYN_HEADERS /* @min:%2eheaders */ ] : 0) || (input instanceof Request ? input[0, $j1HbR._DYN_HEADERS /* @min:%2eheaders */ ] || {} : {}));
                    headers.forEach(function(value, key) {
                        if (_canIncludeHeaders(key)) requestHeaders[key] = value;
                    });
                }
                ajaxData[0, $j1HbR._DYN_REQUEST_HEADERS /* @min:%2erequestHeaders */ ] = requestHeaders;
                _createMarkId($7478fbe354599201$var$STR_FETCH, ajaxData);
                return ajaxData;
            }
            function _getFailedFetchDiagnosticsMessage(input) {
                var result = "";
                try {
                    if (!(0, $erRAP.isNullOrUndefined)(input)) {
                        if ((0, $erRAP.isString)(input)) result += "(url: '".concat(input, "')");
                        else result += "(url: '".concat(input.url, "')");
                    }
                } catch (e) {
                    $7478fbe354599201$var$_throwInternalCritical(_self, 15 /* _eInternalMessageId.FailedMonitorAjaxOpen */ , "Failed to grab failed fetch diagnostics message", {
                        exception: (0, $3I5zg.dumpObj)(e)
                    });
                }
                return result;
            }
            function _reportFetchMetrics(callDetails, status, input, response, ajaxData, getResponse, properties) {
                if (!ajaxData) return;
                function _reportFetchError(msgId, e, failedProps) {
                    var errorProps = failedProps || {};
                    errorProps["fetchDiagnosticsMessage"] = _getFailedFetchDiagnosticsMessage(input);
                    if (e) errorProps["exception"] = (0, $3I5zg.dumpObj)(e);
                    $7478fbe354599201$var$_throwInternalWarning(_self, msgId, $7478fbe354599201$var$FAILED_TO_CALCULATE_DURATION_ERROR + "fetch call" + $7478fbe354599201$var$ERROR_NOT_SENT, errorProps);
                }
                ajaxData[0, $j1HbR._DYN_RESPONSE_FINISHED_TI15 /* @min:%2eresponseFinishedTime */ ] = (0, $4sUzw.dateTimeUtilsNow)();
                ajaxData[0, $j1HbR._DYN_STATUS /* @min:%2estatus */ ] = status;
                _findPerfResourceEntry($7478fbe354599201$var$STR_FETCH, ajaxData, function() {
                    var dependency = ajaxData[0, $j1HbR._DYN__CREATE_TRACK_ITEM /* @min:%2eCreateTrackItem */ ]("Fetch", _enableRequestHeaderTracking, getResponse);
                    var properties;
                    try {
                        if (!!_addRequestContext) properties = _addRequestContext({
                            status: status,
                            request: input,
                            response: response
                        });
                    } catch (e) {
                        $7478fbe354599201$var$_throwInternalWarning(_self, 104 /* _eInternalMessageId.FailedAddingCustomDefinedRequestContext */ , $7478fbe354599201$var$CUSTOM_REQUEST_CONTEXT_ERROR);
                    }
                    if (dependency) {
                        if (properties !== undefined) dependency[0, $ag2Pd.STR_PROPERTIES /* @min:%2eproperties */ ] = (0, $fcMe7.__assignFn)((0, $fcMe7.__assignFn)({}, dependency.properties), properties);
                        var sysProperties = ajaxData[0, $j1HbR._DYN_GET_PART_APROPS /* @min:%2egetPartAProps */ ]();
                        _reportDependencyInternal(_dependencyInitializers, _self[0, $j1HbR._DYN_CORE /* @min:%2ecore */ ], ajaxData, dependency, null, sysProperties);
                    } else _reportFetchError(14 /* _eInternalMessageId.FailedMonitorAjaxDur */ , null, {
                        requestSentTime: ajaxData[0, $j1HbR._DYN_REQUEST_SENT_TIME /* @min:%2erequestSentTime */ ],
                        responseFinishedTime: ajaxData[0, $j1HbR._DYN_RESPONSE_FINISHED_TI15 /* @min:%2eresponseFinishedTime */ ]
                    });
                }, function(e) {
                    _reportFetchError(18 /* _eInternalMessageId.FailedMonitorAjaxGetCorrelationHeader */ , e, null);
                });
            }
            function _getFetchCorrelationContext(response) {
                if (response && response[0, $j1HbR._DYN_HEADERS /* @min:%2eheaders */ ]) try {
                    var responseHeader = response[0, $j1HbR._DYN_HEADERS /* @min:%2eheaders */ ].get((0, $f5lFa.RequestHeaders)[0 /* eRequestHeaders.requestContextHeader */ ]);
                    return (0, $4sUzw.CorrelationIdHelper)[0, $j1HbR._DYN_GET_CORRELATION_CONT17 /* @min:%2egetCorrelationContext */ ](responseHeader);
                } catch (e) {
                    $7478fbe354599201$var$_throwInternalWarning(_self, 18 /* _eInternalMessageId.FailedMonitorAjaxGetCorrelationHeader */ , $7478fbe354599201$var$CORRELATION_HEADER_ERROR, {
                        fetchDiagnosticsMessage: _getFailedFetchDiagnosticsMessage(response),
                        exception: (0, $3I5zg.dumpObj)(e)
                    });
                }
            }
            function _reportDependencyInternal(initializers, core, ajaxData, dependency, properties, systemProperties) {
                var result = true;
                var initializersCount = initializers[0, $j1HbR._DYN_LENGTH /* @min:%2elength */ ];
                if (initializersCount > 0) {
                    var details = {
                        item: dependency,
                        properties: properties,
                        sysProperties: systemProperties,
                        context: ajaxData ? ajaxData[0, $j1HbR._DYN_CONTEXT /* @min:%2econtext */ ] : null,
                        aborted: ajaxData ? !!ajaxData[0, $j1HbR._DYN_ABORTED /* @min:%2eaborted */ ] : false
                    };
                    result = $7478fbe354599201$var$_processDependencyContainer(core, initializers, details, "initializer");
                }
                if (result) _self[0, $j1HbR._DYN_TRACK_DEPENDENCY_DAT4 /* @min:%2etrackDependencyDataInternal */ ](dependency, properties, systemProperties);
            }
        });
        return _this;
    }
    // Removed Stub for AjaxMonitor.prototype.initialize.
    AjaxMonitor.prototype.processTelemetry = function(item, itemCtx) {
        this.processNext(item, itemCtx);
    };
    // Removed Stub for AjaxMonitor.prototype.trackDependencyData.
    // Removed Stub for AjaxMonitor.prototype.includeCorrelationHeaders.
    // Removed Stub for AjaxMonitor.prototype.addDependencyListener.
    /**
     * Add an dependency telemetry initializer callback function to allow populating additional properties or drop the request.
     * It is called after the dependency call has completed and any available performance details are available. A dependency
     * initializer is similar to the TelemetryInitializer function but it allows you to block the reporting of the dependency
     * request so that it doesn't count against the `maxAjaxCallsPerView`.
     * @param dependencyInitializer - The Dependency Telemetry Initializer function
     * @returns - A IDependencyInitializerHandler to enable the initializer to be removed
     */ AjaxMonitor.prototype.addDependencyInitializer = function(dependencyInitializer) {
        return null;
    };
    // Removed Stub for AjaxMonitor.prototype.trackDependencyDataInternal.
    AjaxMonitor.identifier = "AjaxDependencyPlugin";
    AjaxMonitor.getDefaultConfig = $7478fbe354599201$var$_getDefaultConfig;
    AjaxMonitor.getEmptyConfig = $7478fbe354599201$var$_getEmptyConfig;
    return AjaxMonitor;
}((0, $3wvVb.BaseTelemetryPlugin));

});
parcelRegister("ag2Pd", function(module, exports) {

$parcel$export(module.exports, "STR_DURATION", function () { return $777d9705ee6d7ac5$export$be41298b7716c698; });
$parcel$export(module.exports, "STR_PROPERTIES", function () { return $777d9705ee6d7ac5$export$400e70f2a2ecb5aa; });
/*
 * Application Insights JavaScript SDK - Dependencies Plugin, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ // !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// Note: DON'T Export these const from the package as we are still targeting ES3 this will export a mutable variables that someone could change!!!
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// Generally you should only put values that are used more than 2 times and then only if not already exposed as a constant (such as SdkCoreNames)
// as when using "short" named values from here they will be will be minified smaller than the SdkCoreNames[eSdkCoreNames.xxxx] value.
var $777d9705ee6d7ac5$export$be41298b7716c698 = "duration";
var $777d9705ee6d7ac5$export$400e70f2a2ecb5aa = "properties";

});

parcelRegister("j1HbR", function(module, exports) {

$parcel$export(module.exports, "_DYN_REQUEST_URL", function () { return $dd9f9d03285ba266$export$8ff033ecd75b66c3; });
$parcel$export(module.exports, "_DYN_INST", function () { return $dd9f9d03285ba266$export$25a34734290022f3; });
$parcel$export(module.exports, "_DYN_LENGTH", function () { return $dd9f9d03285ba266$export$6eae51590aaea43; });
$parcel$export(module.exports, "_DYN_TRACE_ID", function () { return $dd9f9d03285ba266$export$a5eb52c53bba8560; });
$parcel$export(module.exports, "_DYN_SPAN_ID", function () { return $dd9f9d03285ba266$export$c105b94efa183847; });
$parcel$export(module.exports, "_DYN_TRACE_FLAGS", function () { return $dd9f9d03285ba266$export$4e92e4b92b41ba2d; });
$parcel$export(module.exports, "_DYN_CONTEXT", function () { return $dd9f9d03285ba266$export$fdcd48959e13aba7; });
$parcel$export(module.exports, "_DYN_ABORTED", function () { return $dd9f9d03285ba266$export$fcf18cee9ee41961; });
$parcel$export(module.exports, "_DYN_TRACE_ID0", function () { return $dd9f9d03285ba266$export$f8d9e07631527156; });
$parcel$export(module.exports, "_DYN_SPAN_ID1", function () { return $dd9f9d03285ba266$export$e39be82dc519c4ae; });
$parcel$export(module.exports, "_DYN_CORE", function () { return $dd9f9d03285ba266$export$f9ae8d0acf86503e; });
$parcel$export(module.exports, "_DYN_INCLUDE_CORRELATION_2", function () { return $dd9f9d03285ba266$export$ec2c4b7da1ef8dd0; });
$parcel$export(module.exports, "_DYN_CAN_INCLUDE_CORRELAT3", function () { return $dd9f9d03285ba266$export$ae427c8b4e4f202a; });
$parcel$export(module.exports, "_DYN_GET_ABSOLUTE_URL", function () { return $dd9f9d03285ba266$export$de5be3709039b9b0; });
$parcel$export(module.exports, "_DYN_HEADERS", function () { return $dd9f9d03285ba266$export$829ed22a43b4aada; });
$parcel$export(module.exports, "_DYN_REQUEST_HEADERS", function () { return $dd9f9d03285ba266$export$b58618e731cdb301; });
$parcel$export(module.exports, "_DYN_APP_ID", function () { return $dd9f9d03285ba266$export$3d3b09d87c20a6d6; });
$parcel$export(module.exports, "_DYN_SET_REQUEST_HEADER", function () { return $dd9f9d03285ba266$export$84ecd29f369f5b1d; });
$parcel$export(module.exports, "_DYN_TRACK_DEPENDENCY_DAT4", function () { return $dd9f9d03285ba266$export$bc1ce1356cea67a; });
$parcel$export(module.exports, "_DYN_DISTRIBUTED_TRACING_5", function () { return $dd9f9d03285ba266$export$cc97618f4c74340f; });
$parcel$export(module.exports, "_DYN_START_TIME", function () { return $dd9f9d03285ba266$export$69cac26425c8ea23; });
$parcel$export(module.exports, "_DYN_TO_LOWER_CASE", function () { return $dd9f9d03285ba266$export$e4eaee9e01d9baaa; });
$parcel$export(module.exports, "_DYN_ENABLE_REQUEST_HEADE6", function () { return $dd9f9d03285ba266$export$574c5c1d5bb17955; });
$parcel$export(module.exports, "_DYN_ENABLE_AJAX_ERROR_ST7", function () { return $dd9f9d03285ba266$export$c9cd806c1fef7192; });
$parcel$export(module.exports, "_DYN_ENABLE_AJAX_PERF_TRA8", function () { return $dd9f9d03285ba266$export$7c0a9d78ce383de9; });
$parcel$export(module.exports, "_DYN_MAX_AJAX_CALLS_PER_V9", function () { return $dd9f9d03285ba266$export$7f047061a0f4113a; });
$parcel$export(module.exports, "_DYN_ENABLE_RESPONSE_HEAD10", function () { return $dd9f9d03285ba266$export$650df8a93357784d; });
$parcel$export(module.exports, "_DYN_EXCLUDE_REQUEST_FROM11", function () { return $dd9f9d03285ba266$export$16e1c69e14a7249e; });
$parcel$export(module.exports, "_DYN_ADD_REQUEST_CONTEXT", function () { return $dd9f9d03285ba266$export$e9d1b90025f35753; });
$parcel$export(module.exports, "_DYN_DISABLE_AJAX_TRACKIN12", function () { return $dd9f9d03285ba266$export$966ff5e4f4a47843; });
$parcel$export(module.exports, "_DYN_DISABLE_FETCH_TRACKI13", function () { return $dd9f9d03285ba266$export$674680799cc6c04c; });
$parcel$export(module.exports, "_DYN_STATUS", function () { return $dd9f9d03285ba266$export$f8d169088a01f6f2; });
$parcel$export(module.exports, "_DYN_STATUS_TEXT", function () { return $dd9f9d03285ba266$export$e44f43b238a0c7f0; });
$parcel$export(module.exports, "_DYN_HEADER_MAP", function () { return $dd9f9d03285ba266$export$422ea83a60e3414b; });
$parcel$export(module.exports, "_DYN_OPEN_DONE", function () { return $dd9f9d03285ba266$export$9984940f44bb6769; });
$parcel$export(module.exports, "_DYN_SEND_DONE", function () { return $dd9f9d03285ba266$export$ebd7b63f645a373e; });
$parcel$export(module.exports, "_DYN_REQUEST_SENT_TIME", function () { return $dd9f9d03285ba266$export$b3507d39ae3f3e22; });
$parcel$export(module.exports, "_DYN_ABORT_DONE", function () { return $dd9f9d03285ba266$export$dda6370f5a5c9f36; });
$parcel$export(module.exports, "_DYN_GET_TRACE_ID", function () { return $dd9f9d03285ba266$export$90dab0fe9b2b7158; });
$parcel$export(module.exports, "_DYN_GET_TRACE_FLAGS", function () { return $dd9f9d03285ba266$export$1fd22cf8d803736f; });
$parcel$export(module.exports, "_DYN_METHOD", function () { return $dd9f9d03285ba266$export$47d30bd816d62bdc; });
$parcel$export(module.exports, "_DYN_ERROR_STATUS_TEXT", function () { return $dd9f9d03285ba266$export$cce28811c9041832; });
$parcel$export(module.exports, "_DYN_STATE_CHANGE_ATTACHE14", function () { return $dd9f9d03285ba266$export$292775acf8df8831; });
$parcel$export(module.exports, "_DYN_RESPONSE_TEXT", function () { return $dd9f9d03285ba266$export$d9f76b3afffa4e88; });
$parcel$export(module.exports, "_DYN_RESPONSE_FINISHED_TI15", function () { return $dd9f9d03285ba266$export$182d7e789a77d304; });
$parcel$export(module.exports, "_DYN__CREATE_TRACK_ITEM", function () { return $dd9f9d03285ba266$export$e31aceb60e1b3a1a; });
$parcel$export(module.exports, "_DYN_RESPONSE", function () { return $dd9f9d03285ba266$export$71a9f4a2e496846d; });
$parcel$export(module.exports, "_DYN_GET_ALL_RESPONSE_HEA16", function () { return $dd9f9d03285ba266$export$6bf05f118580ffa; });
$parcel$export(module.exports, "_DYN_GET_PART_APROPS", function () { return $dd9f9d03285ba266$export$e2e640c31408a88f; });
$parcel$export(module.exports, "_DYN_GET_CORRELATION_CONT17", function () { return $dd9f9d03285ba266$export$c69633899eccb4a7; });
$parcel$export(module.exports, "_DYN_PERF_MARK", function () { return $dd9f9d03285ba266$export$9e85e7b326182790; });
$parcel$export(module.exports, "_DYN_AJAX_PERF_LOOKUP_DEL18", function () { return $dd9f9d03285ba266$export$1ee8a32f080b146; });
$parcel$export(module.exports, "_DYN_NAME", function () { return $dd9f9d03285ba266$export$9734b0a24bf02e93; });
$parcel$export(module.exports, "_DYN_PERF_TIMING", function () { return $dd9f9d03285ba266$export$6bec4987b5d3526c; });
$parcel$export(module.exports, "_DYN_CORRELATION_CONTEXT", function () { return $dd9f9d03285ba266$export$c4a9b5c39c7409f7; });
$parcel$export(module.exports, "_DYN_AJAX_TOTAL_DURATION", function () { return $dd9f9d03285ba266$export$7820e90f0eaab413; });
$parcel$export(module.exports, "_DYN_EVENT_TRACE_CTX", function () { return $dd9f9d03285ba266$export$c050ff25390a2bce; });
/*
 * Application Insights JavaScript SDK - Dependencies Plugin, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ // @skip-file-minify
// ##############################################################
// AUTO GENERATED FILE: This file is Auto Generated during build.
// ##############################################################
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// Note: DON'T Export these const from the package as we are still targeting ES3 this will export a mutable variables that someone could change!!!
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
var $dd9f9d03285ba266$export$8ff033ecd75b66c3 = "requestUrl"; // Count: 12
var $dd9f9d03285ba266$export$25a34734290022f3 = "inst"; // Count: 5
var $dd9f9d03285ba266$export$6eae51590aaea43 = "length"; // Count: 10
var $dd9f9d03285ba266$export$a5eb52c53bba8560 = "traceID"; // Count: 9
var $dd9f9d03285ba266$export$c105b94efa183847 = "spanID"; // Count: 8
var $dd9f9d03285ba266$export$4e92e4b92b41ba2d = "traceFlags"; // Count: 13
var $dd9f9d03285ba266$export$fdcd48959e13aba7 = "context"; // Count: 7
var $dd9f9d03285ba266$export$fcf18cee9ee41961 = "aborted"; // Count: 7
var $dd9f9d03285ba266$export$f8d9e07631527156 = "traceId"; // Count: 5
var $dd9f9d03285ba266$export$e39be82dc519c4ae = "spanId"; // Count: 5
var $dd9f9d03285ba266$export$f9ae8d0acf86503e = "core"; // Count: 8
var $dd9f9d03285ba266$export$ec2c4b7da1ef8dd0 = "includeCorrelationHeaders"; // Count: 4
var $dd9f9d03285ba266$export$ae427c8b4e4f202a = "canIncludeCorrelationHeader"; // Count: 2
var $dd9f9d03285ba266$export$de5be3709039b9b0 = "getAbsoluteUrl"; // Count: 3
var $dd9f9d03285ba266$export$829ed22a43b4aada = "headers"; // Count: 6
var $dd9f9d03285ba266$export$b58618e731cdb301 = "requestHeaders"; // Count: 13
var $dd9f9d03285ba266$export$3d3b09d87c20a6d6 = "appId"; // Count: 5
var $dd9f9d03285ba266$export$84ecd29f369f5b1d = "setRequestHeader"; // Count: 3
var $dd9f9d03285ba266$export$bc1ce1356cea67a = "trackDependencyDataInternal"; // Count: 2
var $dd9f9d03285ba266$export$cc97618f4c74340f = "distributedTracingMode"; // Count: 3
var $dd9f9d03285ba266$export$69cac26425c8ea23 = "startTime"; // Count: 6
var $dd9f9d03285ba266$export$e4eaee9e01d9baaa = "toLowerCase"; // Count: 6
var $dd9f9d03285ba266$export$574c5c1d5bb17955 = "enableRequestHeaderTracking"; // Count: 2
var $dd9f9d03285ba266$export$c9cd806c1fef7192 = "enableAjaxErrorStatusText"; // Count: 2
var $dd9f9d03285ba266$export$7c0a9d78ce383de9 = "enableAjaxPerfTracking"; // Count: 2
var $dd9f9d03285ba266$export$7f047061a0f4113a = "maxAjaxCallsPerView"; // Count: 2
var $dd9f9d03285ba266$export$650df8a93357784d = "enableResponseHeaderTracking"; // Count: 2
var $dd9f9d03285ba266$export$16e1c69e14a7249e = "excludeRequestFromAutoTrackingPatterns"; // Count: 2
var $dd9f9d03285ba266$export$e9d1b90025f35753 = "addRequestContext"; // Count: 2
var $dd9f9d03285ba266$export$966ff5e4f4a47843 = "disableAjaxTracking"; // Count: 2
var $dd9f9d03285ba266$export$674680799cc6c04c = "disableFetchTracking"; // Count: 2
var $dd9f9d03285ba266$export$f8d169088a01f6f2 = "status"; // Count: 11
var $dd9f9d03285ba266$export$e44f43b238a0c7f0 = "statusText"; // Count: 9
var $dd9f9d03285ba266$export$422ea83a60e3414b = "headerMap"; // Count: 8
var $dd9f9d03285ba266$export$9984940f44bb6769 = "openDone"; // Count: 3
var $dd9f9d03285ba266$export$ebd7b63f645a373e = "sendDone"; // Count: 3
var $dd9f9d03285ba266$export$b3507d39ae3f3e22 = "requestSentTime"; // Count: 9
var $dd9f9d03285ba266$export$dda6370f5a5c9f36 = "abortDone"; // Count: 3
var $dd9f9d03285ba266$export$90dab0fe9b2b7158 = "getTraceId"; // Count: 3
var $dd9f9d03285ba266$export$1fd22cf8d803736f = "getTraceFlags"; // Count: 3
var $dd9f9d03285ba266$export$47d30bd816d62bdc = "method"; // Count: 8
var $dd9f9d03285ba266$export$cce28811c9041832 = "errorStatusText"; // Count: 3
var $dd9f9d03285ba266$export$292775acf8df8831 = "stateChangeAttached"; // Count: 2
var $dd9f9d03285ba266$export$d9f76b3afffa4e88 = "responseText"; // Count: 6
var $dd9f9d03285ba266$export$182d7e789a77d304 = "responseFinishedTime"; // Count: 7
var $dd9f9d03285ba266$export$e31aceb60e1b3a1a = "CreateTrackItem"; // Count: 3
var $dd9f9d03285ba266$export$71a9f4a2e496846d = "response"; // Count: 4
var $dd9f9d03285ba266$export$6bf05f118580ffa = "getAllResponseHeaders"; // Count: 2
var $dd9f9d03285ba266$export$e2e640c31408a88f = "getPartAProps"; // Count: 3
var $dd9f9d03285ba266$export$c69633899eccb4a7 = "getCorrelationContext"; // Count: 2
var $dd9f9d03285ba266$export$9e85e7b326182790 = "perfMark"; // Count: 4
var $dd9f9d03285ba266$export$1ee8a32f080b146 = "ajaxPerfLookupDelay"; // Count: 2
var $dd9f9d03285ba266$export$9734b0a24bf02e93 = "name"; // Count: 6
var $dd9f9d03285ba266$export$6bec4987b5d3526c = "perfTiming"; // Count: 3
var $dd9f9d03285ba266$export$ae4e4f44752daa55 = "ajaxDiagnosticsMessage"; // Count: 3
var $dd9f9d03285ba266$export$c4a9b5c39c7409f7 = "correlationContext"; // Count: 3
var $dd9f9d03285ba266$export$7820e90f0eaab413 = "ajaxTotalDuration"; // Count: 3
var $dd9f9d03285ba266$export$c050ff25390a2bce = "eventTraceCtx"; // Count: 3

});

parcelRegister("aZeII", function(module, exports) {

$parcel$export(module.exports, "ajaxRecord", function () { return $7ffb05004280b3c3$export$3391d178758cbbb1; });
/*
 * Application Insights JavaScript SDK - Dependencies Plugin, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $kbmky = parcelRequire("kbmky");

var $cGFCT = parcelRequire("cGFCT");
var $4sUzw = parcelRequire("4sUzw");
var $2gDxc = parcelRequire("2gDxc");
var $6Gvon = parcelRequire("6Gvon");
var $8EowS = parcelRequire("8EowS");

var $erRAP = parcelRequire("erRAP");

var $ag2Pd = parcelRequire("ag2Pd");

var $j1HbR = parcelRequire("j1HbR");
/** @ignore */ function $7ffb05004280b3c3$var$_calcPerfDuration(resourceEntry, start, end) {
    var result = 0;
    var from = resourceEntry[start];
    var to = resourceEntry[end];
    if (from && to) result = (0, $4sUzw.dateTimeUtilsDuration)(from, to);
    return result;
}
/** @ignore */ function $7ffb05004280b3c3$var$_setPerfDuration(props, name, resourceEntry, start, end) {
    var result = 0;
    var value = $7ffb05004280b3c3$var$_calcPerfDuration(resourceEntry, start, end);
    if (value) result = $7ffb05004280b3c3$var$_setPerfValue(props, name, (0, $6Gvon.msToTimeSpan)(value));
    return result;
}
/** @ignore */ function $7ffb05004280b3c3$var$_setPerfValue(props, name, value) {
    var strPerf = "ajaxPerf";
    var result = 0;
    if (props && name && value) {
        var perfData = props[strPerf] = props[strPerf] || {};
        perfData[name] = value;
        result = 1;
    }
    return result;
}
/** @ignore */ function $7ffb05004280b3c3$var$_populatePerfData(ajaxData, dependency) {
    /*
    * https://developer.mozilla.org/en-US/docs/Web/API/Resource_Timing_API/Using_the_Resource_Timing_API
    *  | -startTime
    *  | -redirectStart
    *  |            | -redirectEnd
    *  |            | | -fetchStart
    *  |            | |   | -domainLookupStart
    *  |            | |   |                |- domainLookupEnd
    *  |            | |   |                | | -connectStart
    *  |            | |   |                | |  | -secureConnectionStart
    *  |            | |   |                | |  |        | -connectEnd
    *  |            | |   |                | |  |        | | -requestStart
    *  |            | |   |                | |  |        | |           | | -responseStart
    *  |            | |   |                | |  |        | |           | |            | | -responseEnd
    *  +------------+-+---+----------------+-+--+--------+-+-----------+-+------------+-+
    *  |--redirect--| |---|--domainLookup--| |--connect--| |--request--| |--response--| |
    *  |-------------------networkConnect----------------|
    *  |                                                   |---------sentRequest--------|
    *  |------------------------------------perfTotal-----------------------------------|
    */ var resourceEntry = ajaxData[0, $j1HbR._DYN_PERF_TIMING /* @min:%2eperfTiming */ ];
    var props = dependency[0, $ag2Pd.STR_PROPERTIES /* @min:%2eproperties */ ] || {};
    var propsSet = 0;
    var strName = "name";
    var strStart = "Start";
    var strEnd = "End";
    var strDomainLookup = "domainLookup";
    var strConnect = "connect";
    var strRedirect = "redirect";
    var strRequest = "request";
    var strResponse = "response";
    var strStartTime = "startTime";
    var strDomainLookupStart = strDomainLookup + strStart;
    var strDomainLookupEnd = strDomainLookup + strEnd;
    var strConnectStart = strConnect + strStart;
    var strConnectEnd = strConnect + strEnd;
    var strRequestStart = strRequest + strStart;
    var strRequestEnd = strRequest + strEnd;
    var strResponseStart = strResponse + strStart;
    var strResponseEnd = strResponse + strEnd;
    var strRedirectStart = strRedirect + strStart;
    var strRedirectEnd = strRedirect = strEnd;
    var strTransferSize = "transferSize";
    var strEncodedBodySize = "encodedBodySize";
    var strDecodedBodySize = "decodedBodySize";
    var strServerTiming = "serverTiming";
    if (resourceEntry) {
        // redirect
        propsSet |= $7ffb05004280b3c3$var$_setPerfDuration(props, strRedirect, resourceEntry, strRedirectStart, strRedirectEnd);
        // domainLookup
        propsSet |= $7ffb05004280b3c3$var$_setPerfDuration(props, strDomainLookup, resourceEntry, strDomainLookupStart, strDomainLookupEnd);
        // connect
        propsSet |= $7ffb05004280b3c3$var$_setPerfDuration(props, strConnect, resourceEntry, strConnectStart, strConnectEnd);
        // request
        propsSet |= $7ffb05004280b3c3$var$_setPerfDuration(props, strRequest, resourceEntry, strRequestStart, strRequestEnd);
        // response
        propsSet |= $7ffb05004280b3c3$var$_setPerfDuration(props, strResponse, resourceEntry, strResponseStart, strResponseEnd);
        // Network connection time
        propsSet |= $7ffb05004280b3c3$var$_setPerfDuration(props, "networkConnect", resourceEntry, strStartTime, strConnectEnd);
        // Sent Request
        propsSet |= $7ffb05004280b3c3$var$_setPerfDuration(props, "sentRequest", resourceEntry, strRequestStart, strResponseEnd);
        // PerfTotal / Duration
        var duration = resourceEntry[0, $ag2Pd.STR_DURATION /* @min:%2eduration */ ];
        if (!duration) duration = $7ffb05004280b3c3$var$_calcPerfDuration(resourceEntry, strStartTime, strResponseEnd) || 0;
        propsSet |= $7ffb05004280b3c3$var$_setPerfValue(props, (0, $ag2Pd.STR_DURATION), duration);
        propsSet |= $7ffb05004280b3c3$var$_setPerfValue(props, "perfTotal", duration);
        var serverTiming = resourceEntry[strServerTiming];
        if (serverTiming) {
            var server_1 = {};
            (0, $erRAP.arrForEach)(serverTiming, function(value, idx) {
                var name = (0, $erRAP.normalizeJsName)(value[strName] || "" + idx);
                var newValue = server_1[name] || {};
                (0, $erRAP.objForEachKey)(value, function(key, val) {
                    if (key !== strName && (0, $erRAP.isString)(val) || (0, $erRAP.isNumber)(val)) {
                        if (newValue[key]) val = newValue[key] + ";" + val;
                        if (val || !(0, $erRAP.isString)(val)) // Only set the value if it has a value and it's not an empty string
                        newValue[key] = val;
                    }
                });
                server_1[name] = newValue;
            });
            propsSet |= $7ffb05004280b3c3$var$_setPerfValue(props, strServerTiming, server_1);
        }
        propsSet |= $7ffb05004280b3c3$var$_setPerfValue(props, strTransferSize, resourceEntry[strTransferSize]);
        propsSet |= $7ffb05004280b3c3$var$_setPerfValue(props, strEncodedBodySize, resourceEntry[strEncodedBodySize]);
        propsSet |= $7ffb05004280b3c3$var$_setPerfValue(props, strDecodedBodySize, resourceEntry[strDecodedBodySize]);
    } else if (ajaxData[0, $j1HbR._DYN_PERF_MARK /* @min:%2eperfMark */ ]) propsSet |= $7ffb05004280b3c3$var$_setPerfValue(props, "missing", ajaxData.perfAttempts);
    if (propsSet) dependency[0, $ag2Pd.STR_PROPERTIES /* @min:%2eproperties */ ] = props;
}
var $7ffb05004280b3c3$export$79f098456caec6e7 = /** @class */ function() {
    function XHRMonitoringState() {
        var self = this;
        self[0, $j1HbR._DYN_OPEN_DONE /* @min:%2eopenDone */ ] = false;
        self.setRequestHeaderDone = false;
        self[0, $j1HbR._DYN_SEND_DONE /* @min:%2esendDone */ ] = false;
        self[0, $j1HbR._DYN_ABORT_DONE /* @min:%2eabortDone */ ] = false;
        // <summary>True, if onreadyStateChangeCallback function attached to xhr, otherwise false</summary>
        self[0, $j1HbR._DYN_STATE_CHANGE_ATTACHE14 /* @min:%2estateChangeAttached */ ] = false;
    }
    return XHRMonitoringState;
}();
var $7ffb05004280b3c3$export$3391d178758cbbb1 = /** @class */ function() {
    function ajaxRecord(traceId, spanId, logger, traceCtx) {
        var _a;
        var self = this;
        var _logger = logger;
        var strResponseText = "responseText";
        // Assigning the initial/default values within the constructor to avoid typescript from creating a bunch of
        // this.XXXX = null
        self[0, $j1HbR._DYN_PERF_MARK /* @min:%2eperfMark */ ] = null;
        self.completed = false;
        self.requestHeadersSize = null;
        self[0, $j1HbR._DYN_REQUEST_HEADERS /* @min:%2erequestHeaders */ ] = null;
        self.responseReceivingDuration = null;
        self.callbackDuration = null;
        self[0, $j1HbR._DYN_AJAX_TOTAL_DURATION /* @min:%2eajaxTotalDuration */ ] = null;
        self[0, $j1HbR._DYN_ABORTED /* @min:%2eaborted */ ] = 0;
        self.pageUrl = null;
        self[0, $j1HbR._DYN_REQUEST_URL /* @min:%2erequestUrl */ ] = null;
        self.requestSize = 0;
        self[0, $j1HbR._DYN_METHOD /* @min:%2emethod */ ] = null;
        self[0, $j1HbR._DYN_STATUS /* @min:%2estatus */ ] = null;
        self[0, $j1HbR._DYN_REQUEST_SENT_TIME /* @min:%2erequestSentTime */ ] = null;
        self.responseStartedTime = null;
        self[0, $j1HbR._DYN_RESPONSE_FINISHED_TI15 /* @min:%2eresponseFinishedTime */ ] = null;
        self.callbackFinishedTime = null;
        self.endTime = null;
        self.xhrMonitoringState = new $7ffb05004280b3c3$export$79f098456caec6e7();
        self.clientFailure = 0;
        self[0, $j1HbR._DYN_TRACE_ID /* @min:%2etraceID */ ] = traceId;
        self[0, $j1HbR._DYN_SPAN_ID /* @min:%2espanID */ ] = spanId;
        self[0, $j1HbR._DYN_TRACE_FLAGS /* @min:%2etraceFlags */ ] = traceCtx === null || traceCtx === void 0 ? void 0 : traceCtx.getTraceFlags();
        if (traceCtx) self[0, $j1HbR._DYN_EVENT_TRACE_CTX /* @min:%2eeventTraceCtx */ ] = (_a = {}, _a[0, $j1HbR._DYN_TRACE_ID0 /* @min:traceId */ ] = traceCtx[0, $j1HbR._DYN_GET_TRACE_ID /* @min:%2egetTraceId */ ](), _a[0, $j1HbR._DYN_SPAN_ID1 /* @min:spanId */ ] = traceCtx.getSpanId(), _a[0, $j1HbR._DYN_TRACE_FLAGS /* @min:traceFlags */ ] = traceCtx[0, $j1HbR._DYN_GET_TRACE_FLAGS /* @min:%2egetTraceFlags */ ](), _a);
        else self[0, $j1HbR._DYN_EVENT_TRACE_CTX /* @min:%2eeventTraceCtx */ ] = null;
        (0, $kbmky.default)(ajaxRecord, self, function(self) {
            self.getAbsoluteUrl = function() {
                return self[0, $j1HbR._DYN_REQUEST_URL /* @min:%2erequestUrl */ ] ? (0, $8EowS.urlGetAbsoluteUrl)(self[0, $j1HbR._DYN_REQUEST_URL /* @min:%2erequestUrl */ ]) : null;
            };
            self.getPathName = function() {
                return self[0, $j1HbR._DYN_REQUEST_URL /* @min:%2erequestUrl */ ] ? (0, $cGFCT.dataSanitizeUrl)(_logger, (0, $8EowS.urlGetCompleteUrl)(self[0, $j1HbR._DYN_METHOD /* @min:%2emethod */ ], self[0, $j1HbR._DYN_REQUEST_URL /* @min:%2erequestUrl */ ])) : null;
            };
            self[0, $j1HbR._DYN__CREATE_TRACK_ITEM /* @min:%2eCreateTrackItem */ ] = function(ajaxType, enableRequestHeaderTracking, getResponse) {
                var _a;
                // round to 3 decimal points
                self.ajaxTotalDuration = Math.round((0, $4sUzw.dateTimeUtilsDuration)(self.requestSentTime, self.responseFinishedTime) * 1000) / 1000;
                if (self[0, $j1HbR._DYN_AJAX_TOTAL_DURATION /* @min:%2eajaxTotalDuration */ ] < 0) return null;
                var dependency = (_a = {
                    id: "|" + self[0, $j1HbR._DYN_TRACE_ID /* @min:%2etraceID */ ] + "." + self[0, $j1HbR._DYN_SPAN_ID /* @min:%2espanID */ ],
                    target: self[0, $j1HbR._DYN_GET_ABSOLUTE_URL /* @min:%2egetAbsoluteUrl */ ]()
                }, _a[0, $j1HbR._DYN_NAME /* @min:name */ ] = self.getPathName(), _a.type = ajaxType, _a[0, $j1HbR._DYN_START_TIME /* @min:startTime */ ] = null, _a.duration = self[0, $j1HbR._DYN_AJAX_TOTAL_DURATION /* @min:%2eajaxTotalDuration */ ], _a.success = +self[0, $j1HbR._DYN_STATUS /* @min:%2estatus */ ] >= 200 && +self[0, $j1HbR._DYN_STATUS /* @min:%2estatus */ ] < 400, _a.responseCode = +self[0, $j1HbR._DYN_STATUS /* @min:%2estatus */ ], _a[0, $ag2Pd.STR_PROPERTIES] = {
                    HttpMethod: self[0, $j1HbR._DYN_METHOD /* @min:%2emethod */ ]
                }, _a);
                var props = dependency[0, $ag2Pd.STR_PROPERTIES];
                if (self[0, $j1HbR._DYN_ABORTED /* @min:%2eaborted */ ]) props[0, $j1HbR._DYN_ABORTED /* @min:%2eaborted */ ] = true;
                if (self[0, $j1HbR._DYN_REQUEST_SENT_TIME /* @min:%2erequestSentTime */ ]) {
                    // Set the correct dependency start time
                    dependency[0, $j1HbR._DYN_START_TIME /* @min:%2estartTime */ ] = new Date();
                    dependency[0, $j1HbR._DYN_START_TIME /* @min:%2estartTime */ ].setTime(self[0, $j1HbR._DYN_REQUEST_SENT_TIME /* @min:%2erequestSentTime */ ]);
                }
                // Add Ajax perf details if available
                $7ffb05004280b3c3$var$_populatePerfData(self, dependency);
                if (enableRequestHeaderTracking) {
                    if ((0, $erRAP.objKeys)(self.requestHeaders)[0, $j1HbR._DYN_LENGTH /* @min:%2elength */ ] > 0) props[0, $j1HbR._DYN_REQUEST_HEADERS /* @min:%2erequestHeaders */ ] = self[0, $j1HbR._DYN_REQUEST_HEADERS /* @min:%2erequestHeaders */ ];
                }
                if (getResponse) {
                    var response = getResponse();
                    if (response) {
                        // enrich dependency target with correlation context from the server
                        var correlationContext = response[0, $j1HbR._DYN_CORRELATION_CONTEXT /* @min:%2ecorrelationContext */ ];
                        if (correlationContext) dependency.correlationContext = /* dependency.target + " | " + */ correlationContext;
                        if (response[0, $j1HbR._DYN_HEADER_MAP /* @min:%2eheaderMap */ ]) {
                            if ((0, $erRAP.objKeys)(response.headerMap)[0, $j1HbR._DYN_LENGTH /* @min:%2elength */ ] > 0) props.responseHeaders = response[0, $j1HbR._DYN_HEADER_MAP /* @min:%2eheaderMap */ ];
                        }
                        if (self[0, $j1HbR._DYN_ERROR_STATUS_TEXT /* @min:%2eerrorStatusText */ ]) {
                            if (self[0, $j1HbR._DYN_STATUS /* @min:%2estatus */ ] >= 400) {
                                var responseType = response.type;
                                if (responseType === "" || responseType === "text") props.responseText = response.responseText ? response[0, $j1HbR._DYN_STATUS_TEXT /* @min:%2estatusText */ ] + " - " + response[strResponseText] : response[0, $j1HbR._DYN_STATUS_TEXT /* @min:%2estatusText */ ];
                                if (responseType === "json") props.responseText = response.response ? response[0, $j1HbR._DYN_STATUS_TEXT /* @min:%2estatusText */ ] + " - " + JSON.stringify(response[0, $j1HbR._DYN_RESPONSE /* @min:%2eresponse */ ]) : response[0, $j1HbR._DYN_STATUS_TEXT /* @min:%2estatusText */ ];
                            } else if (self[0, $j1HbR._DYN_STATUS /* @min:%2estatus */ ] === 0) props.responseText = response[0, $j1HbR._DYN_STATUS_TEXT /* @min:%2estatusText */ ] || "";
                        }
                    }
                }
                return dependency;
            };
            self[0, $j1HbR._DYN_GET_PART_APROPS /* @min:%2egetPartAProps */ ] = function() {
                var _a;
                var partA = null;
                var traceCtx = self[0, $j1HbR._DYN_EVENT_TRACE_CTX /* @min:%2eeventTraceCtx */ ];
                if (traceCtx && (traceCtx[0, $j1HbR._DYN_TRACE_ID0 /* @min:%2etraceId */ ] || traceCtx[0, $j1HbR._DYN_SPAN_ID1 /* @min:%2espanId */ ])) {
                    partA = {};
                    var traceExt = partA[(0, $2gDxc.Extensions).TraceExt] = (_a = {}, _a[0, $j1HbR._DYN_TRACE_ID /* @min:traceID */ ] = traceCtx[0, $j1HbR._DYN_TRACE_ID0 /* @min:%2etraceId */ ], _a.parentID = traceCtx[0, $j1HbR._DYN_SPAN_ID1 /* @min:%2espanId */ ], _a);
                    if (!(0, $erRAP.isNullOrUndefined)(traceCtx[0, $j1HbR._DYN_TRACE_FLAGS /* @min:%2etraceFlags */ ])) traceExt[0, $j1HbR._DYN_TRACE_FLAGS /* @min:%2etraceFlags */ ] = traceCtx[0, $j1HbR._DYN_TRACE_FLAGS /* @min:%2etraceFlags */ ];
                }
                return partA;
            };
        });
    }
    // Removed Stub for ajaxRecord.prototype.getAbsoluteUrl.
    // Removed Stub for ajaxRecord.prototype.getPathName.
    // Removed Stub for ajaxRecord.prototype.CreateTrackItem.
    // Removed Stub for ajaxRecord.prototype.getPartAProps.
    // This is a workaround for an IE8 bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    // this will be removed when ES3 support is dropped.
    ajaxRecord.__ieDyn = 1;
    return ajaxRecord;
}();

});


parcelRegister("cPPgl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $95820321d34a3759$export$2e2bcd8739ae039; });
/*
 * Application Insights JavaScript SDK - Properties Plugin, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ /**
* PropertiesPlugin.ts
* @copyright Microsoft 2018
*/ 
var $fcMe7 = parcelRequire("fcMe7");

var $kbmky = parcelRequire("kbmky");

var $1EHoQ = parcelRequire("1EHoQ");
var $4sUzw = parcelRequire("4sUzw");
var $80I4P = parcelRequire("80I4P");
var $fu0yT = parcelRequire("fu0yT");

var $8z2Gd = parcelRequire("8z2Gd");
var $3wvVb = parcelRequire("3wvVb");
var $kry7o = parcelRequire("kry7o");
var $3I5zg = parcelRequire("3I5zg");
var $erRAP = parcelRequire("erRAP");

var $cAyh4 = parcelRequire("cAyh4");

var $ji1BH = parcelRequire("ji1BH");
var $95820321d34a3759$var$PropertiesPlugin = /** @class */ function(_super) {
    (0, $fcMe7.__extendsFn)(PropertiesPlugin, _super);
    function PropertiesPlugin() {
        var _this = _super.call(this) || this;
        _this.priority = 110;
        _this.identifier = (0, $1EHoQ.PropertiesPluginIdentifier);
        var _extensionConfig;
        var _distributedTraceCtx;
        var _previousTraceCtx;
        (0, $kbmky.default)(PropertiesPlugin, _this, function(_self, _base) {
            _initDefaults();
            _self.initialize = function(config, core, extensions, pluginChain) {
                _base.initialize(config, core, extensions, pluginChain);
                _populateDefaults(config);
            };
            /**
             * Add Part A fields to the event
             * @param event The event that needs to be processed
             */ _self.processTelemetry = function(event, itemCtx) {
                if ((0, $erRAP.isNullOrUndefined)(event)) ;
                else {
                    itemCtx = _self._getTelCtx(itemCtx);
                    // If the envelope is PageView, reset the internal message count so that we can send internal telemetry for the new page.
                    if (event.name === (0, $80I4P.PageView).envelopeType) itemCtx.diagLog().resetInternalMessageCount();
                    var theContext = _self.context || {};
                    if (theContext.session) // If customer did not provide custom session id update the session manager
                    {
                        if (typeof _self.context.session.id !== "string" && theContext[0, $ji1BH._DYN_SESSION_MANAGER /* @min:%2esessionManager */ ]) theContext[0, $ji1BH._DYN_SESSION_MANAGER /* @min:%2esessionManager */ ][0, $ji1BH._DYN_UPDATE /* @min:%2eupdate */ ]();
                    }
                    var userCtx = theContext.user;
                    if (userCtx && !userCtx[0, $ji1BH._DYN_IS_USER_COOKIE_SET /* @min:%2eisUserCookieSet */ ]) userCtx[0, $ji1BH._DYN_UPDATE /* @min:%2eupdate */ ](theContext.user.id);
                    _processTelemetryInternal(event, itemCtx);
                    if (userCtx && userCtx[0, $ji1BH._DYN_IS_NEW_USER /* @min:%2eisNewUser */ ]) {
                        userCtx[0, $ji1BH._DYN_IS_NEW_USER /* @min:%2eisNewUser */ ] = false;
                        var message = new (0, $8z2Gd._InternalLogMessage)(72 /* _eInternalMessageId.SendBrowserInfoOnUserInit */ , ((0, $3I5zg.getNavigator)() || {}).userAgent || "");
                        (0, $8z2Gd._logInternalMessage)(itemCtx.diagLog(), 1 /* eLoggingSeverity.CRITICAL */ , message);
                    }
                    _self.processNext(event, itemCtx);
                }
            };
            _self._doTeardown = function(unloadCtx, unloadState) {
                var core = (unloadCtx || {}).core();
                if (core && core[0, $ji1BH._DYN_GET_TRACE_CTX /* @min:%2egetTraceCtx */ ]) {
                    var traceCtx = core[0, $ji1BH._DYN_GET_TRACE_CTX /* @min:%2egetTraceCtx */ ](false);
                    if (traceCtx === _distributedTraceCtx) core.setTraceCtx(_previousTraceCtx);
                }
                _initDefaults();
            };
            function _initDefaults() {
                _extensionConfig = null;
                _distributedTraceCtx = null;
                _previousTraceCtx = null;
            }
            function _populateDefaults(config) {
                var identifier = _self.identifier;
                var core = _self.core;
                var ctx = (0, $kry7o.createProcessTelemetryContext)(null, config, core);
                var defaultConfig = PropertiesPlugin.getDefaultConfig();
                _extensionConfig = _extensionConfig || {};
                (0, $erRAP.objForEachKey)(defaultConfig, function(field, value) {
                    _extensionConfig[field] = function() {
                        return ctx.getConfig(identifier, field, value());
                    };
                });
                if (config.storagePrefix) (0, $fu0yT.utlSetStoragePrefix)(config.storagePrefix);
                _previousTraceCtx = core[0, $ji1BH._DYN_GET_TRACE_CTX /* @min:%2egetTraceCtx */ ](false);
                _self.context = new (0, $cAyh4.TelemetryContext)(core, _extensionConfig, _previousTraceCtx);
                _distributedTraceCtx = (0, $4sUzw.createDistributedTraceContextFromTrace)(_self.context[0, $ji1BH._DYN_TELEMETRY_TRACE /* @min:%2etelemetryTrace */ ], _previousTraceCtx);
                core.setTraceCtx(_distributedTraceCtx);
                _self.context.appId = function() {
                    var breezeChannel = core.getPlugin((0, $1EHoQ.BreezeChannelIdentifier));
                    return breezeChannel ? breezeChannel.plugin["_appId"] : null;
                };
                // Test hook to allow accessing the internal values -- explicitly not defined as an available property on the class
                _self["_extConfig"] = _extensionConfig;
            }
            function _processTelemetryInternal(evt, itemCtx) {
                // Set Part A fields
                (0, $erRAP.getSetValue)(evt, "tags", []);
                (0, $erRAP.getSetValue)(evt, "ext", {});
                var ctx = _self.context;
                ctx[0, $ji1BH._DYN_APPLY_SESSION_CONTEX0 /* @min:%2eapplySessionContext */ ](evt, itemCtx);
                ctx[0, $ji1BH._DYN_APPLY_APPLICATION_CO1 /* @min:%2eapplyApplicationContext */ ](evt, itemCtx);
                ctx[0, $ji1BH._DYN_APPLY_DEVICE_CONTEXT /* @min:%2eapplyDeviceContext */ ](evt, itemCtx);
                ctx[0, $ji1BH._DYN_APPLY_OPERATION_CONT2 /* @min:%2eapplyOperationContext */ ](evt, itemCtx);
                ctx[0, $ji1BH._DYN_APPLY_USER_CONTEXT /* @min:%2eapplyUserContext */ ](evt, itemCtx);
                ctx[0, $ji1BH._DYN_APPLY_OPERATING_SYST3 /* @min:%2eapplyOperatingSystemContxt */ ](evt, itemCtx);
                ctx.applyWebContext(evt, itemCtx);
                ctx[0, $ji1BH._DYN_APPLY_LOCATION_CONTE4 /* @min:%2eapplyLocationContext */ ](evt, itemCtx); // legacy tags
                ctx[0, $ji1BH._DYN_APPLY_INTERNAL_CONTE5 /* @min:%2eapplyInternalContext */ ](evt, itemCtx); // legacy tags
                ctx.cleanUp(evt, itemCtx);
            }
        });
        return _this;
    }
    PropertiesPlugin.getDefaultConfig = function() {
        var _a;
        var defaultValue;
        var nullValue = null;
        var defaultConfig = (_a = {
            instrumentationKey: function() {
                return defaultValue;
            }
        }, _a[0, $ji1BH._DYN_ACCOUNT_ID /* @min:accountId */ ] = function() {
            return nullValue;
        }, _a.sessionRenewalMs = function() {
            return 1800000;
        }, _a.samplingPercentage = function() {
            return 100;
        }, _a.sessionExpirationMs = function() {
            return 86400000;
        }, _a[0, $ji1BH._DYN_COOKIE_DOMAIN /* @min:cookieDomain */ ] = function() {
            return nullValue;
        }, _a[0, $ji1BH._DYN_SDK_EXTENSION /* @min:sdkExtension */ ] = function() {
            return nullValue;
        }, _a.isBrowserLinkTrackingEnabled = function() {
            return false;
        }, _a.appId = function() {
            return nullValue;
        }, _a[0, $ji1BH._DYN_GET_SESSION_ID /* @min:getSessionId */ ] = function() {
            return nullValue;
        }, _a[0, $ji1BH._DYN_NAME_PREFIX /* @min:namePrefix */ ] = function() {
            return defaultValue;
        }, _a[0, $ji1BH._DYN_SESSION_COOKIE_POSTF6 /* @min:sessionCookiePostfix */ ] = function() {
            return defaultValue;
        }, _a[0, $ji1BH._DYN_USER_COOKIE_POSTFIX /* @min:userCookiePostfix */ ] = function() {
            return defaultValue;
        }, _a[0, $ji1BH._DYN_ID_LENGTH /* @min:idLength */ ] = function() {
            return 22;
        }, _a[0, $ji1BH._DYN_GET_NEW_ID /* @min:getNewId */ ] = function() {
            return nullValue;
        }, _a);
        return defaultConfig;
    };
    // Removed Stub for PropertiesPlugin.prototype.initialize.
    // Removed Stub for PropertiesPlugin.prototype.processTelemetry.
    return PropertiesPlugin;
}((0, $3wvVb.BaseTelemetryPlugin));
var $95820321d34a3759$export$2e2bcd8739ae039 = $95820321d34a3759$var$PropertiesPlugin;

});
parcelRegister("cAyh4", function(module, exports) {

$parcel$export(module.exports, "TelemetryContext", function () { return $92a36efbe64e7854$export$7b6b7bc4acb29126; });
/*
 * Application Insights JavaScript SDK - Properties Plugin, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ /**
* TelemetryContext.ts
* @copyright Microsoft 2018
*/ 
var $kbmky = parcelRequire("kbmky");

var $2gDxc = parcelRequire("2gDxc");
var $cGFCT = parcelRequire("cGFCT");
var $80I4P = parcelRequire("80I4P");

var $8z2Gd = parcelRequire("8z2Gd");
var $erRAP = parcelRequire("erRAP");
var $3I5zg = parcelRequire("3I5zg");

var $iCa8h = parcelRequire("iCa8h");

var $9T9aG = parcelRequire("9T9aG");

var $huLRP = parcelRequire("huLRP");

var $83eui = parcelRequire("83eui");

var $3pRKW = parcelRequire("3pRKW");

var $bm4n7 = parcelRequire("bm4n7");

var $bgM3F = parcelRequire("bgM3F");

var $ji1BH = parcelRequire("ji1BH");
var $92a36efbe64e7854$var$strExt = "ext";
var $92a36efbe64e7854$var$strTags = "tags";
function $92a36efbe64e7854$var$_removeEmpty(target, name) {
    if (target && target[name] && (0, $erRAP.objKeys)(target[name])[0, $ji1BH._DYN_LENGTH /* @min:%2elength */ ] === 0) delete target[name];
}
var $92a36efbe64e7854$export$7b6b7bc4acb29126 = /** @class */ function() {
    function TelemetryContext(core, defaultConfig, previousTraceCtx) {
        var _this = this;
        var logger = core.logger;
        this.appId = function() {
            return null;
        };
        this[0, $ji1BH._DYN_GET_SESSION_ID /* @min:%2egetSessionId */ ] = function() {
            return null;
        };
        (0, $kbmky.default)(TelemetryContext, this, function(_self) {
            _self.application = new (0, $iCa8h.Application)();
            _self.internal = new (0, $huLRP.Internal)(defaultConfig);
            if ((0, $3I5zg.hasWindow)()) {
                _self[0, $ji1BH._DYN_SESSION_MANAGER /* @min:%2esessionManager */ ] = new (0, $3pRKW._SessionManager)(defaultConfig, core);
                _self.device = new (0, $9T9aG.Device)();
                _self.location = new (0, $83eui.Location)();
                _self.user = new (0, $bgM3F.User)(defaultConfig, core);
                var traceId = void 0;
                var parentId = void 0;
                var name_1;
                if (previousTraceCtx) {
                    traceId = previousTraceCtx.getTraceId();
                    parentId = previousTraceCtx.getSpanId();
                    name_1 = previousTraceCtx.getName();
                }
                _self[0, $ji1BH._DYN_TELEMETRY_TRACE /* @min:%2etelemetryTrace */ ] = new (0, $bm4n7.TelemetryTrace)(traceId, parentId, name_1, logger);
                _self.session = new (0, $3pRKW.Session)();
            }
            _self[0, $ji1BH._DYN_GET_SESSION_ID /* @min:%2egetSessionId */ ] = function() {
                var session = _self.session;
                var sesId = null;
                // If customer set session info, apply their context; otherwise apply context automatically generated
                if (session && (0, $erRAP.isString)(session.id)) sesId = session.id;
                else {
                    // Gets the automatic session if it exists or an empty object
                    var autoSession = (_self[0, $ji1BH._DYN_SESSION_MANAGER /* @min:%2esessionManager */ ] || {})[0, $ji1BH._DYN_AUTOMATIC_SESSION /* @min:%2eautomaticSession */ ];
                    sesId = autoSession && (0, $erRAP.isString)(autoSession.id) ? autoSession.id : null;
                }
                return sesId;
            };
            _self[0, $ji1BH._DYN_APPLY_SESSION_CONTEX0 /* @min:%2eapplySessionContext */ ] = function(evt, itemCtx) {
                (0, $erRAP.setValue)((0, $erRAP.getSetValue)(evt.ext, (0, $2gDxc.Extensions).AppExt), "sesId", _self[0, $ji1BH._DYN_GET_SESSION_ID /* @min:%2egetSessionId */ ](), (0, $erRAP.isString));
            };
            _self[0, $ji1BH._DYN_APPLY_OPERATING_SYST3 /* @min:%2eapplyOperatingSystemContxt */ ] = function(evt, itemCtx) {
                (0, $erRAP.setValue)(evt.ext, (0, $2gDxc.Extensions).OSExt, _self.os);
            };
            _self[0, $ji1BH._DYN_APPLY_APPLICATION_CO1 /* @min:%2eapplyApplicationContext */ ] = function(evt, itemCtx) {
                var application = _self.application;
                if (application) {
                    // evt.ext.app
                    var tags = (0, $erRAP.getSetValue)(evt, $92a36efbe64e7854$var$strTags);
                    (0, $erRAP.setValue)(tags, (0, $2gDxc.CtxTagKeys).applicationVersion, application.ver, (0, $erRAP.isString));
                    (0, $erRAP.setValue)(tags, (0, $2gDxc.CtxTagKeys).applicationBuild, application.build, (0, $erRAP.isString));
                }
            };
            _self[0, $ji1BH._DYN_APPLY_DEVICE_CONTEXT /* @min:%2eapplyDeviceContext */ ] = function(evt, itemCtx) {
                var device = _self.device;
                if (device) {
                    // evt.ext.device
                    var extDevice = (0, $erRAP.getSetValue)((0, $erRAP.getSetValue)(evt, $92a36efbe64e7854$var$strExt), (0, $2gDxc.Extensions).DeviceExt);
                    (0, $erRAP.setValue)(extDevice, "localId", device.id, (0, $erRAP.isString));
                    (0, $erRAP.setValue)(extDevice, "ip", device.ip, (0, $erRAP.isString));
                    (0, $erRAP.setValue)(extDevice, "model", device.model, (0, $erRAP.isString));
                    (0, $erRAP.setValue)(extDevice, "deviceClass", device.deviceClass, (0, $erRAP.isString));
                }
            };
            _self[0, $ji1BH._DYN_APPLY_INTERNAL_CONTE5 /* @min:%2eapplyInternalContext */ ] = function(evt, itemCtx) {
                var internal = _self.internal;
                if (internal) {
                    var tags = (0, $erRAP.getSetValue)(evt, $92a36efbe64e7854$var$strTags);
                    (0, $erRAP.setValue)(tags, (0, $2gDxc.CtxTagKeys).internalAgentVersion, internal.agentVersion, (0, $erRAP.isString)); // not mapped in CS 4.0
                    (0, $erRAP.setValue)(tags, (0, $2gDxc.CtxTagKeys).internalSdkVersion, (0, $cGFCT.dataSanitizeString)(logger, internal.sdkVersion, 64), (0, $erRAP.isString));
                    if (evt.baseType === (0, $8z2Gd._InternalLogMessage).dataType || evt.baseType === (0, $80I4P.PageView).dataType) {
                        (0, $erRAP.setValue)(tags, (0, $2gDxc.CtxTagKeys).internalSnippet, internal.snippetVer, (0, $erRAP.isString));
                        (0, $erRAP.setValue)(tags, (0, $2gDxc.CtxTagKeys).internalSdkSrc, internal.sdkSrc, (0, $erRAP.isString));
                    }
                }
            };
            _self[0, $ji1BH._DYN_APPLY_LOCATION_CONTE4 /* @min:%2eapplyLocationContext */ ] = function(evt, itemCtx) {
                var location = _this.location;
                if (location) (0, $erRAP.setValue)((0, $erRAP.getSetValue)(evt, $92a36efbe64e7854$var$strTags, []), (0, $2gDxc.CtxTagKeys).locationIp, location.ip, (0, $erRAP.isString));
            };
            _self[0, $ji1BH._DYN_APPLY_OPERATION_CONT2 /* @min:%2eapplyOperationContext */ ] = function(evt, itemCtx) {
                var telemetryTrace = _self[0, $ji1BH._DYN_TELEMETRY_TRACE /* @min:%2etelemetryTrace */ ];
                if (telemetryTrace) {
                    var extTrace = (0, $erRAP.getSetValue)((0, $erRAP.getSetValue)(evt, $92a36efbe64e7854$var$strExt), (0, $2gDxc.Extensions).TraceExt, {
                        traceID: undefined,
                        parentID: undefined
                    });
                    (0, $erRAP.setValue)(extTrace, "traceID", telemetryTrace.traceID, (0, $erRAP.isString), (0, $erRAP.isNullOrUndefined));
                    (0, $erRAP.setValue)(extTrace, "name", telemetryTrace.name, (0, $erRAP.isString), (0, $erRAP.isNullOrUndefined));
                    (0, $erRAP.setValue)(extTrace, "parentID", telemetryTrace.parentID, (0, $erRAP.isString), (0, $erRAP.isNullOrUndefined));
                }
            };
            _self.applyWebContext = function(evt, itemCtx) {
                var web = _this.web;
                if (web) (0, $erRAP.setValue)((0, $erRAP.getSetValue)(evt, $92a36efbe64e7854$var$strExt), (0, $2gDxc.Extensions).WebExt, web);
            };
            _self[0, $ji1BH._DYN_APPLY_USER_CONTEXT /* @min:%2eapplyUserContext */ ] = function(evt, itemCtx) {
                var user = _self.user;
                if (user) {
                    var tags = (0, $erRAP.getSetValue)(evt, $92a36efbe64e7854$var$strTags, []);
                    // stays in tags
                    (0, $erRAP.setValue)(tags, (0, $2gDxc.CtxTagKeys).userAccountId, user[0, $ji1BH._DYN_ACCOUNT_ID /* @min:%2eaccountId */ ], (0, $erRAP.isString));
                    // CS 4.0
                    var extUser = (0, $erRAP.getSetValue)((0, $erRAP.getSetValue)(evt, $92a36efbe64e7854$var$strExt), (0, $2gDxc.Extensions).UserExt);
                    (0, $erRAP.setValue)(extUser, "id", user.id, (0, $erRAP.isString));
                    (0, $erRAP.setValue)(extUser, "authId", user[0, $ji1BH._DYN_AUTHENTICATED_ID /* @min:%2eauthenticatedId */ ], (0, $erRAP.isString));
                }
            };
            _self.cleanUp = function(evt, itemCtx) {
                var ext = evt.ext;
                if (ext) {
                    $92a36efbe64e7854$var$_removeEmpty(ext, (0, $2gDxc.Extensions).DeviceExt);
                    $92a36efbe64e7854$var$_removeEmpty(ext, (0, $2gDxc.Extensions).UserExt);
                    $92a36efbe64e7854$var$_removeEmpty(ext, (0, $2gDxc.Extensions).WebExt);
                    $92a36efbe64e7854$var$_removeEmpty(ext, (0, $2gDxc.Extensions).OSExt);
                    $92a36efbe64e7854$var$_removeEmpty(ext, (0, $2gDxc.Extensions).AppExt);
                    $92a36efbe64e7854$var$_removeEmpty(ext, (0, $2gDxc.Extensions).TraceExt);
                }
            };
        });
    }
    // Removed Stub for TelemetryContext.prototype.applySessionContext.
    // Removed Stub for TelemetryContext.prototype.applyOperatingSystemContxt.
    // Removed Stub for TelemetryContext.prototype.applyApplicationContext.
    // Removed Stub for TelemetryContext.prototype.applyDeviceContext.
    // Removed Stub for TelemetryContext.prototype.applyInternalContext.
    // Removed Stub for TelemetryContext.prototype.applyLocationContext.
    // Removed Stub for TelemetryContext.prototype.applyOperationContext.
    // Removed Stub for TelemetryContext.prototype.applyWebContext.
    // Removed Stub for TelemetryContext.prototype.applyUserContext.
    // Removed Stub for TelemetryContext.prototype.cleanUp.
    // This is a workaround for an IE8 bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    // this will be removed when ES3 support is dropped.
    TelemetryContext.__ieDyn = 1;
    return TelemetryContext;
}();

});
parcelRegister("iCa8h", function(module, exports) {

$parcel$export(module.exports, "Application", function () { return $d8d3a2bcc5ac9643$export$16975c34e60e1e61; });
/*
 * Application Insights JavaScript SDK - Properties Plugin, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ var $d8d3a2bcc5ac9643$export$16975c34e60e1e61 = /** @class */ function() {
    function Application() {}
    return Application;
}();

});

parcelRegister("9T9aG", function(module, exports) {

$parcel$export(module.exports, "Device", function () { return $73305d55f3550ed1$export$8215d14a63d9fb10; });
/*
 * Application Insights JavaScript SDK - Properties Plugin, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ var $73305d55f3550ed1$export$8215d14a63d9fb10 = /** @class */ function() {
    /**
     * Constructs a new instance of the Device class
     */ function Device() {
        // don't attempt to fingerprint browsers
        this.id = "browser";
        // Device type is a dimension in our data platform
        // Setting it to 'Browser' allows to separate client and server dependencies/exceptions
        this.deviceClass = "Browser";
    }
    return Device;
}();

});

parcelRegister("huLRP", function(module, exports) {

$parcel$export(module.exports, "Internal", function () { return $cbca5e7311e2b517$export$81742925a72ee8f2; });
/*
 * Application Insights JavaScript SDK - Properties Plugin, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $ji1BH = parcelRequire("ji1BH");
var $cbca5e7311e2b517$var$Version = "2.8.18";
var $cbca5e7311e2b517$export$81742925a72ee8f2 = /** @class */ function() {
    /**
     * Constructs a new instance of the internal telemetry data class.
     */ function Internal(config) {
        this.sdkVersion = (config[0, $ji1BH._DYN_SDK_EXTENSION /* @min:%2esdkExtension */ ] && config[0, $ji1BH._DYN_SDK_EXTENSION /* @min:%2esdkExtension */ ]() ? config[0, $ji1BH._DYN_SDK_EXTENSION /* @min:%2esdkExtension */ ]() + "_" : "") + "javascript:" + $cbca5e7311e2b517$var$Version;
    }
    return Internal;
}();

});
parcelRegister("ji1BH", function(module, exports) {

$parcel$export(module.exports, "_DYN_SESSION_MANAGER", function () { return $e0b0f1e822cf0678$export$1c39d669bde62767; });
$parcel$export(module.exports, "_DYN_UPDATE", function () { return $e0b0f1e822cf0678$export$c9f4bebf02f459de; });
$parcel$export(module.exports, "_DYN_IS_USER_COOKIE_SET", function () { return $e0b0f1e822cf0678$export$52b1fe3e70f4c699; });
$parcel$export(module.exports, "_DYN_IS_NEW_USER", function () { return $e0b0f1e822cf0678$export$e8019acdc6dfe227; });
$parcel$export(module.exports, "_DYN_GET_TRACE_CTX", function () { return $e0b0f1e822cf0678$export$2d15b9b0e9d1daaa; });
$parcel$export(module.exports, "_DYN_TELEMETRY_TRACE", function () { return $e0b0f1e822cf0678$export$805965d0d38cc4a5; });
$parcel$export(module.exports, "_DYN_APPLY_SESSION_CONTEX0", function () { return $e0b0f1e822cf0678$export$585a4eb45f8043ec; });
$parcel$export(module.exports, "_DYN_APPLY_APPLICATION_CO1", function () { return $e0b0f1e822cf0678$export$5c833c29ed72a760; });
$parcel$export(module.exports, "_DYN_APPLY_DEVICE_CONTEXT", function () { return $e0b0f1e822cf0678$export$f3448cce94ee4935; });
$parcel$export(module.exports, "_DYN_APPLY_OPERATION_CONT2", function () { return $e0b0f1e822cf0678$export$a6c599a5c1ab6761; });
$parcel$export(module.exports, "_DYN_APPLY_USER_CONTEXT", function () { return $e0b0f1e822cf0678$export$5090ada1085f4557; });
$parcel$export(module.exports, "_DYN_APPLY_OPERATING_SYST3", function () { return $e0b0f1e822cf0678$export$dddc87038d37bcef; });
$parcel$export(module.exports, "_DYN_APPLY_LOCATION_CONTE4", function () { return $e0b0f1e822cf0678$export$4768decfd4f15bcf; });
$parcel$export(module.exports, "_DYN_APPLY_INTERNAL_CONTE5", function () { return $e0b0f1e822cf0678$export$348ac062a116e27c; });
$parcel$export(module.exports, "_DYN_ACCOUNT_ID", function () { return $e0b0f1e822cf0678$export$f251a1587d4aac90; });
$parcel$export(module.exports, "_DYN_SDK_EXTENSION", function () { return $e0b0f1e822cf0678$export$49c19c49385e770b; });
$parcel$export(module.exports, "_DYN_GET_SESSION_ID", function () { return $e0b0f1e822cf0678$export$3af04f76fec134a; });
$parcel$export(module.exports, "_DYN_NAME_PREFIX", function () { return $e0b0f1e822cf0678$export$6d013a7bc2da53c1; });
$parcel$export(module.exports, "_DYN_SESSION_COOKIE_POSTF6", function () { return $e0b0f1e822cf0678$export$d2109757a25c372a; });
$parcel$export(module.exports, "_DYN_USER_COOKIE_POSTFIX", function () { return $e0b0f1e822cf0678$export$f3af58106bbab288; });
$parcel$export(module.exports, "_DYN_ID_LENGTH", function () { return $e0b0f1e822cf0678$export$5c90c36f2382a0ff; });
$parcel$export(module.exports, "_DYN_GET_NEW_ID", function () { return $e0b0f1e822cf0678$export$d4e11a6879dac67b; });
$parcel$export(module.exports, "_DYN_LENGTH", function () { return $e0b0f1e822cf0678$export$6eae51590aaea43; });
$parcel$export(module.exports, "_DYN_AUTOMATIC_SESSION", function () { return $e0b0f1e822cf0678$export$4d608086992f55c7; });
$parcel$export(module.exports, "_DYN_AUTHENTICATED_ID", function () { return $e0b0f1e822cf0678$export$574ff42e0e7ce0c; });
$parcel$export(module.exports, "_DYN_SESSION_EXPIRATION_M7", function () { return $e0b0f1e822cf0678$export$e56d5c5918c53a30; });
$parcel$export(module.exports, "_DYN_SESSION_RENEWAL_MS", function () { return $e0b0f1e822cf0678$export$e274b4de953959a8; });
$parcel$export(module.exports, "_DYN_CONFIG", function () { return $e0b0f1e822cf0678$export$25fc8bd3fb7f1e5a; });
$parcel$export(module.exports, "_DYN_ACQUISITION_DATE", function () { return $e0b0f1e822cf0678$export$8c9471ee03377604; });
$parcel$export(module.exports, "_DYN_RENEWAL_DATE", function () { return $e0b0f1e822cf0678$export$7254663b30b11264; });
$parcel$export(module.exports, "_DYN_COOKIE_DOMAIN", function () { return $e0b0f1e822cf0678$export$2e1ae641796d707d; });
$parcel$export(module.exports, "_DYN_JOIN", function () { return $e0b0f1e822cf0678$export$9876e756459769d6; });
$parcel$export(module.exports, "_DYN_COOKIE_SEPARATOR", function () { return $e0b0f1e822cf0678$export$57599fb6aa598bd4; });
$parcel$export(module.exports, "_DYN_AUTH_USER_COOKIE_NAM8", function () { return $e0b0f1e822cf0678$export$b362f54ec0f6467; });
/*
 * Application Insights JavaScript SDK - Properties Plugin, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ // @skip-file-minify
// ##############################################################
// AUTO GENERATED FILE: This file is Auto Generated during build.
// ##############################################################
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// Note: DON'T Export these const from the package as we are still targeting ES3 this will export a mutable variables that someone could change!!!
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
var $e0b0f1e822cf0678$export$1c39d669bde62767 = "sessionManager"; // Count: 3
var $e0b0f1e822cf0678$export$c9f4bebf02f459de = "update"; // Count: 4
var $e0b0f1e822cf0678$export$52b1fe3e70f4c699 = "isUserCookieSet"; // Count: 4
var $e0b0f1e822cf0678$export$e8019acdc6dfe227 = "isNewUser"; // Count: 4
var $e0b0f1e822cf0678$export$2d15b9b0e9d1daaa = "getTraceCtx"; // Count: 3
var $e0b0f1e822cf0678$export$805965d0d38cc4a5 = "telemetryTrace"; // Count: 3
var $e0b0f1e822cf0678$export$585a4eb45f8043ec = "applySessionContext"; // Count: 2
var $e0b0f1e822cf0678$export$5c833c29ed72a760 = "applyApplicationContext"; // Count: 2
var $e0b0f1e822cf0678$export$f3448cce94ee4935 = "applyDeviceContext"; // Count: 2
var $e0b0f1e822cf0678$export$a6c599a5c1ab6761 = "applyOperationContext"; // Count: 2
var $e0b0f1e822cf0678$export$5090ada1085f4557 = "applyUserContext"; // Count: 2
var $e0b0f1e822cf0678$export$dddc87038d37bcef = "applyOperatingSystemContxt"; // Count: 2
var $e0b0f1e822cf0678$export$4768decfd4f15bcf = "applyLocationContext"; // Count: 2
var $e0b0f1e822cf0678$export$348ac062a116e27c = "applyInternalContext"; // Count: 2
var $e0b0f1e822cf0678$export$f251a1587d4aac90 = "accountId"; // Count: 8
var $e0b0f1e822cf0678$export$49c19c49385e770b = "sdkExtension"; // Count: 4
var $e0b0f1e822cf0678$export$3af04f76fec134a = "getSessionId"; // Count: 4
var $e0b0f1e822cf0678$export$6d013a7bc2da53c1 = "namePrefix"; // Count: 7
var $e0b0f1e822cf0678$export$d2109757a25c372a = "sessionCookiePostfix"; // Count: 4
var $e0b0f1e822cf0678$export$f3af58106bbab288 = "userCookiePostfix"; // Count: 4
var $e0b0f1e822cf0678$export$5c90c36f2382a0ff = "idLength"; // Count: 5
var $e0b0f1e822cf0678$export$d4e11a6879dac67b = "getNewId"; // Count: 6
var $e0b0f1e822cf0678$export$6eae51590aaea43 = "length"; // Count: 4
var $e0b0f1e822cf0678$export$4d608086992f55c7 = "automaticSession"; // Count: 5
var $e0b0f1e822cf0678$export$574ff42e0e7ce0c = "authenticatedId"; // Count: 6
var $e0b0f1e822cf0678$export$e56d5c5918c53a30 = "sessionExpirationMs"; // Count: 5
var $e0b0f1e822cf0678$export$e274b4de953959a8 = "sessionRenewalMs"; // Count: 4
var $e0b0f1e822cf0678$export$25fc8bd3fb7f1e5a = "config"; // Count: 4
var $e0b0f1e822cf0678$export$8c9471ee03377604 = "acquisitionDate"; // Count: 5
var $e0b0f1e822cf0678$export$7254663b30b11264 = "renewalDate"; // Count: 4
var $e0b0f1e822cf0678$export$2e1ae641796d707d = "cookieDomain"; // Count: 3
var $e0b0f1e822cf0678$export$9876e756459769d6 = "join"; // Count: 5
var $e0b0f1e822cf0678$export$57599fb6aa598bd4 = "cookieSeparator"; // Count: 5
var $e0b0f1e822cf0678$export$b362f54ec0f6467 = "authUserCookieName"; // Count: 3

});


parcelRegister("83eui", function(module, exports) {

$parcel$export(module.exports, "Location", function () { return $5dc9d7790baf137d$export$18a2be9195644f38; });
/*
 * Application Insights JavaScript SDK - Properties Plugin, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ var $5dc9d7790baf137d$export$18a2be9195644f38 = /** @class */ function() {
    function Location() {}
    return Location;
}();

});

parcelRegister("3pRKW", function(module, exports) {

$parcel$export(module.exports, "Session", function () { return $27cd67bfcb353704$export$1fb4852a55678982; });
$parcel$export(module.exports, "_SessionManager", function () { return $27cd67bfcb353704$export$9a3efd42578d1f11; });
/*
 * Application Insights JavaScript SDK - Properties Plugin, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $kbmky = parcelRequire("kbmky");

var $fu0yT = parcelRequire("fu0yT");

var $8z2Gd = parcelRequire("8z2Gd");
var $erRAP = parcelRequire("erRAP");
var $3I5zg = parcelRequire("3I5zg");
var $990ap = parcelRequire("990ap");
var $31Ks8 = parcelRequire("31Ks8");

var $ji1BH = parcelRequire("ji1BH");
var $27cd67bfcb353704$var$cookieNameConst = "ai_session";
var $27cd67bfcb353704$export$1fb4852a55678982 = /** @class */ function() {
    function Session() {}
    return Session;
}();
var $27cd67bfcb353704$export$9a3efd42578d1f11 = /** @class */ function() {
    function _SessionManager(config, core) {
        var self = this;
        var _storageNamePrefix;
        var _cookieUpdatedTimestamp;
        var _logger = (0, $8z2Gd.safeGetLogger)(core);
        var _cookieManager = (0, $31Ks8.safeGetCookieMgr)(core);
        (0, $kbmky.default)(_SessionManager, self, function(_self) {
            if (!config) config = {};
            if (!(0, $erRAP.isFunction)(config[0, $ji1BH._DYN_SESSION_EXPIRATION_M7 /* @min:%2esessionExpirationMs */ ])) config[0, $ji1BH._DYN_SESSION_EXPIRATION_M7 /* @min:%2esessionExpirationMs */ ] = function() {
                return _SessionManager.acquisitionSpan;
            };
            if (!(0, $erRAP.isFunction)(config[0, $ji1BH._DYN_SESSION_RENEWAL_MS /* @min:%2esessionRenewalMs */ ])) config[0, $ji1BH._DYN_SESSION_RENEWAL_MS /* @min:%2esessionRenewalMs */ ] = function() {
                return _SessionManager.renewalSpan;
            };
            _self[0, $ji1BH._DYN_CONFIG /* @min:%2econfig */ ] = config;
            // sessionCookiePostfix takes the preference if it is configured, otherwise takes namePrefix if configured.
            var sessionCookiePostfix = _self.config[0, $ji1BH._DYN_SESSION_COOKIE_POSTF6 /* @min:%2esessionCookiePostfix */ ] && _self[0, $ji1BH._DYN_CONFIG /* @min:%2econfig */ ][0, $ji1BH._DYN_SESSION_COOKIE_POSTF6 /* @min:%2esessionCookiePostfix */ ]() ? _self.config[0, $ji1BH._DYN_SESSION_COOKIE_POSTF6 /* @min:%2esessionCookiePostfix */ ]() : _self.config[0, $ji1BH._DYN_NAME_PREFIX /* @min:%2enamePrefix */ ] && _self[0, $ji1BH._DYN_CONFIG /* @min:%2econfig */ ][0, $ji1BH._DYN_NAME_PREFIX /* @min:%2enamePrefix */ ]() ? _self[0, $ji1BH._DYN_CONFIG /* @min:%2econfig */ ][0, $ji1BH._DYN_NAME_PREFIX /* @min:%2enamePrefix */ ]() : "";
            _storageNamePrefix = function() {
                return $27cd67bfcb353704$var$cookieNameConst + sessionCookiePostfix;
            };
            _self[0, $ji1BH._DYN_AUTOMATIC_SESSION /* @min:%2eautomaticSession */ ] = new $27cd67bfcb353704$export$1fb4852a55678982();
            _self[0, $ji1BH._DYN_UPDATE /* @min:%2eupdate */ ] = function() {
                // Always using Date getTime() as there is a bug in older IE instances that causes the performance timings to have the hi-bit set eg 0x800000000 causing
                // the number to be incorrect.
                var nowMs = (0, $erRAP.dateNow)();
                var isExpired = false;
                var session = _self[0, $ji1BH._DYN_AUTOMATIC_SESSION /* @min:%2eautomaticSession */ ];
                if (!session.id) isExpired = !_initializeAutomaticSession(session, nowMs);
                var sessionExpirationMs = _self.config[0, $ji1BH._DYN_SESSION_EXPIRATION_M7 /* @min:%2esessionExpirationMs */ ]();
                if (!isExpired && sessionExpirationMs > 0) {
                    var sessionRenewalMs = _self.config[0, $ji1BH._DYN_SESSION_RENEWAL_MS /* @min:%2esessionRenewalMs */ ]();
                    var timeSinceAcqMs = nowMs - session[0, $ji1BH._DYN_ACQUISITION_DATE /* @min:%2eacquisitionDate */ ];
                    var timeSinceRenewalMs = nowMs - session[0, $ji1BH._DYN_RENEWAL_DATE /* @min:%2erenewalDate */ ];
                    isExpired = timeSinceAcqMs < 0 || timeSinceRenewalMs < 0; // expired if the acquisition or last renewal are in the future
                    isExpired = isExpired || timeSinceAcqMs > sessionExpirationMs; // expired if the time since acquisition is more than session Expiration
                    isExpired = isExpired || timeSinceRenewalMs > sessionRenewalMs; // expired if the time since last renewal is more than renewal period
                }
                // renew if acquisitionSpan or renewalSpan has elapsed
                if (isExpired) // update automaticSession so session state has correct id
                _renew(nowMs);
                else // do not update the cookie more often than cookieUpdateInterval
                if (!_cookieUpdatedTimestamp || nowMs - _cookieUpdatedTimestamp > _SessionManager.cookieUpdateInterval) _setCookie(session, nowMs);
            };
            /**
             *  Record the current state of the automatic session and store it in our cookie string format
             *  into the browser's local storage. This is used to restore the session data when the cookie
             *  expires.
             */ _self.backup = function() {
                var session = _self[0, $ji1BH._DYN_AUTOMATIC_SESSION /* @min:%2eautomaticSession */ ];
                _setStorage(session.id, session[0, $ji1BH._DYN_ACQUISITION_DATE /* @min:%2eacquisitionDate */ ], session[0, $ji1BH._DYN_RENEWAL_DATE /* @min:%2erenewalDate */ ]);
            };
            /**
             * Use config.namePrefix + ai_session cookie data or local storage data (when the cookie is unavailable) to
             * initialize the automatic session.
             * @returns true if values set otherwise false
             */ function _initializeAutomaticSession(session, now) {
                var isValid = false;
                var cookieValue = _cookieManager.get(_storageNamePrefix());
                if (cookieValue && (0, $erRAP.isFunction)(cookieValue.split)) isValid = _initializeAutomaticSessionWithData(session, cookieValue);
                else {
                    // There's no cookie, but we might have session data in local storage
                    // This can happen if the session expired or the user actively deleted the cookie
                    // We only want to recover data if the cookie is missing from expiry. We should respect the user's wishes if the cookie was deleted actively.
                    // The User class handles this for us and deletes our local storage object if the persistent user cookie was removed.
                    var storageValue = (0, $fu0yT.utlGetLocalStorage)(_logger, _storageNamePrefix());
                    if (storageValue) isValid = _initializeAutomaticSessionWithData(session, storageValue);
                }
                return isValid || !!session.id;
            }
            /**
             * Extract id, acquisitionDate, and renewalDate from an ai_session payload string and
             * use this data to initialize automaticSession.
             *
             * @param {string} sessionData - The string stored in an ai_session cookie or local storage backup
             * @returns true if values set otherwise false
             */ function _initializeAutomaticSessionWithData(session, sessionData) {
                var isValid = false;
                var sessionReset = ", session will be reset";
                var tokens = sessionData.split("|");
                if (tokens[0, $ji1BH._DYN_LENGTH /* @min:%2elength */ ] >= 2) try {
                    var acqMs = +tokens[1] || 0;
                    var renewalMs = +tokens[2] || 0;
                    if (isNaN(acqMs) || acqMs <= 0) (0, $8z2Gd._throwInternal)(_logger, 2 /* eLoggingSeverity.WARNING */ , 27 /* _eInternalMessageId.SessionRenewalDateIsZero */ , "AI session acquisition date is 0" + sessionReset);
                    else if (isNaN(renewalMs) || renewalMs <= 0) (0, $8z2Gd._throwInternal)(_logger, 2 /* eLoggingSeverity.WARNING */ , 27 /* _eInternalMessageId.SessionRenewalDateIsZero */ , "AI session renewal date is 0" + sessionReset);
                    else if (tokens[0]) {
                        // Everything looks valid so set the values
                        session.id = tokens[0];
                        session[0, $ji1BH._DYN_ACQUISITION_DATE /* @min:%2eacquisitionDate */ ] = acqMs;
                        session[0, $ji1BH._DYN_RENEWAL_DATE /* @min:%2erenewalDate */ ] = renewalMs;
                        isValid = true;
                    }
                } catch (e) {
                    (0, $8z2Gd._throwInternal)(_logger, 1 /* eLoggingSeverity.CRITICAL */ , 9 /* _eInternalMessageId.ErrorParsingAISessionCookie */ , "Error parsing ai_session value [" + (sessionData || "") + "]" + sessionReset + " - " + (0, $erRAP.getExceptionName)(e), {
                        exception: (0, $3I5zg.dumpObj)(e)
                    });
                }
                return isValid;
            }
            function _renew(nowMs) {
                var theConfig = _self[0, $ji1BH._DYN_CONFIG /* @min:%2econfig */ ] || {};
                var getNewId = (theConfig[0, $ji1BH._DYN_GET_NEW_ID /* @min:%2egetNewId */ ] ? theConfig[0, $ji1BH._DYN_GET_NEW_ID /* @min:%2egetNewId */ ]() : null) || (0, $990ap.newId);
                _self.automaticSession.id = getNewId(theConfig[0, $ji1BH._DYN_ID_LENGTH /* @min:%2eidLength */ ] ? theConfig[0, $ji1BH._DYN_ID_LENGTH /* @min:%2eidLength */ ]() : 22);
                _self[0, $ji1BH._DYN_AUTOMATIC_SESSION /* @min:%2eautomaticSession */ ][0, $ji1BH._DYN_ACQUISITION_DATE /* @min:%2eacquisitionDate */ ] = nowMs;
                _setCookie(_self[0, $ji1BH._DYN_AUTOMATIC_SESSION /* @min:%2eautomaticSession */ ], nowMs);
                // If this browser does not support local storage, fire an internal log to keep track of it at this point
                if (!(0, $fu0yT.utlCanUseLocalStorage)()) (0, $8z2Gd._throwInternal)(_logger, 2 /* eLoggingSeverity.WARNING */ , 0 /* _eInternalMessageId.BrowserDoesNotSupportLocalStorage */ , "Browser does not support local storage. Session durations will be inaccurate.");
            }
            function _setCookie(session, nowMs) {
                var acq = session[0, $ji1BH._DYN_ACQUISITION_DATE /* @min:%2eacquisitionDate */ ];
                session[0, $ji1BH._DYN_RENEWAL_DATE /* @min:%2erenewalDate */ ] = nowMs;
                var config = _self[0, $ji1BH._DYN_CONFIG /* @min:%2econfig */ ];
                var renewalPeriodMs = config[0, $ji1BH._DYN_SESSION_RENEWAL_MS /* @min:%2esessionRenewalMs */ ]();
                // Set cookie to expire after the session expiry time passes or the session renewal deadline, whichever is sooner
                // Expiring the cookie will cause the session to expire even if the user isn't on the page
                var acqTimeLeftMs = acq + config[0, $ji1BH._DYN_SESSION_EXPIRATION_M7 /* @min:%2esessionExpirationMs */ ]() - nowMs;
                var cookie = [
                    session.id,
                    acq,
                    nowMs
                ];
                var maxAgeSec = 0;
                if (acqTimeLeftMs < renewalPeriodMs) maxAgeSec = acqTimeLeftMs / 1000;
                else maxAgeSec = renewalPeriodMs / 1000;
                var cookieDomain = config[0, $ji1BH._DYN_COOKIE_DOMAIN /* @min:%2ecookieDomain */ ] ? config[0, $ji1BH._DYN_COOKIE_DOMAIN /* @min:%2ecookieDomain */ ]() : null;
                // if sessionExpirationMs is set to 0, it means the expiry is set to 0 for this session cookie
                // A cookie with 0 expiry in the session cookie will never expire for that browser session.  If the browser is closed the cookie expires.
                // Depending on the browser, another instance does not inherit this cookie, however, another tab will
                _cookieManager.set(_storageNamePrefix(), cookie.join("|"), config[0, $ji1BH._DYN_SESSION_EXPIRATION_M7 /* @min:%2esessionExpirationMs */ ]() > 0 ? maxAgeSec : null, cookieDomain);
                _cookieUpdatedTimestamp = nowMs;
            }
            function _setStorage(guid, acq, renewal) {
                // Keep data in local storage to retain the last session id, allowing us to cleanly end the session when it expires
                // Browsers that don't support local storage won't be able to end sessions cleanly from the client
                // The server will notice this and end the sessions itself, with loss of accurate session duration
                (0, $fu0yT.utlSetLocalStorage)(_logger, _storageNamePrefix(), [
                    guid,
                    acq,
                    renewal
                ][0, $ji1BH._DYN_JOIN /* @min:%2ejoin */ ]("|"));
            }
        });
    }
    // Removed Stub for _SessionManager.prototype.update.
    // Removed Stub for _SessionManager.prototype.backup.
    _SessionManager.acquisitionSpan = 86400000; // 24 hours in ms
    _SessionManager.renewalSpan = 1800000; // 30 minutes in ms
    _SessionManager.cookieUpdateInterval = 60000; // 1 minute in ms
    return _SessionManager;
}();

});

parcelRegister("bm4n7", function(module, exports) {

$parcel$export(module.exports, "TelemetryTrace", function () { return $844523f682ad2cdb$export$d65492b1f626b9ec; });
/*
 * Application Insights JavaScript SDK - Properties Plugin, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $cGFCT = parcelRequire("cGFCT");

var $iBAi6 = parcelRequire("iBAi6");
var $3I5zg = parcelRequire("3I5zg");
var $844523f682ad2cdb$export$d65492b1f626b9ec = /** @class */ function() {
    function TelemetryTrace(id, parentId, name, logger) {
        var _self = this;
        _self.traceID = id || (0, $iBAi6.generateW3CId)();
        _self.parentID = parentId;
        var location = (0, $3I5zg.getLocation)();
        if (!name && location && location.pathname) name = location.pathname;
        _self.name = (0, $cGFCT.dataSanitizeString)(logger, name);
    }
    return TelemetryTrace;
}();

});

parcelRegister("bgM3F", function(module, exports) {

$parcel$export(module.exports, "User", function () { return $834677b0d66ee91b$export$1f44aaf2ec115b54; });
/*
 * Application Insights JavaScript SDK - Properties Plugin, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ 
var $kbmky = parcelRequire("kbmky");

var $fu0yT = parcelRequire("fu0yT");

var $8z2Gd = parcelRequire("8z2Gd");
var $990ap = parcelRequire("990ap");
var $31Ks8 = parcelRequire("31Ks8");
var $erRAP = parcelRequire("erRAP");

var $ji1BH = parcelRequire("ji1BH");
function $834677b0d66ee91b$var$_validateUserInput(id) {
    // Validate:
    // 1. Id is a non-empty string.
    // 2. It does not contain special characters for cookies.
    if (typeof id !== "string" || !id || id.match(/,|;|=| |\|/)) return false;
    return true;
}
var $834677b0d66ee91b$export$1f44aaf2ec115b54 = /** @class */ function() {
    function User(config, core) {
        /**
         * A flag indicating whether this represents a new user
         */ this.isNewUser = false;
        /**
         * A flag indicating whether the user cookie has been set
         */ this.isUserCookieSet = false;
        var _logger = (0, $8z2Gd.safeGetLogger)(core);
        var _cookieManager = (0, $31Ks8.safeGetCookieMgr)(core);
        var _storageNamePrefix;
        (0, $kbmky.default)(User, this, function(_self) {
            _self[0, $ji1BH._DYN_CONFIG /* @min:%2econfig */ ] = config;
            var userCookiePostfix = _self.config[0, $ji1BH._DYN_USER_COOKIE_POSTFIX /* @min:%2euserCookiePostfix */ ] && _self[0, $ji1BH._DYN_CONFIG /* @min:%2econfig */ ][0, $ji1BH._DYN_USER_COOKIE_POSTFIX /* @min:%2euserCookiePostfix */ ]() ? _self[0, $ji1BH._DYN_CONFIG /* @min:%2econfig */ ][0, $ji1BH._DYN_USER_COOKIE_POSTFIX /* @min:%2euserCookiePostfix */ ]() : "";
            _storageNamePrefix = function() {
                return User.userCookieName + userCookiePostfix;
            };
            // get userId or create new one if none exists
            var cookie = _cookieManager.get(_storageNamePrefix());
            if (cookie) {
                _self[0, $ji1BH._DYN_IS_NEW_USER /* @min:%2eisNewUser */ ] = false;
                var params = cookie.split(User[0, $ji1BH._DYN_COOKIE_SEPARATOR /* @min:%2ecookieSeparator */ ]);
                if (params[0, $ji1BH._DYN_LENGTH /* @min:%2elength */ ] > 0) {
                    _self.id = params[0];
                    // we already have a cookie
                    _self[0, $ji1BH._DYN_IS_USER_COOKIE_SET /* @min:%2eisUserCookieSet */ ] = !!_self.id;
                }
            }
            function _generateNewId() {
                var theConfig = config || {};
                var getNewId = (theConfig[0, $ji1BH._DYN_GET_NEW_ID /* @min:%2egetNewId */ ] ? theConfig[0, $ji1BH._DYN_GET_NEW_ID /* @min:%2egetNewId */ ]() : null) || (0, $990ap.newId);
                var id = getNewId(theConfig[0, $ji1BH._DYN_ID_LENGTH /* @min:%2eidLength */ ] ? config[0, $ji1BH._DYN_ID_LENGTH /* @min:%2eidLength */ ]() : 22);
                return id;
            }
            function _generateNewCookie(userId) {
                var acqStr = (0, $erRAP.toISOString)(new Date());
                _self.accountAcquisitionDate = acqStr;
                _self[0, $ji1BH._DYN_IS_NEW_USER /* @min:%2eisNewUser */ ] = true;
                var newCookie = [
                    userId,
                    acqStr
                ];
                return newCookie;
            }
            function _setUserCookie(cookie) {
                // without expiration, cookies expire at the end of the session
                // set it to 365 days from now
                // 365 * 24 * 60 * 60 = 31536000
                var oneYear = 31536000;
                _self[0, $ji1BH._DYN_IS_USER_COOKIE_SET /* @min:%2eisUserCookieSet */ ] = _cookieManager.set(_storageNamePrefix(), cookie, oneYear);
            }
            if (!_self.id) {
                _self.id = _generateNewId();
                var newCookie = _generateNewCookie(_self.id);
                _setUserCookie(newCookie[0, $ji1BH._DYN_JOIN /* @min:%2ejoin */ ](User[0, $ji1BH._DYN_COOKIE_SEPARATOR /* @min:%2ecookieSeparator */ ]));
                // If we have an config.namePrefix() + ai_session in local storage this means the user actively removed our cookies.
                // We should respect their wishes and clear ourselves from local storage
                var name_1 = config[0, $ji1BH._DYN_NAME_PREFIX /* @min:%2enamePrefix */ ] && config[0, $ji1BH._DYN_NAME_PREFIX /* @min:%2enamePrefix */ ]() ? config[0, $ji1BH._DYN_NAME_PREFIX /* @min:%2enamePrefix */ ]() + "ai_session" : "ai_session";
                (0, $fu0yT.utlRemoveStorage)(_logger, name_1);
            }
            // We still take the account id from the ctor param for backward compatibility.
            // But if the the customer set the accountId through the newer setAuthenticatedUserContext API, we will override it.
            _self[0, $ji1BH._DYN_ACCOUNT_ID /* @min:%2eaccountId */ ] = config[0, $ji1BH._DYN_ACCOUNT_ID /* @min:%2eaccountId */ ] ? config[0, $ji1BH._DYN_ACCOUNT_ID /* @min:%2eaccountId */ ]() : undefined;
            // Get the auth user id and account id from the cookie if exists
            // Cookie is in the pattern: <authenticatedId>|<accountId>
            var authCookie = _cookieManager.get(User[0, $ji1BH._DYN_AUTH_USER_COOKIE_NAM8 /* @min:%2eauthUserCookieName */ ]);
            if (authCookie) {
                authCookie = decodeURI(authCookie);
                var authCookieString = authCookie.split(User[0, $ji1BH._DYN_COOKIE_SEPARATOR /* @min:%2ecookieSeparator */ ]);
                if (authCookieString[0]) _self[0, $ji1BH._DYN_AUTHENTICATED_ID /* @min:%2eauthenticatedId */ ] = authCookieString[0];
                if (authCookieString[0, $ji1BH._DYN_LENGTH /* @min:%2elength */ ] > 1 && authCookieString[1]) _self[0, $ji1BH._DYN_ACCOUNT_ID /* @min:%2eaccountId */ ] = authCookieString[1];
            }
            _self.setAuthenticatedUserContext = function(authenticatedUserId, accountId, storeInCookie) {
                if (storeInCookie === void 0) storeInCookie = false;
                // Validate inputs to ensure no cookie control characters.
                var isInvalidInput = !$834677b0d66ee91b$var$_validateUserInput(authenticatedUserId) || accountId && !$834677b0d66ee91b$var$_validateUserInput(accountId);
                if (isInvalidInput) {
                    (0, $8z2Gd._throwInternal)(_logger, 2 /* eLoggingSeverity.WARNING */ , 60 /* _eInternalMessageId.SetAuthContextFailedAccountName */ , "Setting auth user context failed. User auth/account id should be of type string, and not contain commas, semi-colons, equal signs, spaces, or vertical-bars.", true);
                    return;
                }
                // Create cookie string.
                _self[0, $ji1BH._DYN_AUTHENTICATED_ID /* @min:%2eauthenticatedId */ ] = authenticatedUserId;
                var authCookie = _self[0, $ji1BH._DYN_AUTHENTICATED_ID /* @min:%2eauthenticatedId */ ];
                if (accountId) {
                    _self[0, $ji1BH._DYN_ACCOUNT_ID /* @min:%2eaccountId */ ] = accountId;
                    authCookie = [
                        _self[0, $ji1BH._DYN_AUTHENTICATED_ID /* @min:%2eauthenticatedId */ ],
                        _self.accountId
                    ][0, $ji1BH._DYN_JOIN /* @min:%2ejoin */ ](User[0, $ji1BH._DYN_COOKIE_SEPARATOR /* @min:%2ecookieSeparator */ ]);
                }
                if (storeInCookie) // Set the cookie. No expiration date because this is a session cookie (expires when browser closed).
                // Encoding the cookie to handle unexpected unicode characters.
                _cookieManager.set(User[0, $ji1BH._DYN_AUTH_USER_COOKIE_NAM8 /* @min:%2eauthUserCookieName */ ], encodeURI(authCookie));
            };
            /**
             * Clears the authenticated user id and the account id from the user context.
             * @returns {}
             */ _self.clearAuthenticatedUserContext = function() {
                _self[0, $ji1BH._DYN_AUTHENTICATED_ID /* @min:%2eauthenticatedId */ ] = null;
                _self[0, $ji1BH._DYN_ACCOUNT_ID /* @min:%2eaccountId */ ] = null;
                _cookieManager.del(User[0, $ji1BH._DYN_AUTH_USER_COOKIE_NAM8 /* @min:%2eauthUserCookieName */ ]);
            };
            _self[0, $ji1BH._DYN_UPDATE /* @min:%2eupdate */ ] = function(userId) {
                // Optimizations to avoid setting and processing the cookie when not needed
                if (_self.id !== userId || !_self[0, $ji1BH._DYN_IS_USER_COOKIE_SET /* @min:%2eisUserCookieSet */ ]) {
                    var user_id = userId ? userId : _generateNewId();
                    var user_cookie = _generateNewCookie(user_id);
                    _setUserCookie(user_cookie[0, $ji1BH._DYN_JOIN /* @min:%2ejoin */ ](User[0, $ji1BH._DYN_COOKIE_SEPARATOR /* @min:%2ecookieSeparator */ ]));
                }
            };
        });
    }
    // Removed Stub for User.prototype.setAuthenticatedUserContext.
    // Removed Stub for User.prototype.clearAuthenticatedUserContext.
    // Removed Stub for User.prototype.update.
    User.cookieSeparator = "|";
    User.userCookieName = "ai_user";
    User.authUserCookieName = "ai_authUser";
    return User;
}();

});



parcelRegister("4GkI4", function(module, exports) {

$parcel$export(module.exports, "STR_SNIPPET", function () { return $368b26310be16570$export$c40a95bd1f19a04a; });
$parcel$export(module.exports, "STR_GET_COOKIE_MGR", function () { return $368b26310be16570$export$da4182b670dc48ff; });
$parcel$export(module.exports, "STR_START_TRACK_PAGE", function () { return $368b26310be16570$export$4dff843ac2d49cae; });
$parcel$export(module.exports, "STR_STOP_TRACK_PAGE", function () { return $368b26310be16570$export$83ac403ed0121674; });
$parcel$export(module.exports, "STR_FLUSH", function () { return $368b26310be16570$export$36b97ab40aae74fe; });
$parcel$export(module.exports, "STR_START_TRACK_EVENT", function () { return $368b26310be16570$export$5ac4d387b85102; });
$parcel$export(module.exports, "STR_STOP_TRACK_EVENT", function () { return $368b26310be16570$export$7895813056375cb; });
$parcel$export(module.exports, "STR_ADD_TELEMETRY_INITIALIZER", function () { return $368b26310be16570$export$40f0bd7f5212655f; });
$parcel$export(module.exports, "STR_POLL_INTERNAL_LOGS", function () { return $368b26310be16570$export$6030ed320bde556b; });
$parcel$export(module.exports, "STR_GET_PLUGIN", function () { return $368b26310be16570$export$59cf80c2878d98fc; });
$parcel$export(module.exports, "STR_EVT_NAMESPACE", function () { return $368b26310be16570$export$657de6e6c53d3d4b; });
$parcel$export(module.exports, "STR_TRACK_EVENT", function () { return $368b26310be16570$export$2a937c908483aaba; });
$parcel$export(module.exports, "STR_TRACK_TRACE", function () { return $368b26310be16570$export$6a76308d410f3214; });
$parcel$export(module.exports, "STR_TRACK_METRIC", function () { return $368b26310be16570$export$f73efacb9b6b9a35; });
$parcel$export(module.exports, "STR_TRACK_PAGE_VIEW", function () { return $368b26310be16570$export$96dcb75b34c1a4; });
$parcel$export(module.exports, "STR_TRACK_EXCEPTION", function () { return $368b26310be16570$export$5a8b50b634878942; });
$parcel$export(module.exports, "STR_TRACK_DEPENDENCY_DATA", function () { return $368b26310be16570$export$ab9c6dcf6c4e2bbc; });
$parcel$export(module.exports, "STR_SET_AUTHENTICATED_USER_CONTEXT", function () { return $368b26310be16570$export$94666ce386bd4f64; });
$parcel$export(module.exports, "STR_CLEAR_AUTHENTICATED_USER_CONTEXT", function () { return $368b26310be16570$export$f920535c288b298f; });
/*
 * Application Insights JavaScript SDK - Web, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ // !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// Note: DON'T Export these const from the package as we are still targeting ES3 this will export a mutable variables that someone could change!!!
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// Generally you should only put values that are used more than 2 times and then only if not already exposed as a constant (such as SdkCoreNames)
// as when using "short" named values from here they will be will be minified smaller than the SdkCoreNames[eSdkCoreNames.xxxx] value.
var $368b26310be16570$var$_AUTHENTICATED_USER_CONTEXT = "AuthenticatedUserContext";
var $368b26310be16570$var$_TRACK = "track";
var $368b26310be16570$export$5e8607ab26634759 = "";
var $368b26310be16570$export$c40a95bd1f19a04a = "snippet";
var $368b26310be16570$export$da4182b670dc48ff = "getCookieMgr";
var $368b26310be16570$export$4dff843ac2d49cae = "startTrackPage";
var $368b26310be16570$export$83ac403ed0121674 = "stopTrackPage";
var $368b26310be16570$export$36b97ab40aae74fe = "flush";
var $368b26310be16570$export$5ac4d387b85102 = "startTrackEvent";
var $368b26310be16570$export$7895813056375cb = "stopTrackEvent";
var $368b26310be16570$export$40f0bd7f5212655f = "addTelemetryInitializer";
var $368b26310be16570$export$98706f009830c697 = $368b26310be16570$export$40f0bd7f5212655f + "s";
var $368b26310be16570$export$6030ed320bde556b = "pollInternalLogs";
var $368b26310be16570$export$59cf80c2878d98fc = "getPlugin";
var $368b26310be16570$export$657de6e6c53d3d4b = "evtNamespace";
var $368b26310be16570$export$2a937c908483aaba = $368b26310be16570$var$_TRACK + "Event";
var $368b26310be16570$export$6a76308d410f3214 = $368b26310be16570$var$_TRACK + "Trace";
var $368b26310be16570$export$f73efacb9b6b9a35 = $368b26310be16570$var$_TRACK + "Metric";
var $368b26310be16570$export$96dcb75b34c1a4 = $368b26310be16570$var$_TRACK + "PageView";
var $368b26310be16570$export$5a8b50b634878942 = $368b26310be16570$var$_TRACK + "Exception";
var $368b26310be16570$export$ab9c6dcf6c4e2bbc = $368b26310be16570$var$_TRACK + "DependencyData";
var $368b26310be16570$export$94666ce386bd4f64 = "set" + $368b26310be16570$var$_AUTHENTICATED_USER_CONTEXT;
var $368b26310be16570$export$f920535c288b298f = "clear" + $368b26310be16570$var$_AUTHENTICATED_USER_CONTEXT;

});

parcelRegister("iRSJj", function(module, exports) {

$parcel$export(module.exports, "_DYN_UPDATE_SNIPPET_DEFIN0", function () { return $dbc7a16b96d74998$export$56d11d1ffdb728a7; });
$parcel$export(module.exports, "_DYN_LOAD_APP_INSIGHTS", function () { return $dbc7a16b96d74998$export$e434ab7388d06df0; });
$parcel$export(module.exports, "_DYN_ENDPOINT_URL", function () { return $dbc7a16b96d74998$export$bfa1c9e5dcf1e78; });
$parcel$export(module.exports, "_DYN_DIAGNOSTIC_LOG_INTER4", function () { return $dbc7a16b96d74998$export$4631c661dc34d47f; });
$parcel$export(module.exports, "_DYN_DISABLE_FLUSH_ON_BEF11", function () { return $dbc7a16b96d74998$export$a07bbe540f52b458; });
$parcel$export(module.exports, "_DYN_DISABLE_FLUSH_ON_UNL12", function () { return $dbc7a16b96d74998$export$2a30c6d97fdf0018; });
$parcel$export(module.exports, "_DYN_CONFIG", function () { return $dbc7a16b96d74998$export$25fc8bd3fb7f1e5a; });
$parcel$export(module.exports, "_DYN_CONTEXT", function () { return $dbc7a16b96d74998$export$fdcd48959e13aba7; });
$parcel$export(module.exports, "_DYN_PUSH", function () { return $dbc7a16b96d74998$export$a0a330e7fa1e278c; });
$parcel$export(module.exports, "_DYN_VERSION", function () { return $dbc7a16b96d74998$export$568c4302d11f2b22; });
$parcel$export(module.exports, "_DYN_QUEUE", function () { return $dbc7a16b96d74998$export$a1c208448cc1b3be; });
$parcel$export(module.exports, "_DYN_CONNECTION_STRING", function () { return $dbc7a16b96d74998$export$1160203e21ea532; });
$parcel$export(module.exports, "_DYN_INSTRUMENTATION_KEY", function () { return $dbc7a16b96d74998$export$81cfd43387c8dbcc; });
$parcel$export(module.exports, "_DYN_APP_INSIGHTS", function () { return $dbc7a16b96d74998$export$d8af525758d25fb5; });
$parcel$export(module.exports, "_DYN_DISABLE_IKEY_DEPRECA18", function () { return $dbc7a16b96d74998$export$2ca03919edead886; });
$parcel$export(module.exports, "_DYN_GET_TRANSMISSION_CON19", function () { return $dbc7a16b96d74998$export$b3539c8da0ecc607; });
$parcel$export(module.exports, "_DYN_ONUNLOAD_FLUSH", function () { return $dbc7a16b96d74998$export$f30bfb116278d530; });
$parcel$export(module.exports, "_DYN_ADD_HOUSEKEEPING_BEF20", function () { return $dbc7a16b96d74998$export$b3ed0e59f38a8fcc; });
$parcel$export(module.exports, "_DYN_INDEX_OF", function () { return $dbc7a16b96d74998$export$a3d3f936db372b4b; });
/*
 * Application Insights JavaScript SDK - Web, 2.8.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */ // @skip-file-minify
// ##############################################################
// AUTO GENERATED FILE: This file is Auto Generated during build.
// ##############################################################
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// Note: DON'T Export these const from the package as we are still targeting ES3 this will export a mutable variables that someone could change!!!
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
var $dbc7a16b96d74998$export$56d11d1ffdb728a7 = "updateSnippetDefinitions"; // Count: 4
var $dbc7a16b96d74998$export$e434ab7388d06df0 = "loadAppInsights"; // Count: 4
var $dbc7a16b96d74998$export$bfa1c9e5dcf1e78 = "endpointUrl"; // Count: 4
var $dbc7a16b96d74998$export$803d432e48ba5ceb = "maxBatchSizeInBytes"; // Count: 3
var $dbc7a16b96d74998$export$983774f06380e463 = "maxBatchInterval"; // Count: 3
var $dbc7a16b96d74998$export$2c73dfb33d25230b = "disableExceptionTracking"; // Count: 2
var $dbc7a16b96d74998$export$99a824310ffb055 = "disableTelemetry"; // Count: 2
var $dbc7a16b96d74998$export$82b14b88cf436ea1 = "emitLineDelimitedJson"; // Count: 2
var $dbc7a16b96d74998$export$4631c661dc34d47f = "diagnosticLogInterval"; // Count: 6
var $dbc7a16b96d74998$export$e17c3d9a2369a284 = "autoTrackPageVisitTime"; // Count: 2
var $dbc7a16b96d74998$export$51ccd61d31b31ade = "samplingPercentage"; // Count: 4
var $dbc7a16b96d74998$export$f7da12a644be5862 = "disableAjaxTracking"; // Count: 2
var $dbc7a16b96d74998$export$8e8c994d518b7819 = "maxAjaxCallsPerView"; // Count: 3
var $dbc7a16b96d74998$export$9e0ab1d9fac8a26c = "isBeaconApiDisabled"; // Count: 2
var $dbc7a16b96d74998$export$77fb4d57addb69c1 = "disableCorrelationHeaders"; // Count: 2
var $dbc7a16b96d74998$export$403128f8b49883c6 = "correlationHeaderExcludedDomains"; // Count: 2
var $dbc7a16b96d74998$export$a07bbe540f52b458 = "disableFlushOnBeforeUnload"; // Count: 4
var $dbc7a16b96d74998$export$2a30c6d97fdf0018 = "disableFlushOnUnload"; // Count: 3
var $dbc7a16b96d74998$export$53c294bc3a6a47ff = "enableSessionStorageBuffer"; // Count: 2
var $dbc7a16b96d74998$export$6cac25abb8c67dca = "isCookieUseDisabled"; // Count: 2
var $dbc7a16b96d74998$export$8e5935a499744308 = "isStorageUseDisabled"; // Count: 2
var $dbc7a16b96d74998$export$64926320c15e80f9 = "isBrowserLinkTrackingEnabled"; // Count: 2
var $dbc7a16b96d74998$export$fe04ab9b23fe7639 = "enableCorsCorrelation"; // Count: 2
var $dbc7a16b96d74998$export$25fc8bd3fb7f1e5a = "config"; // Count: 6
var $dbc7a16b96d74998$export$fdcd48959e13aba7 = "context"; // Count: 8
var $dbc7a16b96d74998$export$a0a330e7fa1e278c = "push"; // Count: 5
var $dbc7a16b96d74998$export$568c4302d11f2b22 = "version"; // Count: 6
var $dbc7a16b96d74998$export$a1c208448cc1b3be = "queue"; // Count: 6
var $dbc7a16b96d74998$export$1160203e21ea532 = "connectionString"; // Count: 3
var $dbc7a16b96d74998$export$81cfd43387c8dbcc = "instrumentationKey"; // Count: 2
var $dbc7a16b96d74998$export$d8af525758d25fb5 = "appInsights"; // Count: 3
var $dbc7a16b96d74998$export$2ca03919edead886 = "disableIkeyDeprecationMessage"; // Count: 2
var $dbc7a16b96d74998$export$b3539c8da0ecc607 = "getTransmissionControls"; // Count: 2
var $dbc7a16b96d74998$export$f30bfb116278d530 = "onunloadFlush"; // Count: 6
var $dbc7a16b96d74998$export$b3ed0e59f38a8fcc = "addHousekeepingBeforeUnload"; // Count: 2
var $dbc7a16b96d74998$export$a3d3f936db372b4b = "indexOf"; // Count: 4

});



parcelRegister("2Ptzq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $25a18d453f270f1e$export$2e2bcd8739ae039; });
const $25a18d453f270f1e$var$styles = [
    "font-weight: bold; color: red",
    "color: orange",
    "font-weight: bold; color: red"
];
const $25a18d453f270f1e$var$printFunctionCall = (name, args)=>console.log(`\u{279C} %c${name}(%c${args ? args.map((value)=>JSON.stringify(value)).join(", ") : ""}%c)`, ...$25a18d453f270f1e$var$styles);
var $25a18d453f270f1e$export$2e2bcd8739ae039 = $25a18d453f270f1e$var$printFunctionCall;

});



parcelRegister("lRXhp", function(module, exports) {
$parcel$export(module.exports, "RFIDTagsPage", function () { return (parcelRequire("9IrFu")).RFIDTagsPage; });
parcelRequire("9IrFu");

});
parcelRegister("9IrFu", function(module, exports) {

$parcel$export(module.exports, "RFIDTagsPage", function () { return $68d905bdb390d881$export$57aa6992c23c34e2; });

var $7E7Dk = parcelRequire("7E7Dk");

var $9xZTv = parcelRequire("9xZTv");

var $26yAo = parcelRequire("26yAo");
parcelRequire("19IsI");
var $gbHof = parcelRequire("gbHof");

var $76PWd = parcelRequire("76PWd");

var $5u6k9 = parcelRequire("5u6k9");

var $5RPMp = parcelRequire("5RPMp");
const $68d905bdb390d881$export$57aa6992c23c34e2 = ()=>{
    const text = (0, $5u6k9.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $26yAo.PageLayoutContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $5RPMp.LazyTabView), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $9xZTv.TabPanel), {
        header: text("lblRFIDWidget"),
        leftIcon: "pi pi-tags mr-2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $gbHof.RFIDTagsWidget), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $9xZTv.TabPanel), {
        header: text("lblRejectedRFIDTags"),
        leftIcon: "pi pi-plus mr-2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $76PWd.RegisterRfidTagWidget), null))));
};

});
parcelRegister("19IsI", function(module, exports) {
$parcel$export(module.exports, "RFIDTagsWidget", function () { return (parcelRequire("gbHof")).RFIDTagsWidget; });
parcelRequire("gbHof");

});
parcelRegister("gbHof", function(module, exports) {

$parcel$export(module.exports, "RFIDTagsWidget", function () { return $582e16a3621df40d$export$e98a44e1c16336a1; });

var $7E7Dk = parcelRequire("7E7Dk");

var $ej4sl = parcelRequire("ej4sl");

var $2rQNl = parcelRequire("2rQNl");

var $1ot1u = parcelRequire("1ot1u");

var $eHYdO = parcelRequire("eHYdO");

var $8jp0J = parcelRequire("8jp0J");

var $g915J = parcelRequire("g915J");

var $1O9Jh = parcelRequire("1O9Jh");

var $diakb = parcelRequire("diakb");

var $bd4QF = parcelRequire("bd4QF");

var $jSjRA = parcelRequire("jSjRA");

var $eIymc = parcelRequire("eIymc");

var $1o9MR = parcelRequire("1o9MR");

var $5u6k9 = parcelRequire("5u6k9");

var $aCffN = parcelRequire("aCffN");

var $9p3YO = parcelRequire("9p3YO");
parcelRequire("6qrpi");
var $igTNR = parcelRequire("igTNR");
parcelRequire("6rpAf");
var $fBJsG = parcelRequire("fBJsG");
const $582e16a3621df40d$export$e98a44e1c16336a1 = ()=>{
    const text = (0, $5u6k9.default)();
    const { partnerId: partnerId, selectedCompanyId: selectedCompanyId } = (0, $2rQNl.useSelector)((state)=>state.user);
    const { data: rfidTags = [], isLoading: isLoadingRfidTags } = (0, $jSjRA.useRFIDTagsQuery)(partnerId, selectedCompanyId);
    const [deleteTag] = (0, $1O9Jh.useNfcTagDeleteMutation)();
    const [globalFilter, setGlobalFilter] = (0, $7E7Dk.useState)("");
    const menuRef = (0, $7E7Dk.useRef)(null);
    const toast = (0, $aCffN.useToast)();
    const [rfidTag, setRfidTag] = (0, $7E7Dk.useState)(undefined);
    const [rfidTagDialogIsOpen, setRfidTagDialogIsOpen] = (0, $7E7Dk.useState)(false);
    const [rfidTagPoolsDialogIsOpen, setRfidTagPoolsDialogIsOpen] = (0, $7E7Dk.useState)(false);
    const [rfidTagChargePointsDialogIsOpen, setRfidTagChargePointsDialogIsOpen] = (0, $7E7Dk.useState)(false);
    const editAdmin = (rfidTag)=>{
        setRfidTag(rfidTag);
        setRfidTagDialogIsOpen(true);
    };
    const hideRfidTagDialog = ()=>{
        setRfidTagDialogIsOpen(false);
        setRfidTag(undefined);
    };
    const handleRemoveRFIDTag = async (rfidTag)=>{
        if (!rfidTag) return;
        const confirmed = await (0, $9p3YO.confirm)({
            header: text("lblProceedConfirmation"),
            message: text("msgDoYouWantToDeleteRFID", {
                id: rfidTag.id
            }),
            variant: "danger"
        });
        if (!confirmed) return;
        deleteTag({
            nfcTagId: rfidTag.id
        }).unwrap().then(()=>{
            toast.notifySuccess(text("msgRFIDDeleted"));
        }).catch(()=>{
            toast.notifyError(text("msgRFIDNotDeleted"));
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "flex align-items-center justify-content-end mb-4"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
        label: text("btnCreate"),
        icon: "pi pi-plus",
        onClick: ()=>setRfidTagDialogIsOpen(true),
        className: "mr-2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1o9MR.Input), {
        id: "rfid-search-input",
        type: "search",
        value: globalFilter,
        onChange: (e)=>setGlobalFilter(e.target.value),
        placeholder: text("lblSearch"),
        icon: (0, $eHYdO.PrimeIcons).SEARCH
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $8jp0J.Menu), {
        model: [
            {
                label: text("lblRFIDAccessToPools"),
                command: ()=>setRfidTagPoolsDialogIsOpen(true),
                disabled: !rfidTag?.companyId
            },
            {
                label: text("lblRFIDAccessToChargers"),
                command: ()=>setRfidTagChargePointsDialogIsOpen(true),
                disabled: !rfidTag?.companyId
            }
        ],
        ref: menuRef,
        popup: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $g915J.Table), {
        value: rfidTags,
        globalFilter: globalFilter,
        globalFilterFields: [
            "id",
            "companyName",
            "fullName",
            "externalId",
            "comment"
        ],
        removableSort: true,
        loading: isLoadingRfidTags,
        paginator: true,
        emptyMessage: text("msgNoRfidTagsFound"),
        "data-testid": "rfid-tags"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $ej4sl.Column), {
        field: "id",
        header: text("lblId"),
        sortable: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $ej4sl.Column), {
        body: (rowData)=>(0, $bd4QF.default)(rowData.id),
        header: text("lblRfidDex")
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $ej4sl.Column), {
        body: (rowData)=>(0, $bd4QF.default)(rowData.id, true),
        header: text("lblRfidReverse")
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $ej4sl.Column), {
        field: "companyName",
        header: text("lblOrganisationNameField"),
        sortable: true,
        hidden: (0, $eIymc.isAdminDomain)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $ej4sl.Column), {
        field: "fullName",
        header: text("lblUserOrOwner"),
        sortable: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $ej4sl.Column), {
        field: "externalId",
        header: text("lblExternalId"),
        sortable: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $ej4sl.Column), {
        field: "comment",
        header: text("lblComment"),
        sortable: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $ej4sl.Column), {
        body: (rowData)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
                className: "flex gap-3"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
                size: "small",
                icon: "pi pi-pencil",
                rounded: true,
                outlined: true,
                severity: "info",
                onClick: ()=>editAdmin(rowData)
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
                size: "small",
                icon: "pi pi-cog",
                rounded: true,
                outlined: true,
                onClick: (event)=>{
                    setRfidTag(rowData);
                    menuRef.current?.toggle(event);
                },
                disabled: !rowData.companyId,
                tooltip: rowData?.companyId ? undefined : text("lblRFIDSettingsRestrictionTooltip"),
                tooltipOptions: {
                    position: "left",
                    showOnDisabled: true
                }
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
                size: "small",
                icon: "pi pi-trash",
                rounded: true,
                outlined: true,
                severity: "danger",
                onClick: ()=>handleRemoveRFIDTag(rowData)
            }));
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $diakb.RfidTagDialog), {
        rfidTag: rfidTag,
        onHide: hideRfidTagDialog,
        visible: rfidTagDialogIsOpen
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igTNR.RfidTagPoolsDialog), {
        visible: rfidTagPoolsDialogIsOpen,
        onHide: ()=>setRfidTagPoolsDialogIsOpen(false),
        rfidTag: rfidTag
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $fBJsG.RfidTagChargePointsDialog), {
        visible: rfidTagChargePointsDialogIsOpen,
        onHide: ()=>setRfidTagChargePointsDialogIsOpen(false),
        rfidTag: rfidTag
    }));
};

});
parcelRegister("6qrpi", function(module, exports) {
$parcel$export(module.exports, "RfidTagPoolsDialog", function () { return (parcelRequire("igTNR")).RfidTagPoolsDialog; });
parcelRequire("igTNR");

});
parcelRegister("igTNR", function(module, exports) {

$parcel$export(module.exports, "RfidTagPoolsDialog", function () { return $083ff6139b133498$export$2fc5341dbffc8644; });

var $7E7Dk = parcelRequire("7E7Dk");

var $ej4sl = parcelRequire("ej4sl");

var $eHYdO = parcelRequire("eHYdO");

var $1O9Jh = parcelRequire("1O9Jh");

var $g915J = parcelRequire("g915J");

var $5u6k9 = parcelRequire("5u6k9");

var $1o9MR = parcelRequire("1o9MR");

var $j8chc = parcelRequire("j8chc");

var $MMfqT = parcelRequire("MMfqT");
const $083ff6139b133498$export$2fc5341dbffc8644 = ({ visible: visible, onHide: onHide, rfidTag: rfidTag })=>{
    const text = (0, $5u6k9.default)();
    const { data: pools, isLoading: poolsIsLoading } = (0, $1O9Jh.useCompanyGetPoolsWithNfcInfoForTagQuery)({
        companyId: rfidTag?.companyId || "",
        nfcTagId: rfidTag?.id || ""
    }, {
        skip: !rfidTag?.companyId || !rfidTag?.id,
        refetchOnMountOrArgChange: true
    });
    const [loadingStates, setLoadingStates] = (0, $7E7Dk.useState)({});
    const [updatePool] = (0, $1O9Jh.useCompanySetPoolsNfcInfoForTagMutation)();
    const setNfcAccess = async (hasNfcAccess, pool)=>{
        setLoadingStates((prev)=>({
                ...prev,
                [`${pool.id}`]: true
            }));
        try {
            if (rfidTag) await updatePool({
                body: [
                    {
                        companyId: rfidTag.companyId,
                        id: pool.id,
                        hasNfcAccess: hasNfcAccess
                    }
                ],
                companyId: rfidTag.companyId,
                nfcTagId: rfidTag.id
            }).unwrap();
        } catch (err) {
        // ignore
        } finally{
            setLoadingStates((prev)=>({
                    ...prev,
                    [`${pool.id}`]: false
                }));
        }
    };
    const [globalFilter, setGlobalFilter] = (0, $7E7Dk.useState)("");
    const resetDialogState = ()=>{
        setGlobalFilter("");
        setLoadingStates({});
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $MMfqT.Dialog), {
        visible: visible,
        onHide: onHide,
        onShow: resetDialogState,
        header: text("lblRFIDAccessToPools"),
        style: {
            width: "50rem"
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "flex flex-wrap align-items-center justify-content-end mb-3 pt-1"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1o9MR.Input), {
        id: "pools-search-input",
        value: globalFilter,
        type: "search",
        onChange: (e)=>setGlobalFilter(e.target.value),
        placeholder: text("lblSearch"),
        icon: (0, $eHYdO.PrimeIcons).SEARCH
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $g915J.Table), {
        value: pools,
        loading: poolsIsLoading,
        paginator: true,
        scrollable: true,
        scrollHeight: "30rem",
        globalFilter: globalFilter,
        emptyMessage: text("msgNoPoolsFound"),
        tableClassName: "min-w-full"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $ej4sl.Column), {
        field: "name",
        header: text("lblName")
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $ej4sl.Column), {
        body: (pool)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $j8chc.Switch), {
                checked: !!pool.hasNfcAccess,
                onChange: (event)=>{
                    setNfcAccess(event.value, pool);
                },
                loading: loadingStates[`${pool.id}`],
                inputId: `switch-nfc-access-${pool.id}`,
                pt: {
                    input: {
                        "aria-label": text("lblPoolRfidAccessSwitch", {
                            name: pool.name
                        }),
                        "data-testid": `switch-nfc-access-${pool.id}`
                    }
                }
            }),
        header: text("lblRFIDAccess")
    })));
};

});


parcelRegister("6rpAf", function(module, exports) {
$parcel$export(module.exports, "RfidTagChargePointsDialog", function () { return (parcelRequire("fBJsG")).RfidTagChargePointsDialog; });
parcelRequire("fBJsG");

});
parcelRegister("fBJsG", function(module, exports) {

$parcel$export(module.exports, "RfidTagChargePointsDialog", function () { return $01b8305b6dbbed5c$export$a9bf58d7e09e6fe4; });

var $7E7Dk = parcelRequire("7E7Dk");

var $eHYdO = parcelRequire("eHYdO");

var $ej4sl = parcelRequire("ej4sl");

var $1O9Jh = parcelRequire("1O9Jh");

var $1o9MR = parcelRequire("1o9MR");

var $5u6k9 = parcelRequire("5u6k9");

var $g915J = parcelRequire("g915J");

var $4gSsL = parcelRequire("4gSsL");

var $j8chc = parcelRequire("j8chc");

var $MMfqT = parcelRequire("MMfqT");
const $01b8305b6dbbed5c$export$a9bf58d7e09e6fe4 = ({ visible: visible, onHide: onHide, rfidTag: rfidTag })=>{
    const text = (0, $5u6k9.default)();
    const { data: chargePoints, isLoading: chargePointsIsLoading } = (0, $1O9Jh.useCompanyGetChargePointsWithNfcInfoForTagQuery)({
        companyId: rfidTag?.companyId || "",
        nfcTagId: rfidTag?.id || ""
    }, {
        skip: !rfidTag?.companyId || !rfidTag?.id
    });
    const adaptConnectorNaming = (0, $4gSsL.useAdaptConnectorNaming)();
    const [updateChargePointsNfcAccess] = (0, $1O9Jh.useCompanySetChargePointsNfcInfoForTagMutation)();
    const [loadingStates, setLoadingStates] = (0, $7E7Dk.useState)({});
    const updateNfcAccess = async (chargePointId, connectorId, hasNfcAccess)=>{
        setLoadingStates((prev)=>({
                ...prev,
                [`${chargePointId}_${connectorId}`]: true
            }));
        try {
            if (rfidTag) await updateChargePointsNfcAccess({
                body: [
                    {
                        chargePointId: chargePointId,
                        connectorId: connectorId,
                        hasNfcAccess: hasNfcAccess
                    }
                ],
                companyId: rfidTag.companyId,
                nfcTagId: rfidTag.id
            }).unwrap();
        } catch (err) {
        // ignore
        } finally{
            setLoadingStates((prev)=>({
                    ...prev,
                    [`${chargePointId}_${connectorId}`]: false
                }));
        }
    };
    const [globalFilter, setGlobalFilter] = (0, $7E7Dk.useState)("");
    const resetDialogState = ()=>{
        setGlobalFilter("");
        setLoadingStates({});
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $MMfqT.Dialog), {
        visible: visible,
        onHide: onHide,
        onShow: resetDialogState,
        header: text("lblRFIDAccessToChargers"),
        style: {
            width: "50rem"
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "flex flex-wrap align-items-center justify-content-end mb-3 pt-1"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1o9MR.Input), {
        id: "charge-points-search-input",
        value: globalFilter,
        type: "search",
        onChange: (e)=>setGlobalFilter(e.target.value),
        placeholder: text("lblSearch"),
        icon: (0, $eHYdO.PrimeIcons).SEARCH
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $g915J.Table), {
        value: chargePoints,
        loading: chargePointsIsLoading,
        paginator: true,
        scrollable: true,
        scrollHeight: "30rem",
        globalFilter: globalFilter,
        emptyMessage: text("msgNoChargePointsFound"),
        tableClassName: "min-w-full"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $ej4sl.Column), {
        field: "id",
        header: text("lblId")
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $ej4sl.Column), {
        field: "name",
        header: text("lblName")
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $ej4sl.Column), {
        className: "w-4",
        body: (chargePoint)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
                className: "flex flex-column gap-2"
            }, chargePoint.connectors?.filter((connector)=>connector.connectorFunctionType === "Charger").map((connector)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $j8chc.Switch), {
                    key: connector.connectorId,
                    checked: !!connector.hasNfcAccess,
                    onChange: (event)=>void updateNfcAccess(chargePoint.id, connector.connectorId, event.value),
                    loading: loadingStates[`${chargePoint.id}_${connector.connectorId}`],
                    label: adaptConnectorNaming(connector.name),
                    inputId: `switch-${chargePoint.id}-${connector.connectorId}`,
                    pt: {
                        input: {
                            "data-testid": `switch-${chargePoint.id}-${connector.connectorId}`
                        }
                    }
                }))),
        header: text("lblRFIDAccess")
    })));
};

});




parcelRegister("76PWd", function(module, exports) {

$parcel$export(module.exports, "RegisterRfidTagWidget", function () { return $d2ddb1db21a072ff$export$bdb2c33964b673f7; });

var $7E7Dk = parcelRequire("7E7Dk");

var $2rQNl = parcelRequire("2rQNl");

var $ej4sl = parcelRequire("ej4sl");

var $eHYdO = parcelRequire("eHYdO");

var $1ot1u = parcelRequire("1ot1u");

var $5L4Lm = parcelRequire("5L4Lm");

var $k6jwa = parcelRequire("k6jwa");

var $90NQT = parcelRequire("90NQT");
var $6Wotx = parcelRequire("6Wotx");
var $4MLzO = parcelRequire("4MLzO");
var $4179t = parcelRequire("4179t");

var $g915J = parcelRequire("g915J");

var $5u6k9 = parcelRequire("5u6k9");

var $1O9Jh = parcelRequire("1O9Jh");

var $jwHtR = parcelRequire("jwHtR");

var $1o9MR = parcelRequire("1o9MR");

var $eIymc = parcelRequire("eIymc");

var $hohPv = parcelRequire("hohPv");

var $lFIQ9 = parcelRequire("lFIQ9");

var $aTggv = parcelRequire("aTggv");

var $gUTZf = parcelRequire("gUTZf");

var $jSjRA = parcelRequire("jSjRA");

var $c6fcw = parcelRequire("c6fcw");

var $aCffN = parcelRequire("aCffN");

var $9p3YO = parcelRequire("9p3YO");
parcelRequire("cD5Z9");
var $8JVsa = parcelRequire("8JVsa");
const $d2ddb1db21a072ff$var$toRejectedAccessRow = (rejectedAccess)=>({
        ...rejectedAccess,
        rowKey: JSON.stringify([
            rejectedAccess.nfcTagId,
            rejectedAccess.chargePointId,
            rejectedAccess.connectorId,
            rejectedAccess.timeStamp
        ])
    });
const $d2ddb1db21a072ff$export$bdb2c33964b673f7 = ()=>{
    const text = (0, $5u6k9.default)();
    const { partnerId: partnerId, selectedCompanyId: selectedCompanyId } = (0, $2rQNl.useSelector)((state)=>state.user);
    const [createRfidTag] = (0, $1O9Jh.useNfcTagCreateMutation)();
    const toast = (0, $aCffN.useToast)();
    const [addRfidTagIsOpened, setAddRfidTagIsOpened] = (0, $7E7Dk.useState)(false);
    const [selectedTags, setSelectedTags] = (0, $7E7Dk.useState)([]);
    const [globalFilter, setGlobalFilter] = (0, $7E7Dk.useState)("");
    const onAddRfidTag = ()=>{
        if (0, $eIymc.isAdminDomain) handleAddSelected(selectedCompanyId);
        else if (0, $eIymc.isPartnerDomain) setAddRfidTagIsOpened(true);
    };
    const handleAddSelected = (organisationId)=>{
        setAddRfidTagIsOpened(false);
        const selectedTagsWithIds = selectedTags.filter((item)=>Boolean(item.nfcTagId));
        if (selectedTagsWithIds.length !== selectedTags.length) {
            toast.notifyError(text("msgRFIDTagCouldNotBeAdded"));
            return;
        }
        const tags = selectedTagsWithIds.map((item)=>({
                nfcTag: {
                    id: item.nfcTagId,
                    partnerId: partnerId,
                    companyId: organisationId,
                    active: true
                }
            }));
        Promise.all(tags.map((tag)=>createRfidTag(tag).unwrap())).then(()=>{
            toast.notifySuccess(text("msgRFIDTagAdded"));
            setSelectedTags([]);
        }).catch(()=>toast.notifyError(text("msgRFIDTagCouldNotBeAdded")));
    };
    const op = (0, $7E7Dk.useRef)(null);
    const { data: chargePoints, isLoading: isLoadingChargePoints } = (0, $jSjRA.useChargePointsQuery)({
        partnerId: partnerId,
        companyId: selectedCompanyId,
        expand: (0, $gUTZf.default).OcppConfig
    });
    const { data: organisations, isLoading: isLoadingOrganisations } = (0, $1O9Jh.usePartnerGetCompaniesByPartnerIdQuery)({
        partnerId: partnerId
    }, {
        skip: !partnerId
    });
    const [filters, setFilters] = (0, $7E7Dk.useState)({
        noOfItems: (0, $g915J.INITIAL_DEFAULT_TABLE_ROWS),
        page: 0,
        partnerId: (0, $eIymc.isPartnerDomain) ? partnerId : undefined,
        chargePointId: undefined,
        companyId: (0, $eIymc.isAdminDomain) ? selectedCompanyId : undefined,
        from: (0, $4MLzO.default)(new Date(), 1).toISOString(),
        to: undefined
    });
    const { data: rejectedTags, isLoading: rejectedTagsAreLoading } = (0, $1O9Jh.useNfcTagGetRejectedTagsQuery)(filters, {
        refetchOnMountOrArgChange: true
    });
    const [deleteRejectedTag] = (0, $1O9Jh.useChargePointDeleteRejectedTagMutation)();
    const handleDeleteRejectedRFIDTag = async (rfidTag)=>{
        if (!rfidTag) return;
        const confirmed = await (0, $9p3YO.confirm)({
            header: text("lblProceedConfirmation"),
            message: text("msgDoYouWantToDeleteRejectedRFID", {
                id: rfidTag.nfcTagId
            }),
            variant: "danger"
        });
        if (!confirmed) return;
        deleteRejectedTag({
            chargePointId: rfidTag.chargePointId,
            nfcTagId: rfidTag.nfcTagId
        }).unwrap().then(()=>{
            toast.notifySuccess(text("msgRejectedRFIDDeleted"));
        }).catch(()=>{
            toast.notifyError(text("msgRejectedRFIDNotDeleted"));
        });
    };
    const applyFilter = (filter)=>{
        setFilters((prev)=>({
                ...prev,
                ...filter,
                page: 0
            }));
    };
    const filteredData = (rejectedTags?.items ?? []).filter((item)=>{
        if (!globalFilter) return true;
        const search = globalFilter.toLowerCase();
        return item.nfcTagId?.toLowerCase()?.includes(search) || item.chargePointId?.toLowerCase()?.includes(search);
    }).map($d2ddb1db21a072ff$var$toRejectedAccessRow);
    const selectedCharger = chargePoints?.items?.find((item)=>item.id === filters.chargePointId);
    const page = filters.page ?? 0;
    const rows = filters.noOfItems ?? (0, $g915J.INITIAL_DEFAULT_TABLE_ROWS);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "flex flex-wrap gap-2 justify-content-end align-items-center mb-4"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "flex gap-2 align-items-center justify-content-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
        disabled: selectedTags.length === 0,
        onClick: onAddRfidTag,
        label: text("btnAddSelected"),
        icon: "pi pi-plus",
        "data-testid": "add-selected-tags-btn"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1o9MR.Input), {
        id: "organisation-search-input",
        type: "search",
        value: globalFilter,
        onChange: (e)=>setGlobalFilter(e.target.value),
        placeholder: text("lblSearch"),
        icon: (0, $eHYdO.PrimeIcons).SEARCH,
        "data-testid": "search-input"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
        icon: "pi pi-filter",
        rounded: true,
        text: true,
        onClick: (e)=>op.current?.toggle(e),
        "data-testid": "filter-btn"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $5L4Lm.OverlayPanel), {
        ref: op,
        closeOnEscape: true,
        className: "px-2 max-w-25rem",
        "data-testid": "filter-panel"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "field col-12"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $c6fcw.Dropdown), {
        label: text("lblChargePointId"),
        value: filters.chargePointId,
        options: chargePoints?.items?.map(({ id: id })=>({
                value: id,
                label: id
            })),
        onChange: (e)=>applyFilter({
                chargePointId: e.value
            }),
        checkmark: true,
        highlightOnSelect: false,
        filter: true,
        id: "charge-point-select",
        className: "w-full",
        showClear: true,
        loading: isLoadingChargePoints,
        "data-testid": "charge-point-select"
    }), selectedCharger && ((0, $hohPv.default)(selectedCharger) || (0, $lFIQ9.default)(selectedCharger)) && !(0, $aTggv.default)(selectedCharger, selectedCharger.connectors?.at(0)) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("small", {
        className: "p-text-secondary block mt-2"
    }, text("msgTurnOnNfcForReader")) : null), (0, $eIymc.isPartnerDomain) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "field col-12"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $c6fcw.Dropdown), {
        label: text("lblOrganisation"),
        value: filters.companyId,
        options: organisations?.map(({ id: id, name: name })=>({
                value: id,
                label: name
            })),
        onChange: (e)=>applyFilter({
                companyId: e.value
            }),
        checkmark: true,
        highlightOnSelect: false,
        filter: true,
        id: "organisation-select",
        className: "w-full",
        showClear: true,
        loading: isLoadingOrganisations,
        "data-testid": "organisation-select"
    })) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "field col-12"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("label", {
        className: "p-label",
        htmlFor: "charge-point-select"
    }, text("lblDateFrom")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $k6jwa.Calendar), {
        className: "w-full",
        id: "from",
        value: filters.from ? new Date(filters.from) : undefined,
        onChange: (e)=>applyFilter({
                from: e.value ? (0, $6Wotx.default)(e.value).toISOString() : undefined
            }),
        minDate: (0, $4179t.default)(new Date(), 1),
        maxDate: filters.to ? new Date(filters.to) : new Date(),
        showButtonBar: true,
        "data-testid": "date-from-input"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "field col-12"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("label", {
        className: "p-label",
        htmlFor: "charge-point-select"
    }, text("lblDateTo")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $k6jwa.Calendar), {
        className: "w-full",
        id: "to",
        value: filters.to ? new Date(filters.to) : undefined,
        onChange: (e)=>applyFilter({
                to: e.value ? (0, $90NQT.default)(e.value).toISOString() : undefined
            }),
        minDate: filters.from ? new Date(filters.from) : (0, $4179t.default)(new Date(), 1),
        maxDate: new Date(),
        showButtonBar: true,
        "data-testid": "date-to-input"
    }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $g915J.Table), {
        value: filteredData,
        dataKey: "rowKey",
        removableSort: true,
        loading: rejectedTagsAreLoading,
        lazy: true,
        paginator: true,
        rows: rows,
        emptyMessage: text("msgNoRfidTagsFound"),
        selectionMode: "checkbox",
        selection: selectedTags,
        onSelectionChange: (e)=>setSelectedTags(e.value),
        first: page * rows,
        totalRecords: rejectedTags?.totalCount ?? 0,
        "data-testid": "rejected-rfid-tags",
        onPage: (e)=>{
            setFilters((prev)=>({
                    ...prev,
                    page: e.page
                }));
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $ej4sl.Column), {
        selectionMode: "multiple",
        headerClassName: "w-3rem"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $ej4sl.Column), {
        field: "nfcTagId",
        header: text("lblId")
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $ej4sl.Column), {
        field: "chargePointId",
        header: text("lblChargePointId")
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $ej4sl.Column), {
        field: "timeStamp",
        header: text("lblRejectedAt"),
        body: (tagData)=>(0, $jwHtR.dateLocalize)(tagData.timeStamp)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $ej4sl.Column), {
        body: (rowData)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
                size: "small",
                icon: "pi pi-trash",
                rounded: true,
                outlined: true,
                severity: "danger",
                onClick: ()=>handleDeleteRejectedRFIDTag(rowData)
            });
        }
    })), partnerId ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $8JVsa.AddRFIDDialog), {
        visible: addRfidTagIsOpened,
        partnerId: partnerId,
        onSubmit: handleAddSelected,
        onHide: ()=>setAddRfidTagIsOpened(false)
    }) : null);
};

});
parcelRegister("cD5Z9", function(module, exports) {
$parcel$export(module.exports, "AddRFIDDialog", function () { return (parcelRequire("8JVsa")).AddRFIDDialog; });
parcelRequire("c3QMn");

});
parcelRegister("c3QMn", function(module, exports) {
$parcel$export(module.exports, "AddRFIDDialog", function () { return (parcelRequire("8JVsa")).AddRFIDDialog; });
parcelRequire("8JVsa");

});
parcelRegister("8JVsa", function(module, exports) {

$parcel$export(module.exports, "AddRFIDDialog", function () { return $f3970eea6091bfe6$export$da3b911690af9650; });

var $7E7Dk = parcelRequire("7E7Dk");

var $cCnqE = parcelRequire("cCnqE");

var $1ot1u = parcelRequire("1ot1u");

var $MMfqT = parcelRequire("MMfqT");

var $c6fcw = parcelRequire("c6fcw");

var $1O9Jh = parcelRequire("1O9Jh");

var $5u6k9 = parcelRequire("5u6k9");
const $f3970eea6091bfe6$var$formId = "add-rfid-form";
const $f3970eea6091bfe6$export$da3b911690af9650 = ({ visible: visible, onHide: onHide, onSubmit: onSubmit, partnerId: partnerId })=>{
    const text = (0, $5u6k9.default)();
    const { data: organisations = [], isLoading: isLoading } = (0, $1O9Jh.usePartnerGetCompaniesByPartnerIdQuery)({
        partnerId: partnerId
    }, {
        skip: !visible
    });
    const { handleSubmit: handleSubmit, control: control, reset: reset, formState: { errors: errors, isSubmitted: isSubmitted } } = (0, $cCnqE.useForm)({
        defaultValues: {
            organisationId: ""
        },
        mode: "onSubmit",
        reValidateMode: "onChange"
    });
    (0, $7E7Dk.useEffect)(()=>{
        if (visible) reset();
    }, [
        reset,
        visible
    ]);
    const organisationOptions = organisations.map((organisation)=>({
            value: organisation?.id,
            label: organisation?.name || ""
        }));
    const saveDisabled = isSubmitted && !!errors.organisationId;
    const footer = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "flex justify-content-end gap-2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
        label: text("btnCancel"),
        type: "button",
        text: true,
        onClick: onHide,
        "data-testid": "btn-cancel"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
        label: text("btnSave"),
        type: "submit",
        form: $f3970eea6091bfe6$var$formId,
        disabled: saveDisabled,
        loading: isLoading,
        "data-testid": "btn-save"
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $MMfqT.Dialog), {
        header: text("lblAddRFIDTagsModal"),
        visible: visible,
        onHide: onHide,
        footer: footer,
        "data-testid": "add-rfid-dialog"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("form", {
        id: $f3970eea6091bfe6$var$formId,
        className: "flex flex-column gap-2",
        noValidate: true,
        onSubmit: handleSubmit(({ organisationId: organisationId })=>onSubmit(organisationId))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $cCnqE.Controller), {
        name: "organisationId",
        control: control,
        rules: {
            required: text("msgOrganisationRequired")
        },
        render: ({ field: field })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $c6fcw.Dropdown), {
                id: "select-organisation",
                "data-testid": "select-organisation",
                label: text("lblOrganisationField"),
                value: field.value ?? null,
                options: organisationOptions,
                onChange: (event)=>field.onChange(event.value),
                onBlur: field.onBlur,
                error: errors.organisationId?.message,
                required: true
            })
    })));
};

});






parcelRegister("dos1r", function(module, exports) {

$parcel$export(module.exports, "getNamesWithFallback", function () { return $c444ef522d918e33$export$8f604c75c726477d; });

var $iH70r = parcelRequire("iH70r");

var $lzT6Z = parcelRequire("lzT6Z");

var $iC5ih = parcelRequire("iC5ih");

var $hgPCr = parcelRequire("hgPCr");
(0, (/*@__PURE__*/$parcel$interopDefault($iH70r))).registerLocale((0, (/*@__PURE__*/$parcel$interopDefault($lzT6Z))));
(0, (/*@__PURE__*/$parcel$interopDefault($iH70r))).registerLocale((0, (/*@__PURE__*/$parcel$interopDefault($iC5ih))));
(0, (/*@__PURE__*/$parcel$interopDefault($iH70r))).registerLocale((0, (/*@__PURE__*/$parcel$interopDefault($hgPCr))));
const $c444ef522d918e33$var$DEFAULT_LOCALE = "en";
const $c444ef522d918e33$var$allowedLocales = [
    "en",
    "sv",
    "de"
];
function $c444ef522d918e33$export$8f604c75c726477d(locale) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($iH70r))).getNames($c444ef522d918e33$var$allowedLocales.includes(locale) ? locale : $c444ef522d918e33$var$DEFAULT_LOCALE);
}
var $c444ef522d918e33$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($iH70r)));

});
parcelRegister("iH70r", function(module, exports) {

$parcel$export(module.exports, "registerLocale", function () { return $03831fb33aa6bd89$export$bab6a7822cc1e2cd; }, function (v) { return $03831fb33aa6bd89$export$bab6a7822cc1e2cd = v; });
$parcel$export(module.exports, "alpha3ToAlpha2", function () { return $03831fb33aa6bd89$export$2a91d0f6f59b9f68; }, function (v) { return $03831fb33aa6bd89$export$2a91d0f6f59b9f68 = v; });
$parcel$export(module.exports, "alpha2ToAlpha3", function () { return $03831fb33aa6bd89$export$65a456803fd0f049; }, function (v) { return $03831fb33aa6bd89$export$65a456803fd0f049 = v; });
$parcel$export(module.exports, "alpha3ToNumeric", function () { return $03831fb33aa6bd89$export$442b6884bee533cd; }, function (v) { return $03831fb33aa6bd89$export$442b6884bee533cd = v; });
$parcel$export(module.exports, "alpha2ToNumeric", function () { return $03831fb33aa6bd89$export$e8f1fd30e9fba660; }, function (v) { return $03831fb33aa6bd89$export$e8f1fd30e9fba660 = v; });
$parcel$export(module.exports, "numericToAlpha3", function () { return $03831fb33aa6bd89$export$c50ba58d0968541f; }, function (v) { return $03831fb33aa6bd89$export$c50ba58d0968541f = v; });
$parcel$export(module.exports, "numericToAlpha2", function () { return $03831fb33aa6bd89$export$e21a59c72a3c77a7; }, function (v) { return $03831fb33aa6bd89$export$e21a59c72a3c77a7 = v; });
$parcel$export(module.exports, "toAlpha3", function () { return $03831fb33aa6bd89$export$3d1d5c3d00561285; }, function (v) { return $03831fb33aa6bd89$export$3d1d5c3d00561285 = v; });
$parcel$export(module.exports, "toAlpha2", function () { return $03831fb33aa6bd89$export$53e0b99b5d556acf; }, function (v) { return $03831fb33aa6bd89$export$53e0b99b5d556acf = v; });
$parcel$export(module.exports, "getName", function () { return $03831fb33aa6bd89$export$7d9f7e9c1c02b41e; }, function (v) { return $03831fb33aa6bd89$export$7d9f7e9c1c02b41e = v; });
$parcel$export(module.exports, "getNames", function () { return $03831fb33aa6bd89$export$dc8de070e3f64a1a; }, function (v) { return $03831fb33aa6bd89$export$dc8de070e3f64a1a = v; });
$parcel$export(module.exports, "getAlpha2Code", function () { return $03831fb33aa6bd89$export$9abd449eff192ddc; }, function (v) { return $03831fb33aa6bd89$export$9abd449eff192ddc = v; });
$parcel$export(module.exports, "getSimpleAlpha2Code", function () { return $03831fb33aa6bd89$export$2db6702cc2165503; }, function (v) { return $03831fb33aa6bd89$export$2db6702cc2165503 = v; });
$parcel$export(module.exports, "getAlpha2Codes", function () { return $03831fb33aa6bd89$export$f340c49a8d00de7f; }, function (v) { return $03831fb33aa6bd89$export$f340c49a8d00de7f = v; });
$parcel$export(module.exports, "getAlpha3Code", function () { return $03831fb33aa6bd89$export$51175d5ff4bc4261; }, function (v) { return $03831fb33aa6bd89$export$51175d5ff4bc4261 = v; });
$parcel$export(module.exports, "getSimpleAlpha3Code", function () { return $03831fb33aa6bd89$export$13496d6083a3d6ac; }, function (v) { return $03831fb33aa6bd89$export$13496d6083a3d6ac = v; });
$parcel$export(module.exports, "getAlpha3Codes", function () { return $03831fb33aa6bd89$export$5b1d6865bbe9ebc; }, function (v) { return $03831fb33aa6bd89$export$5b1d6865bbe9ebc = v; });
$parcel$export(module.exports, "getNumericCodes", function () { return $03831fb33aa6bd89$export$5169b68793e9dfd1; }, function (v) { return $03831fb33aa6bd89$export$5169b68793e9dfd1 = v; });
$parcel$export(module.exports, "langs", function () { return $03831fb33aa6bd89$export$359be4c8544d6fb1; }, function (v) { return $03831fb33aa6bd89$export$359be4c8544d6fb1 = v; });
$parcel$export(module.exports, "getSupportedLanguages", function () { return $03831fb33aa6bd89$export$3308a67cbbb588bc; }, function (v) { return $03831fb33aa6bd89$export$3308a67cbbb588bc = v; });
$parcel$export(module.exports, "isValid", function () { return $03831fb33aa6bd89$export$1ea939691cdc45b8; }, function (v) { return $03831fb33aa6bd89$export$1ea939691cdc45b8 = v; });
/**
 * Register countries in browsers' environment:
 * @param {object} localeData
 * @example countries.registerLocale(require("i18n-iso-countries/langs/en.json"));
 * @return void
 */ var $03831fb33aa6bd89$export$bab6a7822cc1e2cd;
var $03831fb33aa6bd89$export$2a91d0f6f59b9f68;
var $03831fb33aa6bd89$export$65a456803fd0f049;
var $03831fb33aa6bd89$export$442b6884bee533cd;
var $03831fb33aa6bd89$export$e8f1fd30e9fba660;
var $03831fb33aa6bd89$export$c50ba58d0968541f;
var $03831fb33aa6bd89$export$e21a59c72a3c77a7;
var $03831fb33aa6bd89$export$3d1d5c3d00561285;
var $03831fb33aa6bd89$export$53e0b99b5d556acf;
/**
 * @param {string | number | Alpha2Code | Alpha3Code} code
 * @param {String} lang          language for country name
 * @param {GetNameOptions} options
 * @return {String | String[] | undefined}  name
 */ var $03831fb33aa6bd89$export$7d9f7e9c1c02b41e;
/**
 * @param {String} lang             language for country names
 * @param {GetNameOptions} options   getNames Options
 * @return {LocalizedCountryNames}  country code
 *                                  mapped to county name
 */ var $03831fb33aa6bd89$export$dc8de070e3f64a1a;
/*
 * @param name name
 * @param lang language for country name
 * @return ISO 3166-1 alpha-2 or undefined
 */ var $03831fb33aa6bd89$export$9abd449eff192ddc;
/*
 * @param name name
 * @param lang language for country name
 * @return ISO 3166-1 alpha-2 or undefined
 */ var $03831fb33aa6bd89$export$2db6702cc2165503;
/*
 * @return Object of alpha-2 codes mapped to alpha-3 codes
 */ var $03831fb33aa6bd89$export$f340c49a8d00de7f;
/*
 * @param name name
 * @param lang language for country name
 * @return ISO 3166-1 alpha-3 or undefined
 */ var $03831fb33aa6bd89$export$51175d5ff4bc4261;
/*
 * @param name name
 * @param lang language for country name
 * @return ISO 3166-1 alpha-3 or undefined
 */ var $03831fb33aa6bd89$export$13496d6083a3d6ac;
/*
 * @return Object of alpha-3 codes mapped to alpha-2 codes
 */ var $03831fb33aa6bd89$export$5b1d6865bbe9ebc;
/*
 * @return Object of numeric codes mapped to alpha-2 codes
 */ var $03831fb33aa6bd89$export$5169b68793e9dfd1;
/*
 * @return Array of registered languages
 */ var $03831fb33aa6bd89$export$359be4c8544d6fb1;
/*
 * @return Array of supported languages
 */ var $03831fb33aa6bd89$export$3308a67cbbb588bc;
/*
 * @param code ISO 3166-1 alpha-2, alpha-3 or numeric code
 * @return Boolean
 */ var $03831fb33aa6bd89$export$1ea939691cdc45b8;
"use strict";

var $i5aux = parcelRequire("i5aux");

var $gI0I2 = parcelRequire("gI0I2");

var $k0kKK = parcelRequire("k0kKK");
var $03831fb33aa6bd89$require$removeDiacritics = $k0kKK.remove;
const $03831fb33aa6bd89$var$registeredLocales = {};
/*
 * All codes map to ISO 3166-1 alpha-2
 */ const $03831fb33aa6bd89$var$alpha2 = {}, $03831fb33aa6bd89$var$alpha3 = {}, $03831fb33aa6bd89$var$numeric = {}, $03831fb33aa6bd89$var$invertedNumeric = {};
$i5aux.forEach(function(codeInformation) {
    const s = codeInformation;
    $03831fb33aa6bd89$var$alpha2[s[0]] = s[1];
    $03831fb33aa6bd89$var$alpha3[s[1]] = s[0];
    $03831fb33aa6bd89$var$numeric[s[2]] = s[0];
    $03831fb33aa6bd89$var$invertedNumeric[s[0]] = s[2];
});
/**
 * @private
 * @param {number} code
 */ function $03831fb33aa6bd89$var$formatNumericCode(code) {
    return String("000" + (code ? code : "")).slice(-3);
}
/**
 * @private
 * Avoid using obj.hasOwnProperty directly as `hasOwnProperty` could be a
 * property in itself ({ hasOwnProperty: 1 }) and cause weird bugs
 * https://eslint.org/docs/rules/no-prototype-builtins
 */ function $03831fb33aa6bd89$var$hasOwnProperty(object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
}
/**
 * @private
 * Pass localeList through a filter and return a newLocaleList obj
 * with the same structure of the old localeList.
 *
 * @param {LocalizedCountryNames} localeList  Local List in raw
 * @param {Function} filter    callback to set filter rule
 * @return {String | String[]} new filtered Local List
 */ function $03831fb33aa6bd89$var$localeFilter(localeList, filter) {
    return Object.keys(localeList).reduce(function(newLocaleList, alpha2) {
        const nameList = localeList[alpha2];
        newLocaleList[alpha2] = filter(nameList, alpha2);
        return newLocaleList;
    }, {});
}
/**
 * @private
 * Preserve for getName & getNames
 *
 * @param {GetNameOptions.select} type all | official | alias
 * @param countryNameList  string array of country's
 *                         official name and alias
 * @return {String | String[]} of a country name
 */ function $03831fb33aa6bd89$var$filterNameBy(type, countryNameList) {
    switch(type){
        case "official":
            return Array.isArray(countryNameList) ? countryNameList[0] : countryNameList;
        case "all":
            return typeof countryNameList === "string" ? [
                countryNameList
            ] : countryNameList;
        case "alias":
            return Array.isArray(countryNameList) ? countryNameList[1] || countryNameList[0] : countryNameList;
        default:
            throw new TypeError("LocaleNameType must be one of these: all, official, alias!");
    }
}
$03831fb33aa6bd89$export$bab6a7822cc1e2cd = function(localeData) {
    if (!localeData.locale) throw new TypeError("Missing localeData.locale");
    if (!localeData.countries) throw new TypeError("Missing localeData.countries");
    $03831fb33aa6bd89$var$registeredLocales[localeData.locale] = localeData.countries;
};
/*
 * @param code Alpha-3 code
 * @return Alpha-2 code or undefined
 */ function $03831fb33aa6bd89$var$alpha3ToAlpha2(code) {
    return $03831fb33aa6bd89$var$alpha3[code];
}
$03831fb33aa6bd89$export$2a91d0f6f59b9f68 = $03831fb33aa6bd89$var$alpha3ToAlpha2;
/*
 * @param code Alpha-2 code
 * @return Alpha-3 code or undefined
 */ function $03831fb33aa6bd89$var$alpha2ToAlpha3(code) {
    return $03831fb33aa6bd89$var$alpha2[code];
}
$03831fb33aa6bd89$export$65a456803fd0f049 = $03831fb33aa6bd89$var$alpha2ToAlpha3;
/*
 * @param code Alpha-3 code
 * @return Numeric code or undefined
 */ function $03831fb33aa6bd89$var$alpha3ToNumeric(code) {
    return $03831fb33aa6bd89$var$invertedNumeric[$03831fb33aa6bd89$var$alpha3ToAlpha2(code)];
}
$03831fb33aa6bd89$export$442b6884bee533cd = $03831fb33aa6bd89$var$alpha3ToNumeric;
/*
 * @param code Alpha-2 code
 * @return Numeric code or undefined
 */ function $03831fb33aa6bd89$var$alpha2ToNumeric(code) {
    return $03831fb33aa6bd89$var$invertedNumeric[code];
}
$03831fb33aa6bd89$export$e8f1fd30e9fba660 = $03831fb33aa6bd89$var$alpha2ToNumeric;
/*
 * @param code Numeric code
 * @return Alpha-3 code or undefined
 */ function $03831fb33aa6bd89$var$numericToAlpha3(code) {
    const padded = $03831fb33aa6bd89$var$formatNumericCode(code);
    return $03831fb33aa6bd89$var$alpha2ToAlpha3($03831fb33aa6bd89$var$numeric[padded]);
}
$03831fb33aa6bd89$export$c50ba58d0968541f = $03831fb33aa6bd89$var$numericToAlpha3;
/*
 * @param code Numeric code
 * @return Alpha-2 code or undefined
 */ function $03831fb33aa6bd89$var$numericToAlpha2(code) {
    const padded = $03831fb33aa6bd89$var$formatNumericCode(code);
    return $03831fb33aa6bd89$var$numeric[padded];
}
$03831fb33aa6bd89$export$e21a59c72a3c77a7 = $03831fb33aa6bd89$var$numericToAlpha2;
/*
 * @param code ISO 3166-1 alpha-2, alpha-3 or numeric code
 * @return ISO 3166-1 alpha-3
 */ function $03831fb33aa6bd89$var$toAlpha3(code) {
    if (typeof code === "string") {
        if (/^[0-9]*$/.test(code)) return $03831fb33aa6bd89$var$numericToAlpha3(code);
        if (code.length === 2) return $03831fb33aa6bd89$var$alpha2ToAlpha3(code.toUpperCase());
        if (code.length === 3) return code.toUpperCase();
    }
    if (typeof code === "number") return $03831fb33aa6bd89$var$numericToAlpha3(code);
    return undefined;
}
$03831fb33aa6bd89$export$3d1d5c3d00561285 = $03831fb33aa6bd89$var$toAlpha3;
/*
 * @param code ISO 3166-1 alpha-2, alpha-3 or numeric code
 * @return ISO 3166-1 alpha-2
 */ function $03831fb33aa6bd89$var$toAlpha2(code) {
    if (typeof code === "string") {
        if (/^[0-9]*$/.test(code)) return $03831fb33aa6bd89$var$numericToAlpha2(code);
        if (code.length === 2) return code.toUpperCase();
        if (code.length === 3) return $03831fb33aa6bd89$var$alpha3ToAlpha2(code.toUpperCase());
    }
    if (typeof code === "number") return $03831fb33aa6bd89$var$numericToAlpha2(code);
    return undefined;
}
$03831fb33aa6bd89$export$53e0b99b5d556acf = $03831fb33aa6bd89$var$toAlpha2;
$03831fb33aa6bd89$export$7d9f7e9c1c02b41e = function(code, lang, options = {}) {
    if (!("select" in options)) options.select = "official";
    try {
        const codeMaps = $03831fb33aa6bd89$var$registeredLocales[lang.toLowerCase()];
        const nameList = codeMaps[$03831fb33aa6bd89$var$toAlpha2(code)];
        return $03831fb33aa6bd89$var$filterNameBy(options.select, nameList);
    } catch (err) {
        return undefined;
    }
};
$03831fb33aa6bd89$export$dc8de070e3f64a1a = function(lang, options = {}) {
    if (!("select" in options)) options.select = "official";
    const localeList = $03831fb33aa6bd89$var$registeredLocales[lang.toLowerCase()];
    if (localeList === undefined) return {};
    return $03831fb33aa6bd89$var$localeFilter(localeList, function(nameList) {
        return $03831fb33aa6bd89$var$filterNameBy(options.select, nameList);
    });
};
$03831fb33aa6bd89$export$9abd449eff192ddc = function(name, lang) {
    const normalizeString = (string)=>string.toLowerCase();
    const areSimilar = (a, b)=>normalizeString(a) === normalizeString(b);
    try {
        const codenames = $03831fb33aa6bd89$var$registeredLocales[lang.toLowerCase()];
        for(const p in codenames){
            if (!$03831fb33aa6bd89$var$hasOwnProperty(codenames, p)) continue;
            if (typeof codenames[p] === "string") {
                if (areSimilar(codenames[p], name)) return p;
            }
            if (Array.isArray(codenames[p])) for (const mappedName of codenames[p]){
                if (areSimilar(mappedName, name)) return p;
            }
        }
        return undefined;
    } catch (err) {
        return undefined;
    }
};
$03831fb33aa6bd89$export$2db6702cc2165503 = function(name, lang) {
    const normalizeString = (string)=>$03831fb33aa6bd89$require$removeDiacritics(string.toLowerCase());
    const areSimilar = (a, b)=>normalizeString(a) === normalizeString(b);
    try {
        const codenames = $03831fb33aa6bd89$var$registeredLocales[lang.toLowerCase()];
        for(const p in codenames){
            if (!$03831fb33aa6bd89$var$hasOwnProperty(codenames, p)) continue;
            if (typeof codenames[p] === "string") {
                if (areSimilar(codenames[p], name)) return p;
            }
            if (Array.isArray(codenames[p])) for (const mappedName of codenames[p]){
                if (areSimilar(mappedName, name)) return p;
            }
        }
        return undefined;
    } catch (err) {
        return undefined;
    }
};
$03831fb33aa6bd89$export$f340c49a8d00de7f = function() {
    return $03831fb33aa6bd89$var$alpha2;
};
$03831fb33aa6bd89$export$51175d5ff4bc4261 = function(name, lang) {
    const alpha2 = $03831fb33aa6bd89$export$9abd449eff192ddc(name, lang);
    if (alpha2) return $03831fb33aa6bd89$export$3d1d5c3d00561285(alpha2);
    else return undefined;
};
$03831fb33aa6bd89$export$13496d6083a3d6ac = function(name, lang) {
    const alpha2 = $03831fb33aa6bd89$export$2db6702cc2165503(name, lang);
    if (alpha2) return $03831fb33aa6bd89$export$3d1d5c3d00561285(alpha2);
    else return undefined;
};
$03831fb33aa6bd89$export$5b1d6865bbe9ebc = function() {
    return $03831fb33aa6bd89$var$alpha3;
};
$03831fb33aa6bd89$export$5169b68793e9dfd1 = function() {
    return $03831fb33aa6bd89$var$numeric;
};
$03831fb33aa6bd89$export$359be4c8544d6fb1 = function() {
    return Object.keys($03831fb33aa6bd89$var$registeredLocales);
};
$03831fb33aa6bd89$export$3308a67cbbb588bc = function() {
    return $gI0I2;
};
$03831fb33aa6bd89$export$1ea939691cdc45b8 = function(code) {
    if (!code) return false;
    const coerced = code.toString().toUpperCase();
    return $03831fb33aa6bd89$var$hasOwnProperty($03831fb33aa6bd89$var$alpha3, coerced) || $03831fb33aa6bd89$var$hasOwnProperty($03831fb33aa6bd89$var$alpha2, coerced) || $03831fb33aa6bd89$var$hasOwnProperty($03831fb33aa6bd89$var$numeric, coerced);
};

});
parcelRegister("i5aux", function(module, exports) {
module.exports = JSON.parse('[["AF","AFG","004","ISO 3166-2:AF"],["AL","ALB","008","ISO 3166-2:AL"],["DZ","DZA","012","ISO 3166-2:DZ"],["AS","ASM","016","ISO 3166-2:AS"],["AD","AND","020","ISO 3166-2:AD"],["AO","AGO","024","ISO 3166-2:AO"],["AI","AIA","660","ISO 3166-2:AI"],["AQ","ATA","010","ISO 3166-2:AQ"],["AG","ATG","028","ISO 3166-2:AG"],["AR","ARG","032","ISO 3166-2:AR"],["AM","ARM","051","ISO 3166-2:AM"],["AW","ABW","533","ISO 3166-2:AW"],["AU","AUS","036","ISO 3166-2:AU"],["AT","AUT","040","ISO 3166-2:AT"],["AZ","AZE","031","ISO 3166-2:AZ"],["BS","BHS","044","ISO 3166-2:BS"],["BH","BHR","048","ISO 3166-2:BH"],["BD","BGD","050","ISO 3166-2:BD"],["BB","BRB","052","ISO 3166-2:BB"],["BY","BLR","112","ISO 3166-2:BY"],["BE","BEL","056","ISO 3166-2:BE"],["BZ","BLZ","084","ISO 3166-2:BZ"],["BJ","BEN","204","ISO 3166-2:BJ"],["BM","BMU","060","ISO 3166-2:BM"],["BT","BTN","064","ISO 3166-2:BT"],["BO","BOL","068","ISO 3166-2:BO"],["BA","BIH","070","ISO 3166-2:BA"],["BW","BWA","072","ISO 3166-2:BW"],["BV","BVT","074","ISO 3166-2:BV"],["BR","BRA","076","ISO 3166-2:BR"],["IO","IOT","086","ISO 3166-2:IO"],["BN","BRN","096","ISO 3166-2:BN"],["BG","BGR","100","ISO 3166-2:BG"],["BF","BFA","854","ISO 3166-2:BF"],["BI","BDI","108","ISO 3166-2:BI"],["KH","KHM","116","ISO 3166-2:KH"],["CM","CMR","120","ISO 3166-2:CM"],["CA","CAN","124","ISO 3166-2:CA"],["CV","CPV","132","ISO 3166-2:CV"],["KY","CYM","136","ISO 3166-2:KY"],["CF","CAF","140","ISO 3166-2:CF"],["TD","TCD","148","ISO 3166-2:TD"],["CL","CHL","152","ISO 3166-2:CL"],["CN","CHN","156","ISO 3166-2:CN"],["CX","CXR","162","ISO 3166-2:CX"],["CC","CCK","166","ISO 3166-2:CC"],["CO","COL","170","ISO 3166-2:CO"],["KM","COM","174","ISO 3166-2:KM"],["CG","COG","178","ISO 3166-2:CG"],["CD","COD","180","ISO 3166-2:CD"],["CK","COK","184","ISO 3166-2:CK"],["CR","CRI","188","ISO 3166-2:CR"],["CI","CIV","384","ISO 3166-2:CI"],["HR","HRV","191","ISO 3166-2:HR"],["CU","CUB","192","ISO 3166-2:CU"],["CY","CYP","196","ISO 3166-2:CY"],["CZ","CZE","203","ISO 3166-2:CZ"],["DK","DNK","208","ISO 3166-2:DK"],["DJ","DJI","262","ISO 3166-2:DJ"],["DM","DMA","212","ISO 3166-2:DM"],["DO","DOM","214","ISO 3166-2:DO"],["EC","ECU","218","ISO 3166-2:EC"],["EG","EGY","818","ISO 3166-2:EG"],["SV","SLV","222","ISO 3166-2:SV"],["GQ","GNQ","226","ISO 3166-2:GQ"],["ER","ERI","232","ISO 3166-2:ER"],["EE","EST","233","ISO 3166-2:EE"],["ET","ETH","231","ISO 3166-2:ET"],["FK","FLK","238","ISO 3166-2:FK"],["FO","FRO","234","ISO 3166-2:FO"],["FJ","FJI","242","ISO 3166-2:FJ"],["FI","FIN","246","ISO 3166-2:FI"],["FR","FRA","250","ISO 3166-2:FR"],["GF","GUF","254","ISO 3166-2:GF"],["PF","PYF","258","ISO 3166-2:PF"],["TF","ATF","260","ISO 3166-2:TF"],["GA","GAB","266","ISO 3166-2:GA"],["GM","GMB","270","ISO 3166-2:GM"],["GE","GEO","268","ISO 3166-2:GE"],["DE","DEU","276","ISO 3166-2:DE"],["GH","GHA","288","ISO 3166-2:GH"],["GI","GIB","292","ISO 3166-2:GI"],["GR","GRC","300","ISO 3166-2:GR"],["GL","GRL","304","ISO 3166-2:GL"],["GD","GRD","308","ISO 3166-2:GD"],["GP","GLP","312","ISO 3166-2:GP"],["GU","GUM","316","ISO 3166-2:GU"],["GT","GTM","320","ISO 3166-2:GT"],["GN","GIN","324","ISO 3166-2:GN"],["GW","GNB","624","ISO 3166-2:GW"],["GY","GUY","328","ISO 3166-2:GY"],["HT","HTI","332","ISO 3166-2:HT"],["HM","HMD","334","ISO 3166-2:HM"],["VA","VAT","336","ISO 3166-2:VA"],["HN","HND","340","ISO 3166-2:HN"],["HK","HKG","344","ISO 3166-2:HK"],["HU","HUN","348","ISO 3166-2:HU"],["IS","ISL","352","ISO 3166-2:IS"],["IN","IND","356","ISO 3166-2:IN"],["ID","IDN","360","ISO 3166-2:ID"],["IR","IRN","364","ISO 3166-2:IR"],["IQ","IRQ","368","ISO 3166-2:IQ"],["IE","IRL","372","ISO 3166-2:IE"],["IL","ISR","376","ISO 3166-2:IL"],["IT","ITA","380","ISO 3166-2:IT"],["JM","JAM","388","ISO 3166-2:JM"],["JP","JPN","392","ISO 3166-2:JP"],["JO","JOR","400","ISO 3166-2:JO"],["KZ","KAZ","398","ISO 3166-2:KZ"],["KE","KEN","404","ISO 3166-2:KE"],["KI","KIR","296","ISO 3166-2:KI"],["KP","PRK","408","ISO 3166-2:KP"],["KR","KOR","410","ISO 3166-2:KR"],["KW","KWT","414","ISO 3166-2:KW"],["KG","KGZ","417","ISO 3166-2:KG"],["LA","LAO","418","ISO 3166-2:LA"],["LV","LVA","428","ISO 3166-2:LV"],["LB","LBN","422","ISO 3166-2:LB"],["LS","LSO","426","ISO 3166-2:LS"],["LR","LBR","430","ISO 3166-2:LR"],["LY","LBY","434","ISO 3166-2:LY"],["LI","LIE","438","ISO 3166-2:LI"],["LT","LTU","440","ISO 3166-2:LT"],["LU","LUX","442","ISO 3166-2:LU"],["MO","MAC","446","ISO 3166-2:MO"],["MG","MDG","450","ISO 3166-2:MG"],["MW","MWI","454","ISO 3166-2:MW"],["MY","MYS","458","ISO 3166-2:MY"],["MV","MDV","462","ISO 3166-2:MV"],["ML","MLI","466","ISO 3166-2:ML"],["MT","MLT","470","ISO 3166-2:MT"],["MH","MHL","584","ISO 3166-2:MH"],["MQ","MTQ","474","ISO 3166-2:MQ"],["MR","MRT","478","ISO 3166-2:MR"],["MU","MUS","480","ISO 3166-2:MU"],["YT","MYT","175","ISO 3166-2:YT"],["MX","MEX","484","ISO 3166-2:MX"],["FM","FSM","583","ISO 3166-2:FM"],["MD","MDA","498","ISO 3166-2:MD"],["MC","MCO","492","ISO 3166-2:MC"],["MN","MNG","496","ISO 3166-2:MN"],["MS","MSR","500","ISO 3166-2:MS"],["MA","MAR","504","ISO 3166-2:MA"],["MZ","MOZ","508","ISO 3166-2:MZ"],["MM","MMR","104","ISO 3166-2:MM"],["NA","NAM","516","ISO 3166-2:NA"],["NR","NRU","520","ISO 3166-2:NR"],["NP","NPL","524","ISO 3166-2:NP"],["NL","NLD","528","ISO 3166-2:NL"],["NC","NCL","540","ISO 3166-2:NC"],["NZ","NZL","554","ISO 3166-2:NZ"],["NI","NIC","558","ISO 3166-2:NI"],["NE","NER","562","ISO 3166-2:NE"],["NG","NGA","566","ISO 3166-2:NG"],["NU","NIU","570","ISO 3166-2:NU"],["NF","NFK","574","ISO 3166-2:NF"],["MP","MNP","580","ISO 3166-2:MP"],["MK","MKD","807","ISO 3166-2:MK"],["NO","NOR","578","ISO 3166-2:NO"],["OM","OMN","512","ISO 3166-2:OM"],["PK","PAK","586","ISO 3166-2:PK"],["PW","PLW","585","ISO 3166-2:PW"],["PS","PSE","275","ISO 3166-2:PS"],["PA","PAN","591","ISO 3166-2:PA"],["PG","PNG","598","ISO 3166-2:PG"],["PY","PRY","600","ISO 3166-2:PY"],["PE","PER","604","ISO 3166-2:PE"],["PH","PHL","608","ISO 3166-2:PH"],["PN","PCN","612","ISO 3166-2:PN"],["PL","POL","616","ISO 3166-2:PL"],["PT","PRT","620","ISO 3166-2:PT"],["PR","PRI","630","ISO 3166-2:PR"],["QA","QAT","634","ISO 3166-2:QA"],["RE","REU","638","ISO 3166-2:RE"],["RO","ROU","642","ISO 3166-2:RO"],["RU","RUS","643","ISO 3166-2:RU"],["RW","RWA","646","ISO 3166-2:RW"],["SH","SHN","654","ISO 3166-2:SH"],["KN","KNA","659","ISO 3166-2:KN"],["LC","LCA","662","ISO 3166-2:LC"],["PM","SPM","666","ISO 3166-2:PM"],["VC","VCT","670","ISO 3166-2:VC"],["WS","WSM","882","ISO 3166-2:WS"],["SM","SMR","674","ISO 3166-2:SM"],["ST","STP","678","ISO 3166-2:ST"],["SA","SAU","682","ISO 3166-2:SA"],["SN","SEN","686","ISO 3166-2:SN"],["SC","SYC","690","ISO 3166-2:SC"],["SL","SLE","694","ISO 3166-2:SL"],["SG","SGP","702","ISO 3166-2:SG"],["SK","SVK","703","ISO 3166-2:SK"],["SI","SVN","705","ISO 3166-2:SI"],["SB","SLB","090","ISO 3166-2:SB"],["SO","SOM","706","ISO 3166-2:SO"],["ZA","ZAF","710","ISO 3166-2:ZA"],["GS","SGS","239","ISO 3166-2:GS"],["ES","ESP","724","ISO 3166-2:ES"],["LK","LKA","144","ISO 3166-2:LK"],["SD","SDN","729","ISO 3166-2:SD"],["SR","SUR","740","ISO 3166-2:SR"],["SJ","SJM","744","ISO 3166-2:SJ"],["SZ","SWZ","748","ISO 3166-2:SZ"],["SE","SWE","752","ISO 3166-2:SE"],["CH","CHE","756","ISO 3166-2:CH"],["SY","SYR","760","ISO 3166-2:SY"],["TW","TWN","158","ISO 3166-2:TW"],["TJ","TJK","762","ISO 3166-2:TJ"],["TZ","TZA","834","ISO 3166-2:TZ"],["TH","THA","764","ISO 3166-2:TH"],["TL","TLS","626","ISO 3166-2:TL"],["TG","TGO","768","ISO 3166-2:TG"],["TK","TKL","772","ISO 3166-2:TK"],["TO","TON","776","ISO 3166-2:TO"],["TT","TTO","780","ISO 3166-2:TT"],["TN","TUN","788","ISO 3166-2:TN"],["TR","TUR","792","ISO 3166-2:TR"],["TM","TKM","795","ISO 3166-2:TM"],["TC","TCA","796","ISO 3166-2:TC"],["TV","TUV","798","ISO 3166-2:TV"],["UG","UGA","800","ISO 3166-2:UG"],["UA","UKR","804","ISO 3166-2:UA"],["AE","ARE","784","ISO 3166-2:AE"],["GB","GBR","826","ISO 3166-2:GB"],["US","USA","840","ISO 3166-2:US"],["UM","UMI","581","ISO 3166-2:UM"],["UY","URY","858","ISO 3166-2:UY"],["UZ","UZB","860","ISO 3166-2:UZ"],["VU","VUT","548","ISO 3166-2:VU"],["VE","VEN","862","ISO 3166-2:VE"],["VN","VNM","704","ISO 3166-2:VN"],["VG","VGB","092","ISO 3166-2:VG"],["VI","VIR","850","ISO 3166-2:VI"],["WF","WLF","876","ISO 3166-2:WF"],["EH","ESH","732","ISO 3166-2:EH"],["YE","YEM","887","ISO 3166-2:YE"],["ZM","ZMB","894","ISO 3166-2:ZM"],["ZW","ZWE","716","ISO 3166-2:ZW"],["AX","ALA","248","ISO 3166-2:AX"],["BQ","BES","535","ISO 3166-2:BQ"],["CW","CUW","531","ISO 3166-2:CW"],["GG","GGY","831","ISO 3166-2:GG"],["IM","IMN","833","ISO 3166-2:IM"],["JE","JEY","832","ISO 3166-2:JE"],["ME","MNE","499","ISO 3166-2:ME"],["BL","BLM","652","ISO 3166-2:BL"],["MF","MAF","663","ISO 3166-2:MF"],["RS","SRB","688","ISO 3166-2:RS"],["SX","SXM","534","ISO 3166-2:SX"],["SS","SSD","728","ISO 3166-2:SS"],["XK","XKK","983","ISO 3166-2:XK"]]');

});

parcelRegister("gI0I2", function(module, exports) {
module.exports = JSON.parse('["br","cy","dv","sw","eu","af","am","ha","ku","ml","mt","no","ps","sd","so","sq","ta","tg","tt","ug","ur","vi","ar","az","be","bg","bn","bs","ca","cs","da","de","el","en","es","et","fa","fi","fr","ga","gl","he","hi","hr","hu","hy","id","is","it","ja","ka","kk","km","ko","ky","lt","lv","mk","mn","mr","ms","nb","nl","nn","pl","pt","ro","ru","sk","sl","sr","sv","th","tk","tr","uk","uz","zh"]');

});

parcelRegister("k0kKK", function(module, exports) {

$parcel$export(module.exports, "remove", function () { return $e903e7dce6dc4d79$export$cd7f480d6b8286c3; }, function (v) { return $e903e7dce6dc4d79$export$cd7f480d6b8286c3 = v; });
var $e903e7dce6dc4d79$export$cd7f480d6b8286c3;
var $e903e7dce6dc4d79$export$452fcf31d2a11c49;
var $e903e7dce6dc4d79$export$a078a2660a2c4d03;
$e903e7dce6dc4d79$export$cd7f480d6b8286c3 = $e903e7dce6dc4d79$var$removeDiacritics;
var $e903e7dce6dc4d79$var$replacementList = [
    {
        base: " ",
        chars: "\xa0"
    },
    {
        base: "0",
        chars: "\u07C0"
    },
    {
        base: "A",
        chars: "\u24B6\uFF21\xc0\xc1\xc2\u1EA6\u1EA4\u1EAA\u1EA8\xc3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xc4\u01DE\u1EA2\xc5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
    },
    {
        base: "AA",
        chars: "\uA732"
    },
    {
        base: "AE",
        chars: "\xc6\u01FC\u01E2"
    },
    {
        base: "AO",
        chars: "\uA734"
    },
    {
        base: "AU",
        chars: "\uA736"
    },
    {
        base: "AV",
        chars: "\uA738\uA73A"
    },
    {
        base: "AY",
        chars: "\uA73C"
    },
    {
        base: "B",
        chars: "\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0181"
    },
    {
        base: "C",
        chars: "\u24B8\uFF23\uA73E\u1E08\u0106C\u0108\u010A\u010C\xc7\u0187\u023B"
    },
    {
        base: "D",
        chars: "\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018A\u0189\u1D05\uA779"
    },
    {
        base: "Dh",
        chars: "\xd0"
    },
    {
        base: "DZ",
        chars: "\u01F1\u01C4"
    },
    {
        base: "Dz",
        chars: "\u01F2\u01C5"
    },
    {
        base: "E",
        chars: "\u025B\u24BA\uFF25\xc8\xc9\xca\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xcb\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E\u1D07"
    },
    {
        base: "F",
        chars: "\uA77C\u24BB\uFF26\u1E1E\u0191\uA77B"
    },
    {
        base: "G",
        chars: "\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E\u0262"
    },
    {
        base: "H",
        chars: "\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
    },
    {
        base: "I",
        chars: "\u24BE\uFF29\xcc\xcd\xce\u0128\u012A\u012C\u0130\xcf\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
    },
    {
        base: "J",
        chars: "\u24BF\uFF2A\u0134\u0248\u0237"
    },
    {
        base: "K",
        chars: "\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
    },
    {
        base: "L",
        chars: "\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
    },
    {
        base: "LJ",
        chars: "\u01C7"
    },
    {
        base: "Lj",
        chars: "\u01C8"
    },
    {
        base: "M",
        chars: "\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C\u03FB"
    },
    {
        base: "N",
        chars: "\uA7A4\u0220\u24C3\uFF2E\u01F8\u0143\xd1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u019D\uA790\u1D0E"
    },
    {
        base: "NJ",
        chars: "\u01CA"
    },
    {
        base: "Nj",
        chars: "\u01CB"
    },
    {
        base: "O",
        chars: "\u24C4\uFF2F\xd2\xd3\xd4\u1ED2\u1ED0\u1ED6\u1ED4\xd5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xd6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xd8\u01FE\u0186\u019F\uA74A\uA74C"
    },
    {
        base: "OE",
        chars: "\u0152"
    },
    {
        base: "OI",
        chars: "\u01A2"
    },
    {
        base: "OO",
        chars: "\uA74E"
    },
    {
        base: "OU",
        chars: "\u0222"
    },
    {
        base: "P",
        chars: "\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
    },
    {
        base: "Q",
        chars: "\u24C6\uFF31\uA756\uA758\u024A"
    },
    {
        base: "R",
        chars: "\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
    },
    {
        base: "S",
        chars: "\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
    },
    {
        base: "T",
        chars: "\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
    },
    {
        base: "Th",
        chars: "\xde"
    },
    {
        base: "TZ",
        chars: "\uA728"
    },
    {
        base: "U",
        chars: "\u24CA\uFF35\xd9\xda\xdb\u0168\u1E78\u016A\u1E7A\u016C\xdc\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
    },
    {
        base: "V",
        chars: "\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
    },
    {
        base: "VY",
        chars: "\uA760"
    },
    {
        base: "W",
        chars: "\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
    },
    {
        base: "X",
        chars: "\u24CD\uFF38\u1E8A\u1E8C"
    },
    {
        base: "Y",
        chars: "\u24CE\uFF39\u1EF2\xdd\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
    },
    {
        base: "Z",
        chars: "\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
    },
    {
        base: "a",
        chars: "\u24D0\uFF41\u1E9A\xe0\xe1\xe2\u1EA7\u1EA5\u1EAB\u1EA9\xe3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xe4\u01DF\u1EA3\xe5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250\u0251"
    },
    {
        base: "aa",
        chars: "\uA733"
    },
    {
        base: "ae",
        chars: "\xe6\u01FD\u01E3"
    },
    {
        base: "ao",
        chars: "\uA735"
    },
    {
        base: "au",
        chars: "\uA737"
    },
    {
        base: "av",
        chars: "\uA739\uA73B"
    },
    {
        base: "ay",
        chars: "\uA73D"
    },
    {
        base: "b",
        chars: "\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253\u0182"
    },
    {
        base: "c",
        chars: "\uFF43\u24D2\u0107\u0109\u010B\u010D\xe7\u1E09\u0188\u023C\uA73F\u2184"
    },
    {
        base: "d",
        chars: "\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\u018B\u13E7\u0501\uA7AA"
    },
    {
        base: "dh",
        chars: "\xf0"
    },
    {
        base: "dz",
        chars: "\u01F3\u01C6"
    },
    {
        base: "e",
        chars: "\u24D4\uFF45\xe8\xe9\xea\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xeb\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u01DD"
    },
    {
        base: "f",
        chars: "\u24D5\uFF46\u1E1F\u0192"
    },
    {
        base: "ff",
        chars: "\uFB00"
    },
    {
        base: "fi",
        chars: "\uFB01"
    },
    {
        base: "fl",
        chars: "\uFB02"
    },
    {
        base: "ffi",
        chars: "\uFB03"
    },
    {
        base: "ffl",
        chars: "\uFB04"
    },
    {
        base: "g",
        chars: "\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\uA77F\u1D79"
    },
    {
        base: "h",
        chars: "\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
    },
    {
        base: "hv",
        chars: "\u0195"
    },
    {
        base: "i",
        chars: "\u24D8\uFF49\xec\xed\xee\u0129\u012B\u012D\xef\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
    },
    {
        base: "j",
        chars: "\u24D9\uFF4A\u0135\u01F0\u0249"
    },
    {
        base: "k",
        chars: "\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
    },
    {
        base: "l",
        chars: "\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747\u026D"
    },
    {
        base: "lj",
        chars: "\u01C9"
    },
    {
        base: "m",
        chars: "\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
    },
    {
        base: "n",
        chars: "\u24DD\uFF4E\u01F9\u0144\xf1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5\u043B\u0509"
    },
    {
        base: "nj",
        chars: "\u01CC"
    },
    {
        base: "o",
        chars: "\u24DE\uFF4F\xf2\xf3\xf4\u1ED3\u1ED1\u1ED7\u1ED5\xf5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xf6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xf8\u01FF\uA74B\uA74D\u0275\u0254\u1D11"
    },
    {
        base: "oe",
        chars: "\u0153"
    },
    {
        base: "oi",
        chars: "\u01A3"
    },
    {
        base: "oo",
        chars: "\uA74F"
    },
    {
        base: "ou",
        chars: "\u0223"
    },
    {
        base: "p",
        chars: "\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755\u03C1"
    },
    {
        base: "q",
        chars: "\u24E0\uFF51\u024B\uA757\uA759"
    },
    {
        base: "r",
        chars: "\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
    },
    {
        base: "s",
        chars: "\u24E2\uFF53\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B\u0282"
    },
    {
        base: "ss",
        chars: "\xdf"
    },
    {
        base: "t",
        chars: "\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
    },
    {
        base: "th",
        chars: "\xfe"
    },
    {
        base: "tz",
        chars: "\uA729"
    },
    {
        base: "u",
        chars: "\u24E4\uFF55\xf9\xfa\xfb\u0169\u1E79\u016B\u1E7B\u016D\xfc\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
    },
    {
        base: "v",
        chars: "\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
    },
    {
        base: "vy",
        chars: "\uA761"
    },
    {
        base: "w",
        chars: "\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
    },
    {
        base: "x",
        chars: "\u24E7\uFF58\u1E8B\u1E8D"
    },
    {
        base: "y",
        chars: "\u24E8\uFF59\u1EF3\xfd\u0177\u1EF9\u0233\u1E8F\xff\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
    },
    {
        base: "z",
        chars: "\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
    }
];
var $e903e7dce6dc4d79$var$diacriticsMap = {};
for(var $e903e7dce6dc4d79$var$i = 0; $e903e7dce6dc4d79$var$i < $e903e7dce6dc4d79$var$replacementList.length; $e903e7dce6dc4d79$var$i += 1){
    var $e903e7dce6dc4d79$var$chars = $e903e7dce6dc4d79$var$replacementList[$e903e7dce6dc4d79$var$i].chars;
    for(var $e903e7dce6dc4d79$var$j = 0; $e903e7dce6dc4d79$var$j < $e903e7dce6dc4d79$var$chars.length; $e903e7dce6dc4d79$var$j += 1)$e903e7dce6dc4d79$var$diacriticsMap[$e903e7dce6dc4d79$var$chars[$e903e7dce6dc4d79$var$j]] = $e903e7dce6dc4d79$var$replacementList[$e903e7dce6dc4d79$var$i].base;
}
function $e903e7dce6dc4d79$var$removeDiacritics(str) {
    return str.replace(/[^\u0000-\u007e]/g, function(c) {
        return $e903e7dce6dc4d79$var$diacriticsMap[c] || c;
    });
}
$e903e7dce6dc4d79$export$452fcf31d2a11c49 = $e903e7dce6dc4d79$var$replacementList;
$e903e7dce6dc4d79$export$a078a2660a2c4d03 = $e903e7dce6dc4d79$var$diacriticsMap;

});


parcelRegister("lzT6Z", function(module, exports) {
module.exports = JSON.parse('{"locale":"en","countries":{"AF":"Afghanistan","AL":"Albania","DZ":"Algeria","AS":"American Samoa","AD":"Andorra","AO":"Angola","AI":"Anguilla","AQ":"Antarctica","AG":"Antigua and Barbuda","AR":"Argentina","AM":"Armenia","AW":"Aruba","AU":"Australia","AT":"Austria","AZ":"Azerbaijan","BS":"Bahamas","BH":"Bahrain","BD":"Bangladesh","BB":"Barbados","BY":"Belarus","BE":"Belgium","BZ":"Belize","BJ":"Benin","BM":"Bermuda","BT":"Bhutan","BO":"Bolivia","BA":"Bosnia and Herzegovina","BW":"Botswana","BV":"Bouvet Island","BR":"Brazil","IO":"British Indian Ocean Territory","BN":"Brunei Darussalam","BG":"Bulgaria","BF":"Burkina Faso","BI":"Burundi","KH":"Cambodia","CM":"Cameroon","CA":"Canada","CV":"Cape Verde","KY":"Cayman Islands","CF":"Central African Republic","TD":"Chad","CL":"Chile","CN":["People\'s Republic of China","China"],"CX":"Christmas Island","CC":"Cocos (Keeling) Islands","CO":"Colombia","KM":"Comoros","CG":["Republic of the Congo","Congo"],"CD":["Democratic Republic of the Congo","Congo"],"CK":"Cook Islands","CR":"Costa Rica","CI":["Cote d\'Ivoire","C\xf4te d\'Ivoire","Ivory Coast"],"HR":"Croatia","CU":"Cuba","CY":"Cyprus","CZ":["Czech Republic","Czechia"],"DK":"Denmark","DJ":"Djibouti","DM":"Dominica","DO":"Dominican Republic","EC":"Ecuador","EG":"Egypt","SV":"El Salvador","GQ":"Equatorial Guinea","ER":"Eritrea","EE":"Estonia","ET":"Ethiopia","FK":"Falkland Islands (Malvinas)","FO":"Faroe Islands","FJ":"Fiji","FI":"Finland","FR":"France","GF":"French Guiana","PF":"French Polynesia","TF":"French Southern Territories","GA":"Gabon","GM":["Republic of The Gambia","The Gambia","Gambia"],"GE":"Georgia","DE":"Germany","GH":"Ghana","GI":"Gibraltar","GR":"Greece","GL":"Greenland","GD":"Grenada","GP":"Guadeloupe","GU":"Guam","GT":"Guatemala","GN":"Guinea","GW":"Guinea-Bissau","GY":"Guyana","HT":"Haiti","HM":"Heard Island and McDonald Islands","VA":"Holy See (Vatican City State)","HN":"Honduras","HK":"Hong Kong","HU":"Hungary","IS":"Iceland","IN":"India","ID":"Indonesia","IR":["Islamic Republic of Iran","Iran"],"IQ":"Iraq","IE":"Ireland","IL":"Israel","IT":"Italy","JM":"Jamaica","JP":"Japan","JO":"Jordan","KZ":"Kazakhstan","KE":"Kenya","KI":"Kiribati","KP":"North Korea","KR":["South Korea","Korea, Republic of","Republic of Korea"],"KW":"Kuwait","KG":"Kyrgyzstan","LA":"Lao People\'s Democratic Republic","LV":"Latvia","LB":"Lebanon","LS":"Lesotho","LR":"Liberia","LY":"Libya","LI":"Liechtenstein","LT":"Lithuania","LU":"Luxembourg","MO":"Macao","MG":"Madagascar","MW":"Malawi","MY":"Malaysia","MV":"Maldives","ML":"Mali","MT":"Malta","MH":"Marshall Islands","MQ":"Martinique","MR":"Mauritania","MU":"Mauritius","YT":"Mayotte","MX":"Mexico","FM":"Micronesia, Federated States of","MD":"Moldova, Republic of","MC":"Monaco","MN":"Mongolia","MS":"Montserrat","MA":"Morocco","MZ":"Mozambique","MM":"Myanmar","NA":"Namibia","NR":"Nauru","NP":"Nepal","NL":["Netherlands","The Netherlands","Netherlands (Kingdom of the)"],"NC":"New Caledonia","NZ":"New Zealand","NI":"Nicaragua","NE":"Niger","NG":"Nigeria","NU":"Niue","NF":"Norfolk Island","MK":["The Republic of North Macedonia","North Macedonia"],"MP":"Northern Mariana Islands","NO":"Norway","OM":"Oman","PK":"Pakistan","PW":"Palau","PS":["State of Palestine","Palestine"],"PA":"Panama","PG":"Papua New Guinea","PY":"Paraguay","PE":"Peru","PH":"Philippines","PN":["Pitcairn","Pitcairn Islands"],"PL":"Poland","PT":"Portugal","PR":"Puerto Rico","QA":"Qatar","RE":"Reunion","RO":"Romania","RU":["Russian Federation","Russia"],"RW":"Rwanda","SH":"Saint Helena","KN":"Saint Kitts and Nevis","LC":"Saint Lucia","PM":"Saint Pierre and Miquelon","VC":"Saint Vincent and the Grenadines","WS":"Samoa","SM":"San Marino","ST":"Sao Tome and Principe","SA":"Saudi Arabia","SN":"Senegal","SC":"Seychelles","SL":"Sierra Leone","SG":"Singapore","SK":"Slovakia","SI":"Slovenia","SB":"Solomon Islands","SO":"Somalia","ZA":"South Africa","GS":"South Georgia and the South Sandwich Islands","ES":"Spain","LK":"Sri Lanka","SD":"Sudan","SR":"Suriname","SJ":"Svalbard and Jan Mayen","SZ":"Eswatini","SE":"Sweden","CH":"Switzerland","SY":"Syrian Arab Republic","TW":["Taiwan, Province of China","Taiwan"],"TJ":"Tajikistan","TZ":["United Republic of Tanzania","Tanzania"],"TH":"Thailand","TL":"Timor-Leste","TG":"Togo","TK":"Tokelau","TO":"Tonga","TT":"Trinidad and Tobago","TN":"Tunisia","TR":["T\xfcrkiye","Turkey"],"TM":"Turkmenistan","TC":"Turks and Caicos Islands","TV":"Tuvalu","UG":"Uganda","UA":"Ukraine","AE":["United Arab Emirates","UAE"],"GB":["United Kingdom","UK","Great Britain"],"US":["United States of America","United States","USA","U.S.A.","US","U.S."],"UM":"United States Minor Outlying Islands","UY":"Uruguay","UZ":"Uzbekistan","VU":"Vanuatu","VE":"Venezuela","VN":"Vietnam","VG":"Virgin Islands, British","VI":"Virgin Islands, U.S.","WF":"Wallis and Futuna","EH":"Western Sahara","YE":"Yemen","ZM":"Zambia","ZW":"Zimbabwe","AX":["\xc5land Islands","Aland Islands"],"BQ":"Bonaire, Sint Eustatius and Saba","CW":"Cura\xe7ao","GG":"Guernsey","IM":"Isle of Man","JE":"Jersey","ME":"Montenegro","BL":"Saint Barth\xe9lemy","MF":"Saint Martin (French part)","RS":"Serbia","SX":"Sint Maarten (Dutch part)","SS":"South Sudan","XK":"Kosovo"}}');

});

parcelRegister("iC5ih", function(module, exports) {
module.exports = JSON.parse('{"locale":"sv","countries":{"AD":"Andorra","AE":"F\xf6renade Arabemiraten","AF":"Afghanistan","AG":"Antigua och Barbuda","AI":"Anguilla","AL":"Albanien","AM":"Armenien","AO":"Angola","AQ":"Antarktis","AR":"Argentina","AS":"Amerikanska Samoa","AT":"\xd6sterrike","AU":"Australien","AW":"Aruba","AX":"\xc5land","AZ":"Azerbajdzjan","BA":"Bosnien och Hercegovina","BB":"Barbados","BD":"Bangladesh","BE":"Belgien","BF":"Burkina Faso","BG":"Bulgarien","BH":"Bahrain","BI":"Burundi","BJ":"Benin","BL":"Saint-Barth\xe9lemy","BM":"Bermuda","BN":"Brunei","BO":"Bolivia","BQ":"Bonaire, Saint Eustatius och Saba","BR":"Brasilien","BS":"Bahamas","BT":"Bhutan","BV":"Bouvet\xf6n","BW":"Botswana","BY":"Belarus","BZ":"Belize","CA":"Kanada","CC":"Kokos\xf6arna","CD":"Demokratiska republiken Kongo","CF":"Centralafrikanska republiken","CG":"Kongo-Brazzaville","CH":"Schweiz","CI":"Elfenbenskusten","CK":"Cook\xf6arna","CL":"Chile","CM":"Kamerun","CN":"Kina","CO":"Colombia","CR":"Costa Rica","CU":"Kuba","CV":"Kap Verde","CW":"Curacao","CX":"Jul\xf6n","CY":"Cypern","CZ":"Tjeckien","DE":"Tyskland","DJ":"Djibouti","DK":"Danmark","DM":"Dominica","DO":"Dominikanska republiken","DZ":"Algeriet","EC":"Ecuador","EE":"Estland","EG":"Egypten","EH":"V\xe4stsahara","ER":"Eritrea","ES":"Spanien","ET":"Etiopien","FI":"Finland","FJ":"Fiji","FK":"Falklands\xf6arna","FM":"Mikronesiska federationen","FO":"F\xe4r\xf6arna","FR":"Frankrike","GA":"Gabon","GB":"Storbritannien","GD":"Grenada","GE":"Georgien","GF":"Franska Guyana","GG":"Guernsey","GH":"Ghana","GI":"Gibraltar","GL":"Gr\xf6nland","GM":"Gambia","GN":"Guinea","GP":"Guadeloupe","GQ":"Ekvatorialguinea","GR":"Grekland","GS":"Sydgeorgien och Sydsandwich\xf6arna","GT":"Guatemala","GU":"Guam","GW":"Guinea Bissau","GY":"Guyana","HK":"Hongkong","HM":"Heard- och McDonalds\xf6arna","HN":"Honduras","HR":"Kroatien","HT":"Haiti","HU":"Ungern","ID":"Indonesien","IE":"Irland","IL":"Israel","IM":"Isle of Man","IN":"Indien","IO":"Brittiska territoriet i Indiska Oceanen","IQ":"Irak","IR":"Iran","IS":"Island","IT":"Italien","JE":"Jersey","JM":"Jamaica","JO":"Jordanien","JP":"Japan","KE":"Kenya","KG":"Kirgizistan","KH":"Kambodja","KI":"Kiribati","KM":"Komorerna","KN":"Saint Kitts och Nevis","KP":"Nordkorea","KR":"Sydkorea","KW":"Kuwait","KY":"Cayman\xf6arna","KZ":"Kazakstan","LA":"Laos","LB":"Libanon","LC":"Saint Lucia","LI":"Liechtenstein","LK":"Sri Lanka","LR":"Liberia","LS":"Lesotho","LT":"Litauen","LU":"Luxemburg","LV":"Lettland","LY":"Libyen","MA":"Marocko","MC":"Monaco","MD":"Moldavien","ME":"Montenegro","MF":"Saint Martin (franska delen)","MG":"Madagaskar","MH":"Marshall\xf6arna","MK":"Nordmakedonien","ML":"Mali","MM":"Burma","MN":"Mongoliet","MO":"Macau","MP":"Nordmarianerna","MQ":"Martinique","MR":"Mauretanien","MS":"Montserrat","MT":"Malta","MU":"Mauritius","MV":"Maldiverna","MW":"Malawi","MX":"Mexiko","MY":"Malaysia","MZ":"Mo\xe7ambique","NA":"Namibia","NC":"Nya Kaledonien","NE":"Niger","NF":"Norfolk\xf6n","NG":"Nigeria","NI":"Nicaragua","NL":"Nederl\xe4nderna","NO":"Norge","NP":"Nepal","NR":"Nauru","NU":"Niue","NZ":"Nya Zeeland","OM":"Oman","PA":"Panama","PE":"Peru","PF":"Franska Polynesien","PG":"Papua Nya Guinea","PH":"Filippinerna","PK":"Pakistan","PL":"Polen","PM":"Saint-Pierre och Miquelon","PN":"Pitcairn\xf6arna","PR":"Puerto Rico","PS":"Palestinska territoriet, ockuperade","PT":"Portugal","PW":"Palau","PY":"Paraguay","QA":"Qatar","RE":"R\xe9union","RO":"Rum\xe4nien","RS":"Serbien","RU":"Ryssland","RW":"Rwanda","SA":"Saudiarabien","SB":"Salomon\xf6arna","SC":"Seychellerna","SD":"Sudan","SE":"Sverige","SG":"Singapore","SH":"Sankta Helena","SI":"Slovenien","SJ":"Svalbard och Jan Mayen","SK":"Slovakien","SL":"Sierra Leone","SM":"San Marino","SN":"Senegal","SO":"Somalia","SR":"Surinam","SS":"Sydsudan","ST":"S\xe3o Tom\xe9 och Pr\xedncipe","SV":"El Salvador","SX":"Sint Maarten (nederl\xe4ndska delen)","SY":"Syrien","SZ":"Eswatini","TC":"Turks- och Caicos\xf6arna","TD":"Tchad","TF":"Franska s\xf6dra territorierna","TG":"Togo","TH":"Thailand","TJ":"Tadzjikistan","TK":"Tokelau\xf6arna","TL":"\xd6sttimor","TM":"Turkmenistan","TN":"Tunisien","TO":"Tonga","TR":"Turkiet","TT":"Trinidad och Tobago","TV":"Tuvalu","TW":"Taiwan","TZ":"Tanzania","UA":"Ukraina","UG":"Uganda","UM":"USA:s yttre \xf6ar","US":"USA","UY":"Uruguay","UZ":"Uzbekistan","VA":"Vatikanstaten","VC":"Saint Vincent och Grenadinerna","VE":"Venezuela","VG":"Brittiska Jungfru\xf6arna","VI":"Amerikanska Jungfru\xf6arna","VN":"Vietnam","VU":"Vanuatu","WF":"Wallis- och Futuna\xf6arna","WS":"Samoa","YE":"Jemen","YT":"Mayotte","ZA":"Sydafrika","ZM":"Zambia","ZW":"Zimbabwe","XK":"Kosovo"}}');

});

parcelRegister("hgPCr", function(module, exports) {
module.exports = JSON.parse('{"locale":"de","countries":{"AF":"Afghanistan","EG":"\xc4gypten","AX":"\xc5land","AL":"Albanien","DZ":"Algerien","AS":"Amerikanisch-Samoa","VI":"Amerikanische Jungferninseln","AD":"Andorra","AO":"Angola","AI":"Anguilla","AQ":"Antarktis","AG":"Antigua und Barbuda","GQ":"\xc4quatorialguinea","AR":"Argentinien","AM":"Armenien","AW":"Aruba","AZ":"Aserbaidschan","ET":"\xc4thiopien","AU":"Australien","BS":"Bahamas","BH":"Bahrain","BD":"Bangladesch","BB":"Barbados","BY":"Belarus","BE":"Belgien","BZ":"Belize","BJ":"Benin","BM":"Bermuda","BT":"Bhutan","BO":"Bolivien","BQ":"Bonaire","BA":"Bosnien und Herzegowina","BW":"Botswana","BV":"Bouvetinsel","BR":"Brasilien","VG":"Britische Jungferninseln","IO":"Britisches Territorium im Indischen Ozean","BN":"Brunei Darussalam","BG":"Bulgarien","BF":"Burkina Faso","BI":"Burundi","CL":"Chile","CN":"China","CK":"Cookinseln","CR":"Costa Rica","CI":"Elfenbeink\xfcste","CW":"Cura\xe7ao","DK":"D\xe4nemark","DE":"Deutschland","DM":"Dominica","DO":"Dominikanische Republik","DJ":"Dschibuti","EC":"Ecuador","SV":"El Salvador","ER":"Eritrea","EE":"Estland","FK":"Falklandinseln","FO":"F\xe4r\xf6er","FJ":"Fidschi","FI":"Finnland","FR":"Frankreich","GF":"Franz\xf6sisch-Guayana","PF":"Franz\xf6sisch-Polynesien","TF":"Franz\xf6sische S\xfcd- und Antarktisgebiete","GA":"Gabun","GM":"Gambia","GE":"Georgien","GH":"Ghana","GI":"Gibraltar","GD":"Grenada","GR":"Griechenland","GL":"Gr\xf6nland","GP":"Guadeloupe","GU":"Guam","GT":"Guatemala","GG":"Guernsey","GN":"Guinea","GW":"Guinea-Bissau","GY":"Guyana","HT":"Haiti","HM":"Heard und McDonaldinseln","HN":"Honduras","HK":["Hongkong","Hong Kong"],"IN":"Indien","ID":"Indonesien","IM":"Insel Man","IQ":"Irak","IR":"Iran","IE":"Irland","IS":"Island","IL":"Israel","IT":"Italien","JM":"Jamaika","JP":"Japan","YE":"Jemen","JE":"Jersey","JO":"Jordanien","KY":"Kaimaninseln","KH":"Kambodscha","CM":"Kamerun","CA":"Kanada","CV":"Kap Verde","KZ":"Kasachstan","QA":"Katar","KE":"Kenia","KG":"Kirgisistan","KI":"Kiribati","CC":"Kokosinseln","CO":"Kolumbien","KM":"Komoren","CD":"Kongo","KP":"Nordkorea","KR":"S\xfcdkorea","HR":"Kroatien","CU":"Kuba","KW":"Kuwait","LA":"Laos","LS":"Lesotho","LV":"Lettland","LB":"Libanon","LR":"Liberia","LY":"Libyen","LI":"Liechtenstein","LT":"Litauen","LU":"Luxemburg","MO":"Macao","MG":"Madagaskar","MW":"Malawi","MY":"Malaysia","MV":"Malediven","ML":"Mali","MT":"Malta","MA":"Marokko","MH":"Marshallinseln","MQ":"Martinique","MR":"Mauretanien","MU":"Mauritius","YT":"Mayotte","MX":"Mexiko","FM":"Mikronesien","MD":"Moldawien","MC":"Monaco","MN":"Mongolei","ME":"Montenegro","MS":"Montserrat","MZ":"Mosambik","MM":"Myanmar","NA":"Namibia","NR":"Nauru","NP":"Nepal","NC":"Neukaledonien","NZ":"Neuseeland","NI":"Nicaragua","NL":"Niederlande","NE":"Niger","NG":"Nigeria","NU":"Niue","MK":"Nordmazedonien","MP":"N\xf6rdliche Marianen","NF":"Norfolkinsel","NO":"Norwegen","OM":"Oman","AT":"\xd6sterreich","TL":"Osttimor","PK":"Pakistan","PS":"Staat Pal\xe4stina","PW":"Palau","PA":"Panama","PG":"Papua-Neuguinea","PY":"Paraguay","PE":"Peru","PH":"Philippinen","PN":"Pitcairninseln","PL":"Polen","PT":"Portugal","PR":"Puerto Rico","TW":"Taiwan","CG":"Republik Kongo","RE":"R\xe9union","RW":"Ruanda","RO":"Rum\xe4nien","RU":["Russische F\xf6deration","Russland"],"BL":"Saint-Barth\xe9lemy","MF":"Saint-Martin","SB":"Salomonen","ZM":"Sambia","WS":"Samoa","SM":"San Marino","ST":"S\xe3o Tom\xe9 und Pr\xedncipe","SA":"Saudi-Arabien","SE":"Schweden","CH":"Schweiz","SN":"Senegal","RS":"Serbien","SC":"Seychellen","SL":"Sierra Leone","ZW":"Simbabwe","SG":"Singapur","SX":"Sint Maarten","SK":"Slowakei","SI":"Slowenien","SO":"Somalia","ES":"Spanien","LK":"Sri Lanka","SH":"St. Helena","KN":"St. Kitts und Nevis","LC":"St. Lucia","PM":"Saint-Pierre und Miquelon","VC":"St. Vincent und die Grenadinen","ZA":"S\xfcdafrika","SD":"Sudan","GS":"S\xfcdgeorgien und die S\xfcdlichen Sandwichinseln","SS":"S\xfcdsudan","SR":"Suriname","SJ":"Svalbard und Jan Mayen","SZ":"Eswatini","SY":"Syrien, Arabische Republik","TJ":"Tadschikistan","TZ":["Tansania, Vereinigte Republik","Tansania"],"TH":"Thailand","TG":"Togo","TK":"Tokelau","TO":"Tonga","TT":"Trinidad und Tobago","TD":"Tschad","CZ":["Tschechische Republik","Tschechien"],"TN":"Tunesien","TR":"T\xfcrkei","TM":"Turkmenistan","TC":"Turks- und Caicosinseln","TV":"Tuvalu","UG":"Uganda","UA":"Ukraine","HU":"Ungarn","UM":"United States Minor Outlying Islands","UY":"Uruguay","UZ":"Usbekistan","VU":"Vanuatu","VA":"Vatikanstadt","VE":"Venezuela","AE":"Vereinigte Arabische Emirate","US":["Vereinigte Staaten von Amerika","Vereinigte Staaten","USA"],"GB":["Vereinigtes K\xf6nigreich","Gro\xdfbritannien"],"VN":"Vietnam","WF":"Wallis und Futuna","CX":"Weihnachtsinsel","EH":"Westsahara","CF":"Zentralafrikanische Republik","CY":"Zypern","XK":"Kosovo"}}');

});


parcelRegister("5bkW8", function(module, exports) {
$parcel$export(module.exports, "OrganisationSettingsWidget", function () { return (parcelRequire("8laWZ")).OrganisationSettingsWidget; });
parcelRequire("8laWZ");

});
parcelRegister("8laWZ", function(module, exports) {

$parcel$export(module.exports, "OrganisationSettingsWidget", function () { return $554013f2193fb3c3$export$d20a1f62a648d607; });

var $7E7Dk = parcelRequire("7E7Dk");

var $76MyM = parcelRequire("76MyM");

var $cCnqE = parcelRequire("cCnqE");

var $1ot1u = parcelRequire("1ot1u");

var $c6fcw = parcelRequire("c6fcw");

var $1O9Jh = parcelRequire("1O9Jh");

var $aLIw2 = parcelRequire("aLIw2");

var $5u6k9 = parcelRequire("5u6k9");

var $aCffN = parcelRequire("aCffN");

var $2nOeJ = parcelRequire("2nOeJ");

var $eXdML = parcelRequire("eXdML");

var $dos1r = parcelRequire("dos1r");
const $554013f2193fb3c3$var$getCommunicationLanguage = (settings)=>(0, $eXdML.getCompanySettingValue)(settings, "Language") ?? "";
const $554013f2193fb3c3$var$getBillingCountry = (settings)=>(0, $eXdML.getCompanySettingValue)(settings, "BillingCountry") ?? (0, $eXdML.DEFAULT_BILLING_COUNTRY);
function $554013f2193fb3c3$export$d20a1f62a648d607({ className: className, style: style, companyId: companyId, disabled: disabled }) {
    const text = (0, $5u6k9.default)();
    const toast = (0, $aCffN.useToast)();
    const { locale: locale } = (0, $aLIw2.useLocalizationContext)();
    const communicationLanguageOptions = (0, $7E7Dk.useMemo)(()=>(0, $aLIw2.AVAILABLE_LANGUAGES).map((key)=>({
                key: key,
                value: (0, $aLIw2.AVAILABLE_LANGUAGES_LOCAL)[key] ?? key
            })), []);
    const billingCountryOptions = (0, $7E7Dk.useMemo)(()=>Object.entries((0, $dos1r.getNamesWithFallback)(locale)).map(([key, value])=>({
                key: key,
                value: value
            })).sort((a, b)=>a.value.localeCompare(b.value, locale)), [
        locale
    ]);
    const { data: companySettings, isFetching: isFetching } = (0, $1O9Jh.useCompanyGetCompanySettingsQuery)({
        companyId: companyId ?? ""
    }, {
        skip: !companyId
    });
    const [updateCompanySettings, { isLoading: isSaving }] = (0, $1O9Jh.useCompanyUpdateCompanySettingsMutation)();
    const { control: control, handleSubmit: handleSubmit, reset: reset, formState: { isDirty: isDirty } } = (0, $cCnqE.useForm)({
        defaultValues: {
            communicationLanguage: $554013f2193fb3c3$var$getCommunicationLanguage(companySettings),
            billingCountry: $554013f2193fb3c3$var$getBillingCountry(companySettings)
        },
        mode: "onChange"
    });
    (0, $7E7Dk.useEffect)(()=>{
        reset({
            communicationLanguage: $554013f2193fb3c3$var$getCommunicationLanguage(companySettings),
            billingCountry: $554013f2193fb3c3$var$getBillingCountry(companySettings)
        });
    }, [
        companySettings,
        reset
    ]);
    const saveSettings = handleSubmit(async ({ communicationLanguage: communicationLanguage, billingCountry: billingCountry })=>{
        if (!companyId || !communicationLanguage || !billingCountry) return;
        try {
            await updateCompanySettings({
                companyId: companyId,
                body: (0, $eXdML.mapOrganisationSettingsToCompanySettings)({
                    communicationLanguage: communicationLanguage,
                    billingCountry: billingCountry
                })
            }).unwrap();
            reset({
                communicationLanguage: communicationLanguage,
                billingCountry: billingCountry
            });
            toast.notifySuccess(text("msgCompanyUpdated"));
        } catch  {
            toast.notifyError(text("msgCompanyNotUpdated"));
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $2nOeJ.WidgetLayout), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($76MyM)))(className),
        style: style,
        title: text("lblOrganisationSettingsWidgetTitle"),
        "data-testid": "organisation-settings-widget"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("form", {
        className: "flex flex-column gap-3",
        onSubmit: saveSettings,
        noValidate: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("label", {
        htmlFor: "language",
        "data-testid": "language-label"
    }, text("lblCommunicationLanguage")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $cCnqE.Controller), {
        name: "communicationLanguage",
        control: control,
        rules: {
            required: true
        },
        render: ({ field: field })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $c6fcw.Dropdown), {
                id: "language",
                "aria-label": text("lblCommunicationLanguage"),
                options: communicationLanguageOptions,
                optionLabel: "value",
                optionValue: "key",
                disabled: disabled || isFetching,
                showClear: false,
                value: field.value,
                onChange: (event)=>field.onChange(event.value),
                onBlur: field.onBlur
            })
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("label", {
        htmlFor: "billing-country",
        "data-testid": "billing-country-label"
    }, text("lblBillingCountry")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $cCnqE.Controller), {
        name: "billingCountry",
        control: control,
        rules: {
            required: true
        },
        render: ({ field: field })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $c6fcw.Dropdown), {
                id: "billing-country",
                "aria-label": text("lblBillingCountry"),
                options: billingCountryOptions,
                optionLabel: "value",
                optionValue: "key",
                disabled: disabled || isFetching,
                showClear: false,
                value: field.value,
                onChange: (event)=>field.onChange(event.value),
                onBlur: field.onBlur
            })
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "flex justify-content-end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
        "data-testid": "organisation-settings-save-btn",
        type: "submit",
        disabled: disabled || isFetching || isSaving || !isDirty,
        label: text("btnSave"),
        icon: "pi pi-save"
    }))));
}

});
parcelRegister("eXdML", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_BILLING_COUNTRY", function () { return $ce7401de7e9f448b$export$c90fbfada95421b; });
$parcel$export(module.exports, "getCompanySettingValue", function () { return $ce7401de7e9f448b$export$fdf84e8368903add; });
$parcel$export(module.exports, "mapOrganisationSettingsToCompanySettings", function () { return $ce7401de7e9f448b$export$822e179afc4def51; });
const $ce7401de7e9f448b$export$c90fbfada95421b = "SE";
const $ce7401de7e9f448b$export$fdf84e8368903add = (settings, settingName)=>{
    const setting = settings?.find((item)=>item.name?.toLowerCase() === settingName.toLowerCase());
    return setting?.value?.trim() || null;
};
const $ce7401de7e9f448b$export$822e179afc4def51 = ({ communicationLanguage: communicationLanguage, billingCountry: billingCountry })=>[
        {
            name: "Language",
            value: communicationLanguage
        },
        {
            name: "BillingCountry",
            value: billingCountry
        }
    ];

});



parcelRegister("e7xM3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $727bb6d7a2150e80$export$2e2bcd8739ae039; });
const $727bb6d7a2150e80$var$canChangePassword = (currentUser, selectedUser)=>{
    if (!selectedUser) return false;
    if (!selectedUser.id) return false;
    if (currentUser.id === selectedUser.id) return true;
    if (currentUser.isSuperAdmin) return true;
    return false;
};
var $727bb6d7a2150e80$export$2e2bcd8739ae039 = $727bb6d7a2150e80$var$canChangePassword;

});


//# sourceMappingURL=index.93f97ffa.js.map
